{
  "language_switcher": {
    "language": "Langue",
    "english": "English",
    "french": "Français"
  },
  "clinical_data": {
    "loading": "Chargement des dossiers de soins…",
    "unavailable_title": "Nous n’avons pas pu charger ces dossiers",
    "unavailable_body": "Tes dossiers enregistrés sont toujours en sécurité. Vérifie ta connexion et réessaie.",
    "stale_body": "Certaines informations peuvent être obsolètes, car nous n’avons pas pu les actualiser.",
    "retry": "Réessayer",
    "retrying": "Nouvelle tentative…"
  },
  "cycle_header": {
    "today": "aujourd'hui",
    "tomorrow": "demain",
    "yesterday": "hier",
    "in_n_days": "dans ${n} jours"
  },
  "access": {
    "back": "Accès",
    "overview": {
      "title": "Accès",
      "subtitle": "Trouve soignants, examens et programmes",
      "featured_program_eyebrow": "Programme à la une",
      "featured_fallback_title": "Programmes",
      "featured_fallback_subtitle": "Explore nos programmes de fertilité structurés",
      "categories": {
        "find_care_title": "Trouver des soins",
        "find_care_subtitle": "Cherche un centre, compare les médecins",
        "testing_title": "Examens",
        "testing_subtitle": "Commande tes examens, suis tes résultats",
        "programs_title": "Programmes",
        "programs_subtitle": "Forfaits et parcours structurés",
        "supplements_title": "Compléments",
        "supplements_subtitle": "Protocoles fondés sur la science",
        "donor_registry_title": "Registre de donneurs",
        "donor_registry_subtitle": "Cherche et trouve un·e donneur·euse",
        "therapies_title": "Thérapies et options",
        "therapies_subtitle": "Compare les interventions, les preuves",
        "pharmacy_title": "Pharmacie",
        "pharmacy_subtitle": "Trouve une pharmacie et contacte-la directement"
      }
    },
    "pharmacy": {
      "header_subtitle": "Trouve des coordonnées vérifiées et les services actuels des pharmacies.",
      "tab_prescription": "Ordonnance",
      "tab_quotes": "Devis",
      "tab_savings": "Économies",
      "medication_help_section_eyebrow": "Aide pour les médicaments",
      "medication_help_storage_title": "Conserver et protéger ton médicament",
      "medication_help_storage_summary": "Garde chaque médicament à la température indiquée sur son étiquette.",
      "medication_help_storage_body": "La conservation dépend du produit et de la forme qui t'a été prescrite. Utilise les lignes ci-dessous pour vérifier la fenêtre indiquée sur l'étiquette. Si une dose est restée dans une voiture, sur un comptoir ou au congélateur, ne te fie pas à son apparence.",
      "medication_help_storage_next": "Note la durée et la température approximative, garde le médicament dans son emballage d'origine et appelle la pharmacie qui l'a délivré avant de l'utiliser ou de le jeter.",
      "medication_help_medications_section": "Tes médicaments",
      "medication_help_injectables_section": "Injectables de ton ordonnance",
      "medication_help_missed_section": "Médicament à vérifier",
      "medication_help_delivery_section": "Ordonnances à suivre",
      "medication_help_travel_section": "À emporter avec tes médicaments",
      "medication_help_no_medications": "Aucun médicament n'est encore connecté. Utilise l'étiquette ou la notice patient comme référence et demande conseil à la pharmacie pour toute question de conservation ou d'utilisation.",
      "medication_help_storage_refrigerate": "Réfrigérer",
      "medication_help_storage_room_temperature": "Température ambiante",
      "medication_help_storage_check_label": "Vérifier l'étiquette",
      "medication_help_storage_gonal_window": "Réfrigérer entre 2 et 8 °C, ou conserver entre 20 et 25 °C pendant 3 mois maximum avant la première utilisation ou 28 jours après la première injection.",
      "medication_help_storage_gonal_detail": "Garde le stylo fermé et à l'abri de la lumière. Ne pas congeler.",
      "medication_help_storage_cetrotide_window": "Réfrigérer entre 2 et 8 °C. La solution préparée doit être utilisée immédiatement ; aucune durée à température ambiante n'est indiquée pour le patient.",
      "medication_help_storage_cetrotide_detail": "Garde le plateau dans son emballage extérieur pour le protéger de la lumière.",
      "medication_help_storage_ovidrel_window": "Réfrigérer entre 2 et 8 °C, ou conserver à température ambiante jusqu'à 25 °C pendant 30 jours maximum.",
      "medication_help_storage_ovidrel_detail": "Protéger de la lumière et utiliser pendant la fenêtre de 30 jours indiquée.",
      "medication_help_storage_endometrin_window": "Conserver entre 20 et 25 °C ; des écarts entre 15 et 30 °C sont permis.",
      "medication_help_storage_endometrin_detail": "Cet insert se conserve à température ambiante. Garde-le dans son emballage d'origine.",
      "medication_help_storage_dexamethasone_window": "Conserver entre 20 et 25 °C ; des écarts entre 15 et 30 °C sont permis.",
      "medication_help_storage_dexamethasone_detail": "Protège les comprimés de l'humidité et garde le flacon fermé.",
      "medication_help_storage_unknown_window": "La fenêtre de conservation n'est pas vérifiée pour ce médicament.",
      "medication_help_storage_unknown_detail": "Utilise l'étiquette ou la notice patient avant de décider comment le conserver.",
      "medication_help_injection_title": "Injecter et jeter le matériel",
      "medication_help_injection_summary": "Nouvelles aiguilles, objets piquants et nettoyage sûr.",
      "medication_help_injection_body": "Utilise une aiguille ou une seringue neuve pour chaque injection. Garde les objets piquants près de l'endroit où tu fais l'injection pour les placer directement dans un collecteur résistant aux perforations.",
      "medication_help_injection_next": "Place chaque aiguille, seringue ou aiguille de stylo dans le collecteur immédiatement après utilisation. Ne mets jamais d'objets piquants en vrac dans les poubelles, le recyclage ou les toilettes ; suis les consignes locales quand le collecteur est plein.",
      "medication_help_injection_row": "Suis la voie et les consignes de ton ordonnance ; utilise une aiguille ou une seringue neuve à chaque fois.",
      "medication_help_missed_title": "Dose oubliée ou médicament endommagé",
      "medication_help_missed_summary": "Sache qui appeler avant de reprendre une dose.",
      "medication_help_missed_body": "Le calendrier d'un traitement de fertilité peut être spécifique à ton protocole. Si une dose est en retard, oubliée, tombée, fuyante ou semble différente, attends avant de la remplacer.",
      "medication_help_missed_next": "Note le médicament, la dose prescrite, l'heure prévue et ce qui s'est passé. Appelle ta clinique pour les consignes de calendrier et ta pharmacie pour un remplacement ou une question sur le produit. Ne double pas une dose sans leur accord.",
      "medication_help_missed_row": "Ne remplace pas et ne double pas cette dose sans les consignes de ta clinique.",
      "medication_help_delivery_title": "Livraison, renouvellements et problèmes",
      "medication_help_delivery_summary": "Sache quoi demander quand une commande est en retard ou bloquée.",
      "medication_help_delivery_body": "La pharmacie peut confirmer si elle a reçu l'ordonnance, si le médicament est disponible, si le renouvellement est possible ou si elle a besoin d'informations de ta clinique ou de ton assurance.",
      "medication_help_delivery_next": "Appelle avant la prochaine dose. Demande le stock, la date de renouvellement, l'autorisation préalable, le reste à payer, le transfert et le remplacement le plus sûr si la livraison est retardée.",
      "medication_help_delivery_row": "Confirme le stock, le renouvellement, la prise en charge et la livraison avant la prochaine dose.",
      "medication_help_travel_title": "Voyager avec un traitement de fertilité",
      "medication_help_travel_summary": "Prévois la température, le matériel et les retards.",
      "medication_help_travel_body": "Garde chaque médicament dans son emballage étiqueté d'origine et dans ton bagage cabine. Pour les produits sensibles à la température, prépare la chaîne du froid avant de partir plutôt que d'improviser avec un réfrigérateur d'hôtel.",
      "medication_help_travel_next": "Prends assez de doses pour le voyage et quelques jours de plus en cas de retard. Demande à ta pharmacie les consignes de conservation, la pochette réfrigérante, les aiguilles et les documents nécessaires avant le départ.",
      "medication_help_open_source": "Voir les conseils",
      "section_meds_eyebrow": "Tes médicaments",
      "section_meds_title": "Cycle en cours",
      "section_best_price_eyebrow": "Le meilleur prix",
      "section_savings_eyebrow": "Programmes d'aide",
      "section_directory_eyebrow": "Toutes les pharmacies",
      "directory_source_live_title": "Annuaire des pharmacies en direct",
      "directory_source_live_body": "Les informations sont chargées depuis l’annuaire en direct lorsqu’il est disponible. La prise en charge, le prix et la livraison doivent encore être confirmés par la pharmacie.",
      "directory_source_curated_title": "Annuaire des pharmacies sélectionné",
      "directory_source_curated_body": "Louise affiche les fiches disponibles pendant l’indisponibilité de l’annuaire en direct. Les liens officiels sont affichés lorsqu’ils ont pu être vérifiés.",
      "directory_source_demo_title": "Données de démonstration",
      "directory_source_demo_body": "Cet aperçu utilise des médicaments et devis illustratifs. Les cartes d’aide renvoient vers les sources publiques actuelles, mais les prix et l’éligibilité ne sont pas en direct.",
      "demo_mode_title": "Afficher la démo",
      "demo_mode_body": "Prévisualise des médicaments, devis, aides et cartes de pharmacies plus riches.",
      "demo_mode_hint": "Bascule entre l’annuaire connecté et l’expérience de démonstration illustrative.",
      "demo_mode_enabled": "Démo activée · aucun prix affiché n’est un devis réel",
      "demo_mode_disabled": "Fiches de pharmacies en direct ou sélectionnées",
      "directory_loading_title": "Chargement de l’annuaire",
      "directory_loading_body": "Nous vérifions les dernières informations disponibles.",
      "directory_error_title": "Annuaire indisponible",
      "directory_error_body": "Nous ne pouvons pas charger les pharmacies pour le moment. Réessaie plus tard ou utilise les consignes de ta clinique.",
      "coverage_varies": "Prise en charge selon le contrat",
      "cash_price_label": "Prix comptant",
      "call_pharmacy": "Appeler",
      "view_details": "Voir les détails",
      "view_details_a11y": "${name}. Voir les détails de la pharmacie",
      "medication_guide_a11y": "Ouvrir le guide du médicament ${name}",
      "meds_loading_title": "Chargement des médicaments",
      "meds_loading_body": "Louise consulte les médicaments connectés à ton dossier.",
      "meds_error_title": "Médicaments indisponibles",
      "meds_error_body": "Nous ne pouvons pas charger tes médicaments connectés. Les consignes de ta clinique ou de ta pharmacie restent la référence.",
      "detail_source_live": "Chargé depuis l’annuaire en direct",
      "detail_source_curated": "Chargé depuis une fiche sélectionnée",
      "detail_source_demo": "Aperçu illustratif d’une pharmacie",
      "contact_section_title": "Coordonnées",
      "services_section_title": "Services indiqués",
      "services_disclaimer": "Les services et modalités de livraison peuvent changer. Confirme les informations actuelles avec la pharmacie avant d’envoyer une ordonnance.",
      "phone_unverified": "Téléphone non vérifié dans cet annuaire",
      "open_website": "Ouvrir le site officiel",
      "detail_pricing_body": "Louise ne dispose pas encore d’un devis vérifié, de l’analyse des garanties, du transfert d’ordonnance ou du parcours de commande. Contacte directement la pharmacie pour confirmer le prix, la prise en charge et la livraison.",
      "quote_request_title": "Demander un devis à la pharmacie",
      "quote_request_body": "Ouvre la page officielle de contact ou de devis de la pharmacie, puis demande le prix, la prise en charge, la disponibilité et la livraison actuels. Louise n’enverra pas d’ordonnance ni de demande de devis à ta place.",
      "quote_request_loading": "Chargement de tes médicaments connectés…",
      "quote_request_medications": "Médicaments à vérifier",
      "quote_request_no_medications": "Aucun médicament n’est encore connecté. Tu peux quand même contacter la pharmacie et fournir toi-même les détails de l’ordonnance.",
      "open_quote_source": "Ouvrir la page de devis ou de contact",
      "open_insurance_source": "S'inscrire ou se connecter pour voir les services fertilité & pharmacie",
      "quote_request_insurance_body": "Cette pharmacie délivre les médicaments via ta couverture d'assurance. Inscris-toi ou connecte-toi sur leur site pour voir les services fertilité et pharmacie qui te sont proposés — Louise n'enverra pas d'ordonnance à ta place.",
      "in_house_compounding": "Médicaments préparés sur place",
      "delivery_section_title": "Livraison",
      "delivery_cold_chain": "Chaîne du froid garantie",
      "delivery_same_day": "Livraison le jour même à ${cities}",
      "delivery_overnight_nationwide": "Livraison sous 24 h dans les 50 États",
      "published_prices_section_title": "Grille tarifaire publiée",
      "published_prices_body": "Tarifs affichés par la pharmacie le ${date}. Ce sont des prix sans assurance — ton assurance ou un programme d'aide peut en couvrir une partie.",
      "published_prices_view_source": "Voir la grille complète",
      "prescription_estimate_title": "Ton ordonnance aux tarifs de ${pharmacy}",
      "prescription_estimate_body": "Chaque médicament reconnu est chiffré au prix unitaire publié par ${pharmacy}. Le total réel dépendra de la quantité prescrite et de la durée du cycle.",
      "prescription_estimate_no_match": "Pas listé dans la grille de ${pharmacy}",
      "prescription_estimate_starting_from": "À partir de ${amount} par unité",
      "prescription_estimate_disclaimer": "L'estimation part d'une unité par médicament. Ton protocole peut en demander plusieurs — demande un devis complet à la pharmacie.",
      "share_medication_list": "Partager la liste des médicaments",
      "quote_share_message_title": "Liste des médicaments pour ${pharmacy}",
      "quote_share_message_reminder": "Confirme le prix, la prise en charge, la disponibilité et la livraison actuels avec la pharmacie.",
      "manufacturer_programs_title": "Programmes laboratoire",
      "matched_to_meds": "Correspondant à tes médicaments",
      "meds_empty_body": "Ajoute un médicament ou importe une ordonnance pour voir ici les prix, économies et options de délivrance en pharmacie.",
      "meds_add_medication": "Ajouter un médicament",
      "meds_upload_prescription": "Importer une ordonnance",
      "price_coming_title": "Les comparatifs de prix ne sont pas encore connectés",
      "price_coming_body": "Louise n'affiche pas d'estimations de prix de médicaments en production. Contacte directement les pharmacies pour un devis personnalisé et une vérification de prise en charge.",
      "quote_empty_body": "Importe un devis ou saisis un prix reçu pour le garder au chaud. Bientôt, Louise pourra lire tes devis et les comparer aux prix des autres pharmacies.",
      "quote_upload": "Importer un devis",
      "quote_add_price": "Ajouter un prix",
      "quote_upload_or_add_price": "Importer un devis ou ajouter un prix",
      "quote_patient_provided": "Fourni par le patient",
      "quote_needs_confirmation": "À confirmer",
      "quote_price_not_added": "Prix non ajouté",
      "quote_added_date": "Ajouté le ${date}",
      "quote_details_a11y": "Ouvrir les détails du devis pour ${name}",
      "quote_detail_patient_subtitle": "Devis fourni par le patient · Ajouté le ${date}",
      "quote_detail_demo_subtitle": "Devis illustratif",
      "quote_detail_total": "Prix total",
      "quote_detail_estimated_savings": "Économie estimée",
      "quote_detail_source": "Source",
      "quote_detail_uploaded": "Devis importé",
      "quote_detail_manual": "Prix ajouté manuellement",
      "quote_detail_demo": "Devis de démonstration",
      "quote_detail_document": "Fichier joint",
      "quote_detail_note": "Notes",
      "quote_detail_close": "Fermer",
      "quote_add_title": "Ajouter un devis de pharmacie",
      "quote_add_body": "Saisis un prix reçu ou joins un devis écrit. Les prix fournis par le patient restent séparés des prix connectés jusqu’à confirmation.",
      "quote_pharmacy_label": "Pharmacie",
      "quote_pharmacy_placeholder": "Nom de la pharmacie",
      "quote_total_label": "Prix total",
      "quote_total_placeholder": "0 €",
      "quote_date_label": "Date du devis",
      "quote_date_placeholder": "AAAA-MM-JJ",
      "quote_notes_label": "Notes",
      "quote_notes_placeholder": "Prise en charge, quantité, livraison ou autres détails",
      "quote_attach_title": "Joindre le devis",
      "quote_take_photo": "Prendre une photo",
      "quote_upload_file": "Importer un fichier",
      "quote_opening": "Ouverture…",
      "quote_saving": "Enregistrement…",
      "quote_save": "Enregistrer le devis",
      "quote_cancel": "Annuler",
      "quote_upload_error": "Nous n’avons pas pu enregistrer ce devis. Vérifie ta connexion et réessaie.",
      "pharmacy_prices_section_eyebrow": "Prix en pharmacie",
      "demo_quote_label": "Devis illustratif",
      "demo_quote_medication": "Total d’exemple pour les médicaments du cycle",
      "demo_quote_savings": "Économie : ${amount} $",
      "demo_detail_quote_body": "Exemple pour les démonstrations. Confirme le prix, la prise en charge et la livraison directement avec la pharmacie.",
      "medication_prices_section_title": "Prix médicament par médicament",
      "medication_prices_section_body": "Compare chaque article avant de décider de garder la commande groupée.",
      "medication_price_contact": "Contacter pour le prix",
      "medication_price_lower_elsewhere": "${amount} $ moins cher chez ${pharmacy}",
      "medication_price_split_title": "Économies possibles en séparant la commande",
      "medication_price_split_body": "${count} article(s) sont moins chers dans une autre pharmacie. Compare la livraison et le retrait avant de séparer la commande.",
      "medication_price_demo_disclaimer": "Prix illustratifs pour la démo uniquement. Confirme le prix, la prise en charge et la disponibilité avec chaque pharmacie.",
      "fulfillment_section_eyebrow": "LIVRAISON ET RETRAIT",
      "fulfillment_delivery_title": "Livraison des médicaments",
      "fulfillment_delivery_status": "Expédié",
      "fulfillment_delivery_timing": "Arrive demain, 14 h–18 h",
      "fulfillment_delivery_detail": "Envoi sous chaîne du froid · réfrigérer à réception.",
      "fulfillment_pickup_title": "Retrait en pharmacie",
      "fulfillment_pickup_status": "Prêt aujourd’hui",
      "fulfillment_pickup_timing": "Retrait avant 19 h",
      "fulfillment_pickup_detail": "Le retrait est possible jusqu’à 19 h.",
      "fulfillment_refill_title": "Renouvellement nécessaire",
      "fulfillment_refill_status": "Action requise",
      "fulfillment_refill_timing": "Cetrotide se termine demain",
      "fulfillment_refill_detail": "À demander avant le prochain appel de suivi.",
      "fulfillment_more_medications": "+${count} autres médicaments",
      "fulfillment_view_a11y": "Voir ${title}",
      "savings_programs_title": "Programmes d’aide et prix publics",
      "savings_programs_body": "Basés sur les pages actuelles des programmes. L’éligibilité et les prix peuvent changer ; Louise ne détermine pas l’éligibilité.",
      "savings_summary_title": "${count} programmes d’aide et remises identifiés",
      "savings_summary_body": "Coupons instantanés des laboratoires, prix cash réduits, aides selon les revenus, dispositifs vétérans ou assistance patient. L’éligibilité finale dépend de ta couverture et des critères de chaque programme.",
      "savings_programs_medications": "Médicaments concernés : ${medications}",
      "savings_programs_verified": "Source vérifiée le ${date}",
      "savings_programs_open": "Voir la source",
      "savings_programs_view_details": "Voir les détails",
      "savings_programs_eligibility": "Éligibilité",
      "savings_programs_process": "Fonctionnement",
      "savings_programs_medications_title": "Médicaments concernés",
      "savings_programs_close": "Fermer",
      "savings_coming_title": "Les aides financières arrivent bientôt",
      "savings_coming_body": "Les aides des laboratoires et l'éligibilité peuvent varier selon l'ordonnance et la couverture. Confirme les programmes directement avec ta clinique, ta pharmacie ou le laboratoire jusqu'à ce que Louise connecte des données vérifiées.",
      "search_placeholder": "Rechercher une pharmacie…",
      "filter_all": "Toutes",
      "filter_specialty": "Spécialisée",
      "filter_mail_order": "Vente par correspondance",
      "filter_retail": "Officine",
      "result_count_one": "${count} pharmacie",
      "result_count_other": "${count} pharmacies",
      "accepts_named": "Accepte ${insurer}",
      "accepts_generic": "Accepte la mutuelle",
      "cash_pay_only": "Paiement cash uniquement",
      "contact_for_pricing": "Contacter pour le tarif",
      "save_amount": "Économise ${amount} €",
      "est_savings": "Économie estimée : ${amount}",
      "empty": "Aucune pharmacie ne correspond à ta recherche",
      "coverage": {
        "covered": "Prise en charge",
        "pa_approved": "Accord préalable obtenu",
        "cash_pay": "Hors prise en charge"
      },
      "type": {
        "specialty": "Spécialisée",
        "mail_order": "Vente par correspondance",
        "retail": "Officine"
      }
    },
    "testing": {
      "title": "Examens",
      "subtitle": "Découvre les examens, dépistages et kits à domicile pour mieux comprendre ta santé reproductive.",
      "search_placeholder": "Rechercher un examen ou un kit…",
      "guide_section_label": "Que veux-tu savoir ?",
      "shop_at_home": "À tester chez toi",
      "tests_and_kits": "Examens et kits",
      "empty_search": "Aucun examen ou kit ne correspond à ta recherche",
      "empty_no_options": "Aucun examen disponible pour l'instant",
      "empty_in_guide": "Aucun examen ou kit ne correspond encore à ce profil.",
      "location": {
        "at_home": "À domicile",
        "clinic": "Clinique",
        "lab": "Laboratoire"
      },
      "hero": {
        "eyebrow": "Protocole personnalisé",
        "title": "Découvre ton plan d'examens recommandé",
        "summary": "Une sélection personnalisée d'examens en laboratoire, dépistages et kits à domicile, adaptée à ton profil avant toute réservation.",
        "cta_unlock": "Complète ton profil pour débloquer"
      },
      "recommendations": {
        "eyebrow": "Sélectionné pour toi",
        "title": "Ta shortlist personnalisée",
        "subtitle": "Basée sur ce que tu nous as partagé. Ouvre une carte pour en savoir plus sur l'examen."
      },
      "recommendation": {
        "trigger": {
          "baseline_afab": "Un incontournable pour toi",
          "baseline_amab": "Un incontournable pour toi",
          "varicocele": "Tu as mentionné une varicocèle",
          "pcos": "Tu as mentionné le SOPK",
          "endo": "Tu as mentionné l'endométriose",
          "low_reserve": "Réserve ovarienne basse",
          "age_35_plus": "Pour ta tranche d'âge",
          "age_38_plus_ivf": "Tu as 38+ et tu prépares une FIV",
          "age_40_plus_ivf": "Tu as 40+ et tu prépares une FIV",
          "rpl": "Tu as eu 2+ fausses couches",
          "rif": "Tu as eu 3+ cycles sans succès",
          "ethnicity": "Ton origine familiale",
          "irregular_cycles": "Cycles irréguliers",
          "planned_cycle": "Tu prépares un cycle",
          "planned_ivf": "Tu prépares une FIV",
          "egg_freezing": "Tu prépares une vitrification",
          "cancer_history": "Fertilité après un cancer",
          "early_menopause_reported": "Ménopause précoce",
          "fibroids_reported": "Tu as mentionné des fibromes",
          "ovarian_surgery_reported": "Tu as eu une chirurgie ovarienne",
          "thyroid_reported": "Tu as mentionné la thyroïde",
          "tubal_issues_reported": "Tu as mentionné des trompes"
        },
        "reason": {
          "amh_baseline": "Un premier aperçu de ta réserve d'ovocytes — n'importe quel jour du cycle.",
          "afc_baseline": "Confirme la lecture AMH avec un comptage échographique.",
          "semen_baseline": "Le point de départ de tout bilan de fertilité masculine.",
          "dna_frag_varicocele": "Un spermogramme standard peut passer à côté des dommages à l'ADN liés à la varicocèle.",
          "dna_frag_rpl": "Les fausses couches à répétition sont l'une des indications spécifiques du test de fragmentation de l'ADN.",
          "hormone_pcos": "Confirme le SOPK et écarte les autres causes possibles.",
          "tracker_pcos": "Révèle si — et quand — tu ovules vraiment.",
          "sonogram_endo": "Explore la cavité utérine pour détecter les changements liés à l'endométriose.",
          "endometritis_endo": "Recherche une inflammation silencieuse qui limite l'implantation.",
          "hormone_low_reserve": "Les hormones J2–J4 nous disent comment tes ovaires réagissent.",
          "thyroid_age": "Les troubles thyroïdiens se détectent — et se traitent — plus facilement après 35 ans.",
          "prolactin_irregular": "Une cause fréquente et facilement traitable de retards ou d'absences de règles.",
          "thyroid_irregular": "La thyroïde est une cause majeure d'irrégularités du cycle.",
          "carrier_planned_cycle": "Dépiste chez toi et ton partenaire les conditions à connaître avant la conception.",
          "infectious_planned_cycle": "Exigé par la plupart des cliniques avant un cycle de FIV ou d'IIU.",
          "lining_ivf": "L'endomètre avant transfert est l'un des meilleurs prédicteurs de succès.",
          "hormone_egg_freezing": "Définit le bon protocole de stimulation pour ta vitrification.",
          "amh_cancer": "Un point de repère rapide sur ta réserve avant tout traitement — essentiel si la préservation de la fertilité compte pour toi.",
          "afc_cancer": "Confirme la lecture AMH avec un comptage folliculaire avant tout traitement.",
          "hormone_cancer": "Les hormones J2–J4 indiquent à ton équipe où en est ta fonction ovarienne dès maintenant.",
          "carrier_cancer": "Certains antécédents de cancer recoupent des syndromes héréditaires (BRCA, etc.) qui méritent un dépistage.",
          "semen_cancer": "Un spermogramme de référence avant des traitements qui peuvent affecter la production de spermatozoïdes.",
          "dna_frag_cancer": "Chimio, radiothérapie et certains cancers augmentent les dommages à l'ADN spermatique — à mesurer.",
          "hormone_early_menopause": "Confirme si ta fonction ovarienne baisse plus tôt que prévu.",
          "fsh_early_menopause": "Une FSH J2 élevée est l'un des signes les plus nets de ménopause précoce.",
          "sonogram_fibroids": "Cartographie où se trouvent les fibromes et s'ils touchent la cavité.",
          "baseline_ultrasound_fibroids": "Mesure et localise chaque fibrome pour que ton équipe puisse anticiper.",
          "hormone_ovarian_surgery": "Vérifie ce qu'il reste de fonction ovarienne après ton intervention.",
          "thyroid_reported": "Bilan TSH / T3 / T4 complet — un suivi qui compte quand un diagnostic thyroïdien est déjà posé.",
          "sonogram_tubal": "Évalue la perméabilité tubaire — l'étape standard quand les trompes sont en question.",
          "pgt_a_age": "À 38 ans et plus, le PGT-A mérite d'être discuté avec ton équipe — les preuves sont mitigées mais le risque d'aneuploïdie augmente nettement à cet âge.",
          "thrombophilia_rpl": "Les anticorps antiphospholipides sont l'une des rares causes réversibles de fausses couches à répétition.",
          "thyroid_rpl": "Même une thyroïde légèrement déréglée augmente significativement le risque de fausse couche.",
          "sonogram_rpl": "Vérifie la cavité utérine pour des causes structurelles de pertes répétées.",
          "karyotype_rpl": "Des remaniements chromosomiques parentaux expliquent environ 5% des fausses couches récurrentes.",
          "endometritis_rif": "Une inflammation utérine silencieuse est une cause fréquente — et traitable — d'échec d'implantation.",
          "era_rif": "Personnalise la date du transfert au moment où ton endomètre est le plus réceptif.",
          "dna_frag_rif": "Les dommages à l'ADN spermatique sont un facteur RIF reconnu, même avec un spermogramme normal.",
          "sonogram_rif": "Écarte les problèmes de cavité qui n'apparaissent qu'à l'imagerie saline.",
          "pgt_a_rif": "Sélectionne un embryon chromosomiquement normal — le plus grand levier après plusieurs transferts sans succès.",
          "carrier_ethnicity": "Comme tu as partagé ton origine, un dépistage étendu des conditions à fréquence plus élevée est pertinent.",
          "karyotype_ethnicity": "Certaines origines présentent des taux plus élevés de remaniements chromosomiques — à écarter."
        },
        "detail": {
          "amh_baseline": "Comme tu commences ton parcours, l'AMH est le moyen le plus rapide et le moins invasif d'obtenir un aperçu de ta réserve ovarienne. Une simple prise de sang, n'importe quel jour du cycle — c'est le marqueur sur lequel la plupart des cliniques s'appuient pour bâtir un protocole de stimulation. Référence : ASRM 2020, opinion sur l'évaluation de la réserve ovarienne.",
          "afc_baseline": "Associer le CFA à l'AMH est la référence : l'AMH raconte l'histoire hormonale, le CFA permet de compter les follicules à l'échographie. Ensemble, ils prédisent bien mieux ta réponse à la stimulation. Référence : ASRM 2020.",
          "semen_baseline": "Toute évaluation de la fertilité masculine commence ici. Le manuel WHO 6e édition définit les valeurs de référence utilisées par tous les labos — un seul échantillon suffit pour analyser concentration, mobilité et morphologie. Référence : WHO Laboratory Manual 2021.",
          "dna_frag_varicocele": "Comme une varicocèle est dans ton dossier, le risque de fragmentation de l'ADN spermatique est plus élevé que ce qu'un spermogramme standard révèle. Une fragmentation élevée est associée à des taux de fécondation plus faibles et à des fausses couches récurrentes, et les varicocèles se traitent souvent. Référence : Agarwal et al., World J Mens Health 2020;38(4):412-471.",
          "dna_frag_rpl": "Le guide AUA/ASRM 2024 recommande spécifiquement le test de fragmentation de l'ADN spermatique pour les couples ayant des fausses couches à répétition. Une fragmentation élevée est l'un des facteurs masculins traitables des pertes récurrentes, et sa détection change les options (ICSI, sperme testiculaire, antioxydants). Référence : AUA/ASRM Male Infertility Guideline (2020, amendé 2024).",
          "hormone_pcos": "Comme le SOPK est dans ton dossier, un bilan hormonal complet (LH, FSH, testostérone totale et libre, SHBG, DHEA-S) permet à ton médecin de confirmer le diagnostic et d'écarter les mimétiques comme l'hyperplasie surrénalienne non classique ou la thyroïde. Il oriente aussi le choix des traitements. Référence : ESHRE 2023, guide international SOPK.",
          "tracker_pcos": "Le SOPK entraîne souvent une ovulation imprévisible — voire absente. Un suivi continu capte le vrai schéma du cycle (pics de LH, température, tendances hormonales) pour savoir si tu ovules et, le cas échéant, quand. Référence : ESHRE 2023.",
          "sonogram_endo": "Comme l'endométriose est dans ton dossier, l'hystérosonographie donne une vue plus claire de la cavité utérine qu'une échographie standard — c'est le meilleur moyen de repérer polypes, fibromes, adhérences ou modifications endométriosiques qui pourraient gêner l'implantation. Référence : ESHRE 2022, guide endométriose.",
          "endometritis_endo": "L'endométrite chronique (inflammation de bas grade de la muqueuse utérine) est plus fréquente avec l'endométriose et peut réduire discrètement les taux d'implantation. Une fois diagnostiquée, le traitement est simple. Référence : ESHRE 2022.",
          "hormone_low_reserve": "Avec une préoccupation de réserve ovarienne basse, la FSH et l'estradiol de J2–J4 ajoutent un contexte essentiel à tes résultats d'AMH et de CFA — ils indiquent si tes ovaires travaillent plus fort pour recruter des follicules, ce qui influence le choix du protocole. Référence : ASRM 2020.",
          "thyroid_age": "Les troubles thyroïdiens infracliniques deviennent plus fréquents après 35 ans, et même une TSH légèrement élevée est associée à une fertilité plus faible et à un risque accru de fausse couche. Un simple bilan sanguin les détecte tôt. Référence : ATA 2026, guide sur les maladies thyroïdiennes en préconception, grossesse et post-partum (remplace ATA 2017).",
          "prolactin_irregular": "Comme tes cycles sont irréguliers, vérifier la prolactine permet d'écarter — ou de confirmer — l'une des causes les plus fréquentes et les plus faciles à traiter. Une prolactine élevée bloque l'ovulation et répond bien aux traitements. Référence : ASRM 2021, évaluation de la fertilité féminine — Committee Opinion.",
          "thyroid_irregular": "Les troubles thyroïdiens sont l'une des principales causes endocriniennes de cycles irréguliers. Comme tes cycles le sont, un bilan thyroïdien centré sur la TSH est une prochaine étape à fort rendement. Référence : ASRM 2021, évaluation de la fertilité féminine.",
          "carrier_planned_cycle": "Comme tu prépares un cycle, un dépistage étendu des porteurs pour les deux partenaires est la démarche standard pour identifier les conditions récessives à connaître avant la conception. Un test unique, une information à vie. Référence : ACOG Committee Opinion 691 (2017).",
          "infectious_planned_cycle": "La plupart des cliniques exigent un dépistage à jour des maladies infectieuses (VIH, hépatites B/C, syphilis, HTLV) avant une FIV ou une IIU — le faire tôt évite de retarder ton cycle. Référence : ASRM 2021, évaluation de la fertilité féminine.",
          "lining_ivf": "Comme la FIV est dans ton plan, l'épaisseur et l'aspect de l'endomètre juste avant le transfert font partie des meilleurs prédicteurs à court terme de l'implantation. Un contrôle rapide qui guide le moment du transfert. Référence : ASRM 2021, évaluation de la fertilité féminine.",
          "hormone_egg_freezing": "Pour une vitrification, les hormones J2–J4 (FSH, LH, estradiol) déterminent directement la dose de stimulation et prédisent le rendement attendu en ovocytes. Autant les mesurer avant de commencer tout traitement. Référence : ASRM 2020.",
          "amh_cancer": "Comme un antécédent de cancer est dans ton dossier, une AMH précoce donne à toi et à ton équipe un point de référence avant que le traitement ne commence — chimio et radiothérapie affectent directement la réserve ovarienne, et savoir où tu en es maintenant est essentiel pour toute décision de préservation. Référence : ASRM 2020.",
          "afc_cancer": "Associer le CFA à l'AMH est encore plus important avec un antécédent de cancer, car il capture la situation à l'échographie avant tout traitement susceptible d'altérer le compte folliculaire. Les deux donnent à ton équipe les chiffres nécessaires pour te conseiller rapidement en préservation. Référence : ASRM 2020.",
          "hormone_cancer": "La FSH et l'estradiol J2–J4 permettent à ton équipe de voir comment tes ovaires fonctionnent en ce moment, ce qui compte avant tout traitement susceptible de les endommager. Ils peuvent aussi signaler des changements subtils déjà induits par une chimio antérieure. Référence : ASRM 2020.",
          "carrier_cancer": "Certains antécédents de cancer — en particulier sein, ovaire, ou survenue précoce — recoupent des syndromes héréditaires comme BRCA1/BRCA2 ou Lynch. Un dépistage étendu des porteurs et des cancers héréditaires est pertinent quand on prépare une grossesse. Référence : ACOG Committee Opinion 691 (2017).",
          "semen_cancer": "Comme un antécédent de cancer est dans ton dossier, établir un spermogramme de référence tôt compte — chimio, radiothérapie ou chirurgie proche des organes reproducteurs peuvent réduire la production de spermatozoïdes temporairement ou durablement, et une base permet à ton équipe de comparer plus tard. Référence : WHO Laboratory Manual 2021.",
          "dna_frag_cancer": "Les traitements du cancer — chimio et radiothérapie en particulier — augmentent significativement la fragmentation de l'ADN spermatique pendant des mois voire des années, même quand un spermogramme standard paraît normal. Mesurer la fragmentation donne à ton équipe une vraie lecture de la qualité spermatique. Référence : AUA/ASRM Male Infertility Guideline (2020, amendé 2024) ; Agarwal et al., World J Mens Health 2020.",
          "hormone_early_menopause": "Tu as mentionné une préoccupation de ménopause précoce — un bilan hormonal complet (FSH, LH, estradiol J2–J4) est la façon la plus claire de confirmer ou d'écarter une insuffisance ovarienne prématurée. La détecter tôt ouvre plus d'options de préservation. Référence : ASRM 2020.",
          "fsh_early_menopause": "Une FSH J2–J4 spécifiquement chronométrée est l'un des marqueurs les plus sensibles d'une insuffisance ovarienne prématurée — souvent élevée bien avant que la baisse d'AMH ou de CFA ne devienne évidente. Référence : ASRM 2020.",
          "sonogram_fibroids": "Comme tu as mentionné des fibromes, l'hystérosonographie est la référence pour cartographier exactement leur position — surtout pour identifier ceux qui déforment la cavité utérine, le type le plus susceptible de réduire la fertilité. Référence : ASRM 2021, évaluation de la fertilité féminine.",
          "baseline_ultrasound_fibroids": "Une échographie pelvienne standard mesure et localise chaque fibrome, donnant à ton équipe les informations nécessaires pour décider s'ils doivent être traités avant un cycle ou peuvent être laissés en place. Référence : ASRM 2021, évaluation de la fertilité féminine.",
          "hormone_ovarian_surgery": "Comme tu as eu une chirurgie ovarienne, la FSH et l'estradiol J2–J4 donnent à ton équipe un contrôle fonctionnel — la chirurgie peut réduire la réserve ovarienne même quand l'AMH paraît correcte, et les hormones captent les baisses subtiles. Référence : ASRM 2020.",
          "thyroid_reported": "Comme tu as déjà un diagnostic thyroïdien, garder la TSH — et idéalement T3/T4 libres avec les anticorps thyroïdiens — bien équilibrée est l'un des leviers les plus puissants pour ta fertilité. Même une dysrégulation légère baisse les taux de conception et augmente le risque de fausse couche. Référence : ATA 2026 (guide sur les maladies thyroïdiennes en préconception, grossesse et post-partum ; remplace ATA 2017).",
          "sonogram_tubal": "Comme les trompes sont une préoccupation, l'hystérosonographie (ou HSG) est l'étape standard pour vérifier si les deux trompes sont perméables. Des trompes bouchées sont l'une des causes d'infertilité les plus fréquentes — et les plus traitables. Référence : ASRM 2021, évaluation de la fertilité féminine.",
          "pgt_a_age": "Comme tu prépares une FIV à 38 ans ou plus, le PGT-A est une décision à discuter avec ton équipe. L'aneuploïdie dans les embryons augmente fortement avec l'âge maternel — plus de 50 % à 40 ans et plus de 75 % à 43 ans — et le PGT-A peut réduire le délai jusqu'à une grossesse et le risque de fausse couche dans cette tranche d'âge. Cela dit, la Committee Opinion ASRM 2024 est délibérément prudente : le PGT-A en routine n'a pas démontré sa supériorité pour tout le monde, et il n'est explicitement pas recommandé sur la base de l'âge paternel seul. Référence : ASRM Committee Opinion sur l'utilisation du PGT-A (2024, Fertil Steril ; remplace 2018).",
          "thrombophilia_rpl": "Comme tu as eu 2 fausses couches ou plus, le dépistage du syndrome des antiphospholipides — anticoagulant lupique, anticorps anticardiolipine, anti-β2-glycoprotéine I — fait partie du bilan standard. C'est l'une des rares causes identifiables et traitables de fausses couches récurrentes, et sa détection change la prise en charge (aspirine faible dose ± héparine lors d'une prochaine grossesse). Référence : ESHRE 2022, guide sur les fausses couches récurrentes (Bender Atik et al., Hum Reprod Open).",
          "thyroid_rpl": "Une dysthyroïdie manifeste ou infraclinique — ainsi qu'une auto-immunité thyroïdienne (anticorps anti-TPO) — augmentent significativement le risque de fausse couche. Comme tu as eu des pertes répétées, un bilan thyroïdien complet incluant les anti-TPO est l'un des tests les plus rentables. Référence : ESHRE 2022, guide RPL.",
          "sonogram_rpl": "Des anomalies utérines structurelles — utérus cloisonné, fibromes sous-muqueux, polypes, adhérences — sont retrouvées chez environ 15% des femmes ayant des fausses couches récurrentes et sont souvent traitables. L'hystérosonographie est le premier examen de référence de la cavité. Référence : ASRM Committee Opinion 2020 sur les fausses couches récurrentes (Fertil Steril 2020;113:533-535).",
          "karyotype_rpl": "Des remaniements chromosomiques équilibrés chez l'un des partenaires expliquent environ 3 à 5% des couples ayant des fausses couches récurrentes. Même si la découverte est peu fréquente, le résultat change le conseil et la planification en FIV (y compris l'intérêt d'un PGT-SR). Référence : ASRM 2020, opinion RPL.",
          "endometritis_rif": "Comme tu as eu plusieurs transferts sans succès, l'endométrite chronique (inflammation de bas grade de la muqueuse utérine, souvent asymptomatique) est aujourd'hui reconnue comme l'une des causes les plus fréquentes et les plus traitables du RIF — avec une prévalence de 20 à 40% dans les populations RIF selon les revues récentes. Une seule cure d'antibiotiques la corrige. Référence : ESHRE 2023, bonnes pratiques sur l'échec d'implantation récurrent (Cimadomo et al., Hum Reprod Open 2023;hoad023).",
          "era_rif": "Un test de réceptivité endométriale (ERA / ER-Peak / beReady) vérifie si ta fenêtre d'implantation correspond à un moment de transfert standard — un décalage est retrouvé chez 25 à 30% des cas de RIF. Personnaliser la date du transfert est passé du stade expérimental à recommandé dans cette population. Référence : ESHRE 2023, recommandations RIF.",
          "dna_frag_rif": "La fragmentation de l'ADN spermatique est un facteur RIF reconnu même quand un spermogramme standard est normal, en particulier après plusieurs transferts échoués. Le tester permet à ton équipe de décider s'il faut ajouter une ICSI, du sperme testiculaire ou une supplémentation antioxydante. Référence : ESHRE 2023 ; Agarwal et al., World J Mens Health 2020.",
          "sonogram_rif": "Des distorsions de la cavité qui n'apparaissent pas à l'échographie standard — polypes discrets, adhérences ou cloisons — sont plus fréquentes après plusieurs transferts échoués. L'hystérosonographie (ou hystéroscopie) est la référence pour réévaluer la cavité. Référence : ESHRE 2023, recommandations RIF.",
          "pgt_a_rif": "Après 3 transferts ou plus d'embryons de bonne morphologie sans succès, l'aneuploïdie reste le principal facteur identifiable — et le PGT-A permet à ton équipe de sélectionner un embryon chromosomiquement normal, particulièrement si tu as 35 ans ou plus. Référence : ESHRE 2023 ; ASRM 2018 Committee Opinion sur le PGT-A.",
          "carrier_ethnicity": "Comme tu as partagé ton origine, un dépistage étendu (pan-ethnique) des porteurs est pertinent avant une grossesse. Les recommandations récentes préconisent un dépistage étendu pour toute personne préparant une conception — mais certaines origines (Ashkénaze, africaine, méditerranéenne, sud-est asiatique, canadienne-française) présentent des fréquences plus élevées pour certaines conditions récessives spécifiques qu'il vaut la peine de vérifier. Référence : ACMG 2021, ressource pratique sur le dépistage des porteurs (Gregg et al., Genet Med 2021;23:1793-1806) ; ACOG Committee Opinion 690 (2017, réaffirmée 2023).",
          "karyotype_ethnicity": "Certaines origines présentent des taux plus élevés de remaniements chromosomiques équilibrés. Un caryotype ponctuel associé à ton dépistage étendu complète le tableau génétique préconceptionnel. Référence : ACOG Committee Opinion 691 (2017, réaffirmée 2023)."
        }
      },
      "sections": {
        "ovarian_reserve_title": "Réserve ovarienne",
        "ovarian_reserve_desc": "Comprendre ta réserve ovocytaire",
        "semen_analysis_title": "Spermogramme",
        "semen_analysis_desc": "Évaluer la santé du sperme",
        "cycle_monitoring_title": "Suivi de cycle",
        "cycle_monitoring_desc": "Suivre ovulation et hormones",
        "genetic_screening_title": "Dépistage génétique",
        "genetic_screening_desc": "Dépister des affections génétiques",
        "implantation_title": "Implantation",
        "implantation_desc": "Optimiser ta fenêtre de transfert"
      },
      "guides": {
        "fertility": {
          "label": "Suis-je fertile ?",
          "subtitle": "Réserve ovarienne et santé du sperme",
          "overview": "Le bilan de fertilité est généralement un ensemble, pas un seul résultat. Il combine marqueurs de la réserve ovocytaire, hormones du cycle, échographie, et bilan du sperme si le sperme fait partie du plan.",
          "detail_1_title": "Ce que ces examens peuvent répondre",
          "detail_1_body": "Ces examens peuvent montrer si la réserve ovarienne est élevée, basse ou attendue pour ton âge, si les paramètres du sperme peuvent affecter la fécondation, et s'il vaut la peine d'aller plus loin en consultation avant un traitement.",
          "detail_2_title": "Ce qu'ils ne peuvent pas répondre seuls",
          "detail_2_body": "Un bilan normal ne garantit pas une grossesse, et un marqueur anormal ne signifie pas qu'une grossesse soit impossible. Les résultats sont surtout utiles interprétés avec l'âge, l'historique du cycle, le diagnostic et les objectifs de traitement."
        },
        "amh": {
          "label": "Que signifie l'AMH ?",
          "subtitle": "Marqueurs de la réserve ovocytaire",
          "overview": "L'AMH est un marqueur de la réserve ovarienne. Elle sert souvent à estimer la réponse des ovaires à la stimulation, notamment pour planifier une FIV ou une congélation d'ovocytes.",
          "detail_1_title": "Comment l'utiliser",
          "detail_1_body": "L'AMH est surtout utile à côté du compte des follicules antraux, de l'âge, de la régularité du cycle et de la réponse antérieure aux médicaments. Elle aide à planifier les doses et à anticiper le nombre d'ovocytes prélevés.",
          "detail_2_title": "Idée reçue",
          "detail_2_body": "L'AMH n'est pas une mesure directe de la qualité ovocytaire et ne doit pas être traitée comme un score de fertilité oui/non."
        },
        "sperm": {
          "label": "Le sperme est-il un facteur ?",
          "subtitle": "Spermogramme et fragmentation de l'ADN",
          "overview": "Le bilan du sperme commence par numération, mobilité, morphologie et volume. Si les résultats sont anormaux, ou en cas de fausses couches répétées ou d'échec de fécondation, la fragmentation de l'ADN peut apporter un contexte utile.",
          "detail_1_title": "Examen de première ligne",
          "detail_1_body": "Un spermogramme standard est généralement la première étape, car il est relativement rapide et peut révéler si la concentration, la mobilité ou la forme des spermatozoïdes peut influencer les choix de traitement.",
          "detail_2_title": "Quand aller plus loin",
          "detail_2_body": "L'analyse de la fragmentation de l'ADN est plus spécifique. Elle peut être envisagée quand les résultats standards n'expliquent pas la situation clinique, ou en cas de pertes répétées ou de problèmes de développement embryonnaire."
        },
        "ovulation": {
          "label": "Est-ce que j'ovule ?",
          "subtitle": "Hormones et timing du cycle",
          "overview": "Les examens d'ovulation regardent si un follicule se développe, si le pic de LH se produit, et si la progestérone monte ensuite.",
          "detail_1_title": "Ce qu'il faut vérifier",
          "detail_1_body": "Signaux utiles : profils de LH, estradiol, progestérone après l'ovulation, et suivi échographique si tu es en cycle médicamenté ou en cycle de traitement.",
          "detail_2_title": "Pourquoi le timing compte",
          "detail_2_body": "Une même hormone peut signifier des choses différentes selon le jour du cycle. C'est pourquoi le contexte du cycle est aussi important que la valeur elle-même."
        },
        "embryo_testing": {
          "label": "Faut-il tester les embryons ?",
          "subtitle": "DPI et dépistage des porteurs",
          "overview": "Les tests génétiques peuvent avoir lieu avant la grossesse, pendant la FIV ou sur les embryons. L'option dépend de ce que tu dépistes : statut de porteur, chromosomes, ou affection héréditaire connue.",
          "detail_1_title": "Des tests différents répondent à des questions différentes",
          "detail_1_body": "Le dépistage des porteurs regarde les affections héréditaires chez les parents. Le DPI-A regarde le nombre de copies chromosomiques des embryons. Le DPI-M et le DPI-SR servent à des risques génétiques ou chromosomiques précis.",
          "detail_2_title": "À discuter avec ta clinique",
          "detail_2_body": "Demande ce que le résultat changerait. Certains tests génétiques orientent la sélection d'embryon, d'autres orientent le conseil, le bilan du partenaire ou la nécessité d'une sonde sur mesure."
        },
        "uterus": {
          "label": "Mon utérus est-il en cause ?",
          "subtitle": "Endomètre et fenêtre de transfert",
          "overview": "Les examens utérins et d'implantation regardent la cavité utérine, le développement de l'endomètre, des signes d'inflammation ou de microbiote, et parfois le timing de transfert.",
          "detail_1_title": "Commencer par la structure",
          "detail_1_body": "Une évaluation de la cavité peut chercher polypes, fibromes, adhérences ou liquide qui pourraient gêner l'implantation ou augmenter le risque de fausse couche.",
          "detail_2_title": "Les examens complémentaires demandent du contexte",
          "detail_2_body": "Des examens comme l'ERA ou EMMA/ALICE peuvent être discutés après des transferts ratés ou des symptômes précis, mais ce n'est pas la même chose que les contrôles de première ligne de la cavité et de l'endomètre."
        },
        "at_home": {
          "label": "Puis-je tester à la maison ?",
          "subtitle": "Kits hormonaux et de spermogramme",
          "overview": "Les kits à domicile peuvent être utiles pour une première lecture des hormones, des cycles d'ovulation ou des paramètres du sperme, surtout avant de prendre un rendez-vous en clinique.",
          "detail_1_title": "Où ils aident",
          "detail_1_body": "Ils peuvent baisser la barrière, te donner une base, et t'aider à décider ce que tu vas demander à un·e clinicien·ne. Certains kits incluent le traitement en labo et un compte rendu revu par un·e clinicien·ne.",
          "detail_2_title": "Leurs limites",
          "detail_2_body": "Les tests à domicile ne remplacent pas l'échographie, un bilan d'infertilité complet, ou les examens spécifiques exigés par les cliniques avant FIV, IIU ou transfert d'embryon."
        },
        "baseline": {
          "label": "Suis-je prête pour le traitement ?",
          "subtitle": "Bilan de référence et timing",
          "overview": "Avant un cycle de traitement, les cliniques demandent souvent une imagerie de référence, un bilan sanguin, un dépistage des maladies infectieuses, et parfois une évaluation génétique ou utérine.",
          "detail_1_title": "Ce que la « préparation » signifie",
          "detail_1_body": "L'objectif est de confirmer qu'il n'y a pas de kystes ni de niveaux hormonaux inattendus, que les bilans de sécurité nécessaires sont faits, et que le timing s'aligne avec le cycle prévu.",
          "detail_2_title": "Pourquoi la liste varie",
          "detail_2_body": "Une ponction, une IIU, un transfert d'embryon, un cycle avec don ou un bilan de fausses couches à répétition peuvent chacun nécessiter un panel différent. Ta clinique décidera de ce qui est obligatoire ou facultatif."
        }
      },
      "comparison": {
        "at_a_glance": "En bref",
        "your_results": "Tes résultats",
        "connected_markers": "Marqueurs associés",
        "blood_test": "Prise de sang",
        "also_available_at_home": "Également disponible à domicile",
        "amh_subtitle": "Hormone anti-müllérienne, généralement utilisée pour mesurer la réserve ovarienne.",
        "get_tested": "Faire le test",
        "get_tested_short": "Test",
        "go_to_results": "Voir les résultats",
        "markers_tracked": "Marqueurs suivis",
        "markers_tracked_count": "${count} marqueurs suivis",
        "external_option": "Option externe",
        "included_in": "Ces marqueurs sont également inclus dans :",
        "add_result": "Ajouter un résultat",
        "add_result_description": "Aucun test d'AMH n'est encore enregistré sur ton profil.",
        "test_not_logged_description": "Aucun test de ${marker} n'est encore enregistré sur ton profil.",
        "get_tested_description": "Compare les options en laboratoire et à domicile.",
        "no_result_body": "Aucun résultat de ${marker} n'est encore connecté. Ajoute ou importe un résultat pour voir sa valeur et son historique ici.",
        "panel_no_result_value": "Non enregistré",
        "panel_marker_not_logged": "Aucun résultat de ${marker} n'est encore enregistré.",
        "panel_overview_summary": "${completed} biomarqueurs sur ${total} ont des résultats · Dernier : ${marker}",
        "panel_no_marker_result_title": "Aucun résultat de ${marker} pour le moment",
        "panel_add_result_body": "Ajoute un résultat de ce panel ou importe le compte rendu.",
        "panel_no_results_body": "Aucun résultat de ce panel n'est encore enregistré sur ton profil.",
        "panel_results_summary": "Examine chaque marqueur séparément pour conserver ses propres unités, intervalles et moments de mesure.",
        "panel_view_values": "Voir les valeurs",
        "panel_related_tests_body": "Examine ci-dessous les marqueurs individuels ou les panels associés.",
        "panel_parameter_count": "${count} paramètres",
        "semen_panel_options_body": "Choisis un panel de spermogramme et vois les paramètres inclus avant de le commander dans Louise.",
        "pgt_types_description": "Le PGT est une catégorie générale. Ces types associés répondent à des questions génétiques différentes à partir de cellules issues d'une biopsie embryonnaire.",
        "pgt_commercial_options_description": "Ces options commerciales proposent ce type de PGT via une clinique ou un laboratoire partenaire. Compare les éléments inclus avant d'organiser le test.",
        "pgt_commercial_options_empty": "Les options commerciales pour ce type de PGT seront ajoutées prochainement."
      }
    },
    "programs": {
      "back": "Accès",
      "title": "Programmes",
      "subtitle": "Des parcours fertilité étape par étape qui combinent examens, traitements et accompagnement.",
      "filter_all": "Tous",
      "filter_assessment": "Bilan",
      "filter_optimization": "Optimisation",
      "filter_treatment": "Traitement",
      "filter_support": "Accompagnement",
      "category_assessment": "Bilan",
      "category_optimization": "Optimisation",
      "category_treatment": "Traitement",
      "category_support": "Accompagnement",
      "for_whom_her": "Elle",
      "for_whom_him": "Lui",
      "for_whom_both": "Elle et lui",
      "price_from": "À partir de",
      "open_a11y": "Ouvrir ${title}",
      "hero_recommended_eyebrow": "Recommandé pour toi",
      "hero_find_eyebrow": "Trouve ton programme",
      "hero_fallback_title": "Dis-nous tes objectifs",
      "hero_fallback_subtitle": "Réponds à quelques questions pour qu'on te recommande le programme qui te correspond.",
      "detail_category": {
        "assessment": "Programme de bilan",
        "optimization": "Programme d'optimisation",
        "treatment": "Programme de traitement",
        "support": "Programme d'accompagnement",
        "default": "Programme"
      },
      "module_title_overrides": {
        "female_hormone_baseline": "Panel hormonal et échographie",
        "male_fertility_baseline": "Spermogramme",
        "female_optimization": "Soutien de la qualité ovocytaire",
        "male_optimization": "Soutien de la santé des spermatozoïdes"
      }
    },
    "supplements": {
      "title": "Compléments",
      "subtitle": "Des protocoles fondés sur la science pour soutenir ton parcours fertilité",
      "search_placeholder": "Rechercher un complément…",
      "for_whom": {
        "her": "Pour elle",
        "him": "Pour lui",
        "both": "Pour les deux"
      },
      "goal": {
        "egg_quality": "Qualité ovocytaire",
        "sperm_health": "Santé du sperme",
        "pcos_support": "Soutien PMOS (ex SOPK)",
        "pre_ivf": "Préparation pré-FIV",
        "implantation": "Implantation",
        "stress_support": "Soutien anti-stress",
        "antioxidant": "Antioxydant",
        "general_wellness": "Bien-être général"
      },
      "evidence": {
        "strong": "Données solides",
        "moderate": "Données modérées",
        "emerging": "Émergentes",
        "mixed": "Données mitigées",
        "debunked": "Non étayé"
      },
      "for_you": "Pour toi",
      "hero": {
        "eyebrow": "Protocole personnalisé",
        "title": "Découvre la sélection de compléments recommandée pour toi",
        "with_count": "${count} compléments correspondent à ton profil actuel. Discutes-en avec ton équipe soignante avant de commencer.",
        "without_count": "Une sélection personnalisée construite à partir de tes objectifs, conditions et timing de cycle, avant d'acheter quoi que ce soit.",
        "cta_show_all": "Voir tous les compléments",
        "cta_view_stack": "Voir ma sélection",
        "cta_unlock": "Complète ton profil pour débloquer"
      },
      "empty": "Aucun complément ne correspond à ta recherche ou à tes filtres",
      "food_info": {
        "label": {
          "organ_meats": "Abats",
          "sardines": "Sardines",
          "broccoli": "Brocoli",
          "cauliflower": "Chou-fleur",
          "fatty_fish": "Poissons gras",
          "egg_yolks": "Jaunes d'œuf",
          "fortified_milk": "Lait enrichi",
          "mushrooms": "Champignons",
          "salmon": "Saumon",
          "walnuts": "Noix",
          "flaxseeds": "Graines de lin",
          "leafy_greens": "Légumes verts à feuilles",
          "legumes": "Légumineuses",
          "citrus_fruits": "Agrumes",
          "fortified_grains": "Céréales enrichies",
          "fortified_cereals": "Céréales enrichies",
          "chicken": "Poulet",
          "turkey": "Dinde",
          "garlic": "Ail",
          "onions": "Oignons",
          "cruciferous_vegetables": "Crucifères",
          "oysters": "Huîtres",
          "red_meat": "Viande rouge",
          "fish": "Poisson",
          "poultry": "Volaille",
          "pumpkin_seeds": "Graines de courge",
          "chickpeas": "Pois chiches",
          "milk": "Lait",
          "avocado": "Avocat",
          "brazil_nuts": "Noix du Brésil",
          "tuna": "Thon",
          "eggs": "Œufs",
          "sunflower_seeds": "Graines de tournesol",
          "beans": "Haricots",
          "brown_rice": "Riz complet",
          "cantaloupe": "Melon cantaloup",
          "bell_peppers": "Poivrons",
          "strawberries": "Fraises",
          "kiwi": "Kiwi",
          "tomatoes": "Tomates",
          "almonds": "Amandes",
          "spinach": "Épinards",
          "tart_cherries": "Cerises acidulées",
          "pistachios": "Pistaches",
          "goji_berries": "Baies de goji",
          "lentils": "Lentilles",
          "dark_chocolate": "Chocolat noir",
          "red_grapes": "Raisins rouges",
          "blueberries": "Myrtilles",
          "peanuts": "Cacahuètes",
          "turmeric_root": "Racine de curcuma",
          "curry_powder": "Poudre de curry",
          "yogurt": "Yaourt",
          "kefir": "Kéfir",
          "sauerkraut": "Choucroute",
          "kimchi": "Kimchi"
        },
        "serving": {
          "organ_meats": "85 g de cœur de bœuf",
          "sardines": "85 g de sardines en conserve",
          "broccoli": "1 tasse cuite (156 g)",
          "cauliflower": "1 tasse cuite (124 g)",
          "fatty_fish": "85 g de saumon ou de maquereau",
          "egg_yolks": "1 gros jaune d'œuf",
          "fortified_milk": "1 tasse (240 ml)",
          "mushrooms": "1 tasse exposée aux UV (70 g)",
          "salmon": "85 g de saumon sauvage",
          "walnuts": "30 g (1/4 de tasse)",
          "flaxseeds": "1 cuillère à soupe moulue",
          "leafy_greens": "1 tasse d'épinards crus (30 g)",
          "legumes": "1 tasse de lentilles cuites (198 g)",
          "citrus_fruits": "1 orange moyenne",
          "fortified_grains": "1 tasse de céréales enrichies",
          "fortified_cereals": "1 tasse de céréales enrichies",
          "chicken": "85 g de blanc cuit",
          "turkey": "85 g de dinde cuite",
          "garlic": "3 gousses (9 g)",
          "onions": "1 oignon moyen (110 g)",
          "cruciferous_vegetables": "1 tasse cuite (156 g)",
          "oysters": "6 huîtres moyennes (85 g)",
          "red_meat": "85 g de bœuf cuit",
          "fish": "85 g de poisson cuit",
          "poultry": "85 g de poulet ou de dinde cuits",
          "pumpkin_seeds": "30 g (1/4 de tasse)",
          "chickpeas": "1 tasse cuite (164 g)",
          "milk": "1 tasse (240 ml)",
          "avocado": "1 avocat moyen (150 g)",
          "brazil_nuts": "1 à 2 noix (5 g)",
          "tuna": "85 g de thon en conserve",
          "eggs": "1 gros œuf",
          "sunflower_seeds": "30 g (1/4 de tasse)",
          "beans": "1 tasse cuite (177 g)",
          "brown_rice": "1 tasse cuit (195 g)",
          "cantaloupe": "1 tasse en dés (160 g)",
          "bell_peppers": "1 poivron rouge moyen (119 g)",
          "strawberries": "1 tasse (152 g)",
          "kiwi": "1 kiwi moyen (69 g)",
          "tomatoes": "1 tomate moyenne (123 g)",
          "almonds": "30 g (environ 23 amandes)",
          "spinach": "1 tasse cuite (180 g)",
          "tart_cherries": "1 tasse de jus (240 ml)",
          "pistachios": "30 g (environ 49 pistaches)",
          "goji_berries": "30 g séchées",
          "lentils": "1 tasse cuite (198 g)",
          "dark_chocolate": "30 g (70 % de cacao ou plus)",
          "red_grapes": "1 tasse (151 g)",
          "blueberries": "1 tasse (148 g)",
          "peanuts": "30 g (environ 1/4 de tasse)",
          "turmeric_root": "1 cuillère à soupe râpée (environ 7 g)",
          "curry_powder": "1 cuillère à café (environ 2 g)",
          "yogurt": "1 pot (245 g)",
          "kefir": "1 tasse (240 ml)",
          "sauerkraut": "1/2 tasse (75 g)",
          "kimchi": "1/2 tasse (75 g)"
        },
        "amount": {
          "organ_meats": "~113 mg de CoQ10",
          "sardines": "~6 mg de CoQ10 / ~1,4 g d'Oméga-3",
          "broccoli": "~0,6 mg de CoQ10",
          "cauliflower": "~0,4 mg de CoQ10",
          "fatty_fish": "~600-1 000 UI de vitamine D",
          "egg_yolks": "~40 UI de vitamine D",
          "fortified_milk": "~120 UI de vitamine D",
          "mushrooms": "~400 UI de vitamine D",
          "salmon": "~1,5 g d'Oméga-3",
          "walnuts": "~2,5 g d'ALA (Oméga-3 végétal)",
          "flaxseeds": "~2,3 g d'ALA",
          "leafy_greens": "~58 µg de folates",
          "legumes": "~358 µg de folates",
          "citrus_fruits": "~40 µg de folates",
          "fortified_grains": "~400 µg d'acide folique",
          "fortified_cereals": "~400 µg d'acide folique",
          "chicken": "~1,5 mg de précurseurs de NAC",
          "turkey": "~1,8 mg de précurseurs de NAC",
          "garlic": "Traces de composés soufrés",
          "onions": "Traces de composés soufrés",
          "cruciferous_vegetables": "Traces de composés soufrés",
          "oysters": "~32 mg de zinc",
          "red_meat": "~5 mg de zinc / ~56 mg de L-carnitine",
          "fish": "~0,3-0,8 g de créatine",
          "poultry": "~0,2-0,4 g de créatine",
          "pumpkin_seeds": "~2,2 mg de zinc",
          "chickpeas": "~2,5 mg de zinc",
          "milk": "~8 mg de L-carnitine",
          "avocado": "~2 mg de L-carnitine",
          "brazil_nuts": "~68-91 µg de sélénium",
          "tuna": "~92 µg de sélénium",
          "eggs": "~15 µg de sélénium",
          "sunflower_seeds": "~19 µg de sélénium",
          "beans": "~30 mg de myo-inositol",
          "brown_rice": "~44 mg de myo-inositol",
          "cantaloupe": "~355 mg de myo-inositol",
          "bell_peppers": "~152 mg de vitamine C",
          "strawberries": "~89 mg de vitamine C",
          "kiwi": "~64 mg de vitamine C",
          "tomatoes": "Traces d'acide alpha-lipoïque",
          "almonds": "~7,3 mg de vitamine E",
          "spinach": "~3,7 mg de vitamine E / ~157 mg de magnésium",
          "tart_cherries": "~0,1 mg de mélatonine",
          "pistachios": "~0,23 mg de mélatonine",
          "goji_berries": "Traces de mélatonine",
          "lentils": "~6,6 mg de fer",
          "dark_chocolate": "~3,3 mg de fer / ~64 mg de magnésium",
          "red_grapes": "Petites quantités de resvératrol",
          "blueberries": "Traces de resvératrol",
          "peanuts": "Traces de resvératrol",
          "turmeric_root": "Teneur en curcumine variable",
          "curry_powder": "Petites quantités de curcumine",
          "yogurt": "~1 à 10 milliards d'UFC",
          "kefir": "~10 à 50 milliards d'UFC",
          "sauerkraut": "~1 à 10 milliards d'UFC",
          "kimchi": "~1 à 10 milliards d'UFC"
        },
        "note": {
          "organ_meats": "Les abats sont la source alimentaire la plus riche, mais il faudrait en consommer 3 à 5 portions par jour pour atteindre des doses thérapeutiques (400-600 mg). La supplémentation est bien plus pratique.",
          "sardines": "Une excellente source à la fois de CoQ10 et d'Oméga-3, même si la teneur en CoQ10 reste faible face aux doses des compléments. Côté Oméga-3, 2 à 3 portions de poissons gras par semaine apportent un vrai bénéfice.",
          "broccoli": "Contient des traces de CoQ10. Précieux pour les fibres et d'autres nutriments, mais ce n'est pas une source pertinente pour atteindre des niveaux thérapeutiques de CoQ10.",
          "cauliflower": "Comme le brocoli, le chou-fleur n'en contient que de très faibles quantités. Il faudrait des centaines de portions pour égaler une seule dose de complément.",
          "fatty_fish": "L'une des meilleures sources naturelles de vitamine D. Une portion de saumon peut apporter 600 à 1 000 UI, ce qui se rapproche de l'apport quotidien recommandé. Une consommation régulière de poisson peut réduire le besoin de supplémentation.",
          "egg_yolks": "Les œufs n'apportent que de petites quantités de vitamine D. Il faudrait 50 à 100 œufs par jour pour atteindre des doses thérapeutiques : la supplémentation reste donc indispensable pour la plupart des gens.",
          "fortified_milk": "Les produits laitiers enrichis apportent une quantité modérée. 3 à 4 tasses par jour s'approchent du bas de la fourchette recommandée, mais une supplémentation est généralement nécessaire pour atteindre des niveaux optimaux.",
          "mushrooms": "Les champignons exposés aux UV sont étonnamment riches en vitamine D2 (et non D3). Utile, mais la D3 issue des compléments ou des sources animales est mieux utilisée par l'organisme.",
          "salmon": "Le saumon sauvage est l'une des sources les plus riches en Oméga-3. Deux portions par semaine apportent un vrai bénéfice en EPA/DHA. Le saumon d'élevage en contient moins, mais reste intéressant.",
          "walnuts": "Les noix sont riches en ALA, un Oméga-3 d'origine végétale. Mais l'organisme ne convertit que 5 à 10 % de l'ALA en EPA/DHA : les noix seules ne remplacent donc pas l'huile de poisson ni les compléments.",
          "flaxseeds": "Très riches en ALA, mais le même faible taux de conversion en EPA/DHA s'applique. À utiliser en complément de sources directes d'EPA/DHA, pas en remplacement.",
          "leafy_greens": "Les légumes verts sont une bonne source de folates naturels, mais la cuisson en réduit la teneur de 40 à 50 %. Atteindre 800 µg uniquement par l'alimentation demanderait de très grandes portions quotidiennes.",
          "legumes": "Les lentilles et les haricots font partie des aliments les plus riches en folates. Deux tasses par jour peuvent s'approcher des doses des compléments, mais la biodisponibilité des folates alimentaires est d'environ 50 % par rapport aux compléments.",
          "citrus_fruits": "Une source modeste de folates. Il faudrait environ 20 oranges par jour pour égaler une dose de complément. Mieux vaut les intégrer à une alimentation variée, en parallèle de la supplémentation.",
          "fortified_grains": "Les céréales enrichies utilisent de l'acide folique (forme synthétique). Si tu portes une variante du gène MTHFR (30 à 40 % des femmes), ton organisme peut mal le convertir : les compléments de méthylfolate contournent ce problème.",
          "fortified_cereals": "Comme les céréales enrichies — elles utilisent de l'acide folique synthétique, pas toujours adapté à tout le monde. Parles-en à ton médecin pour vérifier d'éventuelles variantes MTHFR.",
          "chicken": "Contient de la cystéine, l'acide aminé précurseur de la NAC. Les aliments riches en protéines aident l'organisme à produire naturellement du glutathion, mais sans atteindre les niveaux thérapeutiques des compléments.",
          "turkey": "Légèrement plus riche en cystéine que le poulet. Bonne pour soutenir la production de glutathion, mais ne remplace pas la supplémentation en NAC pour un effet antioxydant ciblé.",
          "garlic": "Contient de l'allicine et des composés soufrés qui soutiennent la production de glutathion. Intéressant pour un soutien antioxydant général, mais ne remplace pas la NAC.",
          "onions": "Comme l'ail, ils apportent des composés soufrés. À intégrer à une alimentation variée plutôt qu'à viser comme source ciblée d'un nutriment.",
          "cruciferous_vegetables": "Le brocoli, le chou-fleur et les choux de Bruxelles soutiennent les voies de détoxification de l'organisme. Complémentaires à la NAC, mais ne la remplacent pas.",
          "oysters": "De loin la source alimentaire la plus riche en zinc. Une seule portion dépasse l'apport quotidien recommandé. La plupart des gens n'en mangent toutefois pas assez régulièrement pour un apport constant.",
          "red_meat": "Une bonne source à la fois de zinc et de L-carnitine. Une consommation modérée et régulière apporte un vrai bénéfice, mais les doses de L-carnitine en complément (2 à 3 g) dépassent largement ce que l'alimentation peut fournir.",
          "fish": "Le poisson contient naturellement de la créatine, les poissons gras en apportant souvent des quantités intéressantes. Mais atteindre les doses classiques des compléments (3 à 5 g/jour) uniquement par le poisson demanderait des portions très importantes.",
          "poultry": "La volaille apporte un peu de créatine et des protéines de qualité. Elle soutient l'apport alimentaire, mais reste loin de la dose standardisée utilisée dans la plupart des protocoles de supplémentation en créatine.",
          "pumpkin_seeds": "Une source végétale de zinc, même si la biodisponibilité est plus faible que pour les sources animales à cause des phytates. Parfait pour grignoter, mais insuffisant comme seule source de zinc.",
          "chickpeas": "Teneur modérée en zinc, avec la même réserve liée aux phytates que pour les autres légumineuses. Le trempage et la cuisson améliorent l'absorption. Une bonne option dans une alimentation riche en zinc.",
          "milk": "Contient de petites quantités de L-carnitine. Il faudrait plus de 250 tasses par jour pour atteindre les doses des compléments : la supplémentation reste donc le choix le plus pratique.",
          "avocado": "Teneur en L-carnitine à l'état de traces. Précieux pour ses bonnes graisses et ses nutriments, mais ce n'est pas une source pertinente pour une supplémentation ciblée.",
          "brazil_nuts": "Exceptionnellement riches en sélénium. 1 à 2 noix du Brésil par jour suffisent à couvrir l'apport quotidien. Attention à ne pas en abuser : une toxicité au sélénium est possible en cas d'excès.",
          "tuna": "Une excellente source de sélénium. Une portion couvre tout l'apport quotidien. Il apporte aussi des Oméga-3, ce qui en fait un double atout pour la fertilité masculine.",
          "eggs": "Une source modeste de sélénium. Plusieurs œufs par jour contribuent à l'apport, mais les noix du Brésil ou les fruits de mer sont bien plus efficaces pour couvrir les besoins.",
          "sunflower_seeds": "Une source végétale correcte de sélénium. Associées à d'autres aliments riches en sélénium, elles peuvent contribuer de façon significative à l'apport quotidien.",
          "beans": "Contiennent du myo-inositol, mais bien en deçà des doses thérapeutiques (2 à 4 g). L'alimentation seule ne peut pas remplacer la supplémentation pour la prise en charge du PMOS (ex SOPK).",
          "brown_rice": "L'une des sources alimentaires les plus riches en inositol, mais cela reste une fraction de la dose thérapeutique de 2 à 4 g. La supplémentation est nécessaire pour obtenir des effets cliniques.",
          "cantaloupe": "Parmi les aliments les plus riches en myo-inositol. Même ainsi, il faudrait 6 à 12 tasses par jour pour atteindre les doses des compléments.",
          "bell_peppers": "L'une des sources les plus riches en vitamine C — plus que l'orange. Un seul poivron peut couvrir l'apport quotidien minimum. À privilégier cru, car la cuisson en réduit la teneur.",
          "strawberries": "Une délicieuse source de vitamine C. Deux tasses offrent un bel apport quotidien, mais atteindre les doses des compléments (500 à 1 000 mg) demanderait bien plus.",
          "kiwi": "Étonnamment dense en vitamine C. Deux kiwis par jour apportent une dose naturelle solide et soutiennent aussi la santé digestive grâce aux fibres et aux enzymes.",
          "tomatoes": "Les tomates contiennent de petites quantités d'acide alpha-lipoïque ainsi que des antioxydants comme le lycopène. Utiles dans une alimentation riche en antioxydants, mais pas une source pratique pour un dosage thérapeutique d'ALA.",
          "almonds": "L'une des meilleures sources alimentaires de vitamine E. Une poignée couvre environ la moitié de l'apport quotidien. Riches aussi en magnésium et en bonnes graisses.",
          "spinach": "Une bonne source à la fois de vitamine E et de magnésium, sans oublier le fer et les folates. La cuisson concentre les nutriments par portion. Un véritable superaliment pour la fertilité.",
          "tart_cherries": "L'une des rares sources alimentaires naturelles de mélatonine. Des études montrent que le jus de cerise acidulée peut légèrement augmenter le taux de mélatonine et améliorer la qualité du sommeil.",
          "pistachios": "La source alimentaire connue la plus riche en mélatonine — bien plus que les autres fruits à coque. Une poignée avant le coucher peut soutenir la production naturelle de mélatonine.",
          "goji_berries": "Contiennent de petites quantités de mélatonine et des antioxydants. Plus intéressantes comme aliment antioxydant général que comme source de mélatonine.",
          "lentils": "Une des meilleures sources végétales de fer. Mais le fer non héminique d'origine végétale n'est absorbé qu'à 2-20 %, contre 15-35 % pour le fer héminique de la viande. À associer à de la vitamine C pour booster l'absorption.",
          "dark_chocolate": "Une source étonnamment intéressante à la fois de fer et de magnésium. Choisis un cacao à 70 % ou plus pour un maximum de bénéfices. Une gourmandise fertilité sans culpabilité, avec modération.",
          "red_grapes": "Le resvératrol des raisins se concentre surtout dans la peau. Les raisins rouges peuvent contribuer, mais la quantité est bien plus faible et plus variable qu'avec un complément standardisé de resvératrol.",
          "blueberries": "Les myrtilles apportent des polyphénols et un soutien antioxydant, mais seulement des traces de resvératrol. Mieux vaut les considérer comme un aliment antioxydant général que comme une source thérapeutique de resvératrol.",
          "peanuts": "Les cacahuètes contiennent de petites quantités de resvératrol, surtout dans la peau. La dose reste bien en dessous des compléments classiques : elles sont un soutien, pas un remplacement.",
          "turmeric_root": "Le curcuma frais contient des curcuminoïdes, mais la quantité varie et l'absorption est naturellement faible. L'associer à un corps gras et à du poivre noir aide, mais les extraits standardisés sont plus prévisibles.",
          "curry_powder": "La poudre de curry contient généralement du curcuma, mais la proportion varie beaucoup. Utile pour une exposition alimentaire régulière, mais pas pour égaler la dose d'un complément de curcumine biodisponible.",
          "yogurt": "Un yaourt à ferments vivants soutient la diversité du microbiote intestinal et vaginal. Cherche les marques qui précisent les souches de Lactobacillus. Tous les yaourts ne contiennent pas de ferments vivants.",
          "kefir": "Contient bien plus de souches probiotiques que le yaourt — souvent plus de 30 espèces différentes. L'un des aliments probiotiques naturels les plus puissants disponibles.",
          "sauerkraut": "La choucroute crue et non pasteurisée est riche en Lactobacillus. Elle doit être conservée au frais : les versions à température ambiante ont été chauffées et ne contiennent plus de ferments vivants.",
          "kimchi": "Riche en Lactobacillus et autres bactéries bénéfiques. La fermentation produit aussi des vitamines B et K. Privilégie les versions réfrigérées et non pasteurisées."
        }
      }
    },
    "donor_registry": {
      "title": "Registre de donneurs",
      "subtitle": "Trouve un·e donneur·euse vérifié·e et entre en contact",
      "feature_browse_title": "Parcours des profils de donneur·euses vérifié·es et présélectionné·es",
      "feature_browse_dialog_title": "Parcourir les profils de donneur·euses",
      "feature_browse_description": "Filtre les donneur·euses d'ovocytes et de sperme selon leur parcours, leurs antécédents médicaux et tes préférences.",
      "feature_match_title": "Trouve ton match",
      "feature_match_dialog_title": "Trouve ton match",
      "feature_match_description": "Notre système te recommande des donneur·euses adapté·es à tes critères et à tes besoins médicaux.",
      "private_preview": "Aperçu privé",
      "request_card_title": "Demande l'accès au Registre de donneurs",
      "request_card_body": "On l'ouvre d'abord à un petit cercle d'utilisateur·rices, puis on facilitera l'invitation de tes proches et de ton·ta partenaire au fil de l'ouverture.",
      "request_cta": "Demander l'accès",
      "request_cta_done": "Demande envoyée",
      "preview_label": "Aperçu"
    },
    "therapies": {
      "title": "Thérapies et options",
      "subtitle": "Compare les thérapies, les options de FIV et les données scientifiques pour faire ton choix.",
      "search_placeholder": "Rechercher une thérapie ou une option…",
      "empty": "Aucune thérapie ou option ne correspond à ta recherche",
      "evidence_filter": {
        "all": "Tous les niveaux de preuve",
        "strong": "Solides",
        "moderate": "Modérées",
        "emerging": "Émergentes",
        "mixed": "Mitigées",
        "debunked": "Non étayées"
      },
      "category": {
        "mind_body": "Corps-esprit",
        "traditional": "Médecine traditionnelle",
        "physical": "Physique",
        "nutritional": "Nutrition",
        "lifestyle": "Mode de vie",
        "clinical": "Option clinique"
      },
      "evidence_label": {
        "strong": "Preuves solides",
        "moderate": "Preuves modérées",
        "emerging": "Émergentes",
        "mixed": "Preuves mitigées",
        "debunked": "Pas de preuves scientifiques"
      },
      "for_whom": {
        "her": "Elle",
        "him": "Lui",
        "both": "Les deux partenaires"
      },
      "detail": {
        "section_how_it_works": "Comment ça fonctionne",
        "section_research": "Ce que disent les études",
        "section_practical": "En pratique",
        "section_what_to_expect": "À quoi t'attendre",
        "section_keep_in_mind": "À garder en tête",
        "section_considerations": "Points de vigilance",
        "section_best_for": "Idéal pour",
        "section_supporting_supplements": "Compléments associés",
        "section_evidence": "Sources",
        "session_label": "Séance : ${value}",
        "frequency_label": "Fréquence : ${value}",
        "cost_per_session": "${low} - ${high} par séance",
        "find_provider_cta": "Trouver un·e praticien·ne près de chez moi"
      }
    },
    "find_care": {
      "back": "Accès",
      "title": "Trouver une clinique",
      "providers_count": "${count} cliniques",
      "search_placeholder": "Recherche par nom, ville ou région…",
      "location": {
        "near": "Près de ${place}",
        "clear": "Effacer le lieu",
        "suggestions_label": "Rechercher à proximité de"
      },
      "include_international_a11y": "Inclure les cliniques à l'international",
      "empty_state": "Aucune clinique ne correspond à ta recherche.\nEssaie d'ajuster tes filtres.",
      "international_section_title": "Options à l'international",
      "international_section_count": "${count} hors ${country}",
      "quick_filter": {
        "all": "Toutes",
        "saved": "Favoris",
        "ivf": "FIV",
        "fet": "TEC",
        "embryo_freezing": "Congélation des embryons",
        "egg_freezing": "Vitrification d'ovocytes",
        "sperm_freezing": "Vitrification de sperme",
        "iui": "IIU",
        "pgt": "DPI",
        "donor": "Don"
      },
      "sort": {
        "label": "Trier par",
        "best_match": "Le mieux pour moi",
        "nearest": "Le plus proche",
        "success_rate": "Taux de réussite",
        "most_experience": "Le plus d'expérience",
        "name": "A–Z"
      },
      "country": {
        "us": "États-Unis",
        "fr": "France"
      },
      "sector": {
        "all": "Tous les secteurs",
        "public": "Public",
        "private": "Privé"
      },
      "filters": {
        "title": "Filtres",
        "include_international": "Inclure les cliniques internationales",
        "scope_home_plus_selected": "${country} plus les pays sélectionnés",
        "scope_selected_only": "Pays internationaux sélectionnés uniquement",
        "scope_home_only": "${country} uniquement",
        "accepts_insurance": "Accepte les mutuelles",
        "clear_all": "Tout effacer",
        "loading_providers": "Chargement des prestataires…",
        "show_provider_one": "Afficher ${count} prestataire",
        "show_provider_other": "Afficher ${count} prestataires",
        "section": {
          "location_scope": "Périmètre géographique",
          "treatments": "Traitements",
          "consultation_type": "Type de consultation",
          "clinic_type": "Type de prestataire",
          "practice_setting": "Cadre de pratique",
          "specialties": "Spécialités",
          "languages": "Langues",
          "inclusive_care": "Soins inclusifs",
          "insurance_carrier": "Mutuelle",
          "fertility_benefits": "Avantages fertilité",
          "other": "Autre"
        },
        "treatment": {
          "ivf_icsi": "FIV & ICSI",
          "iui": "IIU",
          "egg_freezing": "Vitrification d'ovocytes",
          "embryo_freezing": "Vitrification d'embryons",
          "sperm_freezing": "Vitrification de sperme",
          "fertility_preservation": "Préservation de la fertilité",
          "pgt": "DPI",
          "donor_programs": "Programmes de don",
          "surrogacy": "GPA",
          "ovulation_induction": "Induction de l'ovulation"
        },
        "consultation": {
          "in_person": "En cabinet",
          "telehealth": "Téléconsultation"
        },
        "clinic_type": {
          "fertility_clinic": "Clinique de fertilité",
          "medical_practice": "Cabinet médical",
          "solo_practitioner": "Praticien·ne individuel·le",
          "wellness_provider": "Prestataire bien-être",
          "lab": "Laboratoire",
          "pharmacy": "Pharmacie"
        },
        "setting": {
          "boutique": "Indépendante",
          "hospital-based": "Hospitalière",
          "network-group": "Réseau ou groupe"
        },
        "specialty": {
          "reproductive_endocrinology": "Endocrinologie reproductive",
          "pmos": "SOPK (PMOS)",
          "male_fertility": "Fertilité masculine",
          "egg_freezing": "Vitrification d'ovocytes",
          "genetics": "Génétique",
          "fertility_acupuncture": "Acupuncture fertilité",
          "fertility_nutrition": "Nutrition fertilité",
          "urology": "Urologie",
          "ob_gyn": "Gynécologie-obstétrique",
          "pelvic_medicine": "Médecine pelvienne",
          "microsurgery": "Microchirurgie",
          "hormone_management": "Suivi hormonal"
        },
        "language": {
          "english": "Anglais",
          "spanish": "Espagnol",
          "mandarin": "Mandarin",
          "korean": "Coréen",
          "russian": "Russe",
          "french": "Français",
          "arabic": "Arabe",
          "vietnamese": "Vietnamien",
          "japanese": "Japonais",
          "portuguese": "Portugais",
          "german": "Allemand",
          "italian": "Italien"
        },
        "patient_group": {
          "lgbtq_friendly": "LGBTQ+ friendly",
          "lgbtqia": "LGBTQIA+",
          "single_parents": "Parents solos",
          "same_sex_couples": "Couples de même sexe"
        }
      },
      "empty_saved_fr": "Aucune clinique française enregistrée",
      "empty_saved_fr_hint": "Appuie sur le cœur d'une clinique pour l'enregistrer",
      "empty_pgt_fr": "Seules 5 cliniques françaises proposent le DPI",
      "empty_pgt_fr_hint": "Vérifie qu'aucun autre filtre ne restreint la liste",
      "empty_donor_private_fr": "Les programmes de don sont uniquement en secteur public en France",
      "empty_donor_private_fr_hint": "Essaie Public ou Tous les secteurs",
      "empty_multi_filter_fr": "Aucune clinique ne correspond à tous ces filtres",
      "empty_multi_filter_fr_hint": "Essaie de relâcher le filtre de secteur ou de traitement"
    },
    "clinic_card": {
      "your_insurance": "Conventionné",
      "insurance": "Mutuelle",
      "also_virtual": "Téléconsultation",
      "free_consult": "Consult. gratuite",
      "rank_badge": "N°${rank} en France"
    },
    "clinic_detail": {
      "back": "Cliniques",
      "loading": "Chargement des détails du prestataire…",
      "load_failed": "Impossible de charger les détails.",
      "not_found": "Prestataire introuvable",
      "badge": {
        "insurance": "Accepte les mutuelles",
        "free_consult": "Première consult. gratuite",
        "telehealth": "Téléconsultation",
        "military": "Réduction militaire",
        "locations_count": "${count} emplacements"
      },
      "cta": {
        "schedule_consult": "Prendre rendez-vous",
        "coming_soon": "BIENTÔT",
        "schedule_consultation": "Prendre rendez-vous"
      },
      "action_dock": {
        "back": "Retour",
        "schedule": "Rendez-vous",
        "website": "Site web",
        "note": "Note"
      },
      "section": {
        "success_rates": "Taux de réussite",
        "cost_coverage": "Coût et prise en charge",
        "treatments": "Traitements et capacités",
        "services": "Traitements et services",
        "what_people_say": "Ce que les gens disent",
        "location_hours": "Localisation et horaires",
        "visit_information": "Informations pratiques",
        "your_journey": "Ton parcours",
        "pricing": "Tarifs",
        "treatment_pricing": "Tarifs des traitements",
        "accepted_insurance": "Mutuelles acceptées",
        "accepted_insurance_benefits": "Mutuelles acceptées et avantages fertilité employeur",
        "financing_options": "Options de financement",
        "take_a_look": "Jette un œil",
        "employer_benefits": "Avantages fertilité employeur",
        "medical_team": "Équipe médicale (${count})",
        "the_facility": "Le centre",
        "clinic_details": "Détails de la clinique"
      },
      "success_modal": {
        "title": "À propos des taux de réussite reportés",
        "what_this_shows": "Ce que ça montre",
        "data_source": "Source des données",
        "national_average": "Moyenne nationale",
        "disclaimer": "Les taux de réussite dépendent de beaucoup de facteurs et le plus pertinent reste ton diagnostic et ton historique. Ces chiffres sont un point de départ, pas une garantie."
      },
      "network_modal": {
        "title": "À propos de la comparaison réseau",
        "what_this_shows": "Ce que ça montre",
        "why_it_matters": "Pourquoi c'est important"
      },
      "estimate_modal": {
        "title": "Comment ton estimation fonctionne"
      },
      "stat": {
        "clinic_age_rate": "Taux de réussite par âge",
        "personalized_estimate": "Estimation personnalisée"
      },
      "success_tabs": {
        "location": "À cet endroit",
        "network": "Dans le réseau"
      },
      "success_context": {
        "cycles_source": "${count} cycles/an déclarés à ${source}"
      },
      "network": {
        "highest_rates": "Meilleurs taux parmi les emplacements ${network}",
        "highest_rates_fallback": "Meilleurs taux parmi les autres emplacements",
        "no_data": "Cet emplacement n'a pas reporté ses propres données",
        "best_reported": "Meilleur taux par tranche d'âge parmi tous les emplacements",
        "siblings_heading": "Autres emplacements ${network} (${count})",
        "siblings_heading_fallback": "Autres emplacements (${count})",
        "locations_name": "Emplacements ${network}",
        "other_locations_name": "Autres emplacements"
      },
      "entity": {
        "provider": "ce prestataire",
        "clinic": "cette clinique"
      },
      "reporting_sources": {
        "abm": {
          "short_label": "Données ABM",
          "full_name": "Agence de la Biomédecine",
          "rate_heading": "Taux de réussite officiel pour ce centre",
          "what_this_shows": "Le taux cumulatif d'accouchement par cycle de ponction reporté par cette clinique, en combinant les transferts frais et congelés pour tous les âges.",
          "data_source": "Tous les centres AMP français reportent leur activité à l'Agence de la Biomédecine. Ces taux proviennent de la publication ABM du 28 avril 2025 sur les données 2021-2022, agrégées par fiv.fr.",
          "national_average": "La moyenne nationale sur l'ensemble des centres français déclarants est de 30 %."
        },
        "ontario": {
          "short_label": "Financée par l'Ontario",
          "full_name": "Ontario Fertility Program",
          "rate_heading": "Taux de réussite publié",
          "what_this_shows": "Cette source confirme la participation au financement public pour les cliniques de l'Ontario. Elle ne publie pas de taux de réussite comparables au niveau de la clinique.",
          "data_source": "L'Ontario publie les prestataires de traitements de fertilité participant au Ontario Fertility Program, mais pas de taux de réussite FIV publics au niveau de la clinique comme le CDC.",
          "national_average": "CFAS/CARTR publie des rapports agrégés canadiens sur l'AMP, mais la liste du Ontario Fertility Program ne fournit pas de taux comparables au niveau de la clinique."
        },
        "redlara": {
          "short_label": "Membre REDLARA",
          "full_name": "REDLARA",
          "rate_heading": "Taux de réussite publié",
          "what_this_shows": "Cette source confirme la participation au registre et les détails d'identité de la clinique. Elle ne fournit pas de taux de réussite publics comparables au niveau de la clinique.",
          "data_source": "REDLARA publie les informations des centres membres, mais ce n'est pas un système national public obligatoire de reporting des taux de réussite au niveau de la clinique.",
          "national_average": "REDLARA publie des rapports régionaux de registre, mais cette fiche membre ne fournit pas de taux publics obligatoires au niveau de la clinique."
        },
        "hfea": {
          "short_label": "Données HFEA",
          "full_name": "Human Fertilisation and Embryology Authority",
          "rate_heading": "Taux de réussite reporté pour ce centre",
          "what_this_shows": "La fiche HFEA de la clinique est la source de référence. Quand des taux sont importés, compare les cliniques avec la même métrique HFEA, le même traitement et la même période.",
          "data_source": "La HFEA est le régulateur britannique de la fertilité ; son service Choose a Fertility Clinic est la source publique officielle des données des cliniques autorisées.",
          "national_average": "Utilise les comparaisons HFEA uniquement lorsque la métrique, le traitement, la tranche d'âge et la période correspondent."
        },
        "sef": {
          "short_label": "Registre SEF",
          "full_name": "Registro Nacional de Actividad - Registro SEF",
          "rate_heading": "Taux de réussite officiel pour ce centre",
          "what_this_shows": "La source SEF identifie les centres espagnols d'assistance médicale à la reproduction participants et publie des résultats officiels par centre.",
          "data_source": "Les documents publics SEF 2023 décrivent le Registro Nacional de Actividad comme le registre espagnol officiel d'AMP et indiquent que la participation des centres est obligatoire.",
          "national_average": "Compare uniquement les cliniques espagnoles lorsque la métrique, la population et l'année SEF correspondent."
        },
        "dutch_ivf": {
          "short_label": "Chiffres FIV néerlandais",
          "full_name": "deGynaecoloog / NVOG",
          "rate_heading": "Taux de réussite officiels pour ce centre",
          "what_this_shows": "Les pourcentages de grossesses évolutives du rapport pour les colonnes FIV, ICSI et cryo de ce centre néerlandais.",
          "data_source": "deGynaecoloog publie les chiffres FIV néerlandais par centre FIV autorisé. Le rapport 2022 indique couvrir tous les centres FIV titulaires d'une licence.",
          "national_average": "Les barres grises utilisent les totaux nationaux NL 2022 du rapport pour la même colonne FIV, ICSI ou cryo."
        },
        "anzard": {
          "short_label": "YourIVFSuccess",
          "full_name": "YourIVFSuccess / ANZARD",
          "rate_heading": "Taux de réussite officiels pour ce centre",
          "what_this_shows": "Les mesures publiques australiennes de comparaison de cliniques publiées pour cette clinique accréditée RTAC, avec les valeurs nationales quand la source les fournit.",
          "data_source": "YourIVFSuccess est un service public australien de comparaison des cliniques qui utilise les données ANZARD des cliniques de fertilité accréditées.",
          "national_average": "Les barres grises utilisent la moyenne nationale YourIVFSuccess pour la même mesure et la même tranche d'âge."
        },
        "belrap": {
          "short_label": "Rapport BELRAP",
          "full_name": "Belgian Register for Assisted Procreation",
          "rate_heading": "Taux de réussite publié",
          "what_this_shows": "Cette source confirme que le centre apparaît dans les documents BELRAP. Elle ne fournit pas de taux de réussite normalisé au niveau de la clinique pour cette page.",
          "data_source": "Les rapports BELRAP sont publiés par le Belgian College of Physicians in Reproductive Medicine.",
          "national_average": "Aucune moyenne nationale comparable au niveau de la clinique n'est disponible dans cette fiche."
        },
        "dir": {
          "short_label": "Membre D.I.R.",
          "full_name": "Deutsches IVF-Register",
          "rate_heading": "Taux de réussite publié",
          "what_this_shows": "Cette source confirme l'appartenance au registre ainsi que l'identité et les coordonnées de la clinique.",
          "data_source": "Le Deutsches IVF-Register publie une liste d'adresses des centres membres et des rapports nationaux.",
          "national_average": "D.I.R. publie des rapports nationaux agrégés, mais cette fiche ne contient pas de valeur au niveau de la clinique à comparer."
        },
        "iss": {
          "short_label": "Registre ISS PMA",
          "full_name": "Registro Nazionale Procreazione Medicalmente Assistita",
          "rate_heading": "Taux de réussite publié",
          "what_this_shows": "Cette source confirme le centre PMA italien autorisé, son niveau et son type public/privé. Elle ne fournit pas de taux de réussite normalisé au niveau de la clinique pour cette page.",
          "data_source": "L'Istituto Superiore di Sanità italien maintient le Registro Nazionale PMA.",
          "national_average": "L'ISS publie l'activité et les résultats nationaux de PMA, mais cette fiche ne contient pas de valeur au niveau de la clinique à comparer."
        },
        "cnpma": {
          "short_label": "Autorisé CNPMA",
          "full_name": "Conselho Nacional de Procriação Medicamente Assistida",
          "rate_heading": "Taux de réussite publié",
          "what_this_shows": "Cette source confirme que le centre est autorisé pour la PMA au Portugal et fournit ses coordonnées.",
          "data_source": "Le CNPMA publie la liste des centres PMA publics et privés autorisés.",
          "national_average": "Aucune moyenne nationale comparable au niveau de la clinique n'est disponible depuis cette source."
        },
        "eaiya": {
          "short_label": "Autorisé EAIYA",
          "full_name": "Greek National Authority of Assisted Reproduction",
          "rate_heading": "Taux de réussite publié",
          "what_this_shows": "Cette source confirme le statut de licence grec de l'unité d'assistance médicale à la reproduction.",
          "data_source": "EAIYA publie la liste des unités FIV et banques de cryoconservation autorisées.",
          "national_average": "Aucune moyenne nationale comparable au niveau de la clinique n'est disponible depuis cette source."
        },
        "clinic_published": {
          "short_label": "Publié par la clinique",
          "full_name": "Données publiées par la clinique",
          "rate_heading": "Taux de réussite publié par la clinique",
          "inline_disclosure": "Ces données proviennent des documents publics de la clinique et ne sont pas vérifiées ni normalisées par un système national obligatoire.",
          "what_this_shows": "La métrique de réussite publiée publiquement par cette clinique. Les définitions peuvent varier : grossesse par transfert, grossesse évolutive, naissance vivante ou taux cumulatif par ponction.",
          "data_source": "Ces valeurs proviennent du site public ou des documents publiés par la clinique. À traiter différemment des données d'un registre national obligatoire.",
          "national_average": "À comparer à une référence nationale uniquement si la clinique utilise la même métrique, la même année, la même population et le même dénominateur."
        },
        "cdc": {
          "short_label": "Données CDC",
          "full_name": "CDC NASS",
          "rate_heading": "Taux de réussite reporté pour ce centre",
          "what_this_shows": "Le taux de naissances vivantes par cycle de ponction reporté par cette clinique au CDC, par tranche d'âge.",
          "data_source": "Toutes les cliniques de fertilité américaines doivent reporter leurs résultats au National ART Surveillance System (NASS) du CDC. Ce sont des résultats vérifiés au niveau de la clinique, pas des estimations.",
          "national_average": "Les barres grises montrent le taux de réussite moyen national pour chaque tranche d'âge parmi toutes les cliniques déclarantes."
        }
      },
      "empty": {
        "pricing": "Informations sur les tarifs non disponibles pour cette clinique. Les coûts varient selon le protocole, impossible d'afficher des prix forfaitaires ici.",
        "insurance": "Informations sur les mutuelles non disponibles pour cette clinique. Impossible de confirmer quelles mutuelles ou avantages fertilité elle accepte.",
        "clinic_details": "Nous n'avons pas encore d'informations sur les consultations, langues, laboratoire ou année de création pour ce ${entity}."
      },
      "military": {
        "section_title": "Réduction militaire",
        "eligibility": "Éligibilité",
        "coverage": "Couverture",
        "exclusions": "Exclusions",
        "additional_programs": "Programmes complémentaires"
      },
      "facility": {
        "onsite_lab": "Laboratoire d'embryologie sur place",
        "consultations": "Consultations",
        "telehealth": "Téléconsultation",
        "in_person": "En cabinet",
        "languages": "Langues",
        "established": "Fondée en ${year}"
      },
      "journey": {
        "status_label": "Statut",
        "note_label": "Note privée",
        "note_placeholder": "Note ce que tu penses de cette clinique…",
        "saved": "Sauvegardée",
        "saving": "Enregistrement…",
        "save_failed_message": "Nous n’avons pas pu enregistrer cette modification. Ta note est toujours là.",
        "conflict_message": "Cette clinique a changé ailleurs. Ta note est toujours là.",
        "save": "Sauvegarder",
        "compare": "Comparer",
        "compare_soon": "Bientôt",
        "share": "Partager",
        "share_copied": "Lien copié",
        "status": {
          "researching": "Je me renseigne",
          "contacted": "Contactée",
          "consulted": "Consultée",
          "in_treatment": "En traitement",
          "past_patient": "Ancienne patiente"
        }
      },
      "team_modal": {
        "research_focus": "Axes de recherche",
        "publications_one": "${count} publication",
        "publications_other": "${count} publications",
        "add_to_care_team": "Ajouter cette personne à mon équipe soignante",
        "added_to_care_team": "Ajouté à mon équipe soignante",
        "add_error": "Impossible d’ajouter cette personne à votre équipe soignante. Réessayez."
      },
      "footer": {
        "info_prefix": "Les informations de cette page proviennent de données publiquement disponibles sur le site de la clinique",
        "info_with_cdc": " et des rapports nationaux CDC/SART",
        "info_with_abm": " et des rapports de l'Agence de la Biomédecine",
        "info_with_ontario": " et des listes de prestataires du Ontario Fertility Program",
        "info_with_redlara": " et des informations du registre/membres REDLARA",
        "info_with_clinic_published": " et des données publiées par la clinique elle-même",
        "info_suffix": ". Les tarifs, mutuelles et services peuvent avoir changé depuis la dernière mise à jour.",
        "last_updated": "Dernière mise à jour : ${date}",
        "last_updated_unknown": "Inconnue",
        "verify": "Vérifie toujours les détails directement auprès de la clinique avant toute décision."
      },
      "source_badge": {
        "official_national": "Données nationales officielles",
        "program_listing": "Liste de programme",
        "registry_participation": "Participation au registre",
        "mandatory_registry": "Registre obligatoire",
        "clinic_published": "Publié par la clinique"
      },
      "rate_heading": {
        "official": "Taux de réussite officiel pour ce centre",
        "published": "Taux de réussite publié",
        "clinic_published": "Taux de réussite publié par la clinique",
        "reported": "Taux de réussite reporté pour ce centre"
      },
      "inline_disclosure": {
        "abm": "Publication nationale officielle. Ces résultats français au niveau de la clinique proviennent d'un organisme de reporting national, pas du marketing de la clinique.",
        "ontario": "Données de liste de programme uniquement. Identifie les prestataires de fertilité financés publiquement en Ontario ; ce n'est pas un flux public de taux de réussite au niveau de la clinique.",
        "redlara": "Participation au registre uniquement. L'appartenance à REDLARA n'est pas un rapport national public obligatoire de taux de réussite pour le Mexique.",
        "clinic_self_published": "Données publiées par la clinique. Ce taux provient des documents publics de la clinique elle-même et n'est pas vérifié ni normalisé par un système national de reporting obligatoire.",
        "cdc": "Données obligatoires du registre national. Les cliniques américaines sont tenues de reporter ces résultats au niveau de la clinique au CDC NASS."
      },
      "sources_extra": {
        "ontario_short": "Financée par l'Ontario",
        "ontario_full": "Ontario Fertility Program",
        "redlara_short": "Membre REDLARA",
        "redlara_full": "REDLARA",
        "clinic_published_short": "Publié par la clinique",
        "clinic_published_full": "Données publiées par la clinique",
        "ontario_what_this_shows": "Cette source confirme la participation au financement public pour les cliniques de l'Ontario. Elle ne publie pas de taux de réussite comparables au niveau de la clinique.",
        "ontario_data_source": "L'Ontario publie les prestataires de traitements de fertilité participant au Ontario Fertility Program, mais pas de taux de réussite FIV publics au niveau de la clinique comme le CDC.",
        "ontario_national_average": "Aucune moyenne nationale au niveau de la clinique n'est disponible depuis cette source.",
        "redlara_what_this_shows": "Cette source confirme la participation au registre et les détails d'identité de la clinique. Elle ne fournit pas de taux de réussite publics comparables au niveau de la clinique.",
        "redlara_data_source": "REDLARA publie les informations des centres membres, mais ce n'est pas un système national public obligatoire de reporting des taux de réussite au niveau de la clinique.",
        "redlara_national_average": "Aucune moyenne nationale au niveau de la clinique n'est disponible depuis cette source.",
        "clinic_published_what_this_shows": "La métrique de réussite publiée publiquement par cette clinique. Les définitions peuvent varier selon la clinique : grossesse par transfert, grossesse évolutive, naissance vivante, ou taux cumulatif par ponction.",
        "clinic_published_data_source": "Ces valeurs proviennent du site web public ou des documents publiés par la clinique. À traiter différemment des données d'un registre national obligatoire.",
        "clinic_published_national_average": "À comparer à une référence nationale uniquement si la clinique utilise la même métrique, la même année, la même population et le même dénominateur."
      },
      "success_rate_empty": {
        "no_usable_title": "Aucun taux de réussite exploitable",
        "no_published_title": "Pas de taux de réussite publié",
        "no_comparable_title": "Pas de taux de réussite comparable",
        "no_imported_title": "Aucun taux de réussite importé",
        "no_usable_body": "${entity} dispose de données publiées par la clinique, mais nous n'avons pas de taux de réussite exploitable pour cette page. Les taux publiés par la clinique ne sont ni vérifiés ni normalisés par un système national de reporting obligatoire.",
        "no_cdc_sart_body": "${entity} n'a pas de taux de réussite positif publié dans les données CDC/SART américaines importées. Le fichier public peut masquer les résultats pour un faible volume, zéro cycle reporté ou d'autres limites de reporting.",
        "no_abm_body": "${entity} n'a pas encore de taux de réussite comparable au niveau de la clinique dans les données ABM françaises importées.",
        "no_ontario_body": "Cette clinique apparaît dans les listes de prestataires du Ontario Fertility Program, mais cette source ne publie pas de taux de réussite FIV comparables au niveau de la clinique. Cette clinique n'a pas publié son propre taux non plus.",
        "no_redlara_body": "Cette clinique apparaît dans les informations du registre/membres REDLARA, mais ce n'est pas un rapport public obligatoire mexicain de taux de réussite au niveau de la clinique. Cette clinique n'a pas publié son propre taux non plus.",
        "no_hfea_body": "La HFEA est la source publique obligatoire britannique pour les données de cliniques, mais cette fiche ne contient pas encore de taux positif importé pour cette clinique.",
        "no_sef_body": "L'Espagne dispose d'un registre national officiel obligatoire d'AMP via Registro SEF. Ce centre apparaît dans la source SEF participants/résultats, mais cette fiche ne contient pas encore de taux comparable au niveau de la clinique.",
        "no_belrap_body": "Les rapports officiels BELRAP identifient les centres belges déclarants, mais cette fiche ne contient pas de taux public comparable au niveau de la clinique.",
        "no_dir_body": "L'appartenance D.I.R. confirme la participation au registre allemand et les coordonnées, mais ce n'est pas un flux public normalisé de taux de réussite au niveau de la clinique dans cette fiche.",
        "no_iss_body": "L'ISS liste les centres PMA italiens autorisés avec des détails public/privé et de niveau, mais cette fiche ne contient pas de taux comparable au niveau de la clinique.",
        "no_ontario_listing_body": "Le Canada dispose de rapports agrégés CFAS/CARTR sur l'AMP, mais pas de source publique obligatoire au niveau de la clinique pour cette clinique. Cette clinique apparaît dans les listes du Ontario Fertility Program et n'a pas publié son propre taux pour cette page.",
        "no_redlara_country_body": "REDLARA publie des rapports régionaux et des informations de membres, mais ce n'est pas une source publique obligatoire de taux au niveau de la clinique pour ${country}. Cette clinique n'a pas publié son propre taux pour cette page.",
        "no_cnpma_body": "Le CNPMA est une liste portugaise d'autorisation PMA, pas un flux public de taux de réussite au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "no_eaiya_body": "EAIYA est une liste grecque de licences, pas un flux public de taux de réussite au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "no_ca_body": "Il n'existe pas de source publique obligatoire nationale de taux de réussite au niveau de la clinique pour le Canada, et cette clinique n'a pas publié son propre taux non plus.",
        "no_mx_body": "Il n'existe pas de source publique obligatoire mexicaine de taux de réussite au niveau de la clinique pour cette clinique, et celle-ci n'a pas publié son propre taux non plus.",
        "no_redlara_mexico_body": "REDLARA publie des rapports régionaux latino-américains, mais il n'existe pas de source publique obligatoire mexicaine au niveau de la clinique pour cette clinique. Elle n'a pas publié son propre taux non plus.",
        "no_redlara_record_country_body": "REDLARA publie des rapports régionaux et des informations de membres, mais il n'existe pas de source publique obligatoire au niveau de la clinique pour cette clinique en ${country} dans notre fiche. Cette clinique n'a pas publié son propre taux non plus.",
        "no_country_body": "Il n'existe pas de source publique obligatoire nationale de taux de réussite au niveau de la clinique pour ${country}, et cette clinique n'a pas publié son propre taux non plus.",
        "no_au_body": "L'Australie dispose de données publiques de comparaison via YourIVFSuccess / ANZARD, mais cette fiche ne contient pas de taux positif importé au niveau de la clinique.",
        "no_in_body": "Le National ART & Surrogacy Registry indien confirme l'enregistrement ou l'autorisation de la clinique. La source importée ne publie pas de taux publics comparables au niveau de la clinique, et cette clinique n'a pas publié son propre taux pour cette page.",
        "no_id_body": "PERFITRI publie des entrées de registre indonésiennes sur les volumes de cycles FIV, mais ce n'est pas une source publique de taux au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "no_vn_body": "Aucune source publique obligatoire de taux au niveau de la clinique n'a été importée pour le Vietnam, et cette fiche ne contient pas de taux publié par la clinique.",
        "no_ng_body": "Aucune source publique obligatoire de taux au niveau de la clinique n'a été importée pour le Nigeria, et cette fiche ne contient pas de taux publié par la clinique.",
        "no_ru_body": "RAHR publie des rapports nationaux russes sur l'AMP, mais cette fiche ne contient pas de taux comparable au niveau de la clinique. La participation à l'annuaire RAHR n'est pas un taux de réussite spécifique à la clinique.",
        "no_jp_body": "La recherche d'établissements JSOG au Japon confirme les capacités FIV, transfert embryonnaire ou ICSI. La source JSOG importée n'est pas un flux public de taux au niveau de la clinique, et cette clinique n'a pas publié son propre taux pour cette page.",
        "no_kr_body": "Les sources publiques sud-coréennes confirment le statut d'établissement désigné FIV et de production embryonnaire. Les sources gouvernementales importées ne publient pas de taux comparables au niveau de la clinique, et aucun taux publié par la clinique n'est enregistré pour cette page.",
        "no_cn_body": "La liste de la National Health Commission chinoise confirme les technologies d'AMP approuvées et le statut d'activité. La source NHC importée ne publie pas de taux publics comparables au niveau de la clinique, et aucun taux publié par la clinique n'est enregistré pour cette page.",
        "no_fr_body": "Certains centres AMP français ont des données ABM officielles, mais ${entity} n'a pas encore de taux de réussite comparable publié dans notre base.",
        "no_gb_body": "Le Royaume-Uni dispose de données HFEA publiques obligatoires au niveau de la clinique, mais cette fiche ne contient pas encore de taux positif importé.",
        "no_es_body": "L'Espagne dispose d'un registre national officiel obligatoire via Registro SEF, mais cette fiche ne contient pas encore de taux comparable au niveau de la clinique.",
        "no_be_body": "La Belgique dispose de rapports nationaux BELRAP sur l'AMP, mais cette fiche ne contient pas de taux public comparable au niveau de la clinique.",
        "no_de_body": "L'Allemagne dispose de rapports nationaux agrégés D.I.R. et d'un contexte de centres membres, mais cette fiche ne contient pas de taux public normalisé au niveau de la clinique.",
        "no_it_body": "L'Italie dispose du registre national ISS Registro PMA et d'un registre des centres, mais cette fiche ne contient pas de taux comparable au niveau de la clinique.",
        "no_pt_body": "La source portugaise CNPMA est une liste d'autorisation, pas un flux public de taux de réussite au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "no_gr_body": "La source grecque EAIYA est une liste de licences, pas un flux public de taux de réussite au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "supplemental_europe_at": "L'Autriche dispose de rapports annuels IVF-Fonds et de listes de centres conventionnés, mais cette fiche complémentaire n'est pas liée à une valeur publique comparable de taux au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "supplemental_europe_dk": "Le Danemark dispose de données de registre FIV nationales et de tableaux de résultats annuels de la Danish Fertility Society, mais cette fiche complémentaire n'est pas encore reliée à une valeur comparable au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "supplemental_europe_nl": "Les Pays-Bas publient les chiffres FIV 2022 des centres FIV autorisés via deGynaecoloog/NVOG. Cette fiche complémentaire n'est pas encore associée à l'une de ces lignes de centre autorisé, ce qui peut indiquer un site satellite, un site de suivi, un site historique ou un lieu non déclarant.",
        "supplemental_europe_se": "La Suède dispose de rapports du registre national de qualité Q-IVF et de documents publics, mais cette fiche complémentaire n'est pas encore reliée à une valeur comparable au niveau de la clinique. Aucun taux publié par la clinique n'est enregistré pour cette page.",
        "supplemental_europe_default": "Pour ${country}, cette fiche clinique n'est pas liée à une source publique obligatoire vérifiée de taux au niveau de la clinique, et aucun taux publié par la clinique n'est enregistré pour cette page. Les sources d'annuaire/contact servent uniquement à l'identité et à la localisation, pas aux résultats.",
        "no_us_body": "Nous n'avons pas encore de taux de réussite CDC/SART pour ${entity}.",
        "no_default_body": "Nous n'avons pas encore de données de taux de réussite publiées pour ${entity}."
      },
      "wikipedia_source": "Source : Wikipedia",
      "clinic_images_title": "Photos du centre",
      "no_contact_details": "Coordonnées non disponibles pour le moment.",
      "sources": {
        "cdc": {
          "data": "Données CDC",
          "name": "CDC NASS",
          "success_rate_desc": "Taux de naissances vivantes par cycle de ponction reporté par cette clinique au CDC, par tranche d'âge.",
          "reporting_desc": "Toutes les cliniques de fertilité américaines doivent reporter leurs résultats au CDC's National ART Surveillance System (NASS). Ce sont des résultats vérifiés au niveau de la clinique — pas des estimations.",
          "average_desc": "Les barres grises montrent le taux de réussite moyen national pour chaque tranche d'âge, calculé sur l'ensemble des cliniques américaines reportant des données."
        },
        "abm": {
          "data": "Données ABM",
          "name": "Agence de la Biomédecine",
          "success_rate_desc": "Taux cumulatif d'accouchement par cycle de ponction reporté par cette clinique à l'Agence de la Biomédecine, par tranche d'âge.",
          "reporting_desc": "Tous les centres AMP français reportent leur activité à l'Agence de la Biomédecine. Ce sont des résultats vérifiés au niveau du centre — pas des estimations.",
          "average_desc": "La moyenne nationale sur l'ensemble des centres français reportant des données est de 30 %."
        }
      },
      "note_cta": {
        "edit": "Modifier la note",
        "add": "Ajouter une note privée"
      },
      "international_care": {
        "title": "Soins à l'international",
        "body": "Cette clinique est en ${clinicCountry}. Les résultats et la logistique peuvent suivre des règles de reporting, de déplacement, de paiement et de prise en charge différentes de celles des cliniques en ${homeCountry}."
      },
      "location_success_rate_heading": "Taux de réussite reporté pour ce centre",
      "visit_website": "Voir le site de la clinique",
      "empty_state": {
        "no_success_rates_title": "Pas de taux de réussite publié",
        "no_success_rates_provider": "Ce soignant n'a pas de données de taux de réussite publiées dans les rapports SART ou CDC.",
        "no_success_rates_clinic": "Cette clinique n'a pas de données de taux de réussite publiées dans les rapports SART ou CDC.",
        "no_facility_provider": "Aucune image de ce soignant n'est disponible pour le moment.",
        "no_facility_clinic": "Aucune image de cette clinique n'est disponible pour le moment.",
        "no_medical_team_provider": "Informations sur l'équipe médicale non disponibles pour ce soignant.",
        "no_medical_team_clinic": "Informations sur l'équipe médicale non disponibles pour cette clinique.",
        "medical_team_title": "Équipe médicale"
      },
      "schedule_caption": "On contacte la clinique pour toi",
      "estimate_modal_extra": {
        "factors_title": "Facteurs pris en compte dans ton estimation",
        "confidence_title": "Fourchette de confiance",
        "confidence_body": "Fourchette estimée de ${low} à ${high} %, basée sur l'échantillon de cette clinique et les ajustements de ton profil."
      },
      "network_modal_body": {
        "what_this_shows": "Pour chaque tranche d'âge, ce graphique montre le meilleur taux de réussite reporté parmi tous les emplacements du réseau de cette clinique, ainsi que la ville qui l'a reporté.",
        "why_it_matters": "Les réseaux multi-sites peuvent avoir des résultats différents selon le site. Cela aide à voir l'emplacement le plus performant pour ta tranche d'âge si tu es flexible sur l'endroit.",
        "source_note": "Les taux s'appuient sur les mêmes données ${source}. Les écarts entre emplacements peuvent refléter le volume de patientes, les protocoles ou les caractéristiques démographiques."
      },
      "social_channels": "Réseaux sociaux",
      "uk_context": {
        "title": "Contexte du traitement au Royaume-Uni",
        "hfea_title": "Centre de traitement agréé HFEA",
        "hfea_body": "Les centres de fertilité britanniques sont agréés et inspectés par la HFEA. Cette fiche est liée au profil HFEA de la clinique, y compris les inspections publiques et les résultats quand la HFEA les publie.",
        "diagnostics_title": "Prestataire de diagnostic ou de suivi",
        "diagnostics_body": "Ce prestataire est listé pour des tests, un suivi ou des conseils spécialisés liés à la fertilité. Confirme directement s'il réalise lui-même des traitements ou travaille avec une clinique agréée HFEA.",
        "provider_title": "Prestataire fertilité au Royaume-Uni",
        "provider_body": "Confirme le statut de licence HFEA actuel pour tout prestataire qui stocke des gamètes ou embryons, utilise du sperme de donneur ou réalise des traitements de procréation assistée réglementés.",
        "nhs_title": "Le financement NHS dépend du lieu",
        "nhs_body": "L'accès à la FIV financée par le NHS dépend de la nation et, en Angleterre, des critères locaux de l'ICB. L'éligibilité, le nombre de cycles, les médicaments, le stockage et les transferts congelés peuvent varier selon la zone.",
        "referral_title": "Les orientations et courriers comptent",
        "referral_body": "De nombreux parcours NHS commencent par une orientation du médecin généraliste ou de l'hôpital, des examens de fertilité, une revue d'éligibilité et un courrier de financement ou d'étapes suivantes avant le traitement.",
        "consent_title": "Consentement, donneurs et stockage",
        "consent_body": "Les formulaires de consentement HFEA sont une étape clé pour le traitement et le stockage au Royaume-Uni. Les traitements avec donneur ont aussi des règles spécifiques d'identité et de conseil à examiner avant de choisir une voie."
      }
    },
    "cumulative_rate": {
      "national_rank": "Classement national",
      "volume": "Volume",
      "this_clinic": "Cette clinique",
      "national_avg": "Moyenne nationale",
      "live_birth_per_retrieval": "taux de naissances vivantes par ponction d'ovocytes",
      "vs_national_average": "vs moyenne nationale française",
      "volume_unit_year": "${count} ponctions d'ovocytes (${year})",
      "volume_unit_no_year": "${count} ponctions d'ovocytes",
      "rank_format": "#${rank} sur ${total} en France",
      "what_this_means_title": "Ce que ça veut dire",
      "what_this_means_body": "En FIV, une ponction d'ovocytes est un cycle de stimulation ovarienne au cours duquel les ovocytes sont prélevés. Les ovocytes deviennent des embryons — certains sont transférés frais, d'autres congelés pour des tentatives ultérieures. Ce taux correspond au % de ponctions d'ovocytes dans cette clinique ayant abouti à une naissance, en comptant tout embryon (frais ou congelé) issu de cette ponction."
    },
    "location_card": {
      "day_mon": "Lun",
      "day_tue": "Mar",
      "day_wed": "Mer",
      "day_thu": "Jeu",
      "day_fri": "Ven",
      "day_sat": "Sam",
      "day_sun": "Dim",
      "closed": "Fermée",
      "open_in_maps": "Ouvrir dans Maps",
      "opening_hours": "Horaires d'ouverture",
      "open_now": "Ouvert maintenant",
      "no_hours": "Horaires non publiés pour cette clinique. Consulte le site de la clinique pour les horaires à jour.",
      "email_subject": "Question sur les services de fertilité chez ${clinic}",
      "email_body": "Bonjour l'équipe ${clinic},\n\nJ'ai trouvé votre clinique via Louise et je souhaite en savoir plus sur vos services de fertilité.\n\nJ'aimerais prendre rendez-vous ou connaître les prochaines étapes.\n\nMerci"
    },
    "pricing_card": {
      "free": "Gratuit",
      "excludes_medications": "Médicaments non inclus",
      "includes_label": "Inclus :",
      "excludes_label": "Exclus :",
      "medications_additional_footer": "Les médicaments sont en supplément et facturés séparément par la pharmacie.",
      "in_house_payment_plans": "Plans de paiement internes",
      "fertile_guarantee": "Fertile Guarantee",
      "financing_options": "Options de financement",
      "financing_empty": "Nous n'avons pas encore d'informations sur le financement de cette clinique, donc nous ne savons pas si elle propose des plans de paiement ou travaille avec un partenaire de financement.",
      "financing_details_unavailable": "Contacte le centre pour connaître les conditions et l'éligibilité actuelles.",
      "learn_more": "En savoir plus",
      "enrichment": {
        "patientfi": {
          "tagline": "Paiements mensuels pour les traitements de fertilité",
          "highlight_1": "Plans à 0 % APR disponibles",
          "highlight_2": "Préqualification sans vérification dure du crédit",
          "highlight_3": "Paiement sur 6 à 60 mois"
        },
        "capexmd": {
          "tagline": "Financement fertilité et programmes à risque partagé",
          "highlight_1": "Risque partagé : remboursement sans naissance vivante",
          "highlight_2": "Programmes multi-cycles avec remise",
          "highlight_3": "Couvre FIV, médicaments et DPI"
        },
        "future_family": {
          "tagline": "Prêts conçus pour les soins de fertilité",
          "highlight_1": "Couvre FIV, vitrification d'ovocytes et GPA",
          "highlight_2": "Taux fixes dès 5,99 % APR",
          "highlight_3": "Jusqu'à 50 000 $, accord sous 24 h"
        },
        "prosper": {
          "tagline": "Prêts personnels pour dépenses médicales",
          "highlight_1": "Emprunt de 2 000 à 50 000 $",
          "highlight_2": "Taux fixes, pas de pénalité de remboursement anticipé",
          "highlight_3": "Fonds en 1 à 3 jours ouvrés"
        },
        "lendingclub": {
          "tagline": "Financement patient pour les soins",
          "highlight_1": "Paiements mensuels flexibles",
          "highlight_2": "Pas de pénalité de remboursement anticipé",
          "highlight_3": "Vérifie le taux sans affecter le crédit"
        }
      }
    },
    "success_chart": {
      "national_average": "Moyenne nationale",
      "all_ages": "Tous les âges",
      "not_reported": "Non communiqué",
      "avg_value": "moy ${value}%",
      "unavailable_title": "Taux de réussite indisponibles",
      "unavailable_body": "Cette clinique n'a pas encore communiqué de données de réussite FIV",
      "clinic_success_rate": "Taux de réussite de la clinique",
      "based_on_age": "selon ton âge",
      "personalized_estimate": "Estimation personnalisée",
      "confidence_range": "intervalle ${low}–${high}%",
      "personalize_cta": "Personnaliser mon estimation",
      "no_adjustments_body_prefix": "Cette clinique reporte un taux de naissances vivantes de ",
      "no_adjustments_body_suffix": " pour ta tranche d'âge. Complète ton profil santé pour voir comment d'autres facteurs pourraient ajuster ce chiffre pour toi.",
      "info": {
        "how_title": "Comment ça marche",
        "how_body": "Ton estimation personnalisée part du taux de réussite reporté par cette clinique pour ta tranche d'âge, puis l'ajuste en fonction des facteurs de ton profil santé connus pour influencer les résultats en FIV.",
        "adjust_title": "Ce que nous prenons en compte",
        "adjust_body": "Diagnostic (par ex. SOPK, endométriose, faible réserve ovarienne), IMC, statut tabagique, grossesses antérieures et nombre de cycles de FIV précédents. Chaque facteur ajuste l'estimation à la hausse ou à la baisse en s'appuyant sur la recherche clinique évaluée par les pairs.",
        "sources_title": "Sources des données",
        "sources_body": "Les taux de réussite des cliniques proviennent du National ART Surveillance System (NASS) du CDC, qui collecte les résultats vérifiés de toutes les cliniques de fertilité aux États-Unis. Les facteurs d'ajustement sont issus d'études à grande échelle publiées en médecine de la reproduction.",
        "confidence_title": "Intervalle de confiance",
        "confidence_body": "L'intervalle reflète l'incertitude statistique liée à la taille de l'échantillon de la clinique et au nombre d'ajustements appliqués. Les cliniques avec plus de cycles par an produisent des intervalles plus étroits et plus fiables.",
        "disclaimer": "Il s'agit d'une estimation statistique, pas d'une prédiction médicale. Les résultats individuels dépendent de nombreux facteurs non pris en compte ici. Discute toujours de tes chances avec ton spécialiste en fertilité."
      }
    },
    "clinic_services": {
      "group": {
        "treatment-options": "Options de traitement",
        "fertility-preservation": "Préservation de la fertilité",
        "testing-lab": "Tests et services de laboratoire",
        "donor-lgbtq-surrogacy-support": "Don, LGBTQ+, gestation pour autrui et accompagnement"
      },
      "item": {
        "ivf": "FIV et ICSI",
        "iui": "IUI",
        "mini-ivf": "Mini-FIV",
        "ovulation-induction": "Induction de l’ovulation",
        "egg-freezing": "Congélation d’ovocytes",
        "embryo-freezing": "Congélation d’embryons",
        "sperm-freezing": "Congélation de sperme",
        "fertility-preservation": "Préservation de la fertilité",
        "onsite-lab": "Laboratoire d’embryologie sur place",
        "fertility-testing": "Bilan de fertilité",
        "pgt-a": "PGT-A",
        "pgt-m": "PGT-M",
        "pgt-sr": "PGT-SR",
        "pgt-p": "PGT-P",
        "donor-programs": "Programmes de don",
        "gestational-carrier": "Accompagnement d’une gestatrice",
        "lgbtq-care": "Soins LGBTQ+",
        "monitoring": "Rendez-vous de suivi"
      },
      "status": {
        "offered": "Proposé confirmé",
        "not-offered": "Non proposé confirmé",
        "unknown": "Disponibilité non confirmée"
      },
      "metadata": {
        "source": "Source : ${source}",
        "verified": "Vérifié le : ${date}",
        "source_missing": "Source non renseignée",
        "verified_missing": "Date de vérification non renseignée"
      },
      "pgt_subtypes_hint": "Le PGT regroupe plusieurs tests. La disponibilité peut varier selon le sous-type."
    },
    "capabilities": {
      "category": {
        "art": "Traitements principaux",
        "preservation": "Préservation de la fertilité",
        "diagnostic": "Diagnostics",
        "surgical": "Chirurgical",
        "wellness": "Accompagnement & bien-être",
        "lab": "Laboratoire & embryologie",
        "other": "Autres"
      },
      "item": {
        "onsite-lab": "Laboratoire d'embryologie sur place",
        "pgt": "Test génétique (DPI)",
        "blastocyst": "Culture jusqu'au stade blastocyste",
        "assisted-hatching": "Éclosion assistée",
        "time-lapse": "Imagerie time-lapse",
        "ai-embryo": "Grading embryonnaire par IA",
        "onco": "Préservation onco-fertilité",
        "era": "Réceptivité endométriale (ERA)",
        "embryoglue": "EmbryoGlue",
        "ovarian-tissue": "Cryopréservation de tissu ovarien",
        "ivm": "MIV (maturation in-vitro)",
        "immunology": "Immunologie de la reproduction",
        "prp": "PRP (ovarien / endométrial)",
        "peptides": "Thérapies peptidiques",
        "longevity": "Protocoles de longévité"
      },
      "no_info": "Nous n'avons pas encore d'informations sur ${label} pour cette clinique.",
      "no_info_label_confirmed_treatments": "les traitements confirmés"
    },
    "sentiment": {
      "soon_body": "Bientôt tu trouveras ici un résumé de ce que les patientes disent vraiment de cette clinique, rassemblé à partir d'avis, de Reddit et de forums sur la fertilité."
    },
    "empty_state": {
      "contact_verify": "Contacte la clinique pour vérifier"
    },
    "clinic_detail_extra": {
      "cycles_per_year_source": "${count} cycles/an · ${source}"
    }
  },
  "region_gate": {
    "not_available_in_region": "Indisponible dans votre région",
    "us_only_coming_soon": "Cette fonctionnalité est conçue pour les utilisateurs aux États-Unis. Le support français arrivera bientôt."
  },
  "status_badge": {
    "beta": "Beta",
    "coming_soon": "Bientôt"
  },
  "costs": {
    "costs": "Coûts",
    "coverage_and_ways_to_pay": "Couverture et options de paiement",
    "coming_soon": "Bientôt disponible",
    "insurance": "Assurance",
    "employer_benefits": "Avantages employeur",
    "financing": "Options de financement",
    "grants": "Aides à la fertilité",
    "tax_deductions": "Déductions fiscales",
    "donor_scenario_note": "Les coûts varient beaucoup selon les situations avec don. Si tu reçois des ovocytes ou des spermatozoïdes de donneur, demande à la clinique de détailler les frais de don, de laboratoire, les frais juridiques et de conservation. Si tu es donneur ou donneuse, le traitement peut être gratuit ou indemnisé.",
    "us_first_title": "Le module Coûts est d'abord pensé pour les États-Unis",
    "us_first_body": "Louise peut tout de même t'aider à rassembler des devis de cliniques, des factures et tes questions de prise en charge en attendant un module adapté à la France.",
    "insurance_fallback": "Assurance",
    "insurance_add_prompt": "Ajoute ton assurance pour voir ta prise en charge",
    "insurance_verified_suffix": "${name} · Vérifiée",
    "insurance_pending_suffix": "${name} · Vérification en attente",
    "employer_subtitle_default": "Programmes employeur · mutuelle · règles locales",
    "financing_subtitle_default": "5 prestataires · options promotionnelles disponibles",
    "financing_page": {
      "hero_eyebrow": "Options de financement",
      "hero_title": "Trouve une solution adaptée à tes soins",
      "hero_summary": "Compare le fonctionnement de chaque prestataire, les informations demandées et les points à vérifier avant de faire une demande.",
      "prepare_applicant_info": "Préparer mes informations",
      "edit_applicant_info": "Modifier mes informations",
      "best_for": "Idéal pour",
      "funding": "Montant",
      "coverage": "Prise en charge",
      "pricing": "Tarification",
      "credit_check": "Vérification du crédit",
      "provider_access": "Accès au prestataire",
      "provider_details": "Voir les détails",
      "visit_provider": "Visiter le prestataire",
      "fact_sheet_summary_heading": "En bref",
      "fact_sheet_details_heading": "Points à vérifier",
      "fact_sheet_reviewed": "Vérifié le ${date} · ${jurisdiction}",
      "read_provider_terms": "Lire les conditions actuelles",
      "close_fact_sheet": "Fermer",
      "verify_with_provider": "À confirmer avec le prestataire",
      "not_a_credit_product": "Ce n'est pas un produit de crédit",
      "review_pending_details": "Certains détails attendent leur prochaine vérification éditoriale.",
      "fact_sheet_unavailable": "Les détails actuels du prestataire ne sont pas disponibles avant leur vérification.",
      "applicant_dialog_heading": "Préparer ton aperçu",
      "applicant_dialog_intro": "Ces informations t'aident à préparer tes échanges avec les prestataires. Louise n'envoie pas de demande et ne leur transmet pas cet aperçu.",
      "full_name": "Nom complet",
      "date_of_birth": "Date de naissance",
      "email_address": "Adresse e-mail",
      "phone_number": "Téléphone portable",
      "physical_address": "Adresse postale",
      "physical_address_placeholder": "Commence à saisir ton adresse",
      "state": "État",
      "zip_code": "Code postal",
      "clinic_name": "Clinique ou prestataire",
      "treatment_type": "Traitement ou dépense",
      "estimated_treatment_cost": "Coût estimé du traitement",
      "requested_financing_amount": "Montant à financer",
      "employment_status": "Situation professionnelle",
      "employment_status_placeholder": "Salarié·e, indépendant·e, retraité·e, etc.",
      "employer": "Employeur",
      "occupation": "Profession",
      "annual_gross_income": "Revenu brut annuel",
      "household_annual_income": "Revenu annuel du foyer",
      "housing_status": "Situation de logement",
      "housing_status_placeholder": "Locataire, propriétaire, hébergé·e, etc.",
      "monthly_housing_cost": "Coût mensuel du logement",
      "monthly_debt_payments": "Mensualités de dettes",
      "co_applicant_full_name": "Nom complet du co-demandeur",
      "co_applicant_date_of_birth": "Date de naissance du co-demandeur",
      "co_applicant_email": "E-mail du co-demandeur",
      "co_applicant_phone": "Téléphone du co-demandeur",
      "co_applicant_annual_gross_income": "Revenu brut annuel du co-demandeur",
      "co_applicant_employment_status": "Situation professionnelle du co-demandeur",
      "co_applicant_relationship": "Lien avec le co-demandeur",
      "co_applicant_relationship_placeholder": "Partenaire, conjoint·e, membre de la famille, etc.",
      "save_applicant_info": "Enregistrer",
      "save_applicant_info_error": "Nous n'avons pas pu enregistrer ces informations. Réessaie.",
      "cancel_applicant_info": "Annuler",
      "application_profile_disclaimer": "Cet aperçu sert à préparer tes démarches ; ce n'est ni une demande ni une évaluation de crédit."
    },
    "grants_subtitle_count": "${count} programmes disponibles",
    "tax_subtitle_default": "Les frais de fertilité peuvent être déductibles",
    "tax_review": {
      "tax_year_review": "Revue fiscale",
      "tax_year_review_subtitle": "Regroupe ici tes paiements, reçus et justificatifs pour ${tax_year}.",
      "review_this_tax_year": "Revoir cette année fiscale",
      "recap": "Récapitulatif",
      "your_tax_year_recap": "Ton récapitulatif des déductions ${tax_year}",
      "records_analyzed": "${count} dossiers analysés",
      "expenses_added_basis": "Basé sur ${count} dépenses que tu as ajoutées",
      "ready_for_review_count": "${count} prêts à vérifier",
      "needs_attention_count": "${count} à compléter",
      "patient_paid_costs": "Dépenses payées par toi",
      "non_patient_allocations_basis": "${amount} pris en charge par d'autres sources sont suivis séparément",
      "potential_deduction": "Déduction potentielle",
      "potential_deduction_empty_title": "Vois ta déduction potentielle pour ${tax_year}",
      "potential_deduction_empty_body": "Ajoute ton AGI pour comparer les frais médicaux payés par toi au seuil de 7,5 %.",
      "deduction_illustration": "Illustration de la déduction de frais médicaux",
      "add_tax_inputs": "Ajouter les informations fiscales",
      "add_agi_to_calculate": "Ajoute ton AGI pour calculer le seuil",
      "tax_inputs": "Informations fiscales",
      "adjusted_gross_income": "Revenu brut ajusté (AGI)",
      "itemization_status": "Choix de déduction",
      "itemizes_deductions": "Je détaille mes déductions",
      "takes_standard_deduction": "Je prends la déduction standard",
      "itemization_unknown": "Je ne sais pas encore",
      "itemized_deduction_amount_label": "Détaillée",
      "standard_deduction_amount_label": "Standard",
      "review_tax_inputs": "Revoir les informations fiscales",
      "view_tax_inputs": "Voir les informations fiscales",
      "view_tax_review": "Voir la revue fiscale",
      "tax_review_action": "Revue fiscale",
      "tax_inputs_explanation": "L'AGI fixe le seuil de 7,5 %. Le choix de détailler tes déductions nous indique si une déduction de frais médicaux peut s'appliquer.",
      "view_tax_sources": "Voir les sources de la déduction de frais médicaux",
      "tax_sources_title": "Sources de la déduction de frais médicaux",
      "agi_threshold_explanation": "${rate} % de l'AGI s'appliquent avant qu'une déduction de frais médicaux puisse être disponible.",
      "uploaded_photo": "Photo importée",
      "uploaded_file": "Fichier importé",
      "save_tax_inputs": "Enregistrer les informations fiscales",
      "needs_attention": "À vérifier",
      "no_attention": "Chaque dépense a déjà une décision de revue",
      "expenses_in_review": "Dépenses de cette revue",
      "documents_attached": "${count} justificatif(s) joint(s)",
      "missing_items_count": "${count} élément(s) manquant(s)",
      "missing_receipt": "Justificatif manquant",
      "missing_payment_document": "Ajoute une facture ou un reçu de paiement",
      "missing_insurance_outcome": "Ajoute le résultat de l'assurance ou du remboursement",
      "missing_payer_allocation": "Confirme qui a payé cette dépense",
      "missing_eligibility_context": "Confirme qu'il s'agit d'une dépense médicale admissible",
      "not_medical_expense": "Dépense non médicale",
      "tax_eligibility": "Admissibilité fiscale",
      "tax_eligibility_body": "Réponds à ces questions pour séparer les dépenses potentielles des déductions médicales confirmées.",
      "tax_expense_type": "Type de dépense",
      "tax_expense_medical": "Dépense médicale",
      "tax_expense_not_medical": "Non médicale",
      "tax_expense_unknown": "Je ne sais pas",
      "tax_care_recipient": "Qui a reçu les soins ?",
      "tax_care_self": "Moi",
      "tax_care_spouse": "Conjoint·e",
      "tax_care_dependent": "Personne à charge",
      "tax_care_other": "Autre personne",
      "tax_care_unknown": "Je ne sais pas",
      "tax_insurance_outcome": "Résultat du remboursement",
      "tax_insurance_not_applicable": "Non applicable",
      "tax_insurance_not_reimbursed": "Non remboursé",
      "tax_insurance_partially_reimbursed": "Partiellement remboursé",
      "tax_insurance_fully_reimbursed": "Entièrement remboursé",
      "tax_insurance_unknown": "Je ne sais pas",
      "missing_amount_or_date": "Confirme le montant et la date du paiement",
      "missing_provider": "Ajoute le prestataire",
      "ready_for_review": "Prêt à vérifier",
      "needs_your_decision": "Ta décision est nécessaire",
      "excluded_from_review": "Exclu de la revue",
      "included_in_review": "Inclus dans la revue",
      "tax_review_decision": "Décision de revue fiscale",
      "tax_review_decision_body": "Choisis si cette dépense doit compter dans ta déduction potentielle.",
      "include_expense_in_review": "Inclure dans la revue",
      "exclude_expense_from_review": "Exclure de la revue",
      "reset_expense_review_decision": "Réinitialiser la décision",
      "review_expense": "Revoir la dépense",
      "open_payments": "Ouvrir les paiements",
      "add_expense": "Ajouter une dépense",
      "payment_records_empty_title": "Tes paiements et justificatifs",
      "payment_records_empty_body": "Ajoute un paiement ou un justificatif de ${tax_year} pour le revoir ici. Les demandes et remboursements ne sont pas comptés comme des dépenses déductibles.",
      "no_records_title": "Aucun paiement pour le moment",
      "no_records_body": "Ajoute un paiement ou un reçu dans Coûts : il apparaîtra automatiquement ici.",
      "not_enough_information": "Informations insuffisantes",
      "invalid_agi": "Saisis ton AGI, par exemple 100000.",
      "save_tax_inputs_error": "Nous n'avons pas pu enregistrer tes informations fiscales. Réessaie.",
      "missing_document_linkage": "Le justificatif importé n'est pas correctement rattaché.",
      "uploaded_document_label": "Justificatif ${kind} importé",
      "potential_result_disclaimer": "Ceci est une aide à la revue, pas un calcul de déclaration ni un conseil fiscal. Confirme ta situation avec un professionnel qualifié."
    }
  },
  "compare_clinic": {
    "compare_clinic_costs": "Comparer les coûts des cliniques",
    "comparison_coming_soon": "La comparaison des centres d'AMP, avec tarifs des procédures, médicaments et options de prise en charge, sera bientôt disponible.",
    "find_care": "Trouver un centre"
  },
  "faq": {
    "frequently_asked": "Questions fréquentes"
  },
  "phase_content": {
    "getting_started": {
      "title": "Avant le traitement",
      "description": "Phase de préparation où vous complétez les premiers examens et où votre corps est prêt pour le cycle. Votre clinique passe en revue vos antécédents, prescrit les analyses de référence et établit un protocole personnalisé.",
      "key_facts": [
        "Une pilule contraceptive peut être prescrite pour synchroniser votre cycle",
        "Bilans sanguins et échographies de référence sont planifiés",
        "Votre protocole médicamenteux est finalisé",
        "C'est un bon moment pour vous préparer mentalement et poser vos questions"
      ],
      "typical_duration": "1 à 4 semaines",
      "what_happens": "Votre corps est préparé pour la phase de stimulation.",
      "when_to_call": [
        "Vous avez des questions sur votre protocole médicamenteux",
        "Vous avez besoin d'aide pour comprendre votre calendrier"
      ]
    },
    "baseline": {
      "title": "Bilan de référence",
      "description": "Le bilan de référence confirme que vous êtes prête à commencer la stimulation. Un bilan sanguin et une échographie permettent de vérifier vos taux hormonaux et l'état des ovaires avant de débuter les traitements.",
      "key_facts": [
        "Le bilan sanguin vérifie l'E2, la FSH, la LH et la progestérone",
        "L'échographie mesure votre compte de follicules antraux (CFA)",
        "Les résultats déterminent si vous pouvez démarrer ou nécessitez des ajustements",
        "Réalisé en général au 2e ou 3e jour des règles"
      ],
      "typical_duration": "1 à 2 jours",
      "what_happens": "On établit vos taux hormonaux de référence et le compte folliculaire.",
      "when_to_call": [
        "Vos règles n'arrivent pas comme prévu",
        "Vous n'êtes pas sûre du moment où venir pour le bilan"
      ]
    },
    "stimulation": {
      "title": "Stimulation",
      "description": "Des injections hormonales quotidiennes stimulent vos ovaires pour faire mûrir plusieurs ovocytes. Vous aurez des rendez-vous de suivi tous les 2 à 3 jours avec bilan sanguin et échographie.",
      "key_facts": [
        "Les injections sont sous-cutanées (sous la peau) dans le ventre",
        "La plupart des patientes prennent 2 à 3 traitements différents",
        "Les follicules grossissent d'environ 1 à 2 mm par jour",
        "Le taux d'estradiol (E2) monte à mesure que les follicules grossissent",
        "Vous pouvez ressentir des ballonnements ou une légère gêne — c'est normal",
        "Les doses peuvent être ajustées selon votre réponse"
      ],
      "typical_duration": "8 à 14 jours",
      "what_happens": "Plusieurs follicules grandissent, chacun pouvant contenir un ovocyte mature.",
      "when_to_call": [
        "Douleur abdominale intense ou ballonnement marqué",
        "Difficulté à réaliser vos injections",
        "Vous oubliez une dose ou la prenez au mauvais moment",
        "Fièvre supérieure à 38 °C"
      ]
    },
    "trigger": {
      "title": "Déclenchement (trigger)",
      "description": "L'injection de déclenchement provoque la maturation finale des ovocytes. Elle doit être réalisée à l'heure exacte prescrite par votre médecin. La ponction est programmée exactement 36 heures après.",
      "key_facts": [
        "Souvent une seule injection (Ovitrelle, Lupron ou trigger double)",
        "LE TIMING EST CRUCIAL : à prendre à l'heure exacte prescrite",
        "Ponction prévue exactement 36 heures plus tard",
        "Arrêtez les autres traitements de stimulation, sauf indication contraire",
        "Une reconstitution peut être nécessaire — suivez les consignes attentivement"
      ],
      "typical_duration": "36 heures jusqu'à la ponction",
      "what_happens": "Le déclenchement reproduit le pic naturel de LH et conduit à la maturation finale des ovocytes.",
      "when_to_call": [
        "Vous ne savez pas comment reconstituer ou administrer le déclenchement",
        "Vous manquez l'heure du déclenchement ou le faites au mauvais moment",
        "Vous avez une réaction à l'injection"
      ]
    },
    "retrieval": {
      "title": "Ponction d'ovocytes",
      "description": "Court geste (15 à 20 minutes) sous sédation légère, pendant lequel les ovocytes sont prélevés par ponction guidée par échographie. Vous rentrez chez vous le jour même. Prévoyez 1 à 2 jours de repos.",
      "key_facts": [
        "À jeun strict après minuit la veille",
        "Venez accompagnée — pas de conduite après la sédation et un proche doit vous récupérer",
        "Tenue confortable et ample (sans bijoux, lentilles ni vernis)",
        "L'acte dure environ 15 à 20 minutes",
        "Vous restez 1 à 2 heures en salle de réveil",
        "Crampes et ballonnements modérés sont normaux — la plupart prennent 1 à 2 jours",
        "Votre médecin vous communique le nombre d'ovocytes recueillis avant la sortie",
        "Évitez les efforts intenses pendant 1 à 2 semaines pour prévenir une torsion ovarienne"
      ],
      "typical_duration": "1 jour (acte + 1 à 2 jours de récupération)",
      "what_happens": "Une aiguille guidée par échographie aspire le liquide de chaque follicule pour recueillir les ovocytes. Vous êtes sous sédation légère et ne sentirez rien.",
      "when_to_call": [
        "Saignements abondants (plus que des règles)",
        "Fièvre supérieure à 38 °C",
        "Douleur intense non soulagée par les antalgiques prescrits",
        "Difficulté à uriner ou diminution marquée des urines",
        "Prise de poids rapide ou gonflement abdominal important (signes de SHO)"
      ]
    },
    "fertilization": {
      "title": "Fécondation et développement",
      "description": "Au laboratoire, les ovocytes sont mis en contact avec les spermatozoïdes (FIV) ou un spermatozoïde est injecté dans chaque ovocyte (ICSI). Les embryologistes suivent le développement pendant 5 à 7 jours.",
      "key_facts": [
        "Tous les ovocytes ne sont pas fécondés — c'est normal",
        "Les résultats de fécondation sont en général disponibles le lendemain",
        "Les embryons sont évalués aux jours 3 et 5",
        "Une réduction progressive est attendue à chaque étape",
        "Le DPI-A (s'il est prévu) a lieu vers les jours 5 à 7"
      ],
      "typical_duration": "5 à 7 jours",
      "what_happens": "Les ovocytes sont fécondés et se développent en embryons au laboratoire.",
      "when_to_call": [
        "Vous avez des questions sur votre compte rendu de fécondation",
        "Vous devez discuter d'une congélation ou d'un transfert"
      ]
    },
    "transfer": {
      "title": "Transfert d'embryon",
      "description": "Un embryon est délicatement placé dans l'utérus à l'aide d'un fin cathéter. Acte rapide, indolore et sans sédation.",
      "key_facts": [
        "L'acte dure 5 à 10 minutes",
        "Pas de sédation — vous êtes éveillée",
        "Le médecin peut recommander 24 à 48 h de repos",
        "Poursuivez la progestérone comme prescrit",
        "Vessie pleine parfois demandée pour mieux guider l'échographie"
      ],
      "typical_duration": "1 jour",
      "what_happens": "Un embryon est placé délicatement dans la cavité utérine.",
      "when_to_call": [
        "Saignements abondants ou crampes après l'acte",
        "Vous avez des questions sur les restrictions d'activité"
      ]
    },
    "waiting": {
      "title": "Les deux semaines d'attente",
      "description": "La période entre le transfert et le test de grossesse. Souvent la plus éprouvante émotionnellement. Soyez douce avec vous-même.",
      "key_facts": [
        "Poursuivez tous les traitements (en particulier la progestérone)",
        "Une prise de sang (bêta hCG) est réalisée 10 à 14 jours après le transfert",
        "Crampes légères et petits saignements peuvent être normaux — sans présager du résultat",
        "Évitez les tests urinaires : ils peuvent donner de faux résultats",
        "Activité douce OK ; évitez l'exercice intense"
      ],
      "typical_duration": "10 à 14 jours",
      "what_happens": "L'embryon s'implante et commence à se développer.",
      "when_to_call": [
        "Saignements abondants (qui imbibent une protection)",
        "Douleur intense ou crampes fortes",
        "Vertiges ou malaise",
        "Détresse émotionnelle — un accompagnement est possible"
      ]
    },
    "complete": {
      "title": "Cycle terminé",
      "description": "Votre cycle de traitement est terminé. Votre équipe médicale revient sur les résultats avec vous et évoque les prochaines étapes — nouveau cycle, plan de transfert ou conservation à long terme.",
      "key_facts": [
        "Planifiez un rendez-vous de suivi pour discuter des résultats",
        "Faites le point sur vos embryons ou ovocytes congelés",
        "Discutez de la suite et du timing"
      ],
      "typical_duration": "",
      "what_happens": "Les données de votre cycle sont consignées dans votre dossier médical.",
      "when_to_call": [
        "Vous souhaitez discuter des résultats ou des prochaines étapes",
        "Vous avez encore des symptômes liés au cycle"
      ]
    }
  },
  "test_preview": {
    "amh": {
      "test_name": "AMH",
      "test_purpose": "Reflète votre réserve ovarienne restante",
      "value": "2,1",
      "unit": "ng/mL",
      "headline": "Votre AMH est dans la plage normale pour votre âge",
      "interpretation": "L'AMH (hormone anti-müllérienne) reflète la réserve d'ovocytes restante. Votre valeur se situe dans la fourchette typique pour votre âge.",
      "what_this_means": "Votre clinique peut s'appuyer dessus pour planifier un protocole de stimulation standard. Comptez 10 à 15 ovocytes recueillis par cycle, à plus ou moins.",
      "next_step": "Complétez avec un compte de follicules antraux (CFA) à l'échographie au 2e ou 3e jour du cycle pour une vue complète."
    },
    "fsh": {
      "test_name": "FSH",
      "test_purpose": "Indique l'effort fourni par votre corps pour faire mûrir un ovocyte",
      "value": "12,5",
      "unit": "mUI/mL",
      "headline": "Votre FSH est plus élevée qu'attendu",
      "interpretation": "La FSH (hormone folliculo-stimulante) est libérée par votre cerveau pour recruter un follicule à chaque cycle. Une valeur plus élevée signifie que votre corps doit travailler plus pour y parvenir.",
      "what_this_means": "Votre clinique peut adapter votre protocole de stimulation et les doses en conséquence.",
      "next_step": "Discutez avec votre médecin de la pertinence d'un protocole à dose plus élevée."
    },
    "vitamin_d": {
      "test_name": "Vitamine D",
      "test_purpose": "Soutient la qualité ovocytaire et l'implantation",
      "value": "18",
      "unit": "ng/mL",
      "headline": "Votre vitamine D est sous la fourchette habituelle",
      "interpretation": "La vitamine D est associée à la qualité ovocytaire, à l'implantation et plus globalement aux résultats en fertilité. En dessous de 30 ng/mL est généralement considéré insuffisant.",
      "what_this_means": "Remonter votre taux au-dessus de 30 ng/mL avant la ponction est une optimisation simple et peu coûteuse.",
      "next_step": "Discutez avec votre clinique d'une supplémentation (typiquement 2 000 à 4 000 UI/jour) et d'un nouveau dosage dans 8 à 12 semaines."
    },
    "tsh": {
      "test_name": "TSH",
      "test_purpose": "Indique si votre thyroïde suit le rythme des hormones de la fertilité",
      "value": "Voir les détails",
      "unit": "mUI/L",
      "headline": "Votre TSH est dans la partie haute de la fourchette",
      "interpretation": "Une TSH (hormone thyréostimulante) sous 2,5 mUI/L est considérée comme idéale en traitement de fertilité. La vôtre est juste au-dessus de ce seuil.",
      "what_this_means": "Votre clinique peut souhaiter faire baisser ce taux avant la ponction ou le transfert pour soutenir l'implantation.",
      "next_step": "Demandez si un traitement thyroïdien à faible dose mérite d'être envisagé pour ce cycle."
    }
  },
  "treatment_dashboard": {
    "cycle_fallback": "Traitement",
    "monitoring_hint": {
      "label": "Pas encore programmé",
      "detail": "Échographie + bilan sanguin"
    },
    "follicle_bands": {
      "small_label": "Petits",
      "small_range": "<10 mm",
      "growing_label": "En croissance",
      "growing_range": "10–13 mm",
      "near_ready_label": "Presque prêts",
      "near_ready_range": "14–17 mm",
      "ready_label": "Prêts",
      "ready_range": "18 mm et plus",
      "unknown_label": "Mesurés",
      "unknown_range": "taille non précisée"
    },
    "phases": {
      "baseline": {
        "side_effects": "Pas encore d'effets secondaires liés aux traitements. Vous êtes peut-être encore sous pilule contraceptive issue de la phase de suppression.",
        "when_to_call": "Si vos règles arrivent avant votre rendez-vous de baseline, appelez votre clinique pour confirmer le calendrier."
      },
      "stimulation": {
        "side_effects": "Ballonnements, sautes d'humeur, fatigue, maux de tête. Ce sont des réponses normales à la montée d'œstrogènes. Vous pouvez sentir vos ovaires : ils grossissent pour accueillir les follicules en développement.",
        "when_to_call": "Douleur intense, difficulté à respirer, prise de poids brutale (plus de 1 kg/jour), urines très foncées ou fièvre. Ces signes peuvent indiquer un syndrome d'hyperstimulation ovarienne (SHO)."
      },
      "trigger": {
        "side_effects": "Vous pouvez ressentir une vague de ballonnements et de tension mammaire pendant la maturation finale des ovocytes. C'est la réponse de votre corps à la poussée hormonale.",
        "when_to_call": "Si vous prenez le trigger à un mauvais moment, appelez immédiatement. Le timing est crucial pour la réussite de la ponction."
      },
      "retrieval": {
        "side_effects": "Crampes et ballonnements sont normaux après la ponction. De légers saignements sont possibles. Reposez-vous le reste de la journée. La plupart des personnes reprennent leurs activités sous 1 à 2 jours.",
        "when_to_call": "Fièvre, saignements abondants, douleur intense non soulagée par un antalgique simple, ou signes de SHO (prise de poids rapide, difficulté à respirer, diminution des urines)."
      },
      "fertilization": {
        "side_effects": "Vous pouvez encore vous sentir ballonnée après la ponction. Poursuivez les traitements prescrits (en général la progestérone). Hydratez-vous et reposez-vous.",
        "when_to_call": "Si votre clinique ne vous a pas contactée avec les résultats de fécondation d'ici le lendemain après-midi."
      },
      "embryo_development": {
        "side_effects": "La récupération après la ponction se poursuit. Suivez les consignes de votre clinique concernant la progestérone et les autres traitements.",
        "when_to_call": "Si vous n'avez pas reçu de nouvelles de l'équipe d'embryologie d'ici le jour 6."
      },
      "transfer": {
        "side_effects": "Vous pouvez ressentir de légères crampes. Pas besoin d'alitement, une activité normale est OK. Continuez la progestérone comme prescrit.",
        "when_to_call": "Saignements abondants, crampes intenses ou fièvre après l'intervention."
      },
      "waiting": {
        "side_effects": "Crampes, légers saignements, seins tendus : ces signes peuvent être présents que vous soyez enceinte ou non. Ils sont souvent dus à la progestérone. Fiez-vous au test sanguin, pas aux symptômes.",
        "when_to_call": "Saignements abondants, douleur intense ou signes de SHO."
      },
      "complete": {
        "side_effects": "Votre corps reprendra son cycle habituel dans 1 à 2 semaines.",
        "when_to_call": "Tout symptôme inquiétant après l'intervention."
      }
    }
  },
  "test_result_insights": {
    "amh": {
      "test_purpose": "Reflète votre réserve ovarienne restante",
      "test_name": "AMH (Hormone Anti-Müllérienne)"
    },
    "fsh": {
      "test_purpose": "Indique l'effort fourni par votre corps pour faire mûrir un ovocyte",
      "test_name": "FSH (Hormone Folliculo-Stimulante)"
    },
    "sa": {
      "test_purpose": "Concentration, mobilité et morphologie des spermatozoïdes ensemble",
      "test_name": "Spermogramme",
      "value_see_details": "Voir les détails"
    },
    "progesterone": {
      "test_purpose": "Signale l'ovulation et soutient un début de grossesse",
      "test_name": "Progestérone"
    },
    "e2": {
      "test_purpose": "L'œstrogène monte avec les follicules — le signal-clé de la stimulation",
      "test_name": "Œstradiol (E2)"
    },
    "lh": {
      "test_purpose": "L'hormone qui déclenche l'ovulation — le signal-clé du timing du cycle",
      "test_name": "LH (Hormone Lutéinisante)"
    }
  },
  "partner_invite_landing": {
    "eyebrow": "Invitation partenaire",
    "title_named": "${name} vous a invité·e",
    "title_default": "Vous êtes invité·e",
    "body_named": "${name} a choisi Louise pour l'accompagner dans son parcours de fertilité. Grâce à notre fonctionnalité +1, restez au courant des rendez-vous, des étapes du traitement et des prochaines actions, pour être là l'un·e pour l'autre à chaque étape.",
    "body_default": "Votre partenaire a choisi Louise pour l'accompagner dans son parcours de fertilité. Grâce à notre fonctionnalité +1, restez au courant des rendez-vous, des étapes du traitement et des prochaines actions, pour être là l'un·e pour l'autre à chaque étape.",
    "link_is_incomplete": "Ce lien d'invitation est incomplet",
    "ask_partner_to_resend": "Demandez à votre partenaire de renvoyer l'invitation avant de continuer.",
    "get_started": "Commencer"
  },
  "all_lab_results": {
    "back": "Retour",
    "title_all": "Résultats et analyses",
    "title_for_cycle": "Analyses — ${cycle}",
    "search_placeholder": "Rechercher un résultat…",
    "count_one": "${count} résultat",
    "count_other": "${count} résultats",
    "count_filtered_one": "${count} résultat sur ${total}",
    "count_filtered_other": "${count} résultats sur ${total}",
    "no_results_found": "Aucun résultat trouvé",
    "no_results_filtered": "Aucun résultat ne correspond à ces filtres",
    "clear_filters": "Effacer les filtres",
    "no_date": "Sans date",
    "see_details": "Voir les détails",
    "needs_review": "${name} à examiner",
    "compare_with_range": "À comparer avec la plage de référence : ${range}",
    "badge_waiting": "En attente",
    "badge_scheduled": "Programmé",
    "name_unknown": "Inconnu",
    "purpose_amh": "Reflète votre réserve ovarienne restante",
    "purpose_fsh": "Mesure l'effort que fait votre corps pour faire mûrir un ovocyte",
    "purpose_vitamin_d": "Soutient la qualité ovocytaire, les hormones et la santé générale",
    "purpose_tsh": "Indique si votre thyroïde suit le rythme des hormones de la fertilité",
    "purpose_default": "Dernière valeur disponible dans votre dossier",
    "empty_title": "Importez n'importe quel résultat",
    "empty_body": "Déposez des bilans, échographies, examens d'imagerie, résultats génétiques, dossiers complets ou plusieurs fichiers à la fois. Louise les analysera et créera les résultats quand c'est possible.",
    "empty_note": "Vous pouvez aussi importer un dossier complet. Nous en extrairons automatiquement les résultats quand les documents sont assez lisibles.",
    "empty_manual_entry": "Saisir un résultat",
    "empty_chip_blood_work": "Bilan sanguin",
    "empty_chip_hormones": "Hormones",
    "empty_chip_ultrasounds": "Échographies",
    "empty_chip_imaging": "Imagerie",
    "empty_chip_genetics": "Génétique",
    "empty_chip_semen": "Spermogramme",
    "empty_chip_pathology": "Pathologie",
    "empty_chip_full_records": "Dossier complet",
    "filter_all": "Tous",
    "filter_all_cycles": "Tous les cycles",
    "filter_current_cycle": "Cycle en cours",
    "filter_cycle_fallback": "Cycle",
    "filter_no_cycle": "Sans cycle",
    "filter_blood": "Sang",
    "filter_imaging": "Imagerie",
    "filter_genetics": "Génétique",
    "filter_urine": "Urine",
    "filter_semen": "Sperme",
    "filter_pathology": "Pathologie",
    "filter_other": "Autre",
    "filter_resulted": "Disponible",
    "filter_pending": "En attente",
    "filter_needs_review": "À examiner",
    "manual_title": "Ajouter un résultat",
    "manual_subtitle": "Saisissez les informations principales maintenant. Vous pourrez ajouter plus de détails depuis le résultat.",
    "manual_upload_title": "Téléverser un résultat",
    "manual_upload_subtitle": "Glissez-déposez ou choisissez des fichiers",
    "manual_type_blood": "Sang",
    "manual_type_imaging": "Imagerie",
    "manual_type_genetics": "Génétique",
    "manual_type_semen": "Sperme",
    "manual_type_urine": "Urine",
    "manual_type_other": "Autre",
    "manual_name_placeholder": "Nom du test",
    "manual_value_placeholder": "Valeur",
    "manual_unit_placeholder": "Unité",
    "manual_date_placeholder": "Date, AAAA-MM-JJ",
    "manual_save": "Enregistrer",
    "manual_notes": "Saisi manuellement dans Louise",
    "manual_error_required": "Ajoutez un nom de test, une valeur et une date pour enregistrer ce résultat.",
    "manual_error_save": "Impossible d'enregistrer ce résultat. Veuillez réessayer."
  },
  "auth": {
    "session_recovery": {
      "taking_longer_than_expected": "Louise met plus de temps que prévu",
      "session_setup_failed": "La session n'a pas pu être configurée. Vous pouvez recharger Louise ou vous déconnecter et recommencer.",
      "reload": "Recharger Louise",
      "sign_out": "Se déconnecter"
    },
    "two_fa_challenge": {
      "title_totp": "Double authentification",
      "title_recovery": "Code de récupération",
      "subtitle_totp": "Saisissez le code à 6 chiffres de votre application d'authentification.",
      "subtitle_recovery": "Saisissez l'un de vos codes de récupération.",
      "placeholder_recovery": "Code de récupération",
      "error_invalid_totp": "Code invalide. Veuillez réessayer.",
      "error_invalid_recovery": "Code de récupération invalide.",
      "error_generic": "Une erreur s'est produite. Veuillez réessayer.",
      "verify": "Vérifier",
      "use_recovery_code": "Vous n'avez plus accès à votre application ? Utilisez un code de récupération",
      "back_to_totp": "Revenir au code d'authentification",
      "use_passkey": "Utiliser une clé d'accès",
      "subtitle_passkey": "Utilisez votre clé d'accès pour confirmer votre identité.",
      "error_passkey": "Impossible de vérifier votre clé d'accès. Veuillez réessayer."
    }
  },
  "chat": {
    "have_a_question": "Une question ? Discutez avec nous",
    "reply_time": "Nous répondons généralement en moins d'une heure",
    "hub": {
      "close_chat": "Fermer la conversation",
      "open_chat": "Ouvrir la conversation",
      "mode_care_label": "Équipe médicale",
      "mode_care_short": "Équipe",
      "mode_support_label": "Assistance",
      "mode_support_short": "Aide",
      "ai_title": "Louise AI",
      "ai_subtitle": "Votre copilote personnel",
      "ai_empty_prompt": "Posez-moi toutes vos questions. Si elles concernent vos soins, je vous aiderai à y voir plus clair et à savoir quoi faire ensuite.",
      "ai_input_placeholder": "Qu'avez-vous en tête ?",
      "care_title": "Votre équipe médicale",
      "care_subtitle": "Messages de la clinique",
      "care_empty_prompt": "La messagerie avec votre équipe médicale arrive bientôt. Votre clinique ou votre équipe médicale ne s'est pas encore connectée à Louise pour la messagerie directe. Ce n'est pas de votre fait.",
      "care_empty_title": "Messagerie de l'équipe médicale",
      "care_team_fallback": "votre équipe médicale",
      "care_clinic_empty_prompt": "${clinic} ne s'est pas encore connecté à Louise pour la messagerie directe. Ce n'est pas de votre fait.",
      "care_connected_empty_prompt": "La messagerie avec votre équipe médicale arrive bientôt. ${clinic} est connecté·e à Louise, mais les messages de la clinique ne sont pas encore disponibles ici.",
      "care_input_placeholder": "La messagerie avec votre équipe médicale arrive bientôt.",
      "support_title": "Assistance Louise",
      "support_subtitle": "Assistance produit",
      "support_empty_prompt": "Posez vos questions sur l'application à l'assistance Louise. Un membre de notre équipe d'assistance produit vous répondra ici.",
      "support_team_label": "Assistance produit Louise",
      "support_loading": "Chargement de votre conversation avec l'assistance…",
      "support_input_placeholder": "Demandez de l'aide sur l'application à l'assistance Louise."
    }
  },
  "home": {
    "loading": "Chargement de votre plan...",
    "lets_set_up_plan": "Configurons votre plan.",
    "choose_your_journey": "Choisissez votre parcours",
    "helper_not_available_title": "Bientôt disponible en France",
    "helper_not_available_body": "Nous adaptons les parcours don et gestation pour autrui au système français. En attendant, explorez le reste de Louise depuis la barre d'onglets.",
    "greeting_morning": "Bonjour",
    "greeting_morning_named": "Bonjour, ${name}",
    "greeting_afternoon": "Bon après-midi",
    "greeting_afternoon_named": "Bon après-midi, ${name}",
    "greeting_evening": "Bonsoir",
    "greeting_evening_named": "Bonsoir, ${name}",
    "your_partner_fallback": "ton·ta partenaire",
    "back": "Retour",
    "appointment_fallback": "Rendez-vous",
    "online": "En ligne",
    "clinic_visit": "À la clinique",
    "any_time": "À tout moment",
    "test_result_fallback": "Résultat",
    "result_recorded": "Résultat enregistré",
    "daily_check_in": "Check-in du jour",
    "symptoms_logged": "Symptômes enregistrés",
    "logged_with_symptom": "Enregistré : ${symptom}",
    "medication_fallback": "Médicament",
    "take_as_prescribed": "Prendre selon la prescription",
    "alert_unable_to_start_cycle_title": "Impossible de démarrer le cycle",
    "alert_unable_to_start_cycle_body": "Quelque chose s'est mal passé. Réessaie.",
    "alert_ok": "OK",
    "oauth_phone_link": {
      "chat_from_your_phone": "Échange avec Louise depuis ton téléphone",
      "confirm_phone_number": "Confirme ton numéro de téléphone",
      "connect_account_to_texting_concierge": "Cela sécurise davantage ton compte tout en te donnant accès à plus de fonctionnalités.",
      "otp_subtitle": "Nous avons envoyé un code à 6 chiffres au ${phone}",
      "otp_resend": "Renvoyer le code",
      "otp_send_failed": "Nous n’avons pas pu envoyer le code. Réessaie.",
      "otp_invalid_code": "Ce code n’est pas valide. Réessaie.",
      "otp_save_failed": "Ton numéro a été vérifié, mais nous n’avons pas pu terminer son enregistrement. Réessaie.",
      "change_phone_number": "Modifier le numéro",
      "save_verified_phone": "Enregistrer le numéro vérifié",
      "phone_verified_title": "Ton numéro est vérifié",
      "phone_verified_subtitle": "Ton numéro est enregistré sur ton compte et prêt pour des fonctionnalités plus sécurisées.",
      "phone_verified_done": "Terminé",
      "message_user_question": "Que dois-je faire ensuite ?",
      "message_concierge_reply": "Regardons ton parcours.",
      "phone_placeholder": "Numéro de téléphone",
      "phone_required": "Saisis ton numéro de téléphone pour continuer",
      "add_phone": "Ajouter mon numéro"
    },
    "what_to_know": "À savoir",
    "about_you": "À propos de toi",
    "side_effects_title": "Effets secondaires fréquents en ce moment",
    "log_my_symptoms": "Noter mes symptômes",
    "when_to_call_clinic": "Quand contacter ta clinique",
    "call_my_clinic": "Appeler ma clinique",
    "add_my_clinic": "Ajouter ma clinique",
    "no_clinic_on_file": "Nous n'avons pas encore ta clinique enregistrée. Touche ici pour la trouver et l'appeler en un clic la prochaine fois.",
    "donor_modal": {
      "title_source": "Tu fais ça avec un·e partenaire ou un·e donneur·euse ?",
      "title_donor_status": "As-tu déjà choisi un·e donneur·euse ?",
      "partner_title": "Partenaire",
      "partner_subtitle": "Invite-le·la sur Louise pour qu'on intègre sa partie du plan.",
      "donor_title": "Donneur·euse",
      "donor_subtitle": "Dis-nous si le·la donneur·euse est déjà choisi·e ou si tu as besoin d'aide pour en trouver un·e.",
      "donor_selected_title": "J'ai déjà choisi un·e donneur·euse",
      "donor_selected_subtitle": "Ajoute la source du·de la donneur·euse et les documents dont la clinique aura besoin avant le cycle.",
      "donor_need_help_title": "J'ai besoin d'aide pour en trouver un·e",
      "donor_need_help_subtitle": "Accéder au matching donneur·euse et au soutien des registres."
    },
    "coverage_modal": {
      "title": "Par quelle couverture commencer ?",
      "body": "Les frais de fertilité dépendent de l'assurance santé, des avantages employeur, de la couverture pharmacie, des règles de l'État et des options en self-pay.",
      "health_insurance_title": "Assurance santé",
      "health_insurance_subtitle": "Ajoute les détails de ton assureur et de ton contrat pour qu'on vérifie la couverture fertilité, diagnostics, médicaments et stockage.",
      "employer_benefit_title": "Avantage fertilité employeur",
      "employer_benefit_subtitle": "Vérifie ta mutuelle d'entreprise, les accords santé spécifiques à la fertilité ou la prise en charge directe par l'employeur.",
      "unsure_title": "Je ne suis pas sûr·e",
      "unsure_subtitle": "Voir d'abord la vue d'ensemble des coûts, avec les fourchettes self-pay, les bourses, le financement, le HSA/FSA, et ce qu'il faut vérifier."
    },
    "helper_steps": {
      "donor": {
        "apply_title": "Postuler à une clinique ou une agence",
        "apply_subtitle": "Parcours les partenaires qui acceptent de nouveaux·elles donneur·euse·s et envoie ta candidature. Ce sont elles·eux qui financent le dépistage, donc elles·ils passent en premier.",
        "screened_title": "Faire ton dépistage",
        "screened_subtitle": "Une fois accepté·e, ta clinique organise et finance le dépistage médical, psychologique et génétique.",
        "match_title": "Être mis·e en relation avec des parents d'intention",
        "match_subtitle": "Ton profil est partagé avec des parents d'intention à la recherche d'un·e donneur·euse.",
        "sign_title": "Signer ton accord de don",
        "sign_subtitle": "Relis et signe les documents légaux qui couvrent tes droits, les conditions et la compensation.",
        "begin_title": "Commencer ton cycle de don",
        "begin_subtitle": "La procédure elle-même : ponction d'ovocytes ou visites pour don de sperme, selon ton parcours."
      },
      "carrier": {
        "apply_title": "Postuler à une agence de gestation pour autrui",
        "apply_subtitle": "Parcours les agences qui acceptent de nouvelles gestatrices et envoie ta candidature. Elles coordonnent (et financent) le dépistage une fois que tu es retenue.",
        "screened_title": "Faire ton dépistage",
        "screened_subtitle": "Ton agence ou sa clinique partenaire organise et couvre l'évaluation médicale, psychologique et obstétrique.",
        "match_title": "Être mise en relation avec des parents d'intention",
        "match_subtitle": "Ton agence te présente à des familles qui cherchent une gestatrice.",
        "sign_title": "Signer ton contrat de gestation pour autrui",
        "sign_subtitle": "Relis et signe les documents légaux qui couvrent les aspects médicaux, financiers et post-naissance.",
        "begin_title": "Commencer le traitement",
        "begin_subtitle": "Préparation médicamenteuse, transfert d'embryon, grossesse et suivi post-partum."
      }
    },
    "learn_card": {
      "title": "En savoir plus",
      "subtitle": "Articles sur le dépistage, à quoi t'attendre, et les conditions concernées."
    }
  },
  "plan_builder_card": {
    "your_plan_is_ready": "Votre plan est prêt",
    "personalized_based_on": "Personnalisé selon vos réponses",
    "edit": "Modifier",
    "continue_building": "Continuer à construire votre plan",
    "lets_build": "Construisons votre plan",
    "pick_up_where": "Reprenez là où vous vous êtes arrêté·e.",
    "tailor_everything": "Quelques questions rapides pour tout adapter à votre situation.",
    "benefit_testing": "Des tests adaptés à votre corps",
    "benefit_clinics": "Cliniques et tarifs comparés pour vous",
    "benefit_timeline": "Un calendrier qui s'adapte à votre vie",
    "benefit_guidance": "Un accompagnement à chaque étape",
    "continue": "Continuer",
    "get_started": "Commencer",
    "just_3_minutes": "3 minutes suffisent"
  },
  "role_banner": {
    "donor_title": "Accompagnement donneur",
    "donor_body": "Un accompagnement sur la compensation, le dépistage et la mise en relation avec les centres pour les donneurs et donneuses arrivera bientôt.",
    "carrier_title": "Accompagnement gestation pour autrui",
    "carrier_body": "Un accompagnement sur la compensation, les démarches légales et les étapes pour les gestatrices arrivera bientôt.",
    "intended_parent_title": "Accompagnement parent d'intention",
    "intended_parent_body": "Un accompagnement sur les parcours GPA et don, la mise en relation avec les agences et l'accompagnement juridique arrivera bientôt."
  },
  "active_cycle": {
    "progress_through_cycle": "${percent}% de votre cycle"
  },
  "condition_insight": {
    "your_condition": "Votre condition",
    "show_less": "Réduire",
    "learn_more": "En savoir plus",
    "recommended_supplements": "Compléments recommandés"
  },
  "test_result": {
    "your_result": "Votre résultat",
    "category_normal": "Normal",
    "category_low": "Sous la norme",
    "category_high": "Au-dessus de la norme",
    "category_borderline": "Limite",
    "show_less": "Réduire",
    "what_this_means": "Ce que cela signifie pour votre traitement",
    "suggested_next_step": "Prochaine étape suggérée"
  },
  "plan_builder": {
    "save_failure_title": "Ta progression n'a pas été enregistrée",
    "save_failure_detail": "Ce changement n'a pas pu être conservé sur cet appareil. Réessaie.",
    "continue": "Continuer",
    "age": {
      "title": "Quelle est votre date de naissance ?",
      "subtitle": "L'âge influence les délais de fertilité, les protocoles de test et nos recommandations. Nous l'utilisons pour personnaliser votre plan.",
      "placeholder": "JJ/MM/AAAA",
      "age_label": "${age} ans",
      "invalid": "Veuillez saisir une date de naissance valide."
    },
    "goal_recap": {
      "title": "Quel objectif vous correspond le mieux ?",
      "subtitle": "Sélectionnez votre objectif pour qu'on puisse adapter votre plan.",
      "preserve_label": "Préservation de la fertilité",
      "preserve_label_female": "Congélation d'ovocytes",
      "preserve_label_male": "Congélation de sperme",
      "preserve_detail": "Préservez votre fertilité pour plus tard",
      "preserve_detail_female": "Conservez vos ovocytes",
      "preserve_detail_male": "Conservez votre sperme",
      "embryo_label": "Congélation d'embryons",
      "embryo_detail": "Créez et conservez des embryons",
      "pregnancy_label": "Grossesse",
      "pregnancy_detail": "Essayer de concevoir, avec ou sans traitement",
      "egg_donation_label": "Don d'ovocytes",
      "egg_donation_detail": "Devenir donneuse d'ovocytes",
      "sperm_donation_label": "Don de sperme",
      "sperm_donation_detail": "Devenir donneur de sperme"
    },
    "modality": {
      "title": "Quels traitements envisagez-vous ?",
      "subtitle": "Sélectionnez tout ce qui s'applique. Cela nous aide à adapter votre parcours, vos tests et l'estimation des coûts. Vous pourrez toujours modifier plus tard.",
      "ivf_label": "FIV",
      "ivf_description": "Fécondation in vitro — les ovocytes sont prélevés et fécondés en laboratoire.",
      "iui_label": "IIU",
      "iui_description": "Insémination intra-utérine — le sperme est placé directement dans l'utérus.",
      "fet_label": "Transfert d'embryon congelé",
      "fet_description": "Transférer un embryon déjà congelé ; ce parcours ne comprend pas de prélèvement d'ovocytes.",
      "not_sure_label": "Je ne sais pas encore",
      "not_sure_description": "Nous vous aiderons à comprendre les options et à trouver la bonne voie."
    },
    "accepted_plan": {
      "current_plan_title": "Quel traitement avez-vous choisi ?",
      "current_plan_subtitle": "Indiquez ce que vous avez convenu avec votre centre. Cela est différent des traitements que vous envisagez encore et nous aide à afficher les prochaines étapes adaptées.",
      "distinction_note": "Si votre plan n'est pas encore décidé, choisissez cette option. Nous garderons un parcours exploratoire plutôt que de deviner.",
      "treatment_family_prompt": "Quel traitement fait partie de votre plan actuel ?",
      "fertilization_method_prompt": "Comment les ovocytes seront-ils fécondés ?",
      "egg_source_prompt": "D'où viendront les ovocytes ?",
      "egg_state_prompt": "Quel est l'état des ovocytes ?",
      "sperm_source_prompt": "D'où viendra le sperme ?",
      "sperm_state_prompt": "Quel est l'état du sperme ?",
      "transfer_plan_prompt": "Quel est le plan de transfert ?",
      "pgt_plan_prompt": "Un dépistage génétique est-il prévu ?",
      "decision_source_prompt": "Qui a pris cette décision de traitement ?",
      "ivf_option": "FIV",
      "ivf_detail": "Les ovocytes seront prélevés et fécondés en laboratoire.",
      "iui_option": "IIU",
      "iui_detail": "Le sperme préparé sera placé directement dans l'utérus.",
      "egg_freezing_option": "Congélation d'ovocytes",
      "egg_freezing_detail": "Les ovocytes seront prélevés et conservés pour plus tard.",
      "embryo_freezing_option": "Congélation d'embryons",
      "embryo_freezing_detail": "Les embryons seront créés et conservés pour plus tard.",
      "sperm_freezing_option": "Congélation de sperme",
      "sperm_freezing_detail": "Le sperme sera recueilli et conservé pour plus tard.",
      "fet_option": "Transfert d'embryon congelé",
      "fet_detail": "Un embryon conservé sera décongelé puis transféré.",
      "conventional_ivf_option": "FIV classique",
      "conventional_ivf_detail": "Les ovocytes et le sperme sont mis en contact pour féconder.",
      "icsi_option": "ICSI",
      "icsi_detail": "Un spermatozoïde est injecté dans chaque ovocyte sélectionné.",
      "split_ivf_icsi_option": "FIV classique et ICSI",
      "split_ivf_icsi_detail": "Les ovocytes sont répartis entre FIV classique et ICSI.",
      "rescue_icsi_option": "ICSI de rattrapage",
      "rescue_icsi_detail": "L'ICSI est utilisée si la fécondation classique n'a pas lieu.",
      "self_source_option": "Les miens",
      "self_source_detail": "Mes propres ovocytes ou spermatozoïdes.",
      "partner_source_option": "Ceux de mon/ma partenaire",
      "partner_source_detail": "Les ovocytes ou spermatozoïdes de mon/ma partenaire.",
      "donor_source_option": "Ceux d'un donneur",
      "donor_source_detail": "Des ovocytes ou spermatozoïdes issus d'un don.",
      "external_source_option": "Une autre source",
      "external_source_detail": "Une source organisée en dehors de ce centre.",
      "fresh_state_option": "Frais",
      "fresh_state_detail": "Prélevé ou utilisé sans avoir été congelé.",
      "frozen_state_option": "Congelé",
      "frozen_state_detail": "Précédemment congelé et conservé.",
      "surgically_retrieved_option": "Prélevé chirurgicalement",
      "surgically_retrieved_detail": "Prélevé au moyen d'une intervention chirurgicale.",
      "fresh_transfer_option": "Transfert frais",
      "fresh_transfer_detail": "Transfert au cours du même cycle de traitement.",
      "freeze_all_option": "Tout congeler",
      "freeze_all_detail": "Congeler les embryons maintenant et prévoir le transfert plus tard.",
      "later_fet_option": "Transfert plus tard",
      "later_fet_detail": "Prévoir un transfert d'embryon congelé lors d'un cycle ultérieur.",
      "no_transfer_option": "Aucun transfert prévu",
      "no_transfer_detail": "Aucun transfert d'embryon n'est prévu dans ce plan.",
      "pgt_a_option": "DPI-A",
      "pgt_a_detail": "Dépistage du nombre de chromosomes.",
      "pgt_m_option": "DPI-M",
      "pgt_m_detail": "Dépistage d'une maladie héréditaire précise.",
      "pgt_sr_option": "DPI-SR",
      "pgt_sr_detail": "Dépistage des remaniements chromosomiques structuraux.",
      "other_pgt_option": "Un autre test génétique",
      "other_pgt_detail": "Un autre test recommandé par votre équipe de soins.",
      "not_planned_option": "Aucun test génétique prévu",
      "not_planned_detail": "Les tests génétiques ne font pas partie de ce plan.",
      "patient_decision_option": "J'ai décidé",
      "patient_decision_detail": "Cela reflète ma propre décision de traitement.",
      "clinic_decision_option": "Mon centre a décidé",
      "clinic_decision_detail": "Ce choix a été fait par mon équipe de soins.",
      "shared_decision_option": "Mon centre et moi avons décidé ensemble",
      "shared_decision_detail": "Cette décision de traitement a été prise en commun.",
      "not_applicable_option": "Sans objet",
      "not_applicable_detail": "Cette partie ne s'applique pas à mon plan.",
      "not_decided_option": "Pas encore décidé",
      "not_decided_detail": "Je n'ai pas encore de réponse confirmée.",
      "continue_with_plan": "Continuer avec ce plan",
      "save_failed": "Nous n'avons pas pu enregistrer votre plan de traitement. Veuillez réessayer."
    },
    "conditions": {
      "title": "Antécédents médicaux pertinents ?",
      "subtitle": "Sélectionnez tout ce qui s'applique. Cela nous aide à ajuster nos recommandations de tests et à signaler les informations pertinentes.",
      "pcos": "PMOS (ex SOPK)",
      "endometriosis": "Endométriose",
      "thyroid_disease": "Problème de thyroïde",
      "irregular": "Cycles irréguliers",
      "loss": "Fausse couche",
      "low_ovarian_reserve": "Réserve ovarienne diminuée",
      "male_factor": "Infertilité d'origine masculine",
      "cancer": "Cancer (actuel ou passé)",
      "other": "Autre",
      "none_or_unsure": "Aucun / pas sûr·e"
    },
    "ethnicity": {
      "title": "Quelle est votre origine ?",
      "subtitle": "Sélectionnez tout ce qui s'applique. Certaines conditions génétiques sont plus fréquentes dans certaines populations. Cela nous aide à recommander les bons dépistages.",
      "white": "Blanc·he / européen·ne",
      "black": "Noir·e / afro-descendant·e",
      "hispanic": "Hispanique / latino",
      "east_asian": "Asiatique de l'Est",
      "south_asian": "Asiatique du Sud",
      "southeast_asian": "Asiatique du Sud-Est",
      "middle_eastern": "Moyen-Orient / Afrique du Nord",
      "native_american": "Amérindien·ne / autochtone",
      "pacific_islander": "Îles du Pacifique",
      "mixed": "Métis·se / multiethnique",
      "prefer_not_to_say": "Je préfère ne pas répondre"
    },
    "partner_status": {
      "title": "Avec qui faites-vous ce parcours ?",
      "subtitle": "Cela détermine les étapes de test et les démarches légales de votre plan.",
      "with_partner_label": "En couple",
      "with_partner_detail": "Avec le sperme ou les ovocytes de votre partenaire",
      "using_donor_label": "Avec un don",
      "using_donor_detail": "Sperme, ovocytes ou embryons issus d'un don",
      "solo_label": "Seul·e",
      "solo_detail": "En solo avec un don"
    },
    "clinic_status": {
      "title": "Où en êtes-vous avec votre centre ?",
      "subtitle": "Cela nous aide à adapter votre plan à votre situation actuelle.",
      "no_clinic_label": "Je n'ai pas encore cherché",
      "no_clinic_sublabel": "Je découvre encore le processus",
      "researching_label": "Je compare des centres",
      "researching_sublabel": "Je compare les options, sans choix arrêté",
      "at_clinic_label": "Je suis déjà dans un centre",
      "at_clinic_sublabel": "J'ai choisi un centre ou eu une consultation"
    },
    "timeline": {
      "title": "Quand souhaitez-vous commencer ?",
      "subtitle": "Cela nous aide à prioriser vos prochaines actions.",
      "asap_label": "Dès que possible",
      "asap_detail": "Prêt·e à commencer maintenant",
      "three_months_label": "Dans les 3 mois",
      "three_months_detail": "Je règle d'abord quelques détails",
      "six_months_label": "Dans les 6 mois",
      "six_months_detail": "Je planifie à l'avance",
      "exploring_label": "Je me renseigne",
      "exploring_detail": "Je découvre les options"
    },
    "past_cycles": {
      "title": "Avez-vous déjà suivi un traitement de fertilité ?",
      "subtitle": "Cela inclut la FIV, l'IIU, la congélation d'ovocytes, la congélation d'embryons ou les cycles médicamenteux.",
      "yes_label": "Oui, j'en ai suivi ou je suis en traitement",
      "yes_detail": "FIV, IIU, congélation d'ovocytes ou autres cycles, passés ou en cours",
      "no_label": "Non, c'est ma première fois",
      "no_detail": "Je n'ai pas encore commencé de traitement"
    },
    "past_cycle_details": {
      "title": "Parlez-nous de vos cycles",
      "subtitle": "Type de traitement, nombre de cycles et résultat.",
      "cycle_n": "Cycle ${n}",
      "type_label": "Type",
      "count_label": "Combien de cycles ?",
      "outcome_label": "Résultat",
      "outcome_n_label": "Résultat ${type} ${n}",
      "add_another": "Ajouter un autre traitement",
      "type": {
        "ivf": "FIV",
        "iui": "IIU",
        "egg_freezing": "Congélation d'ovocytes",
        "embryo_freezing": "Congélation d'embryons",
        "medicated_cycle": "Cycle médicamenteux",
        "other": "Autre"
      },
      "outcome": {
        "successful": "Réussi",
        "unsuccessful": "Sans succès",
        "cancelled": "Annulé",
        "ongoing": "En cours",
        "prefer_not_to_say": "Je préfère ne pas dire"
      }
    },
    "known_results": {
      "title": "Avez-vous des résultats d'examens ?",
      "subtitle": "Si vous avez déjà des résultats, nous pouvons les interpréter et ajuster votre plan. Passez ce que vous n'avez pas.",
      "amh_label": "AMH (hormone anti-müllérienne)",
      "amh_detail": "Indicateur de réserve ovarienne",
      "amh_unit": "Valeur (ng/mL)",
      "amh_placeholder": "ex. 2,5",
      "fsh_label": "FSH (hormone folliculo-stimulante)",
      "fsh_detail": "Marqueur de fonction ovarienne",
      "fsh_unit": "Valeur (mUI/mL)",
      "fsh_placeholder": "ex. 7,2",
      "sa_label": "Spermogramme",
      "sa_detail": "Numération, mobilité, morphologie des spermatozoïdes",
      "sa_overall_label": "Résultat global",
      "sa": {
        "normal": "Normal",
        "borderline": "Limite",
        "low": "Bas",
        "unknown": "Pas sûr·e"
      },
      "skip": "Je n'ai pas encore de résultats"
    },
    "location_insurance": {
      "title": "Localisation et coûts",
      "subtitle": "Pour les recommandations de centres et l'estimation des coûts.",
      "zip_label": "ZIP Code",
      "zip_placeholder": "ex. 10001",
      "postal_label_fr": "Code postal",
      "postal_placeholder_fr": "ex. 75001",
      "insurance_label": "Avez-vous une assurance santé ?",
      "insurance_label_fr": "Avez-vous une mutuelle ?",
      "insurance_yes": "Oui",
      "insurance_no": "Non",
      "carrier_label": "Assurance (optionnel)",
      "carrier_placeholder": "ex. Aetna, UnitedHealthcare",
      "carrier_placeholder_fr": "ex. MGEN, Harmonie Mutuelle",
      "benefit_label": "Avantages fertilité de votre employeur ?",
      "benefit_yes": "Oui",
      "benefit_no": "Non",
      "benefit_not_sure": "Pas sûr·e"
    },
    "free_text": {
      "title": "Autre chose à nous dire ?",
      "subtitle": "Diagnostics antérieurs, préoccupations particulières, questions, ou tout ce qui nous aiderait à mieux adapter votre expérience. Complètement optionnel.",
      "placeholder": "ex. J'ai eu un cycle de FIV annulé pour mauvaise réponse. Mon médecin a évoqué une réserve ovarienne diminuée et j'aimerais un deuxième avis...",
      "skip": "Passer",
      "char_count": "${current}/${max}"
    },
    "building": {
      "title": "Nous construisons votre plan",
      "subtitle": "Nous adaptons vos analyses, votre calendrier et nos recommandations.",
      "save_error": "Ton plan n'a pas pu être conservé en sécurité sur cet appareil.",
      "retry_save": "Réessayer d'enregistrer"
    },
    "plan_reveal": {
      "title": "Votre plan est prêt",
      "subtitle": "Voici ce que nous avons préparé pour vous.",
      "goal_journey_fallback": "Votre parcours",
      "journey_step_count": "${count} étapes — nous vous guiderons à chaque étape.",
      "testing_title": "Des analyses adaptées à vous",
      "testing_have_results": "Nous interpréterons les résultats que vous avez déjà et vous indiquerons ceux qui restent à faire.",
      "testing_no_results": "Selon votre objectif et vos antécédents, nous avons préparé une liste d'analyses personnalisée pour commencer.",
      "clinics_title": "${count}+ centres à explorer",
      "clinics_body": "Comparez taux de réussite, coûts et avis patients — tout au même endroit.",
      "clinics_distance_suffix": " Nous les classerons par distance.",
      "cost_title": "Estimation des coûts",
      "cost_out_of_pocket": "reste à charge estimé",
      "cost_total": "total estimé",
      "cost_with_insurance": "Renseignez votre mutuelle plus tard pour une estimation plus précise.",
      "cost_without_insurance": "Nous vous aiderons à explorer les options de financement et de réduction des coûts.",
      "conditions_title": "Personnalisé selon vos antécédents",
      "conditions_body_prefix": "Nous avons pris en compte ",
      "conditions_body_suffix": " — vous verrez des conseils adaptés à chaque étape.",
      "accepted_plan_title": "Votre plan de traitement actuel",
      "accepted_plan_subtitle": "Nous utiliserons ces éléments confirmés pour adapter les prochaines étapes.",
      "accepted_plan_treatment": "Traitement : ${value}",
      "accepted_plan_fertilization": "Fécondation : ${value}",
      "accepted_plan_transfer": "Transfert : ${value}",
      "accepted_plan_genetic_testing": "Dépistage génétique : ${value}",
      "cta_go_to_plan": "Voir mon plan",
      "goal": {
        "preserve": "Congélation d'ovocytes",
        "embryo_preserve": "Congélation d'embryons",
        "pregnancy": "Avoir un enfant",
        "egg_donation": "Don d'ovocytes",
        "sperm_donation": "Don de sperme",
        "adoption": "Adoption",
        "surrogacy": "GPA"
      },
      "condition": {
        "pcos": "PMOS (ex SOPK)",
        "endometriosis": "Endométriose",
        "thyroid_disease": "Problème de thyroïde",
        "diminished_ovarian_reserve": "Réserve ovarienne diminuée",
        "primary_ovarian_insufficiency": "Insuffisance ovarienne prématurée",
        "fibroids": "Fibromes",
        "irregular": "Cycles irréguliers",
        "loss": "Fausse couche",
        "cancer": "Antécédent de cancer",
        "male_factor": "Facteur masculin",
        "other": "Autre condition"
      }
    }
  },
  "cost_estimate": {
    "estimated_cost": "Coût estimé",
    "of_total": "sur ${total} au total",
    "coverage_verified": "Couverture vérifiée",
    "verification_pending": "Vérification en cours",
    "not_yet_verified": "Pas encore vérifiée",
    "no_coverage_uploaded": "Aucune couverture renseignée",
    "insurance_covers": "L'assurance couvre ${amount}",
    "you_pay": "À votre charge ${amount}",
    "upload_to_see": "Renseignez votre couverture pour voir ce qui est pris en charge",
    "see_breakdown": "Voir le détail",
    "hide_breakdown": "Masquer le détail",
    "percent_covered": "${percent}% couvert",
    "estimated_total": "Votre total estimé",
    "ways_to_reduce": "Comment réduire vos coûts",
    "hide_ways_to_reduce": "Masquer",
    "disclaimer": "Il s'agit d'estimations basées sur des moyennes nationales. Les coûts réels varient selon la clinique, l'emplacement et le protocole. Votre clinique vous fournira une estimation détaillée lors de la consultation."
  },
  "onboarding": {
    "back": "Retour",
    "continue": "Continuer",
    "next": "Suivant",
    "splash": {
      "eyebrow": "INTELLIGENCE REPRODUCTIVE",
      "title": "Comprendre chaque possibilité.",
      "body": "Faites vos tests, trouvez les soins adaptés, anticipez les coûts, gérez chaque étape du traitement et préparez la suite.",
      "get_started": "Commencer",
      "text_louise": "Écrire à Louise",
      "already_have_account": "Vous avez déjà un compte ?",
      "log_in": "Se connecter"
    },
    "login": {
      "title": "Ravi de vous revoir",
      "phone_subtitle": "Connectez-vous pour reprendre là où vous vous étiez arrêté·e.",
      "or_sign_in_with": "ou connectez-vous avec",
      "sign_in_with": "Se connecter avec ${provider}",
      "passkey": "Se connecter avec une clé d'accès",
      "passkey_error": "La connexion avec la clé d'accès a échoué. Réessayez ou utilisez une autre option.",
      "oauth_error": "Cette option de connexion n'a pas fonctionné. Réessayez ou utilisez une autre option.",
      "new_to_louise": "Vous découvrez Louise ?",
      "get_started": "Commencer",
      "new_to_louise_get_started": "Vous découvrez Louise ? Commencer"
    },
    "welcome_goals": {
      "title": "Qu'est-ce qui vous amène chez Louise ?",
      "subtitle": "À partir d'ici, tout est sur mesure.",
      "preserve_label": "Préserver votre fertilité",
      "preserve_sublabel": "Congeler ovocytes, spermatozoïdes ou embryons",
      "grow_label": "Fonder votre famille",
      "grow_sublabel": "Naturellement ou avec un traitement",
      "donate_label": "Aider quelqu'un d'autre",
      "donate_sublabel": "Vous envisagez le don",
      "learn_label": "Je me renseigne",
      "learn_sublabel": "Découvrir mes options",
      "already_have_account": "Vous avez déjà un compte ?",
      "log_in": "Se connecter"
    },
    "family_building_path": {
      "title": "Comment envisagez-vous de fonder votre famille ?",
      "subtitle": "Cela nous aide à comprendre votre projet familial sans présumer du reste de votre parcours.",
      "with_partner_label": "Avec un·e partenaire",
      "with_partner_sublabel": "Nous préparons ce projet ensemble",
      "on_my_own_label": "Seul·e",
      "on_my_own_sublabel": "Je prépare ce projet de façon autonome",
      "unsure_label": "Je ne sais pas encore",
      "unsure_sublabel": "Je veux d'abord découvrir mes options"
    },
    "journey_stage": {
      "preserve_title": "Que souhaitez-vous explorer ?",
      "preserve_subtitle": "Cela nous aide à adapter votre plan de préparation et la sélection des cliniques.",
      "grow_title": "Où en êtes-vous dans votre projet familial ?",
      "grow_subtitle": "Nous vous orienterons vers les bonnes ressources.",
      "exploring_label": "Je me renseigne",
      "exploring_sublabel": "Je découvre mes options",
      "egg_freezing_label": "Congélation d'ovocytes",
      "egg_freezing_sublabel": "J'y pense ou j'ai déjà commencé",
      "sperm_freezing_label": "Congélation de sperme",
      "sperm_freezing_sublabel": "J'y pense ou j'ai déjà commencé",
      "embryo_freezing_label": "Congélation d'embryons",
      "embryo_freezing_sublabel": "J'y pense ou j'ai déjà commencé",
      "trying_naturally_label": "Conception naturelle",
      "trying_naturally_sublabel": "Pas encore d'intervention médicale",
      "exploring_options_label": "J'explore mes options",
      "exploring_options_sublabel": "Je ne sais pas par où commencer",
      "getting_ready_label": "Je me prépare au traitement",
      "getting_ready_sublabel": "J'envisage IIU, FIV ou d'autres procédures",
      "in_treatment_label": "Déjà en traitement",
      "in_treatment_sublabel": "Actuellement en IIU, FIV ou similaire"
    },
    "treatment_type": {
      "getting_ready_title": "Quel traitement envisagez-vous ?",
      "getting_ready_subtitle": "Choisissez l'option qui vous correspond le mieux. Vous pourrez préciser plus tard.",
      "in_treatment_title": "Quel traitement suivez-vous actuellement ?",
      "in_treatment_subtitle": "Cela nous aide à vous proposer les conseils et l'accompagnement les plus pertinents.",
      "ivf_label": "FIV",
      "ivf_sublabel": "Fécondation in vitro",
      "iui_label": "IIU",
      "iui_sublabel": "Insémination intra-utérine",
      "oi_label": "Stimulation de l'ovulation",
      "oi_sublabel": "Médicaments pour favoriser l'ovulation",
      "embryo_freezing_label": "Congélation d'embryons",
      "embryo_freezing_sublabel": "Créer et préserver des embryons pour plus tard",
      "fet_label": "Transfert d'embryon congelé",
      "fet_sublabel": "Transférer un embryon déjà congelé",
      "not_sure_label": "Je ne sais pas encore",
      "not_sure_sublabel": "Garder mes options ouvertes"
    },
    "how_are_you_helping": {
      "title": "Comment souhaitez-vous aider ?",
      "subtitle": "Choisissez la voie qui vous correspond. Nous adapterons l'expérience.",
      "egg_label": "Donner des ovocytes",
      "egg_sublabel": "Aider d'autres à fonder leur famille",
      "sperm_label": "Donner du sperme",
      "sperm_sublabel": "Aider d'autres à fonder leur famille",
      "carrier_label": "Devenir mère porteuse",
      "carrier_sublabel": "Porter une grossesse pour quelqu'un d'autre"
    },
    "working_with_surrogate": {
      "title": "Qui portera la grossesse ?",
      "subtitle": "Que ce soit vous, votre partenaire ou une personne porteuse, nous adapterons les conseils à votre parcours.",
      "carry_label": "Je porterai la grossesse",
      "carry_sublabel": "Je prévois de vivre la grossesse",
      "partner_label": "Mon ou ma partenaire la portera",
      "partner_sublabel": "Mon ou ma partenaire prévoit de vivre la grossesse",
      "considering_label": "Nous envisageons une GPA",
      "considering_sublabel": "Nous n'avons pas encore décidé qui la portera",
      "surrogate_label": "Une personne porteuse la portera",
      "surrogate_sublabel": "Une personne extérieure à notre couple la portera"
    },
    "sex": {
      "title": "Votre prise en charge dépend de votre biologie",
      "subtitle": "Cela nous aide à adapter les examens, les options, les procédures et les conseils qui vous concernent",
      "afab_label": "Femme",
      "afab_sublabel": "Assignée femme à la naissance",
      "amab_label": "Homme",
      "amab_sublabel": "Assigné homme à la naissance"
    },
    "birthday": {
      "title": "Quel âge avez-vous ?",
      "subtitle": "L'âge est le facteur le plus important en fertilité. Il influence les options de traitement, les résultats attendus et votre calendrier.",
      "placeholder": "JJ/MM/AAAA",
      "years_old": "${age} ans"
    },
    "location": {
      "title": "Où êtes-vous basé·e ?",
      "subtitle": "Saisissez votre ${label} pour que nous puissions trouver des cliniques et vérifier votre couverture dans votre région.",
      "country_search_placeholder": "Rechercher un pays ou un code",
      "country_search_no_matches": "Aucun pays ne correspond à « ${query} »",
      "postal_code_optional_subtitle": "Ajoutez votre code postal si vous en avez un pour personnaliser votre expérience.",
      "postal_code_optional_placeholder": "Code postal (facultatif)",
      "postal_code_required": "Saisissez votre code postal pour continuer.",
      "postal_code_invalid": "Saisissez un code postal valide pour ce pays."
    },
    "partner_confirm": {
      "default_partner_name": "ton·ta partenaire",
      "save_error": "Impossible d'enregistrer ton parcours. Réessaie.",
      "linking_accounts": "Liaison des comptes en cours…",
      "title": "Tu rejoins ${name}",
      "subtitle": "On prépare ton plan pour t'aider à soutenir le parcours de ${name} (${journey}). Tu pourras ajuster à tout moment depuis ton profil.",
      "their_journey": "Son parcours",
      "cta_save": "OK, je rejoins",
      "cta_saving": "Enregistrement…"
    },
    "auth_callback": {
      "completing_sign_in": "Connexion en cours…",
      "sign_in_link_expired": "Ce lien de connexion a expiré",
      "link_no_longer_valid": "Ce lien n'est plus valide. Tu peux te reconnecter ci-dessous.",
      "go_sign_in": "Se reconnecter"
    },
    "create_account": {
      "loading_putting_together": "On rassemble tout...",
      "loading_mapping": "On cartographie vos options...",
      "loading_personalizing": "On personnalise votre calendrier...",
      "loading_ready": "Votre parcours commence ici",
      "saving": "Configuration de votre compte...",
      "welcome_otp": "Saisissez votre code",
      "welcome": "Bienvenue",
      "welcome_with_name": "Bienvenue, ${name}",
      "otp_subtitle": "Nous avons envoyé un code à 6 chiffres au ${phone}",
      "phone_subtitle": "Nous vous recommandons d'utiliser votre numéro pour profiter de notre agent par SMS.",
      "or_sign_up_with": "ou inscrivez-vous avec",
      "phone_placeholder": "Numéro de téléphone",
      "phone_label": "Numéro de téléphone",
      "country_search_placeholder": "Rechercher un pays ou un indicatif",
      "country_search_no_matches": "Aucun pays ne correspond à « ${query} »",
      "send_code": "Envoyer le code",
      "sending": "Envoi...",
      "verifying": "Vérification...",
      "resend_code": "Renvoyer le code",
      "resend_code_countdown": "Renvoyer le code dans ${seconds} s",
      "use_different_number": "Changer de numéro",
      "sign_up_with": "S'inscrire avec ${provider}",
      "error_invalid_phone": "Veuillez saisir un numéro de téléphone valide",
      "error_send_failed": "Échec de l'envoi du code. Réessayez.",
      "error_invalid_code": "Code invalide. Veuillez réessayer.",
      "error_verify_failed": "Une erreur est survenue. Veuillez réessayer.",
      "error_resend_failed": "Échec du renvoi du code. Réessayez.",
      "error_setup_failed": "Échec de la configuration. Veuillez réessayer.",
      "setup_recovery_title": "Nous n'avons pas pu terminer la configuration de votre compte",
      "setup_recovery_body": "Vos réponses sont toujours enregistrées. Réessayez pour terminer la configuration de votre compte.",
      "retry_setup": "Réessayer la configuration",
      "partner_invite_account_ready": "Votre compte est prêt",
      "partner_invite_unavailable": "Votre compte a été créé, mais nous n'avons pas pu vous relier à cette invitation. Réessayez ou continuez sans vous connecter et demandez à votre partenaire de vous envoyer une nouvelle invitation.",
      "partner_invite_invalid": "Votre compte a été créé, mais cette invitation n'est pas disponible. Continuez sans vous connecter et demandez à votre partenaire de vous envoyer une nouvelle invitation.",
      "partner_invite_expired": "Votre compte a été créé, mais cette invitation a expiré. Continuez sans vous connecter et demandez à votre partenaire de vous envoyer une nouvelle invitation.",
      "partner_invite_already_used": "Votre compte a été créé, mais cette invitation a déjà été utilisée. Continuez sans vous connecter et demandez à votre partenaire de vous envoyer une nouvelle invitation.",
      "partner_invite_cancelled": "Votre compte a été créé, mais cette invitation a été annulée. Continuez sans vous connecter et demandez à votre partenaire de vous envoyer une nouvelle invitation.",
      "partner_invite_retry": "Réessayer la connexion",
      "partner_invite_retrying": "Nouvel essai…",
      "partner_invite_continue_unconnected": "Continuer sans se connecter",
      "test_sign_in": "Connexion de test",
      "test_email": "Email",
      "test_password": "Mot de passe",
      "test_signin_button": "Se connecter",
      "test_signin_loading": "Connexion..."
    }
  },
  "country": {
    "us": "États-Unis",
    "gb": "Royaume-Uni",
    "ca": "Canada",
    "au": "Australie",
    "de": "Allemagne",
    "fr": "France",
    "es": "Espagne",
    "it": "Italie",
    "nl": "Pays-Bas",
    "se": "Suède",
    "ch": "Suisse",
    "ie": "Irlande",
    "nz": "Nouvelle-Zélande",
    "sg": "Singapour",
    "jp": "Japon",
    "kr": "Corée du Sud",
    "in": "Inde",
    "ae": "Émirats arabes unis",
    "il": "Israël",
    "br": "Brésil",
    "mx": "Mexique",
    "za": "Afrique du Sud",
    "xx": "Autre"
  },
  "care": {
    "your_care": "Vos soins",
    "view_all": "Tout voir",
    "add_medication": "Ajouter un médicament",
    "add_appointment": "Ajouter un rendez-vous",
    "start_a_cycle": "Démarrer un cycle",
    "start_a_cycle_help": "Commencer à suivre votre traitement",
    "active_cycle": {
      "badge": "Cycle en cours",
      "started": "Démarré le ${date}"
    },
    "today": {
      "title": "Aujourd'hui"
    },
    "coming_up": {
      "title": "À venir",
      "see_all": "Tout voir",
      "until": "jusqu'au ${day}",
      "ongoing": "en cours",
      "daily_until": "Quotidien · ${until}"
    },
    "check_in": {
      "title": "Suivi quotidien des symptômes",
      "how_are_you_feeling": "Comment vous sentez-vous"
    },
    "calendar": {
      "title": "Calendrier",
      "week": "Semaine",
      "month": "Mois",
      "morning": "Matin",
      "evening": "Soir",
      "as_needed": "Si besoin",
      "log_period": "Enregistrer mes règles",
      "save_period": "Enregistrer",
      "day_monday": "Lundi",
      "day_tuesday": "Mardi",
      "day_wednesday": "Mercredi",
      "day_thursday": "Jeudi",
      "day_friday": "Vendredi",
      "day_saturday": "Samedi",
      "day_sunday": "Dimanche",
      "month_jan": "Jan",
      "month_feb": "Fév",
      "month_mar": "Mar",
      "month_apr": "Avr",
      "month_may": "Mai",
      "month_jun": "Juin",
      "month_jul": "Juil",
      "month_aug": "Août",
      "month_sep": "Sep",
      "month_oct": "Oct",
      "month_nov": "Nov",
      "month_dec": "Déc"
    },
    "care_team": {
      "title": "Équipe médicale",
      "manage": "Gérer",
      "primary": "Référent·e"
    },
    "cycle_history": {
      "title": "Cycles précédents",
      "open_cycle_a11y": "Ouvrir ${title}",
      "cycle": "cycle",
      "cycles": "cycles",
      "view_all_past": "Voir tous les cycles précédents",
      "outcome_positive": "Réussi",
      "outcome_negative": "Sans succès",
      "outcome_cancelled": "Annulé",
      "outcome_closed": "Clôturé",
      "outcome_ongoing": "En cours",
      "outcome_frozen": "Congelé",
      "outcome_completed": "Terminé",
      "status_active": "En cours",
      "metric_started": "Début",
      "metric_ended": "Fin",
      "subtitle_default": "Cycle passé",
      "empty": {
        "title": "As-tu déjà suivi un traitement de fertilité ?",
        "subtitle": "Ajoute un traitement passé maintenant, ou dis-nous que cette section ne s'applique pas pour alléger la page.",
        "type_iui": "IIU",
        "type_ivf": "FIV",
        "type_medicated_cycle": "Cycle médicamenté",
        "type_retrieval": "Ponction",
        "type_transfer": "Transfert",
        "type_egg_or_embryo_freezing": "Congélation d'ovocytes ou d'embryons",
        "none_button": "Aucun traitement",
        "none_a11y": "Je n'ai jamais eu de traitement de fertilité",
        "none_saved_title": "Aucun traitement passé enregistré",
        "none_saved_subtitle": "Cela compte maintenant dans l'historique médical. Tu peux annuler ou ajouter un traitement plus tard.",
        "undo_none_button": "Annuler",
        "undo_none_a11y": "Annuler la réponse aucun traitement passé",
        "add_button": "Ajouter un traitement",
        "add_a11y": "Ajouter un traitement passé"
      }
    },
    "results_labs": {
      "title": "Résultats et analyses"
    },
    "conditions": {
      "title": "Diagnostics et antécédents",
      "primary_diagnosis": "Diagnostic principal",
      "contributing_factor": "Facteur associé",
      "surgical_history": "Antécédent chirurgical",
      "detail_modal": {
        "source_label": "Source",
        "close_a11y": "Fermer les détails du diagnostic",
        "care_impact": "Impact sur les soins",
        "fertility_context": "Contexte fertilité",
        "insurance_and_records": "Assurance et documents",
        "what_to_watch": "Ce que Louise garde à l'œil",
        "add_records_cta": "Ajouter des documents",
        "done_cta": "Terminé",
        "view_details_a11y": "Voir les détails de ${title}"
      }
    },
    "cryo_vault": {
      "title": "Cryoconservation",
      "embryo": "Embryon",
      "embryos": "Embryons",
      "egg": "Ovocyte",
      "eggs": "Ovocytes",
      "semen": "Sperme",
      "overview": {
        "title_empty": "Cryoconservation",
        "title_count_one": "${count} échantillon en cryoconservation",
        "title_count_other": "${count} échantillons en cryoconservation",
        "subtitle_empty": "Suis tes ovocytes, embryons et spermatozoïdes congelés.",
        "subtitle_one_facility": "Tes ovocytes, embryons et spermatozoïdes conservés dans ${count} centre.",
        "subtitle_other_facility": "Tes ovocytes, embryons et spermatozoïdes conservés dans ${count} centres.",
        "open_a11y": "Ouvrir la cryoconservation",
        "type_egg_singular": "ovocyte",
        "type_egg_plural": "ovocytes",
        "type_embryo_singular": "embryon",
        "type_embryo_plural": "embryons",
        "type_sperm_singular": "paillette",
        "type_sperm_plural": "paillettes",
        "renewal_not_set": "Non défini",
        "detail_stored_since": "Conservé depuis le ${date}",
        "detail_collected": "Prélevé le ${date}",
        "detail_default": "Conservation enregistrée.",
        "status_stored": "Conservé",
        "status_report_pending": "Rapport en attente",
        "empty_title": "Des échantillons congelés à enregistrer ?",
        "empty_subtitle": "Ajoute tes ovocytes, embryons, paillettes, centre et rapports — ou indique que ça ne te concerne pas.",
        "empty_chip_eggs": "Ovocytes",
        "empty_chip_embryos": "Embryons",
        "empty_chip_sperm": "Paillettes",
        "empty_chip_facility": "Centre",
        "empty_chip_reports": "Rapports",
        "empty_none_a11y": "Je n'ai pas d'échantillons à ajouter",
        "empty_none_button": "Rien à ajouter",
        "empty_add_a11y": "Ajouter des échantillons",
        "empty_add_button": "Ajouter"
      }
    },
    "cryo_vault_bridge": {
      "title": "Cryoconservation",
      "view_all": "Tout voir",
      "specimen": "échantillon",
      "specimens": "échantillons",
      "egg": "ovocyte",
      "eggs": "ovocytes",
      "embryo": "embryon",
      "embryos": "embryons",
      "vial": "paillette",
      "vials": "paillettes",
      "empty_help": "Ajoute les détails de tes échantillons congelés pour suivre tes ovocytes ou embryons conservés.",
      "has_step_help": "Renseigne les détails de ta cryoconservation pour clôturer ton cycle.",
      "add_more": "En ajouter",
      "record_details": "Saisir les détails",
      "add_specimens": "Ajouter des échantillons",
      "complete_cycle": "Clôturer le cycle",
      "type_label_eggs": "Ovocytes",
      "type_label_embryos": "Embryons",
      "type_label_sperm": "Sperme",
      "pill_vitrification": "Vitrification",
      "pill_slow_freeze": "Congélation lente",
      "pill_day": "Jour ${day}",
      "pill_pgt_a": "DPI-A",
      "pill_pgt_m": "DPI-M",
      "pill_pgt_sr": "DPI-SR",
      "pill_pgt_a_m": "DPI-A+M",
      "pill_pgt_pending": "DPI en attente",
      "pill_pgt": "DPI",
      "pill_icsi": "ICSI",
      "pill_ivf": "FIV",
      "pill_split": "Mixte",
      "expand_label": "Développer",
      "collapse_label": "Réduire",
      "live_birth_estimate_a11y": "${action} estimation de naissances vivantes"
    },
    "documents_vault": {
      "title": "Votre dossier",
      "import_my_records": "Importer mes documents",
      "import_my_records_help": "Récupérez vos documents auprès de vos centres et hôpitaux",
      "category_medical_records_label": "Dossiers médicaux",
      "category_medical_records_subtitle": "Analyses et comptes-rendus",
      "category_coverage_benefits_label": "Assurance et couverture",
      "category_coverage_benefits_subtitle": "Cartes et autorisations",
      "category_legal_consent_label": "Formulaires et accords",
      "category_legal_consent_subtitle": "Consentements et documents signés",
      "category_admin_label": "Factures et paiements",
      "category_admin_subtitle": "Factures et reçus"
    },
    "insurance": {
      "title": "Assurance et couverture",
      "lifetime_max": "Plafond à vie",
      "out_of_pocket_ytd": "Reste à charge cette année : ${amount}",
      "preauth_approved": "Entente préalable accordée",
      "preauth_pending": "Entente préalable en attente",
      "preauth_denied": "Entente préalable refusée"
    },
    "medical_history": {
      "title": "Antécédents médicaux",
      "loading": "Chargement...",
      "all_complete": "Toutes les sections sont complètes !",
      "of_done": "${completed} sections sur ${total} complétées",
      "remaining_level": "${remaining} à compléter · ${level}",
      "xp_level": "${xp} XP · Niv.${level}",
      "continue_to_earn": "Continuer pour gagner ${xp} XP",
      "level_1": "Débutant·e",
      "level_2": "En route",
      "level_3": "Explorateur·trice",
      "level_4": "Bien-être confirmé",
      "level_5": "Champion·ne santé",
      "group_basic": "Infos de base",
      "group_cycles": "Fertilité et examens",
      "group_gynae": "Gynéco et grossesses",
      "group_medical": "Antécédents médicaux",
      "group_lifestyle": "Mode de vie"
    },
    "notes": {
      "title": "Notes",
      "today": "Aujourd'hui",
      "day_n": "Jour ${n}",
      "add_a_note": "Ajouter une note...",
      "on_your_mind": "Ce qui vous passe par la tête aujourd'hui...",
      "saving": "Enregistrement...",
      "save": "Enregistrer"
    },
    "embryo_report": {
      "back": "Retour",
      "screen_title": "Test embryonnaire",
      "screen_intro": "Examinez vos résultats et discutez des prochaines étapes avec votre équipe soignante.",
      "loading_failed_title": "Impossible de charger le compte rendu",
      "loading_failed_body": "Un problème est survenu lors de la récupération des résultats. Veuillez réessayer dans un instant.",
      "retry_report": "Réessayer",
      "empty_title": "Pas encore de compte rendu",
      "empty_body": "Dès que vos résultats de DPI ou de séquençage génomique reviendront du laboratoire, ils apparaîtront ici.",
      "upload_or_import_report": "Importer ou téléverser un compte rendu",
      "open_source_document": "Ouvrir le document source",
      "replace_source_document": "Remplacer le document source",
      "source_document_heading": "Document source",
      "source_document_body": "Ce document est lié au compte rendu et peut être ouvert par vous ou votre équipe soignante.",
      "source_document_file": "Compte rendu importé",
      "download_full_report": "Télécharger le compte rendu complet (PDF)",
      "open_cryo_vault": "Ouvrir le Cryo Vault",
      "report_state_pending": "En attente",
      "report_state_partial": "Compte rendu partiel",
      "report_state_final": "Compte rendu final",
      "report_state_corrected": "Compte rendu corrigé",
      "report_state_superseded": "Remplacé",
      "report_state_retracted": "Retiré",
      "report_date": "Date du compte rendu",
      "biopsy_date": "Date de biopsie",
      "retrieval_date": "Date de ponction",
      "clinic": "Centre",
      "physician": "Médecin",
      "laboratory": "Laboratoire",
      "sample_type": "Type d'échantillon",
      "indication": "Indication",
      "review_title": "À examiner avec votre équipe soignante",
      "review_wgs": "Les résultats génomiques sont complexes. Nous recommandons d'en discuter avec un·e conseiller·ère en génétique qui pourra interpréter ces résultats dans leur contexte.",
      "review_pgt": "Votre spécialiste en fertilité peut vous aider à comprendre ces résultats et discuter des prochaines étapes pour la sélection et le transfert d'embryon.",
      "review_no_testing": "Aucune décision de test génétique n'est enregistrée ici. Votre équipe soignante peut expliquer si un test est prévu, non prévu ou encore indécis.",
      "review_clinic_pending": "Votre centre n'a pas encore enregistré de décision concernant le test. Demandez à votre équipe quand le projet de test sera confirmé.",
      "transfer_yes": "Recommandé",
      "transfer_no": "Non recommandé",
      "transfer_counseling": "Avec accompagnement",
      "result_euploid": "Euploïde",
      "result_aneuploid": "Aneuploïde",
      "result_mosaic": "Mosaïque",
      "result_no_result": "Sans résultat",
      "result_na": "N/A",
      "section_summary": "Récapitulatif des résultats",
      "section_comparison": "Comparaison",
      "section_embryos": "Embryons",
      "embryo_search_label": "Rechercher un embryon",
      "embryo_search_placeholder": "Rechercher par embryon ou échantillon",
      "embryo_search_clear": "Effacer la recherche d'embryon",
      "embryo_filter_result": "Filtrer par résultat",
      "embryo_filter_all": "Tous les résultats",
      "embryo_filter_empty": "Aucun embryon ne correspond à ces filtres. Essayez une autre recherche ou un autre résultat.",
      "col_grade": "Grade",
      "col_karyotype": "Caryotype",
      "col_sex": "Sexe",
      "col_result": "Résultat",
      "col_biopsy_day": "Jour de biopsie",
      "col_transfer": "Transfert",
      "col_abnormalities": "Anomalies",
      "col_mosaicism": "Mosaïcisme",
      "col_carrier_status": "Statut de porteur·euse",
      "col_polygenic_risk": "Risque polygénique",
      "col_embryo": "Embryon",
      "carrier_clear": "Aucun",
      "carrier_typical": "Typique",
      "above_avg": "${count} au-dessus de la moyenne",
      "embryo_number": "Embryon ${number}",
      "grade_day": "${grade} · Jour ${day}",
      "day_label": "Jour ${day}",
      "development_section": "Développement de l’embryon",
      "development_day": "Jour ${day}",
      "development_stage": "Stade",
      "development_grade": "Qualité",
      "development_cells": "Cellules",
      "development_status": "Statut",
      "development_arrested": "Arrêté",
      "development_progressing": "En développement",
      "development_notes": "Notes",
      "development_source": "Source",
      "development_verification": "Vérification",
      "of_total": "sur ${total}",
      "entry": {
        "title": "Ajouter les détails du compte rendu",
        "edit_title": "Modifier les détails du compte rendu",
        "edit_intro": "Mettez à jour les informations saisies lorsque votre compte rendu change. Cela ne crée pas une nouvelle interprétation clinique.",
        "edit": "Modifier les détails du compte rendu",
        "open_form": "Ajouter les détails du compte rendu",
        "intro": "Saisissez les informations indiquées sur votre compte rendu de laboratoire. Laissez inconnues les informations absentes et discutez des résultats avec votre équipe soignante.",
        "source_document_ready": "Ce document sera lié lorsque vous enregistrerez le compte rendu.",
        "report_details": "Détails du compte rendu",
        "report_state": "État du compte rendu",
        "correction_reason": "Pourquoi corrigez-vous ce compte rendu ?",
        "correction_reason_placeholder": "Par exemple, le laboratoire a émis un compte rendu corrigé",
        "select_date": "Sélectionner une date",
        "clinic_placeholder": "Centre indiqué sur le compte rendu",
        "physician_placeholder": "Médecin prescripteur",
        "laboratory_placeholder": "Laboratoire d'analyse",
        "indication_placeholder": "Motif indiqué pour l'examen",
        "sample_type_placeholder": "Par exemple, biopsie embryonnaire",
        "test_type": "Type de test",
        "report_state_pending": "Compte rendu en attente",
        "report_state_partial": "Compte rendu partiel",
        "report_state_final": "Compte rendu final",
        "test_type_not_tested": "Aucun test génétique",
        "test_type_undecided": "Pas encore décidé",
        "test_type_clinic_pending": "Décision du centre en attente",
        "test_type_pgt_a": "DPI-A",
        "test_type_pgt_m": "DPI-M",
        "test_type_pgt_sr": "DPI-SR",
        "test_type_pgt_a_pgt_m": "DPI-A + DPI-M",
        "test_type_pgt_a_pgt_sr": "DPI-A + DPI-SR",
        "test_type_pgt_a_pgt_m_pgt_sr": "DPI-A + DPI-M + DPI-SR",
        "test_type_wgs": "Séquençage du génome entier",
        "test_type_other": "Autre test indiqué",
        "embryo_results": "Résultats par embryon",
        "add_embryo": "Ajouter un embryon",
        "remove_embryo": "Retirer l'embryon",
        "no_embryo_results": "Vous pouvez d'abord enregistrer les détails du compte rendu, puis ajouter les résultats par embryon lorsque vous les aurez.",
        "embryo_number": "Embryon ${number}",
        "sample_id": "Identifiant de l'échantillon",
        "embryo_number_field": "Numéro de l'embryon",
        "karyotype": "Caryotype",
        "biopsy_day": "Jour de biopsie",
        "embryo_biopsy_date": "Date de biopsie de l'embryon",
        "comments": "Commentaires",
        "unknown_note": "Saisissez uniquement ce qui figure sur le compte rendu. Moon n'interprète pas les résultats génétiques et ne recommande pas de sélectionner un embryon.",
        "cancel": "Annuler",
        "save": "Enregistrer le compte rendu",
        "update": "Mettre à jour le compte rendu"
      },
      "history": {
        "title": "Historique du compte rendu",
        "saved_versions": "${count} versions enregistrées de ce compte rendu",
        "version_label": "Version ${version}",
        "current_report_label": "Actuelle",
        "corrected_report_label": "Corrigée",
        "updated_on": "Mise à jour le ${date}",
        "correction_reason_label": "Motif de la correction : ${reason}"
      }
    },
    "journey_ahead": {
      "title": "Ton parcours",
      "n_medication": "${n} médicament",
      "n_medications": "${n} médicaments",
      "status_completed": "Terminé",
      "status_current": "Phase actuelle",
      "status_upcoming": "À venir",
      "status_now": "En cours",
      "section_medications": "Médicaments",
      "section_how_it_works": "Comment ça se passe",
      "section_what_to_expect": "À quoi t'attendre",
      "section_how_to_prepare": "Comment se préparer",
      "section_emotional_support": "Soutien émotionnel",
      "emotional_support_body": "Chaque étape de ce parcours apporte ses propres émotions. Sois douce avec toi-même et appuie-toi sur ton entourage."
    },
    "phase_education": {
      "pre_treatment": {
        "description": "Bilans de référence, médicaments et préparation du corps",
        "how_it_works": "Avant le début de la stimulation, ta clinique confirme que tu es prête avec un bilan sanguin et une échographie de référence. Tu revois ton protocole médicamenteux et peux commencer des médicaments de suppression.",
        "duration": "5–7 jours",
        "what_to_expect": [
          "Bilan sanguin et échographie de référence",
          "Revue du protocole médicamenteux",
          "Coordination avec la pharmacie pour la livraison des médicaments"
        ],
        "prep_instructions": [
          "Récupérer toutes les ordonnances",
          "Assister à la formation aux injections",
          "Commencer les vitamines prénatales si ce n'est pas déjà fait"
        ],
        "partner": {
          "description": "Compléments, hygiène de vie et habitudes pour soutenir la qualité du sperme avant le recueil",
          "how_it_works": "Dans les semaines précédant le recueil, beaucoup de cliniques recommandent des compléments (antioxydants, CoQ10, zinc, sélénium, vitamine E) et des ajustements d'hygiène de vie pour soutenir la qualité du sperme. La spermatogenèse dure environ 70 jours, donc les changements faits maintenant influencent ce qui sera recueilli plus tard.",
          "duration": "Semaines avant le recueil",
          "what_to_expect": [
            "Recommandations possibles d'antioxydants ou compléments vitaminiques",
            "Ajustements d'hygiène de vie (sommeil, hydratation, moins d'alcool/tabac)",
            "Spermogramme de référence optionnel pour fixer des attentes"
          ],
          "prep_instructions": [
            "Suis les consignes d'abstinence de la clinique à l'approche du recueil",
            "Évite jacuzzis, saunas et ordinateurs sur les genoux",
            "Réduis l'alcool et le tabac quand tu peux",
            "Reste bien hydraté et mange équilibré — le sperme réagit à l'hygiène de vie"
          ]
        }
      },
      "protocol": {
        "description": "Injections hormonales quotidiennes pour faire grandir plusieurs follicules",
        "how_it_works": "Tu prends des médicaments injectables quotidiens pour stimuler tes ovaires. Ton médecin suit la croissance des follicules avec échographies et bilans sanguins tous les 1–3 jours.",
        "duration": "8–12 jours",
        "what_to_expect": [
          "Légers ballonnements à mesure que les follicules grandissent",
          "Sensibilité aux points d'injection",
          "Rendez-vous de suivi fréquents"
        ],
        "prep_instructions": [
          "Prends les injections à la même heure chaque jour",
          "Reste hydratée et mange des aliments riches en protéines",
          "Évite les efforts intenses"
        ],
        "partner": {
          "description": "Ton·ta partenaire prend des injections hormonales quotidiennes pour faire grandir plusieurs follicules",
          "how_it_works": "Ton·ta partenaire prend des médicaments injectables quotidiens pour stimuler ses ovaires. Son médecin suit la croissance des follicules avec échographies et bilans tous les 1–3 jours.",
          "what_to_expect": [
            "Il peut se sentir ballonné à mesure que les follicules grandissent",
            "Les points d'injection peuvent être sensibles",
            "Rendez-vous de suivi fréquents — souvent tôt le matin"
          ],
          "prep_instructions": [
            "Aide ton partenaire à tenir le rythme des injections quotidiennes",
            "Accompagne ton partenaire aux rendez-vous quand tu peux",
            "Les sautes d'humeur sont normales — sois patient"
          ]
        }
      },
      "egg_retrieval": {
        "description": "Acte court pour recueillir les ovocytes sous sédation légère",
        "how_it_works": "Sous sédation légère, ton médecin utilise une aiguille guidée par échographie pour recueillir les ovocytes de chaque follicule. L'acte dure environ 15–30 minutes.",
        "duration": "Acte de 15–30 min",
        "what_to_expect": [
          "Tu ne sentiras rien pendant l'acte",
          "Légères crampes après",
          "Ta clinique t'appelle le jour même avec le nombre d'ovocytes"
        ],
        "prep_instructions": [
          "Ne rien manger ni boire après minuit",
          "Prévois quelqu'un pour te ramener",
          "Prévois de te reposer toute la journée"
        ],
        "partner": {
          "description": "Acte court pour recueillir les ovocytes de ton·ta partenaire sous sédation légère",
          "how_it_works": "Sous sédation légère, le médecin utilise une aiguille guidée par échographie pour recueillir les ovocytes de chaque follicule de ton·ta partenaire. L'acte dure environ 15–30 minutes.",
          "what_to_expect": [
            "Il ne sentira rien pendant l'acte",
            "Légères crampes après",
            "La clinique appellera le jour même avec le nombre d'ovocytes"
          ],
          "prep_instructions": [
            "Sois disponible le jour de la ponction",
            "Ramène ton partenaire — il ne peut pas conduire après la sédation",
            "Offre-lui une journée calme pour se reposer"
          ]
        }
      },
      "fertilization": {
        "description": "Les ovocytes sont fécondés et les embryons cultivés au laboratoire",
        "how_it_works": "Tes ovocytes sont mis en contact avec le sperme le jour de la ponction. L'équipe d'embryologie suit le développement pendant 5–6 jours.",
        "duration": "5–6 jours",
        "what_to_expect": [
          "Jour 1 : compte rendu de fécondation",
          "Jour 3 : point sur le développement précoce",
          "Jour 5–6 : compte rendu blastocyste et classement"
        ]
      },
      "embryo_development": {
        "description": "Les embryons grandissent et sont classés au laboratoire",
        "how_it_works": "Les embryons continuent à se développer jusqu'au stade blastocyste. Ils peuvent être biopsiés pour un test génétique (DPI-A).",
        "duration": "3–5 jours",
        "what_to_expect": [
          "Mises à jour quotidiennes de l'équipe d'embryologie",
          "Tous les embryons n'atteindront pas le blastocyste",
          "L'attente peut être émotionnellement difficile"
        ]
      },
      "transfer": {
        "description": "Embryon placé dans l'utérus via un cathéter fin",
        "how_it_works": "Un seul embryon est délicatement placé dans ton utérus avec un cathéter fin guidé par échographie. Rapide et indolore.",
        "duration": "Acte de 5–10 min",
        "what_to_expect": [
          "Acte rapide (5–10 minutes)",
          "Tu peux voir l'embryon à l'échographie",
          "Commencer le soutien en progestérone comme indiqué"
        ],
        "prep_instructions": [
          "Bois de l'eau pour avoir la vessie pleine",
          "Porte des vêtements confortables",
          "Prévois une journée calme et sans stress"
        ],
        "partner": {
          "description": "Embryon placé dans l'utérus de ton·ta partenaire via un cathéter fin",
          "how_it_works": "Un seul embryon est délicatement placé dans l'utérus de ton·ta partenaire avec un cathéter fin guidé par échographie. Rapide et indolore.",
          "what_to_expect": [
            "Acte rapide (5–10 minutes)",
            "Ton partenaire peut voir l'embryon à l'échographie",
            "Ton partenaire commence le soutien en progestérone comme indiqué"
          ],
          "prep_instructions": [
            "Accompagne ton partenaire si il le souhaite",
            "Aide à organiser une journée calme et sans stress",
            "Prends en charge les courses pour que ton partenaire puisse se reposer"
          ]
        }
      },
      "luteal_phase": {
        "description": "Période d'attente avant la prise de sang de grossesse",
        "how_it_works": "Continue le soutien en progestérone et attends ta prise de sang bêta hCG, typiquement 10–14 jours après le transfert.",
        "duration": "10–14 jours",
        "what_to_expect": [
          "Continuer tous les médicaments prescrits",
          "Légères crampes et saignements peuvent être normaux",
          "Éviter les tests de grossesse à domicile"
        ],
        "prep_instructions": [
          "Continue la progestérone exactement comme prescrit",
          "Pense à des activités anti-stress",
          "Appuie-toi sur ton entourage"
        ],
        "partner": {
          "description": "Période d'attente avant la prise de sang de grossesse de ton·ta partenaire",
          "how_it_works": "Ton·ta partenaire continue le soutien en progestérone et vous attendez ensemble la prise de sang bêta hCG, typiquement 10–14 jours après le transfert.",
          "what_to_expect": [
            "Ton partenaire continue tous les médicaments prescrits",
            "De légères crampes et des saignements peuvent être normaux",
            "Évitez les tests de grossesse à domicile — la bêta est plus fiable"
          ],
          "prep_instructions": [
            "Assure-toi que ton partenaire prenne sa progestérone à l'heure",
            "Sois patient avec les changements d'humeur — les hormones sont intenses",
            "Allez ensemble au rendez-vous bêta"
          ]
        }
      },
      "sperm_collection": {
        "description": "Recueil d'un échantillon de sperme pour la fécondation",
        "how_it_works": "Un échantillon de sperme est recueilli et préparé par le laboratoire pour servir à la fécondation ou à l'insémination.",
        "duration": "Le jour même",
        "what_to_expect": [
          "Échantillon recueilli à la clinique",
          "Le laboratoire prépare l'échantillon"
        ]
      },
      "insemination": {
        "description": "Sperme préparé placé directement dans l'utérus",
        "how_it_works": "Un cathéter fin sert à placer le sperme lavé directement dans l'utérus, au moment de l'ovulation.",
        "duration": "5–10 minutes",
        "what_to_expect": [
          "Acte rapide et peu inconfortable",
          "Tu peux reprendre tes activités normales après"
        ],
        "partner": {
          "description": "Sperme préparé placé directement dans l'utérus de ton·ta partenaire",
          "how_it_works": "Un cathéter fin sert à placer le sperme lavé directement dans l'utérus de ton·ta partenaire, au moment de son ovulation.",
          "what_to_expect": [
            "Acte rapide et peu inconfortable pour ton partenaire",
            "Ton partenaire peut reprendre ses activités normales après"
          ]
        }
      }
    },
    "treatment_hub": {
      "partner_calendar": {
        "invite_your_partner": "Invitez votre partenaire",
        "once_connected_and_shared_their_calendar_receives_them": "Une fois la connexion faite et le partage des rendez-vous activé, son calendrier reçoit les rendez-vous qui le concernent, celui-ci compris. Vous n’aurez rien à transmettre.",
        "invite_my_partner": "Inviter mon partenaire",
        "not_now": "Plus tard"
      },
      "title": "Centre de suivi",
      "start_your_treatment": "Commencer votre traitement",
      "start_your_treatment_help": "Suivez votre cycle étape par étape.",
      "start_tracking": "Commencer le suivi",
      "save_failed_title": "Échec de l'enregistrement",
      "save_failed_message": "Nous n'avons pas pu enregistrer cette étape. Veuillez réessayer.",
      "waiting_requires_performed_title": "Transfert non enregistré",
      "waiting_requires_performed_message": "La période d'attente commence après que vous avez indiqué que le transfert a eu lieu. Enregistrez d'abord le transfert effectué, puis réessayez.",
      "completion": {
        "all_steps_complete": "Toutes les étapes terminées !",
        "treatment_complete": "Traitement terminé",
        "cycle_label": "${treatment} — Cycle n°${number}",
        "days_clinic_separator": "${days} jours · ${clinic}",
        "days_only": "${days} jours",
        "summary_header": "Récapitulatif du traitement",
        "skipped": "Sautée",
        "completed": "Terminée",
        "trigger_confirmed": "Déclenchement confirmé",
        "iui_completed": "IUI terminée",
        "eggs_collected": "${count} ovocytes recueillis",
        "mature_count": "${count} matures",
        "frozen_count": "${count} congelé·e·s",
        "fertilized_count": "${count} fécondé·e·s",
        "transferred_count": "${count} transféré·e·s",
        "med_count_one": "${count} médicament",
        "med_count_other": "${count} médicaments",
        "med_more_suffix": "+${count} de plus",
        "cta_complete_cycle": "Terminer le cycle",
        "cta_complete_preservation": "Terminer la préservation",
        "cta_enter_waiting": "Passer en phase d'attente",
        "cta_complete_this_cycle": "Terminer ce cycle",
        "cryo_add_default": "Ajouter au Cryo Vault",
        "cryo_add_eggs": "Ajouter les ovocytes au Cryo Vault",
        "cryo_add_embryos": "Ajouter les embryons au Cryo Vault",
        "cryo_add_subtitle": "Renseignez le nombre de paillettes, le centre de conservation et les dates pour votre suivi.",
        "cryo_added_title": "Enregistré dans ton Cryo Vault",
        "cryo_added_subtitle": "Ouvre le vault pour consulter ou modifier les détails.",
        "cryo_added_a11y": "Voir le Cryo Vault"
      },
      "scheduled_view": {
        "eyebrow": "Planifié",
        "due_eyebrow": "C'est le jour",
        "countdown_unit_days": "jours",
        "countdown_unit_soon": "bientôt",
        "due_hero_unit": "à toi de logger",
        "subline_with_time": "${date} · ${time}",
        "due_today_title": "C'est aujourd'hui · à toi de logger",
        "due_today_cta": "Saisir les résultats",
        "edit_a11y": "Modifier la date",
        "prep_tips_title": "À prévoir",
        "prep_tips": {
          "egg_retrieval": "Pas de nourriture solide les 8 h précédentes · Arrive 30 min avant pour l'admission · Quelqu'un doit pouvoir te ramener",
          "transfer": "Vessie pleine au moment du transfert · Pas besoin de repos strict après",
          "insemination": "Présente-toi à l'heure exacte, le sperme est préparé juste avant",
          "sperm_collection": "Abstinence de 2 à 5 jours recommandée · Apporte une pièce d'identité"
        }
      },
      "step_card": {
        "current_badge": "Actuelle",
        "skipped_badge": "Sautée",
        "scheduled_badge": "Planifié le ${date}",
        "partner_data_chip": "Données du·de la partenaire",
        "partner_named_data_chip": "Données de ${name}",
        "awaiting_partner_update": "En attente de la mise à jour de votre partenaire",
        "awaiting_partner_named_update": "En attente de la mise à jour de ${name}",
        "add_info": "Ajouter des infos",
        "sperm_question": "Quel sperme utilisez-vous ?",
        "sperm_fresh": "Frais",
        "sperm_frozen_own": "Congelé (le vôtre)",
        "sperm_frozen_partner": "Congelé (partenaire)",
        "sperm_frozen_donor": "Congelé (donneur)"
      },
      "step_filled": {
        "completed": "Terminé",
        "waiting_in_progress": "Phase d'attente en cours",
        "medications_one": "${count} médicament",
        "medications_other": "${count} médicaments",
        "eggs_collected": "${count} ovocytes recueillis",
        "mature_count": "${count} matures",
        "frozen_count": "${count} congelé·e·s",
        "fertilized_count": "${count} fécondé·e·s",
        "embryo_transferred_one": "${count} embryon transféré",
        "embryo_transferred_other": "${count} embryons transférés",
        "grade_label": "Grade ${grade}",
        "iui_completed": "IIU terminée",
        "specimen_linked": "Échantillon de sperme associé",
        "trigger_confirmed": "Déclenchement confirmé"
      },
      "phase_widget": {
        "e2_label": "E2 : ${value}",
        "follicles_count": "${count} follicules",
        "trigger_confirmed": "Déclenchement confirmé",
        "trigger_pending": "Déclenchement en attente",
        "recovery_day": "Récupération jour ${day} · Reposez-vous et hydratez-vous",
        "recovery_in_progress": "Récupération en cours"
      },
      "educational": {
        "what_to_expect": "À quoi s'attendre",
        "key_facts": "Points clés",
        "how_to_prepare": "Comment se préparer",
        "emotional_support": "Soutien émotionnel",
        "during_phase": "Pendant ${phase}",
        "when_to_call": "Quand appeler ta clinique",
        "typical_duration_label": "Durée typique : ${duration}",
        "emotional_support_default": "Chaque étape de ce parcours porte ses propres émotions. Sois douce avec toi-même et appuie-toi sur ton entourage. Ton équipe soignante est là pour toi à chaque étape."
      },
      "recorded_result": {
        "title_pregnancy": "Un résultat positif",
        "title_birth": "Un bébé est né",
        "title_no_pregnancy": "Ce cycle ne s'est pas terminé par une grossesse",
        "title_miscarriage": "Ce cycle s'est arrêté",
        "title_cancelled": "Ce cycle a été annulé",
        "title_other": "Votre résultat est enregistré",
        "body_pregnancy": "Félicitations. C'est enregistré sur ce cycle — votre clinique confirmera la suite.",
        "body_birth": "Félicitations. C'est enregistré sur ce cycle.",
        "body_no_pregnancy": "Nous sommes désolés. C'est enregistré sur ce cycle, et rien n'est à décider aujourd'hui.",
        "body_miscarriage": "Nous sommes vraiment désolés. C'est enregistré sur ce cycle. Votre équipe soignante est le bon interlocuteur pour la suite, et Louise peut garder vos questions jusqu'à ce que vous soyez prêt·e.",
        "body_cancelled": "C'est enregistré sur ce cycle. Un cycle annulé n'est pas un résultat, et rien n'est à décider aujourd'hui.",
        "body_other": "C'est enregistré sur ce cycle. Vous pourrez ajouter des détails dès que vous les aurez.",
        "recorded_on": "Enregistré le ${date}",
        "close_cycle": "Clôturer ce cycle",
        "update_result": "Modifier ce résultat bêta",
        "partner_title_pregnancy": "Un résultat positif",
        "partner_title_birth": "Un bébé est né",
        "partner_title_no_pregnancy": "Ce cycle ne s'est pas terminé par une grossesse",
        "partner_title_miscarriage": "Ce cycle s'est arrêté",
        "partner_title_cancelled": "Ce cycle a été annulé",
        "partner_title_other": "Le résultat est enregistré",
        "partner_body_pregnancy": "Félicitations à vous deux. C'est enregistré sur ce cycle — la clinique confirmera la suite.",
        "partner_body_birth": "Félicitations à vous deux. C'est enregistré sur ce cycle.",
        "partner_body_no_pregnancy": "Nous sommes désolés. C'est enregistré sur ce cycle, et il n'y a rien à réparer aujourd'hui.",
        "partner_body_miscarriage": "Nous sommes vraiment désolés. C'est enregistré sur ce cycle. Prenez le temps qu'il vous faut à tous les deux.",
        "partner_body_cancelled": "C'est enregistré sur ce cycle. Un cycle annulé n'est pas un résultat.",
        "partner_body_other": "C'est enregistré sur ce cycle.",
        "partner_hint": "La clôture du cycle lui revient, quand elle sera prête.",
        "close_hint": "La clôture déplace ce cycle dans votre historique. Vous pourrez toujours l'ouvrir."
      },
      "waiting_phase": {
        "section_label": "Attente de deux semaines",
        "made_it_through": "Deux semaines d'attente",
        "test_will_be_on": "votre test de grossesse aura lieu le",
        "test_day_self_chip": "C'est le jour du test — vous y êtes",
        "test_day_partner_chip": "C'est le jour du test — vous y êtes ensemble",
        "past_test_self_chip": "Il est temps d'enregistrer votre résultat",
        "past_test_partner_chip": "Il est temps d'enregistrer le résultat de votre partenaire",
        "days_to_go_one": "Plus qu'1 jour",
        "days_to_go_other": "Plus que ${count} jours",
        "test_day_self_announce": "Aujourd'hui, c'est le jour de votre test",
        "test_day_partner_announce": "Aujourd'hui, c'est le jour du test de votre partenaire",
        "test_was_ago_one": "Le test était il y a 1 jour — enregistrez quand vous voulez",
        "test_was_ago_other": "Le test était il y a ${count} jours — enregistrez quand vous voulez",
        "test_date_save_failed": "Nous n'avons pas pu enregistrer cette date de test. Votre phase d'attente est toujours active. Réessayez.",
        "retry_test_date": "Réessayer",
        "beta_order_title": "Suivi du test de grossesse",
        "beta_order_status": "Statut : ${status}",
        "beta_order_collection_window": "Fenêtre de prélèvement : ${date}",
        "beta_order_latest_result": "Dernier résultat associé : ${value} ${unit}",
        "beta_order_result_series": "Résultats enregistrés",
        "beta_order_result_entry": "Résultat ${sequence} : ${value} ${unit}",
        "beta_order_result_date": "Signalé le ${date}",
        "beta_order_result_collected_date": "Prélevé le ${date}",
        "beta_interpretation_title": "Interprétation",
        "beta_interpretation_state": "Interprétation : ${state}",
        "beta_interpretation_follow_up": "Suite prévue : ${action} · ${date}",
        "beta_interpretation_no_due_date": "date non indiquée",
        "beta_interpretation_urgent": "Un suivi urgent a été enregistré.",
        "beta_interpretation_state_negative": "Négatif",
        "beta_interpretation_state_indeterminate": "Indéterminé",
        "beta_interpretation_state_pregnancy_detected": "Grossesse détectée",
        "beta_interpretation_state_unknown_location": "La localisation de la grossesse n’est pas encore établie",
        "beta_interpretation_state_intrauterine": "Grossesse intra-utérine",
        "beta_interpretation_state_ectopic_concern": "Suspicion de grossesse extra-utérine",
        "beta_interpretation_state_ectopic_diagnosis": "Diagnostic de grossesse extra-utérine",
        "beta_interpretation_state_biochemical": "Grossesse biochimique",
        "beta_interpretation_state_early_loss": "Perte de grossesse précoce",
        "beta_interpretation_state_ongoing": "Grossesse en cours",
        "beta_interpretation_state_live_birth": "Naissance vivante",
        "beta_interpretation_state_unavailable": "Indisponible",
        "beta_interpretation_state_unknown": "Inconnu",
        "beta_interpretation_state_corrected": "Corrigé",
        "beta_interpretation_state_refuted": "Réfuté",
        "beta_follow_up_repeat": "Nouveau dosage de bêta-hCG",
        "beta_follow_up_ultrasound": "Échographie",
        "beta_follow_up_review": "Revue",
        "beta_follow_up_urgent": "Évaluation urgente",
        "beta_follow_up_none": "Aucune suite enregistrée",
        "beta_follow_up_unknown": "Suite non indiquée",
        "beta_order_no_order": "Aucun test bêta n'est encore associé à cette attente.",
        "beta_order_no_result": "Aucun résultat n'est encore associé.",
        "beta_order_status_not_reported": "Non indiqué",
        "beta_order_status_ordered": "Ordonné",
        "beta_order_status_scheduled": "Programmé",
        "beta_order_status_collected": "Prélèvement effectué",
        "beta_order_status_missed": "Manqué",
        "beta_order_status_cancelled": "Annulé",
        "beta_order_status_changed": "Modifié",
        "beta_order_status_completed": "Terminé",
        "beta_order_status_unknown": "Inconnu",
        "pregnancy_test_label": "Test de grossesse",
        "tap_to_pick_date": "Touchez pour choisir une date",
        "edit_label": "Modifier",
        "record_beta_self": "Enregistrer le résultat bêta",
        "record_beta_partner": "Enregistrer le résultat de la partenaire",
        "record_beta_waiting_for_order": "Aucun test bêta n'est encore associé",
        "record_beta_waiting_for_collection": "En attente du prélèvement",
        "chat_about_this": "En parler",
        "chat_seed_prompt": "Je suis en pleine attente de deux semaines et j'aurais besoin d'un peu de soutien.",
        "tap_enter_hcg_self": "Touchez pour saisir votre résultat hCG",
        "tap_enter_hcg_partner": "Touchez pour saisir son résultat hCG",
        "upload_test_photo": "Importer la photo du test",
        "upload_coming_soon_title": "Bientôt disponible",
        "upload_coming_soon_body": "L'import de la photo de votre résultat bêta hCG sera disponible dans une prochaine mise à jour.",
        "while_you_wait": "Pendant que vous attendez",
        "take_care": "Prenez soin de vous",
        "tip_hydrate": "Restez bien hydraté·e et reposé·e — le sommeil aide votre corps à faire son travail.",
        "tip_movement": "Un mouvement doux est bénéfique — marche, yoga prénatal. Évitez les charges lourdes.",
        "tip_caffeine": "Limitez la caféine à ~200 mg par jour et évitez l'alcool.",
        "tip_symptoms": "Guetter les symptômes peut être épuisant — le résultat et l'interprétation du centre guideront la suite.",
        "day_label": "Jour",
        "test_day_label": "Jour du test",
        "test_passed_label": "Test passé",
        "of_total": "sur ${total}",
        "pick_test_date": "Choisissez une date de test",
        "tw_self_past_test_title": "Il est temps d'enregistrer votre résultat",
        "tw_self_past_test_body": "Votre date de test est passée. Lorsque vous aurez votre résultat bêta hCG, touchez le bouton ci-dessous — nous vous guiderons pour la suite.",
        "tw_self_test_day_title": "C'est le jour du test",
        "tw_self_test_day_body": "Respirez profondément. Quel que soit le résultat, votre équipe médicale est là. Lorsque vous aurez votre chiffre bêta hCG, touchez le bouton ci-dessous.",
        "tw_self_setup_title": "Configuration de votre attente",
        "tw_self_setup_body": "Choisissez votre date de test ci-dessous pour que nous puissions vous accompagner pendant ces deux semaines.",
        "tw_self_implant_title": "Pendant l'attente",
        "tw_self_implant_body": "Le protocole, les dossiers et le suivi prescrits par votre équipe de soins sont les meilleurs repères pour cette période. Vous n'avez rien à diagnostiquer aujourd'hui.",
        "tw_self_hormones_title": "Dans l'attente du résultat",
        "tw_self_hormones_body": "Une valeur d'hCG ne suffit pas à établir la localisation ou la viabilité d'une grossesse. Votre équipe de soins interprétera le résultat et vous indiquera si un suivi est nécessaire.",
        "tw_self_days_until_one": "Plus qu'1 jour avant votre test",
        "tw_self_days_until_other": "Plus que ${count} jours avant votre test",
        "tw_self_days_until_body": "Vous y êtes presque. Soyez bienveillant·e envers vous-même — les symptômes racontent rarement toute l'histoire. Le résultat et l'interprétation de votre équipe guideront la suite.",
        "tw_partner_past_test_title": "Il est temps d'enregistrer le résultat",
        "tw_partner_past_test_body": "La date du test de ${name} est passée. Lorsque le résultat bêta hCG sera disponible, touchez le bouton ci-dessous — nous vous guiderons ensemble pour la suite.",
        "tw_partner_test_day_title": "C'est le jour du test",
        "tw_partner_test_day_body": "Respirez profondément. Quel que soit le résultat, vous êtes ensemble dans cette aventure. Lorsque le chiffre bêta hCG arrivera, touchez le bouton ci-dessous.",
        "tw_partner_setup_title": "Configuration de l'attente",
        "tw_partner_setup_body": "Choisissez la date du test ci-dessous pour que nous puissions vous accompagner tou·te·s les deux pendant ces deux semaines.",
        "tw_partner_implant_title": "Pendant l'attente",
        "tw_partner_implant_body": "Le protocole, les dossiers et le suivi prescrits par l'équipe de soins sont les meilleurs repères pour cette période. Vous n'avez rien à diagnostiquer aujourd'hui.",
        "tw_partner_hormones_title": "Dans l'attente du résultat",
        "tw_partner_hormones_body": "Une valeur d'hCG ne suffit pas à établir la localisation ou la viabilité d'une grossesse. L'équipe de soins interprétera le résultat et expliquera si un suivi est nécessaire.",
        "tw_partner_days_until_one": "Plus qu'1 jour avant le test",
        "tw_partner_days_until_other": "Plus que ${count} jours avant le test",
        "tw_partner_days_until_body": "Vous y êtes presque. Soyez bienveillants l'un envers l'autre — les symptômes racontent rarement toute l'histoire. Le résultat et l'interprétation de l'équipe guideront la suite.",
        "partner_learn_practical_title": "Façons concrètes d'aider",
        "partner_learn_practical_subtitle": "Des aspects logistiques que vous pouvez prendre en charge pour votre partenaire.",
        "partner_learn_practical_line_1": "Accompagnez votre partenaire au rendez-vous pour la bêta hCG.",
        "partner_learn_practical_line_2": "Aidez à récupérer les ordonnances et renouvellements si on vous le demande.",
        "partner_learn_practical_line_3": "Soutenez le traitement prescrit par l'équipe de soins.",
        "partner_learn_practical_line_4": "Suivez ensemble le calendrier des rendez-vous.",
        "partner_learn_practical_line_5": "Gérez les petites tâches logistiques pour que votre partenaire puisse se reposer.",
        "partner_learn_beta_title": "Ce que signifie le résultat associé",
        "partner_learn_beta_subtitle": "L'interprétation de l'équipe de soins et la suite.",
        "partner_learn_beta_intro": "La bêta hCG est une prise de sang qui mesure une hormone. Le délai et l'interprétation du résultat dépendent du laboratoire et de l'équipe de soins.",
        "partner_learn_beta_section_positive": "Grossesse détectée",
        "partner_learn_beta_positive_line_1": "Une valeur numérique doit être interprétée médicalement ; il n'existe pas de seuil unique pour toutes les situations.",
        "partner_learn_beta_positive_line_2": "L'équipe peut prescrire un autre résultat ou une imagerie selon le dossier et le protocole.",
        "partner_learn_beta_positive_line_3": "Le calendrier des examens de suivi vient de l'équipe de soins.",
        "partner_learn_beta_section_negative": "Négatif",
        "partner_learn_beta_negative_line_1": "Le centre peut indiquer qu'aucune grossesse n'a été détectée.",
        "partner_learn_beta_negative_line_2": "La clinique discutera des prochaines étapes quand elle sera prête.",
        "partner_learn_beta_section_borderline": "Résultat à revoir",
        "partner_learn_beta_borderline_line_1": "Un résultat non résolu le reste jusqu'à son interprétation par l'équipe ou la prescription d'un suivi.",
        "partner_learn_symptoms_title": "Ce qui est normal — et quand appeler",
        "partner_learn_symptoms_subtitle": "Les symptômes pendant l'attente, et les signaux d'alerte.",
        "partner_learn_symptoms_section_normal": "Symptômes possibles",
        "partner_learn_symptoms_normal_line_1": "De légères crampes ou pertes peuvent survenir ; appelez le centre en cas de doute.",
        "partner_learn_symptoms_normal_line_2": "De légers ballonnements peuvent avoir plusieurs causes.",
        "partner_learn_symptoms_normal_line_3": "La sensibilité des seins peut avoir plusieurs causes.",
        "partner_learn_symptoms_normal_line_4": "La fatigue ou les changements d'humeur peuvent avoir plusieurs causes.",
        "partner_learn_symptoms_section_call": "Appeler la clinique",
        "partner_learn_symptoms_call_line_1": "Saignements abondants (plus que de simples pertes).",
        "partner_learn_symptoms_call_line_2": "Douleur intense non soulagée par les médicaments prescrits.",
        "partner_learn_symptoms_call_line_3": "Fièvre supérieure à 38 °C / 100,4 °F.",
        "partner_learn_symptoms_call_line_4": "Prise de poids rapide ou gonflement abdominal important (signes d'OHSS).",
        "partner_learn_symptoms_call_line_5": "Difficultés à uriner ou diminution significative du volume urinaire."
      },
      "breadcrumb": {
        "prep": "Prép.",
        "stim": "Stim",
        "trigger": "Décl.",
        "retr": "Ponct.",
        "outcome": "Résultat",
        "luteal": "Lutéal",
        "fert": "Féc.",
        "emb": "Embry.",
        "transfer": "Transfert",
        "wait": "Attente",
        "sperm": "Sperme",
        "iui": "IIU",
        "screen": "Bilan",
        "analysis": "Analyse"
      },
      "status": {
        "done": "Terminé",
        "skipped": "Passé",
        "here": "Tu es ici",
        "planned": "Planifié",
        "coming_up": "À venir"
      },
      "partner_data": "Données partenaire",
      "partner_name_data": "Données de ${name}",
      "position_current": "Tu es à l'étape ${current} sur ${total}",
      "position_completed": "${completed} sur ${total} terminés",
      "step_of": "Étape ${current} sur ${total}",
      "continue_where_left": "Reprends là où tu en étais",
      "continue_to_a11y": "Continuer vers ${title}",
      "cta": {
        "save_planned": "Enregistrer",
        "next": "Suivant",
        "edit": "Modifier",
        "change": "Changer"
      },
      "view_steps": "Étapes",
      "view_calendar": "Calendrier",
      "view_a11y": "Afficher ${label}",
      "quick_add": {
        "menu_a11y": "Ajouter à ce cycle",
        "medication": "Ajouter un médicament",
        "appointment": "Ajouter un rendez-vous",
        "test": "Ajouter un résultat"
      },
      "skipped_message": "Cette étape a été passée.",
      "waiting_partner": "En attente des données du partenaire lié·e.",
      "your_clinic_recorded_this_transfer": "Votre clinique a enregistré ce transfert. Contactez votre équipe de soins pour le modifier.",
      "your_clinic_recorded_this_step": "Votre clinique a enregistré ces informations. Contactez votre équipe de soins pour les modifier.",
      "what_will_cover": "Ce que cette étape couvre",
      "medication_empty": {
        "pre_treatment_title": "Ajouter un médicament de pré-traitement",
        "stimulation_title": "Ajouter un médicament de stimulation",
        "support_title": "Ajouter un médicament de soutien",
        "default_title": "Ajouter un médicament",
        "pre_treatment_subtitle": "Aucun médicament de pré-traitement enregistré pour le moment.",
        "stimulation_subtitle": "Aucun médicament de stimulation enregistré pour le moment.",
        "support_subtitle": "Aucun médicament de soutien enregistré pour le moment.",
        "default_subtitle": "Aucun médicament enregistré pour le moment."
      },
      "schedule_procedure": {
        "egg_retrieval_title": "Planifier la ponction ovocytaire",
        "transfer_title": "Planifier le transfert d'embryon",
        "sperm_collection_title": "Planifier le recueil de sperme",
        "insemination_title": "Planifier l'IIU",
        "default_title": "Planifier un rendez-vous",
        "subtitle": "Ajoutez-le à votre calendrier et nous garderons cette étape à jour."
      },
      "iui_specimen_linkage": {
        "sample_of_date": "Échantillon du ${date}",
        "title": "Échantillon de sperme",
        "link_or_add": "Associer ou ajouter un échantillon",
        "sample_unavailable": "Échantillon indisponible",
        "choose_sample_title": "Choisir un échantillon de sperme",
        "add_new_sample": "Ajouter un nouvel échantillon de sperme",
        "link_failed": "Nous n'avons pas pu associer cet échantillon. Réessaie.",
        "origin": {
          "mine": "Mon échantillon",
          "partner": "Échantillon du/de la partenaire",
          "donor": "Échantillon d'un donneur"
        },
        "processing": {
          "fresh": "Frais",
          "washed": "Lavé",
          "frozen": "Congelé",
          "thawed": "Décongelé"
        },
        "status": {
          "collected": "Recueilli",
          "processed": "Préparé",
          "stored": "Conservé",
          "in_transit": "En transit"
        }
      },
      "retrieval_outcome": {
        "add_title": "Ajouter les résultats de la ponction",
        "add_subtitle": "Enregistrez les ovocytes recueillis et leur congélation dans Cryo Vault.",
        "add_more_results": "Ajouter d'autres résultats",
        "results_are_on_the_outcome_tab": "Ce que vous avez enregistré est sur l'onglet Résultat, où vous pouvez aussi le modifier."
      },
      "cycle_outcome": {
        "record_title": "Enregistrer ton résultat",
        "record_subtitle": "Ajoute ta valeur de bêta hCG dès que tu l'as."
      },
      "results_upload": {
        "analysis_title": "Ajouter les résultats du spermogramme",
        "analysis_subtitle": "Importez le rapport et nous récupérerons les valeurs."
      },
      "step_details": {
        "screening_title": "Importer les résultats de dépistage",
        "screening_upload_subtitle": "Importe tout document de dépistage ou ajoute des notes pour ta clinique.",
        "pgt_testing_title": "Ajouter les résultats du DPI",
        "fertilization_title": "Ajouter les détails de fécondation",
        "embryo_development_title": "Ajouter le développement embryonnaire",
        "freezing_title": "Ajouter les détails de congélation",
        "default_title": "Ajouter les détails",
        "subtitle": "Renseignez les détails de cette étape."
      },
      "endometrial_prep": {
        "title": "Préparation de l'endomètre",
        "description": "Prépare ton endomètre pour le transfert avec œstrogènes et progestérone.",
        "prompt": "Quels médicaments as-tu pris pendant la préparation ?",
        "skip_text": "Je n'ai pas pris de médicaments de préparation ce cycle"
      },
      "phase_extensions": {
        "getting_started": {
          "how_it_works": "Avant que la stimulation ne commence, ta clinique confirme que tu es prête à démarrer avec un bilan sanguin de référence (estradiol, FSH, LH) et une échographie endovaginale pour repérer les kystes et compter tes follicules antraux. Tu passes en revue ton protocole médicamenteux et tu peux commencer une pilule contraceptive ou un priming à l'œstrogène selon ton plan.",
          "what_to_expect": [
            "Bilan sanguin et échographie de référence au 2e ou 3e jour du cycle",
            "Revue complète de ton protocole médicamenteux avec ton infirmier·ère",
            "Coordination avec la pharmacie pour la livraison des médicaments",
            "Possibles médicaments de suppression (pilule, Lupron)",
            "Un mélange d'excitation et de nervosité — c'est totalement normal"
          ],
          "prep_instructions": [
            "Récupère toutes tes ordonnances et confirme les dates de livraison",
            "Assiste à ta séance de formation aux injections",
            "Prépare un espace propre et organisé pour ranger les médicaments",
            "Libère ton agenda pour les 2 à 3 semaines de suivi à venir",
            "Commence les vitamines prénatales si ce n'est pas déjà fait"
          ],
          "partner": {
            "description": "Compléments, hygiène de vie et habitudes pour soutenir la qualité du sperme avant le recueil",
            "what_happens": "La spermatogenèse dure environ 70 jours — la préparation d'aujourd'hui façonne l'échantillon qui sera prélevé plus tard. Beaucoup de cliniques recommandent des compléments et des ajustements d'hygiène de vie pendant cette phase.",
            "how_it_works": "Dans les semaines qui précèdent le recueil, beaucoup de cliniques recommandent des compléments antioxydants (CoQ10, zinc, sélénium, vitamine E) et des ajustements d'hygiène de vie pour soutenir la qualité du sperme. Un spermogramme de référence peut être demandé pour fixer un point de départ.",
            "what_to_expect": [
              "Recommandations possibles d'antioxydants ou de compléments vitaminiques",
              "Ajustements d'hygiène de vie : sommeil, hydratation, alcool, tabac",
              "Spermogramme de référence optionnel pour poser des attentes",
              "Le temps — le sperme répond aux changements sur plusieurs semaines, pas en quelques jours"
            ],
            "prep_instructions": [
              "Respecte les consignes d'abstinence de ta clinique à l'approche du recueil (généralement 2 à 5 jours)",
              "Évite jacuzzis, saunas et ordinateurs portables sur les genoux",
              "Réduis l'alcool et le tabac autant que possible",
              "Reste hydraté, mange équilibré et priorise le sommeil",
              "Bouge — une activité modérée aide"
            ]
          }
        },
        "stimulation": {
          "how_it_works": "Tu fais des injections quotidiennes (typiquement FSH et LH) pour stimuler tes ovaires à produire plusieurs ovocytes au lieu du seul qui mûrit habituellement chaque cycle. Ton médecin suit la croissance des follicules par échographie et bilan sanguin tous les 1 à 3 jours.",
          "what_to_expect": [
            "Ballonnements légers et sensation de plénitude à mesure que les follicules grossissent",
            "Sensibilité ou petits bleus aux points d'injection",
            "Rendez-vous de suivi fréquents (tous les 1 à 3 jours)",
            "Sautes d'humeur possibles liées aux fluctuations hormonales",
            "Sensibilité ovarienne qui augmente progressivement"
          ],
          "prep_instructions": [
            "Apprends la technique d'injection avec ton infirmier·ère avant de commencer",
            "Range les médicaments selon les consignes (certains au réfrigérateur)",
            "Fais tes injections à la même heure chaque jour",
            "Reste bien hydratée et privilégie les aliments riches en protéines",
            "Évite les efforts intenses à mesure que les follicules grossissent"
          ],
          "partner": {
            "description": "Ta partenaire fait des injections hormonales quotidiennes pour faire grandir plusieurs follicules. Elle a des rendez-vous de suivi tous les 2 à 3 jours avec bilan sanguin et échographie.",
            "what_happens": "Plusieurs follicules se développent chez ta partenaire, chacun pouvant contenir un ovocyte mature.",
            "how_it_works": "Ta partenaire fait des injections quotidiennes (typiquement FSH et LH) pour stimuler ses ovaires à produire plusieurs ovocytes au lieu du seul qui mûrit habituellement chaque cycle. Son médecin suit la croissance des follicules par échographie et bilan sanguin tous les 1 à 3 jours.",
            "what_to_expect": [
              "Elle peut se sentir ballonnée à mesure que les follicules grossissent",
              "Ses points d'injection peuvent être sensibles ou marqués",
              "Rendez-vous de suivi fréquents — souvent tôt le matin",
              "Les sautes d'humeur liées aux hormones sont normales",
              "Ses ovaires deviennent progressivement plus sensibles"
            ],
            "prep_instructions": [
              "Assiste à la formation aux injections pour pouvoir l'aider",
              "Range les médicaments selon les consignes (certains au réfrigérateur)",
              "Aide-la à tenir le rythme — même heure chaque jour",
              "Accompagne-la aux rendez-vous de suivi quand tu peux",
              "Sois patient face aux sautes d'humeur — les hormones sont intenses"
            ]
          }
        },
        "trigger": {
          "how_it_works": "Quand tes follicules atteignent la bonne taille (typiquement 18 à 20 mm), tu reçois une injection de déclenchement (hCG ou Lupron) pour initier la maturation finale des ovocytes. Le timing est critique — la ponction est programmée exactement 36 heures après cette injection.",
          "what_to_expect": [
            "Une seule injection, généralement le soir",
            "Ta clinique te donne l'heure précise pour l'administrer",
            "Les crampes ou ballonnements peuvent augmenter légèrement",
            "Tu peux te sentir émotionnellement à fleur de peau"
          ],
          "prep_instructions": [
            "Mets une alarme pour l'heure exacte de l'injection",
            "Prévois un plan de secours en cas de problème avec l'injection",
            "Confirme l'horaire de ta ponction avec la clinique",
            "Organise ton transport pour le jour de la ponction"
          ]
        },
        "retrieval": {
          "how_it_works": "Sous sédation légère, ton médecin utilise une aiguille guidée par échographie pour aspirer le liquide de chaque follicule et recueillir les ovocytes. L'acte dure environ 15 à 30 minutes. Tu restes 1 à 2 heures en salle de réveil.",
          "what_to_expect": [
            "Tu ne sentiras rien pendant l'intervention",
            "Crampes légères à modérées ensuite",
            "De petits saignements pendant 1 à 2 jours sont normaux",
            "Les ballonnements peuvent culminer dans les jours qui suivent la ponction",
            "Ta clinique t'appelle le jour même avec le nombre d'ovocytes"
          ],
          "prep_instructions": [
            "Rien à manger ni à boire après minuit",
            "Porte des vêtements confortables et amples",
            "Enlève tous les bijoux et le vernis à ongles",
            "Prévois quelqu'un pour te ramener",
            "Prévois de te reposer le reste de la journée"
          ],
          "partner": {
            "description": "Un acte court (15 à 20 minutes) sous sédation légère pendant lequel les ovocytes de ta partenaire sont recueillis par ponction guidée par échographie. Elle rentre le jour même. Prévois de la soutenir pendant 1 à 2 jours ensuite.",
            "what_happens": "Sous sédation légère, une aiguille guidée par échographie aspire le liquide des follicules de ta partenaire pour recueillir les ovocytes. Elle ne sent pas l'acte.",
            "how_it_works": "Sous sédation légère, le médecin utilise une aiguille guidée par échographie pour aspirer le liquide de chaque follicule de ta partenaire et recueillir les ovocytes. L'acte dure environ 15 à 30 minutes. Elle reste 1 à 2 heures en salle de réveil.",
            "what_to_expect": [
              "Elle ne sentira rien pendant l'intervention",
              "Crampes légères à modérées ensuite",
              "De petits saignements pendant 1 à 2 jours sont normaux pour elle",
              "Les ballonnements peuvent culminer dans les jours qui suivent",
              "La clinique appellera le jour même avec le nombre d'ovocytes"
            ],
            "prep_instructions": [
              "Sois disponible le jour de la ponction",
              "Emmène-la et ramène-la de la clinique — elle ne peut pas conduire après la sédation",
              "Aide-la à être à l'aise (vêtements amples, pas de bijoux)",
              "Signe sa sortie à la clinique une fois la récupération terminée",
              "Offre-lui une journée calme à la maison pour se reposer"
            ]
          }
        },
        "fertilization": {
          "how_it_works": "Tes ovocytes sont mis en contact avec le sperme (FIV classique ou ICSI) le jour de la ponction. L'équipe d'embryologie suit le développement pendant 5 à 6 jours et te donne des nouvelles sur le taux de fécondation et le grade des embryons. Les embryons qui atteignent le stade blastocyste peuvent être biopsiés pour un test génétique (DPI-A).",
          "what_to_expect": [
            "Jour 1 : rapport de fécondation (combien d'ovocytes ont fécondé)",
            "Jour 3 : point sur le développement précoce",
            "Jour 5–6 : rapport blastocyste et classement",
            "Tous les ovocytes ne fécondent pas et tous les embryons n'atteignent pas le blastocyste",
            "Cette période d'attente peut être émotionnellement difficile"
          ],
          "partner": {
            "description": "Les ovocytes de ta partenaire sont mis en contact avec le sperme au laboratoire. L'équipe d'embryologie suit le développement des embryons pendant 5 à 6 jours et vous rapporte les résultats.",
            "what_happens": "Les ovocytes de ta partenaire et l'échantillon de sperme se rencontrent au laboratoire. Pendant 5 à 6 jours, l'équipe d'embryologie suit la fécondation et le développement embryonnaire.",
            "how_it_works": "Les ovocytes de ta partenaire sont mis en contact avec le sperme (FIV classique ou ICSI) le jour de la ponction. L'équipe d'embryologie suit le développement pendant 5 à 6 jours et donne des nouvelles sur le taux de fécondation et le grade des embryons. Les embryons qui atteignent le stade blastocyste peuvent être biopsiés pour un test génétique (DPI-A).",
            "what_to_expect": [
              "Jour 1 : rapport de fécondation (combien d'ovocytes ont fécondé)",
              "Jour 3 : point sur le développement précoce",
              "Jour 5–6 : rapport blastocyste et classement",
              "Tous les ovocytes ne fécondent pas et tous les embryons n'atteignent pas le blastocyste",
              "La période d'attente peut être émotionnellement difficile pour vous deux"
            ]
          }
        },
        "transfer": {
          "how_it_works": "Un seul embryon est délicatement placé dans ton utérus à l'aide d'un fin cathéter guidé par échographie. L'acte est rapide et indolore — aucune anesthésie nécessaire. On te demande d'avoir la vessie confortablement pleine pour une meilleure visualisation à l'échographie.",
          "what_to_expect": [
            "Acte rapide et indolore (5 à 10 minutes)",
            "Tu peux voir l'embryon sur l'écran d'échographie",
            "De petits saignements ensuite sont normaux",
            "Reprends tes activités normales dès le lendemain",
            "Commence le soutien en progestérone comme indiqué"
          ],
          "prep_instructions": [
            "Bois de l'eau pour avoir la vessie pleine",
            "Prends les médicaments prescrits (valium, antibiotiques) si demandé",
            "Porte des vêtements confortables",
            "Prévois une journée calme et sans stress ensuite"
          ],
          "partner": {
            "description": "Un seul embryon est délicatement placé dans l'utérus de ta partenaire à l'aide d'un fin cathéter guidé par échographie. Rapide et indolore — aucune anesthésie nécessaire.",
            "what_happens": "L'embryon est placé dans l'utérus de ta partenaire. L'acte est bref et elle est éveillée du début à la fin.",
            "how_it_works": "Un seul embryon est délicatement placé dans l'utérus de ta partenaire à l'aide d'un fin cathéter guidé par échographie. L'acte est rapide et indolore — aucune anesthésie nécessaire. Elle aura la vessie confortablement pleine pour une meilleure visualisation à l'échographie.",
            "what_to_expect": [
              "Acte rapide et indolore (5 à 10 minutes)",
              "Elle peut voir l'embryon sur l'écran d'échographie",
              "De petits saignements ensuite sont normaux pour elle",
              "Elle reprend ses activités normales dès le lendemain",
              "Elle commence le soutien en progestérone comme indiqué"
            ],
            "prep_instructions": [
              "Accompagne-la si elle souhaite ton soutien",
              "Aide-la à prendre les médicaments prescrits avant",
              "Prévois une journée calme et sans stress pour elle ensuite",
              "Prends en charge les tâches pour qu'elle puisse se reposer"
            ]
          }
        },
        "waiting": {
          "how_it_works": "Après le transfert, tu continues le soutien en progestérone et tu attends ta prise de sang bêta hCG, typiquement 10 à 14 jours plus tard. Ce test mesure l'hormone de grossesse pour déterminer si l'embryon s'est implanté.",
          "what_to_expect": [
            "Continue tous les médicaments prescrits",
            "De légères crampes et petits saignements peuvent être normaux (et ne signifient pas un échec)",
            "Les hauts et les bas émotionnels sont très fréquents",
            "Évite les tests de grossesse à domicile — ils peuvent donner de faux résultats",
            "Ta clinique fixera la date de ta prise de sang"
          ],
          "prep_instructions": [
            "Continue la progestérone exactement comme prescrit",
            "Garde tes activités normales mais évite les extrêmes",
            "Pense à des activités anti-stress (marches, méditation)",
            "Appuie-toi sur ton entourage pendant cette période"
          ],
          "partner": {
            "description": "Ta partenaire continue le soutien en progestérone et vous attendez ensemble sa prise de sang bêta hCG, typiquement 10 à 14 jours plus tard.",
            "what_happens": "Ta partenaire vit l'attente des deux semaines. Son corps travaille — l'embryon s'implante ou non, et la bêta vous le dira à tous les deux.",
            "how_it_works": "Après le transfert, ta partenaire continue le soutien en progestérone et vous attendez ensemble sa prise de sang bêta hCG, typiquement 10 à 14 jours plus tard. Ce test mesure l'hormone de grossesse pour déterminer si l'embryon s'est implanté.",
            "what_to_expect": [
              "Elle continue tous les médicaments prescrits",
              "De légères crampes et petits saignements peuvent être normaux pour elle",
              "Des hauts et des bas émotionnels pour vous deux",
              "Évitez les tests de grossesse à domicile — la bêta hCG est plus fiable",
              "La clinique fixera la date de la prise de sang"
            ],
            "prep_instructions": [
              "Assure-toi qu'elle prenne sa progestérone à l'heure",
              "Sois patient face aux changements d'humeur — les hormones sont intenses",
              "Prévoyez des activités calmes ensemble",
              "Allez ensemble au rendez-vous bêta"
            ]
          }
        }
      },
      "frozen_egg_ivf_overrides": {
        "stimulation": {
          "how_it_works": "Ton endomètre est préparé pour le transfert. L'œstrogène épaissit la muqueuse ; la progestérone est ajoutée à l'approche du transfert. Pas de stimulation ovarienne nécessaire — tes ovocytes sont déjà recueillis et congelés.",
          "what_to_expect": [
            "Œstrogène quotidien (oral, patch ou injection) pendant 2 à 4 semaines",
            "Échographies de contrôle pour vérifier que l'endomètre atteint ≥7 à 8 mm",
            "Progestérone ajoutée (voie vaginale, injection ou les deux) environ 5 jours avant le transfert",
            "Tes ovocytes congelés restent en sécurité jusqu'au jour du dégel",
            "Beaucoup moins de rendez-vous de suivi qu'un cycle de stimulation fraîche"
          ],
          "prep_instructions": [
            "Confirme la livraison de tes œstrogènes et de ta progestérone avec ta pharmacie",
            "Programme tes échographies de contrôle de l'endomètre avec la clinique",
            "Coordonne la date du dégel une fois ta muqueuse prête",
            "Prévois une approche calme et sans stress avant le transfert"
          ]
        },
        "fertilization": {
          "how_it_works": "Le jour du dégel, tes ovocytes congelés sont réchauffés au laboratoire et fécondés — typiquement par ICSI, la couche externe de l'ovocyte s'étant durcie après la congélation. L'équipe d'embryologie suit le développement pendant 5 à 6 jours.",
          "what_to_expect": [
            "Les ovocytes sont dégelés le matin ; le taux de survie est typiquement de 80 à 90 %",
            "L'ICSI est la méthode de fécondation par défaut pour les ovocytes dégelés",
            "Jour 1 : rapport de fécondation (combien d'ovocytes ont fécondé)",
            "Jour 3 : point sur le développement précoce",
            "Jour 5–6 : rapport blastocyste et classement",
            "Tous les ovocytes ne survivent pas au dégel ni ne fécondent — c'est attendu"
          ]
        }
      }
    },
    "treatment_milestones": {
      "egg_retrieval": "Ponction d'ovocytes",
      "transfer": "Transfert d'embryon",
      "trigger_shot": "Déclenchement",
      "stimulation_start": "Début de la stimulation"
    },
    "treatment_flows": {
      "scheduled_for_date": "Planifié pour le ${date}",
      "dated_on": "Dat\u00e9 du ${date}",
      "options": {
        "none": "Aucune préparation supplémentaire",
        "washed": "Lavé",
        "swim_up": "Sélection swim-up",
        "density_gradient": "Sélection par gradient de densité",
        "dgc_swim_up": "Gradient de densité + swim-up",
        "microfluidics": "Sélection microfluidique",
        "macs": "Sélection MACS",
        "partner": "Partenaire",
        "donor": "Donneur",
        "fresh": "Frais",
        "frozen": "Congelé",
        "ivf": "FIV",
        "icsi": "ICSI",
        "yes": "Oui",
        "no": "Non",
        "other": "Autre",
        "select_placeholder": "Sélectionner…",
        "other_enter_below": "Autre (à préciser)"
      },
      "actions": {
        "confirm_save": "Confirmer",
        "schedule": "Planifier",
        "undo": "Annuler",
        "cancel": "Annuler",
        "delete_medication": "Supprimer le médicament",
        "add_medication": "Ajouter un médicament",
        "add_another_medication": "Ajouter un autre médicament",
        "add_trigger": "Ajouter le déclenchement",
        "trigger_added": "Déclenchement ajouté",
        "add_trigger_a11y": "Ajouter le médicament de déclenchement",
        "default_skip": "Je n'ai pas fait cette étape"
      },
      "status": {
        "completed": "Terminé",
        "skipped": "Passé",
        "in_progress": "En cours"
      },
      "state": {
        "step_complete": "Cette étape est terminée",
        "step_skipped": "Cette étape a été passée",
        "required_field": "Requis : ${field}"
      },
      "medications": {
        "unnamed": "Médicament sans nom",
        "medication": "Médicament",
        "trigger_badge": "Déclenchement",
        "none_logged": "Aucun médicament enregistré pour le moment",
        "none_found": "Aucun médicament trouvé",
        "more_count": "+${count} médicaments supplémentaires"
      },
      "collection_methods": {
        "ejaculation": "Éjaculation",
        "tese": "TESE",
        "tesa": "TESA",
        "pesa": "PESA",
        "mesa": "MESA",
        "mtese": "Micro-TESE",
        "electroejaculation": "Électro-éjaculation",
        "post_ejaculatory_urine": "Urines post-éjaculatoires"
      },
      "ivf": {
        "pre_treatment": {
          "title": "Pré-traitement",
          "description": "Pilule contraceptive ou traitement de priming avant la stimulation",
          "prompt": "As-tu pris une pilule ou un traitement de priming avant la stimulation ?",
          "skip_text": "Je n'ai pas eu de pré-traitement ce cycle",
          "partner": {
            "description": "Compléments ou médicaments pour soutenir la qualité du sperme avant le recueil",
            "prompt": "Prends-tu des compléments ou des médicaments avant le recueil ?"
          }
        },
        "protocol": {
          "title": "Stimulation ovarienne",
          "description": "Phase de médicaments pour stimuler le développement des ovocytes, injection de déclenchement incluse",
          "prompt": "Quels médicaments as-tu pris pendant la stimulation ?",
          "skip_text": "Je n'ai pas eu de stimulation ovarienne ce cycle",
          "partner": {
            "description": "Phase de médicaments que prend ta partenaire pour stimuler le développement des ovocytes, injection de déclenchement incluse",
            "prompt": "Quels médicaments prend ta partenaire pendant la stimulation ?",
            "skip_text": "Ma partenaire n'a pas eu de stimulation ovarienne ce cycle"
          }
        },
        "egg_retrieval": {
          "title": "Ponction d'ovocytes",
          "description": "Acte de prélèvement des ovocytes",
          "prompt": "Comment s'est passée ta ponction ?",
          "scheduling_prompt": "Quand ta ponction est-elle prévue ?",
          "fields": {
            "procedureDate": { "label": "Date et heure de l'intervention" },
            "eggsCollected": {
              "label": "Ovocytes recueillis",
              "placeholder": "0"
            },
            "notes": {
              "label": "Notes",
              "placeholder": "Notes sur la qualité…"
            }
          },
          "partner": {
            "description": "Acte de prélèvement des ovocytes de ta partenaire",
            "prompt": "Comment s'est passée la ponction de ta partenaire ?",
            "fields": {
              "eggsCollected": {
                "label": "Ovocytes recueillis chez elle",
                "placeholder": "0"
              }
            }
          }
        },
        "fertilization": {
          "title": "Fécondation",
          "description": "Comment tes ovocytes ont été fécondés",
          "prompt": "Quels sont tes résultats de fécondation ?",
          "skip_text": "Je n'ai pas encore les détails de fécondation",
          "fields": {
            "spermSource": { "label": "Origine du sperme" },
            "spermType": { "label": "Frais ou congelé" },
            "fertilizationMethod": { "label": "Méthode de fécondation" },
            "eggsFertilized": {
              "label": "Ovocytes fécondés (2PN)",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "skip_text": "Nous n'avons pas encore les détails de fécondation"
          }
        },
        "embryo_development": {
          "title": "Développement embryonnaire",
          "description": "Croissance des embryons, classement et décisions de congélation",
          "prompt": "Comment se développent tes embryons ?",
          "skip_text": "Je n'ai pas encore les détails des embryons",
          "fields": {
            "embryoGrade": { "label": "Meilleur grade d'embryon" },
            "embryosFrozen": {
              "label": "Embryons congelés",
              "placeholder": "0"
            }
          },
          "partner": {
            "skip_text": "Nous n'avons pas encore les détails des embryons"
          }
        },
        "transfer": {
          "title": "Transfert d'embryon",
          "description": "Transfert d'embryon dans l'utérus",
          "prompt": "Raconte-nous ton transfert d'embryon",
          "scheduling_prompt": "Quand ton transfert est-il prévu ?",
          "skip_text": "Je congèle tous les embryons ce cycle",
          "fields": {
            "transferDate": { "label": "Date du transfert" },
            "embryosTransferred": {
              "label": "Embryons transférés",
              "placeholder": "0"
            },
            "embryoType": { "label": "Type d'embryon" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Transfert d'embryon dans l'utérus de ta partenaire",
            "prompt": "Raconte-nous le transfert d'embryon de ta partenaire",
            "skip_text": "Nous congelons tous les embryons ce cycle"
          }
        },
        "luteal_phase": {
          "title": "Soutien lutéal",
          "description": "Médicaments de soutien après le transfert",
          "prompt": "Quels médicaments de soutien prends-tu ?",
          "partner": {
            "title": "Soutien lutéal de ta partenaire",
            "description": "Médicaments de soutien que prend ta partenaire après le transfert",
            "prompt": "Quels médicaments de soutien prend ta partenaire ?"
          }
        },
        "outcome": {
          "title": "Résultat",
          "description": "Ton résultat pour ce cycle",
          "prompt": "Quel a été le résultat de ce cycle ?",
          "partner": {
            "description": "Le résultat du cycle de ta partenaire",
            "prompt": "Quel a été le résultat de ce cycle ?"
          }
        },
        "sperm_collection": {
          "title": "Recueil de sperme",
          "description": "Prélèvement et préparation de l'échantillon de sperme",
          "prompt": "Raconte-nous le recueil de sperme",
          "scheduling_prompt": "Quand le recueil de sperme est-il prévu ?",
          "skip_text": "Je n'ai pas les détails du recueil de sperme",
          "fields": {
            "spermSource": { "label": "Origine du sperme" },
            "spermType": { "label": "Frais ou congelé" },
            "collectionMethod": { "label": "Type de recueil" },
            "preparationMethod": { "label": "Préparation" },
            "abstinencePeriod": {
              "label": "Jours d'abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Date du recueil" },
            "notes": { "label": "Notes" }
          }
        }
      },
      "icsi": {
        "pre_treatment": {
          "title": "Pré-traitement",
          "description": "Pilule contraceptive ou traitement de priming avant la stimulation",
          "prompt": "As-tu pris une pilule ou un traitement de priming ?",
          "skip_text": "Je n'ai pas eu de pré-traitement ce cycle",
          "partner": {
            "description": "Compléments ou médicaments pour soutenir la qualité du sperme avant le recueil",
            "prompt": "Prends-tu des compléments ou des médicaments avant le recueil ?"
          }
        },
        "protocol": {
          "title": "Stimulation ovarienne",
          "description": "Phase de médicaments pour stimuler le développement des ovocytes, injection de déclenchement incluse",
          "prompt": "Quels médicaments as-tu pris pendant la stimulation ?",
          "skip_text": "Je n'ai pas eu de stimulation ovarienne ce cycle",
          "partner": {
            "description": "Phase de médicaments que prend ta partenaire pour stimuler le développement des ovocytes, injection de déclenchement incluse",
            "prompt": "Quels médicaments prend ta partenaire pendant la stimulation ?",
            "skip_text": "Ma partenaire n'a pas eu de stimulation ovarienne ce cycle"
          }
        },
        "egg_retrieval": {
          "title": "Ponction d'ovocytes",
          "description": "Acte de prélèvement des ovocytes",
          "prompt": "Comment s'est passée ta ponction ?",
          "scheduling_prompt": "Quand ta ponction est-elle prévue ?",
          "fields": {
            "procedureDate": { "label": "Date et heure de l'intervention" },
            "eggsCollected": {
              "label": "Ovocytes recueillis",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Acte de prélèvement des ovocytes de ta partenaire",
            "prompt": "Comment s'est passée la ponction de ta partenaire ?",
            "fields": {
              "eggsCollected": {
                "label": "Ovocytes recueillis chez elle",
                "placeholder": "0"
              }
            }
          }
        },
        "sperm_collection": {
          "title": "Recueil de sperme",
          "description": "Prélèvement et préparation de l'échantillon de sperme",
          "prompt": "Raconte-nous le recueil de sperme",
          "scheduling_prompt": "Quand le recueil de sperme est-il prévu ?",
          "skip_text": "Je n'ai pas les détails du recueil de sperme",
          "fields": {
            "spermSource": { "label": "Origine du sperme" },
            "spermType": { "label": "Frais ou congelé" },
            "collectionMethod": { "label": "Type de recueil" },
            "preparationMethod": { "label": "Préparation" },
            "abstinencePeriod": {
              "label": "Jours d'abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Date du recueil" },
            "notes": { "label": "Notes" }
          }
        },
        "fertilization": {
          "title": "Fécondation (ICSI)",
          "description": "Résultats de la micro-injection intracytoplasmique",
          "prompt": "Quels sont tes résultats de fécondation par ICSI ?",
          "skip_text": "Je n'ai pas encore les détails de fécondation",
          "fields": {
            "spermSource": { "label": "Origine du sperme" },
            "spermType": { "label": "Frais ou congelé" },
            "eggsInjected": {
              "label": "Ovocytes injectés (ICSI)",
              "placeholder": "0"
            },
            "eggsFertilized": {
              "label": "Ovocytes fécondés (2PN)",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "skip_text": "Nous n'avons pas encore les détails de fécondation"
          }
        },
        "embryo_development": {
          "title": "Développement embryonnaire",
          "description": "Croissance des embryons, classement et décisions de congélation",
          "prompt": "Comment se développent tes embryons ?",
          "skip_text": "Je n'ai pas encore les détails des embryons",
          "fields": {
            "embryoGrade": { "label": "Meilleur grade d'embryon" },
            "embryosFrozen": {
              "label": "Embryons congelés",
              "placeholder": "0"
            }
          },
          "partner": {
            "skip_text": "Nous n'avons pas encore les détails des embryons"
          }
        },
        "transfer": {
          "title": "Transfert d'embryon",
          "description": "Transfert d'embryon dans l'utérus",
          "prompt": "Raconte-nous ton transfert d'embryon",
          "scheduling_prompt": "Quand ton transfert est-il prévu ?",
          "skip_text": "Je congèle tous les embryons ce cycle",
          "fields": {
            "transferDate": { "label": "Date du transfert" },
            "embryosTransferred": {
              "label": "Embryons transférés",
              "placeholder": "0"
            },
            "embryoType": { "label": "Type d'embryon" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Transfert d'embryon dans l'utérus de ta partenaire",
            "prompt": "Raconte-nous le transfert d'embryon de ta partenaire",
            "skip_text": "Nous congelons tous les embryons ce cycle"
          }
        },
        "luteal_phase": {
          "title": "Soutien lutéal",
          "description": "Médicaments de soutien après le transfert",
          "prompt": "Quels médicaments de soutien prends-tu ?",
          "partner": {
            "title": "Soutien lutéal de ta partenaire",
            "description": "Médicaments de soutien que prend ta partenaire après le transfert",
            "prompt": "Quels médicaments de soutien prend ta partenaire ?"
          }
        },
        "outcome": {
          "title": "Résultat",
          "description": "Ton résultat pour ce cycle",
          "prompt": "Quel a été le résultat de ce cycle ?",
          "partner": {
            "description": "Le résultat du cycle de ta partenaire",
            "prompt": "Quel a été le résultat de ce cycle ?"
          }
        }
      },
      "iui": {
        "pre_treatment": {
          "title": "Pré-traitement",
          "description": "Préparation avant le cycle d'IIU",
          "prompt": "As-tu pris des médicaments avant ton cycle d'IIU ?",
          "skip_text": "Je n'ai pas eu de pré-traitement ce cycle",
          "partner": {
            "description": "Compléments ou médicaments pour soutenir la qualité du sperme avant le recueil",
            "prompt": "Prends-tu des compléments ou des médicaments avant le recueil ?"
          }
        },
        "protocol": {
          "title": "Stimulation ovarienne",
          "description": "Traitement pour soutenir le développement des ovocytes, injection de déclenchement incluse",
          "prompt": "Quels médicaments as-tu pris pendant la stimulation ?",
          "partner": {
            "description": "Traitement que prend ta partenaire pour soutenir le développement des ovocytes, injection de déclenchement incluse",
            "prompt": "Quels médicaments prend ta partenaire pendant la stimulation ?"
          }
        },
        "sperm_collection": {
          "title": "Recueil de sperme",
          "description": "Prélèvement et préparation de l'échantillon de sperme",
          "prompt": "Raconte-nous le recueil de sperme",
          "scheduling_prompt": "Quand le recueil de sperme est-il prévu ?",
          "skip_text": "Je n'ai pas les détails du recueil de sperme",
          "fields": {
            "spermSource": { "label": "Origine du sperme" },
            "spermType": { "label": "Frais ou congelé" },
            "collectionMethod": { "label": "Type de recueil" },
            "preparationMethod": { "label": "Préparation" },
            "abstinencePeriod": {
              "label": "Jours d'abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Date du recueil" },
            "notes": { "label": "Notes" }
          }
        },
        "insemination": {
          "title": "Insémination (IIU)",
          "description": "Le sperme est déposé directement dans l'utérus",
          "prompt": "Comment s'est passée ton IIU ?",
          "scheduling_prompt": "Quand ton IIU est-elle prévue ?",
          "fields": {
            "procedureDate": { "label": "Date et heure de l'intervention" },
            "inseminationType": { "label": "Type d'IIU" },
            "catheterType": { "label": "Type de cathéter" },
            "catheterBrand": { "label": "Marque du cathéter" },
            "ultrasoundGuided": { "label": "Guidée par échographie" },
            "inseminationDuration": {
              "label": "Durée de l'intervention (minutes)",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Le sperme est déposé directement dans l'utérus de ta partenaire",
            "prompt": "Comment s'est passée l'IIU de ta partenaire ?"
          }
        },
        "luteal_phase": {
          "title": "Soutien lutéal",
          "description": "Soutien après l'insémination",
          "prompt": "Prends-tu des médicaments de soutien ?",
          "skip_text": "Je ne prends pas de soutien lutéal",
          "partner": {
            "title": "Soutien lutéal de ta partenaire",
            "description": "Soutien que prend ta partenaire après l'insémination",
            "prompt": "Ta partenaire prend-elle des médicaments de soutien ?",
            "skip_text": "Ma partenaire ne prend pas de soutien lutéal"
          }
        },
        "outcome": {
          "title": "Résultat",
          "description": "Ton résultat pour ce cycle",
          "prompt": "Quel a été le résultat de ce cycle ?",
          "partner": {
            "description": "Le résultat du cycle de ta partenaire",
            "prompt": "Quel a été le résultat de ce cycle ?"
          }
        }
      },
      "fet": {
        "pre_treatment": {
          "title": "Pré-traitement",
          "description": "Préparation avant le cycle de transfert",
          "prompt": "As-tu pris des médicaments avant ton cycle de TEC ?",
          "skip_text": "Je n'ai pas eu de pré-traitement ce cycle",
          "partner": {
            "description": "Compléments ou médicaments pour soutenir la qualité du sperme avant le recueil",
            "prompt": "Prends-tu des compléments ou des médicaments avant le recueil ?"
          }
        },
        "protocol": {
          "title": "Préparation de l'endomètre",
          "description": "Épaississement de la muqueuse utérine pour le transfert",
          "prompt": "Quels médicaments prends-tu pour préparer ta muqueuse ?",
          "partner": {
            "description": "Médicaments que prend ta partenaire pour épaissir sa muqueuse utérine en vue du transfert",
            "prompt": "Quels médicaments prend ta partenaire pour préparer sa muqueuse ?"
          }
        },
        "transfer": {
          "title": "Transfert d'embryon",
          "description": "Transfert d'embryon congelé dans l'utérus",
          "prompt": "Raconte-nous ton transfert d'embryon",
          "scheduling_prompt": "Quand ton transfert est-il prévu ?",
          "fields": {
            "transferDate": { "label": "Date du transfert" },
            "embryosTransferred": {
              "label": "Embryons transférés",
              "placeholder": "0"
            },
            "embryoType": { "label": "Type d'embryon" },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Transfert d'embryon congelé dans l'utérus de ta partenaire",
            "prompt": "Raconte-nous le transfert d'embryon de ta partenaire"
          }
        },
        "luteal_phase": {
          "title": "Soutien lutéal",
          "description": "Médicaments de soutien après le transfert",
          "prompt": "Quels médicaments de soutien prends-tu ?",
          "partner": {
            "title": "Soutien lutéal de ta partenaire",
            "description": "Médicaments de soutien que prend ta partenaire après le transfert",
            "prompt": "Quels médicaments de soutien prend ta partenaire ?"
          }
        },
        "outcome": {
          "title": "Résultat",
          "description": "Ton résultat pour ce cycle",
          "prompt": "Quel a été le résultat de ce cycle ?",
          "partner": {
            "description": "Le résultat du cycle de ta partenaire",
            "prompt": "Quel a été le résultat de ce cycle ?"
          }
        }
      },
      "oi": {
        "pre_treatment": {
          "title": "Pré-traitement",
          "description": "Bilans de référence et préparation",
          "prompt": "As-tu pris des médicaments de pré-traitement ?",
          "skip_text": "Je n'ai pas eu de pré-traitement ce cycle"
        },
        "protocol": {
          "title": "Induction de l'ovulation",
          "description": "Traitement pour stimuler l'ovulation, avec déclenchement et fenêtre de fertilité",
          "prompt": "Quels médicaments prends-tu pour l'induction de l'ovulation ?",
          "fields": {
            "timingWindow": {
              "label": "Fenêtre de rapports programmés",
              "placeholder": "p. ex. 12–14 fév."
            },
            "notes": { "label": "Notes" }
          }
        },
        "luteal_phase": {
          "title": "Soutien lutéal",
          "description": "Soutien après l'ovulation et période d'attente",
          "prompt": "Prends-tu des médicaments de soutien ?",
          "skip_text": "Je ne prends pas de soutien lutéal"
        },
        "outcome": {
          "title": "Résultat",
          "description": "Ton résultat pour ce cycle",
          "prompt": "Quel a été le résultat de ce cycle ?"
        }
      },
      "egg_freezing": {
        "pre_treatment": {
          "title": "Pré-traitement",
          "short_title": "Pré-traitement",
          "description": "Pilule contraceptive ou traitement de priming",
          "prompt": "As-tu pris une pilule ou un traitement de priming ?",
          "skip_text": "Je n'ai pas eu de pré-traitement ce cycle"
        },
        "stimulation": {
          "title": "Stimulation et suivi",
          "short_title": "Stimulation",
          "description": "Phase de médicaments pour stimuler le développement des ovocytes",
          "prompt": "Quels médicaments as-tu pris pendant la stimulation ?",
          "skip_text": "Je n'ai pas eu de stimulation ovarienne ce cycle"
        },
        "trigger_shot": {
          "title": "Déclenchement",
          "short_title": "Déclenchement",
          "description": "Injection finale pour déclencher la maturation avant la ponction",
          "prompt": "Enregistre ton déclenchement comme les autres médicaments."
        },
        "egg_retrieval": {
          "title": "Ponction d'ovocytes",
          "short_title": "Ponction",
          "description": "Acte de prélèvement des ovocytes",
          "prompt": "Comment s'est passée ta ponction ?",
          "scheduling_prompt": "Quand ta ponction est-elle prévue ?",
          "fields": {
            "procedureDate": { "label": "Date et heure de l'intervention" },
            "eggsCollected": {
              "label": "Ovocytes recueillis",
              "placeholder": "0"
            },
            "notes": {
              "label": "Notes",
              "placeholder": "Comment ça s'est passé ?"
            }
          }
        },
        "freezing": {
          "title": "Résultat",
          "short_title": "Résultat",
          "description": "Ovocytes matures, congelés et notes du laboratoire",
          "prompt": "Quels sont tes résultats de congélation ?",
          "fields": {
            "matureEggs": {
              "label": "Ovocytes matures (MII)",
              "placeholder": "0"
            },
            "eggsFrozen": { "label": "Ovocytes congelés", "placeholder": "0" },
            "notes": {
              "label": "Notes",
              "placeholder": "Notes sur la qualité…"
            }
          }
        }
      },
      "embryo_freezing": {
        "pre_treatment": {
          "title": "Pré-traitement",
          "description": "Pilule contraceptive ou traitement de priming",
          "prompt": "As-tu pris une pilule ou un traitement de priming ?",
          "skip_text": "Je n'ai pas eu de pré-traitement ce cycle",
          "partner": {
            "description": "Compléments ou médicaments pour soutenir la qualité du sperme avant le recueil",
            "prompt": "Prends-tu des compléments ou des médicaments avant le recueil ?"
          }
        },
        "protocol": {
          "title": "Stimulation ovarienne",
          "description": "Traitement pour stimuler le développement des ovocytes, injection de déclenchement incluse",
          "prompt": "Quels médicaments as-tu pris pendant la stimulation ?",
          "skip_text": "Je n'ai pas eu de stimulation ovarienne ce cycle",
          "partner": {
            "description": "Traitement que prend ta partenaire pour stimuler le développement des ovocytes, injection de déclenchement incluse",
            "prompt": "Quels médicaments prend ta partenaire pendant la stimulation ?",
            "skip_text": "Ma partenaire n'a pas eu de stimulation ovarienne ce cycle"
          }
        },
        "egg_retrieval": {
          "title": "Ponction d'ovocytes",
          "description": "Acte de prélèvement des ovocytes",
          "prompt": "Comment s'est passée ta ponction ?",
          "scheduling_prompt": "Quand ta ponction est-elle prévue ?",
          "fields": {
            "procedureDate": { "label": "Date et heure de l'intervention" },
            "eggsCollected": {
              "label": "Ovocytes recueillis",
              "placeholder": "0"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "description": "Acte de prélèvement des ovocytes de ta partenaire",
            "prompt": "Comment s'est passée la ponction de ta partenaire ?",
            "fields": {
              "eggsCollected": {
                "label": "Ovocytes recueillis chez elle",
                "placeholder": "0"
              }
            }
          }
        },
        "sperm_collection": {
          "title": "Recueil de sperme",
          "description": "Prélèvement et préparation de l'échantillon de sperme",
          "prompt": "Raconte-nous le recueil de sperme",
          "scheduling_prompt": "Quand le recueil de sperme est-il prévu ?",
          "skip_text": "Je n'ai pas les détails du recueil de sperme",
          "fields": {
            "spermSource": { "label": "Origine du sperme" },
            "spermType": { "label": "Frais ou congelé" },
            "collectionMethod": { "label": "Type de recueil" },
            "abstinencePeriod": {
              "label": "Jours d'abstinence",
              "placeholder": "0"
            },
            "collectionDate": { "label": "Date du recueil" },
            "notes": { "label": "Notes" }
          }
        },
        "fertilization": {
          "title": "Fécondation et congélation",
          "description": "Résultats de fécondation, classement des embryons et conservation",
          "prompt": "Que s'est-il passé au laboratoire et combien d'embryons ont été congelés ?",
          "skip_text": "Je n'ai pas encore les détails des embryons",
          "fields": {
            "spermSource": { "label": "Origine du sperme" },
            "fertilizationMethod": { "label": "Méthode" },
            "eggsFertilized": {
              "label": "Ovocytes fécondés (2PN)",
              "placeholder": "0"
            },
            "embryosFrozen": {
              "label": "Embryons congelés",
              "placeholder": "0"
            },
            "embryoGrade": {
              "label": "Grade de l'embryon",
              "placeholder": "p. ex. 4AA, 3AB"
            },
            "procedureDate": { "label": "Date et heure de congélation" },
            "storageLocation": {
              "label": "Lieu de conservation",
              "placeholder": "Clinique / Banque / Autre"
            },
            "notes": { "label": "Notes" }
          },
          "partner": {
            "skip_text": "Nous n'avons pas encore les détails de la fécondation"
          }
        },
        "embryo_development": {
          "title": "Développement embryonnaire",
          "short_title": "Développement",
          "description": "Croissance, classement et décisions de congélation des embryons",
          "prompt": "Comment tes embryons se développent-ils ?",
          "skip_text": "Je n'ai pas encore les détails du développement embryonnaire",
          "fields": {
            "embryoGrade": { "label": "Meilleur grade embryonnaire" },
            "embryosDay3": {
              "label": "Embryons au jour 3",
              "placeholder": "0"
            },
            "embryosDay5": {
              "label": "Embryons au jour 5",
              "placeholder": "0"
            },
            "embryosFrozen": {
              "label": "Embryons congelés",
              "placeholder": "0"
            },
            "procedureDate": { "label": "Date et heure de congélation" },
            "storageLocation": {
              "label": "Lieu de conservation",
              "placeholder": "Clinique / Banque / Autre"
            },
            "notes": { "label": "Notes" }
          }
        }
      },
      "sperm_freezing": {
        "pre_treatment": {
          "title": "Préparation avant le recueil",
          "short_title": "Pré-traitement",
          "description": "Médicaments ou compléments avant ton recueil",
          "prompt": "Prends-tu des médicaments ou des compléments avant ton recueil ?",
          "skip_text": "Je ne prends rien"
        },
        "screening": {
          "title": "Dépistage",
          "short_title": "Dépistage",
          "description": "Résultats de dépistage avant congélation ; ajoute les documents infectieux, génétiques ou de porteurs",
          "prompt": "Importe tous tes documents de dépistage et ajoute des notes pour ta clinique",
          "fields": {
            "screeningDocumentId": {
              "label": "Importer un document de dépistage"
            },
            "stdScreeningDate": {
              "label": "Date du dépistage IST / infectieux"
            },
            "stdResultNotes": {
              "label": "Notes du dépistage IST / infectieux",
              "placeholder": "Ajoute le résultat ou toute note sur le dépistage…"
            },
            "geneticScreeningDate": {
              "label": "Date du dépistage génétique / des porteurs"
            },
            "geneticResultNotes": {
              "label": "Notes du dépistage génétique / des porteurs",
              "placeholder": "Ajoute le résultat ou toute note sur le dépistage…"
            },
            "notes": {
              "label": "Notes complémentaires",
              "placeholder": "Autre chose à signaler à ta clinique…"
            }
          }
        },
        "sperm_collection": {
          "title": "Recueil de sperme",
          "short_title": "Recueil",
          "description": "Recueil de l'échantillon à la clinique ou au laboratoire",
          "prompt": "Raconte-nous le recueil",
          "scheduling_prompt": "Quand le recueil de sperme est-il prévu ?",
          "fields": {
            "collectionDate": { "label": "Date et heure du recueil" },
            "abstinenceDays": {
              "label": "Jours d'abstinence",
              "placeholder": "p. ex. 3"
            },
            "spermType": { "label": "Frais ou congelé" },
            "notes": {
              "label": "Notes",
              "placeholder": "Qualité, conditions, tout ce qui est utile…"
            }
          }
        },
        "analysis": {
          "title": "Spermogramme",
          "short_title": "Analyse",
          "description": "Numération, mobilité, morphologie et volume",
          "prompt": "Importe ton spermogramme pour pré-remplir, ou saisis les valeurs manuellement.",
          "skip_text": "Je n'ai pas encore les résultats du spermogramme",
          "fields": {
            "analysisResultDocId": { "label": "Rapport d'analyse (PDF)" },
            "concentration": {
              "label": "Concentration (M/mL)",
              "placeholder": "0"
            },
            "totalCount": {
              "label": "Numération totale (M)",
              "placeholder": "0"
            },
            "motilityPercent": { "label": "Mobilité (%)", "placeholder": "0" },
            "morphologyPercent": {
              "label": "Morphologie normale (%)",
              "placeholder": "0"
            },
            "volumeMl": { "label": "Volume (mL)", "placeholder": "0" },
            "notes": { "label": "Notes" }
          }
        },
        "freezing": {
          "title": "Congélation",
          "short_title": "Congélation",
          "description": "Paillettes congelées — les détails de conservation sont dans le Cryo Vault",
          "prompt": "Combien de paillettes ont été congelées ? Tu ajouteras le lieu de conservation dans ton Cryo Vault.",
          "fields": {
            "vialsFrozen": {
              "label": "Paillettes congelées",
              "placeholder": "0"
            },
            "freezeDate": { "label": "Date de congélation" },
            "notes": {
              "label": "Notes",
              "placeholder": "Quelque chose à noter…"
            }
          }
        }
      }
    },
    "all_past_cycles": {
      "title": "Cycles passés",
      "subtitle": "Garde une trace claire des cycles de traitement de ton parcours.",
      "add_button": "Ajouter un cycle passé",
      "add_title": "Ajouter un cycle passé",
      "add_subtitle": "Renseigne les détails que tu souhaites conserver dans ton parcours.",
      "step_progress": "Étape {current} sur {total}",
      "type_step_title": "Quel type de cycle était-ce ?",
      "type_step_subtitle": "Commence par le type de traitement. Tu ajouteras ensuite la date du cycle.",
      "when_step_title": "Quand ce cycle a-t-il eu lieu ?",
      "when_step_subtitle": "Le mois et l'année suffisent pour l'enregistrer. Continue quand tu es prête à ajouter des détails.",
      "outcome_step_title": "Que s'est-il passé pendant ce cycle ?",
      "outcome_step_subtitle": "Choisis un résultat si tu t'en souviens. Tu pourras ajouter les détails ensuite.",
      "treatment_outcome_step_title": "Comment le traitement s'est-il terminé ?",
      "treatment_outcome_step_subtitle": "Commence par nous dire si le traitement est allé jusqu'au bout ou s'il s'est arrêté avant.",
      "treatment_completed": "Traitement terminé",
      "treatment_completed_description": "Le traitement prévu est arrivé au point où le résultat de grossesse pouvait être évalué.",
      "treatment_cancelled": "Cycle annulé",
      "treatment_cancelled_description": "Le traitement s'est arrêté avant d'être terminé.",
      "treatment_other": "Autre ou je ne sais plus",
      "treatment_other_description": "Choisis cette option si une autre description correspond, ou si tu ne t'en souviens pas.",
      "pregnancy_outcome_step_title": "Y a-t-il eu une grossesse ?",
      "pregnancy_outcome_step_subtitle": "Compte une grossesse ici même si elle s'est terminée plus tard par une perte. Tu pourras ajouter la suite.",
      "pregnancy_including_loss": "Grossesse, y compris une perte ultérieure",
      "pregnancy_including_loss_description": "Un résultat positif à un moment après le traitement, que la grossesse ait continué ou non.",
      "pregnancy_result_not_recorded": "Je ne sais pas ou ce n'est pas renseigné",
      "pregnancy_result_not_recorded_description": "Tu peux enregistrer le cycle et revenir ajouter le résultat de grossesse plus tard.",
      "pregnancy_details_step_title": "Que s'est-il passé après la grossesse ?",
      "pregnancy_details_step_subtitle": "Ajoute le résultat que tu connais aujourd'hui. Tu pourras ajouter d'autres détails plus tard.",
      "pregnancy_ongoing": "Grossesse en cours",
      "pregnancy_ongoing_description": "La grossesse était toujours en cours lorsque tu as enregistré ce cycle.",
      "pregnancy_live_birth": "Naissance vivante",
      "pregnancy_live_birth_description": "La grossesse a donné lieu à une naissance vivante.",
      "pregnancy_multiple_live_birth": "Naissances vivantes multiples",
      "pregnancy_multiple_live_birth_description": "La grossesse a donné lieu à plusieurs naissances vivantes.",
      "pregnancy_loss": "Perte de grossesse",
      "pregnancy_loss_description": "La grossesse s'est terminée par une perte. Tu pourras ajouter le type plus tard.",
      "pregnancy_details_other": "Autre ou je ne sais pas",
      "pregnancy_details_other_description": "Choisis cette option si un autre résultat de grossesse correspond mieux.",
      "outcome_followup_title": "Souhaites-tu ajouter plus de détails sur ce résultat maintenant ?",
      "outcome_followup_subtitle": "Tu peux enregistrer le cycle maintenant ou ajouter le résultat bêta et d'autres détails.",
      "outcome_details_available_title": "Ajouter le résultat bêta et les détails",
      "outcome_details_available_subtitle": "Enregistre la valeur bêta, le statut du résultat et les détails que tu souhaites conserver pour ce cycle.",
      "add_outcome_details_button": "Ajouter des détails",
      "outcome_note_step_subtitle": "Ajoute une note sur ce qui s'est passé. Tu pourras en ajouter plus tard.",
      "when_month_year_label": "Mois et année",
      "month_year_placeholder": "MM/AAAA",
      "details_step_title": "Ajoute des détails à ce cycle",
      "details_step_subtitle": "Ajoute les détails dont tu te souviens. Tu pourras en ajouter plus tard.",
      "metric_follicles": "Follicules mesurés",
      "metric_eggs_retrieved": "Ovocytes prélevés",
      "metric_mature_eggs": "Ovocytes matures",
      "metric_eggs_frozen": "Ovocytes congelés",
      "metric_fertilized_eggs": "Ovocytes fécondés",
      "metric_day3_embryos": "Embryons J3",
      "metric_blastocysts": "Blastocystes",
      "metric_embryos_frozen": "Embryons congelés",
      "metric_embryos_transferred": "Embryons transférés",
      "egg_cohort_label": "Cycle de congélation d'ovocytes",
      "save_cycle_button": "Enregistrer le cycle",
      "add_details_button": "Continuer pour ajouter des détails",
      "continue_button": "Continuer",
      "back_button": "Retour",
      "validation_outcome_required": "Choisis un résultat pour continuer.",
      "validation_treatment_outcome_required": "Choisis comment le traitement s'est terminé pour continuer.",
      "validation_pregnancy_result_required": "Choisis s'il y a eu une grossesse pour continuer.",
      "validation_pregnancy_details_required": "Choisis ce qui s'est passé après la grossesse pour continuer.",
      "type_label": "Type de cycle",
      "clinic_label": "Clinique ou professionnel·le",
      "clinic_placeholder": "Où ce cycle a-t-il eu lieu ?",
      "start_date_label": "Début",
      "end_date_label": "Fin (facultatif)",
      "outcome_label": "Résultat",
      "preservation_outcome_unavailable": "Les résultats des spécimens et de leur conservation sont enregistrés dans Cryo Vault.",
      "notes_label": "Notes (facultatif)",
      "notes_placeholder": "Quelque chose à retenir…",
      "when": "Quand",
      "where": "Où",
      "no_date": "Dates non renseignées",
      "no_clinic": "Clinique non renseignée",
      "open_details": "Ouvrir les détails du cycle",
      "cancel_button": "Annuler",
      "save_button": "Ajouter le cycle",
      "validation_required": "Choisis un type de cycle pour continuer.",
      "validation_type_required": "Choisis un type de cycle pour continuer.",
      "validation_month_year_required": "Ajoute le mois et l'année pour continuer.",
      "validation_dates": "La date de fin ne peut pas précéder la date de début.",
      "save_error": "Impossible d’ajouter ce cycle. Réessaye.",
      "empty": "Aucun cycle passé pour l'instant",
      "outcome_positive": "Positif",
      "outcome_negative": "Sans succès",
      "outcome_cancelled": "Annulé",
      "outcome_completed": "Terminé",
      "outcome_ongoing": "En cours",
      "outcome_frozen": "Congelé"
    },
    "past_cycle_detail": {
      "loading": "Chargement des détails du cycle…",
      "outcome_cancelled": "Annulé·e",
      "outcome_cancelled_with_reason": "Annulé · ${reason}",
      "outcome_live_birth": "Naissance vivante",
      "outcome_multiple_live_birth": "Naissances multiples",
      "outcome_positive_beta": "Bêta positive",
      "outcome_negative": "Non concluant",
      "outcome_completed": "Terminé·e",
      "outcome_frozen": "Congelé·e",
      "outcome_ongoing": "En cours",
      "eggs_retrieved": "${count} ovocytes prélevés",
      "embryos_frozen": "${count} embryons congelés",
      "add_outcome": "Ajouter un résultat",
      "add_outcome_unavailable": "L'ajout de résultats aux cycles passés n'est pas encore disponible.",
      "add_clinic": "Ajouter une clinique",
      "add_dates": "Ajouter des dates",
      "edit_unavailable": "La modification des détails de cycles passés n'est pas encore disponible.",
      "header_eyebrow": "Cycle passé",
      "error_title": "Impossible de charger le cycle",
      "error_body": "Ce cycle n'existe peut-être plus.",
      "go_back": "Retour",
      "backfill_alert_title": "Bientôt disponible",
      "backfill_alert_body": "La modification des données de cycles passés n'est pas encore disponible — c'est dans nos prochains chantiers. Pour l'instant, tu peux enregistrer ces infos sur les cycles actifs ; on te permettra bientôt de compléter les précédents.",
      "labels": {
        "eggs_retrieved": "Ovocytes prélevés",
        "mature_eggs": "Ovocytes matures",
        "fertilized": "Fécondés",
        "day3_embryos": "Embryons J3",
        "blastocysts": "Blastocystes",
        "embryos_transferred": "Embryons transférés",
        "embryos_frozen": "Embryons congelés",
        "eggs_frozen": "Ovocytes congelés"
      },
      "specimen_status": {
        "used_later": "Utilisé",
        "discarded": "Éliminé",
        "donated": "Donné",
        "in_transit": "En transit",
        "not_active": "Inactif"
      },
      "lab_cryo_dialog": {
        "retrieval_title": "Ponction d'ovocytes",
        "retrieval_subtitle": "Commence par ce que le laboratoire a observé à la ponction. Si ça s'est arrêté tôt, on s'arrêtera là aussi.",
        "fertilization_title": "Fécondation",
        "fertilization_subtitle": "Indique combien d'ovocytes matures ont fécondé. Si zéro, les détails embryon, transfert et cryo sont ignorés.",
        "embryo_title": "Embryon, transfert et cryo",
        "embryo_subtitle": "Ajoute ce qui s'est passé après la fécondation pour ce cycle.",
        "back": "Retour",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "next": "Suivant",
        "fill_in_all": "Tout renseigner"
      }
    },
    "cycle_protocol": {
      "section_title": "Protocole",
      "tabs": {
        "medications": "Médicaments",
        "medications_compact": "Médic.",
        "timeline": "Chronologie",
        "timeline_compact": "Chrono.",
        "notes": "Notes",
        "notes_compact": "Notes"
      },
      "empty": {
        "medications_title": "Ajouter un médicament",
        "medications_subtitle": "Ajoute un médicament utilisé pendant ce cycle.",
        "timeline_title": "Ajouter un médicament",
        "timeline_subtitle": "Ajoute un médicament pour commencer la chronologie du cycle.",
        "notes_title": "Ajouter notes et ajustements de protocole",
        "notes_subtitle": "Enregistre les changements de dose, consignes de l'équipe soignante et notes de ce cycle."
      },
      "labels": {
        "medication_timeline": "Chronologie des médicaments",
        "daily": "Quotidien",
        "once": "Ponctuel",
        "since": "Depuis ${day}",
        "until": "Jusqu'à ${day}",
        "default_medication_name": "Médicament"
      },
      "add_medication": "Ajouter un médicament",
      "timeline": {
        "add_note_menu": "Ajouter une note",
        "day_menu": "Ouvrir les actions du ${date}",
        "add_note_title": "Ajouter une note à la chronologie",
        "add_note_placeholder": "Que s'est-il passé ce jour-là ?",
        "save_note": "Enregistrer la note",
        "status_taken": "Pris",
        "status_late": "Pris en retard",
        "status_missed": "Manqué",
        "status_upcoming": "À venir",
        "status_scheduled": "Prévu",
        "no_dose": "Dose non renseignée",
        "day_label": "Jour ${day}",
        "medication_singular": "médicament",
        "medication_plural": "médicaments",
        "scheduled_recap": "prévu(s)",
        "logged_recap": "enregistré(s)",
        "note_only_recap": "Une note a été ajoutée à cette journée.",
        "event_added": "Ajouté",
        "event_dose_changed": "Dose modifiée",
        "event_swapped": "Remplacement possible",
        "event_stopped": "Arrêté"
      }
    },
    "update_pregnancy": {
      "add_anything_you_want_to": "Ajoutez ce que vous voulez. Vous pouvez aussi simplement enregistrer.",
      "choose_a_different_answer": "Choisir une autre réponse",
      "weeks_along_one": "À ${count} semaine",
      "weeks_along_other": "À ${count} semaines",
      "babies_count_one": "${count} bébé",
      "babies_count_other": "${count} bébés",
      "where_things_stand": "Où en êtes-vous",
      "tell_us_only_what_you_want_to": "Dites-nous seulement ce que vous voulez. Le reste peut rester vide.",
      "stands_continuing": "Enceinte",
      "stands_ended": "La grossesse s'est arrêtée",
      "stands_birth": "Un bébé est né",
      "how_many_weeks_if_you_know": "À combien de semaines, si vous le savez",
      "weeks_placeholder": "Semaines",
      "if_your_clinic_told_you_which": "Si votre clinique vous a dit de quel type il s'agit, vous pouvez l'ajouter. Ce n'est pas obligatoire.",
      "i_am_not_sure": "Je ne sais pas",
      "loss_complete_miscarriage": "Fausse couche",
      "loss_incomplete_miscarriage": "Fausse couche incomplète",
      "loss_missed_miscarriage": "Fausse couche silencieuse",
      "loss_chemical_pregnancy": "Perte très précoce (grossesse biochimique)",
      "loss_ectopic_pregnancy": "Grossesse extra-utérine",
      "loss_anembryonic_pregnancy": "Grossesse anembryonnaire (œuf clair)",
      "loss_still_birth": "Mort fœtale in utero",
      "loss_recurrent_miscarriage": "Fausses couches à répétition",
      "how_many_babies_if_you_want_to_say": "Combien de bébés, si vous voulez le préciser",
      "babies_placeholder": "Bébés",
      "save": "Enregistrer",
      "specify_the_outcome": "Préciser l'issue",
      "say_where_things_stand": "Dites où vous en êtes, quand vous vous sentez prête."
    },
    "cycle_tests": {
      "section_title": "Examens",
      "view_all": "Tout voir",
      "empty_title": "Ajouter un résultat",
      "empty_subtitle": "Téléverse ou rattache des comptes rendus de labo, imagerie, spermogramme, génétique et autres examens à ce cycle.",
      "see_details": "Voir le détail",
      "badge_waiting": "En attente",
      "badge_scheduled": "Planifié",
      "no_date": "Pas de date",
      "linked_to_cycle": "Lié à ce cycle"
    },
    "cycle_clinic_team": {
      "rei": "Méd. repro.",
      "reproductive_endocrinologist": "Médecin de la reproduction",
      "clinic": "Centre",
      "clinic_connected": "Centre rattaché à ce cycle.",
      "add_providers_portal": "Ajoute soignants, accès au portail et consignes de cycle.",
      "connect_care_team_fallback": "Connecte ton équipe soignante",
      "menu_edit_team": "Modifier l'équipe",
      "menu_add_provider": "Ajouter un soignant ou un centre",
      "connect_clinic_title": "Rattacher un centre",
      "connect_clinic_subtitle": "Trouve ton centre, ajoute-le, ou garde les accès au portail avec ce cycle.",
      "add_physicians_title": "Ajouter des soignants",
      "add_physicians_subtitle": "Ajoute ton médecin de la reproduction, ton infirmier·ère coordinateur·rice, ton gynécologue ou tout autre soignant.",
      "team_subtitle_present": "Retrouve ici la surveillance, les ajustements de protocole, les consignes du portail et le suivi de la ponction pour ce cycle.",
      "team_subtitle_empty": "Ajoute centres, médecins et soignants pour garder consignes, rendez-vous et dossiers ensemble.",
      "open_member": "Ouvrir ${name}",
      "open_actions": "Ouvrir les actions de l'équipe",
      "call_clinic": "Appeler le centre",
      "open_portal": "Ouvrir le portail du centre",
      "manage_title": "Gérer l’équipe de ce cycle",
      "manage_description": "Garde ici les soignants et le centre associés à ce cycle. Les nouvelles personnes peuvent d’abord être enregistrées dans ton équipe soignante.",
      "manage_match_note": "Ajoute une personne de ton équipe soignante pour la garder visible dans ce cycle. Ses informations pourront être confirmées plus tard.",
      "cycle_clinic_label": "Enregistré pour ce cycle",
      "recorded_badge": "Enregistré",
      "recorded_team_title": "Équipe soignante enregistrée",
      "add_recorded_member_title": "Ajouter depuis ton équipe",
      "add_recorded_member_description": "Choisis une personne ou une organisation déjà enregistrée et associe-la à ce cycle.",
      "add_recorded_member_action": "Ajouter",
      "remove_recorded_member_action": "Retirer",
      "no_available_records": "Enregistre d’abord un soignant, un centre ou une pharmacie dans ton équipe.",
      "attach_failed": "Impossible d’ajouter cet enregistrement au cycle. Réessaie.",
      "detach_failed": "Impossible de retirer cet enregistrement du cycle. Réessaie.",
      "empty_manage": "Aucun soignant officiel n’est encore rattaché à ce cycle.",
      "open_profile_action": "Ouvrir l’équipe",
      "done": "Terminer",
      "cancel": "Annuler",
      "remove_member_action": "Retirer",
      "remove_member_title": "Retirer ${name} de ce cycle ?",
      "remove_member_description": "Cela retire l’association officielle avec ce cycle, sans supprimer le profil du soignant.",
      "remove_member_confirm": "Retirer",
      "remove_member_failed": "Impossible de modifier l’équipe de ce cycle. Réessaie."
    },
    "cycle_documents": {
      "section_title": "Documents liés",
      "view_all": "Tout voir",
      "empty_title": "Ajouter un document",
      "empty_subtitle": "Téléverse ou rattache comptes rendus de labo, consentements, factures et autres dossiers à ce cycle.",
      "no_date": "Pas de date",
      "doc_lab_record": "Compte rendu de labo",
      "doc_imaging_report": "Compte rendu d'imagerie",
      "doc_treatment_plan": "Plan de traitement",
      "doc_genetic_report": "Compte rendu génétique",
      "doc_billing": "Facturation, frais ou reçus",
      "doc_consent": "Consentement ou directive",
      "doc_coverage": "Justificatif de prise en charge",
      "doc_default": "Document de cycle"
    },
    "cycle_detail": {
      "menu": {
        "edit_cycle": "Modifier le cycle",
        "add_specimen": "Ajouter un spécimen",
        "end_cycle": "Terminer le cycle"
      },
      "alerts": {
        "save_failed_title": "Impossible d'enregistrer le cycle",
        "save_failed_message": "Une erreur est survenue. Réessaye.",
        "coming_soon_title": "Bientôt disponible",
        "coming_soon_message": "La connexion des cliniques et soignants à un cycle actif sera bientôt intégrée à ton équipe soignante. Une fois connectés, ils apparaîtront ici pour ce cycle.",
        "error_generic": "Une erreur est survenue. Réessaye."
      },
      "empty": {
        "no_active_cycle_title": "Aucun cycle actif",
        "no_active_cycle_subtitle": "Aucun cycle de traitement n'est actif pour le moment. Démarre-en un quand tu seras prête, ou ajoute un cycle passé à ton historique.",
        "post_cycle_positive_title": "Félicitations pour cette belle nouvelle",
        "post_cycle_positive_body": "Ton cycle est désormais archivé dans tes cycles passés.",
        "post_cycle_eyebrow": "Cycle terminé",
        "back_to_care": "Retour à mon parcours",
        "read_article_positive": "Lire : l'attente de deux semaines et le début de grossesse",
        "read_article_negative": "Lire : soutien émotionnel pendant le parcours",
        "active_cycle_eyebrow": "Cycle actif",
        "starting_soon": "Démarre bientôt",
        "no_active_cycle_main": "Aucun cycle actif"
      },
      "buttons": {
        "add_clinic": "Ajouter une clinique",
        "add_start_date": "Ajouter une date de début"
      },
      "sections": {
        "cryo_vault": "Coffre de cryopréservation",
        "connect_care_team": "Connecte ton équipe soignante"
      },
      "timeline": {
        "day_label": "Jour ${day}",
        "day_of_phase": "Jour ${day} – ${phase}",
        "day_of_treatment": "Jour ${day} de traitement",
        "started_with_day": "Démarré le ${date} · Jour ${day}",
        "started_on": "Démarré le ${date}",
        "starts": "Démarre le ${date}",
        "upcoming": "À venir",
        "started_marker": "Démarré le ${date} — tu es ici (Jour ${day})",
        "starts_short": "Démarre le ${date}",
        "est_window": "Estimé ${window}",
        "filled": "Complété le ${date}",
        "test_on": "Test le ${date}",
        "result_recorded_on": "Enregistré le ${date}"
      },
      "timeline_steps": {
        "pre_treatment": "Pré-traitement",
        "stimulation": "Stimulation",
        "trigger": "Déclenchement",
        "retrieval": "Ponction",
        "freezing": "Résultat de congélation",
        "fertilization": "Fécondation",
        "embryo_culture": "Culture embryonnaire",
        "transfer": "Transfert",
        "waiting_period": "Période d'attente",
        "sperm_sample": "Recueil de sperme",
        "sperm_short": "Sperme",
        "trigger_shot_full": "Déclenchement de l'ovulation",
        "screening": "Bilan préalable",
        "semen_analysis": "Spermogramme",
        "insemination": "Insémination"
      },
      "frozen_protocol": {
        "step_title": "Préparation de l'endomètre",
        "description": "Prépare ta muqueuse utérine pour le transfert avec œstrogènes et progestérone.",
        "prompt": "Quels médicaments as-tu pris pendant la préparation ?",
        "skip_text": "Je n'ai pas pris de médicaments de préparation ce cycle-ci"
      },
      "lab_labels": {
        "e2": "E2 (pg/mL)",
        "lh": "LH (mUI/mL)",
        "p4": "P4 (ng/mL)",
        "follicles_r": "Follicules D",
        "follicles_l": "Follicules G",
        "lining": "Endomètre (mm)"
      },
      "biomarkers": {
        "estradiol": {
          "label": "Estradiol",
          "description": "Principal œstrogène produit par les follicules en croissance.",
          "why_matters": "Une E2 qui monte confirme que les follicules grandissent.",
          "normal_range": "~200–300 pg/mL par follicule mature.",
          "assessment_high": "À surveiller de près",
          "assessment_rising": "Bonne progression",
          "assessment_low": "Bas — ajustement possible",
          "assessment_on_track": "Conforme"
        },
        "follicles": {
          "label": "Follicules",
          "description": "Sacs remplis de liquide pouvant chacun contenir un ovocyte.",
          "why_matters": "Le nombre et la taille prédisent combien d'ovocytes pourront être prélevés.",
          "normal_range": "Bonne réponse : 8–15 follicules.",
          "assessment_strong": "Réponse forte",
          "assessment_good": "Bonne réponse",
          "assessment_moderate": "Réponse modérée",
          "assessment_low": "Réponse faible"
        },
        "lining": {
          "label": "Endomètre",
          "description": "Tissu qui tapisse l'utérus.",
          "why_matters": "Un endomètre épais favorise l'implantation.",
          "normal_range": "Optimal : ≥7–8 mm.",
          "assessment_optimal": "Épaisseur optimale",
          "assessment_nearly": "Presque optimale",
          "assessment_thickening": "S'épaissit encore",
          "assessment_thin": "Fin — à surveiller"
        },
        "lh": {
          "label": "LH",
          "description": "Déclenche l'ovulation.",
          "why_matters": "Maintenue basse pendant la FIV pour éviter une ovulation prématurée.",
          "normal_range": "Pendant la stimulation, en dessous de 10 UI/L.",
          "assessment_elevated": "Élevée — alerte l'équipe",
          "assessment_suppressed": "Bien suppressée",
          "assessment_in_range": "Dans la norme"
        }
      },
      "detail": {
        "what_is_it": "De quoi s'agit-il",
        "why_it_matters": "Pourquoi c'est important",
        "typical_range": "Plage typique",
        "your_values_this_cycle": "Tes valeurs ce cycle",
        "values_by_cycle": "Valeurs par cycle",
        "values_over_time": "Valeurs dans le temps",
        "not_tracked_badge": "Pas encore suivi",
        "not_tracked_title": "Aucun résultat pour l'instant",
        "not_tracked_body": "Cette mesure peut être consultée même avant d'avoir un résultat. Ajoute un compte rendu de laboratoire quand tu l'as et l'historique apparaîtra ici.",
        "upload_results": "Ajouter des résultats",
        "related_documents": "Documents liés",
        "previous_value": "Précédent : ${value} ${unit}",
        "history_point": "${day} — ${date}"
      },
      "medication": {
        "default_name": "Médicament",
        "scheduled_at": "Prévu ${times}"
      },
      "cycle_label": {
        "with_type": "Cycle ${type}",
        "fallback": "Cycle",
        "started_chip": "Démarré le ${date}"
      },
      "phase_content": {
        "pre_treatment": {
          "description": "Bilans de référence, revue des médicaments et préparation avant le début de la stimulation.",
          "detail_1": "Bilan sanguin et échographie de référence",
          "detail_2": "Revue et commande des médicaments",
          "detail_3": "Apprentissage de la technique d'injection avec ton infirmier·ère",
          "detail_4": "Confirmation de ton protocole et de ton calendrier"
        },
        "protocol": {
          "description": "Des injections hormonales quotidiennes stimulent tes ovaires pour faire grandir plusieurs follicules, chacun contenant un ovocyte potentiel.",
          "detail_1": "Injections quotidiennes pour stimuler la croissance des follicules",
          "detail_2": "Antagoniste ajouté en milieu de cycle pour éviter une ovulation prématurée",
          "detail_3": "Bilans sanguins et échographies réguliers pour suivre la réponse",
          "detail_4": "Les doses peuvent être ajustées selon ta réponse"
        },
        "egg_retrieval": {
          "description": "Un acte court sous sédation légère pendant lequel les ovocytes sont prélevés de tes follicules sous guidage échographique.",
          "detail_1": "Ne rien manger ni boire après minuit la veille",
          "detail_2": "L'intervention dure environ 15 à 20 minutes sous sédation légère",
          "detail_3": "Une aiguille guidée par échographie aspire le liquide de chaque follicule",
          "detail_4": "Tu sauras combien d'ovocytes ont été prélevés au réveil",
          "detail_5": "Prévois de te reposer le reste de la journée"
        },
        "fertilization": {
          "description": "Les ovocytes prélevés sont fécondés (par FIV ou ICSI) et les embryons sont cultivés au laboratoire pendant 3 à 5 jours.",
          "detail_1": "Jour 1 : vérification de la fécondation — combien d'ovocytes ont fécondé normalement",
          "detail_2": "Jour 3 : les embryons sont typiquement à 6–8 cellules",
          "detail_3": "Jour 5 : les embryons survivants peuvent atteindre le stade blastocyste",
          "detail_4": "Tous les ovocytes ne fécondent pas, et tous les embryons ne se développent pas — c'est normal",
          "detail_5": "Ta clinique te donnera des nouvelles tous les jours ou tous les deux jours"
        },
        "transfer": {
          "description": "Un seul embryon est délicatement placé dans ton utérus à l'aide d'un cathéter fin. Pas besoin de sédation.",
          "detail_1": "Arrive avec la vessie confortablement pleine (cela aide le guidage échographique)",
          "detail_2": "L'intervention dure environ 5 à 10 minutes et est généralement indolore",
          "detail_3": "Tu verras le transfert sur l'écran d'échographie",
          "detail_4": "Reprise des activités normales le jour même",
          "detail_5": "Commence ou continue le soutien en progestérone comme prescrit"
        },
        "luteal_phase": {
          "description": "La période d'attente entre le transfert et ta prise de sang de grossesse (bêta hCG).",
          "detail_1": "Continue la progestérone et tous les autres médicaments prescrits",
          "detail_2": "Prise de sang (bêta hCG) entre 10 et 14 jours après le transfert pour confirmer la grossesse",
          "detail_3": "Évite les tests de grossesse à domicile trop tôt — ils peuvent donner de faux résultats",
          "detail_4": "De légères crampes et des saignements peuvent être normaux",
          "detail_5": "Appuie-toi sur ton entourage — c'est souvent la partie la plus difficile émotionnellement"
        }
      }
    },
    "lab_result": {
      "ref_prefix": "Réf. : ${range}",
      "context_title": "Comment ce résultat a été interprété",
      "context_meta": "Contexte temporel",
      "context_cycle_day": "Jour du cycle",
      "context_cycle_phase": "Phase du cycle",
      "context_treatment_phase": "Phase du traitement",
      "context_used": "Contexte utilisé",
      "context_day_value": "Jour ${day}",
      "context_baseline": "Référence de base",
      "context_follicular": "Phase folliculaire",
      "context_stimulation": "Stimulation",
      "context_ovulatory": "Ovulation",
      "context_luteal": "Phase lutéale",
      "context_unknown": "Inconnu",
      "context_show_details": "Afficher le contexte temporel",
      "context_hide_details": "Masquer le contexte temporel",
      "abnormal_warning": "Hors de la plage de référence. À discuter avec votre équipe soignante.",
      "trend_over_time": "Évolution dans le temps",
      "what_is_it": "De quoi s'agit-il ?",
      "why_it_matters": "Pourquoi c'est important",
      "typical_range": "Plage typique",
      "no_info_title": "Pas d'information détaillée disponible",
      "no_info_body": "Nous n'avons pas encore de contenu pédagogique pour ce test. Votre valeur et votre historique restent enregistrés ci-dessus.",
      "all_values": "Toutes les valeurs",
      "delete_value_prompt": "Supprimer cette valeur ?",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "edit_error": "Impossible d'enregistrer ce résultat. Vérifie les détails et réessaie.",
      "delete_error": "Impossible de supprimer ce résultat. Réessaie ou annule pour le conserver.",
      "edit_value": "Modifier la valeur",
      "delete_confirm": "Voulez-vous vraiment supprimer ce résultat ? Cette action est irréversible.",
      "disclaimer": "Les résultats doivent être interprétés par votre médecin\ndans le contexte de votre situation clinique globale.",
      "edit_value_label": "Valeur",
      "edit_value_placeholder": "Saisir une valeur",
      "edit_unit_label": "Unité",
      "edit_unit_placeholder": "p. ex. pg/mL",
      "edit_cancel": "Annuler",
      "edit_save": "Enregistrer",
      "category_lab_result": "Résultat de labo",
      "loinc_label": "LOINC ${code}",
      "edit_result_title": "Modifier le résultat",
      "tab_overview": "Aperçu",
      "tab_overview_short": "Info",
      "tab_values": "Valeurs",
      "tab_values_short": "Valeurs",
      "tab_biology": "Biologie",
      "tab_biology_short": "Bio",
      "tab_related": "Associé",
      "tab_related_short": "Plus",
      "no_values_title": "Pas encore d'historique",
      "no_values_body": "Ajoute un autre résultat pour voir l'évolution de cette valeur.",
      "biological_basis": "Base biologique",
      "how_it_is_measured": "Comment c'est mesuré",
      "how_it_changes_over_time": "Comment cela évolue dans le temps",
      "when_it_is_measured": "Quand c'est mesuré",
      "how_to_read_it": "Comment le lire",
      "related_markers": "Marqueurs associés",
      "testing_options": "Faire le test",
      "testing_options_empty": "Aucune option de test liée à ce marqueur pour le moment.",
      "view_test_details": "Voir les détails du test",
      "related_documents": "Documents associés",
      "source_document": "Compte rendu source",
      "source_document_pending": "Compte rendu en cours de traitement",
      "source_document_add": "Ajouter le compte rendu source",
      "source_document_missing": "Aucun compte rendu associé pour le moment",
      "documents_empty_title": "Aucun document associé",
      "documents_empty_body": "Les comptes rendus de laboratoire et documents de rendez-vous associés apparaîtront ici lorsqu'ils seront liés.",
      "latest_value": "Dernière valeur",
      "trend_stable": "Stable",
      "trend_up": "En hausse",
      "trend_down": "En baisse",
      "reference_label": "Référence : ${range}",
      "tag_amh": "AMH",
      "tag_afc": "AFC",
      "tag_testing": "Analyses",
      "tag_at_home": "À domicile",
      "tag_lab": "Laboratoire",
      "tag_clinic_visit": "Rendez-vous en clinique",
      "tag_pre_cycle": "Avant le cycle",
      "tag_during_cycle": "Pendant le cycle",
      "tag_post_cycle": "Après le cycle",
      "tag_ivf": "FIV",
      "tag_fet": "TEC",
      "tag_pcos": "SOPK",
      "tag_pmos": "PMOS",
      "tag_thyroid": "Thyroïde",
      "sample_blood": "Sang",
      "sample_ultrasound": "Échographie",
      "sample_imaging": "Imagerie",
      "sample_urine": "Urine",
      "sample_saliva": "Salive",
      "sample_semen": "Sperme",
      "sample_genetic": "Génétique",
      "sample_swab": "Prélèvement",
      "sample_tissue": "Tissu"
    },
    "delivery": {
      "title": "Livraison de médicaments",
      "in_this_shipment": "Dans ce colis",
      "estimated_arrival": "Arrivée estimée ${time}",
      "tracking_label": "Suivi : ${number}",
      "copied": "Copié !",
      "contact_pharmacy": "Contacter ${pharmacy}",
      "not_connected_body": "Le suivi de livraison apparaîtra ici quand Louise aura une vraie connexion pharmacie ou livraison.",
      "not_connected_sheet_title": "Suivi de livraison pharmacie",
      "not_connected_sheet_description": "Tu pourras suivre les expéditions de ta pharmacie ici quand Louise sera connectée à de vraies données pharmacie ou livraison. En attendant, contacte directement ta pharmacie pour l'ETA et les informations de suivi.",
      "step_placed": "Commande passée",
      "step_preparing": "En préparation",
      "step_shipped": "Expédiée",
      "step_in_transit": "En transit",
      "step_delivered": "Livrée"
    },
    "cycle_type": {
      "ivf": "Cycle FIV",
      "iui": "Cycle IIU",
      "fet": "Cycle TEC",
      "icsi": "Cycle FIV + ICSI",
      "oi": "Induction de l'ovulation",
      "egg_freezing": "Congélation d'ovocytes",
      "embryo_freezing": "Congélation d'embryons",
      "sperm_freezing": "Congélation de sperme"
    },
    "phase_type": {
      "pre_treatment": "Pré-traitement",
      "protocol": "Phase de stimulation",
      "egg_retrieval": "Ponction ovocytaire",
      "sperm_collection": "Recueil de sperme",
      "fertilization": "Fécondation",
      "insemination": "Insémination",
      "embryo_development": "Développement embryonnaire",
      "transfer": "Transfert d'embryon",
      "luteal_phase": "Période d'attente"
    },
    "calendar_full_month": {
      "january": "Janvier",
      "february": "Février",
      "march": "Mars",
      "april": "Avril",
      "may": "Mai",
      "june": "Juin",
      "july": "Juillet",
      "august": "Août",
      "september": "Septembre",
      "october": "Octobre",
      "november": "Novembre",
      "december": "Décembre"
    },
    "weekday_short": {
      "mon": "LUN",
      "tue": "MAR",
      "wed": "MER",
      "thu": "JEU",
      "fri": "VEN",
      "sat": "SAM",
      "sun": "DIM"
    },
    "weekday_long": {
      "mon": "lundi",
      "tue": "mardi",
      "wed": "mercredi",
      "thu": "jeudi",
      "fri": "vendredi",
      "sat": "samedi",
      "sun": "dimanche"
    },
    "symptoms": {
      "title": "Suivi quotidien des symptômes",
      "question_today": "${question} aujourd'hui ?",
      "question_on_date": "${question} le ${date} ?",
      "view_all": "Voir tous les symptômes",
      "view_fewer": "Voir moins",
      "n_logged_today": "${count} enregistré·s aujourd'hui — votre équipe médicale peut les voir",
      "n_logged_on_date": "${count} enregistré·s ${date} — votre équipe médicale peut les voir",
      "today": "aujourd'hui",
      "yesterday": "hier",
      "category": {
        "digestion": "Digestion",
        "sexual": "Vie sexuelle et reproductive",
        "urogenital": "Urogénital",
        "bleeding": "Saignements et coagulation",
        "psychological": "Psychologique",
        "heart": "Cœur et poumons"
      },
      "symptom": {
        "bloated": "Ballonnements",
        "nauseous": "Nausées",
        "cravings": "Envies",
        "indigestion": "Indigestion",
        "constipation": "Constipation",
        "diarrhea": "Diarrhée",
        "weight_gain": "Prise de poids",
        "weight_loss": "Perte de poids",
        "high_libido": "Libido élevée",
        "low_libido": "Libido faible",
        "ovulation_pain": "Douleur d'ovulation",
        "breast_tenderness": "Sensibilité mammaire",
        "hot_flashes": "Bouffées de chaleur",
        "vaginal_dryness": "Sécheresse vaginale",
        "acne": "Acné",
        "frequent_urination": "Mictions fréquentes",
        "burning": "Brûlures",
        "incontinence": "Incontinence",
        "spotting": "Pertes brunes",
        "light_bleeding": "Saignement léger",
        "heavy_bleeding": "Saignement abondant",
        "clots": "Caillots",
        "moody": "Humeur changeante",
        "anxious": "Anxieux·se",
        "irritable": "Irritable",
        "tired": "Fatigue",
        "insomnia": "Insomnie",
        "good_energy": "Bonne énergie",
        "feeling_okay": "Ça va",
        "palpitations": "Palpitations",
        "shortness_of_breath": "Essoufflement",
        "injection_site_sore": "Douleur au point d'injection",
        "headache": "Mal de tête",
        "cramping": "Crampes",
        "shoulder_pain": "Douleur à l'épaule",
        "fever": "Fièvre",
        "dizziness": "Vertiges",
        "erectile_difficulty": "Trouble érectile",
        "testicular_discomfort": "Gêne testiculaire",
        "ejaculation_pain": "Douleur à l'éjaculation",
        "difficulty_starting_urination": "Difficulté à uriner"
      }
    },
    "start_treatment": {
      "title_start": "Démarrer un cycle de traitement",
      "title_edit": "Modifier le cycle de traitement",
      "title_where_when": "Où et quand ?",
      "subtitle_step1": "Choisissez le type de traitement que vous commencez.",
      "subtitle_step2": "${label} · ajoutez votre centre et une date de début prévue.",
      "cycle_ivf": "FIV",
      "cycle_icsi": "FIV + ICSI",
      "cycle_iui": "IIU",
      "cycle_fet": "TEC (transfert d'embryon congelé)",
      "cycle_oi": "Stimulation ovarienne",
      "cycle_egg_freezing": "Congélation d'ovocytes",
      "cycle_embryo_freezing": "Congélation d'embryons",
      "cycle_sperm_freezing": "Congélation de sperme",
      "cycle_unavailable": "Traitement pris en charge",
      "cycle_ivf_partner": "FIV (avec partenaire)",
      "cycle_icsi_partner": "FIV + ICSI (avec partenaire)",
      "cycle_iui_partner": "IIU (avec partenaire)",
      "cycle_fet_partner": "TEC (avec partenaire)",
      "cycle_embryo_freezing_partner": "Congélation d'embryons (avec partenaire)",
      "clinic_label": "Nom du centre",
      "clinic_placeholder": "Saisir le nom du centre",
      "date_label": "Date de début prévue",
      "date_hint": "Une date approximative suffit. Vous pourrez la modifier plus tard.",
      "frozen_selection_title": "Fiches CryoVault sélectionnées",
      "frozen_selection_summary": "${count} fiche(s) précise(s) proviennent du Cryo Vault et seront réservées au démarrage du cycle.",
      "frozen_selection_authority_confirmation": "Je confirme avoir l'autorité et le consentement requis pour réserver ces fiches CryoVault précises pour ce cycle de traitement.",
      "change_frozen_selection": "Modifier la sélection",
      "next": "Suivant",
      "back": "Retour",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "start_cycle": "Démarrer le cycle",
      "update_cycle": "Mettre à jour le cycle",
      "cycle_already_open": {
        "you_have_open_cycle": "Un cycle est déjà en cours",
        "finish_before_starting_new": "Terminez votre cycle actuel avant d'en démarrer un nouveau.",
        "go_to_current_cycle": "Voir mon cycle en cours",
        "not_now": "Plus tard"
      }
    },
    "discontinue": {
      "title": "Quelque chose a changé ?",
      "description": "Cela mettra fin au cycle en cours. Toutes vos informations de traitement, votre progression et vos comptes rendus resteront accessibles depuis l'historique de traitement.",
      "reason_header": "Motif",
      "reason_medical_advice": "Recommandation du médecin",
      "reason_personal_choice": "Raisons personnelles",
      "reason_side_effects": "Effets secondaires",
      "reason_protocol_switch": "Changement de protocole",
      "reason_financial": "Raisons financières",
      "reason_trigger_not_administered": "Déclenchement non administré",
      "reason_no_retrieval": "Aucun prélèvement effectué",
      "reason_other": "Autre",
      "notes_label": "Notes (optionnel)",
      "notes_placeholder": "Si vous le souhaitez, partagez quelques mots sur la raison de l'arrêt…",
      "confirm": "Arrêter le traitement",
      "cancel": "Annuler"
    },
    "complete_cycle": {
      "title": "Terminer le cycle",
      "description": "Cela marquera votre cycle comme terminé. Votre historique de traitement et vos échantillons congelés resteront accessibles depuis les cycles passés.",
      "summary_header": "Récapitulatif du cycle",
      "treatment_label": "Traitement",
      "clinic_label": "Centre",
      "started_label": "Démarré le",
      "outcome_review_header": "Résultat du traitement",
      "retrieved_count": "Ovocytes prélevés",
      "mature_count": "Ovocytes matures",
      "fertilized_count": "Fécondés normalement",
      "frozen_count": "Ovocytes congelés",
      "embryos_frozen_count": "Embryons congelés",
      "vials_frozen_count": "Paillettes congelées",
      "not_recorded": "Non renseigné",
      "confirmed_no_stored_specimens": "Aucun échantillon n'a été conservé lors de ce cycle. Tu peux terminer le cycle sans ajouter d'inventaire.",
      "stored_specimens_count_mismatch": "Le résultat indique ${expectedCount} échantillons congelés, mais ${storedCount} échantillons correspondants sont rattachés à ce cycle. Tu peux les ajouter ou les corriger, ou terminer le cycle — le dossier conserve les deux chiffres.",
      "no_frozen_count_recorded": "Aucun nombre d'échantillons congelés n'a encore été enregistré pour ce cycle. Tu peux ajouter les échantillons conservés, ou terminer le cycle sans eux.",
      "add_stored_specimens": "Ajouter les échantillons conservés",
      "specimens_one": "${count} échantillon congelé",
      "specimens_other": "${count} échantillons congelés",
      "stored_specimens_label": "Échantillons stockés",
      "eggs_one": "${count} ovocyte",
      "eggs_other": "${count} ovocytes",
      "embryos_one": "${count} embryon",
      "embryos_other": "${count} embryons",
      "vials_one": "${count} paillette",
      "vials_other": "${count} paillettes",
      "group_eggs": "Ovocytes",
      "group_embryos": "Embryons",
      "group_sperm": "Sperme",
      "notes_label": "Notes (optionnel)",
      "notes_placeholder": "Notes éventuelles sur ce cycle…",
      "confirm": "Confirmer la finalisation",
      "cancel": "Annuler"
    },
    "beta_result": {
      "header_self": "Enregistrer le résultat bêta hCG",
      "header_partner": "Enregistrer le résultat bêta hCG",
      "header_we_are_sorry": "Nous sommes désolé·e·s",
      "header_pregnancy_confirmed": "Grossesse confirmée",
      "header_congrats": "Félicitations",
      "header_with_you": "Nous sommes avec vous",
      "intro_self": "Joignez le compte rendu ou saisissez le chiffre.",
      "intro_partner": "Joignez le compte rendu ou saisissez le chiffre.",
      "section_result_self": "Votre résultat de bêta-hCG",
      "section_result_partner": "Résultat de bêta-hCG de ${name}",
      "choice_yes_self_title": "Oui, je suis enceinte",
      "choice_yes_partner_title": "Oui, elle est enceinte",
      "choice_yes_self_subtitle": "Votre bêta-hCG a confirmé la grossesse",
      "choice_yes_partner_subtitle": "La bêta-hCG de ${name} a confirmé la grossesse",
      "choice_no_title": "Non, pas cette fois",
      "choice_no_subtitle": "La bêta-hCG était négative",
      "not_pregnant_intro_title": "Prenez le temps qu'il vous faut.",
      "not_pregnant_intro_body": "Avant de clôturer le cycle, une petite question — vous pouvez la passer.",
      "notes_label": "Notes (optionnel)",
      "notes_placeholder_default": "Ce que vous aimeriez retenir de ce moment…",
      "notes_placeholder_negative": "Ce que vous souhaitez noter pour vous-même ? (optionnel)",
      "notes_placeholder_positive": "Ce que vous voulez garder de ce moment ? (optionnel)",
      "continued_title": "Quelle nouvelle ✨",
      "continued_body": "Nous marquerons ce cycle comme une grossesse positive. Vous pourrez revenir ajouter les détails plus tard — rien à remplir maintenant.",
      "save": "Enregistrer",
      "value_label_self": "Votre valeur de bêta-hCG",
      "value_label_partner": "Valeur de bêta-hCG de ${name}",
      "value_unit": "mUI/mL",
      "value_placeholder": "ex. 142",
      "value_notes_prefix": "Bêta hCG",
      "collection_date_label": "Date du prélèvement (optionnel)",
      "collection_date_hint": "Ajoutez la date si vous savez quand l'échantillon a été prélevé. Vous pouvez ajouter l'heure séparément.",
      "collection_time_label": "Heure du prélèvement (optionnel)",
      "documents_label": "Document de résultat",
      "documents_drop_action": "Ajouter un document",
      "documents_drop_hint": "PDF ou photo",
      "document_name_prefix": "Résultat bêta hCG",
      "confirm_your_transfer_before_recording_a_beta": "Confirmez d'abord votre transfert : c'est à sa date qu'un résultat bêta se rattache. Vous pouvez le faire depuis votre plan, puis revenir ici.",
      "fet_order_lookup_pending": "Le suivi bêta de ce cycle est encore en cours de chargement. Réessayez dans un instant.",
      "earlier_entry_saved": "Votre saisie précédente a déjà été enregistrée. Nous avons actualisé ce cycle — enregistrez à nouveau pour le mettre à jour avec cette valeur.",
      "recorded_by_your_clinic": "Votre clinique a enregistré le résultat de ce cycle, il ne peut donc pas être modifié ici. Contactez votre équipe de soins pour le mettre à jour.",
      "result_cannot_be_changed_here": "Ce résultat ne peut pas être modifié ici. Votre équipe de soins peut le mettre à jour.",
      "only_they_can_record_this_result": "Un résultat pour ce cycle ne peut être enregistré que par ${name}, depuis son propre compte.",
      "only_the_person_this_cycle_belongs_to_can_record": "Un résultat pour ce cycle ne peut être enregistré que par la personne concernée, depuis son propre compte.",
      "uploading": "Téléversement…",
      "reading": "Lecture…",
      "parsed_badge": "Lu",
      "parsed": "Vérifiez la valeur ci-dessous et modifiez-la si besoin.",
      "unreadable": "Lecture impossible. Ajoutez la valeur ci-dessous.",
      "cancel": "Annuler",
      "header_borderline": "Un second dosage est recommandé",
      "borderline_subhead": "Une valeur de ${value} mUI/mL est détectable mais encore basse. C'est le second dosage qui nous dira si elle augmente, alors essayez de ne pas trop interpréter ce seul chiffre.",
      "borderline_repeat_label": "Second dosage bêta",
      "borderline_repeat_hint": "Généralement sous 48 heures, afin que votre série de bêta-hCG montre si le taux augmente.",
      "borderline_note": "Nous avons enregistré cette valeur. Vous pourrez mettre à jour le résultat une fois votre second dosage reçu.",
      "positive_headline": "Quelle belle nouvelle ✨",
      "positive_subhead": "Prenez un moment. Vous avez traversé beaucoup pour en arriver là.",
      "whats_next": "La suite",
      "milestone_first_ultrasound": "Première échographie",
      "milestone_first_ultrasound_hint": "vers 6 semaines de gestation",
      "milestone_first_trimester_end": "Fin du premier trimestre",
      "milestone_first_trimester_end_hint": "13 semaines",
      "milestone_half_way": "Mi-parcours",
      "milestone_half_way_hint": "20 semaines",
      "keep_cycle_title": "Nous gardons ce cycle ici",
      "keep_cycle_body": "Vous pouvez revenir à tout moment ajouter les détails de l'accouchement (naissance, jumeaux, etc.) le moment venu.",
      "negative_subhead": "Ce que vous ressentez en ce moment est légitime. Déception, peine, colère, vide — il n'y a pas de bonne façon de réagir.",
      "resource_care_team_label": "Parlez à votre équipe soignante",
      "resource_care_team_hint": "Elle peut analyser ce cycle et vous aider à envisager la suite.",
      "resource_self_care_label": "Prendre soin de soi",
      "resource_self_care_hint": "Reposez-vous, mangez bien, bougez doucement. Appuyez-vous sur vos proches.",
      "resource_community_label": "Échanger avec d'autres qui comprennent",
      "resource_community_hint": "Des communautés de personnes qui sont passées par là.",
      "done": "Terminé"
    },
    "select_specimens": {
      "title_embryo": "Sélectionner les embryons à transférer",
      "title_oocyte": "Sélectionner les ovocytes à féconder",
      "subtitle_embryo": "Choisissez les embryons à utiliser pour ce transfert.",
      "subtitle_oocyte": "Choisissez les ovocytes congelés que vous allez décongeler et féconder.",
      "starting": "Démarrage…",
      "pick_at_least_one_embryo": "Choisissez au moins un embryon",
      "pick_at_least_one_egg": "Choisissez au moins un ovocyte",
      "confirm": "Confirmer et démarrer",
      "back": "Retour",
      "different_retrieval": "prélèvement différent",
      "reserved_by_open_cycle": "déjà réservé",
      "reserved_notice": "Certains spécimens sont déjà réservés pour un cycle ouvert et ne peuvent pas être sélectionnés ici."
    },
    "protocol_notes": {
      "adjustment_type": {
        "dose_change": "Ajustement de dose",
        "add_medication": "Ajout d'un médicament",
        "remove_medication": "Arrêt d'un médicament",
        "swap_medication": "Changement de médicament",
        "protocol_change": "Changement de protocole",
        "timing_change": "Changement de timing"
      },
      "urgency": {
        "immediate": "Immédiat",
        "next_visit": "Prochaine visite",
        "consider": "À envisager"
      },
      "quality": {
        "excellent": "Excellente réponse",
        "good": "Bonne réponse",
        "moderate": "Réponse modérée",
        "poor": "Réponse faible",
        "over": "Réponse excessive"
      },
      "self_reported": "Auto-déclaré",
      "analyzing": "Analyse du protocole…",
      "empty_state": "Aucun ajustement de protocole pour le moment",
      "add_button": "Ajouter un ajustement",
      "modal_title": "Ajouter un ajustement de protocole",
      "missing_info_title": "Information manquante",
      "missing_info_message": "Merci de remplir les champs requis.",
      "save_error_title": "Erreur",
      "save_error_message": "Enregistrement impossible. Réessaie plus tard.",
      "save_button": "Enregistrer l'ajustement",
      "reason_label": "Raison (optionnel)",
      "reason_placeholder": "ex. Le médecin a ajusté après le monitoring",
      "select_medication_title": "Choisir le médicament",
      "select_medication_subtitle_stop": "Sélectionne celui à arrêter.",
      "select_medication_subtitle_dose": "Sélectionne celui à ajuster.",
      "select_medication_subtitle_swap": "Sélectionne celui à remplacer.",
      "no_active_meds": "Aucun médicament actif pour le moment. Ajoutes-en un d'abord.",
      "swap_replacing_banner": "Remplace ${medication}",
      "confirm_stop_title": "Arrêter ${medication} ?",
      "confirm_stop_message": "${medication} sera marqué comme arrêté aujourd'hui.",
      "confirm_stop_cta": "Arrêter",
      "cancel": "Annuler",
      "stop_reason_label": "Raison (optionnel)",
      "stop_reason_placeholder": "ex. effet secondaire, changement de dose, demande du médecin…",
      "stop_heading": "Arrêter ${medication}",
      "stop_heading_help": "Ajoute une raison si tu veux — elle sera conservée dans tes notes.",
      "swap_step1_heading": "Remplacer ${medication}",
      "swap_step1_help": "Nous allons l'arrêter, puis tu pourras configurer le nouveau médicament.",
      "swap_reason_label": "Raison (optionnel)",
      "swap_reason_placeholder": "ex. effet secondaire, changement de protocole, problème de dose…",
      "swap_continue_cta": "Continuer",
      "note_dose_change_summary": "${oldDose} → ${newDose}",
      "start_medication": "Démarrer ${medication}",
      "stop_medication": "Arrêter ${medication}",
      "ai_swap_current": "Actuel",
      "ai_swap_new": "Nouveau",
      "ai_timing_fallback": "Ajustement du timing",
      "user_fallback": {
        "dose_change": "Ajustement de dose",
        "add_medication": "Ajout d'un médicament",
        "remove_medication": "Arrêt d'un médicament",
        "swap_medication": "Changement de médicament",
        "protocol_change": "Changement de protocole"
      },
      "field": {
        "medication": "Médicament",
        "current_dose": "Dose actuelle",
        "new_dose": "Nouvelle dose",
        "dosage": "Dosage",
        "medication_to_stop": "Médicament à arrêter",
        "current_medication": "Médicament actuel",
        "new_medication": "Nouveau médicament",
        "new_dosage": "Nouveau dosage",
        "description": "Description"
      },
      "placeholder": {
        "medication_gonal": "ex. Gonal-F",
        "current_dose": "ex. 150 UI",
        "new_dose": "ex. 225 UI",
        "medication_cetrotide": "ex. Cetrotide",
        "dosage": "ex. 0,25 mg/jour",
        "medication_menopur": "ex. Menopur",
        "medication_follistim": "ex. Follistim",
        "new_dosage": "ex. 150 UI/jour",
        "description": "ex. Passer en protocole antagoniste"
      }
    },
    "response_chart": {
      "default_title": "Ta réponse",
      "last_label": "Dernier : ${date}",
      "empty_title": "Aucune donnée de monitoring pour le moment",
      "empty_subtitle": "Ajoute ta première mesure pour commencer à suivre ta réponse.",
      "add_data_button": "Ajouter une mesure",
      "axis_day": "Jour",
      "axis_follicles": "Follicules",
      "axis_lining": "Endomètre (mm)",
      "axis_estradiol": "Estradiol (pg/mL)",
      "axis_lh": "LH (mUI/mL)",
      "axis_progesterone": "Progestérone (ng/mL)",
      "trigger_label": "Déclenchement",
      "follicle_avg": "moy. ${size} mm",
      "mode": {
        "e2": "E2",
        "follicles": "Follicules",
        "lining": "Endomètre",
        "lh": "LH",
        "p4": "P4"
      },
      "metric": {
        "estradiol_label": "Estradiol",
        "estradiol_description": "L'estradiol (E2) est l'œstrogène principal produit par les follicules ovariens en croissance. Il augmente à mesure que les follicules mûrissent pendant la stimulation.",
        "estradiol_why": "Une E2 qui monte confirme que tes follicules grandissent et répondent au traitement. Ton médecin s'en sert pour ajuster les doses et déterminer le moment du déclenchement.",
        "estradiol_range": "Pendant la stim, l'E2 monte typiquement d'environ 200 à 300 pg/mL par follicule mature. Au déclenchement, des valeurs de 1 500 à 3 000 pg/mL sont fréquentes.",
        "follicles_label": "Follicules",
        "follicles_description": "Les follicules sont des sacs remplis de liquide dans les ovaires, chacun pouvant contenir un ovocyte. Ils sont comptés et mesurés à l'échographie pendant le monitoring.",
        "follicles_why": "Le nombre et la taille des follicules aident à estimer combien d'ovocytes pourront être ponctionnés. Ton médecin vise plusieurs follicules qui grandissent à un rythme similaire.",
        "follicles_range": "Une bonne réponse correspond généralement à 8–15 follicules. Un follicule est considéré comme mature entre 17 et 22 mm de diamètre.",
        "lining_label": "Endomètre",
        "lining_description": "L'endomètre est le tissu qui tapisse l'intérieur de ton utérus. Sous l'effet de l'œstrogène, il s'épaissit pendant la stimulation.",
        "lining_why": "Un endomètre épais et réceptif est essentiel à une implantation réussie. Un endomètre fin peut parfois être amélioré avec un soutien œstrogénique supplémentaire.",
        "lining_range": "L'idéal pour un transfert est 8–14 mm avec un aspect trilaminaire. Sous 7 mm, une stratégie freeze-all peut être envisagée.",
        "lh_label": "LH",
        "lh_description": "L'hormone lutéinisante (LH) déclenche l'ovulation naturellement. Pendant une FIV, la LH est freinée par un antagoniste pour éviter une ovulation prématurée.",
        "lh_why": "Si la LH grimpe trop tôt, tu peux ovuler avant la ponction. La maintenir basse permet aux ovocytes de rester dans les follicules jusqu'au jour de la ponction.",
        "lh_range": "Sous protocole antagoniste, la LH devrait rester sous 10 mUI/mL. Une montée brutale au-dessus de 10 peut signaler un pic prématuré.",
        "p4_label": "Progestérone",
        "p4_description": "La progestérone (P4) prépare l'endomètre à l'implantation. Pendant la stimulation, elle doit rester basse — une montée prématurée peut indiquer une lutéinisation des follicules avant la ponction.",
        "p4_why": "Ton médecin surveille la P4 à l'approche du déclenchement. Si elle dépasse ~1,5 ng/mL en fin de stim, le timing de la ponction ou le protocole peut être ajusté.",
        "p4_range": "Sous protocole antagoniste, la P4 reste typiquement sous 1,5 ng/mL jusqu'après le déclenchement."
      },
      "context": {
        "on_track": "Tout est en ordre",
        "monitor_closely": "À surveiller de près",
        "rising_well": "En bonne progression",
        "low_adjustment": "Faible — ajustement possible",
        "strong_response": "Réponse soutenue",
        "good_response": "Bonne réponse",
        "moderate_response": "Réponse modérée",
        "low_response": "Réponse faible",
        "optimal_thickness": "Épaisseur optimale",
        "nearly_optimal": "Presque optimal",
        "still_thickening": "S'épaissit encore",
        "thin_monitoring": "Fin — à surveiller",
        "elevated_contact": "Élevé — contacte ta clinique",
        "well_suppressed": "Bien freinée",
        "within_range": "Dans la cible",
        "approaching_threshold": "Approche du seuil"
      }
    },
    "outcome_funnel_card": {
      "embryo_title": "Estimation du parcours embryonnaire",
      "embryo_subtitle": "Une estimation de planification de la ponction à la fécondation, aux blastocystes, au DPI-A éventuel et à la vitrification.",
      "egg_title": "Estimation du parcours de vitrification d'ovocytes",
      "egg_subtitle": "Une estimation de planification de la ponction au contrôle de maturité et à la vitrification.",
      "collapse": "Replier",
      "expand": "Déplier",
      "embryo_a11y": "estimation du parcours embryonnaire",
      "egg_a11y": "estimation du parcours de vitrification d'ovocytes"
    },
    "stim_editor": {
      "empty_cta": "Ajouter une mesure",
      "empty_subtitle": "Suis tes mesures de stimulation ici",
      "table_metric": "Mesure",
      "row": {
        "e2": "E2 (pg/mL)",
        "lh": "LH (mUI/mL)",
        "p4": "P4 (ng/mL)",
        "follicles_right": "Follicules D",
        "follicles_left": "Follicules G",
        "lining": "Endomètre (mm)"
      },
      "edit_cell": {
        "count_label": "Nombre",
        "sizes_label": "Tailles (mm)",
        "count_placeholder": "ex. 5",
        "sizes_placeholder": "ex. 12, 14, 16",
        "sizes_hint": "Optionnel. Sépare les tailles par des virgules.",
        "value_placeholder": "Entrer une valeur",
        "save": "Enregistrer"
      },
      "add_day": {
        "title": "Ajouter une mesure",
        "today": "Aujourd'hui",
        "subtitle": "Entre tes valeurs de monitoring",
        "save_all": "Tout enregistrer",
        "saving": "Enregistrement…"
      },
      "validation": {
        "enter_number": "Entre un nombre.",
        "must_be_zero_or_more": "Doit être 0 ou plus.",
        "must_be_max_or_less": "Doit être ${max} ou moins.",
        "sizes_format": "Entre les tailles en mm séparées par des virgules (ex. 12,14,16).",
        "sizes_zero_or_more": "Les tailles doivent être 0 mm ou plus.",
        "sizes_max": "Chaque taille doit être ${max} mm ou moins."
      },
      "alert": {
        "unable_to_save_title": "Enregistrement impossible",
        "no_cycle": "Aucun cycle actif trouvé.",
        "save_failed_title": "Échec de l'enregistrement",
        "save_failed_message": "Impossible d'enregistrer les données de monitoring. Réessaie."
      }
    },
    "overview": {
      "eyebrow_care": "Soins",
      "eyebrow_current_cycle": "Cycle en cours · ${type}",
      "pre_cycle_title": "Ton espace de suivi",
      "pre_cycle_summary": "Utilise ici le calendrier, les suivis, les rendez-vous et tes documents. Démarre un cycle de traitement uniquement si tu en choisis un.",
      "summary_default": "Retrouve ici tout ce qui concerne ton cycle en cours : médicaments, rendez-vous, examens, documents et actualités de ton équipe soignante.",
      "summary": {
        "egg_freezing": "Retrouve ici tout ton cycle de vitrification d'ovocytes : médicaments, monitoring, timing de la ponction, mises à jour du labo et suivi de la conservation.",
        "sperm_freezing": "Retrouve ici tout ton cycle de vitrification de sperme : timing du recueil, analyses, stockage et étapes de suivi.",
        "iui": "Retrouve ici tout ton cycle d'IIU : médicaments, monitoring, timing de l'insémination et période d'attente.",
        "ivf": "Retrouve ici tout ton cycle de FIV : médicaments, monitoring, ponction, mises à jour du labo, planification du transfert et documents.",
        "icsi": "Retrouve ici tout ton cycle d'ICSI : médicaments, monitoring, ponction, mises à jour du labo, planification du transfert et documents.",
        "fet": "Retrouve ici tout ton transfert : préparation, médicaments, contrôles de l'endomètre, jour du transfert et période d'attente.",
        "embryo_freezing": "Retrouve ici tout ton cycle de vitrification d'embryons : médicaments, monitoring, ponction, fécondation, développement embryonnaire et suivi de la conservation."
      },
      "title_phase_day": "${phase} jour ${day}",
      "header": {
        "cycle_closed_title": "Cycle terminé",
        "pre_treatment_title": "Pré-traitement · jour ${day}",
        "stim_trigger_logged_title": "Trigger fait · planifie ta ponction",
        "stim_trigger_logged_summary": "Habituellement ~36 h après le trigger. Note la date de ta ponction dès que la clinique te la confirme.",
        "stim_monitoring_title": "Stim · suivi ${when}",
        "stim_med_title": "Stim · prochaine injection ${when} à ${time}",
        "stim_generic_title": "Stim · jour ${day}",
        "retrieval_scheduled_title": "Ponction ${when}",
        "retrieval_done_pending_title": "Ponction faite · résultats à venir",
        "fertilization_title": "Fécondation en cours",
        "embryo_dev_title": "Développement embryonnaire · jour ${day}",
        "transfer_scheduled_title": "Transfert ${when}",
        "beta_scheduled_title": "Période d'attente · béta ${when}",
        "beta_pending_title": "Période d'attente · planifie ta béta",
        "result_recorded_title": "Votre résultat est enregistré",
        "unknown_active_title": "Cycle en cours"
      },
      "team": {
        "role_provider": "Soignant·e",
        "label_clinic": "Clinique",
        "clinic_connected": "Clinique connectée à ce cycle.",
        "clinic_add_details": "Ajoute des soignants, l'accès au portail et les instructions du cycle.",
        "section_title": "Ton équipe pour ce cycle"
      },
      "quick_add": {
        "medication": "Médicament",
        "appointment": "Rendez-vous",
        "document": "Document",
        "start_cycle": "Démarrer un cycle"
      },
      "menu": {
        "view_cycle_details": "Voir les détails du cycle",
        "view_past_cycles": "Voir les cycles passés",
        "cycle_documents": "Documents du cycle",
        "end_cycle": "Terminer le cycle",
        "start_cycle": "Démarrer un cycle",
        "documents": "Documents"
      },
      "alerts": {
        "choose_treatment_title": "Choisis un type de traitement",
        "choose_treatment_message": "Merci de sélectionner un type de traitement supporté avant de démarrer un cycle.",
        "unable_to_start_title": "Impossible de démarrer le cycle",
        "unable_to_start_message": "Quelque chose s'est mal passé. Réessaie.",
        "reserve_specimens_failed_title": "Cycle démarré, échantillons non liés",
        "reserve_specimens_failed_message": "Ton cycle a bien été créé, mais nous n'avons pas pu y associer les échantillons congelés sélectionnés. Appuie à nouveau sur Démarrer le cycle pour réessayer ; ta sélection est toujours là.",
        "frozen_specimen_consent_required_title": "Confirmation requise",
        "frozen_specimen_consent_required_message": "Confirme que tu as l'autorité et le consentement requis pour réserver les fiches CryoVault sélectionnées avant de démarrer ce cycle.",
        "frozen_selection_mismatch_title": "Choisis le traitement correspondant",
        "frozen_selection_mismatch_message": "Les embryons congelés peuvent être liés à un transfert d'embryon congelé, les ovocytes à une FIV ou une ICSI, et le sperme congelé à une IIU, une FIV ou une ICSI. Ta sélection congelée est toujours là."
      },
      "calendar": {
        "markers": {
          "meds": "Médicaments",
          "appointment": "Rendez-vous",
          "test": "Examen",
          "period": "Règles",
          "fertileWindow": "Fenêtre de fertilité"
        },
        "prediction": {
          "title": "Estimation de la fenêtre de fertilité",
          "insufficient_title": "Fenêtre de fertilité indisponible",
          "insufficient_body": "Enregistre au moins deux débuts de règles pour obtenir une estimation personnalisée.",
          "dismiss_a11y": "Masquer l'avis de fenêtre de fertilité",
          "confidence": "Niveau de confiance : ${level}.",
          "confidence_levels": {
            "low": "faible",
            "medium": "moyen",
            "high": "élevé"
          },
          "cycle": "Cycle",
          "logged": "Enregistré",
          "peak_fertility": "Pic de fertilité",
          "fertile_window": "Fenêtre de fertilité",
          "predicted": "Prévu",
          "peak": "Pic",
          "fertile": "Fertile",
          "warnings": {
            "limited_history": "Cette estimation repose sur un historique limité et s'améliorera à mesure que tu enregistreras tes cycles.",
            "irregular_history": "Ton historique de cycles semble irrégulier : l'estimation est donc plus large et moins certaine."
          },
          "disclaimer": "Ces dates sont des estimations, pas une méthode contraceptive ni un avis médical."
        },
        "log_tabs": {
          "symptoms": "Symptômes",
          "monitoring": "Suivi",
          "schedule": "Traitements"
        },
        "check_in": {
          "saved": "Enregistré",
          "future_date": "Cette date est dans le futur, tu ne peux pas encore y enregistrer de symptômes.",
          "choose": "Choisis",
          "today": "aujourd'hui",
          "or_past_day": "ou un jour passé.",
          "select_today_a11y": "Sélectionner aujourd'hui",
          "bleeding_title": "Saignements",
          "notes_title": "Notes",
          "notes_placeholder": "Tout ce qui te traverse l'esprit aujourd'hui…",
          "view_all": "Voir tous les symptômes",
          "view_fewer": "Voir moins",
          "view_all_a11y": "Voir tous les symptômes",
          "view_fewer_a11y": "Voir moins de symptômes",
          "log_symptoms_a11y": "Enregistrer mes symptômes",
          "log_button": "Ajouter",
          "save_failed": "Nous n’avons pas pu enregistrer ton suivi. Tes réponses sont toujours là. Réessaie.",
          "selected_day_loading": "Chargement du suivi de cette journée…",
          "selected_day_unavailable_title": "Nous n’avons pas pu charger le suivi de cette journée",
          "selected_day_unavailable_body": "Tes dossiers enregistrés sont en sécurité. Réessaie avant d’ajouter ou de modifier des symptômes."
        },
        "nav": {
          "previous_week_a11y": "Semaine précédente",
          "previous_month_a11y": "Mois précédent",
          "next_week_a11y": "Semaine suivante",
          "next_month_a11y": "Mois suivant",
          "show_week_view_a11y": "Afficher la vue semaine",
          "show_month_view_a11y": "Afficher la vue mois"
        },
        "empty": {
          "title": "Rien de prévu pour le ${date} ${monthName}.",
          "subtitle": "Ajoute un rendez-vous, un médicament, un test ou tes règles depuis les actions rapides ci-dessus."
        },
        "no_selected_day": {
          "title": "Sélectionne un jour pour le consulter.",
          "body": "Choisis un jour dans le calendrier pour voir tes médicaments, tes rendez-vous et les détails du suivi."
        },
        "summary": {
          "title": "Symptômes enregistrés",
          "no_symptoms": "Aucun symptôme enregistré",
          "symptom_one": "${count} symptôme",
          "symptom_other": "${count} symptômes",
          "notes_added": "notes ajoutées"
        },
        "monitoring_log": {
          "action_label": "enregistrer les résultats du monitoring",
          "add_result": "Ajouter un résultat de monitoring",
          "future_date": "Cette date est dans le futur, tu ne peux pas encore ${action}.",
          "read_loading": "Chargement des données de monitoring…",
          "read_unavailable_title": "Nous n’avons pas pu charger les données de monitoring",
          "read_unavailable_body": "Tes résultats de monitoring enregistrés sont en sécurité. Réessaie avant d’ajouter ou de modifier des résultats.",
          "subtitle": "Consulte la dernière visite, puis note ce qui a changé à cette date.",
          "field": {
            "follicles_label": "Follicules",
            "follicles_value": "Ajouter un nombre",
            "lead_size_label": "Follicule dominant",
            "lead_size_value": "Ajouter en mm",
            "lining_label": "Endomètre",
            "lining_value": "Ajouter en mm",
            "estradiol_label": "Estradiol",
            "estradiol_value": "Ajouter pg/mL",
            "lh_label": "LH",
            "lh_value": "Optionnel",
            "progesterone_label": "Progestérone",
            "progesterone_value": "Optionnel"
          },
          "modal": {
            "title": "Ajouter un résultat de monitoring",
            "subtitle": "Regroupe l'échographie et les analyses sanguines d'une même visite.",
            "date_label": "Monitoring du ${date}",
            "date_input_label": "Date du monitoring",
            "date_required": "Ajoute la date du monitoring avant d'enregistrer.",
            "date_future": "Choisis aujourd'hui ou une date antérieure.",
            "needs_one_value": "Ajoute au moins une valeur de monitoring avant d'enregistrer.",
            "save_failed_keep_draft": "Impossible d'enregistrer ces résultats de monitoring. Tes saisies sont conservées — réessaie d'enregistrer.",
            "date_detail": "Un résultat distinct sera enregistré pour cette date du calendrier.",
            "previous_title": "Monitoring précédent",
            "previous_detail": "Utilise-le comme repère. Seules les valeurs saisies ci-dessous seront enregistrées pour cette date.",
            "import_title": "Ajouter depuis un document",
            "import_detail": "Ajoute une ou plusieurs images ou PDF pour préremplir ces champs.",
            "import_action": "Téléverser",
            "import_notice": "Les valeurs extraites ont été ajoutées ci-dessous. Vérifie-les avant d'enregistrer ce monitoring.",
            "ultrasound_title": "Échographie",
            "ultrasound_detail": "Saisis les mesures folliculaires lorsqu'elles sont disponibles ; les nombres et le follicule dominant sont calculés.",
            "left_follicles": "Follicules de l'ovaire gauche",
            "right_follicles": "Follicules de l'ovaire droit",
            "derived_count_left": "Nombre à gauche",
            "derived_count_right": "Nombre à droite",
            "derived_lead": "Follicule dominant",
            "fallback_count_left": "Nombre de follicules à gauche",
            "fallback_count_right": "Nombre de follicules à droite",
            "count_placeholder": "Optionnel",
            "lining_placeholder": "ex. 8,5",
            "blood_title": "Analyses sanguines",
            "blood_detail": "Ajoute les valeurs présentes sur le même compte rendu de monitoring.",
            "estradiol_label": "Estradiol (E2)",
            "lh_label": "LH",
            "fsh_label": "FSH",
            "progesterone_label": "Progestérone",
            "lining_label": "Épaisseur de l'endomètre",
            "notes_label": "Notes ou consignes",
            "notes_placeholder": "Ce que tu veux retenir…",
            "cancel": "Annuler",
            "save": "Enregistrer",
            "left": "Gauche",
            "right": "Droite",
            "input_placeholder": "Ajouter une valeur",
            "input_placeholder_with_unit": "Ajouter en ${unit}",
            "sizes_placeholder": "ex. 12, 14, 16",
            "cell_edit": {
              "subtitle": "${date} · Modifie uniquement ce détail du monitoring.",
              "follicles_title": "Follicules",
              "left_ovary": "Ovaire gauche",
              "right_ovary": "Ovaire droit",
              "lining_title": "Endomètre",
              "lining_label": "Épaisseur de l'endomètre",
              "estradiol_title": "Estradiol",
              "estradiol_label": "Estradiol (E2)",
              "lh_title": "LH",
              "lh_label": "LH",
              "progesterone_title": "Progestérone",
              "progesterone_label": "Progestérone",
              "value_placeholder": "Ajouter une valeur",
              "value_required": "Ajoute une valeur avant d'enregistrer.",
              "save_error": "Nous n'avons pas pu enregistrer cette valeur de monitoring. Réessaie.",
              "cancel": "Annuler",
              "save": "Enregistrer"
            }
          }
        },
        "schedule_log": {
          "subtitle": "Ajoute ou consulte les médicaments et rendez-vous liés à cette date.",
          "add_medication": "Ajouter un médicament",
          "add_visit": "Ajouter une visite",
          "empty": "Rien n'est prévu à cette date pour le moment.",
          "read_loading": "Chargement des médicaments et des rendez-vous…",
          "read_unavailable_title": "Nous n'avons pas pu charger les médicaments et les rendez-vous",
          "read_unavailable_body": "Ton planning enregistré est toujours en sécurité. Vérifie ta connexion et réessaie.",
          "read_stale_body": "Certains médicaments ou rendez-vous sont peut-être obsolètes. Réessaie pour les actualiser.",
          "read_medication_log_stale_body": "Nous n'avons pas pu charger le statut de prise de tes médicaments. Tes doses planifiées sont toujours affichées, mais leur statut peut être obsolète. Réessaie pour actualiser le statut."
        },
        "overlay": {
          "cancel": "Annuler",
          "save": "Enregistrer"
        }
      },
      "symptoms": {
        "bleeding": {
          "none": "Aucun",
          "spotting": "Pertes légères",
          "light_bleeding": "Saignements légers",
          "medium_bleeding": "Saignements modérés",
          "heavy_bleeding": "Saignements abondants",
          "clots": "Caillots"
        },
        "category": {
          "worth_flagging": "À surveiller",
          "digestion": "Digestion",
          "sexual_reproductive": "Sexualité et fonction reproductive",
          "urogenital": "Urogénital",
          "psychological": "Psychologique",
          "body_skin": "Corps et peau"
        },
        "item": {
          "injection_site_sore": "Site d'injection douloureux",
          "headache": "Mal de tête",
          "cramping": "Crampes",
          "dizziness": "Vertiges",
          "palpitations": "Palpitations",
          "shortness_of_breath": "Essoufflement",
          "chest_tightness": "Oppression thoracique",
          "fever": "Fièvre",
          "chills": "Frissons",
          "vomiting": "Vomissements",
          "bloated": "Ballonné·e",
          "nauseous": "Nausées",
          "constipation": "Constipation",
          "diarrhea": "Diarrhée",
          "cravings": "Fringales",
          "indigestion": "Indigestion",
          "appetite_changes": "Changements d'appétit",
          "high_libido": "Libido élevée",
          "low_libido": "Libido basse",
          "ovulation_pain": "Douleur d'ovulation",
          "breast_tenderness": "Seins sensibles",
          "frequent_urination": "Mictions fréquentes",
          "burning": "Brûlures",
          "incontinence": "Incontinence",
          "moody": "Humeur changeante",
          "anxious": "Anxieux·se",
          "irritable": "Irritable",
          "tired": "Fatigué·e",
          "insomnia": "Insomnie",
          "good_energy": "Bonne énergie",
          "feeling_okay": "Je vais bien",
          "fatigue": "Fatigue",
          "body_aches": "Courbatures",
          "hot_flashes": "Bouffées de chaleur",
          "acne": "Acné",
          "dry_skin": "Peau sèche",
          "hair_loss": "Chute de cheveux"
        }
      },
      "guides": {
        "early_pregnancy_title": "Guide début de grossesse",
        "early_pregnancy_subtitle": "Les analyses de contrôle, la première échographie, les symptômes qui méritent un appel et comment se confirme la datation.",
        "egg_freezing_title": "Guide vitrification d'ovocytes",
        "egg_freezing_subtitle": "Timing des médicaments, visites de monitoring, préparation de la ponction et ce que veulent dire les mises à jour du labo.",
        "ivf_title": "Guide FIV",
        "ivf_subtitle": "Stimulation, ponction, fécondation, développement embryonnaire, planification du transfert et mises à jour du labo.",
        "embryo_freezing_title": "Guide vitrification d'embryons",
        "embryo_freezing_subtitle": "Ponction, fécondation, croissance embryonnaire, vitrification, stockage et timing des rapports.",
        "transfer_title": "Guide transfert",
        "transfer_subtitle": "Contrôles de l'endomètre, timing des médicaments, jour du transfert et période d'attente.",
        "iui_title": "Guide IIU",
        "iui_subtitle": "Timing des médicaments, monitoring, déclenchement, insémination et période d'attente.",
        "sperm_freezing_title": "Guide vitrification de sperme",
        "sperm_freezing_subtitle": "Analyses, timing du recueil, enregistrements de stockage et tâches de suivi.",
        "fallback_title": "Guide de soins",
        "fallback_subtitle": "Bases du traitement, examens, références des médicaments, procédures et documents."
      },
      "conditions": {
        "pcos": "SOPK",
        "endometriosis": "Endométriose",
        "fibroids": "Fibromes",
        "low_ovarian_reserve": "Réserve ovarienne basse",
        "early_menopause": "Ménopause précoce",
        "varicocele": "Varicocèle",
        "klinefelter": "Syndrome de Klinefelter",
        "y_microdeletion": "Microdélétion du chromosome Y",
        "undescended_testicles": "Testicules non descendus",
        "genital_tract_obstruction": "Obstruction des voies génitales",
        "retrograde_ejaculation": "Éjaculation rétrograde",
        "erectile_dysfunction": "Troubles de l'érection",
        "thyroid": "Thyroïde",
        "modal": {
          "condition_a11y": "Je n'ai pas de pathologie à ajouter",
          "condition_none": "Rien à ajouter",
          "condition_none_suggestions_a11y": "Masquer ces suggestions de pathologies",
          "condition_none_suggestions": "Aucune de ces suggestions",
          "condition_add": "Ajouter une pathologie",
          "specimen_a11y": "Je n'ai pas de spécimens congelés à ajouter",
          "specimen_none": "Rien à ajouter",
          "specimen_add_a11y": "Ajouter des spécimens congelés",
          "specimen_type_eggs": "Ovocytes",
          "specimen_type_embryos": "Embryons",
          "specimen_type_sperm": "Sperme",
          "specimen_type_facility": "Centre",
          "specimen_type_reports": "Rapports"
        },
        "section_title": "Pathologies et diagnostics",
        "section_subtitle": "Pathologies, diagnostics et antécédents chirurgicaux pouvant affecter les traitements et la prise en charge.",
        "add_a11y": "Ajouter une pathologie ou un diagnostic",
        "add_short": "Ajouter",
        "empty_title": "Des pathologies ou diagnostics à signaler ?",
        "empty_subtitle": "Ajoute ce qui te concerne, ou masque ces suggestions si aucune ne s'applique.",
        "suggestions_hidden_title": "Suggestions de pathologies masquées",
        "suggestions_hidden_subtitle": "Cela masque seulement ces suggestions rapides. Ton historique médical complet n'est pas marqué comme terminé.",
        "restore_suggestions": "Afficher les suggestions",
        "restore_suggestions_a11y": "Afficher à nouveau les suggestions de pathologies"
      },
      "screen_title": "Soins",
      "testing_actions": {
        "order_title": "Commander ou planifier des analyses",
        "order_subtitle": "Analyses à domicile, en centre ou en laboratoire selon tes besoins.",
        "learn_title": "Comprendre chaque analyse",
        "learn_subtitle": "Valeurs normales, timing, préparation et pourquoi les résultats varient."
      },
      "testing": {
        "title": "Analyses",
        "all_tests": "Toutes les analyses",
        "lab_results_title": "Résultats d'analyses",
        "upload_results_title": "Importer mes résultats",
        "lab_results_subtitle_one": "${count} résultat enregistré dans tes dossiers.",
        "lab_results_subtitle_other": "${count} résultats enregistrés dans tes dossiers.",
        "upload_results_subtitle": "Ajoute tes comptes rendus d'analyses, échographies et autres résultats au fur et à mesure.",
        "upload_lab_results_title": "Importer mes résultats d'analyses"
      },
      "good_to_know": {
        "title": "Bon à savoir",
        "tests_markers_title": "Analyses et marqueurs",
        "tests_markers_subtitle": "Valeurs normales, timing, préparation et pourquoi les résultats varient."
      },
      "pharmacy": {
        "section_title": "Pharmacie",
        "medication_guide_title": "Guide des médicaments",
        "medication_guide_subtitle": "Fiches pratiques, effets indésirables, conseils de prise et interactions médicamenteuses.",
        "inventory_title": "Stock de médicaments",
        "inventory_subtitle": "Stock physique disponible pour ce cycle.",
        "session_only_note": "L'inventaire reste sur cet appareil pour le moment — il n'est pas enregistré dans ton compte et se réinitialise au redémarrage de l'app.",
        "inventory_on_hand_badge": "${count} en stock",
        "add_stock": "Ajouter du stock",
        "open_guide": "Ouvrir le guide",
        "contact_pharmacy": "Contacter la pharmacie",
        "edit_inventory": "Modifier le stock",
        "inventory_dialog_cancel": "Annuler",
        "inventory_dialog_save": "Enregistrer",
        "inventory_dialog_title": "Modifier le stock",
        "inventory_dialog_subtitle": "Ce stock recense uniquement ce que tu as en main. Ce n'est ni une prescription ni un schéma de prise.",
        "in_this_shipment": "Dans cette livraison",
        "decrease_a11y": "Diminuer ${name}",
        "increase_a11y": "Augmenter ${name}",
        "hide_a11y": "Masquer ${title}",
        "expand_a11y": "Déplier ${title}",
        "collapse_a11y": "Replier ${title}",
        "confirmed_status_label": "En stock",
        "confirmed_timing_delivery": "Confirmé en stock",
        "confirmed_timing_pickup": "Récupéré à l'instant",
        "confirmed_estimated_delivery": "Médicaments confirmés en stock",
        "confirmed_estimated_pickup": "Retrait confirmé",
        "confirmed_detail": "Marqué comme en stock. Garde ces médicaments à portée pour quand la clinique met à jour ton plan.",
        "confirmation_done": "Médicaments en stock",
        "confirmation_default": "Je les ai"
      },
      "lab_cryo": {
        "lab_and_cryo_heading": "Laboratoire et cryoconservation",
        "add_lab_report": "Ajouter un rapport",
        "laboratory_activity_title": "Au laboratoire",
        "laboratory_activity_subtitle": "Le parcours de tes ovocytes lors de ce cycle.",
        "view_my_cycle": "Voir mon cycle",
        "funnel_retrieved": "Ovocytes prélevés",
        "funnel_mature": "Matures",
        "funnel_injected": "Injectés (ICSI)",
        "funnel_fertilized": "Fécondés",
        "funnel_day3": "Embryons J3",
        "funnel_blastocysts": "Blastocystes",
        "funnel_transferred": "Transférés",
        "funnel_frozen_embryos": "Embryons congelés",
        "funnel_frozen_eggs": "Ovocytes congelés",
        "funnel_detail_share": "${share}% des ovocytes prélevés",
        "funnel_detail_recorded": "Enregistré",
        "report_saved_one": "${count} résultat enregistré dans tes dossiers.",
        "report_saved_other": "${count} résultats enregistrés dans tes dossiers.",
        "report_add_subtitle": "Ajoute les comptes rendus de ponction, les vérifications de maturité, les confirmations de congélation et les enregistrements de conservation.",
        "report_status_saved": "Enregistré",
        "report_status_add": "Ajouter"
      },
      "medical_context": {
        "section_title": "Contexte médical"
      },
      "cycle_handoff": {
        "title": "Ton cycle est terminé ?",
        "subtitle": "Termine ce cycle dès que tu en connais l'issue. Tout ton historique est conservé.",
        "end_cycle_a11y": "Terminer le cycle",
        "end_cycle_button": "Terminer le cycle"
      },
      "past_cycles": {
        "title_one": "${count} cycle passé",
        "title_other": "${count} cycles passés",
        "subtitle": "Anciens cycles d'IIU, traitements médicamenteux, FIV, transferts, ponctions et vitrifications.",
        "add_a11y": "Ajouter un traitement antérieur",
        "add_short": "Ajouter"
      }
    },
    "records": {
      "section_title": "Documents",
      "view_all": "Tout voir",
      "import_title": "Importer mes documents",
      "import_subtitle": "Récupérer tes documents auprès des cliniques et hôpitaux",
      "category": {
        "medical_title": "Dossier médical",
        "medical_subtitle": "Analyses et comptes-rendus",
        "coverage_title": "Assurance et couverture",
        "coverage_subtitle": "Cartes et autorisations",
        "legal_title": "Formulaires et accords",
        "legal_subtitle": "Consentements et documents signés",
        "admin_title": "Factures et paiements",
        "admin_subtitle": "Factures, reçus et demandes"
      }
    },
    "stim_monitoring_section": {
      "stimulation_monitoring": "Monitoring de stimulation",
      "endometrial_monitoring": "Suivi de l'endomètre",
      "view_chart": "Graphique",
      "view_table": "Tableau",
      "show_view_a11y": "Afficher la vue ${label}",
      "add_monitoring_a11y": "Ajouter une mesure",
      "monitoring_recorded": "Suivi enregistré",
      "decision_recorded": "Décision enregistrée",
      "not_proceeding": "Ne pas poursuivre"
    },
    "stim_response_chart": {
      "empty_title": "Pas encore assez de données",
      "empty_subtitle": "Ajoutez quelques journées de suivi pour voir la croissance folliculaire et l'estradiol ensemble.",
      "legend_mature": "Matures ≥17",
      "legend_maturing": "En maturation 14-16",
      "legend_size": "Taille des follicules",
      "legend_e2": "Estradiol",
      "legend_lining": "Endomètre",
      "threshold_mature": "17 mm",
      "threshold_maturing": "14 mm",
      "axis_size": "Follicule mm",
      "axis_follicles_and_lining_mm": "Follicules · Endomètre (mm)",
      "axis_lining_mm": "Endomètre mm",
      "axis_days": "Jour",
      "trigger": "Déclenchement"
    },
    "stim_sheet_view": {
      "no_monitoring_logged": "Pas encore de suivi enregistré",
      "monitoring_empty_prompt": "Ajoutez un résultat de suivi depuis un compte rendu de clinique ou saisissez-le vous-même.",
      "row_meds": "Traitements",
      "row_e2": "E2 (pg/mL)",
      "row_lh": "LH (mUI/mL)",
      "row_p4": "P4 (ng/mL)",
      "row_lining": "Endomètre (mm)",
      "row_follicles": "Follicules",
      "follicle_larger_summary": "Max. ${lead} mm · ${larger} ≥17 mm",
      "trigger_label": "Déclenchement",
      "medication_fallback": "Traitement",
      "more_meds": "+${count} de plus",
      "outcome_title": "Résultat du cycle",
      "outcome_subtitle": "Issu de ce cycle de stimulation",
      "outcome_retrieved": "Ovocytes recueillis",
      "outcome_mature": "Matures (M2)",
      "outcome_fertilized": "Fécondés",
      "outcome_blastocysts": "Blastocystes",
      "outcome_frozen": "Congelés"
    },
    "clinic_team": {
      "rei_label": "Méd. repro.",
      "rei_description": "Médecin de la reproduction",
      "clinic_label": "Clinique",
      "clinic_connected": "Clinique connectée à ce cycle.",
      "clinic_add_details": "Ajoute des soignants, l'accès au portail et les instructions du cycle."
    },
    "guidance": {
      "status_done": "Terminé",
      "status_skipped": "Sauté",
      "status_current": "En cours",
      "a11y_expand_step": "Déplier ${step}",
      "a11y_collapse_step": "Replier ${step}",
      "cards": {
        "how_it_works": "Comment ça marche",
        "what_to_expect": "À quoi t'attendre",
        "how_to_prepare": "Comment te préparer",
        "when_to_call": "Quand contacter ta clinique"
      },
      "step": {
        "sperm_collection": {
          "description": "Recueil de sperme pour la fécondation",
          "how_it_works": "Un échantillon de sperme est recueilli puis préparé par le laboratoire pour la fécondation ou l'insémination. Le timing est coordonné avec la ponction d'ovocytes ou l'insémination.",
          "what_to_expect": [
            "Recueil à la clinique, ou apporté depuis la maison si prévu à l'avance",
            "Le labo lave et prépare l'échantillon",
            "Les résultats sont en général disponibles le jour même"
          ],
          "prep_instructions": [
            "Suis les consignes d'abstinence de ta clinique",
            "Évite l'alcool, les bains chauds et le sport intense les jours précédents",
            "Reste bien hydraté"
          ]
        },
        "freezing_sperm": {
          "description": "Nombre de paillettes congelées et remise pour stockage",
          "how_it_works": "Après l'analyse de l'échantillon, le labo le divise en paillettes ou vials, les congèle et enregistre combien sont disponibles pour un usage futur. Les détails de stockage peuvent ensuite être rattachés au Coffre de cryopréservation.",
          "what_to_expect": [
            "Nombre final de paillettes ou vials",
            "Date de congélation et centre de stockage",
            "Notes du labo issues du compte rendu de congélation",
            "Identifiants des échantillons ou étiquettes de stockage si la clinique les fournit"
          ],
          "prep_instructions": [
            "Téléverse l'analyse de sperme ou le compte rendu de congélation si tu l'as",
            "Confirme le centre de stockage et le forfait annuel",
            "Note les identifiants ou étiquettes des paillettes dès qu'ils sont disponibles"
          ],
          "when_to_call": [
            "Le nombre de paillettes ne correspond pas à ton compte rendu",
            "Il manque le lieu de stockage ou les identifiants des échantillons",
            "Tu dois transférer le stockage vers un autre centre"
          ]
        },
        "freezing_embryo": {
          "description": "Embryons congelés et stockés issus de ce cycle",
          "how_it_works": "L'équipe d'embryologie suit la fécondation et le développement embryonnaire, puis congèle les embryons qui peuvent être stockés. Ce résultat résume ce qui a atteint la congélation et quels documents doivent être rattachés.",
          "what_to_expect": [
            "Nombres de fécondation et de développement embryonnaire",
            "Embryons congelés, souvent avec le jour et les détails de grade",
            "Statut de biopsie DPI si un test génétique a été réalisé",
            "Lieu de stockage et identifiants des embryons"
          ],
          "prep_instructions": [
            "Téléverse le compte rendu d'embryologie ou de congélation",
            "Confirme les grades des embryons et les dates de congélation",
            "Ajoute les détails de stockage dans le Coffre de cryopréservation quand ils sont disponibles"
          ],
          "when_to_call": [
            "Le nombre ou le grade des embryons n'est pas clair",
            "Il te manque le compte rendu de congélation",
            "Les détails de stockage ou de test génétique ne correspondent pas à tes documents"
          ]
        },
        "freezing_eggs": {
          "description": "Ovocytes matures, ovocytes congelés et notes du labo",
          "how_it_works": "Après la ponction, le labo vérifie quels ovocytes sont assez matures pour être congelés et confirme combien sont stockés. Ce résultat résume l'issue du cycle plutôt que la ponction elle-même.",
          "what_to_expect": [
            "Nombre total d'ovocytes ponctionnés et d'ovocytes matures",
            "Nombre d'ovocytes congelés",
            "Notes éventuelles sur la qualité des ovocytes ou du labo",
            "Détails de stockage à rattacher au Coffre de cryopréservation"
          ],
          "prep_instructions": [
            "Téléverse le compte rendu de ponction ou d'embryologie si tu l'as",
            "Confirme les nombres d'ovocytes matures et congelés",
            "Ajoute le lieu de stockage et les identifiants de paillettes ou vials"
          ],
          "when_to_call": [
            "Les chiffres ne correspondent pas à ce que la clinique t'a dit",
            "Il te manque le compte rendu du labo ou du stockage",
            "Tu as des douleurs croissantes, des ballonnements, de la fièvre ou des saignements abondants après la ponction"
          ]
        },
        "fertilization_embryo": {
          "description": "Fécondation, croissance embryonnaire et issue des embryons congelés",
          "how_it_works": "Après la ponction, les ovocytes sont fécondés au labo et suivis pendant le développement embryonnaire. Cette étape capture l'issue du labo : combien ont été fécondés, combien ont atteint un stade utilisable, quels embryons ont été congelés, et quels documents doivent être rattachés.",
          "what_to_expect": [
            "Méthode de fécondation et ovocytes normalement fécondés",
            "Mises à jour du développement embryonnaire jusqu'au jour 5 ou 6",
            "Grades embryonnaires et statut DPI si un test a été réalisé",
            "Embryons congelés avec date de congélation et détails de stockage"
          ],
          "prep_instructions": [
            "Téléverse le compte rendu d'embryologie ou de congélation si tu l'as",
            "Confirme les grades des embryons, dates de congélation et identifiants d'échantillon",
            "Ajoute les détails du lieu de stockage dans le Coffre de cryopréservation quand ils sont disponibles"
          ],
          "when_to_call": [
            "Le nombre ou le grade des embryons ne correspond pas à ton compte rendu",
            "Le statut DPI ou de biopsie n'est pas clair",
            "Il te manque les détails de stockage ou de confirmation de congélation"
          ]
        },
        "fertilization_icsi": {
          "description": "Résultats de fécondation ICSI du labo",
          "how_it_works": "Pour l'ICSI, l'équipe d'embryologie injecte un seul spermatozoïde dans chaque ovocyte mature et vérifie le lendemain la fécondation normale. Cette étape enregistre le résultat du labo, pas la ponction.",
          "what_to_expect": [
            "Nombre d'ovocytes matures injectés",
            "Ovocytes normalement fécondés, souvent appelés 2PN",
            "Notes du labo sur la qualité des ovocytes ou du sperme",
            "Prochaine mise à jour sur le développement embryonnaire"
          ],
          "prep_instructions": [
            "Téléverse le compte rendu de fécondation ou d'embryologie",
            "Confirme les nombres d'ovocytes injectés et normalement fécondés",
            "Garde la source du sperme et les notes du labo rattachées au cycle"
          ],
          "when_to_call": [
            "Le nombre de fécondations manque ou n'est pas clair",
            "La clinique mentionne une fécondation anormale",
            "Tu as besoin d'aide pour interpréter le compte rendu du labo"
          ]
        },
        "fertilization_ivf": {
          "description": "Résultats de fécondation du labo",
          "how_it_works": "Après la ponction, les ovocytes matures sont mis en contact avec les spermatozoïdes et vérifiés le lendemain pour une fécondation normale. Cette étape enregistre ce qui s'est passé au labo avant que le développement embryonnaire ne se poursuive.",
          "what_to_expect": [
            "Nombre d'ovocytes normalement fécondés",
            "Méthode de fécondation si FIV ou ICSI a été utilisée",
            "Notes éventuelles du labo sur la qualité des ovocytes ou du sperme",
            "Prochaine mise à jour sur le développement embryonnaire"
          ],
          "prep_instructions": [
            "Téléverse le compte rendu de fécondation ou d'embryologie",
            "Confirme le nombre d'ovocytes normalement fécondés",
            "Garde la source du sperme et les notes du labo rattachées au cycle"
          ],
          "when_to_call": [
            "Le nombre de fécondations manque ou n'est pas clair",
            "La clinique mentionne une fécondation anormale",
            "Tu as besoin d'aide pour interpréter le compte rendu du labo"
          ]
        },
        "embryo_development": {
          "description": "Croissance embryonnaire, grading, tests et décisions de congélation",
          "how_it_works": "Après la fécondation, les embryons sont suivis jusqu'au stade blastocyste. Cette étape capture l'issue de cette fenêtre de labo : grades embryonnaires, décisions de test, plans de transfert et embryons éventuellement congelés.",
          "what_to_expect": [
            "Mises à jour du jour 3 ou du jour 5/6",
            "Nombre de blastocystes et grades embryonnaires",
            "Statut de biopsie ou de test DPI si utilisé",
            "Quels embryons ont été transférés, congelés ou en attente"
          ],
          "prep_instructions": [
            "Téléverse le compte rendu d'embryologie, DPI ou de congélation",
            "Confirme les grades des embryons et le jour de développement",
            "Ajoute les détails de congélation et de stockage pour les embryons conservés"
          ],
          "when_to_call": [
            "Le nombre de blastocystes ou les grades ne sont pas clairs",
            "Il te manque un compte rendu DPI ou embryologique",
            "Des décisions de transfert ou de congélation ont changé et doivent être documentées"
          ]
        },
        "transfer_fet": {
          "description": "Détails du transfert d'embryon congelé et plan de test",
          "how_it_works": "Pour un TEC, un embryon congelé est décongelé et transféré une fois que l'endomètre et le timing de la progestérone sont prêts. Cette étape capture les détails du transfert et le plan du test de grossesse qui suit.",
          "what_to_expect": [
            "Confirmation de la décongélation et du transfert de l'embryon",
            "Identité de l'embryon, grade et statut DPI si connus",
            "Date du transfert et timing de la progestérone",
            "Date du test bêta hCG après le transfert"
          ],
          "prep_instructions": [
            "Confirme les instructions de décongélation et de transfert de l'embryon",
            "Continue à prendre œstrogène et progestérone comme indiqué",
            "Téléverse la note de transfert ou le compte rendu d'embryon si tu l'as"
          ],
          "when_to_call": [
            "Tu oublies la progestérone ou tu la prends au mauvais moment",
            "Tu as des saignements abondants avant ou après le transfert",
            "L'identité de l'embryon ou le compte rendu de transfert n'est pas clair"
          ]
        },
        "transfer_ivf": {
          "description": "Détails du transfert d'embryon et ce qui suit",
          "how_it_works": "Si un transfert a lieu dans ce cycle, la clinique place l'embryon sélectionné dans l'utérus et fixe la date du prochain test de grossesse. Cette étape relie l'embryon sélectionné, la note de transfert et le plan de suivi.",
          "what_to_expect": [
            "Embryon transféré et date du transfert",
            "Grade de l'embryon ou statut DPI si connu",
            "Consignes médicamenteuses après le transfert",
            "Date du test bêta hCG après la période d'attente"
          ],
          "prep_instructions": [
            "Téléverse la note de transfert si tu l'as",
            "Confirme l'embryon sélectionné pour le transfert",
            "Note le timing du test bêta et les consignes des médicaments de soutien"
          ],
          "when_to_call": [
            "Tu oublies une dose de médicament de soutien",
            "Tu as des saignements abondants, des douleurs sévères ou de la fièvre",
            "Les détails du transfert ne correspondent pas au compte rendu"
          ]
        },
        "analysis": {
          "description": "Résultats du spermogramme avant congélation",
          "how_it_works": "Le labo mesure le volume de l'échantillon, la concentration en spermatozoïdes, le nombre total, la mobilité et la morphologie. Ces valeurs aident à expliquer la quantité d'échantillon utilisable avant la congélation.",
          "what_to_expect": [
            "Concentration, nombre total, mobilité, morphologie et volume",
            "Un compte rendu du labo ou de la clinique",
            "Notes sur la qualité ou la préparation de l'échantillon"
          ],
          "prep_instructions": [
            "Téléverse le spermogramme si tu l'as",
            "Saisis les valeurs clés du compte rendu",
            "Garde l'analyse rattachée à l'issue de congélation"
          ],
          "when_to_call": [
            "Un résultat manque ou est difficile à interpréter",
            "L'échantillon n'a pas pu être congelé",
            "Ta clinique recommande de refaire les tests"
          ]
        },
        "screening": {
          "description": "Bilan obligatoire avant le stockage",
          "how_it_works": "Beaucoup de cliniques exigent un dépistage des maladies infectieuses, et parfois un dépistage génétique, avant qu'un échantillon puisse être stocké ou utilisé plus tard. Cette étape garde ces résultats rattachés au cycle.",
          "what_to_expect": [
            "Résultats du bilan IST ou maladies infectieuses",
            "Résultats éventuels d'un dépistage génétique",
            "Documents à partager avec le labo de stockage"
          ],
          "prep_instructions": [
            "Téléverse les comptes rendus de dépistage quand ils sont disponibles",
            "Vérifie si un résultat nécessite un suivi",
            "Garde les dates et documents rattachés à ce cycle"
          ],
          "when_to_call": [
            "Il manque un compte rendu de dépistage requis",
            "Un résultat a besoin d'être clarifié",
            "Ta clinique ne libérera pas l'échantillon sans tests complémentaires"
          ]
        },
        "insemination": {
          "description": "Acte et timing de l'IIU",
          "how_it_works": "Pendant une IIU, un échantillon de sperme préparé est placé directement dans l'utérus autour de l'ovulation. Cette étape capture le timing de l'acte, les notes et les détails associés.",
          "what_to_expect": [
            "Un acte rapide en cabinet",
            "Des crampes légères ou des spottings peuvent survenir après",
            "Le timing est en général coordonné avec l'ovulation ou le déclenchement"
          ],
          "prep_instructions": [
            "Confirme l'horaire de l'acte et la logistique de l'échantillon",
            "Suis les consignes de la clinique pour le timing du déclenchement",
            "Demande quand tester ou commencer le soutien lutéal"
          ],
          "when_to_call": [
            "Tu développes des douleurs sévères, de la fièvre ou des saignements abondants",
            "Tu n'es pas sûr du timing après le déclenchement",
            "Tu rates ou tu dois reprogrammer le rendez-vous"
          ]
        },
        "protocol_fet": {
          "description": "Préparation de l'endomètre avant le transfert d'embryon",
          "how_it_works": "Pour un transfert d'embryon congelé, des médicaments sont utilisés pour préparer l'endomètre. L'œstrogène aide en général à construire la muqueuse, et la progestérone est calée avant le transfert.",
          "what_to_expect": [
            "Œstrogène en comprimés, patchs ou injections selon le protocole",
            "Contrôles de l'endomètre par échographie",
            "Progestérone démarrée avant le transfert",
            "Timing du transfert basé sur la maturité de l'endomètre et l'âge de l'embryon"
          ],
          "prep_instructions": [
            "Confirme la livraison des médicaments et le calendrier des doses",
            "Suis les rendez-vous de contrôle de l'endomètre",
            "Enregistre les consignes de timing du transfert et de la progestérone"
          ],
          "when_to_call": [
            "Tu oublies une dose ou tu la prends au mauvais moment",
            "Tu as des saignements abondants avant le transfert",
            "Tu n'es pas sûr du moment où commencer la progestérone"
          ]
        },
        "protocol_oi": {
          "description": "Médicaments et timing de la stimulation simple de l'ovulation",
          "how_it_works": "La stimulation simple de l'ovulation utilise des médicaments pour soutenir la croissance folliculaire et l'ovulation. Le monitoring et le déclenchement aident à définir la meilleure fenêtre pour les rapports ou l'insémination.",
          "what_to_expect": [
            "Médicaments oraux ou injectables selon ton plan",
            "Monitoring échographique ou biologique si prescrit",
            "Déclenchement ou fenêtre de rapports programmés"
          ],
          "prep_instructions": [
            "Suis les dates de début et de fin des médicaments",
            "Enregistre les consignes de timing de la clinique",
            "Confirme quand tester ou commencer un médicament de soutien"
          ],
          "when_to_call": [
            "Tu oublies une dose de médicament",
            "Tu as des douleurs sévères ou des saignements abondants",
            "Tu n'es pas sûr des consignes de déclenchement ou de timing"
          ]
        },
        "luteal_ivf": {
          "description": "Médicaments de soutien après le transfert",
          "how_it_works": "Après le transfert, les médicaments de soutien continuent. Cette étape garde les consignes médicamenteuses et tes notes de symptômes rattachées au cycle.",
          "what_to_expect": [
            "Progestérone ou autre médicament de soutien",
            "Des symptômes qui peuvent se confondre avec les effets des médicaments"
          ],
          "prep_instructions": [
            "Continue à prendre le soutien exactement comme prescrit",
            "Note les symptômes ou saignements dans le calendrier"
          ],
          "when_to_call": [
            "Tu oublies la progestérone ou une autre dose de soutien",
            "Tu as des saignements abondants, des douleurs sévères ou de la fièvre"
          ]
        },
        "luteal_iui": {
          "description": "Soutien après l'ovulation ou l'insémination",
          "how_it_works": "Après l'ovulation ou l'insémination, ta clinique peut prescrire de la progestérone ou un autre soutien. Cette étape garde ces médicaments et tes notes de symptômes ensemble.",
          "what_to_expect": [
            "Progestérone ou autre médicament de soutien possible",
            "Des symptômes qui peuvent se confondre avec les effets secondaires des médicaments"
          ],
          "prep_instructions": [
            "Continue à prendre le soutien exactement comme prescrit",
            "Note les symptômes ou saignements dans le calendrier"
          ],
          "when_to_call": [
            "Tu as des saignements abondants ou des douleurs sévères",
            "Tu oublies le médicament de soutien"
          ]
        },
        "outcome_iui": {
          "description": "En attente de ton test de grossesse",
          "how_it_works": "Après l'insémination ou l'ovulation, tu attends la fenêtre de test fixée par ta clinique. Tester trop tôt est la première cause de résultat trompeur.",
          "what_to_expect": [
            "Une date de test de grossesse définie",
            "De légères crampes ou des saignements légers, qui ne disent rien de l'issue",
            "Des hauts et des bas émotionnels — cette période est difficile pour la plupart des gens"
          ],
          "prep_instructions": [
            "Confirme la date à laquelle ta clinique veut que tu testes",
            "Attends cette date plutôt que de tester en avance",
            "Appuie-toi sur tes proches pendant l'attente"
          ],
          "when_to_call": [
            "Tu obtiens un test positif avant la prise de sang programmée",
            "Tu as des saignements abondants ou des douleurs sévères",
            "Tu as besoin d'aide pour décider quoi faire d'un résultat"
          ]
        }
      }
    }
  },
  "add_medication": {
    "step_title_add": "Ajouter un médicament",
    "step_title_edit": "Modifier le médicament",
    "step_title_search": "Rechercher un médicament",
    "step_title_configure": "Configurer",
    "step_title_review": "Vérifier",
    "trigger_step_title_add": "Ajouter le déclencheur",
    "trigger_step_title_search": "Rechercher le médicament de déclenchement",
    "trigger_step_title_configure": "Configurer le déclencheur",
    "trigger_step_title_review": "Vérifier l'horaire du déclencheur",
    "entry_intro": "Comment veux-tu ajouter ton médicament ?",
    "trigger_entry_intro": "Ajoute le déclencheur exactement comme prescrit. L'heure d'injection est critique, car le prélèvement ou l'insémination est planifié à partir de celle-ci.",
    "entry_search_by_name": "Rechercher par nom",
    "entry_search_by_name_help": "Saisis le nom du médicament",
    "entry_scan_prescription": "Scanner l'ordonnance",
    "entry_scan_prescription_help": "Importe une photo pour pré-remplir les détails",
    "entry_reading_prescription": "Lecture de l'ordonnance...",
    "scanned_document_name": "Ordonnance",
    "alert_ocr_no_meds_title": "Aucun médicament détecté",
    "alert_ocr_no_meds_message": "Impossible d'extraire des médicaments de cette image. Essaie une photo plus nette ou remplis le formulaire à la main.",
    "alert_file_document_failed_title": "Impossible d'enregistrer le document",
    "alert_file_document_failed_message": "Ton médicament a été enregistré, mais le document scanné n'a pas pu être ajouté à ton dossier.",
    "ocr_queue_progress": "Médicament ${current} sur ${total}",
    "ocr_queue_help": "Valide ce médicament pour l'ajouter au calendrier, puis on passera au suivant.",
    "quick_add": "Ajout rapide",
    "search_intro": "Recherche ton médicament",
    "trigger_search_intro": "Recherche le médicament de déclenchement prescrit par ta clinique.",
    "search_placeholder": "ex. Gonal-F, Letrozole...",
    "trigger_search_placeholder": "ex. Ovidrel, Pregnyl, Novarel, Lupron...",
    "search_loading": "Recherche en cours...",
    "search_no_match": "Aucun résultat — appuie sur Suivant pour saisir manuellement",
    "trigger_search_no_match": "Aucune correspondance exacte — appuie sur Suivant pour utiliser ce nom de déclencheur",
    "next": "Suivant",
    "back": "Retour",
    "medication_name": "Nom du médicament",
    "is_trigger_shot": "C'est un déclencheur d'ovulation",
    "trigger_context_title": "L'horaire du déclencheur est important",
    "trigger_context_body": "Saisis la date et l'heure exactes indiquées par ta clinique. Le prélèvement ou l'insémination est généralement planifié à partir de cette injection.",
    "dosage": "Dosage",
    "dosage_placeholder": "ex. 150",
    "dosage_unit_default": "unité",
    "route": "Voie d'administration",
    "delivery_method": "Méthode d'administration",
    "start_date": "Date de début",
    "duration": "Durée",
    "custom": "Personnalisée",
    "custom_duration_placeholder": "ex. 5",
    "duration_unit_days": "jours",
    "duration_unit_weeks": "semaines",
    "duration_unit_months": "mois",
    "time_of_day": "Moment de la journée",
    "custom_time_placeholder": "HH:MM (ex. 22:30)",
    "add": "Ajouter",
    "as_needed": "Si besoin",
    "notes_optional": "Notes (optionnel)",
    "notes_placeholder": "Notes supplémentaires...",
    "link_to_cycle": "Lier au cycle en cours",
    "review": "Vérifier",
    "review_intro": "Vérifie les détails de ton médicament",
    "trigger_review_intro": "Confirme le médicament, la dose et l'heure exacte du déclencheur avant d'enregistrer.",
    "edit_details": "Modifier les détails",
    "save_add_different_dose": "Enregistrer et ajouter une autre dose",
    "save_add_different_dose_help": "Même médicament, dose ou dates différentes",
    "submit_add": "Ajouter le médicament",
    "submit_add_trigger": "Ajouter le déclencheur",
    "inventory": {
      "step_title_add": "Ajouter au stock",
      "step_title_configure": "Détails du stock",
      "step_title_review": "Vérifier le stock",
      "stock_on_hand_label": "Stock disponible",
      "stock_on_hand_helper": "Cela correspond à la quantité que tu as en stock. Aucun plan de prise n'est créé, sauf si tu en ajoutes un ci-dessous.",
      "toggle_add_schedule": "Ajouter un plan de prise",
      "toggle_hide_schedule": "Masquer le plan de prise",
      "toggle_schedule_helper": "Active cette option pour créer aussi un plan de prise pour ce médicament.",
      "submit_add_only": "Ajouter au stock",
      "submit_add_with_schedule": "Ajouter au stock et au calendrier"
    },
    "submit_edit": "Enregistrer",
    "submitting_add": "Ajout...",
    "submitting_edit": "Enregistrement...",
    "summary_role": "Rôle",
    "summary_role_trigger_shot": "Déclencheur",
    "summary_dosage": "Dosage",
    "summary_route": "Voie",
    "summary_delivery_method": "Méthode",
    "summary_start_date": "Date de début",
    "summary_duration": "Durée",
    "summary_end_date": "Date de fin",
    "summary_schedule": "Horaire",
    "summary_notes": "Notes",
    "summary_linked_to_cycle": "Lié au cycle",
    "summary_yes": "Oui",
    "alert_ocr_failed_title": "Échec de la lecture",
    "alert_ocr_failed_message": "Impossible de lire l'ordonnance. Saisis les détails manuellement.",
    "alert_permission_title": "Autorisation requise",
    "alert_permission_message": "Autorise l'accès à ta photothèque pour scanner des ordonnances.",
    "alert_update_failed_title": "Échec de la mise à jour",
    "alert_update_failed_message": "Impossible d'enregistrer les modifications.",
    "alert_trigger_phase_failed_title": "Date de déclenchement non enregistrée",
    "alert_trigger_phase_failed_message": "Le médicament a été enregistré, mais la date de déclenchement n'a pas pu être ajoutée à ton cycle. Tu peux la définir depuis l'étape de déclenchement du cycle.",
    "dose_error_invalid": "Saisis la dose sous forme de nombre, par ex. 150 ou 0,5.",
    "dose_error_not_positive": "La dose doit être supérieure à zéro.",
    "dose_error_too_large": "Cette dose semble trop élevée — vérifie la quantité.",
    "historical_date_error_title": "Date hors du cycle",
    "historical_date_error_message": "Pour un cycle passé, les dates du médicament doivent rester dans ce cycle.",
    "time_preset": {
      "morning": "Matin",
      "afternoon": "Après-midi",
      "evening": "Soir",
      "night": "Nuit"
    },
    "dose_unit": {
      "units": "unités",
      "pills": "comprimés",
      "tablets": "comprimés",
      "capsules": "gélules",
      "drops": "gouttes",
      "patches": "patchs"
    },
    "route_option": {
      "oral": "Orale",
      "subcutaneous": "Sous-cutanée",
      "intramuscular": "Intramusculaire",
      "vaginal": "Vaginale",
      "topical": "Topique",
      "patch": "Patch",
      "not_specified": "Non renseignée"
    },
    "delivery_method_option": {
      "pre_filled_syringe": "Seringue pré-remplie",
      "pre_filled_pen": "Stylo injecteur",
      "injection_solution": "Flacon + seringue",
      "lyophilized_powder": "Poudre + solvant",
      "multi_vial": "Multi-flacons"
    },
    "duration_preset": {
      "once": "Une fois",
      "7_days": "7 jours",
      "10_days": "10 jours",
      "14_days": "14 jours",
      "3_weeks": "3 semaines",
      "1_month": "1 mois",
      "3_months": "3 mois",
      "ongoing": "En continu"
    }
  },
  "add_appointment": {
    "title_new": "Nouveau rendez-vous",
    "title_details": "Détails",
    "title_edit": "Modifier le rendez-vous",
    "title_review": "Vérifier",
    "go_back": "Retour",
    "close": "Fermer",
    "next": "Suivant",
    "type_intro": "Quel type de rendez-vous ?",
    "error_invalid_date": "Choisissez une date de rendez-vous valide.",
    "error_invalid_time": "Choisissez une heure pour le rendez-vous.",
    "error_end_before_start": "L'heure de fin doit être après l'heure de début.",
    "error_invalid_title": "Donnez un titre à ce rendez-vous.",
    "entry_scan_letter": "Scanner une convocation",
    "entry_scan_letter_help": "Importez une photo pour pré-remplir le rendez-vous",
    "entry_reading_letter": "Lecture de la convocation...",
    "scanned_document_name": "Convocation",
    "alert_ocr_failed_title": "Lecture impossible",
    "alert_ocr_failed_message": "Impossible de lire la convocation. Essayez une photo plus nette ou remplissez le formulaire à la main.",
    "alert_permission_title": "Accès aux photos requis",
    "alert_permission_message": "Autorisez l'accès aux photos pour scanner une convocation.",
    "alert_file_document_failed_title": "Impossible d'enregistrer le document",
    "alert_file_document_failed_message": "Votre rendez-vous a été enregistré, mais le document scanné n'a pas pu être ajouté à votre dossier.",
    "no_results": "Aucun résultat",
    "exam_label": "Examen",
    "procedure_label": "Procédure",
    "what_exam_placeholder": "Quel examen ?",
    "what_procedure_placeholder": "Quelle procédure ?",
    "continue": "Continuer",
    "title_label": "Titre",
    "title_placeholder": "Titre du rendez-vous",
    "activity_remove_accessibility": "Retirer ${activity}",
    "date_label": "Date",
    "time_label": "Heure",
    "time_placeholder": "HH:MM",
    "duration_label": "Durée",
    "duration_hint": "1 h est sélectionnée par défaut. Modifiez-la si nécessaire.",
    "duration_minutes_value": "${count} min",
    "duration_hours_value": "${count} h",
    "duration_custom": "Personnalisée",
    "duration_default_badge": "Par défaut",
    "duration_default_accessibility": "${value}, durée par défaut",
    "duration_custom_accessibility": "Durée personnalisée en minutes",
    "duration_custom_placeholder": "ex. 120",
    "end_preview": "Fin : ${value}",
    "end_value_next_day": "${date} à ${time}",
    "error_invalid_duration": "Saisissez une durée en minutes supérieure à zéro.",
    "location_label": "Lieu / Salle",
    "location_placeholder": "ex. Salle 204, Bâtiment A",
    "format_label": "Format",
    "format_in_person": "En présentiel",
    "format_online": "En ligne",
    "meeting_link_label": "Lien de la visio",
    "meeting_link_placeholder": "https://...",
    "notes_optional": "Notes (optionnel)",
    "notes_placeholder": "Notes supplémentaires...",
    "review_button": "Vérifier",
    "review_intro": "Vérifiez votre rendez-vous",
    "review_hint": "Confirmez les détails ci-dessous",
    "summary_title": "Titre",
    "summary_type": "Type",
    "summary_date": "Date",
    "summary_time": "Heure",
    "summary_duration": "Durée",
    "summary_ends": "Fin",
    "summary_location": "Lieu",
    "summary_format": "Format",
    "summary_meeting_link": "Lien visio",
    "summary_notes": "Notes",
    "submit_add": "Enregistrer",
    "submit_edit": "Enregistrer les modifications",
    "submitting_add": "Enregistrement...",
    "submitting_edit": "Enregistrement...",
    "error_save_failed": "Échec de l'enregistrement",
    "type": {
      "exam": "Examen",
      "procedure": "Procédure",
      "consult": "Consultation",
      "counseling": "Soutien psychologique"
    },
    "activity_section": {
      "common": "Activités courantes"
    },
    "activity": {
      "item": {
        "consultation": "Consultation",
        "blood_tests": "Analyses sanguines",
        "ultrasound": "Échographie",
        "counseling": "Soutien psychologique"
      }
    },
    "exam_section": {
      "blood_lab": "Biologie",
      "imaging": "Imagerie",
      "genetic": "Génétique",
      "item": {
        "beta_hcg": "Bêta hCG",
        "hormonal_testing": "Bilan hormonal",
        "std_testing": "Dépistage des IST",
        "thyroid_testing": "Bilan thyroïdien",
        "urinalysis": "Analyse d'urine",
        "semen_analysis": "Spermogramme",
        "swab_test": "Prélèvement vaginal",
        "pap_smear": "Frottis cervico-utérin",
        "transabdominal_ultrasound": "Échographie sus-pubienne",
        "transvaginal_ultrasound": "Échographie endovaginale",
        "doppler_ultrasound": "Échographie Doppler",
        "hysterosonography": "Hystérosonographie",
        "hsg": "Hystérosalpingographie (HSG)",
        "antral_follicle_count": "Compte des follicules antraux",
        "pelvic_mri": "IRM pelvienne",
        "karyotyping": "Caryotype",
        "carrier_testing": "Test de portage génétique",
        "exome_sequencing": "Séquençage de l'exome ou du génome"
      }
    },
    "procedure_section": {
      "retrieval": "Ponction",
      "transfer": "Transfert",
      "surgical": "Chirurgie",
      "item": {
        "egg_retrieval": "Ponction ovocytaire",
        "sperm_collection": "Recueil de sperme",
        "surgical_sperm_retrieval": "Prélèvement chirurgical de spermatozoïdes",
        "embryo_transfer": "Transfert d'embryon",
        "laparoscopy": "Cœlioscopie",
        "hysteroscopy": "Hystéroscopie",
        "endometrial_biopsy": "Biopsie endométriale (ERA)",
        "testicular_biopsy": "Biopsie testiculaire"
      }
    }
  },
  "procedure_detail": {
    "your_appointment": "Votre rendez-vous",
    "section_how_it_works": "Comment ça se passe",
    "section_part_of": "Fait partie de",
    "section_how_to_prepare": "Comment se préparer",
    "section_what_to_expect": "À quoi s'attendre",
    "section_results": "Résultats",
    "section_pain_and_comfort": "Douleur et confort",
    "section_sample_purpose": "À quoi sert cet échantillon",
    "section_tests_using_sample": "Analyses pouvant utiliser cet échantillon",
    "tests_using_sample_description": "La biopsie prélève l’échantillon ; ces catégories de tests canoniques décrivent ce à quoi il peut servir.",
    "section_risks": "Risques",
    "section_evidence": "Sources scientifiques",
    "sample_endometrial_tissue": "Tissu endométrial",
    "anesthesia_none": "Aucune",
    "recovery_label": "Récupération",
    "tab_procedure": "Procédure",
    "tab_procedure_short": "Étapes",
    "recovery_prefix": "Récupération : ${value}",
    "delete_confirm": "Supprimer ce rendez-vous ?",
    "confirm": "Confirmer",
    "disclaimer": "Les protocoles peuvent varier selon votre centre. Suivez toujours les recommandations spécifiques de votre équipe médicale."
  },
  "appointment_note": {
    "title": "Ajouter une note ?",
    "body": "Quelque chose à retenir pour ce rendez-vous ?",
    "placeholder": "ex. Le médecin a dit que les follicules ont une bonne taille…",
    "save": "Enregistrer",
    "skip": "Passer",
    "cancel": "Annuler"
  },
  "appointment_detail": {
    "row_date": "Date",
    "row_time": "Heure",
    "row_duration": "Durée",
    "row_ends": "Fin",
    "row_location": "Lieu",
    "row_format": "Format",
    "row_notes": "Notes",
    "appointment_notes": "Notes du rendez-vous",
    "completion_title": "Notes après le rendez-vous",
    "documents_title": "Documents",
    "documents_upload": "Importer un document",
    "completion_edit": "Modifier les notes",
    "completion_save": "Enregistrer",
    "completion_cancel": "Annuler",
    "completion_input_label": "Vos notes après le rendez-vous",
    "completion_save_error": "Nous n’avons pas pu enregistrer vos notes. Réessayez.",
    "completion_loading": "Chargement de vos notes après le rendez-vous…",
    "completion_unavailable": "Vos notes après le rendez-vous sont temporairement indisponibles.",
    "edit": "Modifier",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "confirm_delete": "Supprimer le rendez-vous",
    "deleting": "Suppression...",
    "delete_title": "Supprimer ce rendez-vous ?",
    "delete_confirm": "Voulez-vous vraiment supprimer « ${title} » ? Cette action est définitive et ne peut pas être annulée.",
    "delete_error": "Nous n’avons pas pu supprimer ce rendez-vous. Il est toujours là — réessayez.",
    "delete_retry": "Réessayer",
    "learn_more": "En savoir plus sur ce rendez-vous",
    "learn_about_activity": "En savoir plus sur ${activity}"
  },
  "medication_log": {
    "status_taken": "Pris",
    "status_late": "En retard",
    "status_missed": "Manqué"
  },
  "medication_factsheet": {
    "missing_med_id": "ID de médicament manquant — impossible d'arrêter depuis cette vue.",
    "stop_med_error": "Échec de l'arrêt du médicament",
    "delete_med_error": "Échec de la suppression du médicament",
    "partner_both": "Les deux partenaires",
    "partner_her": "Elle",
    "partner_him": "Lui",
    "section_purpose": "Objectif",
    "section_how_to_take": "Comment prendre",
    "section_good_to_know": "Bon à savoir",
    "badge_keep_refrigerated": "À conserver au réfrigérateur",
    "section_side_effects": "Effets secondaires",
    "side_effects_log_hint": "Touchez un symptôme pour voir les détails. Utilisez + pour l'enregistrer aujourd'hui.",
    "symptom_detail_severity": "Sévérité",
    "symptom_detail_normal": "Ce qui peut être normal",
    "symptom_detail_dangerous": "Quand cela peut être dangereux",
    "symptom_detail_call_doctor": "Quand appeler votre médecin",
    "symptom_detail_notes_label": "Ajouter des détails au journal du jour",
    "symptom_detail_notes_placeholder": "Quand est-ce arrivé ? À quelle fréquence ? Quelle intensité ? Qu'est-ce qui a aidé ?",
    "symptom_detail_log_button": "Je ressens ou j'ai ressenti ce symptôme",
    "symptom_detail_update_log": "Mettre à jour le symptôme du jour",
    "section_interacts_with": "Interactions",
    "section_injection_technique": "Technique d'injection",
    "section_subcutaneous": "Injection sous-cutanée",
    "section_intramuscular": "Injection intramusculaire",
    "subq_step_1": "Lavez-vous soigneusement les mains. Désinfectez le site d'injection avec une compresse alcoolisée.",
    "subq_step_2": "Pincez un pli de peau sur le bas de l'abdomen (à environ 5 cm du nombril). Alternez les côtés chaque jour.",
    "subq_step_3": "Insérez l'aiguille à un angle de 45 à 90° d'un mouvement régulier.",
    "subq_step_4": "Injectez le médicament lentement et régulièrement.",
    "subq_step_5": "Relâchez le pli cutané et retirez l'aiguille. Appliquez une légère pression — sans frotter.",
    "subq_step_6": "Alternez les sites d'injection pour limiter les ecchymoses et l'inconfort.",
    "im_body": "Les injections intramusculaires se font dans le quadrant supéro-externe de la fesse. Beaucoup de patientes se font aider par leur partenaire ou un proche. Votre centre peut vous montrer la technique lors du premier rendez-vous de monitoring.",
    "guide_title": "Guide d'injection",
    "guide_intro": "Instructions pas à pas pour chaque type d'injection de votre protocole.",
    "guide_steps_heading": "Étapes",
    "guide_tips_heading": "Conseils",
    "guide_subq_title": "Sous-cutanée (ventre)",
    "guide_subq_subtitle": "Gonal-F, Menopur, Cetrotide, Ovitrelle",
    "guide_subq_step_1": "Lavez-vous soigneusement les mains à l'eau et au savon.",
    "guide_subq_step_2": "Désinfectez le site d'injection à l'aide d'une compresse alcoolisée : à environ 5 cm autour du nombril, en alternant les côtés.",
    "guide_subq_step_3": "Pincez un pli de peau entre le pouce et l'index.",
    "guide_subq_step_4": "Insérez l'aiguille à 90° (ou à 45° si vous êtes très mince).",
    "guide_subq_step_5": "Appuyez sur le piston lentement et régulièrement.",
    "guide_subq_step_6": "Retirez l'aiguille, relâchez le pli cutané et appliquez une légère pression.",
    "guide_subq_tip_1": "Appliquez un peu de froid sur la zone 1 à 2 minutes avant pour limiter la sensation de piqûre.",
    "guide_subq_tip_2": "Alternez les sites d'injection pour limiter les ecchymoses.",
    "guide_subq_tip_3": "Sortez le médicament du réfrigérateur 5 à 10 minutes avant l'injection.",
    "guide_subq_tip_4": "Ne frottez pas le site d'injection après.",
    "guide_im_title": "Intramusculaire (cuisse/fesse)",
    "guide_im_subtitle": "Progestérone huileuse, certains déclencheurs",
    "guide_im_step_1": "Lavez-vous soigneusement les mains.",
    "guide_im_step_2": "Désinfectez le quadrant supéro-externe de la fesse ou la face externe de la cuisse avec une compresse alcoolisée.",
    "guide_im_step_3": "Tendez la peau (ne pincez pas).",
    "guide_im_step_4": "Insérez l'aiguille à 90° d'un geste rapide et ferme.",
    "guide_im_step_5": "Aspirez brièvement : si du sang apparaît, retirez et choisissez un autre site.",
    "guide_im_step_6": "Injectez lentement sur 5 à 10 secondes.",
    "guide_im_step_7": "Retirez l'aiguille et appliquez une pression avec une compresse.",
    "guide_im_tip_1": "Réchauffez le flacon entre vos mains ou sous l'eau tiède pendant 2 minutes.",
    "guide_im_tip_2": "Utilisez l'aiguille la plus large que vous tolérez pour l'injection (l'aiguille de prélèvement est généralement plus grosse).",
    "guide_im_tip_3": "Massez doucement la zone après pour faciliter l'absorption.",
    "guide_im_tip_4": "Une compresse tiède après l'injection peut soulager la sensibilité.",
    "injection_tips_heading": "Conseils pour limiter la douleur et les ecchymoses",
    "injection_tip_im_help": "Beaucoup de personnes se font aider par leur partenaire ou un soignant pour les injections intramusculaires. Demandez à votre centre de vous montrer la technique lors du premier rendez-vous.",
    "section_storage": "Conservation",
    "section_available_as": "Présentations",
    "section_videos": "Vidéos explicatives",
    "interaction_taking": "En cours",
    "interaction_severity_note": "Note",
    "interaction_severity_caution": "Attention",
    "interaction_severity_critical": "Critique",
    "section_official_resources": "Ressources officielles",
    "official_resource_ansm_label": "Fiche officielle ANSM/BDPM — ${brand}",
    "section_evidence": "Sources",
    "section_your_history": "Vos antécédents",
    "section_prescription": "Ordonnance",
    "section_actions": "Actions",
    "stopped_badge": "Arrêté",
    "you_are_taking": "Vous prenez ce médicament",
    "you_have_taken": "Vous avez déjà pris ce médicament",
    "you_stopped_taking": "Vous avez arrêté ce médicament",
    "context_status_current": "En cours",
    "context_status_previous": "Déjà pris",
    "context_status_stopped": "Arrêté",
    "context_since": "Depuis le ${date}",
    "context_ends_on": "Se termine le ${date}",
    "context_ended_on": "Terminé le ${date}",
    "context_stopped_on": "Arrêté le ${date}",
    "stopped_banner_title": "Médicament arrêté",
    "stopped_banner_since": "Arrêté depuis le ${date}",
    "stopped_banner_reason": "Raison de l'arrêt : ${reason}",
    "context_show_details": "Afficher les détails",
    "context_hide_details": "Masquer les détails",
    "context_edit_medication": "Modifier le médicament",
    "your_medication_fallback": "Votre médicament",
    "row_your_medication": "Médicament",
    "row_dosage": "Dosage",
    "row_route": "Voie",
    "row_delivery_method": "Méthode",
    "row_schedule": "Horaire",
    "row_start_date": "Date de début",
    "row_end_date": "Date de fin",
    "row_duration": "Durée",
    "row_type": "Type",
    "row_since": "Depuis",
    "row_notes": "Notes",
    "row_doses_logged": "Prises enregistrées",
    "row_prescriber": "Prescripteur",
    "row_pharmacy": "Pharmacie",
    "row_rx_number": "Numéro d'ordonnance",
    "row_quantity": "Quantité",
    "row_prescribed": "Prescrit le",
    "row_refills_remaining": "Renouvellements restants",
    "refills_none": "Aucun — contactez votre centre",
    "action_edit": "Modifier",
    "action_edit_help": "Changer le dosage, l'horaire ou les notes",
    "action_log_dose": "Noter la prise du jour",
    "action_log_dose_help": "Indiquer si la dose a été prise, retardée, oubliée ou passée",
    "action_refill": "Demander un renouvellement",
    "action_refill_help": "Envoyer à ${pharmacy}",
    "provider_owned_title": "Géré par ton équipe de soins",
    "provider_owned_note": "Ce médicament fait partie de ton plan prescrit. Parles-en à ta clinique pour tout changement — tu peux toujours enregistrer tes prises.",
    "action_stop": "Arrêter le médicament",
    "action_stop_help": "Indiquer la raison et marquer comme arrêté",
    "action_delete": "Supprimer le médicament",
    "action_delete_help": "Supprimer définitivement",
    "delete_mistake_action": "J'ai créé ce médicament par erreur",
    "stop_form_title": "Pourquoi arrêtez-vous ?",
    "stop_form_help": "Cela marque ${name} comme arrêté aujourd'hui. La raison est enregistrée avec les notes du médicament.",
    "stop_form_placeholder": "ex. effets secondaires, avis médical, traitement terminé",
    "stop_form_cancel": "Annuler",
    "stop_form_submit": "Arrêter le médicament",
    "stop_form_submitting": "Arrêt...",
    "delete_modal_title": "Supprimer ${name} ?",
    "delete_modal_message": "Cela supprime définitivement le médicament et son historique. Cette action est irréversible.",
    "delete_modal_cancel": "Annuler",
    "delete_modal_confirm": "Supprimer",
    "delete_modal_deleting": "Suppression...",
    "minimal_no_details": "Aucun détail supplémentaire enregistré pour ce médicament.",
    "minimal_no_factsheet": "Fiche détaillée bientôt disponible. Vous pouvez tout de même modifier ou arrêter ce médicament ci-dessous.",
    "minimal_stop_title": "Arrêter ce médicament ?",
    "minimal_stop_help": "Il sera marqué comme arrêté aujourd'hui. Vous pourrez toujours le rajouter plus tard.",
    "minimal_stop_placeholder": "Pourquoi arrêtez-vous ? (optionnel)",
    "minimal_delete_title": "Supprimer ${name} ?",
    "minimal_delete_help": "Cela supprimera le médicament de votre suivi. Cette action est irréversible.",
    "disclaimer": "Suivez toujours les instructions spécifiques de votre centre. Ces informations sont fournies à titre indicatif uniquement.",
    "schedule_as_needed": "Au besoin",
    "schedule_morning": "Matin",
    "schedule_afternoon": "Après-midi",
    "schedule_evening": "Soir",
    "schedule_night": "Nuit",
    "schedule_daily_template": "${count}× par jour — ${labels}",
    "duration_ongoing": "En cours",
    "duration_1_day": "1 jour",
    "duration_n_days": "${n} jours",
    "duration_1_week": "1 semaine",
    "duration_n_weeks": "${n} semaines",
    "duration_1_month": "1 mois",
    "duration_n_months": "${n} mois",
    "route_subcutaneous": "Sous-cutanée",
    "route_intramuscular": "Intramusculaire",
    "route_oral": "Orale",
    "route_vaginal": "Vaginale",
    "route_topical": "Topique",
    "route_nasal": "Nasale",
    "route_sublingual": "Sublinguale",
    "route_transdermal": "Transdermique",
    "route_rectal": "Rectale",
    "route_intravenous": "Intraveineuse",
    "molecule_androgen_supplement": "Supplément d'androgènes",
    "molecule_antithyroid_agent": "Antithyroïdien",
    "molecule_biguanide": "Biguanide",
    "molecule_clomiphene_citrate": "Citrate de clomifène",
    "molecule_corticosteroid": "Corticoïde",
    "molecule_dopamine_agonist": "Agoniste dopaminergique",
    "molecule_estrogen": "Œstrogène",
    "molecule_gnrh_agonist": "Agoniste GnRH",
    "molecule_gnrh_antagonist": "Antagoniste GnRH",
    "molecule_gonadotropin": "Gonadotrophine",
    "molecule_hcg": "hCG",
    "molecule_letrozole": "Létrozole",
    "molecule_macrolide_antibiotic": "Antibiotique macrolide",
    "molecule_nsaid": "AINS",
    "molecule_progestogen": "Progestatif",
    "molecule_tamoxifen": "Tamoxifène",
    "molecule_tetracycline_antibiotic": "Antibiotique tétracycline",
    "molecule_thyroid_hormone": "Hormone thyroïdienne",
    "molecule_folate_supplement": "Supplément de folates",
    "molecule_unknown": "Inconnu",
    "delivery_pre_filled_syringe": "Seringue préremplie",
    "delivery_pre_filled_pen": "Stylo injecteur",
    "delivery_injection_solution": "Flacon + seringue",
    "delivery_lyophilized_powder": "Poudre + diluant",
    "delivery_multi_vial": "Multi-flacons"
  },
  "date_picker": {
    "placeholder": "Date",
    "today": "Aujourd'hui"
  },
  "time_picker": {
    "placeholder": "Sélectionnez l'heure",
    "header": "Saisir l'heure",
    "input_placeholder_en": "ex. 9:30 AM",
    "input_placeholder_fr": "ex. 09:30",
    "now": "MAINT.",
    "invalid_format_en": "Format invalide. Utilisez \"9:30 AM\" ou \"2:15 PM\"",
    "invalid_format_fr": "Format invalide. Utilisez \"09:30\" ou \"14:15\""
  },
  "journey": {
    "pregnancy_exploring": {
      "description": "Vous n'avez pas encore choisi de parcours de traitement. Nous garderons vos options ouvertes pendant que vous vous informez et décidez avec votre équipe soignante.",
      "learn_title": "Explorez vos options",
      "learn_subtitle": "Choisissez un parcours avec votre équipe soignante"
    },
    "ivf_with_partner": {
      "description": "Fécondation in vitro avec votre partenaire",
      "learn_title": "Comprendre la FIV",
      "learn_subtitle": "Le traitement de fertilité le plus efficace",
      "test_title": "Bilan de fertilité pour vous deux",
      "test_subtitle": "Examen complet de fertilité",
      "clinic_title": "Choisir votre centre d'AMP",
      "clinic_subtitle": "Les taux de réussite comptent particulièrement en FIV",
      "prep_title": "Préparer votre cycle",
      "prep_subtitle": "Dossier administratif et décisions préalables",
      "treatment_title": "Votre cycle de FIV",
      "treatment_subtitle": "Traitement actif avec un suivi quotidien",
      "wait_title": "La période d'attente de deux semaines",
      "wait_subtitle": "Entre le transfert et le test de grossesse"
    },
    "ivf_with_partner_male": {
      "description": "Fécondation in vitro avec votre partenaire",
      "learn_title": "Comprendre la FIV",
      "learn_subtitle": "Le traitement de fertilité le plus efficace",
      "test_title": "Bilan de fertilité pour vous deux",
      "test_subtitle": "Examen complet de fertilité",
      "clinic_title": "Choisir votre centre d'AMP",
      "clinic_subtitle": "Les taux de réussite comptent particulièrement en FIV",
      "prep_title": "Préparer votre cycle",
      "prep_subtitle": "Dossier administratif et décisions préalables",
      "treatment_title": "Votre cycle de FIV",
      "treatment_subtitle": "Traitement actif avec un suivi quotidien",
      "wait_title": "La période d'attente de deux semaines",
      "wait_subtitle": "Entre le transfert et le test de grossesse"
    }
  },
  "chips": {
    "primary_intent": {
      "preserve": "Préservation",
      "grow": "Conception",
      "donate": "Don",
      "learn": "Découverte"
    },
    "treatment_intent": {
      "exploring": "Découverte",
      "preserve": "Congélation d'ovocytes",
      "sperm_preserve": "Congélation de sperme",
      "embryo_preserve": "Congélation d'embryons",
      "pregnancy": "Essai de conception",
      "egg_donation": "Don d'ovocytes",
      "sperm_donation": "Don de sperme",
      "adoption": "Adoption",
      "surrogacy": "GPA",
      "trying_naturally": "Conception naturelle",
      "starting_treatment": "Début de traitement",
      "in_treatment": "En traitement",
      "donation": "Don"
    },
    "condition": {
      "pcos": "PMOS (ex SOPK)",
      "endo": "Endométriose",
      "thyroid": "Thyroïde",
      "irregular": "Cycles irréguliers",
      "loss": "Fausse couche",
      "cancer": "Antécédent de cancer",
      "none": "Aucune condition",
      "unsure": "Pas sûr·e"
    },
    "partner": {
      "with_partner": "En couple",
      "using_donor": "Avec don",
      "solo": "Seul·e",
      "unsure": "Pas encore sûr·e"
    },
    "timeline": {
      "asap": "Dès que possible",
      "three_months": "3 mois",
      "six_months": "6 mois",
      "exploring": "Je réfléchis"
    },
    "ethnicities_count": "${count} origines",
    "conditions_count": "${count} conditions",
    "no_coverage": "Aucune couverture"
  },
  "documents": {
    "filter": {
      "all": "Tous",
      "current_cycle": "Cycle en cours",
      "uploaded_by_you": "Importés par toi",
      "action_needed": "Action requise",
      "cycle_documents_fallback": "Documents du cycle",
      "medical_records": "Dossier médical"
    },
    "no_date": "Pas de date",
    "cycle_type": {
      "ivf": "FIV",
      "fet": "TEC",
      "iui": "IIU",
      "egg_freezing": "Congélation d'ovocytes",
      "embryo_freezing": "Congélation d'embryons",
      "sperm_freezing": "Congélation de sperme"
    },
    "clinical_value": {
      "reference_range": "Plage de référence : ${range}",
      "purpose": {
        "amh": "Reflète la taille de ta réserve ovarienne restante",
        "fsh": "Indique l'effort de ton corps pour faire mûrir un ovocyte",
        "e2": "Montre la montée de l'œstrogène pendant la croissance folliculaire",
        "afc": "Compte les follicules visibles à l'échographie de référence",
        "tsh": "Comment ta thyroïde suit le rythme des hormones de la fertilité"
      }
    },
    "imaging_notes": {
      "type_line": "Type : ${value}",
      "findings_line": "Observations : ${value}",
      "afc_line": "CFA : ${value}",
      "endo_thickness_line": "Épaisseur endomètre : ${value} mm"
    },
    "genetic_notes": {
      "test_type_line": "Type de test : ${value}",
      "summary_line": "Résumé : ${value}"
    },
    "semen_result": {
      "volume": "Volume",
      "concentration": "Concentration",
      "motility": "Mobilité",
      "morphology": "Morphologie"
    },
    "semen_analysis_status": {
      "normal": "Normale",
      "borderline": "Limite",
      "abnormal": "Anormale",
      "unknown": "Inconnue",
      "unassessed": "Non évaluée"
    },
    "title": "Documents",
    "back": "Retour",
    "search_placeholder": "Rechercher un document...",
    "date_unknown": "Date inconnue",
    "more_count": "+${count} autres",
    "category": {
      "medical_records": {
        "label": "Dossier médical",
        "short_label": "Médical",
        "description": "Analyses, imagerie, comptes-rendus et protocoles",
        "example_1": "Résultats d'analyses",
        "example_2": "Comptes-rendus d'échographie",
        "example_3": "Protocoles de traitement"
      },
      "coverage_benefits": {
        "label": "Assurance et couverture",
        "short_label": "Assurance",
        "description": "Assurance, garanties, autorisations et remboursements",
        "example_1": "Carte Vitale",
        "example_2": "Ententes préalables",
        "example_3": "Décomptes de remboursement"
      },
      "legal_consent": {
        "label": "Formulaires et accords",
        "short_label": "Formulaires",
        "description": "Consentements, accords et documents signés du centre",
        "example_1": "Consentements éclairés",
        "example_2": "Conventions",
        "example_3": "Contrats de don"
      },
      "admin": {
        "label": "Factures et paiements",
        "short_label": "Factures",
        "description": "Devis, factures, reçus et justificatifs de paiement",
        "example_1": "Factures du centre",
        "example_2": "Factures pharmacie",
        "example_3": "Justificatifs de paiement"
      },
      "uncategorized": {
        "label": "Non classé",
        "short_label": "Non classé",
        "description": "Documents qui doivent être classés",
        "example_1": "Anciens imports",
        "example_2": "Fichiers importés",
        "example_3": "Documents non triés"
      }
    },
    "doc_type": {
      "header": "Type de document",
      "choose": "Choisir le type de document",
      "lab": "Biologie",
      "imaging": "Imagerie",
      "treatment_plan": "Ordonnance",
      "appointment_letter": "Rendez-vous",
      "genetic": "Génétique",
      "other": "Autre"
    },
    "status": {
      "on_file": "Au dossier",
      "requested": "Demandé",
      "missing": "Manquant"
    },
    "empty": {
      "no_documents": "Aucun document pour l'instant",
      "add_records": "Ajoutez des documents comme ${examples}",
      "add_any_documents": "Ajoutez des dossiers médicaux, documents d'assurance, factures, formulaires ou tout autre document à conserver ici.",
      "upload_first": "Télécharger votre premier document",
      "upload_anything_title": "Importez n'importe quel document",
      "upload_anything_body": "Déposez des PDF, des images, des lots ou un dossier complet. Louise les trie automatiquement et extrait les résultats, médicaments, rendez-vous, factures et formulaires à vérifier.",
      "upload_anything_note": "Les gros fichiers ou dossiers complets peuvent prendre plus de temps. Vous pourrez vérifier les informations extraites avant de les enregistrer.",
      "chip_full_records": "Dossier complet",
      "chip_lab_results": "Résultats labo",
      "chip_ultrasounds": "Échographies",
      "chip_prescriptions": "Ordonnances",
      "chip_appointments": "Rendez-vous",
      "chip_genetics": "Génétique",
      "chip_quotes": "Devis",
      "chip_receipts": "Reçus",
      "chip_referrals": "Courriers",
      "no_matches": "Aucun document ne correspond à ces filtres",
      "adjust_filters": "Essayez d'effacer la recherche ou de modifier les filtres.",
      "clear_filters": "Effacer les filtres"
    },
    "processing_review": {
      "summary_title": "Résumé rapide",
      "summary_subtitle": "Les informations importantes sont affichées ici. Le fichier original et l’extraction complète restent enregistrés.",
      "summary_key_details": "Informations principales",
      "summary_medication_plan": "Plan de traitement",
      "summary_appointment": "Rendez-vous",
      "summary_key_results": "Résultats principaux",
      "summary_unknown_medication": "Médicament",
      "summary_unknown_appointment": "Rendez-vous",
      "summary_unknown_result": "Résultat",
      "summary_no_action": "Le document est enregistré. Tu n’as rien d’autre à vérifier ici.",
      "summary_incomplete": "Certaines informations peuvent manquer car le fichier n’a pas pu être lu entièrement.",
      "anomaly_count": "${count} valeur(s) à vérifier",
      "loading_meaning": "Chargement des informations extraites…",
      "meaning_not_ready": "Le fichier est enregistré. Les informations extraites sont encore en préparation.",
      "meaning_unavailable": "Les informations extraites sont temporairement indisponibles.",
      "document_fallback_title": "Document",
      "mark_as_reviewed": "Marquer comme vérifié",
      "processed_automatically": "Ce document a été traité et enregistré automatiquement."
    },
    "processing_toast": {
      "documents_saved_one": "Ton document a été enregistré.",
      "documents_saved_many": "Tes documents ont été enregistrés.",
      "medications_added_one": "Un médicament a été ajouté à ton plan de traitement.",
      "medications_added_many": "${count} médicaments ont été ajoutés à ton plan de traitement.",
      "appointments_added_one": "Un rendez-vous a été ajouté.",
      "appointments_added_many": "${count} rendez-vous ont été ajoutés.",
      "results_added_one": "Un résultat d’analyse a été ajouté.",
      "results_added_many": "${count} résultats d’analyse ont été ajoutés."
    },
    "slot": {
      "amh": {
        "name": "Dosage de l'AMH",
        "why": "Mesure votre réserve ovarienne — l'indicateur le plus important pour planifier"
      },
      "day3_panel": {
        "name": "Bilan hormonal à J3 (FSH, LH, E2)",
        "why": "Hormones de base nécessaires à votre médecin de la reproduction (MR) avant de choisir un protocole"
      },
      "afc_ultrasound": {
        "name": "Échographie de comptage folliculaire (CFA)",
        "why": "Indique combien de follicules sont disponibles ce cycle"
      },
      "hsg_saline": {
        "name": "Hystérosalpingographie (HSG) ou hystérosonographie",
        "why": "Confirme que l'utérus et les trompes sont perméables pour le transfert"
      },
      "carrier_screening": {
        "name": "Résultats du dépistage des maladies récessives (caryotype élargi)",
        "why": "Identifie les maladies génétiques transmissibles à l'enfant"
      },
      "pgt_results": {
        "name": "Résultats DPI-A / DPI-M",
        "why": "Statut chromosomique de vos embryons après diagnostic préimplantatoire"
      },
      "semen_analysis": {
        "name": "Spermogramme",
        "why": "Évalue la numération, la mobilité et la morphologie des spermatozoïdes"
      },
      "thyroid_panel": {
        "name": "Bilan thyroïdien (TSH, T3, T4)",
        "why": "Les troubles thyroïdiens affectent directement l'implantation et la grossesse"
      },
      "pcos_labs": {
        "name": "Bilan biologique PMOS (ex SOPK) (insuline, testostérone, DHEA-S)",
        "why": "Suit les hormones liées aux symptômes du PMOS (ex SOPK)"
      },
      "endo_imaging": {
        "name": "Imagerie ou comptes-rendus opératoires d'endométriose",
        "why": "Documente l'étendue et la localisation du tissu endométrial"
      },
      "genetic_counseling": {
        "name": "Compte-rendu de conseil génétique",
        "why": "Recommandé lorsque le dépistage révèle une variante génétique"
      },
      "treatment_plan": {
        "name": "Protocole de traitement",
        "why": "La feuille de route de votre MR : médicaments, doses, calendrier et suivi"
      },
      "insurance_card": {
        "name": "Carte Vitale (recto-verso)",
        "why": "Indispensable à chaque consultation"
      },
      "benefits_summary": {
        "name": "Récapitulatif de prise en charge AMP",
        "why": "Détaille les plafonds de remboursement et les actes exclus"
      },
      "pre_auth": {
        "name": "Entente préalable (S3140)",
        "why": "Requise avant la plupart des actes de FIV — sans elle, le reste à charge est total"
      },
      "eob": {
        "name": "Décompte de remboursement (EOB)",
        "why": "Montre ce que l'Assurance Maladie a remboursé et ce qui reste à votre charge"
      },
      "appeal_letter": {
        "name": "Recours contre un refus de prise en charge",
        "why": "Si une demande est refusée, c'est la voie pour la contester"
      },
      "consent_forms": {
        "name": "Formulaires de consentement éclairé",
        "why": "Autorisation légale pour l'acte — les centres exigent leur signature"
      },
      "referral_letter": {
        "name": "Lettre d'adressage",
        "why": "Lettre du/de la gynécologue vers le MR (médecin de la reproduction)"
      },
      "donor_agreement": {
        "name": "Convention de don (consentement éclairé)",
        "why": "Contrat définissant les droits parentaux et les obligations du donneur"
      },
      "partner_consent": {
        "name": "Consentement du conjoint",
        "why": "Les deux conjoints doivent signer pour la création et la conservation d'embryons"
      },
      "storage_agreement": {
        "name": "Contrat de conservation (cryoconservation)",
        "why": "Précise la durée de conservation, les frais annuels et le devenir des gamètes/embryons"
      },
      "disposition_directive": {
        "name": "Directive de devenir des embryons/gamètes",
        "why": "Décide du devenir de vos ovocytes ou embryons si vous ne pouvez plus en disposer"
      },
      "clinic_invoices": {
        "name": "Factures du centre",
        "why": "Suivez vos dépenses — les soins d'AMP sont souvent déductibles des impôts"
      },
      "pharmacy_receipts": {
        "name": "Factures pharmacie / médicaments",
        "why": "Les médicaments peuvent représenter plusieurs milliers d'euros par cycle — conservez chaque reçu"
      },
      "storage_invoices": {
        "name": "Factures de cryoconservation",
        "why": "Les frais annuels de conservation des ovocytes ou embryons sont un coût récurrent"
      },
      "lab_bills": {
        "name": "Factures de laboratoire / examens",
        "why": "Factures de génétique et d'analyses biologiques pour un remboursement complémentaire"
      },
      "travel_receipts": {
        "name": "Justificatifs de transport",
        "why": "Les déplacements pour l'AMP peuvent être déductibles des impôts ou pris en charge par l'employeur"
      },
      "treatment_plan_fallback_name": "Protocole de traitement"
    },
    "upload": {
      "header_title": "Télécharger un document",
      "header_subtitle": "Nous l'analyserons automatiquement et en extrairons les informations clés",
      "choose_file": "Glissez-déposez ou choisissez des fichiers",
      "file_hint": "PDF, images, lots de fichiers ou dossier complet",
      "uploading_document_title": "Téléversement de votre document",
      "uploading_document_subtitle": "Nous le lirons automatiquement une fois le téléversement sécurisé terminé.",
      "reading_document_title": "Lecture de votre document",
      "reading_document_subtitle": "Le téléversement est terminé. Louise recherche les informations que vous pourrez vérifier.",
      "add_more_files": "Ajouter des fichiers",
      "secure_upload": "Téléversement sécurisé",
      "upload_complete_reading": "Téléversement terminé · Lecture en cours",
      "queued_file_added": "En attente · Ajouté à l'instant",
      "processing_uploading": "Téléversement en cours…",
      "processing_reading": "Lecture en cours…",
      "processing_next_up": "Suivant",
      "reading": "Lecture du document",
      "reading_subtitle": "Extraction des informations clés en cours. Cela peut prendre quelques instants.",
      "source_uploading": "Téléversement…",
      "source_filing": "Enregistrement du fichier…",
      "source_saved": "Fichier enregistré",
      "retry_source": "Réessayer l'import",
      "monitoring_reading": "Analyse des valeurs de monitoring",
      "monitoring_reading_subtitle": "Recherche des mesures folliculaires, de l'endomètre et des analyses sanguines.",
      "review_title": "Vérifier les données extraites",
      "review_subtitle": "Vérifiez les informations ci-dessous et corrigez-les si nécessaire avant d'enregistrer",
      "back": "Retour",
      "save": "Enregistrer dans mon dossier",
      "retry_care_rows": "Réessayer les lignes Care",
      "saving": "Enregistrement...",
      "saved": "Enregistré avec succès",
      "results_added_count": "${count} résultats ajoutés à votre dossier",
      "medications_detected_count": "${count} médicaments détectés",
      "more_documents_pending_count": "${count} autre(s) document(s) à vérifier",
      "review_next_document": "Vérifier le document suivant",
      "queued_documents_title": "Autres documents sélectionnés",
      "queued_documents_subtitle": "Nous vérifierons chaque fichier séparément pour garder des résultats extraits fiables.",
      "queued_documents_more": "+${count} autre(s)",
      "monitoring_parsed_title": "Valeurs de monitoring extraites",
      "monitoring_parsed_subtitle": "Nous avons trouvé des valeurs pour remplir ton monitoring. Vérifie-les dans le formulaire avant l'enregistrement.",
      "monitoring_parsed_count": "${count} valeur(s) de monitoring à vérifier",
      "monitoring_parsed_action": "Continuer vers le monitoring",
      "monitoring_parsed_empty_title": "Document analysé",
      "monitoring_parsed_empty_subtitle": "Aucune valeur de monitoring trouvée, mais ce document sera enregistré dans ton dossier.",
      "error_failed_process": "Échec du traitement du document. Veuillez réessayer.",
      "error_failed_save": "Échec de l'enregistrement. Veuillez réessayer.",
      "failure": {
        "unsupported_type": {
          "title": "Ce type de fichier n'est pas pris en charge",
          "description": "Choisissez plutôt un fichier PDF, une image ou un document."
        },
        "file_too_large": {
          "title": "Ce fichier est trop volumineux",
          "description": "Essayez un fichier plus petit ou divisez le dossier en plusieurs parties."
        },
        "batch_too_many_files": {
          "title": "Trop de fichiers sélectionnés",
          "description": "Essayez un groupe de fichiers plus petit pour garder chaque import clair."
        },
        "batch_too_large": {
          "title": "Ce groupe de fichiers est trop volumineux",
          "description": "Essayez d'importer ce dossier en plusieurs groupes plus petits."
        },
        "empty_file": {
          "title": "Ce fichier est vide",
          "description": "Choisissez un fichier contenant des informations à importer."
        },
        "corrupt_file": {
          "title": "Ce fichier ne peut pas être ouvert",
          "description": "Le fichier est peut-être incomplet ou endommagé. Choisissez une autre copie."
        },
        "password_protected": {
          "title": "Ce fichier est protégé par un mot de passe",
          "description": "Supprimez le mot de passe, puis importez à nouveau le fichier."
        },
        "duplicate": {
          "title": "Ce fichier est déjà enregistré",
          "description": "Ce fichier est déjà enregistré dans vos documents. Utilisez la version enregistrée ou choisissez un autre fichier."
        },
        "network_stalled": {
          "title": "Import en pause",
          "description": "La connexion s'est interrompue avant la fin. Réessayez depuis la dernière étape sûre."
        },
        "upload_failed": {
          "title": "L'import n'a pas pu aboutir",
          "description": "L'import original n'est pas terminé. Réessayez depuis la dernière étape sûre."
        },
        "extraction_failed": {
          "title": "Louise n'a pas pu lire ce fichier",
          "description": "Le fichier original est toujours enregistré. Réessayez la lecture sans le téléverser à nouveau."
        },
        "persistence_failed": {
          "title": "Les informations extraites n'ont pas été enregistrées",
          "description": "Le fichier est toujours disponible. Réessayez l'enregistrement sans le téléverser à nouveau."
        },
        "canceled": {
          "title": "Import annulé",
          "description": "Cet import a été annulé avant son enregistrement."
        },
        "status": {
          "not_uploaded": "Non téléversé",
          "not_saved": "Import incomplet · Non enregistré",
          "saved_not_read": "Téléversé et enregistré · Lecture impossible",
          "extracted_not_saved": "Téléversé · Informations extraites non enregistrées",
          "already_saved": "Déjà enregistré",
          "canceled": "Annulé · Non enregistré"
        },
        "checkpoint": {
          "validation": "Vérification du fichier",
          "upload": "Import",
          "processing": "Lecture",
          "saving": "Enregistrement"
        },
        "choose_another": "Choisir un autre fichier",
        "use_saved_file": "Utiliser le fichier enregistré",
        "retry_upload": "Réessayer l'import",
        "retry_reading": "Réessayer la lecture",
        "retry_saving": "Réessayer l'enregistrement",
        "dismiss": "Fermer",
        "details": "Voir les détails",
        "attention_title": "Un fichier nécessite votre attention",
        "attention_body": "Choisissez un autre fichier ou réessayez depuis la dernière étape sûre.",
        "partial_title": "Certains fichiers nécessitent votre attention",
        "partial_ready": "Prêts à continuer : ${fileCount}.",
        "partial_not_uploaded": "Non téléversés : ${fileCount}.",
        "partial_already_saved": "Déjà enregistrés : ${fileCount}.",
        "partial_not_saved": "Non enregistrés car l'import n'est pas terminé : ${fileCount}.",
        "partial_canceled": "Annulés avant l'enregistrement : ${fileCount}.",
        "partial_saved_not_read": "Téléversés et enregistrés, mais lecture impossible : ${fileCount}.",
        "partial_extracted_not_saved": "Téléversés, mais informations extraites non enregistrées : ${fileCount}.",
        "partial_next_step": "Ouvrez un fichier ci-dessous pour voir la prochaine étape.",
        "continue_ready": "Continuer avec les fichiers prêts"
      },
      "error_med_missing_start_date": "Ajoutez une date de début pour le médicament « ${name} » avant d'enregistrer.",
      "error_appt_missing_date_time": "Ajoutez une date et une heure pour le rendez-vous « ${title} » avant d'enregistrer.",
      "error_derived_rows_failed": "Votre document a été enregistré, mais Louise n'a pas pu ajouter ces lignes dans Care : ${items}. Touchez Enregistrer pour réessayer. Le document ne sera pas téléversé à nouveau.",
      "derived_medication_label": "Médicament",
      "derived_appointment_label": "Rendez-vous",
      "doc_type_label": "Type de document",
      "fields": {
        "test_name": "Nom de l'examen",
        "date": "Date",
        "date_placeholder": "AAAA-MM-JJ",
        "lab_clinic": "Laboratoire / centre",
        "lab": "Laboratoire",
        "exam_name": "Nom de l'examen",
        "clinic": "Centre",
        "imaging_type": "Type d'imagerie",
        "findings": "Conclusions",
        "afc": "CFA (comptage folliculaire antral)",
        "afc_placeholder": "Nombre",
        "endo_thickness": "Épaisseur endométriale",
        "endo_placeholder": "Épaisseur",
        "test_type": "Type d'examen",
        "test_type_placeholder": "Caryotype, dépistage récessif...",
        "result": "Résultat",
        "result_default_label": "Résultat",
        "result_placeholder": "Valeur",
        "summary": "Synthèse",
        "volume": "Volume (mL)",
        "concentration": "Concentration (M/mL)",
        "motility": "Mobilité (%)",
        "morphology": "Morphologie (%)",
        "notes": "Notes",
        "prescriber": "Prescripteur",
        "medication_name": "Nom du médicament",
        "dosage": "Dose",
        "unit": "Unité",
        "unit_placeholder": "mg, UI...",
        "frequency": "Fréquence",
        "frequency_placeholder": "Une fois par jour...",
        "route": "Voie",
        "route_placeholder": "Orale, SC...",
        "schedule": "Calendrier",
        "ends": "Fin",
        "appointment_title": "Titre",
        "appointment_type": "Type",
        "appointment_type_placeholder": "examen, intervention...",
        "time": "Heure",
        "time_placeholder": "HH:MM",
        "document_title": "Titre du document",
        "provider": "Praticien"
      },
      "table": {
        "marker": "Marqueur",
        "value": "Valeur",
        "unit": "Unité",
        "name": "Nom",
        "dose": "Dose"
      },
      "results_label": "Résultats",
      "select_placeholder": "Choisir ▾",
      "unit_placeholder": "unité ▾",
      "add_marker": "Ajouter un marqueur",
      "add_medication": "Ajouter un médicament",
      "add_appointment": "Ajouter un rendez-vous",
      "medications_count": "Médicaments (${count})",
      "appointments_count": "Rendez-vous (${count})",
      "unnamed_medication": "Médicament sans nom",
      "unnamed_appointment": "Rendez-vous sans titre"
    },
    "preview": {
      "side_front": "Recto",
      "side_back": "Verso",
      "attachment_fallback": "Pièce jointe",
      "open": "Ouvrir",
      "info": {
        "record_date": "Date de l'examen",
        "document_name": "Nom du document",
        "uploaded": "Téléchargé"
      },
      "section": {
        "results": "Résultats",
        "medications": "Médicaments",
        "appointments": "Rendez-vous",
        "notes_findings": "Notes & conclusions"
      },
      "save": "Enregistrer",
      "add_value": "Ajouter une valeur",
      "add_medication": "Ajouter un médicament",
      "add_appointment": "Ajouter un rendez-vous",
      "medications_empty": "Aucun médicament lié à ce document pour l'instant.",
      "appointments_empty": "Aucun rendez-vous lié à ce document pour l'instant.",
      "medications_start": "Date de début : ${date}",
      "select_placeholder": "Choisir ▾",
      "unit_placeholder": "unité ▾",
      "frequency_placeholder": "Fréquence ▾",
      "medication_name_placeholder": "Nom du médicament",
      "time_placeholder": "HH:MM",
      "title_placeholder": "Titre",
      "appointment_type": {
        "exam": "Examen",
        "procedure": "Intervention",
        "consult": "Consultation",
        "counseling": "Conseil"
      },
      "delete": "Supprimer",
      "open_document": "Ouvrir le document",
      "reupload": "Re-télécharger",
      "delete_confirm_title": "Supprimer le document",
      "delete_confirm_message": "Êtes-vous sûr·e de vouloir supprimer « ${name} » ? Cette action est irréversible.",
      "cancel": "Annuler"
    }
  },
  "cryo_vault": {
    "title": "Cryo vault",
    "subtitle": "Vos échantillons cryoconservés et leurs détails de conservation",
    "hero": {
      "eyebrow": "Votre coffre",
      "title_singular": "${count} échantillon conservé",
      "title_plural": "${count} échantillons conservés",
      "facility_one": "dans 1 centre",
      "facility_other": "dans ${count} centres"
    },
    "back": "Retour",
    "summary": {
      "embryos": "Embryons",
      "eggs": "Ovocytes",
      "semen": "Sperme"
    },
    "specimen_type": {
      "embryo_singular": "Embryon",
      "embryo_plural": "Embryons",
      "egg_singular": "Ovocyte",
      "egg_plural": "Ovocytes",
      "sperm_sample_singular": "Échantillon de sperme",
      "sperm_sample_plural": "Échantillons de sperme"
    },
    "pgt": {
      "euploid": "Euploïde",
      "aneuploid": "Aneuploïde",
      "mosaic": "Mosaïque",
      "untested": "Non testé"
    },
    "top_pick_badge": "MEILLEUR CHOIX",
    "top_pick": "Meilleur choix",
    "grade_prefix": "Grade ${grade}",
    "motility_suffix": "Mobilité ${value}",
    "source_labels": {
      "self_egg": "Vos ovocytes",
      "partner_egg": "Ovocytes de la·du partenaire",
      "donor_egg": "Don d'ovocytes",
      "self_sperm": "Votre échantillon",
      "partner_sperm": "Échantillon de la·du partenaire",
      "donor_sperm": "Don de spermatozoïdes",
      "default_egg": "Ovocyte",
      "default_sperm": "Échantillon de sperme",
      "subtitle_used_for_fertilization": "Utilisé pour la fécondation"
    },
    "source_values": {
      "your_own": "Vous-même",
      "partner": "Partenaire",
      "donor": "Donneur·euse"
    },
    "modal": {
      "grade_alert_title": "Grading embryonnaire",
      "grade_alert_message": "Le grading aide à évaluer la qualité des embryons. Discutez de vos grades précis avec votre centre d'AMP.",
      "grade_label": "Grade",
      "learn_what_grades_mean": "Comprendre la signification du grade embryonnaire",
      "semen_sample_title": "Échantillon de sperme n° ${n}",
      "semen_sample_title_without_number": "Échantillon de sperme",
      "egg_cohort_title": "Cohorte d'ovocytes n° ${n}",
      "egg_cohort_title_without_number": "Cohorte d'ovocytes",
      "tab_summary": "Info",
      "tab_clinical": "Données",
      "tab_reports": "Rapports",
      "tab_reports_short": "Rapport",
      "tab_storage": "Stockage",
      "tab_storage_short": "Stock.",
      "tab_usage": "Util.",
      "tab_documents": "Docs",
      "cycle_linked_tag": "Cycle lié",
      "egg_cohort_tag": "Cohorte",
      "cycle_header_tag": "${cycle} | ${date}",
      "overview_section": "Aperçu",
      "embryo_section": "Détails de l’embryon",
      "embryo_quality_section": "Qualité de l’embryon",
      "embryo_development_section": "Développement de l’embryon",
      "development_day_value": "Jour ${day}",
      "development_stage_value": "Stade : ${stage}",
      "development_grade_value": "Classement : ${grade}",
      "development_cells_value": "${count} cellules",
      "development_arrested_value": "Culture arrêtée",
      "development_record_source": "Source : ${source}",
      "development_record_verification": "Vérification : ${status}",
      "development_not_recorded": "Aucun autre détail de développement enregistré",
      "oocyte_section": "Détails de l’ovocyte",
      "oocyte_cohort_section": "Détails de la cohorte d'ovocytes",
      "sperm_section": "Détails de l'échantillon de sperme",
      "semen_analysis_section": "Spermogramme",
      "extended_semen_panel_section": "Bilan spermatique étendu",
      "retrieval_cohort_section": "Cohorte de ponction",
      "report_backed_outlook_section": "Perspective issue d'un rapport",
      "storage_section": "Conservation",
      "status": "Statut",
      "storage_pending": "Conservation à confirmer",
      "storage_unverified": "Conservation non vérifiée",
      "at_location": "à",
      "collection_date": "Date de recueil",
      "retrieval_date": "Date de ponction",
      "analysis_date": "Date d'analyse",
      "frozen": "Congelé",
      "fertilized": "Fécondé",
      "facility": "Centre",
      "storage_locator": "Emplacement de conservation",
      "storage_context": "Type de conservation",
      "sample_id": "ID de l'échantillon",
      "embryo_id": "ID embryon",
      "embryo_grade": "Grade embryonnaire",
      "day_of_development": "Jour de développement",
      "day_value": "Jour ${day}",
      "pgt": "DPI",
      "sex": "Sexe",
      "freezing_method": "Méthode de congélation",
      "maturity": "Maturité",
      "cohort": "Cohorte",
      "retrieval_cohort": "Cohorte de ponction",
      "total_retrieved": "Total recueilli",
      "mature_mii": "Matures MII",
      "number_frozen": "Nombre congelé",
      "number_thawed": "Nombre décongelé",
      "fertilized_count": "Fécondés",
      "embryos_created": "Embryons créés",
      "embryos_created_from_cohort": "Embryons créés depuis la cohorte",
      "remaining_frozen": "Restants congelés",
      "maturity_rate": "Taux de maturité",
      "thaw_history": "Historique de décongélation",
      "no_thaw_recorded": "Aucune décongélation enregistrée",
      "no_cohort_counts": "Aucun compte de cohorte",
      "predicted_egg_quality": "Potentiel de blastocyste",
      "predicted_fertility_outlook": "Prédiction de naissance vivante",
      "source_report": "Rapport source",
      "report_linked": "Rapport lié",
      "report_assumptions": "Hypothèses du rapport",
      "collection_method": "Méthode de recueil",
      "processing_method": "Méthode de préparation",
      "preparation_method": "Préparation laboratoire",
      "volume": "Volume",
      "total_count": "Compte total",
      "tmsc": "TMSC",
      "abstinence": "Abstinence",
      "abstinence_value": "${count} jours",
      "total_retrieved_value": "${count} recueillis",
      "mature_mii_value": "${count} MII",
      "immature_mi_value": "${count} MI",
      "degenerated_value": "${count} dégénérés",
      "number_thawed_value": "${count} décongelés",
      "thawed_for_fertilization_value": "${count} décongelés pour fécondation",
      "fertilized_count_value": "${count} fécondés",
      "embryos_created_count_value": "${count} embryons créés",
      "survival_value": "${percent}% de survie",
      "pgt_report": "Compte rendu DPI",
      "view_pgt_report": "Voir le compte rendu DPI",
      "embryo_report": "Compte rendu de test embryonnaire",
      "view_embryo_report": "Voir le compte rendu embryonnaire",
      "motility": "Mobilité",
      "progressive_motility": "Mobilité progressive",
      "non_progressive_motility": "Mobilité non progressive",
      "immotile": "Immobiles",
      "agglutination_aggregation": "Agglutination / agrégation",
      "vitality": "Vitalité",
      "leukocytes": "Leucocytes",
      "dna_fragmentation_index": "Index de fragmentation de l'ADN",
      "antisperm_antibody": "Anticorps antispermatozoïdes",
      "sperm_epigenetics": "Épigénétique spermatique",
      "oxidative_stress": "Stress oxydatif",
      "sperm_function": "Fonction spermatique",
      "not_tested": "Non testé",
      "concentration": "Concentration",
      "morphology": "Morphologie",
      "ph": "pH",
      "viscosity": "Viscosité",
      "created_from": "Créé à partir de",
      "cycle_section": "Cycle",
      "origin_cycle": "Cycle d'origine",
      "used_in_cycle": "Utilisé dans le cycle",
      "transfer_cycle": "Cycle de transfert",
      "cycle_linked_value": "Cycle lié",
      "transfer_cycle_linked_value": "Cycle de transfert lié",
      "cohort_partially_used": "Cohorte partiellement utilisée",
      "cohort_state": "État de la cohorte",
      "cohort_use": "Utilisation de la cohorte",
      "current_state": "État actuel",
      "treatment_use": "Usage en traitement",
      "next_available_action": "Action disponible",
      "embryo_use_state": "Aucun transfert enregistré",
      "oocyte_use_state": "Aucune décongélation ou fécondation enregistrée",
      "semen_use_state": "Aucun usage IUI/FIV/ICSI enregistré",
      "usage_empty_title": "Aucun usage lié à un cycle",
      "usage_empty_body": "Ce spécimen n'a pas encore de cycle d'origine ou de traitement lié.",
      "documents_empty_title": "Aucun document source lié",
      "documents_empty_body": "Ajoutez le compte rendu, le consentement ou le document de conservation qui justifie ces détails.",
      "source_documents_section": "Documents sources",
      "source_not_linked": "Source non liée",
      "upload_source_report": "Importer",
      "semen_analysis_empty_title": "Aucune valeur de spermogramme",
      "semen_analysis_empty_body": "Ajoutez ou importez un spermogramme avant d'afficher des valeurs cliniques pour cet échantillon.",
      "semen_analysis_report": "Compte rendu de spermogramme",
      "semen_analysis_report_body": "Justifie le volume, la concentration, la numération, la mobilité, la morphologie et les autres valeurs de laboratoire.",
      "embryology_report": "Compte rendu d'embryologie",
      "retrieval_report": "Compte rendu de ponction",
      "retrieval_report_body": "Justifie la date de ponction, le total recueilli, les comptes de maturité et le lien avec le cycle de ponction.",
      "embryology_lab_report": "Compte rendu d'embryologie ou de laboratoire",
      "embryology_lab_report_body": "Justifie la maturité ovocytaire, la méthode de congélation, l'historique de décongélation, l'utilisation en fécondation et les détails de manipulation en laboratoire.",
      "predictive_fertility_report": "Rapport prédictif de fertilité",
      "predictive_fertility_report_body": "Justifie toute estimation de fertilité future, de qualité ovocytaire ou de perspective de cohorte affichée dans la modale.",
      "consent_to_use_document": "Consentement ou autorisation d'utilisation",
      "consent_to_use_document_body": "Nécessaire avant d'utiliser cet échantillon pour l'IUI, la FIV, l'ICSI, le don, la destruction ou le transfert.",
      "cryostorage_agreement_document": "Contrat de conservation",
      "cryostorage_agreement_document_body": "Confirme les conditions de conservation, le centre et les obligations administratives liées à l'échantillon.",
      "chain_of_custody_document": "Document d'expédition ou de chaîne de conservation",
      "chain_of_custody_document_body": "Pertinent lorsqu'un échantillon a été déplacé entre cliniques, laboratoires, prestataires de conservation ou juridictions.",
      "source_document_upload_why": "Importez le document qui justifie les valeurs cliniques, le consentement ou les détails de conservation de ce spécimen.",
      "edit_specimen": "Modifier le spécimen",
      "edit_specimen_body": "Mettez à jour ce spécimen ou enregistrez la suite de son parcours.",
      "focused_edit_body": "Modifiez uniquement ce détail. Les autres informations du spécimen restent inchangées.",
      "edit_status_title": "Modifier le statut",
      "edit_notes_title": "Modifier les notes",
      "edit_sample_id_title": "Modifier l’identifiant de l’échantillon",
      "edit_identification_number_title": "Modifier le numéro d’identification",
      "edit_collection_date_title": "Modifier la date de recueil",
      "edit_freeze_date_title": "Modifier la date de congélation",
      "edit_facility_title": "Modifier le centre",
      "edit_storage_locator_title": "Modifier l’emplacement de conservation",
      "focused_edit_required": "Saisissez une valeur avant d’enregistrer.",
      "not_recorded": "Non renseigné",
      "record_details_section": "Détails du dossier",
      "record_date_placeholder": "AAAA-MM-JJ",
      "freeze_date": "Date de congélation",
      "facility_placeholder": "Centre ou lieu de conservation",
      "storage_locator_placeholder": "Cuve 4, canister B, canne 13",
      "sample_id_placeholder": "Identifiant de l'échantillon",
      "identification_number": "Numéro d'identification",
      "identification_number_placeholder": "Identifiant de l'ovocyte",
      "record_date_invalid": "Utilisez le format de date AAAA-MM-JJ.",
      "remove_specimen": "Supprimer l’échantillon",
      "confirm_remove_specimen": "Supprimer cet échantillon ?",
      "remove_specimen_consequences": "${specimen} sera retiré de votre coffre et des futures sélections de traitement.",
      "remove_specimen_failed": "Impossible de supprimer cet échantillon. Réessaie.",
      "status_label": "Statut",
      "current_status": "Statut actuel",
      "status_value_collected": "Recueilli",
      "status_value_processed": "Traité",
      "status_value_stored": "Conservé",
      "status_value_used": "Utilisé",
      "status_value_discarded": "Détruit",
      "status_value_donated": "Donné",
      "status_value_in_transit": "En transit",
      "record_lifecycle_event": "Enregistrer un événement du parcours",
      "lifecycle_event_help": "Choisissez un événement à ajouter à l'historique de ce spécimen. Les détails de l'événement sont enregistrés séparément des champs du spécimen.",
      "record_lifecycle_event_button": "Enregistrer l'événement",
      "cohort_lifecycle_event_help": "Enregistrez les événements du parcours depuis les fiches des ovocytes individuels de cette cohorte.",
      "lifecycle_event_thaw": "Décongeler",
      "lifecycle_event_donate": "Donner",
      "lifecycle_event_fertilize": "Féconder",
      "lifecycle_event_mature": "Maturer",
      "lifecycle_event_discard": "Détruire",
      "lifecycle_event_use": "Utiliser",
      "lifecycle_event_release": "Libérer la réservation",
      "lifecycle_event_test": "Tester",
      "lifecycle_event_culture": "Cultiver",
      "lifecycle_event_transfer": "Transférer",
      "lifecycle_event_biopsy": "Biopsier",
      "lifecycle_event_freeze": "Congeler",
      "lifecycle_event_reserve": "Réserver",
      "lifecycle_event_date": "Date de l'événement",
      "lifecycle_event_date_placeholder": "AAAA-MM-JJ",
      "lifecycle_event_time": "Heure de l'événement",
      "lifecycle_event_time_placeholder": "HH:MM",
      "lifecycle_event_quantity": "Quantité exacte",
      "lifecycle_event_quantity_placeholder": "Saisissez la quantité",
      "lifecycle_event_unit_count": "unité(s)",
      "lifecycle_event_unit_vial": "paille(tte)",
      "fertilization_source_label": "Source de sperme",
      "fertilization_source_empty": "Ajoutez un spécimen de sperme avant d'enregistrer la fécondation.",
      "fertilization_source_quantity": "Quantité de sperme",
      "fertilization_output_label": "Libellé du matériel produit",
      "fertilization_output_placeholder": "ex. Ovocyte fécondé 1",
      "fertilization_required": "Choisissez une source de sperme et un libellé de sortie avant d'enregistrer.",
      "lifecycle_thaw_motility": "Mobilité (%)",
      "lifecycle_thaw_viability": "Viabilité (%)",
      "lifecycle_thaw_percentage_placeholder": "0–100",
      "lifecycle_thaw_percentage_error": "Saisissez un pourcentage entre 0 et 100.",
      "lifecycle_thaw_surviving_quantity": "Nombre survivant",
      "lifecycle_thaw_surviving_quantity_placeholder": "Saisissez le nombre",
      "lifecycle_thaw_surviving_quantity_error": "Saisissez un nombre entier compris entre zéro et la quantité décongelée.",
      "lifecycle_thaw_survival_rate": "Taux de survie (%)",
      "lifecycle_thaw_survival_rate_unrecorded": "Non renseigné",
      "lifecycle_event_note": "Notes",
      "lifecycle_event_note_placeholder": "Notes",
      "lifecycle_event_required": "Choisissez un événement, une quantité exacte, une date et une heure avant d'enregistrer.",
      "lifecycle_event_history_unavailable": "L'historique de ce spécimen est indisponible. Rechargez-le avant d'enregistrer un événement.",
      "lifecycle_history": "Historique du parcours",
      "notes_placeholder": "Ajoutez une note sur ce spécimen",
      "save_changes": "Enregistrer les modifications",
      "saving_changes": "Enregistrement…",
      "save_error": "Impossible d’enregistrer les modifications.",
      "lifecycle_event_error": "Impossible d’enregistrer cet événement.",
      "source": "Origine",
      "notes": "Notes",
      "your_notes": "Vos notes",
      "media": "Médias",
      "media_day": "Jour ${day}",
      "time_lapse": "Time-lapse",
      "plan_transfer_alert_title": "Planifier un transfert",
      "plan_transfer_alert_message": "Contactez votre centre d'AMP pour discuter des options et du calendrier du transfert d'embryon.",
      "plan_transfer_button": "Planifier un transfert",
      "view_transfer_alert_title": "Cycle de transfert",
      "view_transfer_button": "Voir transfert",
      "fertilize_alert_title": "Utiliser l'ovocyte",
      "fertilize_alert_message": "Cette action nécessite le flux de décongélation, fécondation ou utilisation en traitement avant de pouvoir mettre à jour votre parcours.",
      "fertilize_button": "Utiliser cet ovocyte",
      "use_remaining_eggs_button": "Utiliser les ovocytes",
      "use_semen_button": "Planifier le traitement",
      "view_cycle_button": "Voir cycle",
      "cycle_button_compact": "Cycle",
      "cycle_number_button": "Cycle #${number}",
      "link_cycle_button": "Lier cycle",
      "view_cycle_alert_title": "Voir le cycle d'origine",
      "view_cycle_alert_message": "La navigation vers le cycle source est suivie séparément et n'est pas encore reliée à cette modale.",
      "link_cycle_alert_title": "Lier un cycle",
      "link_cycle_alert_message": "Le lien de cycle nécessite une relation sauvegardée côté backend avant que cette action puisse enregistrer.",
      "cohort_availability_section": "Disponibilité de la cohorte",
      "add_document_button": "Ajouter doc",
      "add_files_button": "Ajouter des fichiers",
      "add_document_alert_title": "Ajouter un document source",
      "add_document_alert_message": "La provenance documentaire des détails de spécimen est suivie séparément et n'est pas encore reliée à cette modale."
    },
    "metric_info": {
      "current_value": "Valeur actuelle",
      "reference_context": "Repère de référence",
      "result_status": "Statut",
      "result_source": "Source",
      "status_needs_source_range_title": "Plage source requise",
      "status_needs_source_range_body": "Cette valeur est affichée pour contexte, mais Louise ne la classe pas tant que le compte rendu source ou la plage propre au laboratoire n'est pas lié.",
      "status_not_tested_title": "Non testé",
      "status_not_tested_body": "Aucun résultat n'est encore disponible pour ce paramètre sur cet échantillon.",
      "oocyte_status_needs_source_title": "Rapport source requis",
      "oocyte_status_needs_source_body": "Cette valeur doit être liée à un compte rendu de ponction, d'embryologie, de conservation, à un rapport prédictif, à un import clinique ou à une source manuelle vérifiée avant d'être considérée comme confirmée.",
      "source_not_linked_title": "Source non liée",
      "source_not_linked_body": "Ce paramètre n'est pas encore lié à un compte rendu, une extraction OCR, un import clinique ou une saisie manuelle vérifiée.",
      "source_report_linked_title": "Rapport source lié",
      "source_report_linked_body": "Cette valeur est affichée comme issue d'un rapport dans la fixture. En production, le lien réel au rapport, l'extraction et les métadonnées source sont nécessaires.",
      "what_it_means": "Ce que cela signifie",
      "keep_in_mind": "À garder en tête",
      "disclaimer": "Les limites de référence sont populationnelles et les méthodes de laboratoire varient. Votre centre doit interpréter ce résultat avec la durée d'abstinence, les conditions de recueil, les facteurs du ou de la partenaire et le plan de traitement.",
      "oocyte_disclaimer": "Les estimations ovocytaires et de cohorte dépendent de l'âge, des méthodes du centre, du compte rendu du laboratoire, des résultats de décongélation, de la source spermatique et du plan de traitement. Les rapports prédictifs sont des estimations, pas des garanties.",
      "analysis_date": {
        "range": "Date du compte rendu ou de l'analyse",
        "summary": "C'est la date à laquelle le spermogramme a été réalisé ou rendu. Elle aide à relier les valeurs au bon prélèvement et au bon document source.",
        "context": "Les paramètres spermatiques peuvent varier dans le temps, donc la date compte pour comparer des échantillons ou décider si une analyse plus récente est nécessaire."
      },
      "collection_method": {
        "range": "Généralement recueil par masturbation ou éjaculat ; les alternatives dépendent du contexte clinique",
        "summary": "La méthode de recueil indique comment l'échantillon de sperme a été obtenu.",
        "context": "La méthode et le caractère complet du recueil peuvent influencer le volume, la concentration et l'interprétation. Les prélèvements chirurgicaux s'interprètent différemment des éjaculats."
      },
      "processing_method": {
        "range": "Étape de préparation propre au laboratoire",
        "summary": "La méthode de traitement décrit ce que le laboratoire a fait pour préparer ou congeler l'échantillon.",
        "context": "Le traitement influence l'utilisation possible de l'échantillon et l'interprétation des résultats après décongélation."
      },
      "preparation_method": {
        "range": "Exemples : lavage simple, gradient de densité ou swim-up",
        "summary": "La méthode de préparation décrit comment le laboratoire a sélectionné ou nettoyé les spermatozoïdes avant utilisation ou congélation.",
        "context": "Les méthodes peuvent modifier le nombre final de spermatozoïdes mobiles et sont choisies selon la qualité de l'échantillon et le traitement prévu."
      },
      "abstinence": {
        "range": "Souvent environ 2 à 7 jours selon les consignes du laboratoire",
        "summary": "L'abstinence correspond au nombre de jours depuis la dernière éjaculation avant le recueil.",
        "context": "Une abstinence courte ou longue peut modifier le volume, la numération et la mobilité, ce qui aide à comprendre les variations entre échantillons."
      },
      "volume": {
        "range": "Limite basse OMS 2021 : environ 1,4 mL",
        "summary": "Le volume correspond à la quantité de sperme dans l'échantillon. Il influence le nombre total de spermatozoïdes disponibles et le nombre de paillettes ou d'utilisations possibles.",
        "context": "Un volume faible peut venir d'un recueil incomplet, d'une abstinence courte ou d'un problème de production/liquide séminal. Il s'interprète avec le compte total et les notes de recueil."
      },
      "concentration": {
        "range": "Limite basse OMS 2021 : environ 16 millions/mL",
        "summary": "La concentration indique combien de spermatozoïdes sont présents dans chaque millilitre de sperme.",
        "context": "Une concentration basse peut réduire le nombre de spermatozoïdes utilisables, mais le compte total, la mobilité, la morphologie et l'utilisation prévue comptent aussi. En FIV avec ICSI, certains échantillons restent utilisables alors qu'ils seraient limités pour une IUI."
      },
      "total_count": {
        "range": "Limite basse OMS 2021 : environ 39 millions par éjaculat",
        "summary": "Le compte total estime le nombre de spermatozoïdes dans l'ensemble de l'échantillon, en combinant volume et concentration.",
        "context": "Il aide à distinguer un petit échantillon concentré d'un échantillon plus volumineux mais dilué. Il devient plus utile avec la mobilité et la récupération après préparation."
      },
      "tmsc": {
        "range": "Pas de limite OMS unique ; les seuils dépendent du plan IUI/FIV/ICSI",
        "summary": "Le TMSC correspond généralement au nombre total de spermatozoïdes mobiles : une estimation du nombre de spermatozoïdes en mouvement dans l'échantillon.",
        "context": "Les centres utilisent souvent le TMSC pour décider si une IUI est raisonnable ou si une FIV/ICSI est plus adaptée. Le seuil dépend du centre, de la préparation et du fait que la valeur soit avant ou après lavage."
      },
      "motility": {
        "range": "Limite basse OMS 2021 pour la mobilité totale : environ 42 %",
        "summary": "La mobilité est la part de spermatozoïdes en mouvement, qu'il s'agisse d'un mouvement progressif ou non progressif.",
        "context": "La mobilité compte pour la conception naturelle et l'IUI. En FIV/ICSI, un centre peut parfois utiliser des échantillons à mobilité plus faible selon le nombre et la qualité de spermatozoïdes mobiles récupérés."
      },
      "progressive_motility": {
        "range": "Limite basse OMS 2021 : environ 30 %",
        "summary": "La mobilité progressive est la part de spermatozoïdes qui avancent réellement plutôt que de bouger sur place.",
        "context": "C'est une mesure très pratique pour la planification. Si elle est basse, le centre peut discuter d'un nouveau test, des résultats après préparation, des chances en IUI ou d'une FIV/ICSI."
      },
      "non_progressive_motility": {
        "range": "Pas de norme universelle isolée ; s'interprète avec la mobilité totale et progressive",
        "summary": "La mobilité non progressive signifie que les spermatozoïdes bougent mais ne progressent pas efficacement vers l'avant.",
        "context": "Un échantillon peut montrer du mouvement tout en ayant une progression limitée. Cela compte surtout si la mobilité progressive ou le compte total mobile est bas."
      },
      "immotile": {
        "range": "S'interprète comme le complément des spermatozoïdes mobiles",
        "summary": "Les spermatozoïdes immobiles ne bougent pas au moment où l'échantillon est évalué.",
        "context": "Une forte proportion immobile peut réduire le nombre de spermatozoïdes mobiles utilisables. Si la mobilité est très basse, la vitalité aide à distinguer les spermatozoïdes vivants mais immobiles des spermatozoïdes morts."
      },
      "morphology": {
        "range": "Limite basse OMS en critères stricts : environ 4 % de formes normales",
        "summary": "La morphologie est le pourcentage de spermatozoïdes de forme normale selon des critères stricts de laboratoire.",
        "context": "Ce n'est qu'une partie du tableau et elle varie selon les laboratoires. Une morphologie basse peut influencer la recommandation d'ICSI, mais ne prouve pas à elle seule qu'une fécondation est impossible."
      },
      "agglutination_aggregation": {
        "range": "Habituellement attendu : absent ou minime",
        "summary": "L'agglutination ou l'agrégation décrit des spermatozoïdes qui se collent entre eux ou à des débris/cellules.",
        "context": "Les amas peuvent rendre la mobilité plus difficile à interpréter et faire évoquer anticorps, inflammation, infection ou facteurs de manipulation selon le profil observé."
      },
      "ph": {
        "range": "Repère fréquent : pH autour de 7,2 ou plus",
        "summary": "Le pH décrit le caractère acide ou alcalin du sperme.",
        "context": "Le pH peut donner un indice sur les liquides des glandes accessoires ou le moment du prélèvement, mais il ne s'interprète pas seul. La plage du laboratoire doit primer."
      },
      "viscosity": {
        "range": "Habituellement attendu : liquéfaction normale et faible filance après liquéfaction",
        "summary": "La viscosité décrit l'épaisseur ou le caractère filant du sperme après liquéfaction.",
        "context": "Une viscosité élevée peut gêner les mesures et le déplacement des spermatozoïdes. Elle peut refléter une liquéfaction incomplète, une inflammation ou des facteurs de manipulation."
      },
      "vitality": {
        "range": "Limite basse OMS 2021 : environ 54 % de spermatozoïdes vivants",
        "summary": "La vitalité mesure la part de spermatozoïdes vivants, qu'ils bougent ou non.",
        "context": "Elle est surtout utile quand la mobilité est basse, car elle distingue les spermatozoïdes vivants mais immobiles des spermatozoïdes morts. Les recommandations OMS insistent sur son intérêt quand la mobilité totale est basse."
      },
      "leukocytes": {
        "range": "De nombreux laboratoires signalent une leucocytospermie autour de 1 million de globules blancs/mL ou plus",
        "summary": "Les leucocytes sont des globules blancs observés dans le sperme.",
        "context": "Un taux élevé peut évoquer inflammation ou infection, mais les cellules rondes doivent être correctement identifiées. Le centre peut répéter le test, demander une culture ou évaluer les symptômes."
      },
      "dna_fragmentation_index": {
        "range": "Dépend du test ; de nombreux comptes rendus classent le DFI en faible, intermédiaire ou élevé",
        "summary": "La fragmentation de l'ADN estime la part de spermatozoïdes dont l'ADN est endommagé ou fragmenté.",
        "context": "Elle peut apporter du contexte lorsque le spermogramme est normal mais qu'il existe des fausses couches répétées, des échecs de fécondation ou des échecs de traitement. Les seuils dépendent du test utilisé."
      },
      "antisperm_antibody": {
        "range": "Dépend du test ; attendu souvent négatif ou avec faible fixation",
        "summary": "Le test d'anticorps antispermatozoïdes recherche des protéines immunitaires fixées aux spermatozoïdes.",
        "context": "Ces anticorps peuvent parfois gêner le mouvement ou l'interaction spermatozoïde-ovocyte. Le type de test et le degré de fixation déterminent la pertinence clinique."
      },
      "sperm_epigenetics": {
        "range": "Score dépendant du test ; pas de limite OMS",
        "summary": "Les tests épigénétiques spermatiques analysent des marqueurs chimiques sur l'ADN, comme la méthylation.",
        "context": "Ils sont généralement proposés dans des panels avancés ou propriétaires. Ils peuvent donner du contexte sur l'âge spermatique ou les expositions, mais l'interprétation dépend du fournisseur et du clinicien."
      },
      "oxidative_stress": {
        "range": "Dépend du test ; pas de limite OMS unique",
        "summary": "Le stress oxydatif recherche un excès de stress réactif pouvant affecter les membranes et l'ADN des spermatozoïdes.",
        "context": "Il peut être lié à une inflammation, une varicocèle, au tabac, à la chaleur ou à d'autres facteurs. Le résultat s'interprète avec l'histoire clinique, le spermogramme et parfois la fragmentation de l'ADN."
      },
      "sperm_function": {
        "range": "Dépend du test ; pas de limite OMS standard",
        "summary": "Les tests de fonction spermatique cherchent à évaluer la capacité des spermatozoïdes à réaliser certaines étapes comme se lier à l'ovocyte, le pénétrer ou le féconder.",
        "context": "Cela va au-delà du compte et de la mobilité standards. Certains tests sont propriétaires ou basés sur l'expression génique, donc les catégories du compte rendu et le plan de traitement de votre centre sont essentiels."
      },
      "oocyte_maturity": {
        "range": "Catégories fréquentes : MII, MI, GV ou inconnue",
        "summary": "La maturité décrit le stade de l'ovocyte à la ponction ou à la congélation. Les ovocytes MII sont matures et généralement considérés prêts pour la fécondation.",
        "context": "La maturité est le plus souvent une donnée de cohorte issue du compte rendu de ponction ou d'embryologie. Les ovocytes MI ou GV peuvent parfois évoluer selon le contexte, mais l'interprétation dépend du laboratoire et du plan de traitement."
      },
      "oocyte_freezing_method": {
        "range": "La plupart des congélations ovocytaires modernes utilisent la vitrification",
        "summary": "La méthode de congélation décrit comment le laboratoire a cryoconservé l'ovocyte.",
        "context": "La vitrification est l'approche moderne courante car elle congèle très rapidement les cellules. La méthode doit venir du compte rendu de laboratoire ou de conservation, surtout pour comparer des échantillons plus anciens."
      },
      "oocyte_retrieval_date": {
        "range": "Date de procédure du cycle de ponction",
        "summary": "La date de ponction rattache cet ovocyte au cycle et à la cohorte dont il provient.",
        "context": "L'âge au moment de la ponction et le contexte du cycle sont souvent plus pertinents cliniquement que l'âge actuel lorsqu'on discute d'ovocytes congelés."
      },
      "oocyte_frozen_date": {
        "range": "Souvent la date de ponction ou peu après l'évaluation laboratoire",
        "summary": "La date de congélation indique quand l'ovocyte est entré en cryoconservation.",
        "context": "Cette date aide à rapprocher les documents de conservation, la facturation, la chaîne de conservation et les usages ou décongélations ultérieurs."
      },
      "oocyte_total_retrieved": {
        "range": "Compte de cohorte issu du compte rendu de ponction",
        "summary": "Le total recueilli correspond au nombre d'ovocytes obtenus lors du cycle avant filtrage par maturité.",
        "context": "C'est un contexte de cohorte, pas une propriété d'un seul ovocyte. Il aide à situer cet ovocyte individuel dans le résultat complet de la ponction."
      },
      "oocyte_mature_mii": {
        "range": "Nombre de cohorte d'ovocytes matures",
        "summary": "Le compte MII correspond au nombre d'ovocytes matures de la cohorte, généralement ceux considérés utilisables pour congélation ou fécondation.",
        "context": "Le compte MII est une valeur clé pour la planification, mais il doit être rattaché au compte rendu d'embryologie ou de ponction."
      },
      "oocyte_number_frozen": {
        "range": "Nombre de cohorte conservé après évaluation",
        "summary": "Le nombre congelé indique combien d'ovocytes de la cohorte ont été cryoconservés.",
        "context": "Il peut être inférieur au nombre recueilli ou mature si certains ovocytes ont été utilisés immédiatement, n'ont pas rempli les critères ou n'ont pas été congelés."
      },
      "oocyte_number_thawed": {
        "range": "Nombre de cohorte déjà décongelé ou utilisé",
        "summary": "Le nombre décongelé indique combien d'ovocytes de cette cohorte ont déjà quitté la conservation congelée pour décongélation ou utilisation.",
        "context": "C'est un contexte de disponibilité de cohorte. Un ovocyte individuel conservé doit rester compris comme congelé sauf si un événement de décongélation ou d'utilisation lui est spécifiquement lié."
      },
      "oocyte_remaining_frozen": {
        "range": "Nombre congelé moins les événements de décongélation ou d'utilisation enregistrés",
        "summary": "Le nombre restant congelé estime combien d'ovocytes de la cohorte sont encore disponibles en conservation.",
        "context": "Cela nécessite un suivi backend du cycle de vie avant d'être définitif entre décongélation, usage, destruction, don, transfert ou expédition."
      },
      "oocyte_maturity_rate": {
        "range": "MII matures divisé par le total recueilli",
        "summary": "Le taux de maturité estime la part des ovocytes recueillis qui étaient assez matures pour être congelés ou fécondés.",
        "context": "C'est un calcul de cohorte, pas une propriété d'un ovocyte isolé. Il doit être interprété avec l'âge à la ponction, le protocole, le timing du déclenchement, la manipulation au laboratoire et le compte rendu source."
      },
      "oocyte_predictive_quality": {
        "range": "Probabilité propre au fournisseur, souvent basée sur des images d'ovocytes",
        "summary": "Certains rapports estiment la probabilité qu'un ovocyte ou une cohorte développe un blastocyste après décongélation et fécondation.",
        "context": "Cela doit toujours être présenté comme une estimation issue d'un rapport nommé, et non comme une prédiction indépendante de Louise sur la qualité ovocytaire ou le développement embryonnaire."
      },
      "oocyte_predictive_outlook": {
        "range": "Estimation de naissance vivante propre au fournisseur pour la cohorte d'ovocytes congelés",
        "summary": "Certains rapports combinent une évaluation personnalisée des ovocytes avec une modélisation statistique pour estimer les chances d'au moins une naissance vivante à partir de la cohorte congelée.",
        "context": "Ces estimations sont sensibles aux hypothèses et ne remplacent pas un avis médical. Les résultats dépendent aussi de la survie à la décongélation, de la source spermatique, de la fécondation, du développement embryonnaire, du transfert, de l'implantation et des facteurs utérins."
      }
    },
    "grade_explanations": {
      "6AA": "Blastocyste en cours d'éclosion, masse cellulaire interne et trophectoderme de très bonne qualité",
      "5AA": "Blastocyste en cours d'éclosion, excellente qualité",
      "4AA": "Blastocyste expansé, très bonne qualité — excellent candidat au transfert",
      "4AB": "Blastocyste expansé, excellente masse interne, trophectoderme correct",
      "4BA": "Blastocyste expansé, masse interne correcte, excellent trophectoderme",
      "4BB": "Blastocyste expansé, bonne qualité — viable pour transfert",
      "3AA": "Blastocyste complet, très bonne qualité — excellent candidat au transfert",
      "3AB": "Blastocyste complet, excellente masse interne, cellules externes correctes",
      "3BA": "Blastocyste complet, masse interne correcte, excellentes cellules externes",
      "3BB": "Blastocyste complet, bonne qualité — viable pour transfert",
      "2BB": "Blastocyste précoce, bonne qualité — peut poursuivre son développement",
      "1BB": "Cavitation précoce, bonne qualité"
    },
    "egg_grid": {
      "default_cycle_label": "Congélation d'ovocytes",
      "frozen_date": "Congelés le ${date}"
    },
    "grouped_inventory": {
      "unknown_facility": "Centre de conservation",
      "frozen_date": "Congelés le ${date}",
      "egg_cohort_title_frozen": "${count} congelés | ${label}",
      "egg_cohort_title_used": "${remaining} congelés, ${used} utilisés | ${label}"
    },
    "funnel": {
      "subtitle": "Chaque étape comporte une attrition naturelle — voici la progression de votre cycle",
      "view_full_cycle": "Voir le détail complet du cycle",
      "retrieved": "Recueillis",
      "retrieved_subtitle": "Issus de la ponction",
      "mature": "Matures",
      "mature_subtitle": "Prêts pour la fécondation",
      "fertilized": "Fécondés",
      "fertilized_subtitle": "Fécondation réussie",
      "blastocysts": "Blastocystes",
      "blastocysts_subtitle": "Embryons J5 prêts pour la biopsie",
      "pgt_tested": "Testés DPI",
      "pgt_tested_subtitle": "Dépistage génétique réalisé",
      "euploid": "Euploïdes",
      "euploid_subtitle": "Génétiquement normaux",
      "frozen": "Cryoconservés",
      "frozen_subtitle": "Vitrifiés et en conservation",
      "embryos_frozen": "Embryons cryoconservés",
      "no_result": "Aucun résultat",
      "title": "Entonnoir des résultats",
      "observed_subtitle": "Comptes rendus de ce cycle, chaque étape étant comparée à la cohorte ponctionnée.",
      "recorded_detail": "Enregistré pour ce cycle.",
      "share_detail": "${share} % de la cohorte ponctionnée ; enregistré pour ce cycle."
    },
    "facility": {
      "specimen_count_one": "${count} échantillon conservé",
      "specimen_count_other": "${count} échantillons conservés",
      "since": "Depuis le ${date}",
      "annual_cost": "${cost}/an",
      "next_payment": "Prochain paiement le ${date}"
    },
    "disposition": {
      "on_file_title": "Directive de devenir des embryons enregistrée",
      "on_file_subtitle": "Vos instructions concernant vos échantillons sont documentées",
      "expiring_title": "Directive de devenir bientôt expirée",
      "missing_title": "Directive de devenir manquante",
      "missing_subtitle": "Document requis — précise ce qu'il advient de vos échantillons"
    },
    "action_card": {
      "coming_soon": "BIENTÔT DISPONIBLE"
    },
    "egg_planning": {
      "title": "Projet parental — contexte",
      "body_singular": "Avec ${count} ovocytes congelés, vous disposez possiblement de quoi tenter environ ${attempts} cycle de FIV. Cela varie considérablement selon l'âge et la qualité ovocytaire. Discutez de votre situation précise avec votre médecin de la reproduction.",
      "body_plural": "Avec ${count} ovocytes congelés, vous disposez possiblement de quoi tenter environ ${attempts} cycles de FIV. Cela varie considérablement selon l'âge et la qualité ovocytaire. Discutez de votre situation précise avec votre médecin de la reproduction."
    },
    "potential": {
      "section_title": "Le potentiel de votre coffre",
      "tab_combined": "Tout le potentiel",
      "tab_embryos": "Embryons",
      "tab_eggs": "Ovocytes",
      "summary_card_title": "Estimations de vos chances",
      "intro": "Voici, selon les taux de réussite publiés, comment vos échantillons cryoconservés pourraient se traduire en naissances",
      "from_embryos": "À partir des embryons",
      "from_embryos_with_euploid": "À partir des embryons (${count} euploïde·s)",
      "from_frozen_eggs": "À partir des ovocytes cryoconservés",
      "what_this_means": "Ce que cela signifie",
      "recommendation": "Recommandation",
      "frozen_embryos": "Embryons cryoconservés",
      "survive_thaw": "Survivent à la décongélation",
      "implant_successfully": "Implantation réussie",
      "estimated_live_births": "Naissances estimées",
      "combined_inventory": "Stock du coffre",
      "combined_thaw": "Survivent à la décongélation",
      "combined_transfer_ready": "Embryons prêts pour le transfert",
      "combined_implant": "Implantation réussie",
      "combined_live_births": "Naissances estimées",
      "combined_inventory_detail": "${embryos} embryons + ${eggs} ovocytes stockés dans votre coffre.",
      "combined_thaw_detail": "${embryos} embryons + ${eggs} ovocytes devraient survivre à la décongélation.",
      "combined_transfer_ready_detail": "${embryos} embryons décongelés + ${eggs} embryons issus des ovocytes sont attendus.",
      "combined_implant_detail": "${embryos} embryons + ${eggs} embryons issus des ovocytes pourraient s'implanter.",
      "combined_live_birth_detail": "${embryos} attendues des embryons congelés + ${eggs} des ovocytes congelés.",
      "stored_cohort_detail": "Stockés dans votre coffre et disponibles pour cette estimation.",
      "survive_thaw_detail": "Certains peuvent ne pas survivre à la décongélation.",
      "fertilize_detail": "Certains peuvent ne pas féconder après décongélation.",
      "reach_blastocyst_detail": "Certains peuvent s'arrêter avant le stade blastocyste.",
      "implant_detail": "Certains peuvent ne pas s'implanter après le transfert.",
      "live_birth_detail": "Naissances vivantes estimées après les étapes restantes.",
      "frozen_eggs": "Ovocytes cryoconservés",
      "fertilize": "Fécondation",
      "reach_blastocyst": "Atteignent le stade blastocyste",
      "insight_high_singular": "D'après les moyennes publiées, votre stock cryoconservé actuel pourrait conduire à environ ${count} naissance. Il s'agit d'estimations statistiques — votre médecin de la reproduction peut les affiner selon votre situation.",
      "insight_high_plural": "D'après les moyennes publiées, votre stock cryoconservé actuel pourrait conduire à environ ${count} naissances. Il s'agit d'estimations statistiques — votre médecin de la reproduction peut les affiner selon votre situation.",
      "insight_one": "Votre stock actuel vous offre une chance raisonnable d'avoir une naissance d'après les moyennes statistiques. Discutez avec votre médecin de la reproduction de l'opportunité de cycles supplémentaires pour améliorer vos chances.",
      "insight_low": "Avec votre stock actuel, les chances statistiques sont serrées. Votre médecin de la reproduction peut vous aider à décider si une ponction ou une congélation supplémentaire améliorerait significativement vos chances.",
      "recommendation_no_embryos": "Avec uniquement des ovocytes cryoconservés et aucun embryon, envisagez un nouveau cycle de congélation d'ovocytes pour augmenter vos chances, ou évoquez la fécondation de vos ovocytes actuels pour créer des embryons.",
      "recommendation_untested": "Aucun de vos embryons n'a fait l'objet d'un DPI-A (Diagnostic PréImplantatoire pour les Aneuploïdies). Le dépistage génétique peut aider à identifier les meilleurs candidats au transfert et améliorer les taux de réussite.",
      "recommendation_few_euploid": "N'avoir qu'un seul embryon euploïde limite le nombre de tentatives. Discutez avec votre médecin de la reproduction d'un cycle supplémentaire pour disposer de plus d'options.",
      "disclaimer": "Estimations basées sur les moyennes publiées (SART/CDC). Les résultats individuels varient selon l'âge, la qualité ovocytaire, le centre d'AMP et d'autres facteurs. Discutez de vos perspectives personnalisées avec votre médecin de la reproduction."
    },
    "sections": {
      "what_to_do": "Que souhaitez-vous faire ?",
      "retrieval_results": "Résultats de la ponction",
      "storage_facilities": "Centres de conservation",
      "related_documents": "Documents associés",
      "common_questions": "Questions fréquentes"
    },
    "actions": {
      "plan_transfer_label": "Planifier un transfert",
      "plan_transfer_subtitle": "Démarrer la procédure de transfert d'un embryon cryoconservé",
      "fertilize_label": "Féconder mes ovocytes",
      "fertilize_subtitle": "Démarrer un cycle de FIV avec vos ovocytes cryoconservés",
      "start_cycle_label": "Démarrer un autre cycle",
      "start_cycle_subtitle": "Ajouter des ovocytes, embryons ou spermatozoïdes à votre coffre",
      "move_label": "Transférer mes échantillons",
      "move_subtitle": "Organiser le transport entre centres avec suivi"
    },
    "transfer_selection": {
      "title": "Choisis les embryons pour ce transfert",
      "subtitle": "Sélectionne les fiches précises à revoir avec ta clinique. Rien n'est réservé avant le démarrage du cycle.",
      "cancel": "Annuler",
      "continue": "Revoir la sélection"
    },
    "documents": {
      "cryo_agreement_label": "Contrat de cryoconservation",
      "cryo_agreement_subtitle": "Conditions, frais et renouvellement",
      "disposition_label": "Directive de devenir des embryons",
      "disposition_subtitle": "Instructions concernant vos échantillons",
      "invoices_label": "Factures de conservation",
      "invoices_subtitle": "Historique des paiements",
      "empty_title": "Aucun document lié au coffre",
      "empty_body": "Les documents apparaissent ici lorsqu'ils sont explicitement liés à un cycle ou à un échantillon.",
      "empty_action": "Importer un document du coffre"
    },
    "faq": {
      "expire_question": "Les échantillons cryoconservés ont-ils une date de péremption ?",
      "expire_answer": "Les embryons et ovocytes vitrifiés peuvent rester viables pendant des décennies. Aucune limite de durée n'est connue — des échantillons congelés depuis plus de 20 ans ont donné lieu à des naissances en bonne santé.",
      "quality_question": "La qualité diminue-t-elle avec la durée de conservation ?",
      "quality_answer": "Non. La vitrification préserve les cellules dans un état stable. La qualité à la décongélation dépend de la qualité au moment de la congélation, et non de la durée de conservation.",
      "eggs_needed_question": "Combien d'ovocytes faut-il pour un bébé ?",
      "eggs_needed_answer": "Cela dépend de l'âge et de la qualité ovocytaire. En moyenne, 10 à 20 ovocytes peuvent permettre 1 naissance vivante chez les femmes de moins de 35 ans, davantage étant nécessaire à un âge plus avancé. Votre médecin de la reproduction peut vous donner une estimation personnalisée.",
      "move_facility_question": "Puis-je transférer mes échantillons vers un autre centre ?",
      "move_facility_answer": "Oui. Les échantillons peuvent être acheminés entre centres via des transporteurs cryogéniques spécialisés. Les deux centres doivent coordonner le transfert. Nous développons des outils pour faciliter cette démarche."
    },
    "empty": {
      "title": "Ajoutez vos échantillons congelés",
      "body": "Importez un compte rendu de cryoconservation, un contrat de stockage, un résumé d'embryologie, ou saisissez les détails de vos ovocytes, embryons ou paillettes. Louise analysera ce qu'elle peut et gardera le dossier relié à vos soins.",
      "chip_eggs": "Ovocytes",
      "chip_embryos": "Embryons",
      "chip_sperm": "Paillettes",
      "chip_freeze_reports": "Comptes rendus",
      "chip_storage": "Contrats de stockage",
      "chip_facility": "Centres",
      "chip_disposition": "Directives",
      "drop_title": "Glissez-déposez ou choisissez un compte rendu",
      "drop_hint": "PDF, images, rapports de stockage et résumés d'embryologie",
      "note": "Vous pouvez ajouter un échantillon, un compte rendu complet de congélation ou un dossier de stockage. Nous extrairons le centre, la date de congélation, les quantités et les détails quand ils sont lisibles."
    },
    "labels": {
      "embryo_label": "Embryon n°${n}",
      "egg_label": "Ovocyte n°${n}",
      "egg_cohort_label": "Cohorte d'ovocytes n°${n}",
      "sample_label": "Échantillon n°${n}"
    },
    "add_modal": {
      "header_title": "Ajouter des échantillons",
      "form_title": "Ajouter ${type}",
      "upload_intro": "Importez un compte rendu de cryoconservation pour pré-remplir les détails, ou saisissez-les manuellement.",
      "extracting": "Extraction des données de l'échantillon...",
      "extraction_failed_message": "Nous n'avons pas pu extraire ce compte rendu. Le fichier reste joint ; réessayez l'extraction ou saisissez les valeurs manuellement.",
      "retry_extraction": "Réessayer l'extraction",
      "upload_document": "Importer un document",
      "enter_manually": "Saisir manuellement",
      "manual_option": "Ou saisir manuellement",
      "uploaded_file_hint": "Vérifiez le type d’échantillon, puis choisissez sa source.",
      "back": "Retour",
      "next": "Suivant",
      "steps": {
        "related": "Choisir le cycle associé",
        "analysis": "Vérifier l'analyse de l'échantillon",
        "counts": "Indiquer les détails de la ponction",
        "usage": "Que s’est-il passé ensuite ?",
        "development": "Décrire le développement embryonnaire",
        "embryo_group_details": "Détails du groupe d'embryons",
        "embryo_shared_details": "Détails de la fécondation",
        "inventory": "Choisir comment enregistrer les embryons",
        "details": "Détails facultatifs",
        "progress": "Étape ${step} sur ${total}"
      },
      "add_another_cycle": "Ajouter un autre cycle",
      "add_another_sample_action": "Ajouter un autre échantillon",
      "add_another_sample_prompt": "Souhaitez-vous ajouter un autre échantillon ?",
      "done": "Terminé",
      "save": "Enregistrer",
      "success_title": "${type} ajouté",
      "success_title_eggs": "Vos ovocytes sont bien conservés dans le coffre",
      "success_body": "Votre échantillon a été ajouté à votre CryoVault.",
      "embryo_follow_up": {
        "prompt": "Vous avez indiqué que certains de vos ovocytes avaient été fécondés.\nSouhaitez-vous ajouter maintenant les détails de ces embryons ?",
        "not_now": "Pas maintenant",
        "add_details": "Ajouter les détails"
      },
      "save_button_singular": "Enregistrer ${count} échantillon",
      "save_button_plural": "Enregistrer ${count} échantillons",
      "saved": "Enregistré",
      "partial_save_message": "Certains échantillons ont été enregistrés. ${count} nécessitent encore votre attention. Réessayez pour terminer.",
      "batch_save_failed_message": "Nous n'avons pas pu enregistrer ces échantillons. Réessayez pour terminer.",
      "document_upload_failed_message": "L'échantillon a été enregistré, mais un ou plusieurs documents justificatifs n'ont pas pu être liés. Réessayez l'import du document avant de quitter.",
      "document_upload_failed_files": "À réessayer : ${files}",
      "retry_document_upload": "Réessayer l'import du document",
      "post_save_sync_error": "Votre échantillon a été enregistré, mais l'étape du traitement n'a pas pu être mise à jour. Réessayez pour terminer la synchronisation.",
      "retry_post_save_sync": "Réessayer la synchronisation",
      "optional_add_button": "+ Ajouter",
      "validation_error": "Ajoutez au moins un échantillon congelé et une date de recueil, de ponction ou de congélation.",
      "validation_error_embryos": "Ajoutez au moins un embryon ou groupe d'embryons, les détails du développement et une date de fécondation ou de congélation.",
      "generic_error": "Une erreur est survenue.",
      "cycle_card": {
        "eggs": "Ovocytes",
        "sperm": "Sperme",
        "embryos": "Embryons",
        "cycle_index": "${type} n°${n}",
        "no_clinic": "Aucun centre",
        "specimen_count_singular": "${count} échantillon",
        "specimen_count_plural": "${count} échantillons",
        "summary_dot": "${clinic} · ${count_text}"
      },
      "type_toggle": {
        "eggs": "Ovocytes",
        "sperm": "Sperme",
        "embryos": "Embryons"
      },
      "source": {
        "who_specimen_from_optional": "À qui appartient cet échantillon ? (facultatif)",
        "mine": "Le mien",
        "partner": "Partenaire",
        "donor": "Donneur",
        "unknown": "Je ne sais pas"
      },
      "past_cycle": {
        "title": "Ajouter un cycle passé",
        "subtitle": "Ce cycle n’est pas encore entièrement renseigné. Ajoutez son type et sa date maintenant ; vous pourrez compléter les détails plus tard.",
        "type_label": "De quel type de cycle s’agissait-il ?",
        "when_label": "Quand ce cycle a-t-il eu lieu ?",
        "month_year": "MM/AAAA",
        "cancel": "Annuler",
        "save": "Enregistrer le cycle"
      },
      "related_cycle_specimen": {
        "eggs": "ovocytes",
        "sperm": "échantillons de sperme",
        "embryos": "embryons"
      },
      "fields": {
        "clinic": "Centre d'AMP",
        "stored_at": "Où sont-ils conservés ?",
        "stored_at_optional": "Centre ou établissement (facultatif)",
        "storage_location": "Lieu de conservation (facultatif)",
        "storage_location_placeholder": "Choisir une ville ou un pays",
        "clinic_placeholder": "Sélectionnez ou saisissez le nom du centre...",
        "use_custom": "Utiliser « ${value} »",
        "search_placeholder": "Rechercher ou saisir...",
        "search_location": "Rechercher une ville ou un pays…",
        "location_no_matches": "Aucun lieu trouvé",
        "search_country": "Rechercher un pays...",
        "country": "Pays",
        "country_placeholder": "Choisir un pays",
        "upload_supporting_document": "Importer un document justificatif",
        "related_cycle": "Cycle associé",
        "related_cycle_optional": "Cycle associé (facultatif)",
        "sperm_related_cycle": "Cet échantillon était-il lié à un cycle ?",
        "sperm_related_cycle_optional": "Cet échantillon était-il lié à un cycle ? (facultatif)",
        "sperm_preservation": "Conservation uniquement",
        "related_cycle_another": "Autre cycle",
        "related_cycle_not_linked": "Ne pas associer à un cycle pour l'instant",
        "related_cycle_not_linked_hint": "Cet échantillon restera séparé jusqu'à ce que tu choisisses un cycle.",
        "related_cycle_existing": "${count} ${specimen} déjà ajouté(s)",
        "storage_type": "Type de centre",
        "storage_type_optional": "Type de centre (facultatif)",
        "storage_id": "Identifiant / Référence de cuve",
        "storage_id_optional": "Référence de conservation (facultatif)",
        "storage_id_placeholder": "p. ex. « Cuve 4, Canister B »",
        "storage_state_optional": "Quel est l'état de conservation ? (facultatif)",
        "storage_state_placeholder": "Choisir un état de conservation",
        "storage_state_stored": "Conservé dans un établissement",
        "storage_state_not_stored": "Pas actuellement conservé",
        "storage_state_unknown": "Inconnu / à confirmer",
        "notes": "Notes",
        "notes_placeholder": "Notes supplémentaires...",
        "documents": "Documents (facultatif)",
        "documents_prompt": "Déposez les documents que vous souhaitez ajouter concernant ces échantillons : documents juridiques, financiers, de conservation ou du centre. Nous les analyserons pour vous.",
        "documents_drop_action": "Déposez des documents ou choisissez des fichiers",
        "documents_drop_hint": "PDF, images ou dossiers complets",
        "embryo_report": "Compte rendu embryonnaire (facultatif)",
        "embryo_report_prompt": "Importez un compte rendu et nous renseignerons les nombres et les détails embryonnaires que nous trouverons. Vous pourrez tout vérifier et modifier ci-dessous.",
        "embryo_report_drop_action": "Déposez un compte rendu ou choisissez un fichier",
        "embryo_report_drop_hint": "PDF, images ou dossier complet du laboratoire",
        "attachments": "Pièces jointes",
        "attach_file": "Joindre un fichier (PDF ou image)",
        "select_placeholder": "Sélectionner..."
      },
      "oocyte": {
        "retrieval_date": "Date de ponction",
        "retrieval_date_placeholder": "Date de ponction",
        "freeze_date": "Date de congélation",
        "freeze_date_placeholder": "Date de congélation",
        "freeze_date_optional": "Facultatif — cette date peut figurer sur votre compte rendu.",
        "freezing_method": "Méthode de congélation",
        "retrieval_counts": "Détails supplémentaires de la cohorte (facultatif)",
        "total_retrieved": "Combien d’ovocytes ont été recueillis ?",
        "mature_mii": "Combien d’ovocytes étaient matures (MII) ?",
        "immature_mi": "Combien d’ovocytes étaient immatures (MI) ?",
        "degenerated": "Combien d’ovocytes étaient dégénérés ?",
        "cohort_disposition": "Qu’est-il arrivé aux ovocytes recueillis pendant ce cycle ?",
        "disposition_all_frozen": "Tous ont été congelés",
        "disposition_mixed_frozen_fertilized": "Certains ont été congelés, d’autres fécondés",
        "disposition_all_fertilized": "Tous ont été fécondés",
        "disposition_unknown": "Je ne sais pas",
        "number_frozen": "Combien d’ovocytes ont été congelés ?",
        "number_frozen_now": "Combien d’ovocytes sont encore congelés ?",
        "number_frozen_prefill_hint": "Nous avons indiqué ${count} d’après vos réponses précédentes. Modifiez ce nombre pour qu’il corresponde à votre compte rendu.",
        "number_fertilized": "Combien d’ovocytes ont été fécondés ?",
        "number_fertilized_hint": "Vous pourrez ajouter séparément les embryons obtenus et les associer à ce cycle.",
        "all_fertilized_hint": "Aucun ovocyte congelé n’est à ajouter pour cette cohorte. Ajoutez séparément les embryons obtenus.",
        "all_fertilized_save_hint": "Ce parcours ajoute des ovocytes congelés : il n’y a rien à enregistrer tant qu’aucun ovocyte congelé n’est indiqué. Ajoutez séparément les embryons obtenus.",
        "i_dont_know": "Je ne sais pas"
      },
      "sperm": {
        "analysis_title": "Quelques détails sur l'échantillon",
        "advanced_results": "Résultats avancés",
        "dna_fragmentation": "Fragmentation de l'ADN",
        "vitality": "Vitalité",
        "progressive_motility": "Mobilité progressive",
        "other": "Autre",
        "other_placeholder": "Ajoutez d'autres détails sur l'échantillon...",
        "collection_date": "Date de recueil",
        "collection_date_placeholder": "Date de recueil",
        "freeze_date": "Date de congélation",
        "freeze_date_placeholder": "Date de congélation",
        "freeze_date_optional": "Facultatif — cette date peut figurer sur votre compte rendu.",
        "vials_frozen": "Combien de paillettes sont congelées ?",
        "collection_method": "Méthode de recueil",
        "processing_method": "Comment l'échantillon a-t-il été préparé ?",
        "sample_details": "Détails du recueil",
        "sample_details_hint": "Si vous vous souvenez de la durée d'abstinence, vous pouvez l'indiquer ici. Sinon, laissez ce champ vide.",
        "days_abstinence": "Jours d'abstinence",
        "sample_analysis": "Analyse de l'échantillon",
        "sample_analysis_hint": "Si vous avez un compte rendu, ajoutez les valeurs que vous connaissez. Vous pouvez laisser le reste vide.",
        "concentration": "Concentration",
        "total_count": "Numération totale",
        "motility": "Mobilité",
        "morphology": "Morphologie normale",
        "volume": "Volume"
      },
      "embryo": {
        "fertilisation_date": "Date de fécondation",
        "fertilisation_date_placeholder": "Date de fécondation",
        "freeze_date": "Date de congélation",
        "freeze_date_placeholder": "Date de congélation",
        "day_of_development": "Jour de développement",
        "date_relationship_hint": "Si une date manque, nous l'estimons à partir de l'autre date et du jour de développement sélectionné. Vous pouvez modifier l'estimation pour qu'elle corresponde à votre compte rendu.",
        "fertilisation_method": "Méthode de fécondation",
        "genetic_testing": "Test génétique (DPI)",
        "development_scope_group": "Pour ce groupe d'embryons",
        "development_scope_group_hint": "Ces dates et détails du développement s'appliquent à tout le groupe défini à l'étape précédente.",
        "entry_mode": "Mode de saisie",
        "group_mode": "Récapitulatif groupé",
        "individual_mode": "Embryons individuels",
        "group_summary": "Récapitulatif groupé",
        "individual_development_hint": "Pour chaque embryon, indiquez le jour le plus avancé atteint et s'il a été congelé ou arrêté. Les tuiles de jours illustrent le stade de développement.",
        "development_day_reached": "Jour le plus avancé atteint",
        "outcome": "Résultat",
        "total_embryos_created": "Total d'embryons créés",
        "number_frozen": "Nombre congelés",
        "number_tested": "Embryons testés génétiquement",
        "number_euploid": "Euploïdes (normaux)",
        "number_aneuploid": "Aneuploïdes (anormaux)",
        "number_mosaic": "Mosaïques",
        "number_no_result": "Sans résultat / en attente",
        "transferred": "Transférés",
        "discarded": "Éliminés",
        "currently_in_storage": "Actuellement en conservation",
        "override": "modifier",
        "auto": "auto",
        "embryo_index": "Embryon n°${n}",
        "embryo_id": "Identifiant embryon",
        "embryo_id_placeholder": "p. ex. E1",
        "grade": "Grade",
        "grade_placeholder": "Grade",
        "genetic_status": "Statut génétique",
        "genetic_status_placeholder": "Statut génétique",
        "sex": "Sexe",
        "sex_placeholder": "Sexe",
        "status": "Statut",
        "notes_placeholder": "Notes sur cet embryon...",
        "add_embryo": "Ajouter un embryon"
      },
      "options": {
        "storage_type": {
          "clinic": "Centre d'AMP",
          "hospital": "Hôpital",
          "cryobank": "Cryobanque",
          "other": "Autre"
        },
        "country": {
          "us": "États-Unis",
          "gb": "Royaume-Uni",
          "ca": "Canada",
          "au": "Australie",
          "de": "Allemagne",
          "fr": "France",
          "es": "Espagne",
          "it": "Italie",
          "cz": "République tchèque",
          "gr": "Grèce",
          "cy": "Chypre",
          "in": "Inde",
          "jp": "Japon",
          "mx": "Mexique",
          "il": "Israël",
          "other": "Autre"
        },
        "freezing_method": {
          "vitrification": "Vitrification",
          "slow_freeze": "Congélation lente",
          "unknown": "Inconnue"
        },
        "oocyte_status": {
          "in_storage": "En conservation",
          "partially_thawed": "Partiellement décongelés",
          "all_thawed": "Tous décongelés",
          "used": "Utilisés",
          "discarded": "Éliminés",
          "donated": "Donnés"
        },
        "embryo_day": {
          "1": "J1",
          "2": "J2",
          "3": "J3 (clivage)",
          "4": "J4 (morula)",
          "5": "J5 (blastocyste)",
          "6": "J6 (blastocyste)",
          "7": "J7"
        },
        "embryo_grade": {
          "6AA": "6AA – Excellent",
          "5AA": "5AA – Excellent",
          "4AA": "4AA – Excellent",
          "4AB": "4AB – Très bon",
          "4BA": "4BA – Très bon",
          "4BB": "4BB – Bon",
          "3AA": "3AA – Bon",
          "3AB": "3AB – Bon",
          "3BA": "3BA – Moyen",
          "3BB": "3BB – Moyen",
          "2BB": "2BB – Moyen",
          "other": "Autre / Inconnu"
        },
        "fertilisation_method": {
          "ivf": "FIV classique",
          "icsi": "ICSI",
          "split": "Mixte (50/50 ICSI/FIV)",
          "unknown": "Inconnue"
        },
        "pgt": {
          "not_performed": "Non réalisé",
          "pgt_a": "DPI-A (Aneuploïdies)",
          "pgt_m": "DPI-M (Monogénique)",
          "pgt_sr": "DPI-SR (Structurel)",
          "pgt_a_m": "DPI-A + DPI-M",
          "pgt_p": "DPI-P (Polygénique)",
          "pending": "Résultats en attente"
        },
        "genetic_status": {
          "euploid": "Euploïde (normal)",
          "aneuploid": "Aneuploïde (anormal)",
          "mosaic_low": "Mosaïque faible",
          "mosaic_high": "Mosaïque élevée",
          "no_result": "Aucun résultat",
          "not_tested": "Non testé",
          "pending": "En attente"
        },
        "embryo_status": {
          "frozen": "Congelé",
          "arrested": "Arrêté / non congelé",
          "transferred": "Transféré",
          "discarded": "Éliminé",
          "donated": "Donné",
          "research": "Donné à la recherche",
          "thawed_refrozen": "Décongelé et recongelé"
        },
        "sex": {
          "unknown": "Inconnu",
          "xx": "XX (féminin)",
          "xy": "XY (masculin)",
          "prefer_not": "Préfère ne pas savoir"
        },
        "semen_processing": {
          "none": "Aucune préparation supplémentaire",
          "washed": "Lavé",
          "swim_up": "Sélection swim-up",
          "density_gradient": "Sélection par gradient de densité",
          "dgc_swim_up": "Gradient de densité + swim-up",
          "microfluidics": "Sélection microfluidique",
          "macs": "Sélection MACS",
          "other": "Autre / Je ne sais pas"
        },
        "semen_collection": {
          "ejaculation": "Éjaculation",
          "tese": "TESE (extraction testiculaire)",
          "pesa": "PESA (aspiration épididymaire)",
          "mesa": "MESA (extraction microchirurgicale)",
          "other": "Autre"
        }
      }
    }
  },
  "homepage": {
    "shared": {
      "stimulation": "Stimulation",
      "semen_analysis": "Spermogramme",
      "eggs_retrieved": "Ovocytes ponctionnés",
      "done": "Terminé",
      "blastocysts": "Blastocystes",
      "baseline": "Bilan initial",
      "upload_semen_analysis_results": "tes résultats de spermogramme",
      "step_n_of_total": "Étape ${stepNumber} sur ${totalSteps}",
      "step_n_complete": "Étape ${stepNumber} terminée",
      "sperm_side": "Côté sperme",
      "set_cycle_start": "Définir le début du cycle",
      "scheduled_date": "Prévu : ${date}",
      "results_pending": "Résultats en attente",
      "results_expected_date": "Résultats attendus : ${date}",
      "reduce_avoidable_exposures": "Réduire les expositions évitables",
      "partner": "Partenaire",
      "often_10_20_eggs": "Souvent 10-20 ovocytes",
      "mature_eggs": "Ovocytes matures",
      "lifestyle_factors": "Facteurs liés au mode de vie",
      "future_use": "Usage futur",
      "freezing": "Congélation",
      "cycle_timing": "Calendrier du cycle",
      "cycle_estimate": "Estimation du cycle",
      "continue_medical_history": "Continuer l'historique médical",
      "checklist_both": "Checklist — pour vous deux",
      "check_semen_testing": "Vérifier le spermogramme"
    },
    "afc_source_sheet": {
      "title": "Enregistrer le résultat d'AFC",
      "subtitle": "Joins le compte rendu ou saisis le nombre.",
      "existing_section": "Tes résultats d'AFC",
      "value_label": "Ta valeur d'AFC",
      "value_hint": "Total des follicules 2–10 mm sur les deux ovaires",
      "date_label": "Date du test",
      "notes_label": "Notes (facultatif)",
      "notes_placeholder": "Ce que tu aimerais retenir de ce résultat…",
      "saving": "Enregistrement…",
      "save_error": "L'enregistrement a échoué. Réessaie.",
      "remove_afc": "Retirer l'AFC de cette estimation",
      "high_value_warning": "Ce comptage est très élevé. Vérifie que seuls les follicules de 2–10 mm sont comptés, sur les deux ovaires."
    },
    "amh_source_sheet": {
      "title": "Ton AMH",
      "subtitle_with_result": "Ton dernier résultat est utilisé. Ajoute un résultat plus récent pour mettre à jour l'estimation.",
      "subtitle_empty": "Ajoute un résultat d'AMH pour personnaliser ton estimation.",
      "latest_section": "Dernier résultat utilisé",
      "previous_section": "Résultats précédents",
      "add_first_section": "Ajouter ton résultat",
      "add_new_section": "Ajouter un résultat plus récent",
      "add_new_action": "Ajouter un résultat plus récent",
      "manual_section": "Saisir manuellement",
      "value_label": "Valeur",
      "unit_label": "Unité",
      "date_label": "Date",
      "save_and_use": "Enregistrer et utiliser dans mon estimation",
      "saving": "Enregistrement…",
      "save_error": "L'enregistrement a échoué. Réessaie.",
      "remove_amh": "Retirer l'AMH de cette estimation",
      "high_value_warning_ng": "Cette valeur d'AMH est très élevée. Vérifie l'unité — 100 pmol/L ≈ 14 ng/mL.",
      "high_value_warning_pmol": "C'est une valeur très élevée. Vérifie que l'unité est bien pmol/L.",
      "source_line": "Estimation basée sur La Marca et al., 2011 (nomogramme âge + AMH). Au-delà de 10 ng/mL, la valeur est traitée comme 10 dans le calcul."
    },
    "test_result_document": {
      "upload_action": "Téléverser un résultat",
      "upload_description": "Ajoute un compte rendu pour extraire chaque résultat et le conserver comme preuve."
    },
    "clinic_shortlist_section": {
      "criterion_added": "${label} ajouté·e",
      "criterion_add": "Ajouter ${label}",
      "unlock_shortlist": "Débloque ta short-list de cliniques",
      "not_ready_yet": "Ta short-list de cliniques n'est pas encore prête"
    },
    "education_block": {
      "how_it_works": "Comment ça marche",
      "personalized_for_age": "Personnalisé pour ton âge",
      "see_personalized_estimate": "Voir ton estimation personnalisée"
    },
    "emotional_context_card": {
      "youre_not_alone": "Tu n'es pas seul·e"
    },
    "enhanced_emotional_card": {
      "physically": "Physiquement"
    },
    "hero": {
      "open_hero_actions": "Ouvrir les actions du hero"
    },
    "medication_row": {
      "in_transit": "En transit",
      "pickup_ready": "Prêt à récupérer",
      "low_stock": "Stock faible",
      "not_on_hand": "Pas en stock",
      "ordered": "Commandé"
    },
    "outcome_dot_funnel_rows": {
      "add_stage": "Ajouter ${label}",
      "action_add": "Ajouter",
      "action_edit": "Modifier"
    },
    "step_card": {
      "checklist": "Check-list"
    },
    "step_section": {
      "learn": "En savoir plus",
      "continue_cycle": "Continuer ton cycle"
    },
    "substep_row": {
      "results_will_appear_message": "Quand tes résultats arrivent, ils s'affichent ici avec une interprétation personnalisée. On te prévient dès qu'ils sont là.",
      "in_the_meantime": "En attendant",
      "results_in": "Résultats reçus"
    },
    "task_section_card": {
      "collapse_title": "Replier ${title}",
      "expand_title": "Déplier ${title}",
      "mark_title_incomplete": "Marquer ${title} comme non terminé",
      "mark_title_done": "Marquer ${title} comme terminé",
      "collapse_step": "Replier ${stepLabel}",
      "expand_step": "Déplier ${stepLabel}",
      "mark_step_incomplete": "Marquer ${stepLabel} comme non terminé",
      "mark_step_done": "Marquer ${stepLabel} comme terminé",
      "mark_as_done": "Marquer comme fait"
    },
    "test_result_insight_card": {
      "waiting_for_results": "En attente des résultats",
      "new_result": "Nouveau résultat",
      "scheduled": "Programmé",
      "scheduled_trimmed": "Programmé ${trimmed}",
      "purpose_with_expected": "${testPurpose} · résultat attendu ${expectedLabel}"
    },
    "embryo_freezing_clinic_step": {
      "know_what_to_compare": "Sache quoi comparer",
      "know_what_to_compare_detail": "Qualité du labo, ICSI, PGT-A, fréquence des updates, congélation, stockage et coût total."
    },
    "embryo_freezing_start_cycle": {
      "title": "Tu démarres un cycle de vitrification d'embryons ?",
      "body": "Quand ta clinique te donne une date, ça devient ton espace traitement pour la stimulation, la ponction, le recueil du sperme, la fécondation, la culture embryonnaire et les updates de vitrification.",
      "sperm_collection_plan": "Plan de recueil du sperme",
      "fertilization_method": "Méthode de fécondation",
      "lab_update_schedule": "Calendrier des updates labo"
    },
    "optimization_card": {
      "optimization_window": "Fenêtre d'optimisation",
      "window_description": "${cycle}. Tu as une fenêtre de ${window} pour améliorer ta base avant ${retest}.",
      "count_items": "${count} éléments",
      "supplements": "Compléments"
    },
    "optimization_card_v2": {
      "optimize_before_cycle": "Optimise avant ton cycle",
      "things_to_start_now": "Des choses à commencer maintenant qui prennent du temps à agir",
      "egg_quality_paragraph": "La qualité ovocytaire est influencée par ce qui se passe pendant les 3 mois avant la ponction — c'est le temps de maturation des ovocytes. Commencer compléments et changements de mode de vie maintenant leur laisse le temps d'agir avant ton cycle.",
      "evidence_paragraph": "Ça ne fera pas tout, mais les preuves montrent un vrai gain pour la qualité ovocytaire. La qualité du sperme de ton·ta partenaire bénéficie aussi du même timing (~74 jours pour la régénération du sperme).",
      "start_supplements": "Commencer les compléments",
      "supplements_subtitle": "Le CoQ10 (400-600 mg/jour) soutient la fonction mitochondriale des ovocytes. Vitamine D, folate et oméga-3 sont aussi souvent recommandés. Commence 2-3 mois avant ton cycle pour un effet optimal.",
      "lifestyle_subtitle": "Sommeil, activité modérée, alimentation équilibrée et alcool limité soutiennent la qualité ovocytaire. Aucun changement isolé n'est critique. C'est l'ensemble qui compte.",
      "partner_start_supplements": "Partenaire : commencer les compléments",
      "partner_supplements_subtitle": "CoQ10, zinc, folate et vitamine D soutiennent la qualité du sperme. Évite la chaleur (jacuzzi, sauna, ordi sur les genoux), limite l'alcool et reste actif·ve.",
      "track_progress": "Suis tes progrès",
      "track_progress_subtitle": "Fais un AMH de base maintenant et refais le test 2-3 mois plus tard pour voir si ton protocole marche.",
      "guided_program": "Programme accompagné",
      "guided_program_subtitle": "On t'envoie les tests et les compléments, et on suit ta progression jour après jour vers ton objectif de ponction.",
      "coming_soon": "Bientôt disponible"
    },
    "medical_history_step": {
      "title": "Historique médical",
      "level_health_champion": "Champion·ne santé",
      "level_wellness_pro": "Pro du bien-être",
      "level_health_explorer": "Exploratrice·eur santé",
      "level_getting_started": "Démarrage",
      "level_newcomer": "Nouveau venu·e",
      "level_xp": "${title} · ${xp} XP",
      "loading": "Chargement…",
      "all_sections_complete": "Toutes les sections sont complètes !",
      "complete_history_unlocks": "Un historique complet débloque",
      "unlock_treatment_personalisation": "personnalisation du traitement",
      "unlock_medication_safety": "contrôles de sécurité médicamenteuse",
      "unlock_risk_screening": "dépistage des facteurs de risque",
      "unlock_clinic_summaries": "synthèses prêtes pour la clinique",
      "and_more": "et plus encore.",
      "continue": "Continuer"
    },
    "pre_cycle_hero_card": {
      "your_plan": "Ton plan",
      "edit_plan": "Modifier le plan",
      "complete_setup": "Termine ta configuration pour personnaliser ce plan",
      "keep_shaping_plan": "Continue à façonner ton plan avant le début du traitement",
      "start_with_history": "Commence par l'historique médical pour que ta prépa, tes options de soin et le timing s'ajustent à toi.",
      "active_step_summary": "${activeStepTitle} est la prochaine étape. ${subtitle}",
      "fallback_subtitle": "Sers-toi de ça pour faire avancer ton plan.",
      "your_path": "Ton parcours",
      "steps_complete": "${completedSteps} étapes sur ${totalSteps} terminées",
      "steps_complete_one": "${completedSteps} étape sur ${totalSteps} terminée",
      "plan_not_set": "Plan non défini"
    },
    "pre_cycle_egg_freezing": {
      "eyebrow": "Planification vitrification d'ovocytes",
      "title": "Explore la vitrification d'ovocytes et construis ton plan",
      "cycle_start_label": "Pas encore programmé",
      "phase_description": "Avant de choisir une clinique ou de démarrer la stimulation, cet espace t'aide à comprendre le processus, à rassembler les infos de base utiles, à comparer les options et à décider de la suite. Une fois un cycle programmé, ça bascule en vue traitement actif.",
      "intro": "En quelques minutes, on te guide à travers ce que tu dois savoir et ce que tu peux faire ensuite.",
      "open_plan_a11y": "Ouvrir le plan de préparation vitrification d'ovocytes",
      "toggle_plan_a11y": "Afficher/masquer ton plan de préparation",
      "next": "Suivant",
      "choose_next_step": "Choisis ta prochaine étape",
      "treatment_cycle": "Cycle de traitement",
      "no_treatment_scheduled": "Aucun traitement programmé",
      "add_treatment_dates": "Ajouter des dates de traitement"
    },
    "pre_cycle_embryo_freezing": {
      "eyebrow": "Planification vitrification d'embryons",
      "title": "Prépare-toi pour la vitrification d'embryons",
      "cycle_start_label": "Pas encore programmé",
      "phase_description": "Avant qu'un cycle ne démarre, la vitrification d'embryons demande de coordonner stimulation ovarienne, source ou tests du sperme, méthode de fécondation, culture embryonnaire, éventuel PGT-A et compatibilité labo. Cet espace t'aide à comprendre ce qui compte avant le traitement actif.",
      "intro": "En quelques minutes, on passe en revue ce que tu dois comprendre, tester, optimiser et comparer avant de démarrer.",
      "open_plan_a11y": "Ouvrir le plan de préparation vitrification d'embryons",
      "toggle_plan_a11y": "Afficher/masquer ton plan de préparation"
    },
    "pre_cycle_sperm_freezing": {
      "eyebrow": "Planification congélation de sperme",
      "title": "Planifie la congélation de sperme sans deviner",
      "cycle_start_label": "Pas encore programmé",
      "phase_description": "Avant de vitrifier des échantillons, cet espace t'aide à comprendre le spermogramme, le timing du recueil, le stockage, l'intérêt de vitrifier maintenant et si une fenêtre d'optimisation de 90 jours vaut le coup avant.",
      "intro": "En quelques minutes, on passe en revue ce qu'il faut tester, ce qui peut changer et comment avancer vers la banque.",
      "open_plan_a11y": "Ouvrir le plan de préparation congélation de sperme",
      "toggle_plan_a11y": "Afficher/masquer ton plan de préparation",
      "reset_window": "Fenêtre de reset",
      "reset_window_value": "Fenêtre de reset 72-90 jours"
    },
    "treatment_phase": {
      "baseline": "Bilan de départ",
      "stimulation": "Stimulation",
      "trigger": "Déclenchement",
      "retrieval": "Ponction",
      "fertilization": "Fécondation",
      "embryo_development": "Développement embryonnaire",
      "transfer": "Transfert d'embryon",
      "waiting": "Attente de deux semaines",
      "complete": "Cycle terminé",
      "day_of_total": "Jour ${dayInPhase} sur ~${totalPhaseDays}",
      "day_only": "Jour ${dayInPhase}",
      "guidance_stim_1_3": "Une réponse faible est normale les premiers jours. Tes follicules commencent juste à répondre.",
      "guidance_stim_4_7": "Tes follicules grandissent. Tu peux commencer à sentir des ballonnements et de la pression.",
      "guidance_stim_8_10": "La majeure partie de la croissance se passe maintenant. Visites de monitoring fréquentes. Les follicules devraient être entre 14 et 18 mm.",
      "guidance_stim_10_14": "On approche du déclenchement. Les plus gros follicules devraient être à 17-20 mm.",
      "guidance_wait_1_3": "L'embryon éclot et commence à s'attacher.",
      "guidance_wait_4_7": "L'implantation est en cours. Crampes et petits saignements sont normaux.",
      "guidance_wait_8_14": "Le taux d'hCG monte si l'implantation a réussi. La prise de sang donnera la réponse définitive."
    },
    "sperm_freezing_baseline": {
      "step_label": "Étape 2 : Connais ton point de départ",
      "what_to_test": "Ce que tu peux tester",
      "what_to_test_subtitle": "Commence par le spermogramme, puis va plus loin seulement si le résultat ou l'historique le justifie.",
      "upload_subtitle": "Garde résultats de base et de répétition au même endroit pour que le plan puisse comparer.",
      "core_test": "Test principal",
      "semen_analysis_body": "Mesure volume, concentration, numération totale, mobilité, morphologie, et parfois cellules rondes ou viscosité. C'est la base pour les décisions de congélation.",
      "check_testing": "Voir les tests",
      "often_required": "Souvent exigé",
      "infectious_disease_title": "Dépistage des maladies infectieuses",
      "infectious_disease_body": "Les labos peuvent exiger un dépistage VIH, hépatite B, hépatite C, syphilis et autres avant ou autour du stockage, surtout si les échantillons peuvent être utilisés en traitement.",
      "sometimes_useful": "Parfois utile",
      "dna_fragmentation_title": "Fragmentation de l'ADN",
      "dna_fragmentation_body": "À discuter en cas de spermogramme anormal, pertes répétées, échecs de FIV, inquiétudes liées à l'âge ou expositions importantes.",
      "if_abnormal": "Si anormal",
      "hormones_urology_title": "Bilan hormonal et urologie",
      "hormones_urology_body": "Si la numération est basse ou si des symptômes évoquent un problème hormonal, un·e clinicien·ne peut doser testostérone, FSH, LH, prolactine, estradiol, thyroïde, ou orienter en urologie reproductive."
    },
    "sperm_freezing_start": {
      "title": "Prêt·e à vitrifier des échantillons ?",
      "body": "Quand tu es prêt·e, définis une date de début pour lancer ton espace banque : timing du recueil, comptes-rendus, fioles et stockage. Tu pourras ajouter un labo ou une clinique plus tard.",
      "set_banking_start": "Définir le début de la banque",
      "collection_timing": "Timing du recueil",
      "abstinence_window": "Fenêtre d'abstinence",
      "sample_reports": "Comptes-rendus d'échantillon",
      "storage_plan": "Plan de stockage"
    },
    "sperm_freezing_understand": {
      "step_label": "Étape 1 : Comprendre",
      "how_it_works_title": "Comment fonctionne la congélation de sperme",
      "how_it_works_subtitle": "Production de sperme, spermogramme, congélation, fioles, stockage et usage futur.",
      "what_matters_here_label": "Ce qui compte ici",
      "turnover_label": "Renouvellement du sperme",
      "continuous_title": "Le sperme se fabrique en continu",
      "continuous_body": "Le nouveau sperme se développe sur environ 72-90 jours. Ce qui veut dire que chaleur récente, maladie, médicaments, hormones, tabac, cannabis, alcool, sommeil et santé métabolique peuvent ressortir dans l'échantillon.",
      "continuous_callout": "C'est pour ça que beaucoup banquent un échantillon de base maintenant, puis optimisent et refont un test plus tard s'ils ont le temps.",
      "semen_analysis_title": "Le spermogramme explique le point de départ",
      "semen_analysis_body": "Les chiffres clés sont volume, concentration, numération totale, mobilité et morphologie. Ils aident à décider combien d échantillons vitrifier et quel usage futur est réaliste.",
      "semen_analysis_callout": "Un résultat normal ne garantit pas la fertilité future ; il donne une photo utile.",
      "collection_label": "Recueil",
      "collection_title": "Le timing du recueil influence l'échantillon",
      "collection_body": "La plupart des labos demandent 2-5 jours d'abstinence avant le recueil. Plus long n'est pas forcément mieux : un sperme plus vieux peut avoir moins de mobilité ou plus de dommages à l'ADN.",
      "collection_callout": "Beaucoup banquent 2-3 échantillons, souvent espacés de quelques jours, pour créer une redondance.",
      "freezing_title": "L'échantillon est divisé en fioles congelées",
      "freezing_body": "Le labo analyse l'échantillon, ajoute un cryoprotecteur, le divise en fioles et le stocke dans l'azote liquide à environ -196 °C.",
      "freezing_callout": "Une perte de mobilité après décongélation est attendue, donc les chiffres avant congélation et le nombre de fioles comptent tous les deux.",
      "future_use_title": "Les fioles correspondent à différentes procédures futures",
      "future_use_body": "L'IUI demande en général plus de spermatozoïdes mobiles par tentative. La FIV-ICSI en demande souvent moins, mais ça dépend de la politique du labo, de la qualité et des projets futurs.",
      "future_use_callout": "Le but, ce n'est pas juste de congeler un échantillon. C'est de conserver assez de matière utilisable pour le chemin que tu pourras choisir.",
      "storage_label": "Stockage",
      "storage_title": "Le stockage, c'est une décision dans la durée",
      "storage_body": "Tu auras en général des frais annuels, des renouvellements de consentement et des choix futurs sur conservation, transport, don ou destruction des échantillons.",
      "storage_callout": "Un bon labo doit clarifier les conditions de stockage, les règles de transfert et l'accès futur avant que tu banques."
    },
    "egg_freezing_clinic_timeline": {
      "see_clinic_matches": "Voir les cliniques qui correspondent",
      "complete_medical_history": "Compléter l'historique médical",
      "check_coverage_status": "Vérifier le statut de couverture",
      "add_location": "Ajouter une localisation",
      "explore_concierge": "Explorer le matching concierge",
      "concierge_program": "Programme de matching concierge",
      "concierge_subtitle": "Sois accompagné·e pour coordonner tests, choix de médecin, accès clinique et économies avant de t'engager.",
      "testing": "Tests",
      "doctors": "Médecins",
      "savings": "Économies",
      "history": "Historique",
      "history_added": "Historique ajouté",
      "complete_history": "Compléter l'historique",
      "location": "Localisation",
      "location_added": "Localisation ajoutée",
      "coverage_status": "Statut de couverture",
      "coverage_checked": "Couverture vérifiée",
      "check_coverage": "Vérifier la couverture",
      "step_4_find_care": "Étape 4 : Trouver des soins",
      "step_3_choose_clinic": "Étape 3 : Choisis ta clinique",
      "find_care": "Trouver des soins",
      "find_care_sperm": "Cherche des labos, cliniques et banques de sperme pour spermogramme, cryoconservation et stockage.",
      "find_care_embryo": "Cherche des cliniques, labos d'embryologie et professionnel·les pour la vitrification d'embryons.",
      "find_care_egg": "Cherche des cliniques, labos et professionnel·les pour la vitrification d'ovocytes.",
      "labs_selected": "Labos sélectionnés pour toi",
      "clinics_selected": "Cliniques sélectionnées pour toi",
      "shortlist_sperm": "Une short-list basée sur ta localisation, ta couverture, tes besoins en tests, tes préférences de recueil et le stockage adapté.",
      "shortlist_embryo": "Une short-list basée sur ta localisation, ta couverture, tes besoins en labo embryo et ce qui compte pour ce cycle.",
      "shortlist_egg": "Une short-list basée sur ta localisation, ta couverture et ce qui compte pour ce cycle.",
      "locked_sperm": "On s'appuie sur ton historique, ta localisation, ta couverture et tes préférences de banque pour rendre les correspondances pertinentes. Couverture peut vouloir dire avantages ou à ta charge.",
      "locked_embryo": "On s'appuie sur ton historique, ta localisation, ta couverture et tes préférences vitrification d'embryons pour rendre les correspondances pertinentes. Couverture peut vouloir dire avantages ou à ta charge.",
      "locked_egg": "On s'appuie sur ton historique, ta localisation et ta couverture pour rendre les correspondances pertinentes. Couverture peut vouloir dire avantages ou à ta charge.",
      "empty_sperm": "Tes critères sont prêts, mais les données de correspondance ne sont pas encore branchées ici. Tu peux quand même chercher dans le répertoire.",
      "empty_clinic": "Tes critères sont prêts, mais les données de correspondance ne sont pas encore branchées ici. Tu peux quand même chercher dans le répertoire."
    },
    "egg_freezing_cycle_start": {
      "starting_soon": "Bientôt prêt·e à démarrer ?",
      "body": "Quand ta clinique te donne une date, ça devient ton espace traitement pour les jours à venir.",
      "medication_schedule": "Calendrier des médicaments",
      "monitoring_plan": "Plan de monitoring",
      "daily_guidance": "Guidage au quotidien"
    },
    "cycle_complete": {
      "your_results": "Tes résultats",
      "positive": "Positif",
      "positive_message": "Félicitations. Respire un grand coup. Ta clinique va suivre la montée de l'hCG dans les prochaines semaines.",
      "negative_message": "Ce cycle n'a pas abouti à une grossesse. On est désolé·e·s. Un cycle qui n'aboutit pas reste une source d'informations précieuses pour ta clinique sur la façon dont ton corps répond — ce n'est pas repartir de zéro, c'est s'appuyer sur des données.",
      "maturity_rate": "Taux de maturité de ${maturityRate} %",
      "fertilized": "Ovocytes fécondés",
      "frozen": "Vitrifiés",
      "what_numbers_mean": "Ce que ces chiffres veulent dire",
      "eggs": "ovocytes",
      "embryos": "embryons",
      "samples": "échantillons",
      "cryo_storage": "Cryoconservation",
      "count_type_at_facility": "${itemCount} ${typeLabel} chez ${facilityName}",
      "count_type": "${itemCount} ${typeLabel}",
      "storage_with_payment": "Stockage : ${annualCost}/an • Prochain paiement : ${nextPaymentDate}",
      "storage_only": "Stockage : ${annualCost}/an",
      "view_cryo_vault_details": "Voir le détail du coffre cryo",
      "mature_eggs_matter": "Ce sont les ovocytes matures qui comptent le plus",
      "mature_eggs_matter_body": "Seuls les ovocytes matures MII sont en général vitrifiés. Le nombre d'ovocytes matures peut être inférieur au nombre prélevé.",
      "storage_ongoing": "Le stockage, c'est dans la durée",
      "storage_ongoing_body": "La plupart des centres facturent à l'année. Les frais de stockage sont souvent distincts du coût du cycle.",
      "decide_later": "Tu peux décider plus tard",
      "decide_later_body": "Certain·e·s stockent et attendent. D'autres envisagent un nouveau cycle si leur objectif demande plus d'ovocytes en réserve.",
      "open_cryo_vault": "Ouvrir ton coffre cryo",
      "open_cryo_vault_subtitle": "Suivre tes ovocytes vitrifiés, les détails de stockage et leur usage futur.",
      "view_cryo_vault": "Voir le coffre cryo",
      "add_documents": "Ajouter des documents de ponction ou de stockage",
      "add_documents_subtitle": "Importe les comptes-rendus de labo, contrats de stockage ou factures.",
      "upload_documents": "Importer des documents de stockage",
      "consider_another": "Envisager un autre cycle",
      "consider_another_subtitle": "Sers-toi de tes résultats pour décider si vitrifier plus d'ovocytes a du sens.",
      "start_another": "Démarrer un autre cycle",
      "after_retrieval": "Après la ponction",
      "frozen_eggs_decisions": "Ovocytes vitrifiés et prochaines décisions",
      "cycle_is_complete": "Ton cycle est terminé",
      "whats_next": "Et maintenant ?",
      "emotional_message": "Quoi que tu ressentes en ce moment — soulagement, épuisement, fierté, incertitude — tout est légitime. Tu as fait quelque chose qui compte pour la personne que tu seras demain.",
      "annual_reminders": "Rappels annuels",
      "storage_payment_reminder": "Rappel de paiement du stockage",
      "annual_wellness_check": "Bilan de santé annuel",
      "review_fertility_plan": "Revoir ton plan fertilité"
    },
    "outcome_funnel": {
      "family_outlook": "Perspective projet parental",
      "cycle_estimate": "Estimation ${cycleType}",
      "intro": "Cette vue de planification part de tes données de traitement les plus récentes, puis affine via l'entonnoir vitrification et usage futur. Les chiffres se mettent à jour avec le monitoring, la ponction, le labo et les résultats génétiques. Ajuste une étape pour voir l'entonnoir se recalculer.",
      "planning_targets": "Objectifs de planification",
      "one_child": "1 enfant",
      "one_child_value": "Démarre souvent autour de 10-20 ovocytes matures vitrifiés",
      "two_children": "2 enfants",
      "two_children_value": "Démarre souvent autour de 20-35 ovocytes matures vitrifiés",
      "three_children": "3 enfants",
      "three_children_value": "Démarre souvent autour de 35-50+ ovocytes matures vitrifiés",
      "disclaimer": "Les estimations sont des fourchettes de planification, pas des garanties. Ta clinique peut les ajuster selon l'âge, le diagnostic, l'historique labo et la réponse au traitement.",
      "eggs_retrieved_detail": "Projeté à partir de la réponse folliculaire actuelle",
      "mature_eggs_detail": "Ovocytes MII estimés",
      "frozen_eggs_label": "Ovocytes vitrifiés",
      "frozen_eggs_detail": "Ovocytes vitrifiés utilisables estimés",
      "fertilized_eggs_label": "Ovocytes fécondés",
      "fertilized_eggs_detail": "Projection décongélation + fécondation",
      "euploids_label": "Embryons euploïdes",
      "euploids_detail": "Projection embryons + tests",
      "live_births_label": "Naissances vivantes",
      "live_births_detail": "Projection projet parental"
    },
    "partner_home": {
      "your_partner": "ton·ta partenaire",
      "shared_summary_unavailable_title": "Les détails du parcours partagé ne sont pas encore disponibles",
      "shared_summary_unavailable_body": "Le parcours de ton·ta partenaire apparaîtra ici lorsqu’un résumé partagé autorisé sera disponible. Les informations cliniques privées restent privées.",
      "partner_tasks_unavailable_body": "Les tâches de partenaire apparaîtront lorsqu’un responsable sera attribué par le serveur et que l’autorisation d’agir sera confirmée.",
      "how_to_support": "Comment soutenir ${primaryName}",
      "primary_journey": "Le parcours ${journeyTitle} de ${primaryName}",
      "your_tasks": "Tes tâches",
      "count_remaining": "${count} restantes",
      "all_done": "Tout est fait !",
      "completed_count": "Terminées (${count})",
      "what_experiencing": "Ce qu'il vit",
      "how_feeling": "Ce qu'il pourrait ressentir",
      "how_you_help": "Comment tu peux aider",
      "test_physical": "${primaryName} est en train de faire ses tests de base. Certains demandent un timing de cycle précis, ce qui peut ajouter du stress.",
      "test_emotional": "Attendre des résultats peut être anxiogène. Être présent·e pour écouter sans chercher à tout résoudre, c'est le meilleur soutien.",
      "test_help_1": "Propose de conduire aux rendez-vous",
      "test_help_2": "Demande s'il veut parler des résultats ou juste rester ensemble",
      "test_help_3": "Fais tes propres tests rapidement — ça montre que tu es engagé·e à égalité",
      "prep_physical": "${primaryName} prépare le cycle — paperasse, compléments et logistique.",
      "prep_emotional": "L'attente avant le traitement peut être excitante et terrifiante à la fois.",
      "prep_help_1": "Aide pour les appels assurance et la paperasse",
      "prep_help_2": "Renseigne-toi sur les médicaments et les injections",
      "prep_help_3": "Planifie la logistique des visites de monitoring et du jour de la ponction",
      "treatment_physical": "${primaryName} fait des injections quotidiennes qui peuvent provoquer ballonnements, sautes d'humeur et fatigue. C'est normal — ça veut dire que les médicaments agissent.",
      "treatment_emotional": "L'inconfort physique combiné aux enjeux émotionnels peut être écrasant. Patience et présence comptent plus que les mots.",
      "treatment_help_1": "Aide à préparer les injections et à rappeler les horaires",
      "treatment_help_2": "Prends en charge les tâches ménagères — iel peut être physiquement gêné·e",
      "treatment_help_3": "Va aux rendez-vous de monitoring quand c'est possible",
      "treatment_help_4": "Le jour de la ponction : ramène-le·la à la maison, prépare de quoi se sentir bien",
      "wait_physical": "${primaryName} est dans les deux semaines d'attente après le transfert. Il est sous progestérone, qui provoque des symptômes identiques à ceux du début de grossesse.",
      "wait_emotional": "C'est la période émotionnellement la plus difficile. Chaque symptôme paraît chargé de sens. Évite d'être trop optimiste ou minimisant·e.",
      "wait_help_1": "Ne demande pas « tu te sens enceinte ? » — il ne peut pas le savoir, toi non plus",
      "wait_help_2": "Garde la vie normale — la routine stabilise",
      "wait_help_3": "Sois présent·e sans en faire le seul sujet de conversation",
      "wait_help_4": "Aie un plan pour les deux résultats possibles — sache quoi dire dans tous les cas"
    },
    "fet_participant_view": {
      "shared_plan_title": "Ta vue de participation au TEC",
      "shared_plan_body": "Ce résumé affiche uniquement les tâches et le statut des consentements autorisés par tes permissions actives. Les informations cliniques et génétiques privées restent protégées.",
      "role_summary": "Ton rôle : ${role}",
      "plan_status": "Statut du plan : ${status}",
      "tasks_section": "Tâches qui te sont attribuées",
      "no_assigned_tasks": "Aucune tâche de TEC ne t'est encore attribuée.",
      "consent_section": "Statut des consentements",
      "consent_status": "Statut : ${status}",
      "role_recipient": "destinataire",
      "role_partner": "partenaire",
      "role_intended_parent": "parent d'intention",
      "role_gestational_carrier": "gestatrice",
      "role_donor": "donneur ou donneuse",
      "role_genetic_source": "source génétique",
      "role_care_coordinator": "coordinateur ou coordinatrice de soins",
      "role_custodian": "dépositaire",
      "role_not_reported": "non indiqué",
      "task_medications": "Tâche de médicaments du destinataire",
      "task_monitoring": "Tâche de suivi du destinataire",
      "task_transfer_acknowledgement": "Accusé de réception du transfert",
      "task_beta_collection": "Prélèvement de bêta",
      "task_recipient_consent": "Consentement du destinataire",
      "task_embryo_authorization": "Autorisation concernant l'embryon",
      "task_backup_decision": "Décision concernant l'embryon de secours",
      "task_clinic_coordination": "Coordination avec le centre",
      "task_transport_coordination": "Coordination du transport",
      "task_storage_chain_of_custody": "Chaîne de traçabilité du stockage",
      "task_result_review": "Revue des résultats"
    },
    "embryo_freezing_optimization": {
      "step_label": "Étape 3 : Améliore tes inputs",
      "what_can_be_optimized": "Ce que tu peux optimiser",
      "what_can_be_optimized_subtitle": "Si le sperme fait partie du plan, commence par là : la fenêtre d'environ 72 jours est souvent celle où tu as le plus de levier.",
      "start_personalized_title": "Démarrer un plan d'optimisation personnalisé",
      "start_personalized_subtitle": "Revois tests, compléments, expositions et timing pour les deux côtés du plan.",
      "start_plan": "Démarrer le plan d'optimisation",
      "sperm_title": "Fenêtre où tu as le plus de levier : le sperme",
      "sperm_body": "Quand le sperme fait partie du plan, c'est souvent la voie d'optimisation la plus claire : le sperme se renouvelle sur environ 72 jours.",
      "sperm_bullet_1": "Commence par un spermogramme pour ne pas avancer à l'aveugle",
      "sperm_bullet_2": "Passe en revue chaleur, fièvre, tabac, alcool, cannabis, médicaments, hormones anabolisantes et compléments",
      "sperm_bullet_3": "Vois si refaire des tests, consulter en urologie, congeler en backup ou planifier une ICSI est utile",
      "start_sperm_plan": "Démarrer le plan sperme",
      "egg_side": "Côté ovocytes",
      "egg_title": "Soutiens le côté ovarien",
      "egg_body": "L'âge des ovocytes ne se renverse pas, mais on peut planifier le cycle autour de la réserve, de la réponse, de la sécurité et des risques évitables avant la ponction.",
      "egg_bullet_1": "Utilise AMH, AFC, historique et réponse précédente pour planifier le timing",
      "egg_bullet_2": "Passe en revue médicaments, compléments, tabac, alcool, cannabis et expositions",
      "egg_bullet_3": "Travaille sommeil, contexte métabolique, thyroïde, vitamine D ou carences claires si pertinent",
      "check_reserve": "Vérifier la réserve ovarienne"
    },
    "sperm_freezing_reset": {
      "step_label": "Étape 3 : Améliore les facteurs sperme",
      "protocol_title": "Programme reset sperme 90 jours",
      "protocol_subtitle": "Test de base, revue des expositions, bases santé, preuves sur les compléments et test de répétition.",
      "bank_or_reset": "Vitrifier maintenant ou faire un reset d'abord ?",
      "bank_or_reset_subtitle": "Si le timing presse, banque maintenant. Si c'est volontaire et que tu as le temps, compare le résultat de base avec un retest à 90 jours.",
      "start_program": "Démarrer le programme reset sperme",
      "step_1": "Étape 1",
      "step_2": "Étape 2",
      "step_3": "Étape 3",
      "step_4": "Étape 4",
      "step_5": "Étape 5",
      "bank_baseline_title": "Banque ou teste un point de départ d'abord",
      "bank_baseline_body": "Si le timing presse, banque maintenant. Si tu as le temps, fais un spermogramme de base pour que le plan d'optimisation s'appuie sur de vrais chiffres.",
      "bank_baseline_callout": "En cas de traitement anticancéreux, d'hormones d'affirmation de genre, de planification de vasectomie ou de traitement urgent, n'attends pas une fenêtre d'optimisation parfaite.",
      "order_baseline_test": "Commander un test de base",
      "avoid_exposures_body": "Chaleur, fièvre, tabac, vape, cannabis, alcool en quantité, stéroïdes anabolisants, testostérone, certains médicaments et toxines peuvent affecter la production ou l'intégrité de l'ADN du sperme.",
      "avoid_exposures_callout": "N'arrête pas un médicament ou une hormone prescrits sans en parler à ton·ta clinicien·ne. L'idée, c'est de repérer ce qui peut être modifié.",
      "health_basics_title": "Active les leviers santé évidents",
      "health_basics_body": "Sommeil, activité, santé métabolique, évaluation de varicocèle, infection/inflammation et carences peuvent compter plus qu'une pile générique de compléments.",
      "start_sperm_plan": "Démarrer le plan sperme",
      "supplements_title": "Utilise les compléments selon le niveau de preuve",
      "supplements_body": "CoQ10, zinc, folate, oméga-3, vitamines C/E, L-carnitine et vitamine D sont fréquemment discutés, mais leur intérêt dépend de l'alimentation de base, des carences et du profil de spermogramme.",
      "supplements_callout": "C'est une revue, pas une liste de courses. Plus de compléments n'est pas mécaniquement mieux.",
      "review_supplements": "Revoir les compléments",
      "retest_title": "Refaire un test vers 90 jours",
      "retest_body": "Le nouveau sperme se développe sur environ 72-90 jours, donc refaire un spermogramme après la fenêtre de reset est la façon la plus claire de voir si quelque chose a bougé.",
      "retest_callout": "S'il y a amélioration, tu peux vitrifier des échantillons optimisés en plus tout en gardant le point de départ en backup."
    },
    "sperm_analysis_skeleton": {
      "volume_label": "Volume",
      "volume_unit": "ml",
      "volume_description": "Quantité de liquide dans un échantillon. Détermine en combien de fioles il peut être divisé.",
      "concentration_label": "Concentration",
      "concentration_unit": "M/mL",
      "concentration_description": "Nombre de spermatozoïdes par millilitre. Un facteur clé d'utilité d'un échantillon congelé.",
      "progressive_motility_label": "Mobilité progressive",
      "progressive_motility_unit": "%",
      "progressive_motility_description": "Proportion de spermatozoïdes qui avancent. Une perte après décongélation est attendue, donc ce chiffre compte au moment de la congélation.",
      "normal_morphology_label": "Morphologie normale",
      "normal_morphology_unit": "%",
      "normal_morphology_description": "Proportion de spermatozoïdes de forme normale. Aide à anticiper IUI vs FIV-ICSI.",
      "dna_fragmentation_label": "Fragmentation de l'ADN",
      "dna_fragmentation_unit": "% DFI",
      "dna_fragmentation_description": "Pourcentage de spermatozoïdes à ADN endommagé. Des niveaux plus élevés sont liés à moins de fécondations et plus de risque de fausse couche.",
      "methylation_label": "Épigénétique du sperme (méthylation)",
      "methylation_unit": "score",
      "methylation_description": "Marques chimiques sur l'ADN du sperme qui évoluent avec l'âge et les expositions. Sert à estimer le vieillissement au-delà du compte standard.",
      "oxidative_stress_label": "Stress oxydatif (ROS)",
      "oxidative_stress_unit": "niveau",
      "oxidative_stress_description": "Espèces réactives de l'oxygène qui abîment les membranes et l'ADN. Souvent améliorable avec des ajustements ciblés avant la banque.",
      "vitality_label": "Vitalité",
      "vitality_unit": "%",
      "vitality_description": "Proportion de spermatozoïdes vivants. Distingue les vraiment immobiles des morts quand la mobilité est très basse.",
      "aneuploidy_label": "Dépistage chromosomique",
      "aneuploidy_unit": "résultat",
      "aneuploidy_description": "Cherche des chromosomes en plus ou manquants. À considérer en cas de pertes répétées ou de cycles infructueux à répétition.",
      "anatomy_acrosome": "Acrosome",
      "anatomy_head": "Tête",
      "anatomy_neck": "Col",
      "anatomy_tail": "Flagelle",
      "anatomy_motility": "Mobilité",
      "tab_basic": "Base",
      "tab_advanced": "Avancé",
      "your_sperm_analysis": "Ton spermogramme",
      "what_is_going_on": "L'état de tes spermatozoïdes",
      "advanced_intro": "Des tests plus poussés, ajoutés quand les résultats ou l'historique les rendent utiles. Chacun apporte une info qu'un compte standard ne donne pas.",
      "cta_explore_advanced": "Explorer les tests sperme avancés",
      "cta_get_analysis": "Faire un spermogramme"
    },
    "egg_freezing_know_your_numbers": {
      "step_label": "Étape 2 : Connais tes chiffres",
      "estimate_none_value": "Il faut âge + AMH + AFC",
      "estimate_none_body": "L'âge donne une fourchette approximative. C'est l'AMH, l'AFC et l'historique médical qui la rendent utile.",
      "estimate_8_14": "Souvent 8-14 ovocytes",
      "estimate_5_10": "Souvent 5-10 ovocytes",
      "estimate_clinic_specific": "Spécifique à la clinique",
      "estimate_full_value": "Souvent ${low}-${high} ovocytes",
      "estimate_full_body": "Personnalisé selon ton âge, ton AMH, ton AFC et ta FSH. La réponse réelle varie selon le protocole et le cycle.",
      "estimate_amh_afc_value": "Souvent ${low}-${high} ovocytes",
      "estimate_amh_afc_body": "Basé sur ton âge, ton AMH et ton AFC. La FSH ou une évaluation en clinique peuvent affiner l'estimation.",
      "estimate_amh_value": "Souvent ${low}-${high} ovocytes",
      "estimate_amh_body": "Basé sur ton âge et ton AMH (${reserve}). Ajouter l'AFC et la FSH peut affiner l'estimation.",
      "estimate_under_35_body": "C'est une fourchette indicative basée sur l'âge. Ton AMH, ton AFC et ton historique peuvent la faire bouger beaucoup.",
      "estimate_35_37_body": "Beaucoup répondent encore bien, mais l'AMH et l'AFC deviennent plus importants pour planifier.",
      "estimate_37_40_body": "Les cliniques discutent souvent s'il faut un ou plusieurs cycles selon tes chiffres.",
      "estimate_over_40_body": "Après 40 ans, le rendement et la qualité varient davantage. Une clinique doit personnaliser tout ça avec tes tests.",
      "history_title": "Compléter l'historique médical",
      "history_body": "C'est la base de données de ton estimation : diagnostics, médicaments, chirurgies, allergies, règles, cycles passés et facteurs de risque.",
      "history_timing": "Indispensable pour la personnalisation",
      "history_action": "Continuer l'historique",
      "amh_title": "Test sanguin AMH",
      "amh_body": "L'AMH aide à estimer la réserve ovarienne et la réponse attendue. Elle peut en général être prélevée n'importe quel jour du cycle.",
      "amh_timing": "Prise de sang · n'importe quel jour",
      "amh_order_short": "Commander AMH",
      "amh_order_long": "Commander un test AMH à domicile",
      "find_lab_short": "Trouver un labo",
      "find_lab_long": "Trouver un labo",
      "afc_title": "Échographie AFC",
      "afc_body": "Le compte de follicules antraux est une échographie endovaginale qui compte les petits follicules au repos. AMH + AFC donne en général l'estimation la plus claire.",
      "afc_timing": "Échographie · souvent J2-J5 du cycle",
      "find_clinic_short": "Trouver une clinique",
      "find_clinic_long": "Trouver une clinique ou une écho mobile",
      "upload_result_short": "Importer le résultat",
      "upload_afc_long": "Importer le résultat AFC",
      "hormones_title": "Hormones J2-J3",
      "hormones_body": "FSH et estradiol aident à interpréter la réserve ovarienne. Les cliniques peuvent ajouter LH, progestérone, TSH, prolactine, vitamine D ou des sérologies infectieuses.",
      "hormones_timing": "Certains examens doivent être calés sur le cycle",
      "add_results_short": "Ajouter des résultats",
      "add_results_long": "Ajouter des résultats de tests",
      "semen_body": "Numération, mobilité, morphologie et volume aident le labo à décider si une fécondation conventionnelle ou une ICSI est plutôt recommandée.",
      "semen_timing": "Partenaire, donneur, labo ou recueil à domicile",
      "check_options_short": "Voir les options",
      "check_options_long": "Voir les options de spermogramme",
      "upload_semen_long": "Importer le spermogramme",
      "core_title": "Estimation de base",
      "core_body": "Historique, AMH et AFC répondent à la question principale : comment tes ovaires peuvent réagir à un cycle de vitrification.",
      "core_action": "Commencer l'AMH",
      "optional_label": "Optionnel",
      "bloodwork_title": "Bilan santé complet",
      "bloodwork_body": "Un panel de 150+ biomarqueurs peut couvrir vitamines, thyroïde, santé métabolique, inflammation, hormones et autres facteurs d'optimisation.",
      "see_panels_short": "Voir les panels",
      "see_panels_long": "Voir les panels de tests",
      "genetics_title": "Génétique",
      "genetics_body": "Le test de portage évalue le risque pour les enfants à venir. Le génome entier est un séquençage ADN à domicile plus large, avec plus de contexte santé et plus d'incertitudes.",
      "compare_options_short": "Comparer les options",
      "compare_options_long": "Comparer les options de tests génétiques",
      "add_partner_title": "Ajouter un·e partenaire ou une source de sperme",
      "add_partner_subtitle": "Invite un·e partenaire ou indique quelle source de sperme inclure dans le plan.",
      "what_you_can_test": "Ce que tu peux tester",
      "what_you_can_test_embryo": "Commence par le côté ovarien, ajoute le côté sperme, puis décide si la génétique ou des panels plus larges sont utiles.",
      "what_you_can_test_egg": "Quelques options peuvent rendre ton estimation plus utile. Tu peux commencer simple ou aller plus loin.",
      "eyebrow_ovarian_reserve": "Réserve ovarienne",
      "eyebrow_ultrasound": "Échographie",
      "eyebrow_hormones": "Hormones",
      "expand_baseline": "Déplier les tests de base",
      "collapse_baseline": "Replier les tests de base",
      "get_baseline_tests": "Faire les tests de base",
      "count_of_4": "${completedCount} sur 4",
      "decide_testing_title": "Décide combien de tests tu veux faire maintenant",
      "decide_testing_body": "Commence par ce qui prédit la réponse au cycle. Ajoute des bilans sanguins plus larges ou de la génétique seulement si tu veux plus de contexte santé avant le traitement.",
      "testing_levels": "Niveaux de tests",
      "baseline_first_title": "D'abord la base. Les tests plus poussés sont optionnels.",
      "baseline_first_body": "La base répond à la question de l'estimation pour la vitrification. Les bilans complets et la génétique répondent à des questions plus larges sur la santé ou les projets familiaux futurs.",
      "recent_results_note": "Si tu as déjà des résultats récents d'AMH, d'AFC ou d'hormones, importe-les ici. Une clinique peut refaire les tests de base avant le traitement, mais des résultats récents peuvent quand même t'aider à comprendre ta réponse probable dès maintenant.",
      "turn_estimate_title": "Transforme une estimation approximative en vrai plan",
      "turn_estimate_body": "L'étape la plus utile, c'est de compléter ton historique, puis d'ajouter les chiffres de réserve ovarienne qui structurent la planification.",
      "personalized_estimate": "Estimation personnalisée",
      "history_progress_title": "Historique médical ${progressPercent} % complet",
      "history_progress_body": "Ça doit rester visible jusqu'à ce que ce soit complet : médicaments, chirurgies, allergies, cycles et diagnostics changent ce qu'une clinique a besoin de savoir.",
      "core_numbers_base": "Chiffres clés de fertilité",
      "core_numbers_with_percent": "Chiffres clés de fertilité ${percent} % ajoutés",
      "core_numbers_body": "AMH et compte de follicules antraux sont les deux chiffres qui améliorent le plus une estimation avant de choisir un protocole.",
      "optional_broader_title": "Bilan sanguin optionnel élargi",
      "optional_broader_body": "FSH, estradiol, LH, progestérone, TSH, prolactine, vitamine D et d'autres dosages peuvent apporter du contexte, mais ne sont pas tous nécessaires juste pour explorer.",
      "clinic_baseline_title": "Les tests de base en clinique peuvent venir plus tard",
      "clinic_baseline_body": "La plupart des cliniques refont les tests de base et l'échographie avant le traitement. Tout faire via la clinique peut être plus simple, mais parfois plus cher.",
      "review_history": "Revoir l'historique médical",
      "complete_history": "Compléter l'historique médical",
      "history_complete_note": "Ton historique est complet. Rouvre cette section si tu veux ajouter ou revoir des tests de fertilité."
    },
    "embryo_freezing_understand": {
      "step_label": "Étape 1 : Comprendre",
      "how_it_works_title": "Comment fonctionne la vitrification d'embryons",
      "how_it_works_subtitle": "Commence par les trois parties, puis fais défiler toute la biologie et le déroulé labo.",
      "how_many_embryos_title": "Combien d'embryons ça peut donner ?",
      "how_many_embryos_subtitle": "Estime le rendement ovocytaire, l'attrition embryonnaire et le nombre de cycles potentiellement nécessaires.",
      "eggs_vs_embryos_title": "Vitrifier des ovocytes ou des embryons",
      "eggs_vs_embryos_subtitle": "Compare flexibilité, infos obtenues, implications partenaire/juridiques et usage futur.",
      "egg_quantity_label": "Quantité d'ovocytes",
      "egg_supply_title": "Le côté ovarien démarre toujours par la réserve d'ovocytes",
      "egg_supply_body": "La vitrification d'embryons démarre en général par stimulation et ponction, donc l'âge, l'AMH, l'AFC et la réponse précédente conditionnent toujours le nombre d'ovocytes attendu.",
      "egg_supply_callout_label": "Pourquoi c'est important",
      "egg_supply_callout": "L'entonnoir embryon commence par les ovocytes. Moins d'ovocytes prélevés ou matures, c'est en général moins de chances d'embryons ensuite.",
      "test_ovarian_reserve": "Tester la réserve ovarienne",
      "egg_supply_detail_title": "Réserve d'ovocytes avant la vitrification d'embryons",
      "egg_supply_section_1_title": "Les embryons partent des ovocytes",
      "egg_supply_section_1_body": "Même quand l'objectif, ce sont des embryons, la première contrainte biologique reste souvent le nombre de follicules qui répondent et le nombre d'ovocytes matures prélevés.",
      "egg_supply_section_2_title": "Ce que les tests peuvent apporter",
      "egg_supply_section_2_body": "AMH, AFC, hormones J2-J3, âge, diagnostic et réponse aux cycles précédents aident à estimer le rendement probable et le protocole de stimulation.",
      "normal_cycle_label": "Cycle normal",
      "normal_cycle_title": "En général, un seul ovocyte ovule dans le mois",
      "normal_cycle_body": "À chaque cycle, un petit groupe de follicules commence à grandir. En général, un seul devient dominant et les autres s'arrêtent.",
      "why_stimulation_exists": "Pourquoi on stimule",
      "normal_cycle_callout": "La vitrification d'embryons cherche à faire mûrir plus d'ovocytes du même groupe pour que plus en arrivent au labo.",
      "normal_cycle_detail_title": "Cycle normal vs cycle de stimulation",
      "normal_cycle_section_1_title": "Un petit groupe démarre ensemble",
      "normal_cycle_section_1_body": "Une cohorte de follicules commence à répondre pendant un cycle. Dans un cycle menstruel typique, un seul devient dominant et ovule.",
      "normal_cycle_section_2_title": "La stimulation change l'issue",
      "normal_cycle_section_2_body": "La stimulation ne crée pas de nouveaux ovocytes. Elle cherche à faire grandir plus de follicules recrutés assez longtemps pour pouvoir y prélever des ovocytes.",
      "ovaries_follicles_label": "Ovaires et follicules",
      "follicles_title": "Les ovocytes sont dans les follicules, et les follicules dans les ovaires",
      "follicles_body": "Ta clinique peut mesurer les follicules à l'échographie, mais l'ovocyte à l'intérieur est microscopique et n'est observé qu'après la ponction.",
      "key_distinction_label": "Distinction clé",
      "follicles_callout": "Un compte de follicules, ce n'est pas la même chose qu'ovocytes prélevés, matures ou embryons.",
      "follicles_detail_title": "Follicules, ovocytes et ovaires",
      "follicles_section_1_title": "Ce que la clinique peut voir",
      "follicles_section_1_body": "L'échographie montre les follicules et leur taille. L'ovocyte lui-même est trop petit pour être vu directement, donc le nombre final d'ovocytes vient du labo d'embryologie.",
      "follicles_section_2_title": "Pourquoi les chiffres changent",
      "follicles_section_2_body": "Tu peux entendre parler de compte de follicules, ovocytes prélevés, matures, fécondés et embryons. Chacun est une étape différente.",
      "stimulation_title": "Les médicaments cherchent à faire mûrir plus de follicules en même temps",
      "stimulation_body": "Les médicaments de stimulation quotidiens durent en général 10-14 jours et visent à faire grandir plusieurs follicules au lieu d'un seul.",
      "reserve_note_label": "Note réserve",
      "stimulation_callout": "Ça s'appuie sur les follicules déjà recrutés ce cycle-ci ; ça ne pioche pas dans les ovocytes que ton corps gardait pour les mois suivants.",
      "stimulation_detail_title": "Pourquoi on utilise la stimulation",
      "stimulation_section_1_title": "La cohorte du cycle",
      "stimulation_section_1_body": "Chaque mois, un groupe de follicules commence à répondre. La stimulation cherche à en faire grandir davantage assez longtemps pour en prélever des ovocytes.",
      "stimulation_section_2_title": "La dose est personnalisée",
      "stimulation_section_2_body": "Âge, AMH, AFC, poids, diagnostic et réponse antérieure peuvent modifier la dose de départ et le plan de monitoring.",
      "monitoring_label": "Suivi",
      "monitoring_title": "Le suivi décide quand déclencher et ponctionner",
      "monitoring_body": "Les visites ont souvent lieu tous les 2-3 jours. L'échographie suit la taille des follicules et les prises de sang aident à caler le déclenchement.",
      "procedure_note_label": "Note intervention",
      "monitoring_callout": "La ponction est en général une intervention transvaginale courte en ambulatoire sous sédation, pas une chirurgie abdominale.",
      "monitoring_detail_title": "Monitoring, déclenchement et ponction",
      "monitoring_section_1_title": "Le monitoring fait évoluer le plan",
      "monitoring_section_1_body": "Changements de dose, visites supplémentaires et estimations de ponction décalées sont normaux : la clinique réagit à la croissance des follicules et aux hormones.",
      "monitoring_section_2_title": "Le timing du déclenchement compte",
      "monitoring_section_2_body": "La ponction est en général programmée environ 34-36 heures après le déclenchement, avant que l'ovulation n'ait lieu.",
      "monitoring_section_3_title": "Ce que la ponction prélève",
      "monitoring_section_3_body": "Le clinicien recueille le liquide folliculaire ; le labo d'embryologie cherche les ovocytes dans ce liquide au microscope.",
      "sperm_source_title": "La source de sperme fait partie du plan embryon",
      "sperm_source_body": "Le sperme peut venir d'un·e partenaire, d'un·e donneur·se, d'un échantillon frais ou congelé. Ce choix affecte le consentement, le timing, le transport et la méthode labo.",
      "what_to_know_label": "À savoir",
      "sperm_source_callout": "Un plan sperme, ce n'est pas que de la logistique. Ça peut changer si le labo utilise une FIV conventionnelle ou une ICSI.",
      "sperm_source_detail_title": "Source de sperme et vitrification d'embryons",
      "sperm_source_section_1_title": "Frais, congelé, partenaire ou donneur·se",
      "sperm_source_section_1_body": "La source de sperme affecte la logistique et le consentement. Le labo a besoin d'un plan clair avant le jour de la ponction.",
      "sperm_source_section_2_title": "Pourquoi le spermogramme compte",
      "sperm_source_section_2_body": "Numération, mobilité, morphologie et volume peuvent influencer le choix entre insémination conventionnelle et ICSI.",
      "semen_sample_label": "Échantillon de sperme",
      "semen_sample_title": "Un échantillon de sperme est recueilli ou décongelé",
      "semen_sample_body": "Ça se passe souvent le jour de la ponction, mais certain·e·s congèlent du sperme en backup ou utilisent du sperme de donneur déjà congelé.",
      "timing_label": "Timing",
      "semen_sample_callout": "Le côté ovarien prend des jours. Le côté sperme se joue souvent sur un jour, mais la préparation peut commencer des mois à l'avance.",
      "semen_sample_detail_title": "Comment le sperme arrive au labo",
      "semen_sample_section_1_title": "Échantillon frais",
      "semen_sample_section_1_body": "Un échantillon frais peut être recueilli le jour de la ponction, puis préparé par le labo pour la fécondation.",
      "semen_sample_section_2_title": "Échantillon congelé ou donneur",
      "semen_sample_section_2_body": "Du sperme partenaire congelé ou du sperme de donneur peut être décongelé par le labo. La clinique doit confirmer timing, vérifications d'identité, consentement et plans de secours avant le jour de la ponction.",
      "semen_sample_section_3_title": "Pourquoi prévoir un backup",
      "semen_sample_section_3_body": "Si le recueil peut être difficile ou si les paramètres du sperme sont bas, une clinique peut discuter de congeler du sperme de secours avant le cycle.",
      "sperm_quality_label": "Qualité du sperme",
      "sperm_quality_title": "Le spermogramme aide à choisir la méthode labo",
      "sperm_quality_body": "Numération, mobilité, morphologie, volume, historique de fécondation et statut donneur·se/partenaire peuvent tous influencer le plan.",
      "optimization_window_label": "Fenêtre d'optimisation",
      "sperm_quality_callout": "Le sperme se renouvelle en continu sur environ 2-3 mois ; les expositions peuvent donc compter avant la création des embryons.",
      "sperm_quality_detail_title": "Ce que le spermogramme peut changer",
      "sperm_quality_section_1_title": "Les paramètres habituels",
      "sperm_quality_section_1_body": "Le spermogramme regarde en général numération, mobilité, morphologie, volume, et parfois des mesures supplémentaires selon la clinique.",
      "sperm_quality_section_2_title": "Pourquoi ça compte pour les embryons",
      "sperm_quality_section_2_body": "Le résultat peut influencer la recommandation : insémination conventionnelle, ICSI, congélation de sperme de secours, orientation urologie ou plan sperme donneur.",
      "ivf_icsi_label": "FIV vs ICSI",
      "ivf_icsi_title": "FIV et ICSI, ce sont deux méthodes de fécondation",
      "ivf_icsi_body": "En FIV conventionnelle, on met ovocytes et sperme préparés ensemble. En ICSI, l'embryologiste injecte un spermatozoïde dans un ovocyte mature.",
      "what_decides_label": "Ce qui décide",
      "ivf_icsi_callout": "Résultats du spermogramme, fécondation antérieure, plans PGT, politique de la clinique et nombre d'ovocytes peuvent tous influencer la recommandation.",
      "ivf_icsi_detail_title": "FIV conventionnelle vs ICSI",
      "ivf_icsi_section_1_title": "FIV conventionnelle",
      "ivf_icsi_section_1_body": "Le labo met les ovocytes matures avec le sperme préparé et laisse la fécondation se faire sans injecter chaque ovocyte.",
      "ivf_icsi_section_2_title": "ICSI",
      "ivf_icsi_section_2_body": "ICSI veut dire injection intracytoplasmique de spermatozoïde. Un·e embryologiste sélectionne un spermatozoïde et l'injecte directement dans un ovocyte mature.",
      "ivf_icsi_section_3_title": "Pourquoi le choix est personnel",
      "ivf_icsi_section_3_body": "L'ICSI peut être importante en cas de facteur masculin et est souvent utilisée avec le PGT, mais elle n'est pas automatiquement meilleure dans toutes les situations.",
      "day_1_label": "Vérification J1",
      "day_1_title": "Le labo vérifie quels ovocytes ont fécondé normalement",
      "day_1_body": "Le lendemain, le labo vérifie en général la fécondation normale. C'est à ce moment-là que le nombre peut se resserrer de nouveau.",
      "day_1_callout": "Ovocytes prélevés, matures, fécondés normalement et embryons : ce sont des chiffres distincts.",
      "day_1_detail_title": "Ce que veut dire la vérification de fécondation",
      "day_1_section_1_title": "La maturité d'abord",
      "day_1_section_1_body": "Après la ponction, le labo vérifie quels ovocytes sont matures. Les ovocytes immatures ont moins de chances de féconder normalement.",
      "day_1_section_2_title": "Fécondation normale",
      "day_1_section_2_body": "Un ovocyte fécondé à ce stade s'appelle souvent un zygote. Certains ovocytes peuvent ne pas féconder, et d'autres féconder anormalement.",
      "embryo_culture_label": "Culture embryonnaire",
      "embryo_culture_title": "Les embryons sont suivis sur plusieurs jours",
      "embryo_culture_body": "Les ovocytes fécondés se divisent dans le temps. Le labo peut te donner des nouvelles des embryons clivés vers J3 et des blastocystes vers J5-J7.",
      "embryo_culture_callout_label": "Pourquoi les updates peuvent être dures",
      "embryo_culture_callout": "Le nombre baisse souvent à chaque étape du labo ; ça ne veut pas dire forcément que quelque chose s'est mal passé.",
      "embryo_culture_detail_title": "Culture embryonnaire et attrition",
      "embryo_culture_section_1_title": "Développement précoce",
      "embryo_culture_section_1_body": "Le labo suit la division des ovocytes fécondés. Certains s'arrêtent tôt et d'autres continuent vers le stade blastocyste à J5, J6 ou J7.",
      "embryo_culture_section_2_title": "Pourquoi l'entonnoir se resserre",
      "embryo_culture_section_2_body": "Maturité ovocytaire, facteurs sperme, erreurs chromosomiques, conditions du labo et biologie peuvent tous influencer la poursuite du développement.",
      "blastocyst_title": "Les blastocystes sont en général les embryons vitrifiés ou testés",
      "blastocyst_body": "Vers J5-J7, certains embryons atteignent le stade blastocyste. Le labo décide lesquels remplissent les critères pour vitrification, biopsie ou planification de transfert.",
      "after_blastocyst_label": "Après le blastocyste",
      "blastocyst_callout": "Un blastocyste peut être noté, vitrifié, biopsié pour le PGT, ou parfois non conservé s'il ne remplit pas les critères du labo.",
      "blastocyst_detail_title": "Ce qui se passe au stade blastocyste",
      "blastocyst_section_1_title": "Le jour peut varier",
      "blastocyst_section_1_body": "Certains embryons atteignent le blastocyste à J5, d'autres à J6 ou J7, et certains s'arrêtent avant.",
      "blastocyst_section_2_title": "La notation, ce n'est pas le test génétique",
      "blastocyst_section_2_body": "La notation des embryons regarde l'aspect et l'expansion. C'est utile, mais ça ne dit pas si l'embryon a le nombre attendu de chromosomes.",
      "pgt_pgd_label": "PGT / PGD",
      "pgt_pgd_title": "Le diagnostic préimplantatoire est optionnel et il en existe plusieurs types",
      "pgt_pgd_body": "PGD est l'ancien terme. Aujourd'hui on parle plutôt de PGT-A pour le nombre de chromosomes, PGT-M pour une maladie monogénique précise, ou PGT-SR pour des remaniements chromosomiques.",
      "what_it_does_label": "Ce qu'il fait",
      "pgt_pgd_callout": "Le PGT analyse quelques cellules d'une biopsie de blastocyste. Il informe ; il ne modifie pas l'embryon.",
      "pgt_pgd_detail_title": "PGT, PGD et ce qui est testé",
      "pgt_pgd_section_1_title": "PGT-A",
      "pgt_pgd_section_1_body": "Le PGT-A vérifie si la biopsie d'embryon a le nombre attendu de chromosomes. Les résultats parlent en général d'euploïde, aneuploïde, mosaïque ou sans résultat selon le labo.",
      "pgt_pgd_section_2_title": "PGT-M et PGT-SR",
      "pgt_pgd_section_2_body": "Le PGT-M cherche une maladie monogénique précise quand il y a un risque connu. Le PGT-SR cherche les embryons affectés par un remaniement chromosomique connu.",
      "pgt_pgd_section_3_title": "Pourquoi le conseil compte",
      "pgt_pgd_section_3_body": "Les décisions de tests génétiques peuvent affecter coût, timing, usage des embryons et décisions émotionnelles. Beaucoup de cliniques impliquent un·e conseiller·ère en génétique pour le PGT-M ou les résultats complexes.",
      "euploidy_label": "Euploïdie",
      "euploidy_title": "Euploïde veut dire le nombre de chromosomes attendu",
      "euploidy_body": "Un résultat PGT-A euploïde veut dire que la biopsie testée avait le nombre attendu de chromosomes. Aneuploïde veut dire que des chromosomes en plus ou en moins ont été détectés.",
      "important_limit_label": "Limite importante",
      "euploidy_callout": "Euploïde ne garantit pas grossesse ni naissance, et le PGT-A ne teste pas tous les problèmes génétiques possibles.",
      "euploidy_detail_title": "Comment lire le vocabulaire PGT-A",
      "euploidy_section_1_title": "Euploïde",
      "euploidy_section_1_body": "Un résultat euploïde veut dire que la biopsie d'embryon avait le nombre attendu de chromosomes. Les embryons euploïdes ont en général un meilleur potentiel d'implantation, mais les résultats ne sont pas garantis.",
      "euploidy_section_2_title": "Aneuploïde, mosaïque, sans résultat",
      "euploidy_section_2_body": "Aneuploïde veut dire que des chromosomes en plus ou en moins ont été détectés. Mosaïque veut dire des signaux mixtes entre lignées cellulaires. Sans résultat veut dire que le labo n'a pas obtenu de résultat exploitable.",
      "freezing_storage_title": "Les embryons sont vitrifiés et stockés",
      "freezing_storage_body": "Les embryons qui remplissent les critères sont en général vitrifiés, stockés en cuves d'azote liquide et conservés jusqu'à une décision future de décongélation ou de transfert.",
      "how_long_label": "Combien de temps",
      "freezing_storage_callout": "Si le stockage est maintenu, les embryons peuvent rester congelés des années. Les limites pratiques sont en général le consentement, la politique de la clinique, les frais et la loi.",
      "freezing_storage_detail_title": "Vitrification et stockage d'embryons",
      "freezing_storage_section_1_title": "Vitrification",
      "freezing_storage_section_1_body": "La vitrification est une congélation rapide qui réduit la formation de cristaux de glace. Les embryons sont ensuite stockés en cuves d'azote liquide.",
      "freezing_storage_section_2_title": "Le stockage, c'est une décision continue",
      "freezing_storage_section_2_body": "Les embryons congelés impliquent souvent des frais annuels de stockage, des renouvellements de consentement, des décisions de devenir, des considérations légales et une planification de transfert futur.",
      "freezing_storage_section_3_body": "Quand on veut utiliser un embryon plus tard, on le décongèle et on prépare un plan de transfert d'embryon congelé. Tous les embryons ne survivent pas à la décongélation, mais la survie après vitrification moderne est en général élevée.",
      "future_transfer_title": "Utiliser un embryon plus tard, c'est une étape de transfert distincte",
      "future_transfer_body": "La vitrification crée des embryons stockés. Une grossesse plus tard nécessite de décongeler un embryon, de préparer l'utérus ou la gestatrice et de faire un transfert.",
      "why_this_matters_label": "Pourquoi ça compte",
      "future_transfer_callout": "Vitrifier des embryons donne plus d'infos que vitrifier des ovocytes, mais ça crée aussi des décisions sur la propriété, le consentement, le transfert, le stockage et le devenir.",
      "future_transfer_detail_title": "Après la vitrification des embryons",
      "future_transfer_section_1_title": "Transfert d'embryon congelé",
      "future_transfer_section_1_body": "Un transfert futur implique en général un cycle séparé avec préparation utérine, décongélation de l'embryon, transfert et test de grossesse ensuite.",
      "future_transfer_section_2_title": "Consentement et propriété",
      "future_transfer_section_2_body": "Parce que les embryons peuvent impliquer plus d'un·e contributeur·rice génétique, les cliniques exigent en général un consentement clair sur le stockage, le transfert, les tests, la destruction, le don, et ce qui se passe si les circonstances changent.",
      "process_ovarian_label": "Côté ovarien",
      "process_ovarian_timing": "10-14 jours",
      "process_ovarian_title": "Obtiens des ovocytes via la stimulation ovarienne",
      "process_sperm_timing": "1 jour",
      "process_sperm_title": "Recueille ou décongèle un échantillon de sperme",
      "process_lab_label": "Côté labo",
      "process_lab_timing": "5-7 jours",
      "process_lab_title": "Féconde, cultive, teste ou vitrifie les embryons"
    },
    "egg_freezing_biology_carousel": {
      "how_it_works": "Comment fonctionne la vitrification d'ovocytes",
      "biology_first_intro": "Une version axée biologie du processus, y compris pourquoi la stimulation n'épuise pas tes ovocytes futurs.",
      "biology_detail": "Détail biologique",
      "open_detail_for": "Ouvrir le détail de ${title}",
      "reserve_note": "Note réserve",
      "normal_cycle_label": "Cycle normal",
      "normal_cycle_title": "Ton corps démarre avec un groupe",
      "normal_cycle_body": "Chaque mois, un petit groupe de follicules commence à grandir. En général, un seul devient dominant et ovule.",
      "normal_cycle_reserve_note": "La vitrification d'ovocytes ne pioche pas dans les ovocytes que ton corps gardait pour plus tard.",
      "normal_cycle_detail_title": "Ce qui se passe dans un cycle normal",
      "normal_cycle_section_1_title": "Une cohorte démarre ensemble",
      "normal_cycle_section_1_body": "En début de cycle menstruel, plusieurs petits follicules peuvent répondre à l'hormone folliculo-stimulante. Chaque follicule peut contenir un ovocyte.",
      "normal_cycle_section_2_title": "En général, un seul l'emporte",
      "normal_cycle_section_2_body": "Au fil du cycle, un follicule devient dominant. Les autres du même groupe mensuel arrêtent de se développer et sont naturellement réabsorbés.",
      "normal_cycle_section_3_title": "Pourquoi c'est important pour la réserve",
      "normal_cycle_section_3_body": "Ces follicules non dominants faisaient déjà partie de la cohorte du mois. La vitrification cherche à en faire mûrir plus, plutôt que de laisser la plupart disparaître.",
      "cohort_title": "Les médicaments soutiennent davantage de ce groupe",
      "cohort_body": "Les médicaments à base de FSH envoient assez de signal pour que plus de follicules continuent à grandir sur le même cycle.",
      "cohort_reserve_note": "Ça agit sur les follicules recrutés ce mois-ci, pas sur ta réserve totale.",
      "cohort_detail_title": "Pourquoi plusieurs follicules peuvent grandir",
      "cohort_section_1_title": "Le médicament, c'est un signal plus fort",
      "cohort_section_1_body": "Dans un cycle sans stimulation, la FSH baisse quand un follicule prend la tête. En stimulation, la FSH reste assez haute pour que d'autres follicules de la même cohorte continuent.",
      "cohort_section_2_title": "Ça ne fabrique pas de nouveaux ovocytes",
      "cohort_section_2_body": "Le médicament ne crée pas d'ovocytes et ne va pas piocher dans tes années futures. Il soutient les follicules déjà disponibles pendant ce cycle.",
      "cohort_section_3_title": "Pourquoi les cliniques surveillent de près",
      "cohort_section_3_body": "Chaque personne répond différemment. Le monitoring permet d'ajuster les doses, de réduire les risques et de décider quand les follicules sont prêts.",
      "daily_meds_label": "Médicaments quotidiens",
      "medication_title": "La dose cherche à équilibrer la réponse",
      "medication_body": "L'objectif : assez de croissance pour prélever des ovocytes matures, sans surstimuler tes ovaires.",
      "medication_reserve_note": "Les ajustements de dose changent la réponse de ce cycle, pas ta fertilité future.",
      "medication_detail_title": "Ce que fait la stimulation quotidienne",
      "medication_section_1_title": "La FSH, c'est un signal de croissance",
      "medication_section_1_body": "La plupart des protocoles utilisent de la FSH, parfois avec de la LH, pour pousser les follicules à continuer de grandir.",
      "medication_section_2_title": "Plus, ce n'est pas toujours mieux",
      "medication_section_2_body": "Une dose plus forte ne garantit pas plus d'ovocytes. Les cliniques s'appuient sur ton âge, l'AMH, le compte de follicules antraux, la réponse aux cycles précédents et tes hormones pour choisir et ajuster la dose.",
      "medication_section_3_title": "Réserve et fertilité",
      "medication_section_3_body": "La dose de stimulation peut changer combien de follicules mûrissent ce cycle. Elle ne diminue pas durablement ta réserve ovarienne.",
      "monitoring_label": "Suivi",
      "monitoring_title": "La taille et les hormones racontent ce qui se passe",
      "monitoring_body": "L'échographie suit la taille des follicules. Les prises de sang montrent comment ils répondent.",
      "monitoring_reserve_note": "Le monitoring sert au bon timing et à la sécurité ; il n'a pas d'impact sur tes ovocytes.",
      "monitoring_detail_title": "Ce que vérifie le monitoring",
      "monitoring_section_1_title": "Taille des follicules",
      "monitoring_section_1_body": "Les follicules grandissent sur plusieurs jours. Ta clinique attend qu'un groupe atteigne une taille suffisante pour contenir probablement des ovocytes matures.",
      "monitoring_section_2_title": "Niveaux hormonaux",
      "monitoring_section_2_body": "L'estradiol monte au fur et à mesure que les follicules grandissent. LH et progestérone aident la clinique à vérifier que le timing colle au plan.",
      "monitoring_section_3_title": "Pourquoi ça te protège",
      "monitoring_section_3_body": "Le monitoring réduit les risques : déclencher trop tôt, trop tard, ou continuer la stimulation si la réponse est trop forte.",
      "trigger_label": "Déclenchement",
      "trigger_title": "Le déclenchement fait mûrir les ovocytes",
      "trigger_body": "L'injection de déclenchement dit aux ovocytes de finir leur maturation avant la ponction. Le timing est crucial.",
      "trigger_reserve_note": "Le déclenchement modifie le timing de cette cohorte uniquement.",
      "trigger_detail_title": "Pourquoi le timing du déclenchement compte",
      "trigger_section_1_title": "Maturation finale",
      "trigger_section_1_body": "Un follicule peut sembler prêt en taille, mais l'ovocyte à l'intérieur a encore besoin d'un signal final pour mûrir. Le déclenchement donne ce signal.",
      "trigger_section_2_title": "Fenêtre de ponction",
      "trigger_section_2_body": "La ponction est en général programmée 34 à 36 heures après le déclenchement, avant que l'ovulation ne libère les ovocytes.",
      "trigger_section_3_title": "Fertilité future",
      "trigger_section_3_body": "Le déclenchement ne change pas tes cycles futurs. C'est un signal de timing pour les follicules déjà développés ce cycle-ci.",
      "retrieval_label": "Ponction",
      "retrieval_title": "Les ovocytes sont prélevés avant l'ovulation",
      "retrieval_body": "Une aiguille guidée par échographie aspire le liquide des follicules pour que le labo y retrouve les ovocytes.",
      "retrieval_reserve_note": "L'intervention prélève les ovocytes matures de ce cycle ; elle ne touche pas à tes ovocytes futurs.",
      "retrieval_detail_title": "Ce que la ponction prélève",
      "retrieval_section_1_title": "Les follicules, pas les ovaires",
      "retrieval_section_1_body": "L'aiguille entre dans les follicules et aspire le liquide. Le labo d'embryologie examine ce liquide pour y trouver les ovocytes.",
      "retrieval_section_2_title": "Pourquoi le nombre peut varier",
      "retrieval_section_2_body": "Le nombre d'ovocytes prélevés peut être plus faible que le nombre de follicules visibles. Certains follicules ne contiennent pas d'ovocyte, ou l'ovocyte n'est pas mature.",
      "retrieval_section_3_title": "Réserve ovarienne",
      "retrieval_section_3_body": "La ponction prélève les ovocytes des follicules déjà développés sur ce cycle. Ça ne vide pas l'ovaire et ça n'accélère pas la ménopause.",
      "reserve_label": "Réserve",
      "reserve_title": "Ta réserve reste ta réserve",
      "reserve_body": "Le cycle peut révéler comment tes ovaires répondent, mais il n'est pas considéré comme néfaste pour la réserve ovarienne.",
      "reserve_reserve_note": "Les principaux marqueurs de réserve sont l'âge, l'AMH, l'AFC et la réponse aux cycles précédents.",
      "reserve_detail_title": "Pourquoi la vitrification n'épuise pas tes ovocytes futurs",
      "reserve_section_1_title": "Le recrutement se fait naturellement",
      "reserve_section_1_body": "À chaque cycle, beaucoup de follicules démarrent mais la plupart n'ovulent pas. La stimulation en sauve davantage dans le même groupe mensuel.",
      "reserve_section_2_title": "Ce qui peut changer",
      "reserve_section_2_body": "Ta clinique peut découvrir que ta réponse est plus forte ou plus faible que prévu. Cette info peut orienter tes futurs cycles.",
      "reserve_section_3_title": "Ce qui ne change pas",
      "reserve_section_3_body": "Un cycle de stimulation bien suivi n'est pas considéré comme épuisant les ovocytes que tu aurais eus les mois suivants.",
      "freezing_title": "Seuls les ovocytes matures sont vitrifiés",
      "freezing_body": "Le labo vérifie la maturité et vitrifie les ovocytes prêts pour un usage futur.",
      "freezing_reserve_note": "Des ovocytes vitrifiés, c'est une option pour plus tard ; ça ne garantit pas une naissance future.",
      "freezing_detail_title": "Ce que la vitrification préserve",
      "freezing_section_1_title": "La maturité compte",
      "freezing_section_1_body": "On vitrifie surtout les ovocytes matures, car ce sont ceux qui survivent le mieux à la décongélation et qui peuvent être fécondés plus tard.",
      "freezing_section_2_title": "Vitrification",
      "freezing_section_2_body": "La vitrification, c'est une congélation rapide qui empêche les cristaux de glace d'abîmer l'ovocyte.",
      "freezing_section_3_title": "Ce que veut dire le chiffre",
      "freezing_section_3_body": "Le nombre vitrifié, c'est un repère important, mais la réussite future dépend aussi de ton âge au moment de la vitrification, de la survie à la décongélation, de la fécondation, du développement embryonnaire et du transfert."
    },
    "egg_freezing_biology_deep_carousel": {
      "step_1_understand": "Étape 1 : Comprendre",
      "step_1_complete": "Étape 1 terminée",
      "section_subtitle": "Biologie, ponction, vitrification et estimations.",
      "more_detail": "Plus de détails",
      "mark_read": "Marquer comme lu",
      "read": "Lu",
      "expand_how_it_works_a11y": "Déplier le fonctionnement de la vitrification",
      "collapse_how_it_works_a11y": "Replier le fonctionnement de la vitrification",
      "show_completed_a11y": "Afficher le guide vitrification terminé",
      "collapse_completed_a11y": "Replier le guide vitrification terminé",
      "mark_as_read_a11y": "Marquer le guide vitrification comme lu",
      "timeline_how_it_works_subtitle": "Des visuels biologiques plus dimensionnels avec un sens plus clair.",
      "egg_estimate_subtitle": "Estime le rendement, l'attrition et le nombre de cycles potentiellement nécessaires.",
      "optimization_protocol_title": "Protocole d'optimisation ovocytaire en 5 étapes",
      "optimization_protocol_subtitle": "Bilan initial, expositions, bases santé, preuves sur les compléments et plan ciblé.",
      "archive_organic_title": "Comment fonctionne la vitrification d'ovocytes · direction organique",
      "archive_organic_subtitle": "Version de comparaison archivée avec l'ancienne direction visuelle dimensionnelle.",
      "archive_flat_title": "Comment fonctionne la vitrification d'ovocytes · plat/actuel",
      "archive_flat_subtitle": "Version de comparaison archivée avec l'ancienne direction d'illustration plus plate.",
      "egg_supply_label": "Quantité d'ovocytes",
      "egg_supply_title": "Ta réserve d'ovocytes diminue avec le temps",
      "egg_supply_body": "Tu nais avec tous les ovocytes que tu auras dans ta vie. Ils ne se régénèrent pas, la réserve diminue donc naturellement avec les années.",
      "egg_supply_callout_label": "Ce que les tests peuvent te dire",
      "egg_supply_callout": "L'AMH et l'AFC ne comptent pas chaque ovocyte, mais ils aident à estimer ta réserve ovarienne et la réponse probable à un cycle.",
      "egg_supply_cta": "Tester ma réserve ovarienne",
      "egg_supply_detail_title": "Quantité d'ovocytes et réserve ovarienne",
      "egg_supply_s1_title": "La quantité, c'est combien il en reste",
      "egg_supply_s1_body": "Tu nais avec tous tes ovocytes. Le pic est avant la naissance, on en a 1 à 2 millions à la naissance, et le nombre continue de baisser. À la puberté, il en reste souvent 300 000 à 500 000.",
      "egg_supply_s2_title": "Cette baisse est normale",
      "egg_supply_s2_body": "La plupart des ovocytes n'ovulent jamais. Ils se perdent progressivement par perte folliculaire naturelle ; seul un petit nombre ovule sur toute la vie reproductive.",
      "egg_supply_s3_title": "Ce que mesurent les tests de réserve",
      "egg_supply_s3_body": "L'AMH, le compte de follicules antraux, l'âge et la réponse aux cycles précédents aident à estimer comment tes ovaires peuvent répondre à la stimulation. Ce n'est pas un comptage direct de chaque ovocyte restant.",
      "egg_quality_label": "Qualité ovocytaire",
      "egg_quality_title": "La qualité ovocytaire, c'est différent de la quantité",
      "egg_quality_body": "Il n'y a pas de test objectif simple de la qualité d'un ovocyte avant son utilisation. L'âge reste le signal le plus fort, parce que les ovocytes vieillissent avec toi.",
      "egg_quality_callout_label": "Pourquoi le timing compte",
      "egg_quality_callout": "Vitrifier plus tôt permet de préserver des ovocytes avant qu'ils ne soient touchés par plus d'années de vieillissement, d'inflammation, de tabac, de traitements ou d'expositions environnementales.",
      "egg_quality_detail_title": "Qualité ovocytaire et temps",
      "egg_quality_s1_title": "La qualité, c'est si un ovocyte peut fonctionner plus tard",
      "egg_quality_s1_body": "La qualité, c'est si l'ovocyte a les chromosomes, les mitochondries et la machinerie cellulaire pour féconder, se diviser normalement et soutenir le développement embryonnaire.",
      "egg_quality_s2_title": "Il n'y a pas de test direct de la qualité ovocytaire",
      "egg_quality_s2_body": "Les cliniques peuvent estimer le risque à partir de l'âge et de l'historique, mais elles ne peuvent pas regarder un ovocyte au repos et savoir avec certitude s'il deviendra un embryon ou une naissance en bonne santé.",
      "egg_quality_s3_title": "Pourquoi la qualité baisse",
      "egg_quality_s3_body": "Les ovocytes sont des cellules à longue durée de vie. Avec le temps, ils peuvent être affectés par des erreurs de séparation chromosomique, du stress oxydatif, l'inflammation, le tabac, la chimiothérapie, l'endométriose et d'autres expositions ou conditions.",
      "egg_quality_s4_title": "Pourquoi ça compte",
      "egg_quality_s4_body": "Si un ovocyte est utilisé plus tard, une qualité plus faible peut se traduire par un échec de fécondation, une fragmentation embryonnaire, un arrêt embryonnaire, des embryons aneuploïdes, un échec d'implantation ou une fausse couche.",
      "egg_quality_s5_title": "Différence avec le sperme",
      "egg_quality_s5_body": "La qualité du sperme peut aussi être affectée par l'âge et les expositions, mais le sperme se renouvelle en continu. Les ovocytes ne se régénèrent pas de la même manière, c'est pour ça que le timing compte différemment.",
      "ovaries_follicles_label": "Ovaires et follicules",
      "ovaries_follicles_title": "Les ovocytes sont dans les follicules, et les follicules dans les ovaires",
      "ovaries_follicles_body": "Les cliniques peuvent mesurer les follicules à l'échographie, mais l'ovocyte à l'intérieur est microscopique.",
      "key_distinction_label": "Distinction clé",
      "ovaries_follicles_callout": "Les cliniques voient et mesurent les follicules à l'échographie ; l'ovocyte à l'intérieur est microscopique.",
      "ovaries_follicles_detail_title": "Ovocytes, follicules et ovaires",
      "ovaries_follicles_s1_title": "Qu'est-ce qu'un ovaire ?",
      "ovaries_follicles_s1_body": "Les ovaires sont les organes qui contiennent la réserve d'ovocytes et fabriquent des hormones comme l'œstrogène et la progestérone.",
      "ovaries_follicles_s2_title": "Qu'est-ce qu'un follicule ?",
      "ovaries_follicles_s2_body": "Un follicule est un petit sac rempli de liquide dans l'ovaire. Il soutient l'ovocyte pendant sa croissance et produit des hormones durant le cycle.",
      "ovaries_follicles_s3_title": "Qu'y a-t-il dans le follicule ?",
      "ovaries_follicles_s3_body": "Un follicule peut contenir un ovocyte, mais l'ovocyte est trop petit pour être vu directement à l'échographie. C'est pourquoi les cliniques mesurent les follicules comme un indicateur du développement.",
      "ovaries_follicles_s4_title": "Avec combien démarre-t-on ?",
      "ovaries_follicles_s4_body": "On naît avec sa réserve d'ovocytes pour la vie. Le nombre diminue avec le temps. À la puberté, il en reste en général des centaines de milliers, et seule une petite fraction ovulera un jour.",
      "normal_cycle_label": "Cycle menstruel normal",
      "normal_cycle_title": "Chaque mois, ton corps recrute un petit groupe de follicules",
      "normal_cycle_body": "Dans un cycle menstruel typique, plusieurs follicules commencent à répondre. En général, un seul devient dominant et ovule ; les autres arrêtent de grandir.",
      "people_often_get_wrong_label": "Idée fausse fréquente",
      "normal_cycle_callout": "Les autres follicules du mois s'arrêtent de toute façon.",
      "normal_cycle_detail_title": "Ce qui se passe normalement dans un cycle menstruel",
      "normal_cycle_s1_title": "Un petit groupe démarre ensemble",
      "normal_cycle_s1_body": "Chaque mois, l'ovaire recrute un groupe de petits follicules. Le nombre exact varie selon l'âge et la réserve ovarienne, et est lié au compte de follicules antraux que ta clinique peut mesurer.",
      "normal_cycle_s2_title": "En général un follicule domine",
      "normal_cycle_s2_body": "Un follicule devient en général le follicule dominant. Les autres de la même cohorte arrêtent de grandir et sont réabsorbés.",
      "normal_cycle_s3_title": "Pourquoi la stimulation est différente",
      "normal_cycle_s3_body": "La stimulation cherche à faire grandir plus de follicules de la même cohorte assez longtemps pour pouvoir y prélever des ovocytes.",
      "normal_cycle_s4_title": "Pourquoi c'est important pour la réserve",
      "normal_cycle_s4_body": "La vitrification ne prélève pas des ovocytes des mois futurs. Elle cherche à faire mûrir plus de follicules déjà recrutés dans le cycle en cours.",
      "stimulation_title": "Le médicament garde plus de follicules dans la course",
      "stimulation_body": "Les gonadotrophines injectables, en général sur 10 à 14 jours, soutiennent plusieurs follicules à la fois au lieu d'un seul.",
      "what_matters_here_label": "Ce qui compte ici",
      "stimulation_callout": "L'objectif, c'est un groupe coordonné, pas le plus grand nombre possible à tout prix.",
      "stimulation_detail_title": "Pourquoi le médicament recrute plus de follicules",
      "stimulation_s1_title": "La FSH, c'est un signal de croissance",
      "stimulation_s1_body": "Dans un cycle naturel, la FSH baisse quand un follicule prend la tête. Pendant la stimulation, la FSH injectable ou les gonadotrophines apparentées gardent le signal assez haut pour que plus de follicules continuent.",
      "stimulation_s2_title": "Les cliniques ajustent la dose",
      "stimulation_s2_body": "Âge, AMH, AFC, poids, diagnostic et réponse antérieure peuvent tous influencer la dose de départ et les ajustements ultérieurs.",
      "stimulation_s3_title": "Tous les follicules ne répondent pas pareil",
      "stimulation_s3_body": "Certains follicules grandissent vite, d'autres lentement, et certains ne produisent pas d'ovocyte mature. Cette variation est normale.",
      "maturity_label": "Maturité",
      "maturity_title": "Les follicules grandissent pendant que les ovocytes mûrissent à l'intérieur",
      "maturity_body": "Le follicule, c'est la structure remplie de liquide que ta clinique mesure. C'est l'ovocyte à l'intérieur qui doit mûrir.",
      "maturity_callout": "Un compte de follicules, ce n'est pas la même chose qu'un compte d'ovocytes matures.",
      "maturity_cta": "Personnalise avec tes résultats",
      "maturity_detail_title": "Follicules, ovocytes et maturité",
      "maturity_s1_title": "Les follicules se mesurent à l'échographie",
      "maturity_s1_body": "Pendant le monitoring, ta clinique mesure les follicules en millimètres. Les follicules plus grands ont plus de chances de contenir des ovocytes matures, mais la taille n'est pas une garantie.",
      "maturity_s2_title": "L'ovocyte mûrit dans le follicule",
      "maturity_s2_body": "Pendant que les follicules grandissent, l'ovocyte à l'intérieur passe par des stades de maturité. La clinique cale le déclenchement et la ponction pour maximiser les ovocytes matures.",
      "maturity_s3_title": "Pourquoi les comptes peuvent changer",
      "maturity_s3_body": "Tu peux entendre un compte de follicules, puis un compte d'ovocytes prélevés, puis un compte d'ovocytes matures. Chaque chiffre mesure une étape différente.",
      "monitoring_label": "Suivi",
      "monitoring_title": "Le suivi dit à la clinique quand ajuster",
      "monitoring_body": "Les visites ont souvent lieu tous les 2-3 jours. L'échographie montre la taille des follicules, les prises de sang la réponse hormonale.",
      "monitoring_callout": "Le monitoring n'est pas une simple confirmation. C'est ce qui permet à la clinique de rendre le cycle plus sûr et mieux cadencé.",
      "monitoring_detail_title": "Pourquoi le monitoring est important",
      "monitoring_s1_title": "La taille n'est qu'un signal",
      "monitoring_s1_body": "Les follicules doivent souvent atteindre une certaine fourchette de taille avant le déclenchement, mais les cliniques regardent toute la cohorte, pas seulement le plus gros.",
      "monitoring_s2_title": "Les hormones apportent du contexte",
      "monitoring_s2_body": "L'estradiol monte en général à mesure que les follicules grandissent. LH et progestérone aident la clinique à repérer les problèmes de timing.",
      "monitoring_s3_title": "Une cadence concrète",
      "monitoring_s3_body": "Beaucoup de gens sont monitorés tous les 2-3 jours pendant la stimulation. Près du déclenchement, la clinique peut te voir plus souvent parce que le timing devient plus serré.",
      "monitoring_s4_title": "Les ajustements sont normaux",
      "monitoring_s4_body": "Changements de dose, visites supplémentaires et estimations de ponction décalées sont fréquents. En général, c'est que la clinique réagit à tes données.",
      "trigger_label": "Déclenchement",
      "trigger_title": "Le déclenchement lance la maturation finale",
      "trigger_body": "L'injection de déclenchement dit aux ovocytes de finir leurs dernières étapes de maturation avant la ponction.",
      "trigger_callout": "Le déclenchement, ce n'est pas une injection comme les autres. Bien le caler dans le temps, c'est l'un des moments les plus importants du cycle.",
      "trigger_detail_title": "Le déclenchement et la maturation finale",
      "trigger_s1_title": "Les follicules peuvent paraître prêts avant l'ovocyte",
      "trigger_s1_body": "Un follicule peut être proche de la bonne taille alors que l'ovocyte à l'intérieur a encore besoin d'un signal final de maturation.",
      "trigger_s2_title": "La ponction est calée sur le déclenchement",
      "trigger_s2_body": "La ponction est en général programmée 34 à 36 heures après le déclenchement, avant que l'ovulation n'ait lieu.",
      "trigger_s3_title": "Pourquoi les cliniques donnent des horaires précis",
      "trigger_s3_body": "Prendre le déclenchement trop tôt ou trop tard peut affecter la maturité ou la possibilité de prélever les ovocytes. C'est pour ça que l'instruction est en général très précise.",
      "retrieval_label": "Ponction",
      "retrieval_procedure_title": "La ponction, c'est une intervention courte en ambulatoire",
      "retrieval_procedure_body": "Tu es en général sous sédation pendant qu'une fine aiguille, guidée par échographie, passe à travers la paroi vaginale pour atteindre les follicules.",
      "what_people_worry_label": "Ce qui inquiète souvent",
      "retrieval_procedure_callout": "C'est une intervention, mais pas une chirurgie abdominale. Il n'y a en général pas d'incision cutanée, et la plupart des gens rentrent chez elles ou eux le jour même.",
      "retrieval_procedure_detail_title": "À quoi ressemble la ponction d'ovocytes",
      "retrieval_procedure_s1_title": "C'est transvaginal",
      "retrieval_procedure_s1_body": "La ponction se fait en général avec une sonde d'échographie endovaginale. Une fine aiguille passe à travers la paroi vaginale dans chaque follicule accessible pour recueillir le liquide.",
      "retrieval_procedure_s2_title": "Tu es en général sous sédation",
      "retrieval_procedure_s2_body": "La plupart des cliniques utilisent une sédation IV ou une anesthésie, donc tu n'es pas éveillé·e comme pour une échographie de routine. Le plan d'anesthésie dépend de la clinique.",
      "retrieval_procedure_s3_title": "Récupération le jour même",
      "retrieval_procedure_s3_body": "L'intervention est en général courte, avec une récupération à la clinique ensuite. La plupart des gens ont besoin de quelqu'un pour les ramener et se reposer le reste de la journée.",
      "lab_handoff_label": "Passage au labo",
      "lab_handoff_title": "La clinique récupère le liquide folliculaire, puis le labo y trouve les ovocytes",
      "lab_handoff_body": "L'aiguille aspire le liquide des follicules. Le labo d'embryologie cherche les ovocytes dans ce liquide au microscope.",
      "lab_handoff_callout": "Les follicules se voient à l'échographie. Les ovocytes sont microscopiques, donc le nombre final d'ovocytes n'est connu qu'après la ponction.",
      "lab_handoff_detail_title": "Comment les follicules deviennent un compte d'ovocytes",
      "lab_handoff_s1_title": "Le follicule est la cible",
      "lab_handoff_s1_body": "Pendant la ponction, le clinicien vise les follicules assez grands et accessibles en sécurité. L'objectif est de recueillir le liquide où peut se trouver un ovocyte.",
      "lab_handoff_s2_title": "Le labo cherche dans le liquide",
      "lab_handoff_s2_body": "Un·e embryologiste examine le liquide recueilli pour identifier les ovocytes. C'est pour ça que le nombre de follicules visibles et celui d'ovocytes prélevés peuvent différer.",
      "lab_handoff_s3_title": "Tous les follicules ne donnent pas d'ovocyte mature",
      "lab_handoff_s3_body": "Certains follicules peuvent ne pas contenir d'ovocyte, et certains ovocytes peuvent être immatures. Ovocytes prélevés et ovocytes matures sont des étapes distinctes.",
      "egg_count_label": "Compte d'ovocytes",
      "egg_count_title": "Le chiffre de la ponction, c'est une étape parmi d'autres",
      "egg_count_body": "Le labo compte combien d'ovocytes sont trouvés après recueil du liquide folliculaire.",
      "what_people_ask_label": "Ce qu'on demande souvent",
      "egg_count_callout": "Ovocytes prélevés, ce n'est pas le chiffre final. Le nombre d'ovocytes matures est en général plus utile pour la vitrification.",
      "egg_count_cta": "Voir l'entonnoir de résultats",
      "egg_count_detail_title": "Combien d'ovocytes prélève-t-on en général ?",
      "egg_count_s1_title": "Ça varie selon les personnes",
      "egg_count_s1_body": "L'âge, l'AMH, le compte de follicules antraux, le diagnostic, le protocole et la réponse ovarienne influencent tous le nombre prélevé.",
      "egg_count_s2_title": "Une fourchette approximative",
      "egg_count_s2_body": "Beaucoup de cycles de vitrification prélèvent entre 5 et 20 ovocytes, mais certains en prélèvent moins et d'autres plus. Ta clinique doit personnaliser les attentes.",
      "egg_count_s3_title": "Prélevé n'est pas synonyme de mature",
      "egg_count_s3_body": "Après la ponction, le labo vérifie quels ovocytes sont assez matures pour la vitrification. Ce nombre mature peut être plus faible que le nombre prélevé.",
      "mii_label": "Ovocytes MII",
      "mii_title": "Les ovocytes matures sont vitrifiés pour le stockage",
      "mii_body": "Tu verras parfois le terme MII. Les ovocytes matures sont en général vitrifiés rapidement et conservés dans l'azote liquide autour de -196 °C.",
      "term_to_know_label": "Terme à connaître",
      "mii_callout": "MII, c'est le stade mature qui intéresse le plus les cliniques pour la vitrification.",
      "mii_cta": "En savoir plus sur les ovocytes MII",
      "mii_detail_title": "Ce que veut dire MII",
      "mii_s1_title": "MII veut dire métaphase II",
      "mii_s1_body": "Le MII est le stade où un ovocyte a terminé l'étape de maturation nécessaire avant qu'une fécondation puisse avoir lieu plus tard.",
      "mii_s2_title": "Pourquoi les ovocytes immatures ne sont pas toujours vitrifiés",
      "mii_s2_body": "Les ovocytes immatures fonctionnent moins bien après décongélation. Beaucoup de labos vitrifient les ovocytes matures MII car ils ont les meilleures chances d'usage futur.",
      "mii_s3_title": "Vitrification",
      "mii_s3_body": "La vitrification est une congélation rapide conçue pour réduire la formation de cristaux de glace. Les ovocytes vitrifiés sont stockés dans des cuves d'azote liquide à environ -196 °C.",
      "mii_s4_title": "Pourquoi le nombre change",
      "mii_s4_body": "Un cycle peut produire par exemple 14 ovocytes prélevés et 10 matures. Le nombre mature est en général celui qui entre dans ta banque d'ovocytes vitrifiés.",
      "later_use_label": "Usage futur",
      "attrition_title": "Ovocytes, embryons et naissances, ce sont des chiffres différents",
      "attrition_body": "Tous les ovocytes vitrifiés ne survivent pas à la décongélation, ne se fécondent pas, ne deviennent pas embryons, ne sont pas testés normaux, ne s'implantent pas ou ne donnent pas une naissance.",
      "why_estimates_exist_label": "Pourquoi on fait des estimations",
      "attrition_callout": "Le nombre cible d'ovocytes sert à améliorer les chances, pas à garantir un bébé.",
      "attrition_cta": "Personnaliser l'estimation",
      "attrition_detail_title": "L'entonnoir d'attrition",
      "attrition_s1_title": "Les ovocytes ne sont pas des embryons",
      "attrition_s1_body": "Un ovocyte vitrifié est une étape plus tôt qu'un embryon. Plus tard, il doit être décongelé, fécondé avec du sperme et se développer en embryon.",
      "attrition_s2_title": "L'attrition est attendue",
      "attrition_s2_body": "Certains ovocytes ne survivent pas à la décongélation, certains ne fécondent pas, certains embryons s'arrêtent et certains ne sont pas chromosomiquement normaux.",
      "attrition_s3_title": "Pourquoi l'âge compte",
      "attrition_s3_body": "L'âge au moment de la vitrification influence la qualité ovocytaire et la chance qu'un ovocyte mature devienne un jour un embryon viable et une naissance.",
      "estimate_none_value": "Il faut tes chiffres",
      "estimate_none_body": "L'âge n'est qu'un point de départ. C'est l'AMH, l'AFC et ton historique médical qui rendent l'estimation utile.",
      "estimate_8_14": "Souvent 8 à 14 ovocytes",
      "estimate_5_10": "Souvent 5 à 10 ovocytes",
      "estimate_clinic_specific": "Spécifique à la clinique",
      "estimate_under_35_body": "C'est une fourchette indicative basée sur l'âge. Ton AMH, ton AFC et ton historique peuvent la déplacer.",
      "estimate_35_37_body": "L'âge donne une indication, mais les chiffres de réserve ovarienne deviennent plus importants pour planifier.",
      "estimate_37_40_body": "Beaucoup utilisent l'AMH et l'AFC pour décider si plusieurs cycles ont du sens.",
      "estimate_over_40_body": "Après 40 ans, le rendement varie davantage. Une clinique doit personnaliser tout ça avec des tests.",
      "funnel_retrieved_detail": "Estimation de départ pour une ponction, avant l'attrition au labo.",
      "general_estimate": "Estimation générale",
      "funnel_mature_detail": "${diff} peuvent être immatures, manquants ou inutilisables après la ponction.",
      "funnel_frozen_label": "Ovocytes vitrifiés",
      "funnel_frozen_detail": "Ce sont en général les ovocytes matures qui sont vitrifiés et stockés.",
      "funnel_thawed_label": "Ovocytes décongelés",
      "funnel_thawed_detail": "${diff} pourraient ne pas survivre à la décongélation plus tard.",
      "funnel_fertilized_label": "Ovocytes fécondés",
      "funnel_fertilized_detail": "${diff} pourraient ne pas féconder après décongélation.",
      "funnel_blastocysts_detail": "${diff} pourraient s'arrêter avant le stade blastocyste.",
      "funnel_euploids_label": "Embryons euploïdes",
      "funnel_euploids_detail": "${diff} pourraient être chromosomiquement anormaux ou non testés.",
      "funnel_birth_label": "Chance de naissance vivante",
      "funnel_birth_detail": "Il s'agit d'une estimation de population générale de la probabilité d'au moins une naissance vivante à partir de cette cohorte.",
      "embryo_funnel_retrieved_detail": "Estimation de départ pour une ponction, avant maturité et attrition au labo.",
      "embryo_funnel_mature_detail": "${diff} peuvent être immatures, manquants ou inutilisables pour la fécondation.",
      "embryo_funnel_fertilized_detail": "${diff} pourraient ne pas féconder ou féconder anormalement.",
      "embryo_funnel_blastocysts_detail": "${diff} pourraient s'arrêter avant le stade blastocyste J5-J7.",
      "embryo_funnel_frozen_label": "Embryons vitrifiés/testés",
      "embryo_funnel_frozen_detail": "Les blastocystes qui remplissent les critères du labo sont en général vitrifiés ; certains peuvent aussi être biopsiés pour le PGT-A.",
      "embryo_funnel_euploids_label": "Embryons euploïdes",
      "embryo_funnel_euploids_detail": "${diff} peuvent être aneuploïdes, mosaïques, non testés ou non transférables selon le plan.",
      "embryo_funnel_birth_detail": "Il s'agit d'une estimation de planification de population générale de la probabilité d'au moins une naissance vivante à partir de la cohorte d'embryons euploïdes estimée.",
      "age_label": "âge",
      "age_with_value": "âge : ${userAge}",
      "add_amh": "Ajouter AMH",
      "amh_with_value": "AMH ${value} ${unit}",
      "afc_with_value": "AFC ${value}",
      "add_afc": "Ajouter AFC",
      "semen_analysis_lower": "spermogramme",
      "add_semen_analysis": "Ajouter un spermogramme",
      "planning_unit_embryos": "embryons euploïdes",
      "planning_unit_eggs": "ovocytes matures vitrifiés",
      "intro_copy_embryo": "On part d'une estimation du rendement ovocytaire selon l'âge, puis on affine en passant par la fécondation, le développement blastocyste, un éventuel PGT-A et la vitrification.",
      "intro_copy_embryo_with_amh": "Ton AMH et ton âge donnent une estimation personnalisée du nombre d'ovocytes, ensuite affinée par la fécondation, le développement blastocyste, un éventuel PGT-A et la vitrification.",
      "intro_copy_egg": "On part d'une estimation de cycle selon l'âge, puis on affine via l'entonnoir d'usage futur. Ajoute ton AMH et ton AFC pour rendre tout ça plus personnel.",
      "intro_copy_egg_with_amh": "Ton AMH et ton âge donnent une estimation personnalisée de ta ponction, puis l'entonnoir affine jusqu'à l'usage futur. Ajoute une AFC ou une évaluation en clinique pour aller plus loin.",
      "intro_copy_egg_with_amh_afc": "Ton âge, ton AMH et ton AFC donnent une estimation personnalisée de ta ponction, puis l'entonnoir affine jusqu'à l'usage futur. Une évaluation en clinique peut encore préciser tout ça.",
      "intro_copy_embryo_with_amh_afc": "Ton âge, ton AMH et ton AFC donnent une estimation personnalisée du nombre d'ovocytes, ensuite affinée par la fécondation, le développement blastocyste, un éventuel PGT-A et la vitrification.",
      "cta_check_testing": "Voir les options de tests",
      "cta_test_reserve": "Tester la réserve ovarienne",
      "open_detail_a11y": "Ouvrir le détail des hypothèses d'estimation",
      "how_many_children": "Combien d'enfants veux-tu prévoir ?",
      "planning_for_summary": "Prévoir ${childrenGoal} ${childLabel}, c'est viser environ ${target} ${planningUnitLabel} — soit environ ${estimatedCycles} ${cycleLabel} de collecte.",
      "child_singular": "enfant",
      "child_plural": "enfants",
      "cycle_singular": "cycle",
      "cycle_plural": "cycles",
      "reduce_children_goal": "Diminuer l'objectif d'enfants",
      "increase_children_goal": "Augmenter l'objectif d'enfants",
      "planning_for_summary_empty": "Tu prévois ${childrenGoal} ${childLabel}.",
      "no_estimate_add_amh": "Ajoute ton résultat d'AMH pour voir une estimation personnalisée.",
      "young_age_baseline_hint": "À ton âge, c'est surtout l'AMH qui compte. Tes chances devraient être au moins aussi bonnes que la base de référence à 30 ans montrée ci-dessous.",
      "advanced_age_needs_amh": "À ton âge, un dosage d'AMH est indispensable pour te donner une estimation qui a du sens.",
      "add_amh_cta": "Ajouter mon AMH",
      "illustrative_baseline_note": "Référence illustrative à ${baselineAge} ans — ajoute ton AMH pour personnaliser.",
      "illustrative_live_birth_probability": "Environ ${percent}% de chances d'avoir au moins ${childrenGoal} ${childLabel} à cet âge.",
      "planning_disclaimer": "C'est une estimation de planification, pas une garantie. Ta clinique peut l'ajuster avec l'AMH, l'AFC, le diagnostic, le protocole, les paramètres du sperme, le plan labo et la réponse aux cycles précédents.",
      "planning_disclaimer_with_amh": "Cette estimation part de ton AMH et de ton âge — c'est un repère, pas une garantie. Ta clinique peut l'affiner avec l'AFC, le diagnostic, le protocole, les paramètres du sperme et ta réponse aux cycles précédents.",
      "planning_disclaimer_with_amh_afc": "Cette estimation part de ton âge, de ton AMH et de ton AFC — c'est un repère, pas une garantie. Ta clinique peut l'affiner avec le diagnostic, le protocole, les paramètres du sperme et ta réponse aux cycles précédents.",
      "date_of_birth": "Date de naissance",
      "date_of_birth_subtitle": "Utilisée pour personnaliser ton estimation de cycle.",
      "date_of_birth_field": "Ta date de naissance",
      "save": "Enregistrer",
      "where_numbers_come_from": "Comprendre ces chiffres",
      "attrition_funnel": "Pourquoi le nombre baisse à chaque étape",
      "family_planning_target": "Combien de cycles pour ton projet ?",
      "detail_cycle_estimate_title": "D'où vient l'estimation d'un cycle",
      "detail_cycle_estimate_embryo": "Le premier chiffre est une estimation moyenne pour ton âge. Si tu ajoutes ton AMH ou ton AFC, on affine avec ces valeurs. Ton diagnostic, le spermogramme, la méthode de fécondation, le protocole choisi et la réponse à un cycle précédent peuvent le faire varier à la hausse comme à la baisse — ta clinique reste la meilleure référence pour un chiffre adapté à toi.",
      "detail_cycle_estimate_egg": "Le premier chiffre est une estimation moyenne pour ton âge. Si tu ajoutes ton AMH ou ton AFC, on affine avec ces valeurs. C'est une fourchette pour t'orienter, pas une prédiction — ton diagnostic et ta réponse au traitement peuvent le faire évoluer, et ta clinique reste la meilleure référence pour un chiffre adapté à toi.",
      "detail_attrition_embryo": "Tous les ovocytes ponctionnés ne deviennent pas des embryons transférables. Une partie n'est pas mature, une autre ne féconde pas, certaines n'atteignent pas le stade blastocyste, et si un PGT-A est fait, tous ne seront pas euploïdes. C'est normal — l'entonnoir montre ces étapes typiques pour rendre le chiffre final plus lisible.",
      "detail_attrition_egg": "Tous les ovocytes ponctionnés ne deviennent pas des bébés. Une partie n'est pas mature, une autre ne survit pas à la décongélation, certaines ne fécondent pas, et pas toutes les fécondations aboutissent à une grossesse. C'est normal — l'entonnoir montre ces étapes pour aider à comprendre le chiffre final, pas pour prédire ce qui va t'arriver.",
      "detail_family_target_embryo": "Selon le nombre d'enfants que tu envisages, on estime une cible d'embryons euploïdes à réunir (environ 2 pour un enfant, 4 pour deux, 6 pour trois). On divise cette cible par ton estimation par cycle pour te donner un ordre de grandeur du nombre de cycles.",
      "detail_family_target_egg": "Selon le nombre d'enfants que tu envisages, on estime une cible d'ovocytes matures à congeler (environ 15 pour un enfant, 28 pour deux, 42 pour trois). On divise cette cible par ton estimation par cycle pour te donner un ordre de grandeur — sachant qu'un chiffre plus élevé apporte plus de marge, mais que la qualité compte autant que la quantité.",
      "sources_title": "Sur quoi on s'appuie",
      "sources_body": "Ces chiffres sont des moyennes issues d'études publiées — pas un modèle propriétaire Louise. Ta clinique reste la mieux placée pour te donner un chiffre adapté à ta situation.",
      "sources_intro": "Ces chiffres sont des moyennes issues d'études publiées — pas un modèle propriétaire Louise. Ta clinique reste la mieux placée pour te donner un chiffre adapté à ta situation.",
      "sources_item_retrieval_age": "Estimation d'ovocytes par l'âge — Machtinger et al., 2025.",
      "sources_item_retrieval_amh": "Estimation avec l'AMH — La Marca et al., 2011.",
      "sources_item_retrieval_amh_afc": "Estimation avec l'AMH et l'AFC — Choi et al., 2016.",
      "sources_item_goldman": "Modèle Goldman — c'est une estimation théorique optimiste qu'on garde pour référence, mais on ne l'intègre pas dans la chance de naissance affichée.",
      "sources_item_doyle": "Chance de naissance vivante par tranche d'âge — nomogramme Doyle et al., 2016.",
      "sources_item_cobo": "Chance de naissance vivante par ovocyte décongelé — Cobo et al., 2016.",
      "get_personalized_estimate": "Obtiens ton estimation personnalisée",
      "how_many_eggs_question": "Combien d'ovocytes par cycle, à peu près ?",
      "bridge_estimate_text": "${value}. ${body} Un cycle, c'est une phase de stimulation plus une ponction ; certain·e·s en font plusieurs.",
      "know_your_numbers": "Connais tes chiffres",
      "coverage_title_default": "Comprends tes coûts probables",
      "coverage_title_sperm": "Comprends les coûts de banque et de stockage",
      "coverage_subtitle_default": "Vérifie ta couverture avant de comparer les cliniques ou les options à ta charge.",
      "coverage_subtitle_sperm": "Vérifie ta couverture avant de comparer spermogramme, cryostockage et options à ta charge.",
      "coverage_tag_treatment": "Traitement",
      "coverage_treatment_body": "Frais de clinique, monitoring, ponction, labo et vitrification peuvent être estimés une fois la couverture connue.",
      "coverage_treatment_footer": "Pris en charge, partiel ou à ta charge",
      "coverage_tag_medication": "Médicaments",
      "coverage_medication_title": "Fourchette médicaments",
      "coverage_medication_body": "Les médicaments de stimulation peuvent faire varier beaucoup la facture. Certaines mutuelles couvrent la pharmacie, d'autres juste le traitement, d'autres demandent une autorisation préalable.",
      "coverage_medication_footer": "La couverture pharmacie compte",
      "coverage_tag_benefits": "Avantages employeur",
      "coverage_employer_title": "Programmes employeur",
      "coverage_employer_body": "Ta mutuelle d'entreprise, les accords santé spécifiques à la fertilité, les avantages employeur directs et les règles locales peuvent changer le résultat final.",
      "coverage_employer_footer": "Pas seulement l'assurance fertilité",
      "coverage_tag_banking": "Banque (sperme)",
      "coverage_sample_title": "Estimation échantillon + stockage",
      "coverage_sample_body": "Spermogramme, recueil, préparation, congélation et stockage annuel peuvent être estimés une fois la couverture connue.",
      "coverage_sample_footer": "Tests, banque, stockage",
      "coverage_tag_retest": "Retest",
      "coverage_retest_title": "Coût initial et coût de répétition",
      "coverage_retest_body": "Si tu congèles maintenant et que tu refais un test après une fenêtre de reset, l'estimation peut séparer le premier échantillon des tests de suivi et des fioles supplémentaires.",
      "coverage_retest_footer": "Test initial + retest à 90 jours",
      "coverage_sperm_employer_body": "Les avantages employeur, les HSA/FSA, les forfaits à ta charge, les frais de stockage et les règles de couverture fertilité peuvent tous changer la trajectoire finale.",
      "criterion_health_insurance": "Assurance santé",
      "criterion_insurance_added": "Assurance ajoutée",
      "criterion_add_insurance": "Ajouter une assurance",
      "criterion_employer_benefits": "Avantages employeur",
      "criterion_benefits_added": "Avantages ajoutés",
      "criterion_benefits_checked": "Avantages vérifiés",
      "criterion_check_benefits": "Vérifier les avantages",
      "criterion_coverage_status": "Statut de couverture",
      "criterion_status_checked": "Statut vérifié",
      "criterion_confirm_status": "Confirmer le statut",
      "action_check_coverage_status": "Vérifier le statut de couverture",
      "action_open_cost_estimate": "Ouvrir l'estimation des coûts",
      "unlock_cost_estimate": "Débloque ton estimation des coûts",
      "coverage_status_ready": "Statut de couverture prêt",
      "unlock_explainer": "On regarde l'assurance santé, les avantages fertilité employeur et le statut à ta charge. Une couverture peut concerner les diagnostics, les médicaments, le stockage ou les programmes employeur même si le traitement de fertilité n'est pas couvert.",
      "ready_explainer": "On peut maintenant afficher l'estimation avec ta couverture connue et continuer à l'affiner au fil des avantages, des autorisations et des prix des cliniques.",
      "step_1": "Étape 1",
      "step_2": "Étape 2",
      "step_3": "Étape 3",
      "step_4": "Étape 4",
      "step_5": "Étape 5",
      "opt_step_1_title": "Établis ton point de départ",
      "opt_step_1_body": "Commence avant le cycle par les chiffres et l'historique qui expliquent ta réponse probable et ce qui peut faire bouger le plan.",
      "opt_step_1_bullet_1": "AMH, AFC, âge et réponse antérieure aident à estimer le rendement probable",
      "opt_step_1_bullet_2": "Les hormones J2-J3, la thyroïde, la vitamine D et les marqueurs métaboliques peuvent compter",
      "opt_step_1_bullet_3": "Ton historique aide à décider ce qui vaut la peine d'être testé maintenant",
      "opt_step_1_detail_title": "Tests de base et historique",
      "opt_step_1_s1_title": "Pourquoi ça vient en premier",
      "opt_step_1_s1_body": "L'optimisation doit commencer par ce qui est mesurable et actionnable. AMH, AFC, âge, historique et certains labos peuvent aider à estimer la réponse probable et à identifier des points qui pourraient changer le timing ou la sécurité.",
      "opt_step_1_s2_title": "Ne pas tout tester à l'aveugle",
      "opt_step_1_s2_body": "Les tests sont surtout utiles quand ils peuvent changer une étape suivante : planification du traitement, correction d'une carence, sécurité des médicaments, ou besoin d'impliquer un·e spécialiste.",
      "opt_step_2_body": "Commence par le levier le plus clair et le moins coûteux. L'idée, ce n'est pas d'empiler des produits.",
      "opt_step_2_bullet_1": "Arrête le tabac ou la vape si tu peux",
      "opt_step_2_bullet_2": "Passe en revue alcool, cannabis et expositions environnementales",
      "opt_step_2_bullet_3": "Priorise le sommeil et la récupération plutôt que des routines extrêmes",
      "opt_step_2_cta": "Construire mon plan",
      "opt_step_2_detail_title": "Stress oxydatif et expositions",
      "opt_step_2_s1_title": "Pourquoi on parle de stress oxydatif",
      "opt_step_2_s1_body": "Le stress oxydatif peut affecter les cellules, y compris reproductrices. Le tabac et la vape font partie des catégories d'exposition les plus clairement modifiables avant un traitement de fertilité.",
      "opt_step_2_s2_title": "Évite le perfectionnisme",
      "opt_step_2_s2_body": "L'idée n'est pas d'éliminer toutes les expositions possibles. C'est d'identifier les grands changements réalistes qui comptent pour ta situation.",
      "opt_step_3_title": "Soutiens sommeil, nutrition et santé métabolique",
      "opt_step_3_body": "Dans les semaines avant le traitement, agis sur ce qui peut affecter tes hormones, l'inflammation et la planification du cycle.",
      "opt_step_3_bullet_1": "Particulièrement pertinent en cas de PMOS (ex SOPK), cycles irréguliers ou insulinorésistance",
      "opt_step_3_bullet_2": "Protéines, fibres, activité et sommeil soutiennent la stabilité métabolique",
      "opt_step_3_bullet_3": "Les changements de médicaments doivent être encadrés par un·e clinicien·ne",
      "opt_step_3_cta": "Compléter l'historique médical",
      "opt_step_3_detail_title": "Sommeil, nutrition et contexte métabolique",
      "opt_step_3_s1_title": "Pourquoi ça compte",
      "opt_step_3_s1_body": "Les profils métaboliques et hormonaux peuvent affecter la planification de la stimulation, le choix des médicaments, la sécurité et parfois le timing d'un cycle.",
      "opt_step_3_s2_title": "Ce qui est concret",
      "opt_step_3_s2_body": "L'objectif n'est pas un régime extrême. Ce sont des repas stables, une activité adaptée, du sommeil et la prise en charge de problèmes clairs comme un dysfonctionnement thyroïdien ou une insulinorésistance si présents.",
      "opt_step_4_title": "Passe en revue les compléments selon le niveau de preuve",
      "opt_step_4_body": "Avant de commencer quoi que ce soit, passe en revue les compléments par niveau de preuve. C'est une revue, pas une liste de courses.",
      "opt_step_4_bullet_1": "Base solide/courante : prénatal ou folate si pertinent ; vitamine D en cas de carence",
      "opt_step_4_bullet_2": "Discussion modérée/courante : CoQ10",
      "opt_step_4_bullet_3": "Contexte spécifique ou encadrement clinique : myo-inositol, oméga-3, DHEA, compléments hormonaux",
      "opt_step_4_cta": "Voir les preuves sur les compléments",
      "opt_step_4_detail_title": "Niveaux de preuve des compléments",
      "opt_step_4_s1_title": "Pourquoi c'est confus",
      "opt_step_4_s1_body": "Les espaces fertilité en ligne mélangent souvent anecdotes personnelles, habitudes de cliniques et études limitées. Ça peut faire ressentir les compléments comme obligatoires alors que les preuves sont mitigées ou très individuelles.",
      "opt_step_4_s2_title": "La bonne question",
      "opt_step_4_s2_body": "La question n'est pas « qu'est-ce que tout le monde prend ? » C'est « qu'est-ce qui a des preuves, qu'est-ce qui est pertinent pour mon diagnostic, et qu'est-ce qui pourrait interagir avec mes médicaments ou mon protocole ? »",
      "opt_step_4_s3_title": "Catégorie encadrée cliniquement",
      "opt_step_4_s3_body": "La DHEA et les compléments hormonaux ne se prennent pas à la légère. Ils peuvent être inappropriés pour certains diagnostics et doivent être revus avec un·e clinicien·ne.",
      "opt_step_5_title": "Suis et personnalise",
      "opt_step_5_body": "Louise peut transformer ton historique, tes labos, médicaments, compléments, expositions et timing en un plan pratique avant cycle.",
      "opt_step_5_bullet_1": "Utilise tes labos, ton historique, ton âge, ton calendrier et tes objectifs",
      "opt_step_5_bullet_2": "Décide ce qui vaut le coup maintenant et ce qui peut attendre",
      "opt_step_5_bullet_3": "Explique ce qui vaut le coup d'être payé et ce qui ne le vaut pas",
      "opt_step_5_cta": "Construire mon protocole d'optimisation",
      "opt_step_5_detail_title": "Protocole d'optimisation ciblé",
      "opt_step_5_s1_title": "Ce que la revue doit faire",
      "opt_step_5_s1_body": "Une bonne revue d'optimisation doit traduire historique, labos, médicaments, compléments, expositions et objectifs en un plan pratique.",
      "opt_step_5_s2_title": "Ce qu'elle doit éviter",
      "opt_step_5_s2_body": "Elle doit éviter les listes génériques basées sur la peur, les promesses non étayées et les étapes coûteuses qui ne changent pas la planification du traitement."
    },
    "recorded_birth": {
      "a_baby_was_born": "Votre b\u00e9b\u00e9 est n\u00e9",
      "babies_were_born": "Vos b\u00e9b\u00e9s sont n\u00e9s",
      "congratulations_close_whenever_you_are_ready": "F\u00e9licitations. C'est enregistr\u00e9 sur ce cycle \u2014 cl\u00f4turez-le quand vous serez pr\u00eat\u00b7e, il rejoindra votre historique.",
      "keep_this_with_your_records": "Garder tout ça avec vos dossiers",
      "the_record_stays_and_louise_holds_your_questions": "Tout ce qui a été enregistré sur ce cycle reste dans vos dossiers. Louise peut garder une question jusqu'à ce que vous vouliez la poser.",
      "ask_louise_your_questions": "Posez vos questions à Louise",
      "the_result_stays_with_your_records": "Le résultat reste avec vos dossiers",
      "the_cycle_joins_your_history_once_closed": "Le cycle rejoint votre historique à sa clôture",
      "chat_prompt_after_a_birth": "Mon traitement de fertilité s'est terminé par une naissance. Aidez-moi à réunir les questions que je veux poser à mon équipe soignante, et ce qui vaut la peine d'être gardé dans mes dossiers. Ne posez pas de diagnostic et ne modifiez pas mon traitement.",
      "supporting": {
        "congratulations_to_you_both": "F\u00e9licitations \u00e0 vous deux. C'est enregistr\u00e9 sur ce cycle."
      }
    },
    "standing_pregnancy": {
      "congratulations_its_positive": "F\u00e9licitations, c'est positif",
      "saved_and_tell_us_where_you_are": "C'est enregistr\u00e9 sur ce cycle. Prenez le temps qu'il vous faut ; quand vous voudrez, dites-nous o\u00f9 vous en \u00eates et nous daterons la suite.",
      "supporting": {
        "congratulations_to_you_both": "F\u00e9licitations \u00e0 vous deux. C'est enregistr\u00e9 sur ce cycle."
      }
    },
    "closed_without_a_result": {
      "this_cycle_is_closed": "Ce cycle est ferm\u00e9",
      "what_stays_in_your_records": "Ce qui reste dans vos dossiers",
      "nothing_here_needs_deciding_today": "Rien ici ne demande de d\u00e9cision aujourd'hui. C'est l\u00e0 quand vous en aurez envie.",
      "review_this_cycle": "Revoir ce cycle",
      "take_a_breath_the_record_is_kept_and_can_wait": "Respirez \u2014 rien n'a besoin d'\u00eatre d\u00e9cid\u00e9 aujourd'hui. Tout ce qui a \u00e9t\u00e9 enregistr\u00e9 sur ce cycle reste dans vos dossiers, et vous pourrez nous dire comment il s'est termin\u00e9 quand vous le voudrez.",
      "supporting": {
        "this_cycle_is_closed": "Ce cycle est ferm\u00e9",
        "the_record_is_kept_and_nothing_needs_doing": "Respirez. Tout ce qui a \u00e9t\u00e9 enregistr\u00e9 sur ce cycle est conserv\u00e9, et rien n'a besoin d'\u00eatre fait aujourd'hui."
      }
    },
    "cycle_closing": {
      "ui": {
        "close_cycle": "Clôturer ce cycle",
        "review_cycle": "Revoir ce cycle",
        "done": "J'ai compris",
        "done_early": "J'ai compris",
        "open_cycle": "Ouvrir ce cycle"
      },
      "conceiving": {
        "pregnancy": {
          "positive_result": "Un résultat positif",
          "positive_result_clinic_guidance": "Félicitations. Rien à décider aujourd'hui — votre clinique confirmera la suite.",
          "supporting": {
            "positive_result": "Un résultat positif",
            "positive_result_shared_clinic_guidance": "Félicitations à vous deux. Votre part dans ce cycle est terminée — la clinique guidera les prochaines étapes."
          }
        },
        "no_pregnancy": {
          "cycle_is_complete": "Ce cycle est terminé",
          "no_pregnancy_context": "Celui-ci ne s'est pas terminé par une grossesse. Rien n'est à décider aujourd'hui, et vous n'y êtes pour rien.",
          "supporting": {
            "cycle_is_complete": "Ce cycle est terminé",
            "no_pregnancy_support_context": "Celui-ci ne s'est pas terminé par une grossesse. Il n'y a rien à réparer aujourd'hui — être là suffit."
          }
        },
        "loss": {
          "cycle_ended_in_loss": "Ce cycle s'est terminé par une perte",
          "loss_care_guidance": "Nous sommes vraiment désolés. Prenez le temps qu'il vous faut. Votre équipe soignante est le bon interlocuteur pour la suite.",
          "supporting": {
            "cycle_ended_in_loss": "Ce cycle s'est terminé par une perte",
            "loss_support_guidance": "Nous sommes vraiment désolés. Prenez le temps qu'il vous faut à tous les deux — rien n'est attendu de vous aujourd'hui."
          }
        },
        "cancelled": {
          "cycle_was_cancelled": "Ce cycle a été annulé",
          "cancelled_cycle_guidance": "Un cycle annulé n'est pas un résultat. Quelle qu'en soit la raison, s'arrêter était une décision raisonnable."
        },
        "unresolved": {
          "result_is_not_settled": "Ce résultat n'est pas encore établi",
          "unresolved_result_guidance": "Nous n'avons pas assez d'éléments pour trancher, donc nous ne devinerons pas. Votre clinique pourra le confirmer."
        }
      },
      "preservation": {
        "complete": {
          "preservation_reached_completion": "Vous êtes allé·e au bout",
          "stored_materials_are_ready": "Cela vous a demandé beaucoup, et c'est fait. Ce que vous avez conservé est à vous, pour quand vous serez prêt·e."
        },
        "cancelled": {
          "cycle_was_cancelled": "Ce cycle a été annulé",
          "preservation_cancellation_guidance": "Rien n'a été conservé cette fois. S'arrêter était une décision raisonnable, et cela peut être retenté."
        },
        "unresolved": {
          "result_is_not_settled": "La fin de ce cycle n'est pas encore établie",
          "preservation_result_guidance": "Nous n'avons pas assez d'éléments pour décrire ce qui s'est passé. Votre équipe soignante pourra le confirmer."
        }
      },
      "donation": {
        "complete": {
          "donation_is_complete": "Votre don est terminé",
          "donation_acknowledgement": "Merci — c'est un geste généreux."
        },
        "cancelled": {
          "cycle_was_cancelled": "Ce cycle a été annulé",
          "donation_cancellation_guidance": "Ce cycle de don n'a pas eu lieu. S'arrêter était une décision raisonnable."
        },
        "unresolved": {
          "result_is_not_settled": "La fin de ce cycle de don n'est pas encore établie",
          "donation_result_guidance": "Nous n'avons pas assez d'éléments pour décrire ce qui s'est passé. Votre équipe soignante pourra le confirmer."
        }
      },
      "surrogacy": {
        "pregnancy": {
          "positive_result": "Un résultat positif",
          "positive_result_clinic_guidance": "Félicitations. Votre clinique et l'équipe soignante de votre gestatrice guideront la suite.",
          "supporting": {
            "positive_result": "Un résultat positif",
            "positive_result_shared_clinic_guidance": "Félicitations à vous deux. La clinique et l'équipe soignante de votre gestatrice guideront les prochaines étapes."
          }
        },
        "no_pregnancy": {
          "cycle_is_complete": "Ce cycle est terminé",
          "no_pregnancy_context": "Celui-ci ne s'est pas terminé par une grossesse. Rien n'est à décider aujourd'hui.",
          "supporting": {
            "cycle_is_complete": "Ce cycle est terminé",
            "no_pregnancy_support_context": "Celui-ci ne s'est pas terminé par une grossesse. Il n'y a rien à réparer aujourd'hui."
          }
        },
        "loss": {
          "cycle_ended_in_loss": "Ce cycle s'est terminé par une perte",
          "loss_care_guidance": "Nous sommes vraiment désolés. Prenez le temps qu'il vous faut — pour vous et pour votre gestatrice.",
          "supporting": {
            "cycle_ended_in_loss": "Ce cycle s'est terminé par une perte",
            "loss_support_guidance": "Nous sommes vraiment désolés. Prenez le temps qu'il vous faut à tous les deux."
          }
        },
        "cancelled": {
          "cycle_was_cancelled": "Ce cycle a été annulé",
          "cancelled_cycle_guidance": "Un cycle annulé n'est pas un résultat. S'arrêter était une décision raisonnable."
        },
        "unresolved": {
          "result_is_not_settled": "Ce résultat n'est pas encore établi",
          "unresolved_result_guidance": "Nous n'avons pas assez d'éléments pour trancher, donc nous ne devinerons pas."
        }
      },
      "slides": {
        "conceiving": {
          "now": {
            "nothing_needs_deciding_today": "Rien à décider aujourd'hui",
            "saved_result_can_wait": "Vous n'avez pas à choisir la suite maintenant. Ce résultat est enregistré, et il sera toujours là quand vous serez prêt·e à le regarder."
          },
          "next": {
            "cycle_history": "Où en sont les choses",
            "cycle_history_guidance": "Le résultat et tout ce qui a été enregistré avec lui se trouvent dans l'historique de ce cycle. Louise peut garder vos questions jusqu'à votre prochain rendez-vous."
          }
        },
        "preservation": {
          "now": {
            "nothing_needs_deciding_today": "Rien à décider aujourd'hui",
            "stored_materials_can_wait": "Il n'y a aucune étape à choisir maintenant. Ce que vous avez conservé reste conservé, et vous pouvez y revenir quand vous voulez."
          },
          "next": {
            "cryo_vault": "Ce que vous avez conservé",
            "cryo_vault_guidance": "Votre coffre cryo contient ce qui a été congelé et où c'est conservé. Les détails et les frais de conservation s'y trouvent aussi."
          }
        },
        "donation": {
          "now": {
            "nothing_needs_deciding_today": "Rien à décider aujourd'hui",
            "donation_needs_no_action": "Votre part est faite. Rien n'est attendu de vous maintenant."
          },
          "next": {
            "cycle_record": "Où en sont les choses",
            "cycle_record_guidance": "Le dossier de ce cycle contient ce qui a été recueilli et quand. Louise peut garder les questions qu'il vous reste."
          }
        },
        "surrogacy": {
          "now": {
            "nothing_needs_deciding_today": "Rien à décider aujourd'hui",
            "saved_result_can_wait": "Vous n'avez pas à choisir la suite maintenant. Ce résultat est enregistré, et il sera toujours là quand vous serez prêt·e."
          },
          "next": {
            "cycle_history": "Où en sont les choses",
            "cycle_history_guidance": "Le résultat et tout ce qui a été enregistré avec lui se trouvent dans l'historique de ce cycle. Louise peut garder vos questions jusqu'à votre prochain échange."
          }
        }
      }
    },
    "review_concept": {
      "today_done_banner_title": "Tout est prêt pour aujourd'hui.",
      "today_done_banner_subtitle": "Les petites victoires comptent. C'est fait pour aujourd'hui.",
      "today_empty_banner_title": "Rien de prévu aujourd'hui.",
      "today_empty_banner_subtitle": "Les médicaments et rendez-vous que tu ajoutes apparaîtront ici.",
      "future_use_vault_unavailable_title": "Votre coffre est temporairement indisponible.",
      "future_use_vault_unavailable_subtitle": "Nous n'avons pas pu charger les dossiers de cette projection. Ouvrez votre coffre pour les consulter.",
      "future_use_vault_partial_title": "Certains dossiers du coffre se chargent encore.",
      "future_use_vault_partial_subtitle": "Cette projection se mettra à jour lorsque les autres dossiers de stockage seront disponibles.",
      "peek_at_tomorrow": "Aperçu de demain",
      "peek_a11y": "Jeter un œil aux jours suivants",
      "peek_dialog_title": "Un aperçu",
      "peek_dialog_subtitle": "Les prochains jours peuvent évoluer après le monitoring, mais voici le plan actuel.",
      "peek_nothing_scheduled_title": "Rien de prévu pour l'instant.",
      "peek_nothing_scheduled_detail": "Si la clinique ajoute quelque chose, ça apparaîtra ici.",
      "peek_day_tomorrow": "Demain",
      "dialog_cancel": "Annuler",
      "dialog_close": "Fermer",
      "dialog_save": "Enregistrer",
      "cycle_status_review_title": "Gardons les faits de ce cycle",
      "cycle_status_review_summary": "Un parcours de traitement annulé ou modifié n’est pas la même chose qu’un résultat négatif. Vérifiez ce qui a été enregistré et confirmez la prochaine étape avec votre équipe soignante.",
      "post_procedure": {
        "subtitle": "Un rapide point nous aide à passer à la bonne prochaine étape.",
        "back": "Retour",
        "yes_title": "Oui, c'est fait",
        "yes_detail": "Indique la date et ce dont tu veux te souvenir.",
        "not_yet_title": "Pas encore",
        "not_yet_detail": "Nous laisserons cette transition ici pour que tu puisses y revenir après.",
        "not_yet_details_title": "Pas encore",
        "not_yet_details_prompt": "Si tu le souhaites, ajoute une note sur le délai ou la suite prévue.",
        "not_yet_notes_placeholder": "Un détail sur le délai ou la prochaine étape…",
        "not_yet_save": "Enregistrer et garder la transition",
        "cancelled_title": "C'est annulé",
        "cancelled_detail": "Nous ne te le redemanderons pas pour le moment.",
        "cancelled_details_title": "C'est annulé",
        "cancelled_details_prompt": "Si tu le souhaites, ajoute ce dont tu veux te souvenir à propos de l'annulation.",
        "cancelled_notes_placeholder": "Ce dont tu veux te souvenir à propos de l'annulation…",
        "cancelled_save": "Enregistrer et fermer",
        "cancellation_title": "Quelle est la suite ?",
        "cancellation_prompt": "Une procédure annulée ne signifie pas toujours que tout le cycle est terminé.",
        "rescheduled_title": "Elle sera reprogrammée",
        "rescheduled_detail": "Garde le cycle ouvert et ajoute une note sur la suite prévue.",
        "rescheduled_details_title": "Ajoute une note sur la suite prévue",
        "rescheduled_details_prompt": "Si tu sais ce qui est prévu, tu peux l'ajouter ici.",
        "rescheduled_date_label": "Nouvelle date et heure prévues (heure facultative)",
        "rescheduled_notes_placeholder": "Un détail sur la nouvelle date ou la prochaine étape…",
        "rescheduled_save": "Enregistrer et garder le cycle ouvert",
        "cycle_cancelled_title": "Le cycle se termine",
        "cycle_cancelled_detail": "Nous allons t'accompagner pour fermer le cycle.",
        "not_sure_title": "Je ne sais pas encore",
        "not_sure_detail": "Garde le cycle ouvert pendant que tu attends la clinique.",
        "not_sure_details_title": "Garder cela ouvert pour l'instant",
        "not_sure_details_prompt": "Si tu le souhaites, ajoute une note en attendant la prochaine étape de la clinique.",
        "not_sure_notes_placeholder": "Ce dont tu veux te souvenir en attendant…",
        "not_sure_save": "Enregistrer et garder ouvert",
        "embryos_label": "Embryons transférés (facultatif)",
        "embryos_placeholder": "p. ex. 1",
        "notes_label": "Notes (facultatif)",
        "notes_placeholder": "Ce dont tu veux te souvenir ou parler à la clinique…",
        "save_and_continue": "Enregistrer et commencer l'attente",
        "save_failed": "Impossible d'enregistrer la procédure pour l'instant. Réessaie.",
        "transfer": {
          "title": "Ton transfert embryonnaire a-t-il eu lieu ?",
          "prompt": "Si oui, ajoute la date et les détails que tu souhaites garder dans ton cycle.",
          "question": "Ton transfert était prévu aujourd'hui. Que s'est-il passé ?",
          "date_label": "Date et heure du transfert",
          "details_subtitle": "Parle-nous de ton transfert",
          "handoff_title": "Le jour de ton transfert",
          "handoff_body": "Quand tu es prête, raconte-nous comment s'est passé ton transfert. Nous utiliserons la bonne date pour ton attente de deux semaines.",
          "handoff_cta": "Raconter ce qui s'est passé",
          "handoff_check_1": "Confirmer la procédure",
          "handoff_check_2": "Ajouter une note",
          "handoff_check_3": "Commencer l'attente de deux semaines"
        },
        "insemination": {
          "title": "Ton IIU a-t-elle eu lieu ?",
          "prompt": "Si oui, ajoute la date et les détails que tu souhaites garder dans ton cycle.",
          "question": "Ton IIU était prévue aujourd'hui. Que s'est-il passé ?",
          "date_label": "Date et heure de l'IIU",
          "details_subtitle": "Parle-nous de ton IIU",
          "handoff_title": "Le jour de ton IIU",
          "handoff_body": "Quand tu es prête, raconte-nous comment s'est passée ton IIU. Nous utiliserons la bonne date pour ton attente de deux semaines.",
          "handoff_cta": "Raconter ce qui s'est passé",
          "handoff_check_1": "Confirmer la procédure",
          "handoff_check_2": "Ajouter une note",
          "handoff_check_3": "Commencer l'attente de deux semaines"
        },
        "ovulation_window": {
          "title": "Ta fenêtre d'ovulation a-t-elle eu lieu ?",
          "prompt": "Si oui, ajoute la date et les détails que tu souhaites garder dans ton cycle.",
          "question": "Ta fenêtre d'ovulation était prévue aujourd'hui. Que s'est-il passé ?",
          "date_label": "Date et heure de la procédure",
          "details_subtitle": "Raconte-nous ce qui s'est passé",
          "handoff_title": "Ta fenêtre d'ovulation",
          "handoff_body": "Quand tu es prête, raconte-nous ce qui s'est passé. Nous utiliserons la bonne date pour la prochaine attente.",
          "handoff_cta": "Raconter ce qui s'est passé",
          "handoff_check_1": "Confirmer la procédure",
          "handoff_check_2": "Ajouter une note",
          "handoff_check_3": "Commencer la prochaine attente"
        }
      },
      "log_prefix": "Noter : ${title}",
      "log_monitoring_visit_title": "Noter la visite de suivi",
      "log_monitoring_results_title": "Noter les résultats du suivi",
      "log_symptoms_title": "Noter les symptômes",
      "log_medication_summary": "Confirme comment la prise s'est passée. Si quelque chose a été en retard, manqué, douloureux ou peu clair, ajoute-le ici.",
      "log_monitoring_summary": "Ajoute les valeurs d'échographie et de prise de sang de cette visite. Tu pourras revenir les modifier plus tard.",
      "log_appointment_summary": "Confirme le statut du rendez-vous et ajoute un résultat ou une note de suivi.",
      "log_monitoring_results_summary": "Choisis la date de la visite, puis ajoute les valeurs d'échographie et de prise de sang.",
      "log_symptoms_summary": "Choisis le jour, ajoute les symptômes, et signale tout ce qui semble pire que prévu.",
      "log_monitoring_results_unavailable_summary": "La saisie du suivi depuis Home n'est pas encore connectée aux dossiers Care enregistrés.",
      "log_appointment_unavailable_summary": "La fin d'un rendez-vous depuis Home n'est pas encore connectée aux dossiers Care enregistrés.",
      "log_task_unavailable_summary": "Cette tâche Home n'est pas encore connectée aux dossiers Care enregistrés.",
      "log_task_summary": "Confirme ce qui s'est passé et ajoute ce dont tu veux te souvenir.",
      "log_symptoms_unavailable_summary": "Les bilans de symptômes depuis Home ne sont pas encore connectés aux dossiers Care enregistrés.",
      "completion_unavailable_monitoring": "Louise ne peut pas encore enregistrer les résultats de suivi depuis Home, donc cet élément n'a pas été marqué comme terminé. Utilise Care si tu dois mettre à jour les dossiers enregistrés.",
      "completion_unavailable_appointment": "Louise ne peut pas encore enregistrer la fin d'un rendez-vous depuis Home, donc cet élément n'a pas été marqué comme terminé. Utilise Care si tu dois mettre à jour les dossiers enregistrés.",
      "completion_unavailable_task": "Louise ne peut pas encore enregistrer cette tâche Home, donc elle n'a pas été marquée comme terminée.",
      "completion_unavailable_symptoms": "Louise ne peut pas encore enregistrer les bilans de symptômes depuis Home. Rien n'a été enregistré.",
      "field_notes": "Notes",
      "field_estradiol": "Estradiol",
      "field_estradiol_e2": "Estradiol (E2)",
      "field_lh": "LH",
      "field_progesterone": "Progestérone",
      "field_lining": "Endomètre",
      "field_lead_follicle": "Follicule principal",
      "field_left_ovary_follicles": "Follicules ovaire gauche",
      "field_right_ovary_follicles": "Follicules ovaire droit",
      "field_clinic_notes": "Notes de la clinique",
      "field_weight_change": "Changement de poids",
      "field_result_or_followup": "Résultat ou suivi",
      "field_severity": "Intensité",
      "field_symptoms": "Symptômes",
      "placeholder_e2_example": "p. ex. 1820",
      "placeholder_follicle_example": "p. ex. 18",
      "placeholder_lh_example": "p. ex. 12,4",
      "placeholder_progesterone_example": "p. ex. 1,2",
      "placeholder_lining_example": "p. ex. 8",
      "placeholder_optional": "optionnel",
      "placeholder_follicle_sizes": "Tailles en mm, séparées par des virgules",
      "placeholder_medication_notes": "Souci de dose, site d'injection, effet secondaire, ou autre chose à demander à la clinique…",
      "placeholder_monitoring_notes": "Changements de dose, consignes pour le déclencheur, prochaine visite, questions…",
      "placeholder_clinic_notes": "Changements de dose, consignes pour le déclencheur, questions pour la clinique…",
      "placeholder_appointment_result": "Résultats, instructions, prochaines étapes, ou tout élément manquant…",
      "placeholder_generic_notes": "Tout ce que tu veux retenir…",
      "placeholder_symptom_notes": "Ce qui a changé, ce qui a aidé, ou ce que tu veux dire à l'équipe soignante…",
      "medication_log_on_time_label": "Prise à l'heure",
      "medication_log_on_time_detail": "La dose a été prise à l'heure prévue.",
      "medication_log_late_label": "Prise en retard",
      "medication_log_late_detail": "La dose a été prise en dehors de la fenêtre prévue.",
      "medication_log_missed_label": "Dose manquée",
      "medication_log_missed_detail": "La dose a été manquée. Ajoute une note en cas de problème d'injection, d'effet secondaire ou de souci d'approvisionnement.",
      "medication_log_skipped_label": "Dose passée",
      "medication_log_skipped_detail": "La dose n'a volontairement pas été prise. Ajoute une note si tu veux garder la raison en mémoire.",
      "medication_log_missing_medication_id": "Il manque l'identifiant enregistré de ce médicament, donc la dose n'a pas pu être notée.",
      "medication_log_save_failed": "Nous n'avons pas pu enregistrer cette dose. Tes sélections sont toujours là. Tu peux enregistrer à nouveau quand tu es prête.",
      "appointment_log_complete_label": "Terminé",
      "appointment_log_complete_detail": "La visite s'est déroulée comme prévu.",
      "appointment_log_rescheduled_label": "Replanifié",
      "appointment_log_rescheduled_detail": "Le rendez-vous a été déplacé.",
      "appointment_log_issue_label": "Besoin d'aide",
      "appointment_log_issue_detail": "Quelque chose manque ou demande un suivi.",
      "monitoring_log_attended_label": "J'ai assisté à cette visite",
      "monitoring_log_attended_detail": "La visite a bien eu lieu. Cela n'enregistre pas les mesures cliniques.",
      "task_log_complete_label": "Terminée",
      "task_log_complete_detail": "Cette action est terminée.",
      "action_log_save_failed": "Impossible d'enregistrer cette action. Réessaie.",
      "attach_document": "Joindre un document",
      "attach_document_detail": "Ajoute un compte rendu, une image ou un PDF à cette action.",
      "symptom_bloating": "Ballonnements",
      "symptom_cramping": "Crampes",
      "symptom_headache": "Maux de tête",
      "symptom_fatigue": "Fatigue",
      "symptom_nausea": "Nausées",
      "symptom_mood_changes": "Changements d'humeur",
      "severity_none": "Aucune",
      "severity_mild": "Légère",
      "severity_moderate": "Modérée",
      "severity_severe": "Sévère",
      "log_date_today": "Aujourd'hui",
      "log_date_yesterday": "Hier",
      "log_date_cycle_day": "Jour ${day}",
      "log_for_a11y": "Noter pour ${label}",
      "complete_for_a11y": "Marquer ${label} comme fait",
      "completed_a11y": "${label} terminé",
      "optimize_step_label": "Étape 3 : Améliorer les paramètres",
      "optimize_step_label_iui": "Étape 3 : Se préparer",
      "optimize_title_default": "Ce qu'on peut optimiser",
      "optimize_title_ivf": "Ce qu'on peut optimiser avant la FIV",
      "optimize_title_iui": "Ce qu'on peut ajuster avant l'IIU",
      "optimize_title_amab": "Ce qu'on peut optimiser ou coordonner",
      "optimize_subtitle_default": "Si le sperme fait partie du plan, commence là : la fenêtre de production de sperme (environ 72 jours) est souvent le levier le plus actionnable.",
      "optimize_subtitle_ivf": "Profite de la période pré-cycle pour aligner la source de sperme, les analyses côté ovarien, la préparation au transfert, les expositions et les choix de labo.",
      "optimize_subtitle_iui": "La préparation IIU repose surtout sur le timing, l'état des trompes, la logistique du sperme et les règles d'annulation de la clinique.",
      "optimize_subtitle_amab": "Commence par le sperme, puis garde la source d'ovocytes, les conditions don ou gestation pour autrui, la méthode de labo et le calendrier légal connectés.",
      "optimize_action_title_default": "Lancer un plan d'optimisation personnalisé",
      "optimize_action_title_ivf": "Lancer un plan de préparation FIV personnalisé",
      "optimize_action_title_iui": "Construire un plan de préparation IIU",
      "optimize_action_title_amab": "Lancer un plan de coordination de projet parental",
      "optimize_action_subtitle_default": "Passe en revue les analyses, les compléments, les expositions et le timing pour les deux côtés du plan.",
      "optimize_action_subtitle_ivf": "Passe en revue les analyses, les compléments, les expositions, la source de sperme, le parcours de transfert et le timing des deux côtés du plan FIV.",
      "optimize_action_subtitle_iui": "Passe en revue le monitoring, le timing du déclenchement, la source de sperme, les médicaments et le timing du beta avant le jour 1.",
      "optimize_action_subtitle_amab": "Passe en revue les analyses de sperme, la préparation donneuse ou gestation pour autrui, les étapes légales, la conservation et la séquence avec la clinique.",
      "optimize_action_cta": "Lancer le plan d'optimisation",
      "optimize_default_sperm_eyebrow": "Côté sperme",
      "optimize_default_sperm_title": "La fenêtre la plus actionnable : le sperme",
      "optimize_default_sperm_body": "Quand le sperme fait partie du plan, c'est souvent le levier le plus clair : le sperme se renouvelle sur environ 72 jours.",
      "optimize_default_sperm_bullet_1": "Commencer par un spermogramme pour ne pas avancer à l'aveugle",
      "optimize_default_sperm_bullet_2": "Passer en revue chaleur, fièvre, tabac, alcool, cannabis, médicaments, hormones anabolisantes et compléments",
      "optimize_default_sperm_bullet_3": "Décider si un test de contrôle, un suivi en urologie, une congélation de secours ou l'ICSI sont utiles",
      "optimize_default_sperm_cta": "Lancer le plan sperme",
      "optimize_default_egg_eyebrow": "Côté ovocytes",
      "optimize_default_egg_title": "Soutenir le côté ovarien",
      "optimize_default_egg_body": "L'âge des ovocytes ne se rattrape pas, mais on peut quand même planifier le cycle autour de la réserve, de la réponse, de la sécurité et des risques évitables avant la ponction.",
      "optimize_default_egg_bullet_1": "Utiliser AMH, CFA, antécédents et réponse précédente pour planifier le timing",
      "optimize_default_egg_bullet_2": "Passer en revue médicaments, compléments, tabac, alcool, cannabis et expositions",
      "optimize_default_egg_bullet_3": "Traiter sommeil, contexte métabolique, thyroïde, vitamine D ou carences claires si pertinent",
      "optimize_default_egg_cta": "Vérifier la réserve ovarienne",
      "optimize_iui_timing_eyebrow": "Timing",
      "optimize_iui_timing_title": "Préciser le timing de l'ovulation",
      "optimize_iui_timing_body": "Le succès de l'IIU dépend beaucoup du fait que le sperme soit présent près de l'ovulation, donc monitoring, test LH et timing du déclenchement doivent être clairs avant le démarrage.",
      "optimize_iui_timing_bullet_1": "Décider d'un protocole : naturel, médicament oral, injectable ou avec déclenchement",
      "optimize_iui_timing_bullet_2": "Confirmer comment la taille folliculaire, le pic LH et la prise de sang sont suivis",
      "optimize_iui_timing_bullet_3": "Savoir quand la clinique programme l'IIU après déclenchement ou pic",
      "optimize_iui_timing_cta": "Vérifier le plan de timing",
      "optimize_iui_sperm_eyebrow": "Côté sperme",
      "optimize_iui_sperm_title": "Confirmer la source de sperme et la viabilité post-lavage",
      "optimize_iui_sperm_body": "Pour l'IIU, le nombre de spermatozoïdes après lavage, le stock donneur, le timing du recueil et les plans de secours peuvent décider si le cycle est réaliste.",
      "optimize_iui_sperm_bullet_1": "Revoir le spermogramme et la mobilité post-lavage attendue",
      "optimize_iui_sperm_bullet_2": "Confirmer la logistique sperme frais, congelé partenaire ou donneur",
      "optimize_iui_sperm_bullet_3": "Décider si la FIV doit être discutée avant d'utiliser plus de paillettes ou de tentatives",
      "optimize_iui_sperm_cta": "Vérifier le plan sperme",
      "optimize_iui_tube_eyebrow": "Trompes + utérus",
      "optimize_iui_tube_title": "Éliminer les freins évitables",
      "optimize_iui_tube_body": "Comme la fécondation se passe à l'intérieur du corps, l'état des trompes et la préparation utérine comptent avant d'investir dans des tentatives d'IIU.",
      "optimize_iui_tube_bullet_1": "Vérifier si HSG, HyCoSy ou une imagerie antérieure est nécessaire",
      "optimize_iui_tube_bullet_2": "Revoir les résultats de la cavité utérine si la clinique le recommande",
      "optimize_iui_tube_bullet_3": "Clarifier les règles d'annulation pour trop de follicules ou un timing inadapté",
      "optimize_iui_tube_cta": "Trouver l'évaluation",
      "optimize_amab_sperm_eyebrow": "Côté sperme",
      "optimize_amab_sperm_title": "La fenêtre la plus actionnable : le sperme",
      "optimize_amab_sperm_body": "Quand le sperme est ta contribution, spermogramme, suivi en urologie, revue des expositions et congélation de secours peuvent être le travail pré-cycle le plus utile.",
      "optimize_amab_sperm_bullet_1": "Commencer par un spermogramme pour ne pas avancer à l'aveugle",
      "optimize_amab_sperm_bullet_2": "Passer en revue chaleur, fièvre, tabac, alcool, cannabis, médicaments, hormones anabolisantes et compléments",
      "optimize_amab_sperm_bullet_3": "Décider si un test de contrôle, urologie, congélation de secours, prélèvement chirurgical ou don de sperme sont utiles",
      "optimize_amab_sperm_cta": "Lancer le plan sperme",
      "optimize_amab_egg_eyebrow": "Source d'ovocytes",
      "optimize_amab_egg_title": "Coordonner la source côté ovarien",
      "optimize_amab_egg_body": "Une donneuse, une partenaire ou une source connue déterminent le calendrier de ponction, les besoins de screening, le travail légal et le transfert au labo.",
      "optimize_amab_egg_bullet_1": "Confirmer la voie : donneuse fraîche, donneuse congelée, partenaire ou source connue",
      "optimize_amab_egg_bullet_2": "Suivre screening, bilan infectieux, screening génétique et consentements",
      "optimize_amab_egg_bullet_3": "Savoir si le sperme doit être prêt avant que les ovocytes soient expédiés ou prélevés",
      "optimize_amab_egg_cta": "Comparer les sources",
      "optimize_amab_carrier_eyebrow": "Voie GPA",
      "optimize_amab_carrier_title": "Garder la logistique du transfert visible tôt",
      "optimize_amab_carrier_body": "Si une gestation pour autrui fait partie du plan, les étapes légales, agence, clinique et screening médical peuvent commencer avant que les embryons existent.",
      "optimize_amab_carrier_bullet_1": "Clarifier si les embryons sont créés en vue d'un transfert vers GPA",
      "optimize_amab_carrier_bullet_2": "Suivre la préparation légale, agence, clinique et screening médical",
      "optimize_amab_carrier_bullet_3": "Connecter PGT, conservation, expédition et préférences de transfert",
      "optimize_amab_carrier_cta": "Revoir la voie",
      "clinic_step_label_egg": "Étape 3 : Choisir ta clinique",
      "clinic_step_label_find_care": "Étape 4 : Trouver les soins",
      "clinic_search_subtitle_egg_freezing": "Cherche cliniques, labos et soignants pour la vitrification d'ovocytes.",
      "clinic_search_subtitle_embryo_freezing": "Cherche cliniques, labos d'embryologie et soignants pour la vitrification d'embryons.",
      "clinic_search_subtitle_sperm_freezing": "Cherche labos, cliniques et banques de sperme pour spermogramme, cryoconservation et conservation.",
      "clinic_search_subtitle_ivf": "Cherche cliniques de FIV, labos d'embryologie, options de monitoring et programmes de transfert.",
      "clinic_search_subtitle_iui": "Cherche des cliniques qui gèrent monitoring, timing du déclenchement, préparation du sperme, ouverture le week-end et IIU.",
      "clinic_search_subtitle_amab": "Cherche cliniques de FIV, labos d'embryologie, programmes don d'ovocytes, services sperme, accompagnement GPA et équipes formées au juridique.",
      "clinic_matches_title_clinics": "Cliniques sélectionnées pour toi",
      "clinic_matches_title_labs": "Labos sélectionnés pour toi",
      "clinic_matches_title_ivf": "Cliniques de FIV sélectionnées pour toi",
      "clinic_matches_title_iui": "Cliniques d'IIU sélectionnées pour toi",
      "clinic_matches_title_amab": "Soins de projet parental sélectionnés pour toi",
      "clinic_matches_subtitle_egg_freezing": "Une sélection basée sur ta localisation, ta couverture et ce qui compte pour ce cycle.",
      "clinic_matches_subtitle_embryo_freezing": "Une sélection basée sur ta localisation, ta couverture, les besoins du labo d'embryologie et ce qui compte pour ce cycle.",
      "clinic_matches_subtitle_sperm_freezing": "Une sélection basée sur ta localisation, ta couverture, tes besoins d'analyse, tes préférences de recueil et la conservation.",
      "clinic_matches_subtitle_ivf": "Une sélection basée sur ta localisation, ta couverture, les besoins du labo, le parcours de transfert et les exigences sperme ou don.",
      "clinic_matches_subtitle_iui": "Une sélection basée sur la localisation, la couverture, l'accès au monitoring, la source de sperme, l'évaluation des trompes et le timing des rendez-vous.",
      "clinic_matches_subtitle_amab": "Une sélection basée sur le plan sperme, la source d'ovocytes, la voie GPA, les besoins du labo, la localisation, la couverture et la complexité de coordination.",
      "clinic_locked_description_egg_freezing": "On utilise tes antécédents, ta localisation et ta couverture pour rendre les correspondances pertinentes. La couverture peut couvrir les frais ou correspondre à un autofinancement.",
      "clinic_locked_description_embryo_freezing": "On utilise tes antécédents, ta localisation, ta couverture et tes préférences pour la vitrification d'embryons. La couverture peut couvrir les frais ou correspondre à un autofinancement.",
      "clinic_locked_description_sperm_freezing": "On utilise tes antécédents, ta localisation, ta couverture et tes préférences de conservation. La couverture peut couvrir les frais ou correspondre à un autofinancement.",
      "clinic_locked_description_ivf": "On utilise tes antécédents, ta localisation, ta couverture, les analyses côté ovarien, la source de sperme et tes préférences de transfert pour les correspondances FIV.",
      "clinic_locked_description_iui": "On utilise tes antécédents, ta localisation, ta couverture, le plan d'ovulation, l'état des trompes et la source de sperme pour les correspondances IIU.",
      "clinic_locked_description_amab": "On utilise ta source de sperme, ta source d'ovocytes, la voie GPA, tes antécédents, ta localisation et ta couverture pour les correspondances projet parental.",
      "clinic_empty_description_default": "Tes critères sont prêts, mais les données de correspondance ne sont pas encore connectées ici. Tu peux quand même chercher dans le répertoire Trouver des soins.",
      "clinic_empty_description_labs": "Tes critères sont prêts, mais les données de correspondance labo ne sont pas encore connectées ici. Tu peux quand même chercher dans le répertoire Trouver des soins.",
      "clinic_empty_description_ivf": "Tes critères sont prêts, mais les données de correspondance FIV ne sont pas encore connectées ici. Tu peux quand même chercher dans le répertoire Trouver des soins.",
      "clinic_empty_description_iui": "Tes critères sont prêts, mais les données de correspondance IIU ne sont pas encore connectées ici. Tu peux quand même chercher dans le répertoire Trouver des soins.",
      "clinic_empty_description_amab": "Tes critères sont prêts, mais les données de correspondance projet parental ne sont pas encore connectées ici. Tu peux quand même chercher dans le répertoire Trouver des soins.",
      "clinic_action_find_care": "Trouver des soins",
      "clinic_action_see_matches": "Voir les cliniques correspondantes",
      "clinic_action_complete_history": "Compléter mes antécédents",
      "clinic_action_check_coverage": "Vérifier la couverture",
      "clinic_action_add_location": "Ajouter la localisation",
      "clinic_criteria_history_label": "Antécédents",
      "clinic_criteria_history_done": "Antécédents ajoutés",
      "clinic_criteria_history_missing": "Compléter les antécédents",
      "clinic_criteria_location_label": "Localisation",
      "clinic_criteria_location_done": "Localisation ajoutée",
      "clinic_criteria_location_missing": "Ajouter la localisation",
      "clinic_criteria_coverage_label": "Statut de couverture",
      "clinic_criteria_coverage_done": "Couverture vérifiée",
      "clinic_criteria_coverage_missing": "Vérifier la couverture",
      "concierge_title": "Programme d'accompagnement personnalisé",
      "concierge_body": "Obtiens de l'aide pour coordonner analyses, choix du médecin, accès en clinique et options d'économies avant de t'engager.",
      "concierge_tag_testing": "Analyses",
      "concierge_tag_doctors": "Médecins",
      "concierge_tag_savings": "Économies",
      "concierge_explore_label": "Explorer l'accompagnement personnalisé",
      "cycle_start_title": "Tu démarres bientôt ?",
      "cycle_start_body": "Dès que la clinique te donne une date, cet espace devient ton tableau de bord pour les jours à venir.",
      "cycle_start_cta": "Définir le début du cycle",
      "cycle_start_checklist_timing": "Calendrier du cycle",
      "cycle_start_checklist_medication": "Calendrier des médicaments",
      "cycle_start_checklist_monitoring": "Plan de monitoring",
      "cycle_start_checklist_daily_guidance": "Conseils quotidiens",
      "cycle_start_action_label": "Définir ta date de début",
      "understand_step_label": "Étape 1 : Comprendre",
      "understand_default_title": "Comment fonctionne la vitrification d'embryons",
      "understand_default_subtitle": "Commence par les trois éléments clés, puis fais défiler toute la biologie et la séquence du labo.",
      "understand_attrition_embryo_title": "Combien d'embryons ça peut donner ?",
      "understand_attrition_embryo_subtitle": "Estime le nombre d'ovocytes, l'attrition embryonnaire et le nombre de cycles potentiellement nécessaires.",
      "understand_attrition_ivf_title": "Combien d'embryons ce cycle de FIV peut-il donner ?",
      "understand_attrition_ivf_subtitle": "Estime le rendement d'ovocytes, la fécondation, le développement au stade blastocyste, le PGT-A éventuel, et les options de transfert ou de congélation.",
      "understand_attrition_amab_title": "Combien d'embryons le plan peut-il créer ?",
      "understand_attrition_amab_subtitle": "Estime le rendement de la source d'ovocytes, la fécondation, le développement blastocyste, le PGT-A éventuel et les options de transfert.",
      "understand_compare_embryo_title": "Vitrifier des ovocytes ou des embryons",
      "understand_compare_embryo_subtitle": "Compare la flexibilité, les informations obtenues, les implications partenaire/juridiques et l'usage futur.",
      "understand_compare_embryo_cta": "Vitrifier des ovocytes ou des embryons",
      "understand_compare_ivf_title": "FIV, ICSI, tests et choix de transfert",
      "understand_compare_ivf_subtitle": "Passe en revue les décisions de labo et de transfert à clarifier avant la ponction.",
      "understand_compare_ivf_cta": "Revoir les décisions de labo FIV",
      "understand_compare_amab_title": "Sperme, don d'ovocytes, GPA et embryons",
      "understand_compare_amab_subtitle": "Garde le plan sperme, la source d'ovocytes, les étapes légales, la méthode de labo et la voie de transfert connectés.",
      "understand_compare_amab_cta": "Comparer les voies de projet parental",
      "understand_compare_iui_title": "Quand l'IIU n'est plus la bonne prochaine étape",
      "understand_compare_iui_subtitle": "Passe en revue les signaux tubaires, sperme, âge, diagnostic et tentatives répétées qui peuvent orienter vers la FIV.",
      "understand_compare_iui_cta": "Revoir l'adéquation IIU",
      "process_embryo_ovarian_label": "Côté ovarien",
      "process_embryo_ovarian_timing": "10-14 jours",
      "process_embryo_ovarian_title": "Obtenir des ovocytes par stimulation ovarienne",
      "process_embryo_sperm_label": "Côté sperme",
      "process_embryo_sperm_timing": "1 jour",
      "process_embryo_sperm_title": "Recueillir ou décongeler un échantillon",
      "process_embryo_lab_label": "Côté labo",
      "process_embryo_lab_timing": "5-7 jours",
      "process_embryo_lab_title": "Féconder, cultiver, tester ou congeler les embryons",
      "process_ivf_ovarian_label": "Côté ovarien",
      "process_ivf_ovarian_timing": "10-14 jours",
      "process_ivf_ovarian_title": "Stimuler les follicules et ponctionner les ovocytes",
      "process_ivf_sperm_label": "Côté sperme",
      "process_ivf_sperm_timing": "Avant la ponction",
      "process_ivf_sperm_title": "Confirmer source, analyses et secours",
      "process_ivf_lab_label": "Labo + transfert",
      "process_ivf_lab_timing": "5-7 jours +",
      "process_ivf_lab_title": "Créer, congeler, tester ou transférer des embryons",
      "process_amab_sperm_label": "Plan sperme",
      "process_amab_sperm_timing": "2-12 semaines",
      "process_amab_sperm_title": "Tester, optimiser, congeler de secours ou recourir à un donneur",
      "process_amab_egg_label": "Source d'ovocytes",
      "process_amab_egg_timing": "Variable",
      "process_amab_egg_title": "Coordonner donneuse, partenaire ou source connue",
      "process_amab_lab_label": "Labo + GPA",
      "process_amab_lab_timing": "5-7 jours +",
      "process_amab_lab_title": "Créer les embryons et planifier le transfert",
      "process_iui_fit_label": "Adéquation",
      "process_iui_fit_timing": "Avant le cycle",
      "process_iui_fit_title": "Confirmer trompes, ovulation et plan sperme",
      "process_iui_timing_label": "Timing",
      "process_iui_timing_timing": "Jours du cycle",
      "process_iui_timing_title": "Suivre croissance folliculaire, LH ou déclenchement",
      "process_iui_procedure_label": "IIU + attente",
      "process_iui_procedure_timing": "1 jour + beta",
      "process_iui_procedure_title": "Préparer le sperme, inséminer, puis attendre",
      "bio_callout_why_matters": "Pourquoi c'est important",
      "bio_callout_why_stim": "Pourquoi la stimulation existe",
      "bio_callout_key_distinction": "Distinction clé",
      "bio_callout_reserve_note": "À propos de la réserve",
      "bio_callout_procedure_note": "À propos de la procédure",
      "bio_callout_what_to_know": "À savoir",
      "bio_callout_timing": "Timing",
      "bio_callout_optimization_window": "Fenêtre d'optimisation",
      "bio_callout_what_decides": "Ce qui décide",
      "bio_callout_why_updates_hard": "Pourquoi les mises à jour peuvent être dures",
      "bio_callout_after_blastocyst": "Après le blastocyste",
      "bio_callout_what_does": "Ce que ça fait",
      "bio_callout_important_limit": "Limite importante",
      "bio_callout_how_long": "Combien de temps",
      "bio_callout_why_matters_freeze": "Pourquoi c'est important",
      "bio_callout_before_starting": "Avant de commencer",
      "bio_callout_test_examples": "Exemples de tests",
      "bio_callout_safety": "Sécurité",
      "bio_callout_common_timing": "Timing habituel",
      "bio_callout_what_matters": "Ce qui compte",
      "bio_callout_afterward": "Après",
      "bio_callout_different_timeline": "Calendrier différent",
      "bio_callout_why_start_here": "Pourquoi commencer ici",
      "bio_cta_test_ovarian": "Tester la réserve ovarienne",
      "bio_cta_check_semen": "Vérifier le spermogramme",
      "bio_cta_find_tube": "Trouver un test des trompes",
      "bio_emb_supply_label": "Quantité d'ovocytes",
      "bio_emb_supply_title": "Le côté ovarien commence toujours par le stock d'ovocytes",
      "bio_emb_supply_body": "La vitrification d'embryons commence en général par stimulation et ponction, donc âge, AMH, CFA et réponse antérieure orientent le nombre probable d'ovocytes.",
      "bio_emb_supply_callout": "L'entonnoir embryonnaire commence avec les ovocytes. Moins d'ovocytes ponctionnés ou matures signifie souvent moins de chances d'embryons plus tard.",
      "bio_emb_supply_detail_title": "Stock d'ovocytes avant la vitrification d'embryons",
      "bio_emb_supply_d1_title": "Les embryons commencent par les ovocytes",
      "bio_emb_supply_d1_body": "Même quand l'objectif est l'embryon, la première contrainte biologique reste souvent le nombre de follicules qui répondent et le nombre d'ovocytes matures ponctionnés.",
      "bio_emb_supply_d2_title": "Ce que les analyses peuvent ajouter",
      "bio_emb_supply_d2_body": "AMH, CFA, hormones J2-J3, âge, diagnostic et réponse au cycle précédent aident à estimer le rendement probable et l'approche de stimulation.",
      "bio_emb_normal_label": "Cycle normal",
      "bio_emb_normal_title": "En général, un ovocyte ovule par mois",
      "bio_emb_normal_body": "Chaque cycle, un petit groupe de follicules commence à grandir. En général un follicule devient dominant et les autres s'arrêtent.",
      "bio_emb_normal_callout": "La vitrification d'embryons cherche à faire mûrir plus de follicules du même cycle, pour que plus d'ovocytes arrivent au labo.",
      "bio_emb_normal_detail_title": "Cycle normal versus cycle stimulé",
      "bio_emb_normal_d1_title": "Un petit groupe démarre ensemble",
      "bio_emb_normal_d1_body": "Une cohorte de follicules répond pendant un cycle. Dans un cycle menstruel typique, un devient dominant et ovule.",
      "bio_emb_normal_d2_title": "La stimulation change le résultat",
      "bio_emb_normal_d2_body": "La stimulation ne crée pas de nouveaux ovocytes. Elle essaie de garder plus de follicules recrutés en croissance assez longtemps pour pouvoir en prélever des ovocytes.",
      "bio_emb_follicles_label": "Ovaires & follicules",
      "bio_emb_follicles_title": "Les ovocytes sont dans les follicules, et les follicules dans les ovaires",
      "bio_emb_follicles_body": "Ta clinique peut mesurer les follicules à l'échographie, mais l'ovocyte à l'intérieur est microscopique et vérifié seulement après la ponction.",
      "bio_emb_follicles_callout": "Un nombre de follicules n'est pas la même chose que les ovocytes ponctionnés, matures ou les embryons.",
      "bio_emb_follicles_detail_title": "Follicules, ovocytes et ovaires",
      "bio_emb_follicles_d1_title": "Ce que la clinique voit",
      "bio_emb_follicles_d1_body": "L'échographie montre les follicules et leur taille. L'ovocyte est trop petit pour être vu directement, donc le décompte final vient du labo d'embryologie.",
      "bio_emb_follicles_d2_title": "Pourquoi les nombres changent",
      "bio_emb_follicles_d2_body": "Tu entendras parler de nombre de follicules, d'ovocytes ponctionnés, d'ovocytes matures, d'ovocytes fécondés et d'embryons. Chaque chiffre est un point de contrôle différent.",
      "bio_emb_stim_label": "Stimulation",
      "bio_emb_stim_title": "Les médicaments cherchent à faire mûrir plus de follicules en même temps",
      "bio_emb_stim_body": "Les injections de stimulation durent environ 10-14 jours et visent à garder plusieurs follicules en croissance au lieu d'un seul.",
      "bio_emb_stim_callout": "Cela utilise des follicules déjà recrutés dans ce cycle ; ce ne sont pas des ovocytes que ton corps mettait de côté pour les mois suivants.",
      "bio_emb_stim_detail_title": "Pourquoi la stimulation est utilisée",
      "bio_emb_stim_d1_title": "La cohorte du cycle",
      "bio_emb_stim_d1_body": "Chaque mois, un groupe de follicules répond. La stimulation tente d'en garder plus en croissance assez longtemps pour ponctionner des ovocytes.",
      "bio_emb_stim_d2_title": "La dose est personnalisée",
      "bio_emb_stim_d2_body": "Âge, AMH, CFA, poids, diagnostic et réponse antérieure peuvent changer la dose de départ et le plan de monitoring.",
      "bio_emb_monitor_label": "Suivi",
      "bio_emb_monitor_title": "Le monitoring décide quand le déclenchement et la ponction ont lieu",
      "bio_emb_monitor_body": "Les visites ont souvent lieu tous les 2-3 jours. L'échographie suit la taille des follicules et la prise de sang aide à timer le déclenchement.",
      "bio_emb_monitor_callout": "La ponction est en général une courte procédure transvaginale sous sédation, le jour même, pas une chirurgie abdominale.",
      "bio_emb_monitor_detail_title": "Monitoring, déclenchement et ponction",
      "bio_emb_monitor_d1_title": "Le monitoring change le plan",
      "bio_emb_monitor_d1_body": "Changements de dose, visites supplémentaires et ponction décalée sont normaux car la clinique réagit à la croissance folliculaire et aux hormones.",
      "bio_emb_monitor_d2_title": "Le timing du déclenchement compte",
      "bio_emb_monitor_d2_body": "La ponction est en général programmée environ 34-36 heures après le déclenchement, avant que l'ovulation ne se produise.",
      "bio_emb_monitor_d3_title": "Ce que la ponction collecte",
      "bio_emb_monitor_d3_body": "Le clinicien collecte le liquide folliculaire ; le labo d'embryologie cherche les ovocytes dans ce liquide sous microscope.",
      "bio_emb_sperm_label": "Côté sperme",
      "bio_emb_sperm_title": "La source de sperme fait partie du plan embryon",
      "bio_emb_sperm_body": "Le sperme peut venir d'un partenaire, d'un donneur, d'un échantillon frais ou congelé. Ce choix influence le consentement, le timing, le transport et la méthode de labo.",
      "bio_emb_sperm_callout": "Un plan sperme n'est pas que de la logistique. Il peut décider si le labo utilise la FIV classique ou l'ICSI.",
      "bio_emb_sperm_detail_title": "Source de sperme et vitrification d'embryons",
      "bio_emb_sperm_d1_title": "Frais, congelé, partenaire ou donneur",
      "bio_emb_sperm_d1_body": "La source de sperme influence la logistique et le consentement. Le labo a besoin d'un plan clair avant le jour de la ponction.",
      "bio_emb_sperm_d2_title": "Pourquoi le spermogramme compte",
      "bio_emb_sperm_d2_body": "Concentration, mobilité, morphologie et volume peuvent décider si la fécondation classique ou l'ICSI est recommandée.",
      "bio_emb_sample_label": "Échantillon de sperme",
      "bio_emb_sample_title": "Un échantillon de sperme est recueilli ou décongelé",
      "bio_emb_sample_body": "Cela se passe souvent le jour de la ponction, mais certains congèlent un échantillon de secours ou utilisent du sperme de donneur déjà congelé.",
      "bio_emb_sample_callout": "Le côté ovarien prend des jours. Le passage du sperme peut prendre un seul jour, mais la préparation peut commencer des mois plus tôt.",
      "bio_emb_sample_detail_title": "Comment le sperme arrive au labo",
      "bio_emb_sample_d1_title": "Échantillon frais",
      "bio_emb_sample_d1_body": "Un échantillon frais peut être recueilli le jour de la ponction, puis traité par le labo pour préparer le sperme à la fécondation.",
      "bio_emb_sample_d2_title": "Échantillon congelé ou de donneur",
      "bio_emb_sample_d2_body": "Le sperme partenaire congelé ou le sperme de donneur peut être décongelé par le labo. La clinique doit confirmer le timing, les vérifications d'identité, le consentement et les plans de secours avant le jour de la ponction.",
      "bio_emb_sample_d3_title": "Pourquoi les plans de secours comptent",
      "bio_emb_sample_d3_body": "Si le recueil peut être difficile ou que les paramètres sont bas, la clinique peut discuter de congeler du sperme de secours avant le cycle.",
      "bio_emb_quality_label": "Qualité du sperme",
      "bio_emb_quality_title": "Le spermogramme aide à choisir la méthode de labo",
      "bio_emb_quality_body": "Concentration, mobilité, morphologie, volume, antécédents de fécondation et statut donneur/partenaire peuvent tous influencer le plan de fécondation.",
      "bio_emb_quality_callout": "Le sperme est produit en continu et se renouvelle sur environ 2-3 mois, donc les expositions peuvent compter avant la création des embryons.",
      "bio_emb_quality_detail_title": "Ce que le spermogramme peut changer",
      "bio_emb_quality_d1_title": "Les paramètres habituels",
      "bio_emb_quality_d1_body": "Le spermogramme regarde en général concentration, mobilité, morphologie, volume et parfois d'autres mesures selon la clinique.",
      "bio_emb_quality_d2_title": "Pourquoi ça compte pour les embryons",
      "bio_emb_quality_d2_body": "Le résultat peut influencer si la clinique recommande la fécondation classique, l'ICSI, une congélation de secours, un avis urologique ou du sperme de donneur.",
      "bio_emb_ivficsi_label": "FIV vs ICSI",
      "bio_emb_ivficsi_title": "FIV et ICSI sont deux méthodes de fécondation",
      "bio_emb_ivficsi_body": "En FIV classique, ovocytes et sperme préparé sont mis ensemble. En ICSI, l'embryologue injecte un spermatozoïde dans un ovocyte mature.",
      "bio_emb_ivficsi_callout": "Les résultats du spermogramme, la fécondation antérieure, les plans PGT, la politique de la clinique et le nombre d'ovocytes peuvent tous influencer la recommandation.",
      "bio_emb_ivficsi_detail_title": "FIV classique versus ICSI",
      "bio_emb_ivficsi_d1_title": "FIV classique",
      "bio_emb_ivficsi_d1_body": "Le labo place les ovocytes matures avec le sperme préparé et laisse la fécondation se faire sans injecter chaque ovocyte.",
      "bio_emb_ivficsi_d2_title": "ICSI",
      "bio_emb_ivficsi_d2_body": "ICSI signifie injection intracytoplasmique de spermatozoïde. Un embryologue choisit un spermatozoïde et l'injecte directement dans un ovocyte mature.",
      "bio_emb_ivficsi_d3_title": "Pourquoi le choix est personnel",
      "bio_emb_ivficsi_d3_body": "L'ICSI peut être importante pour les cas de facteur sperme et est souvent utilisée avec les protocoles PGT, mais elle n'est pas automatiquement meilleure pour toutes les situations.",
      "bio_emb_fertcheck_label": "Contrôle J+1",
      "bio_emb_fertcheck_title": "Le labo vérifie quels ovocytes ont fécondé normalement",
      "bio_emb_fertcheck_body": "Le lendemain, le labo vérifie en général la fécondation normale. C'est là que le nombre peut à nouveau se réduire.",
      "bio_emb_fertcheck_callout": "Ovocytes ponctionnés, ovocytes matures, ovocytes normalement fécondés et embryons sont des chiffres distincts.",
      "bio_emb_fertcheck_detail_title": "Ce que le contrôle de fécondation veut dire",
      "bio_emb_fertcheck_d1_title": "La maturité passe en premier",
      "bio_emb_fertcheck_d1_body": "Après la ponction, le labo vérifie quels ovocytes sont matures. Les ovocytes immatures sont moins susceptibles de féconder normalement.",
      "bio_emb_fertcheck_d2_title": "Fécondation normale",
      "bio_emb_fertcheck_d2_body": "Un ovocyte fécondé à ce stade est souvent appelé zygote. Certains ovocytes peuvent ne pas féconder, et d'autres féconder anormalement.",
      "bio_emb_culture_label": "Culture embryonnaire",
      "bio_emb_culture_title": "Les embryons sont suivis sur plusieurs jours",
      "bio_emb_culture_body": "Les ovocytes fécondés se divisent au fil du temps. Le labo peut donner des nouvelles des embryons au stade clivage vers J3 et au stade blastocyste vers J5-J7.",
      "bio_emb_culture_callout": "Le nombre baisse souvent à chaque point de contrôle du labo ; ça ne veut pas forcément dire que quelque chose s'est mal passé.",
      "bio_emb_culture_detail_title": "Culture embryonnaire et attrition",
      "bio_emb_culture_d1_title": "Développement précoce",
      "bio_emb_culture_d1_body": "Le labo suit les ovocytes fécondés en division. Certains s'arrêtent tôt, d'autres continuent vers le blastocyste J5, J6 ou J7.",
      "bio_emb_culture_d2_title": "Pourquoi l'entonnoir se rétrécit",
      "bio_emb_culture_d2_body": "Maturité de l'ovocyte, facteurs sperme, erreurs chromosomiques, conditions de labo et biologie influencent tous le développement embryonnaire.",
      "bio_emb_blast_label": "Blastocystes",
      "bio_emb_blast_title": "Les blastocystes sont les embryons en général congelés ou testés",
      "bio_emb_blast_body": "Vers J5-J7, certains embryons atteignent le stade blastocyste. Les labos décident quels blastocystes répondent aux critères de congélation, biopsie ou transfert.",
      "bio_emb_blast_callout": "Un blastocyste peut être noté, congelé, biopsié pour PGT ou parfois écarté s'il ne répond pas aux critères du labo.",
      "bio_emb_blast_detail_title": "Ce qui se passe au stade blastocyste",
      "bio_emb_blast_d1_title": "Le jour peut varier",
      "bio_emb_blast_d1_body": "Certains embryons atteignent le blastocyste à J5, d'autres à J6 ou J7, et certains s'arrêtent avant.",
      "bio_emb_blast_d2_title": "La notation n'est pas un test génétique",
      "bio_emb_blast_d2_body": "La notation des embryons regarde l'apparence et l'expansion. C'est utile, mais ça ne dit pas si l'embryon a le bon nombre de chromosomes.",
      "bio_emb_pgt_label": "PGT / DPI",
      "bio_emb_pgt_title": "Le test génétique est optionnel et a plusieurs types",
      "bio_emb_pgt_body": "DPI est l'ancien terme. Aujourd'hui tu entendras plutôt PGT-A pour le nombre de chromosomes, PGT-M pour une affection génétique précise, ou PGT-SR pour des réarrangements chromosomiques.",
      "bio_emb_pgt_callout": "Le PGT teste quelques cellules d'une biopsie de blastocyste. Il donne des informations ; il ne change pas l'embryon.",
      "bio_emb_pgt_detail_title": "PGT, DPI et ce qui est testé",
      "bio_emb_pgt_d1_title": "PGT-A",
      "bio_emb_pgt_d1_body": "Le PGT-A vérifie si la biopsie de l'embryon a le bon nombre de chromosomes. Les résultats sont en général euploïde, aneuploïde, mosaïque ou sans résultat selon le labo.",
      "bio_emb_pgt_d2_title": "PGT-M et PGT-SR",
      "bio_emb_pgt_d2_body": "Le PGT-M cherche une maladie héréditaire d'un seul gène quand un risque est connu. Le PGT-SR cherche les embryons affectés par un réarrangement chromosomique connu.",
      "bio_emb_pgt_d3_title": "Pourquoi le conseil génétique compte",
      "bio_emb_pgt_d3_body": "Les décisions de test génétique peuvent influencer le coût, le timing, l'usage des embryons et des choix émotionnels. Beaucoup de cliniques font intervenir un conseiller génétique pour les PGT-M ou les résultats complexes.",
      "bio_emb_euploidy_label": "Euploïdie",
      "bio_emb_euploidy_title": "Euploïde signifie le bon nombre de chromosomes",
      "bio_emb_euploidy_body": "Un résultat PGT-A euploïde signifie que la biopsie testée avait le bon nombre de chromosomes. Aneuploïde signifie que des chromosomes en plus ou en moins ont été détectés.",
      "bio_emb_euploidy_callout": "Euploïde ne garantit pas une grossesse ou une naissance vivante, et le PGT-A n'est pas un test pour tous les enjeux génétiques possibles.",
      "bio_emb_euploidy_detail_title": "Comment lire le langage PGT-A",
      "bio_emb_euploidy_d1_title": "Euploïde",
      "bio_emb_euploidy_d1_body": "Un résultat euploïde signifie que la biopsie embryonnaire avait le bon nombre de chromosomes. Les embryons euploïdes ont en général un meilleur potentiel d'implantation, mais les résultats ne sont pas garantis.",
      "bio_emb_euploidy_d2_title": "Aneuploïde, mosaïque, sans résultat",
      "bio_emb_euploidy_d2_body": "Aneuploïde signifie des chromosomes en plus ou en moins détectés. Mosaïque signifie des signaux cellulaires mélangés. Sans résultat signifie que le labo n'a pas pu obtenir de résultat exploitable.",
      "bio_emb_freeze_label": "Congélation",
      "bio_emb_freeze_title": "Les embryons sont vitrifiés et conservés",
      "bio_emb_freeze_body": "Les embryons qui répondent aux critères de congélation sont en général vitrifiés, conservés dans des cuves d'azote liquide, jusqu'à une future décongélation ou transfert.",
      "bio_emb_freeze_callout": "Tant que la conservation est maintenue, les embryons peuvent rester congelés pendant des années. Les limites pratiques sont en général le consentement, la politique de la clinique, les frais et la loi.",
      "bio_emb_freeze_detail_title": "Vitrification et conservation des embryons",
      "bio_emb_freeze_d1_title": "Vitrification",
      "bio_emb_freeze_d1_body": "La vitrification est une congélation ultra-rapide conçue pour réduire la formation de cristaux de glace. Les embryons sont ensuite conservés dans des cuves d'azote liquide.",
      "bio_emb_freeze_d2_title": "La conservation est une décision continue",
      "bio_emb_freeze_d2_body": "Les embryons congelés peuvent impliquer des frais annuels, des renouvellements de consentement, des décisions de disposition, des considérations juridiques et la planification d'un transfert futur.",
      "bio_emb_freeze_d3_title": "Usage futur",
      "bio_emb_freeze_d3_body": "Quand quelqu'un veut utiliser un embryon plus tard, l'embryon est décongelé et un plan de transfert d'embryon congelé est mis en place. Tous les embryons ne survivent pas à la décongélation, mais la survie en vitrification moderne est en général élevée.",
      "bio_emb_future_label": "Usage futur",
      "bio_emb_future_title": "Utiliser un embryon plus tard est une étape de transfert distincte",
      "bio_emb_future_body": "La vitrification d'embryons crée des embryons conservés. Une grossesse plus tard nécessite de décongeler un embryon, préparer l'utérus ou la personne porteuse, et faire un transfert.",
      "bio_emb_future_callout": "Congeler des embryons donne plus d'informations que congeler des ovocytes, mais ça crée aussi des décisions sur la propriété, le consentement, le transfert, la conservation et la disposition.",
      "bio_emb_future_detail_title": "Après la congélation des embryons",
      "bio_emb_future_d1_title": "Transfert d'embryon congelé",
      "bio_emb_future_d1_body": "Un transfert futur implique en général un cycle distinct avec préparation utérine, décongélation, transfert et test de grossesse après.",
      "bio_emb_future_d2_title": "Consentement et propriété",
      "bio_emb_future_d2_body": "Comme les embryons peuvent impliquer plus d'un contributeur génétique, les cliniques exigent en général un consentement clair sur la conservation, le transfert, les tests, la destruction, le don et ce qui se passe si la situation change.",
      "bio_ivf_supply_title": "La FIV commence aussi par le stock d'ovocytes et la réponse",
      "bio_ivf_supply_body": "La FIV commence en général par stimulation et ponction, donc âge, AMH, CFA, diagnostic et réponse antérieure orientent le nombre probable d'ovocytes.",
      "bio_ivf_supply_callout": "L'entonnoir de FIV commence avec les ovocytes. Moins d'ovocytes ponctionnés ou matures signifie souvent moins de chances de fécondation, d'embryons et de transfert.",
      "bio_ivf_supply_detail_title": "Stock d'ovocytes avant la FIV",
      "bio_ivf_supply_d1_title": "La FIV commence par les ovocytes",
      "bio_ivf_supply_d1_body": "La première contrainte biologique est souvent le nombre de follicules qui répondent et le nombre d'ovocytes matures ponctionnés.",
      "bio_ivf_supply_d2_title": "Ce que les analyses peuvent ajouter",
      "bio_ivf_supply_d2_body": "AMH, CFA, hormones J2-J3, âge, diagnostic et réponse antérieure aident à estimer le rendement probable et l'approche de stimulation.",
      "bio_ivf_sperm_title": "La source de sperme change le plan de labo FIV",
      "bio_ivf_sperm_body": "Sperme du partenaire, sperme de donneur, recueil frais, secours congelé ou prélèvement chirurgical peuvent changer consentement, timing, transport et méthode de fécondation.",
      "bio_ivf_sperm_detail_title": "Source de sperme et FIV",
      "bio_ivf_sperm_d1_title": "Frais, congelé, partenaire, donneur ou chirurgical",
      "bio_ivf_sperm_d1_body": "La source de sperme influence la logistique et le consentement. Le labo a besoin d'un plan clair avant le jour de la ponction.",
      "bio_ivf_sperm_d2_title": "Pourquoi le spermogramme compte",
      "bio_ivf_sperm_d2_body": "Concentration, mobilité, morphologie et volume peuvent décider si la FIV classique, l'ICSI, la congélation de secours, un avis urologique ou le sperme de donneur sont recommandés.",
      "bio_ivf_freeze_title": "Les embryons peuvent être congelés, transférés ou testés",
      "bio_ivf_freeze_body": "Certains plans de FIV congèlent les embryons, d'autres transfèrent un embryon frais, et d'autres biopsient les embryons pour le PGT avant la congélation.",
      "bio_ivf_freeze_callout": "Congélation, tests, timing du transfert, frais de conservation et consentement sont des décisions propres à la clinique à clarifier avant la ponction.",
      "bio_ivf_freeze_detail_title": "Après la formation des blastocystes",
      "bio_ivf_freeze_d1_title": "Transférer ou congeler",
      "bio_ivf_freeze_d1_body": "Un blastocyste peut être transféré, congelé, biopsié pour le PGT ou écarté s'il ne répond pas aux critères du labo.",
      "bio_ivf_freeze_d2_title": "La conservation est une décision continue",
      "bio_ivf_freeze_d2_body": "Les embryons congelés peuvent impliquer des frais annuels, des renouvellements de consentement, des décisions de disposition, des considérations juridiques et la planification d'un transfert futur.",
      "bio_ivf_transfer_title": "Le transfert d'embryon est sa propre étape",
      "bio_ivf_transfer_body": "Une grossesse par FIV nécessite de préparer l'utérus ou la personne porteuse, choisir un embryon, le décongeler s'il est congelé, et faire un transfert.",
      "bio_ivf_transfer_callout": "Ponction, création d'embryons et transfert peuvent faire partie du même plan global, mais ce sont des étapes cliniques distinctes.",
      "bio_amab_agency_label": "Côté sperme",
      "bio_amab_agency_title": "Le point de départ le plus actionnable est souvent le sperme",
      "bio_amab_agency_body": "Quand le sperme est ta contribution au plan, spermogramme, test de contrôle, questions urologiques, congélation de secours et expositions peuvent changer les prochaines étapes.",
      "bio_amab_agency_callout": "Le sperme se renouvelle sur environ 2-3 mois, donc ce côté a une vraie fenêtre d'optimisation avant la création des embryons.",
      "bio_amab_agency_detail_title": "Paramètres sperme avant la création des embryons",
      "bio_amab_agency_d1_title": "Ce que le spermogramme apporte",
      "bio_amab_agency_d1_body": "Concentration, mobilité, morphologie et volume aident à décider si la FIV classique, l'ICSI, la congélation de secours, un avis urologique ou le sperme de donneur sont pertinents.",
      "bio_amab_agency_d2_title": "Ce que le timing peut changer",
      "bio_amab_agency_d2_body": "Chaleur, fièvre, tabac, cannabis, alcool, médicaments, hormones anabolisantes, compléments et antécédents de maladie peuvent compter car le sperme est produit en continu.",
      "bio_amab_source_label": "Source de sperme",
      "bio_amab_source_title": "Le labo a besoin d'un plan clair sur la source de sperme",
      "bio_amab_source_body": "Le plan peut utiliser un échantillon frais, une congélation de secours, un prélèvement chirurgical, du sperme de donneur ou une combinaison selon les tests et la fiabilité du recueil.",
      "bio_amab_source_callout": "Le recueil peut ressembler à une journée, mais tests, congélation de secours, matching donneur ou urologie peuvent prendre des semaines ou des mois.",
      "bio_amab_source_detail_title": "Faire arriver le sperme au labo",
      "bio_amab_source_d1_title": "Frais ou congelé",
      "bio_amab_source_d1_body": "Un échantillon frais peut être recueilli le jour de la ponction, tandis qu'une congélation de secours ou du sperme de donneur doivent être expédiés, décongelés, identifiés et consentis correctement.",
      "bio_amab_source_d2_title": "Quand le secours compte",
      "bio_amab_source_d2_body": "Si le recueil peut être difficile ou que les paramètres sont bas, les cliniques discutent souvent de congeler du sperme de secours avant le cycle.",
      "bio_amab_eggsource_label": "Source d'ovocytes",
      "bio_amab_eggsource_title": "La source d'ovocytes détermine le calendrier côté ovarien",
      "bio_amab_eggsource_body": "La création d'embryons a besoin d'ovocytes d'une partenaire, d'une donneuse ou d'une source connue. Ce choix change screening, consentement, timing de stimulation, logistique de ponction et coût.",
      "bio_amab_eggsource_callout": "Ton plan sperme peut être prêt avant la source d'ovocytes, donc la page d'accueil doit suivre les deux côtés séparément.",
      "bio_amab_eggsource_detail_title": "Source d'ovocytes et planification ovarienne",
      "bio_amab_eggsource_d1_title": "Partenaire ou source connue",
      "bio_amab_eggsource_d1_body": "Une partenaire ou une source connue a en général besoin d'antécédents médicaux, de tests de réserve ovarienne, de planification du cycle, de bilan infectieux et de consentement.",
      "bio_amab_eggsource_d2_title": "Don d'ovocytes",
      "bio_amab_eggsource_d2_body": "Les ovocytes de donneuse peuvent être frais ou congelés. Matching, travail légal, screening de la donneuse, expédition et taille de la cohorte affectent tous le plan.",
      "bio_iui_fit_label": "Adéquation IIU",
      "bio_iui_fit_title": "L'IIU dépend de l'ovulation, des trompes et de l'accès du sperme",
      "bio_iui_fit_body": "L'IIU place du sperme préparé dans l'utérus près de l'ovulation. Ça dépend encore d'au moins une trompe ouverte, du timing de l'ovulation, de la qualité du sperme et de la raison clinique du traitement.",
      "bio_iui_fit_callout": "La question pré-cycle clé est si l'IIU est adaptée ou si la FIV devrait être discutée plus tôt.",
      "bio_iui_fit_detail_title": "Ce qui rend l'IIU adaptée",
      "bio_iui_fit_d1_title": "La biologie sur laquelle elle repose",
      "bio_iui_fit_d1_body": "L'ovocyte et le sperme doivent toujours se rencontrer dans la trompe, y féconder, puis l'embryon doit voyager jusqu'à l'utérus.",
      "bio_iui_fit_d2_title": "Quand les cliniques font une pause",
      "bio_iui_fit_d2_body": "Trompes bloquées, mobilité du sperme très basse, résultats sévères de facteur sperme, certains objectifs liés à l'âge ou des IIU répétées sans succès peuvent orienter la discussion vers la FIV.",
      "bio_iui_tubes_label": "Trompes",
      "bio_iui_tubes_title": "L'état des trompes compte avant l'IIU",
      "bio_iui_tubes_body": "Comme la fécondation se passe à l'intérieur du corps, les cliniques confirment souvent qu'au moins une trompe semble ouverte avant d'investir dans des tentatives d'IIU.",
      "bio_iui_tubes_callout": "HSG, HyCoSy, échographie saline, antécédents de cœlioscopie ou imagerie antérieure peuvent être utilisés selon la clinique.",
      "bio_iui_tubes_detail_title": "Pourquoi les trompes comptent pour l'IIU",
      "bio_iui_tubes_d1_title": "L'IIU n'est pas une étape de fécondation au labo",
      "bio_iui_tubes_d1_body": "Le sperme préparé est placé dans l'utérus, mais la captation de l'ovocyte et la fécondation se font toujours via la trompe de Fallope.",
      "bio_iui_tubes_d2_title": "Un côté peut suffire",
      "bio_iui_tubes_d2_body": "Certaines personnes peuvent quand même faire une IIU avec une seule trompe ouverte, mais le timing et l'ovaire qui répond peuvent compter.",
      "bio_iui_med_label": "Médicaments",
      "bio_iui_med_title": "Le choix de médicament change le nombre de follicules",
      "bio_iui_med_body": "Certaines IIU sont en cycle naturel. D'autres utilisent du létrozole, du clomifène ou des injectables pour soutenir l'ovulation ou recruter plus d'un follicule.",
      "bio_iui_med_callout": "Plus de follicules peuvent augmenter la chance de grossesse, mais aussi celle de grossesse multiple ou d'annulation.",
      "bio_iui_med_detail_title": "IIU naturelle versus médicamenteuse",
      "bio_iui_med_d1_title": "Cycle naturel",
      "bio_iui_med_d1_body": "La clinique suit le follicule que ton corps développe déjà et programme l'insémination autour de l'ovulation.",
      "bio_iui_med_d2_title": "Cycle médicamenteux",
      "bio_iui_med_d2_body": "Les médicaments peuvent aider l'ovulation ou recruter plus de follicules. Le monitoring aide à décider s'il est sûr de continuer.",
      "bio_iui_trigger_label": "Déclenchement",
      "bio_iui_trigger_title": "Monitoring et déclenchement contrôlent le timing",
      "bio_iui_trigger_body": "Échographie, test LH, prise de sang ou injection de déclenchement peuvent être utilisés pour timer l'insémination près de l'ovulation.",
      "bio_iui_trigger_callout": "Beaucoup de cliniques programment l'IIU environ 24-36 heures après le déclenchement, mais les protocoles varient.",
      "bio_iui_trigger_detail_title": "Comment le timing est choisi",
      "bio_iui_trigger_d1_title": "Taille du follicule",
      "bio_iui_trigger_d1_body": "L'échographie aide à estimer si un follicule est assez mature pour ovuler.",
      "bio_iui_trigger_d2_title": "Signaux hormonaux",
      "bio_iui_trigger_d2_body": "Pic LH, estradiol, progestérone et timing du déclenchement peuvent tous influencer quand l'IIU est programmée.",
      "bio_iui_prep_label": "Préparation sperme",
      "bio_iui_prep_title": "L'échantillon de sperme est lavé avant l'IIU",
      "bio_iui_prep_body": "Un échantillon frais, congelé partenaire ou donneur est traité par le labo pour concentrer les spermatozoïdes mobiles et retirer le liquide séminal avant l'insémination.",
      "bio_iui_prep_callout": "Le nombre de spermatozoïdes mobiles post-lavage est souvent plus utile pour planifier l'IIU que le spermogramme brut seul.",
      "bio_iui_prep_detail_title": "Préparation du sperme pour l'IIU",
      "bio_iui_prep_d1_title": "Pourquoi le lavage",
      "bio_iui_prep_d1_body": "Le sperme est traité avant son placement dans l'utérus. Les cliniques regardent combien de spermatozoïdes mobiles restent après préparation.",
      "bio_iui_prep_d2_title": "Frais, congelé ou donneur",
      "bio_iui_prep_d2_body": "Sperme frais partenaire, congelé partenaire et sperme de donneur ont des besoins différents en timing, transport, consentement et inventaire.",
      "bio_iui_proc_label": "Jour de l'IIU",
      "bio_iui_proc_title": "L'IIU est une courte procédure en cabinet",
      "bio_iui_proc_body": "Un fin cathéter place le sperme préparé dans l'utérus. La plupart des gens repartent peu après et continuent le plan donné par la clinique.",
      "bio_iui_proc_callout": "La clinique peut prescrire de la progestérone, des consignes d'activité et une date de beta après la procédure.",
      "bio_iui_proc_detail_title": "Ce qui se passe le jour de l'IIU",
      "bio_iui_proc_d1_title": "Timing de l'échantillon",
      "bio_iui_proc_d1_body": "Le recueil frais se fait en général peu avant la procédure. Le sperme congelé ou de donneur est décongelé et préparé par le labo.",
      "bio_iui_proc_d2_title": "Timing de la procédure",
      "bio_iui_proc_d2_body": "L'IIU est programmée autour de l'ovulation ou du déclenchement pour que le sperme soit présent quand l'ovocyte peut être libéré.",
      "bio_iui_wait_label": "Attente de deux semaines",
      "bio_iui_wait_title": "La date du beta fait partie du plan",
      "bio_iui_wait_body": "Après l'IIU, l'écran devrait basculer vers un soutien d'attente avec rappels de médicaments, contexte des symptômes et timing du test de grossesse de la clinique.",
      "bio_iui_wait_callout": "Un beta sanguin est en général programmé environ deux semaines après l'IIU, mais la date exacte dépend du protocole.",
      "bio_iui_wait_detail_title": "Après l'IIU",
      "bio_iui_wait_d1_title": "Tâches de soutien",
      "bio_iui_wait_d1_body": "Consignes de médicaments, contexte des effets secondaires et rappels de rendez-vous sont plus utiles que les prédictions de grossesse au jour le jour.",
      "bio_iui_wait_d2_title": "Suite possible",
      "bio_iui_wait_d2_body": "L'écran suivant doit savoir si ça devient une nouvelle tentative d'IIU, une discussion FIV, un soutien de début de grossesse ou un plan de récupération.",
      "stepper_done": "Fait",
      "stepper_mark_done": "Marquer comme fait",
      "stepper_mark_done_a11y": "Marquer ${stepLabel} comme fait",
      "stepper_mark_incomplete_a11y": "Marquer ${stepLabel} comme non fait",
      "stepper_expand_a11y": "Développer ${stepLabel}",
      "stepper_collapse_a11y": "Réduire ${stepLabel}",
      "start_embryo_cycle_title": "Tu démarres un cycle de vitrification d'embryons ?",
      "start_embryo_cycle_body": "Dès que la clinique te donne une date, cet espace devient ton tableau de bord pour la stimulation, la ponction, le recueil de sperme, la fécondation, le développement embryonnaire et les mises à jour de congélation.",
      "start_embryo_cycle_cta": "Définir le début du cycle",
      "start_embryo_cycle_checklist_timing": "Calendrier du cycle",
      "start_embryo_cycle_checklist_sperm": "Plan de recueil de sperme",
      "start_embryo_cycle_checklist_fertilization": "Méthode de fécondation",
      "start_embryo_cycle_checklist_lab_updates": "Calendrier des nouvelles du labo",
      "numbers_step_label": "Étape 2 : Connaître tes chiffres",
      "numbers_step_label_explorer": "Étape 2 : connais tes chiffres clés",
      "numbers_what_to_test": "Ce que tu peux tester",
      "numbers_subtitle_egg_freezing": "Quelques options peuvent rendre ton estimation plus utile. Tu peux commencer simple ou aller plus loin.",
      "numbers_subtitle_embryo_freezing": "Commence par le côté ovarien, ajoute le côté sperme, puis décide si la génétique ou des panels plus larges sont utiles.",
      "numbers_subtitle_ivf_ovarian": "Commence par la réserve ovarienne, ajoute le côté sperme, puis tiens compte de la préparation au transfert et des analyses exigées par la clinique.",
      "numbers_subtitle_ivf_sperm": "Commence par le spermogramme et la source de sperme, tout en gardant AMH, CFA, analyses côté ovarien et préparation au transfert dans le même plan FIV.",
      "numbers_subtitle_iui": "Confirme les paramètres qui rendent l'IIU possible : timing d'ovulation, état des trompes, source de sperme et analyses exigées par la clinique.",
      "numbers_subtitle_amab": "Commence par le spermogramme, puis connecte source d'ovocytes, exigences donneuse ou GPA, génétique et analyses exigées par la clinique.",
      "numbers_subtitle_explorer": "Ajoute seulement les chiffres qui t’aident à comparer les parcours. Les bons examens dépendent de la suite que tu choisiras.",
      "numbers_step_label_iui": "Étape 2 : Confirmer l'adéquation IIU",
      "numbers_step_label_amab": "Étape 2 : Confirmer les paramètres",
      "guided_ivf_cycle_title": "Tu démarres un cycle de FIV ?",
      "guided_ivf_cycle_body": "Dès que la clinique te donne une date, cet espace devient ton tableau de bord pour la stimulation, le monitoring, la ponction, la fécondation, le transfert et le timing du beta.",
      "guided_iui_cycle_title": "Tu démarres un cycle d'IIU ?",
      "guided_iui_cycle_body": "Dès que la clinique te donne une date, cet espace devient ton tableau de bord pour le monitoring, le timing du déclenchement, la procédure d'IIU et l'attente de deux semaines.",
      "guided_iui_checklist_timing": "Calendrier du cycle",
      "guided_iui_checklist_monitoring": "Suivi",
      "guided_iui_checklist_sperm": "Préparation du sperme",
      "guided_iui_checklist_beta": "Timing du beta",
      "guided_ivf_checklist_timing": "Calendrier du cycle",
      "guided_ivf_checklist_meds": "Calendrier des médicaments",
      "guided_ivf_checklist_monitoring": "Plan de monitoring",
      "guided_ivf_checklist_lab": "Nouvelles du labo et transfert",
      "guided_iui_cycle_body_full": "Dès que la clinique te donne un jour 1 ou une date de monitoring, cet espace devient ton tableau de bord IIU pour les médicaments, le monitoring, le timing du déclenchement, la préparation du sperme, l'insémination et le beta.",
      "guided_ivf_cycle_body_full": "Dès que la clinique te donne une date, cet espace devient ton tableau de bord pour la stimulation, la ponction, le recueil de sperme, la fécondation, le développement embryonnaire, la planification du transfert et les nouvelles du labo.",
      "guided_iui_cycle_cta": "Définir le début du cycle IIU",
      "guided_ivf_cycle_cta": "Définir le début du cycle",
      "guided_iui_checklist_day1": "Jour 1 du cycle ou date de référence",
      "guided_iui_checklist_meds_mon": "Plan de médicaments et de monitoring",
      "guided_iui_checklist_sperm_wash": "Source de sperme et timing du lavage",
      "guided_iui_checklist_trigger_beta": "Déclenchement, IIU et dates du beta",
      "guided_ivf_checklist_timing_v2": "Calendrier du cycle",
      "guided_ivf_checklist_sperm": "Source de sperme ou plan de recueil",
      "guided_ivf_checklist_fertilization": "Méthode de fécondation",
      "guided_ivf_checklist_transfer": "Plan de transfert ou de congélation",
      "guided_amab_cycle_title": "Tu démarres la création d'embryons ?",
      "guided_amab_cycle_body": "Dès que donneuse, GPA, sperme et plan clinique sont prêts, cet espace devient ton tableau de bord pour la ponction, le recueil, la fécondation, le développement embryonnaire, la planification du transfert et les nouvelles du labo.",
      "guided_amab_checklist_sperm": "Source de sperme et plan de secours",
      "guided_amab_checklist_egg": "Don d'ovocytes ou timing côté ovarien",
      "guided_amab_checklist_carrier": "Plan GPA ou de transfert",
      "guided_amab_checklist_lab": "Fécondation et nouvelles du labo",
      "past_cycle_coming_soon": "Bientôt disponible",
      "past_cycle_unlock_export": "Débloquer l'export du cycle",
      "past_cycle_continue": "Continuer",
      "embryo_clinic_compare_title": "Savoir quoi comparer",
      "embryo_clinic_compare_subtitle": "Qualité du labo, ICSI, PGT-A, fréquence des mises à jour, congélation, conservation et coût total.",
      "ivf_clinic_compare_title": "Comparer la clinique et le labo de FIV",
      "ivf_clinic_compare_subtitle": "Regarde le style de stimulation, le labo d'embryologie, la politique ICSI, les protocoles PGT, le transfert frais/congelé, la communication et le coût total.",
      "ivf_clinic_compare_cta": "Comparer les cliniques de FIV",
      "iui_clinic_compare_title": "Comparer la logistique IIU avant de choisir",
      "iui_clinic_compare_subtitle": "Disponibilité le week-end, accès au monitoring, timing du déclenchement, labo de préparation du sperme, gestion du sperme donneur et plan beta comptent autant que la localisation.",
      "iui_clinic_compare_cta": "Comparer les soins IIU",
      "amab_clinic_compare_title": "Comparer toute l'équipe soignante",
      "amab_clinic_compare_subtitle": "Labo de FIV, services sperme, parcours don d'ovocytes, accompagnement GPA, coordination légale, conservation et fréquence des mises à jour doivent fonctionner ensemble.",
      "amab_clinic_compare_cta": "Comparer les soins de projet parental",
      "test_eyebrow_ovarian_reserve": "Réserve ovarienne",
      "test_eyebrow_ultrasound": "Échographie",
      "test_eyebrow_sperm_side": "Côté sperme",
      "test_eyebrow_cycle_timing": "Timing du cycle",
      "test_eyebrow_tube_status": "État des trompes",
      "test_eyebrow_transfer_readiness": "Préparation au transfert",
      "test_eyebrow_egg_source": "Source d'ovocytes",
      "test_eyebrow_carrier_route": "Voie GPA",
      "test_eyebrow_clinic_labs": "Analyses cliniques",
      "test_eyebrow_hormones": "Hormones",
      "test_eyebrow_baseline": "Base",
      "test_eyebrow_optional": "Optionnel",
      "test_history_title": "Compléter les antécédents médicaux",
      "test_history_body": "C'est la base de ton estimation : diagnostics, médicaments, chirurgies, allergies, cycles, cycles précédents et facteurs de risque.",
      "test_history_timing": "Requis pour la personnalisation",
      "test_history_cta": "Continuer les antécédents",
      "test_history_action_label": "Continuer les antécédents médicaux",
      "test_amh_title": "Prise de sang AMH",
      "test_amh_body": "L'AMH aide à estimer la réserve ovarienne et la réponse attendue. Elle peut en général se faire n'importe quel jour du cycle.",
      "test_amh_timing": "Prise de sang · n'importe quel jour",
      "test_amh_cta": "Commander AMH",
      "test_amh_action_label": "Commander un test AMH à domicile",
      "test_find_lab_cta": "Trouver un labo",
      "test_find_lab_action_label": "Trouver un labo",
      "test_afc_title": "Échographie CFA",
      "test_afc_body": "Le compte folliculaire antral (CFA) est une échographie transvaginale qui compte les petits follicules au repos. AMH + CFA donne en général l'estimation la plus claire.",
      "test_afc_timing": "Échographie · souvent J2-J5 du cycle",
      "test_afc_cta": "Trouver une clinique",
      "test_afc_action_label": "Trouver une clinique ou une échographie mobile",
      "test_upload_result_cta": "Téléverser le résultat",
      "test_afc_upload_action_label": "Téléverser le résultat CFA",
      "test_hormones_title": "Hormones J2-J3",
      "test_hormones_body": "FSH et estradiol aident à interpréter la réserve ovarienne. Les cliniques peuvent ajouter LH, progestérone, TSH, prolactine, vitamine D ou bilan infectieux.",
      "test_hormones_timing": "Certaines analyses doivent être chronométrées",
      "test_add_results_cta": "Ajouter les résultats",
      "test_add_results_action_label": "Ajouter les résultats d'analyses",
      "test_semen_title": "Spermogramme",
      "test_semen_body": "Concentration, mobilité, morphologie et volume aident le labo à décider si la fécondation classique ou l'ICSI est recommandée.",
      "test_semen_timing": "Partenaire, donneur, labo ou recueil à domicile",
      "test_check_options_cta": "Voir les options",
      "test_semen_check_action_label": "Voir les options de spermogramme",
      "test_semen_upload_action_label": "Téléverser le spermogramme",
      "test_ovulation_title": "Ovulation et timing du cycle",
      "test_ovulation_body": "Courbes LH, antécédents de cycle, échographie ou prise de sang aident à décider si l'IIU doit être naturelle, médicamenteuse, monitorée ou déclenchée.",
      "test_ovulation_timing": "Propre au cycle",
      "test_check_timing_cta": "Vérifier le timing",
      "test_check_timing_action_label": "Vérifier le timing de l'ovulation",
      "test_find_iui_monitoring_cta": "Trouver une clinique",
      "test_find_iui_monitoring_action_label": "Trouver un monitoring IIU",
      "test_tube_title": "Évaluation des trompes et de l'utérus",
      "test_tube_body": "L'IIU a besoin que sperme et ovocyte se rencontrent à l'intérieur du corps, donc les cliniques confirment souvent qu'au moins une trompe est ouverte et que l'utérus est prêt.",
      "test_tube_timing": "Souvent avant la première IIU",
      "test_find_testing_cta": "Trouver le test",
      "test_find_tube_action_label": "Trouver un test des trompes",
      "test_upload_tube_action_label": "Téléverser le résultat du test des trompes",
      "test_semen_iui_title": "Spermogramme et source de sperme",
      "test_semen_iui_body": "Concentration, mobilité, morphologie, stock donneur et mobilité post-lavage attendue aident à décider si l'IIU est une option raisonnable.",
      "test_semen_iui_timing": "Partenaire, donneur, frais ou congelé",
      "test_clinic_labs_title": "Analyses exigées par la clinique",
      "test_clinic_labs_body": "Beaucoup de cliniques exigent un bilan infectieux, le timing du test de grossesse, le groupe sanguin, le statut rubéole ou varicelle, un screening génétique ou un bilan thyroïdien avant l'IIU.",
      "test_clinic_labs_timing": "Propre à la clinique",
      "test_uterine_title": "Préparation utérine et au transfert",
      "test_uterine_body": "Si un transfert peut faire partie du plan FIV, les cliniques peuvent ajouter une échographie saline, un transfert d'essai, la thyroïde, un bilan infectieux ou des tests propres au protocole.",
      "test_uterine_timing": "Avant la planification du transfert",
      "test_find_evaluation_cta": "Trouver l'évaluation",
      "test_find_uterine_action_label": "Trouver une évaluation utérine",
      "test_upload_uterine_action_label": "Téléverser l'évaluation utérine",
      "test_level_core_title": "Estimation de base",
      "test_level_core_body": "Antécédents médicaux, AMH et CFA répondent à la question clé : comment tes ovaires peuvent répondre à un cycle de vitrification d'ovocytes.",
      "test_level_core_cta": "Commencer AMH",
      "test_level_panel_title": "Bilan de santé complet",
      "test_level_panel_body": "Un panel de plus de 150 biomarqueurs peut vérifier vitamines, thyroïde, santé métabolique, inflammation, hormones et d'autres contextes pour l'optimisation.",
      "test_level_panel_cta": "Voir les panels",
      "test_level_panel_action_label": "Voir les panels d'analyses",
      "test_level_genetics_title": "Génétique",
      "test_level_genetics_body": "Le screening porteur vérifie le risque d'affections héréditaires pour les futurs enfants. Le séquençage complet du génome est un test ADN à domicile plus large avec plus de contexte santé et plus d'incertitude.",
      "test_level_genetics_cta": "Comparer les options",
      "test_level_genetics_action_label": "Comparer les options de tests génétiques",
      "numbers_partner_action_iui_title": "Ajouter un partenaire ou une source de sperme",
      "numbers_partner_action_iui_subtitle": "Le plan IIU a besoin de savoir si le sperme vient d'un partenaire, donneur, frais, congelé ou encore indéterminé.",
      "numbers_partner_action_ivf_sperm_title": "Ajouter partenaire, donneuse ou plan clinique côté ovarien",
      "numbers_partner_action_ivf_sperm_subtitle": "Le plan FIV a quand même besoin d'AMH, CFA, analyses côté ovarien, timing de la ponction et parcours de transfert en parallèle du plan sperme.",
      "numbers_partner_action_ivf_title": "Ajouter partenaire, donneur ou source de sperme",
      "numbers_partner_action_ivf_subtitle": "Le plan FIV a besoin du côté ovarien, de la source de sperme et du parcours de transfert possible dans un seul plan.",
      "numbers_partner_action_amab_title": "Ajouter détails sperme, source d'ovocytes et GPA",
      "numbers_partner_action_amab_subtitle": "Ce plan doit savoir si sperme, source d'ovocytes et voie GPA sont confirmés, encore en cours de screening ou indéterminés.",
      "numbers_partner_action_default_title": "Ajouter un partenaire ou une source de sperme",
      "numbers_partner_action_default_subtitle": "Invite un partenaire ou note la source de sperme à inclure dans le plan.",
      "numbers_add_source_label": "Ajouter un partenaire ou une source de sperme",
      "test_amab_egg_title": "Screening source d'ovocytes",
      "test_amab_egg_body": "Donneuse, partenaire ou source connue d'ovocytes change le screening médical, la génétique, le timing de la ponction, le consentement et l'expédition.",
      "test_amab_egg_timing": "Partenaire, source connue ou donneuse",
      "test_compare_sources_cta": "Comparer les sources",
      "test_amab_egg_compare_action_label": "Comparer les options de source d'ovocytes",
      "test_find_care_cta": "Trouver les soins",
      "test_amab_egg_find_action_label": "Trouver des soins donneuse ou FIV",
      "test_amab_carrier_title": "Voie GPA ou transfert",
      "test_amab_carrier_body": "Si une GPA est impliquée, les étapes légales, agence, clinique et préparation utérine doivent être suivies avant l'usage des embryons.",
      "test_amab_carrier_timing": "Peut se faire avant ou après la création des embryons",
      "test_amab_carrier_review_cta": "Revoir le parcours",
      "test_amab_carrier_review_action_label": "Revoir le parcours GPA",
      "past_cycle_record_completion_title": "Compléter le dossier du cycle",
      "past_cycle_record_completion_body": "${completed} sur ${total} détails complétés. Finis le dossier pour débloquer un export partageable qui raconte l'histoire de ce cycle.",
      "past_cycle_continue_a11y": "Continuer à compléter le dossier du cycle",
      "past_cycle_upload_title": "Téléverser ou déposer les documents du cycle",
      "past_cycle_upload_body": "On peut analyser comptes rendus, détails embryonnaires, médicaments, visites et coûts pour les intégrer à ce cycle.",
      "today_label": "aujourd'hui",
      "yesterday_label": "hier",
      "last_monitoring": "Dernier monitoring",
      "last_monitoring_when": "Dernier monitoring ${when}",
      "on_date": "le ${date}",
      "follicles_count": "${count} follicules",
      "lead_mm": "principal ${value} mm",
      "e2_value": "E2 ${value}",
      "projected_e2": "~E2 ${value}",
      "next_label": "Suivant",
      "not_yet_label": "Pas encore",
      "pending_label": "en attente",
      "lab_status_next": "Suivant",
      "calendar_label": "Calendrier",
      "outlook_label": "Perspective",
      "journey_map_label": "Carte du parcours",
      "open_care_label": "Ouvrir le suivi",
      "expand_a11y": "Développer ${title}",
      "collapse_a11y": "Réduire ${title}",
      "hero_setup_title": "Mettons en place le bon parcours",
      "hero_setup_summary": "Choisis ton objectif et les personnes impliquées pour que Louise oriente correctement les prochaines étapes.",
      "hero_learn_explorer_title": "Compare les voies avant de décider",
      "hero_learn_explorer_summary": "Enregistre tes questions, compare les options, et ajoute des données de référence seulement si tu le souhaites.",
      "hero_egg_freezing_active_title": "Tout est sur les rails pour le monitoring de demain",
      "hero_egg_freezing_active_summary": "Tu as deux médicaments aujourd'hui. La visite de demain confirmera le timing du déclencheur et l'estimation de la ponction.",
      "hero_egg_freezing_postcycle_title": "Ton cycle de vitrification d’ovocytes est terminé",
      "hero_egg_freezing_postcycle_summary": "Consulte ce qui a été enregistré, ajoute les détails de conservation et décide de la suite.",
      "hero_egg_freezing_postcycle_stored_title": "${count} ovocytes sont stockés",
      "hero_egg_freezing_postcycle_stored_summary": "Ton dossier de conservation est disponible. Consulte ce qui est enregistré et décide de la suite.",
      "hero_embryo_freezing_active_title": "La stimulation suit son cours, le monitoring est demain",
      "hero_embryo_freezing_active_summary": "Attends-toi à des ballonnements ou à une pression ovarienne aujourd'hui. La ponction est actuellement estimée au 24 mai, et l'échographie de demain mettra ça à jour.",
      "hero_embryo_freezing_postcycle_title": "Ton cycle de vitrification d’embryons est terminé",
      "hero_embryo_freezing_postcycle_summary": "Consulte les résultats enregistrés, ajoute les rapports en attente et décide de la suite.",
      "hero_embryo_freezing_postcycle_stored_title": "${count} embryons sont stockés",
      "hero_embryo_freezing_postcycle_stored_summary": "Ton dossier de conservation est disponible. Ajoute tout rapport de laboratoire en attente et consulte la suite.",
      "hero_sperm_freezing_active_title": "Tu es prêt·e pour la collecte de demain",
      "hero_sperm_freezing_active_summary": "Ta fenêtre d'abstinence est bonne. Apporte une pièce d'identité et complète le consentement de stockage.",
      "hero_sperm_freezing_wait_title": "Ton échantillon est au laboratoire",
      "hero_sperm_freezing_wait_summary": "L'analyse de sperme et la confirmation de stockage arrivent généralement dans les 2 à 5 jours.",
      "hero_sperm_freezing_postcycle_title": "Ton cycle de vitrification de sperme est terminé",
      "hero_sperm_freezing_postcycle_summary": "Consulte ce qui a été enregistré, ajoute tout rapport de laboratoire en attente et décide de la suite.",
      "hero_sperm_freezing_postcycle_stored_title": "${count} échantillons de sperme sont stockés",
      "hero_sperm_freezing_postcycle_stored_summary": "Ton dossier de conservation est disponible. Consulte les résultats de laboratoire et décide de la suite.",
      "hero_ivf_precycle_title": "Bilan de base et plan sperme sont les prochaines étapes à débloquer",
      "hero_ivf_precycle_summary": "Termine l'historique, AMH/CFA, analyse de sperme et couverture avant de commencer le protocole.",
      "hero_ivf_active_title": "Tout est sur les rails, le monitoring est demain",
      "hero_ivf_active_summary": "Tu as des médicaments aujourd'hui. Les résultats de demain confirmeront le timing du déclencheur et le plan de ponction.",
      "hero_post_retrieval_title": "Ponction terminée",
      "hero_post_retrieval_ivf_eyebrow": "FIV / ICSI",
      "hero_post_retrieval_ivf_summary": "Ta clinique enregistre les mises à jour de fécondation et de développement embryonnaire. Ton programme réel du jour reste visible pendant l’attente.",
      "hero_post_retrieval_egg_freezing_eyebrow": "Vitrification d’ovocytes",
      "hero_post_retrieval_egg_freezing_summary": "Ta clinique enregistre les mises à jour du laboratoire et de la conservation. Ton programme réel du jour reste visible pendant l’attente.",
      "hero_post_retrieval_embryo_freezing_eyebrow": "Vitrification d’embryons",
      "hero_post_retrieval_embryo_freezing_summary": "Ta clinique enregistre les mises à jour de fécondation, de développement embryonnaire et de conservation. Ton programme réel du jour reste visible pendant l’attente.",
      "hero_beta_wait_title_with_date": "La béta est le ${date}, garde les médicaments stables",
      "hero_beta_wait_title_no_date": "Béta à venir, garde les médicaments stables",
      "hero_beta_wait_summary": "Les symptômes ne sont pas prédictifs pour le moment. Appelle pour une douleur sévère, des saignements importants, de la fièvre ou un essoufflement.",
      "hero_ivf_positive_title": "Béta positive, à répéter dans 48 heures",
      "hero_ivf_positive_summary": "Continue les médicaments jusqu'à ce que la clinique change le plan. Le timing de l'échographie vient après la tendance des bétas.",
      "hero_ivf_negative_title": "Résultat examiné, consultation le 23 mai",
      "hero_ivf_negative_summary": "Le plan d'arrêt des médicaments est défini pour aujourd'hui. Le récap de ton cycle et les embryons restants sont prêts à être consultés.",
      "hero_iui_precycle_title": "Appelle au jour 1 du cycle pour démarrer le timing",
      "hero_iui_precycle_summary": "La couverture du déclencheur, le plan sperme et le planning de référence doivent être prêts avant le monitoring.",
      "hero_iui_active_title": "Déclencheur ce soir à 21 h",
      "hero_iui_active_summary": "L'IIU est prévue 36 heures plus tard ; l'échantillon du partenaire est le 20 mai à 8 h.",
      "fet_active_plan_eyebrow": "TEC",
      "fet_active_plan_heading": "Votre plan de transfert d’embryon congelé",
      "fet_active_plan_summary": "Consultez les étapes de préparation, de transfert et de dépistage enregistrées par la clinique. Louise n’invente ni dose, ni date, ni résultat.",
      "hero_iui_wait_title": "La béta de la clinique est le 31 mai",
      "hero_iui_wait_summary": "Le déclencheur peut perturber les tests à la maison. Garde les médicaments et attends le plan de résultats de la clinique.",
      "hero_oi_wait_title": "L’attente après l’ovulation",
      "hero_oi_wait_summary": "Garde le plan de ta clinique et la date prévue du test visibles en attendant une réponse plus claire.",
      "hero_oi_active_title": "Ta stimulation est en cours",
      "hero_oi_active_summary": "Les médicaments du jour et ta prochaine échographie de suivi, avec la réponse enregistrée jusqu’ici.",
      "hero_amab_family_building_precycle_title": "L'analyse de sperme du partenaire B est la prochaine étape",
      "hero_amab_family_building_precycle_summary": "Compare les deux apports de sperme avant les décisions sur le don d'ovocytes, le portage, l'embryon, le légal et les coûts.",
      "hero_partner_precycle_title": "Ta prochaine tâche est l'analyse de sperme",
      "hero_partner_precycle_summary": "Ajoute aussi les détails de couverture ; les deux peuvent affecter le plan FIV/IIU partagé.",
      "hero_partner_active_title": "Confirme le plan d'échantillon aujourd'hui",
      "hero_partner_active_summary": "Le monitoring est demain. Le planning de récupération et le soutien aux injections peuvent être bientôt nécessaires.",
      "hero_egg_donor_title": "Bilans de dépistage et appel coordinateur aujourd'hui",
      "hero_egg_donor_summary": "Ton profil de donneuse est en ligne. Consultation psy et dossier légal viennent ensuite.",
      "hero_sperm_donor_title": "Visite de don vendredi à 9 h",
      "hero_sperm_donor_summary": "Garde la fenêtre d'abstinence dans la cible ; le statut de l'échantillon et du paiement se mettent à jour après la revue du laboratoire.",
      "hero_carrier_title": "Téléverse les dossiers OB pour faire avancer le dépistage",
      "hero_carrier_summary": "La revue d'assurance est en cours. La consultation psy se débloque après le pré-feu vert médical.",
      "hero_intended_parent_title": "Choisis la présélection de donneuse cette semaine",
      "hero_intended_parent_summary": "Les appels d'agence de portage, l'intake légal et l'escrow dépendent tous de la décision de matching.",
      "hero_dynamic": {
        "eyebrow_with_day": "${type} · jour ${day}",
        "eyebrow_no_day": "${type}",
        "eyebrow_type": {
          "pre_treatment": "Préparation",
          "stimulation": "Stimulation",
          "retrieval": "Ponction",
          "fertilization": "Fécondation",
          "embryo_development": "Développement embryonnaire",
          "transfer": "Transfert"
        },
        "metric": {
          "stim_day": "Stim · jour",
          "next_monitoring": "Prochain monitoring",
          "lead_follicle": "Follicule lead",
          "estradiol": "Estradiol",
          "next_injection": "Prochaine injection",
          "trigger": "Déclencheur",
          "retrieval_estimate": "Ponction estimée",
          "retrieval_date": "Ponction",
          "retrieved_on": "Ponction faite",
          "embryo_dev_day": "Développement · jour",
          "endometrium": "Endomètre",
          "transfer_date": "Transfert",
          "beta_date": "Béta",
          "days_post_transfer": "Jours post-transfert",
          "meds_today": "Médicaments aujourd'hui"
        },
        "cta": {
          "open_cycle": "Ouvrir mon cycle",
          "add_medications": "Ajouter mes médicaments",
          "schedule_retrieval": "Planifier ma ponction",
          "log_monitoring": "Saisir mes résultats de monitoring",
          "view_meds_plan": "Voir mon plan de médicaments",
          "prepare_retrieval": "Préparer ma ponction",
          "log_retrieval_results": "Saisir les résultats de la ponction",
          "view_embryo_updates": "Voir les mises à jour embryon",
          "prepare_transfer": "Préparer mon transfert",
          "view_beta_plan": "Voir mon plan de béta",
          "record_my_beta": "Enregistrer ma béta"
        },
        "pre_treatment_title": "Prépare ton corps avant la stimulation",
        "pre_treatment_summary": "Suppléments, pilule, monitoring de base — on installe le terrain pour la stimulation ovarienne.",
        "result_recorded_title": "Votre résultat est enregistré",
        "result_recorded_summary": "Il est enregistré sur ce cycle. Quand vous serez prêt·e, clôturez le cycle depuis l'étape Résultat.",
        "unknown_active_title": "Cycle en cours",
        "unknown_active_summary": "Garde tes médicaments à jour et note chaque étape pour que ton équipe puisse suivre.",
        "stim_trigger_logged_title": "Trigger fait",
        "stim_trigger_logged_summary": "Ton corps fait la maturation finale. La ponction tombe ~36 h après le trigger — la clinique te confirme l'horaire.",
        "stim_monitoring_title": "Suivi ${when}",
        "stim_monitoring_summary": "Garde les médicaments stables. Le prochain rendez-vous confirme le timing du trigger.",
        "stim_med_title": "Prochaine injection ${when} à ${time}",
        "stim_med_summary": "Continue jusqu'au monitoring — ne décale pas l'horaire de plus d'une heure.",
        "stim_generic_title": "Tes follicules grandissent",
        "stim_generic_summary": "Continue les injections au même horaire. Ballonnements et tension dans les ovaires sont normaux à ce stade.",
        "retrieval_scheduled_title": "Ponction ${when}",
        "retrieval_scheduled_summary": "Pas de nourriture solide les 8 h précédentes. Arrive 30 min avant pour l'admission.",
        "retrieval_done_pending_title": "Ponction faite",
        "retrieval_done_pending_summary": "Le labo confirme la fécondation sous 24 h. Repos doux aujourd'hui, hydrate-toi bien.",
        "fertilization_title": "Tes ovocytes sont au labo",
        "fertilization_summary": "L'équipe d'embryologie surveille la fécondation. Premiers résultats demain.",
        "embryo_dev_title": "Tes embryons se développent · jour ${day}",
        "embryo_dev_summary": "Suivi quotidien jusqu'au stade blastocyste (J5-J7). Décision de transfert ou vitrification après.",
        "transfer_scheduled_title": "Transfert ${when}",
        "transfer_scheduled_summary": "Vessie pleine au moment du transfert. Pas besoin de repos strict après — reprends doucement.",
        "beta_scheduled_title": "Béta ${when}",
        "beta_scheduled_summary": "Les symptômes ne sont pas prédictifs pour le moment. Continue les médicaments jusqu'à la prise de sang.",
        "beta_pending_title": "Période d'attente",
        "beta_pending_summary": "Continue les médicaments. Planifie ta prise de sang quand la clinique te confirme la date.",
        "wait_eyebrow": "Période d'attente",
        "wait_day_title": "Jour ${day} de ton attente",
        "wait_day_title_no_total": "Jour ${day} depuis le transfert",
        "wait_reassure_early": "Les premiers jours. Il n'y a encore rien à détecter, alors essaie de ne pas interpréter les symptômes. Continue tes médicaments et sois douce avec toi-même.",
        "wait_reassure_mid": "Ces jours-ci peuvent sembler longs. La progestérone peut imiter les signes de début de grossesse, donc les symptômes ne t'indiquent pas le résultat. C'est la prise de sang qui compte.",
        "wait_reassure_late": "Presque au test. Quoi que tu ressentes, le béta est la réponse honnête. Continue les médicaments jusqu'à ce que la clinique en décide autrement.",
        "wait_progress_start": "Transfert",
        "wait_progress_start_fet": "Transfert TEC",
        "wait_progress_start_iui": "Insémination",
        "wait_progress_start_oi": "Ovulation",
        "wait_progress_end": "Prise de sang",
        "wait_eyebrow_fet": "Attente après TEC",
        "wait_eyebrow_iui": "Attente après insémination",
        "wait_day_title_no_total_fet": "Jour ${day} depuis le transfert congelé",
        "wait_day_title_no_total_iui": "Jour ${day} depuis l'insémination",
        "wait_day_title_no_total_oi": "Jour ${day} depuis l'ovulation",
        "wait_reassure_early_fet": "Ton transfert congelé est terminé. Garde l'œstrogène et la progestérone exactement comme prescrits ; les symptômes ne permettent pas de connaître le résultat.",
        "wait_reassure_mid_fet": "Le timing de la progestérone soutient l'endomètre après un TEC. Les symptômes peuvent venir des médicaments ; c'est la prise de sang qui compte.",
        "wait_reassure_late_fet": "Le test sanguin après TEC approche. Continue les médicaments du transfert jusqu'aux nouvelles consignes de ta clinique.",
        "wait_reassure_early_iui": "C'est encore tôt après l'insémination. L'injection de déclenchement et les médicaments peuvent imiter des symptômes ; garde ton plan stable.",
        "wait_reassure_mid_iui": "L'injection de déclenchement peut persister et la progestérone peut ressembler à un début de grossesse. Les symptômes et les tests maison ne donnent pas le résultat.",
        "wait_reassure_late_iui": "Le test sanguin IIU approche. Le bêta de la clinique est la réponse fiable ; continue les médicaments jusqu'aux nouvelles consignes.",
        "wait_eyebrow_oi": "Attente après l’ovulation",
        "wait_reassure_early_oi": "C’est encore tôt après l’ovulation. Les symptômes ne donnent pas le résultat ; garde le plan de ta clinique.",
        "wait_reassure_mid_oi": "Ces jours-ci peuvent sembler longs. Si on t’a prescrit de la progestérone, elle peut provoquer des symptômes qui ressemblent au début d’une grossesse.",
        "wait_reassure_late_oi": "La date du test approche. Continue les médicaments jusqu’à ce que la clinique te dise quoi faire."
      },
      "wait_extras": {
        "chat_title": "Comment te sens-tu ?",
        "chat_subtitle": "Parle à Louise de tes symptômes ou de tes inquiétudes. On garde une trace pour toi.",
        "chat_empty_prompt": "Dis-moi comment tu te sens aujourd'hui, les symptômes que tu as remarqués ou ce qui te préoccupe. Je suis là pour t'aider, et je garde une trace de ce que tu me dis.",
        "chat_input_placeholder": "Comment te sens-tu ?",
        "readings_label": "À lire pour cette étape",
        "tag_wait": "L'attente",
        "tag_science": "La science",
        "tag_transfer": "Ton transfert",
        "tag_fet": "Ton TEC",
        "tag_insemination": "Ton insémination"
      },
      "outcome_extras": {
        "readings_label": "À lire pour ce moment",
        "tag_next_chapter": "La suite",
        "tag_coping": "Traverser ce moment",
        "tag_emotional": "Ce que tu ressens"
      },
      "stim_extras": {
        "readings_label": "À lire pour cette étape",
        "tag_daily_habits": "Le quotidien",
        "tag_emotional": "Ce que tu ressens"
      },
      "egg_lab": {
        "retrieval": {
          "title": "Jour de la ponction",
          "timeframe": "Le jour même",
          "body": "La clinique recueille le liquide folliculaire et le labo compte les ovocytes trouvés.",
          "m1_label": "Ponctionnés",
          "m1_value": "En attente",
          "m1_note": "ovocytes trouvés dans le liquide folliculaire",
          "m2_label": "Matures MII",
          "m2_value": "En attente",
          "m2_note": "ovocytes éligibles à la congélation",
          "m3_label": "Récupération",
          "m3_value": "Le jour même",
          "m3_note": "après les consignes post-sédation"
        },
        "maturity": {
          "title": "Contrôle de maturité",
          "timeframe": "Après la ponction",
          "body": "Tous les ovocytes ponctionnés ne sont pas matures. Ce sont les ovocytes matures MII qui sont généralement congelés pour un usage futur.",
          "m1_value": "En attente",
          "m1_note": "ovocytes matures",
          "m2_label": "Immatures",
          "m2_value": "En attente",
          "m2_note": "VG ou MI si rapportés",
          "m3_label": "Mise à jour",
          "m3_value": "Appel du labo",
          "m3_note": "le délai varie selon la clinique"
        },
        "vitrification": {
          "title": "Confirmation de vitrification",
          "timeframe": "Le jour même ou le lendemain",
          "body": "Les ovocytes matures sont vitrifiés, c'est-à-dire refroidis très rapidement puis placés en cryoconservation.",
          "m1_label": "Congelés",
          "m1_value": "En attente",
          "m1_note": "nombre final d’ovocytes matures",
          "m2_label": "Méthode",
          "m2_value": "Vitrification",
          "m2_note": "congélation ultra-rapide",
          "m3_label": "Rapport",
          "m3_value": "En attente",
          "m3_note": "à joindre dès réception"
        },
        "storage": {
          "title": "Conservation",
          "timeframe": "Après la congélation",
          "body": "Le rapport de conservation doit indiquer le centre, les identifiants, la date de renouvellement et les frais annuels.",
          "m1_label": "Centre",
          "m1_value": "En attente",
          "m1_note": "lieu de conservation",
          "m2_label": "Renouvellement",
          "m2_value": "En attente",
          "m2_note": "date des frais annuels",
          "m3_label": "Identifiants",
          "m3_value": "En attente",
          "m3_note": "étiquettes des paillettes ou cannes"
        }
      },
      "embryo_lab": {
        "retrieval": {
          "title": "Jour de la ponction",
          "timeframe": "Le jour même",
          "body": "Le labo confirme combien d’ovocytes ont été ponctionnés et combien sont assez matures pour être fécondés.",
          "m1_label": "Ponctionnés",
          "m1_note": "ovocytes collectés pendant la ponction",
          "m2_label": "Matures MII",
          "m2_note": "ovocytes prêts pour FIV ou ICSI",
          "m3_label": "Méthode",
          "m3_note": "ou FIV / plan partagé si choisi"
        },
        "day1": {
          "title": "Jour 1",
          "timeframe": "Contrôle de fécondation",
          "body": "Le labo vérifie quels ovocytes ont été fécondés normalement. Une fécondation normale est souvent appelée 2PN.",
          "m1_note": "embryons fécondés normalement",
          "m2_label": "Anormale",
          "m2_note": "0PN, 1PN ou 3PN si rapportés",
          "m3_label": "Prochaine mise à jour",
          "m3_value": "Jour 3",
          "m3_note": "selon les retours de la clinique"
        },
        "day2_3": {
          "title": "Jours 2-3",
          "timeframe": "Stade de clivage",
          "body": "Les embryons devraient se diviser. Certaines cliniques rapportent le nombre de cellules, la symétrie et la fragmentation.",
          "m1_label": "En division",
          "m1_note": "embryons encore en croissance",
          "m2_label": "Grade",
          "m2_note": "fragmentation / symétrie",
          "m3_label": "Plan",
          "m3_value": "Culture",
          "m3_note": "poursuite jusqu’au blastocyste"
        },
        "day5_7": {
          "title": "Jours 5-7",
          "timeframe": "Blastocyste + vitrification",
          "body": "Les embryons qui continuent à se développer peuvent atteindre le stade blastocyste et devenir éligibles à la biopsie et à la vitrification.",
          "m1_label": "Blastocystes",
          "m1_note": "certains y arrivent plus tard",
          "m2_label": "Congelés / biopsiés",
          "m2_note": "vitrifiés si congelés",
          "m3_label": "Identifiants de conservation",
          "m3_note": "visibles une fois en banque"
        },
        "pgta": {
          "timeframe": "Si prévu",
          "body": "Si les embryons sont biopsiés, les résultats du dépistage génétique arrivent généralement après l’envoi de la biopsie.",
          "m1_label": "Euploïdes",
          "m1_note": "chromosomiquement typiques",
          "m2_label": "Aneuploïdes / mosaïques",
          "m2_note": "la clinique explique les options de transfert",
          "m3_label": "Délai prévu",
          "m3_value": "7-10 jours",
          "m3_note": "selon le labo"
        }
      },
      "logistics": {
        "med_supply": {
          "title": "Stock de médicaments",
          "timeframe": "À vérifier avant le prochain ajustement de dose",
          "body": "Les ajustements de doses peuvent arriver vite pendant la stimulation. Garde sous la main les médicaments de ce soir, demain, l’antagoniste et le déclenchement.",
          "i1_label": "Médicaments de stimulation ce soir",
          "i1_detail": "Quantité suffisante sous la main",
          "i2_label": "Dose d’antagoniste",
          "i2_detail": "Vérifie que la dose de demain est disponible",
          "i3_label": "Médicaments de déclenchement",
          "i3_detail": "Renouvelle tôt si la clinique peut avancer le calendrier"
        },
        "retrieval_prep": {
          "title": "Préparation à la ponction",
          "timeframe": "Avant le jour du déclenchement",
          "body": "La ponction se met en place rapidement dès que les follicules sont prêts. Garde les consignes d’anesthésie, de jeûne, d’arrivée et de retour à la maison facilement accessibles.",
          "i1_label": "Consignes d’anesthésie",
          "i1_detail": "Règles de jeûne et de médicaments",
          "i2_label": "Retour à la maison",
          "i2_detail": "Obligatoire après sédation",
          "i3_label": "Heure d’arrivée",
          "i3_detail": "Confirmée à la programmation du déclenchement"
        },
        "care_team": {
          "title": "Accès à l’équipe de soin",
          "timeframe": "À garder à portée pendant la stimulation",
          "body": "Les moments les plus tendus sont en général les changements de dose, le moment des renouvellements et les questions de ponction en dehors des heures.",
          "i1_label": "Permanence infirmière de la clinique",
          "i1_detail": "Pour les consignes de dosage et de monitoring",
          "i2_label": "Pharmacie spécialisée",
          "i2_detail": "Pour les renouvellements le jour même",
          "i3_label": "Numéro d’astreinte",
          "i3_detail": "Pour les urgences ponction ou déclenchement"
        },
        "embryo_paperwork": {
          "title": "Dossiers cliniques",
          "timeframe": "Cette semaine",
          "body": "La congélation d’embryons dépend du fait que la clinique et le labo aient les bons consentements et décisions avant le jour de la ponction.",
          "i1_label": "Consentements FIV / ICSI",
          "i1_detail": "Signés ou prêts pour relecture par la clinique",
          "i2_label": "Décision PGT-A",
          "i2_detail": "Indique prévu, indécis·e ou non retenu",
          "i3_label": "Documents partenaire / donneur",
          "i3_detail": "Nécessaires si la source de sperme change"
        },
        "egg_consent": {
          "title": "Consentement et conservation",
          "timeframe": "Avant la ponction",
          "body": "Les documents pour la congélation d’ovocytes concernent surtout le consentement à la ponction, la cryoconservation, le renouvellement et les choix futurs d’utilisation.",
          "i1_label": "Consentement à la ponction",
          "i1_detail": "Signé ou prêt pour relecture par la clinique",
          "i2_label": "Contrat de cryoconservation",
          "i2_detail": "Centre, renouvellement et conditions de frais annuels",
          "i3_label": "Utilisation future",
          "i3_detail": "Ce qui se passe si les ovocytes ne sont pas utilisés plus tard"
        }
      },
      "monitoring": {
        "baseline": "État de base",
        "mid_stim_1": "Mi-stim 1",
        "mid_stim_2": "Mi-stim 2",
        "yesterday": "Hier",
        "tomorrow": "Demain",
        "pre_trigger": "Pré-déclenchement"
      },
      "embryo_funnel": {
        "s1_label": "Ovocytes ponctionnés",
        "s1_detail": "Ovocytes trouvés par le labo.",
        "s2_label": "Matures",
        "s2_detail": "Ovocytes MII prêts pour l’ICSI.",
        "s3_label": "Fécondés",
        "s3_detail": "Contrôle de fécondation normale 2PN.",
        "s4_label": "Blastocystes",
        "s4_detail": "Embryons J5-7 pour congélation/test.",
        "s5_label": "Euploïdes",
        "s5_detail": "Estimés après PGT-A ; le rapport du labo confirme le résultat."
      },
      "semen": {
        "volume_label": "Volume",
        "volume_note": "volume de l’échantillon",
        "concentration_label": "Concentration",
        "concentration_note": "spermatozoïdes par mL",
        "motility_label": "Mobilité",
        "motility_note": "spermatozoïdes mobiles",
        "morphology_label": "Morphologie",
        "morphology_note": "formes normales (critères stricts)"
      },
      "sperm_funnel": {
        "s1_label": "Échantillon",
        "s1_detail": "Estimation des spermatozoïdes utilisables avant congélation.",
        "s2_label": "Traités",
        "s2_detail": "Après lavage et préparation au labo.",
        "s3_label": "Paillettes congelées",
        "s3_detail": "Conservées sur deux échantillons.",
        "s4_label": "Utilisables après décongélation",
        "s4_detail": "Estimation des paillettes mobiles."
      },
      "beta": {
        "date_label": "Date du beta",
        "date_note": "prise de sang",
        "dpt_label": "Jours après le transfert",
        "dpt_note": "embryon J5",
        "meds_label": "Médicaments",
        "meds_value": "3 aujourd’hui",
        "meds_note": "à poursuivre",
        "symptoms_label": "Symptômes",
        "symptoms_value": "Non prédictifs",
        "symptoms_note": "à suivre si sévères"
      },
      "stim_cards": {
        "support": {
          "badge": "Aujourd’hui",
          "title": "Soutenir le cycle",
          "body": "L’objectif est la régularité, pas un mode de vie parfait. Voici les bases qui comptent le plus pendant la stimulation.",
          "b1": "Prends les médicaments de stimulation exactement aux horaires de la clinique.",
          "b2": "Fais des repas réguliers avec protéines, végétaux, céréales complètes et bonnes graisses.",
          "b3": "Hydrate-toi, dors et limite la caféine et l’alcool selon les recommandations de la clinique.",
          "b4": "Utilise des techniques anti-stress pour ton bien-être ; le stress n’a pas d’impact prouvé sur les résultats de la FIV."
        },
        "safety": {
          "badge": "Sécurité",
          "title": "À éviter ou à demander d’abord",
          "body": "Quand les ovaires grossissent et que le déclenchement approche, certaines activités et médicaments demandent un avis plus clair de la clinique.",
          "b1": "Évite les rapports ou utilise des préservatifs sauf accord explicite de ta clinique.",
          "b2": "Demande à la clinique avant de prendre tout ibuprofène, naproxène, aspirine, complément ou nouveau médicament.",
          "b3": "Évite les sports à impact, les torsions et tout ce qui aggrave la pression pelvienne.",
          "b4": "Appelle en urgence en cas de douleur sévère, prise de poids rapide, essoufflement, fièvre ou saignements abondants."
        },
        "nutrition": {
          "badge": "Alimentation",
          "title": "Quoi manger",
          "body": "Aucun régime ne garantit une meilleure ponction. L’approche la plus solide reste une base régulière de type méditerranéenne.",
          "b1": "Privilégie légumes, fruits, légumineuses, céréales complètes, huile d’olive, fruits à coque et poisson si tu en manges.",
          "b2": "Ne fais pas de régime drastique et ne coupe pas brutalement les glucides pendant la stimulation.",
          "b3": "En cas de nausées ou de ballonnements, des repas plus petits avec des protéines passent souvent mieux."
        },
        "movement": {
          "badge": "Mouvement",
          "title": "Comment bouger",
          "body": "Bouger devient surtout une question de confort et de risque de torsion une fois les ovaires gonflés par la stimulation.",
          "b1": "La marche et un mouvement doux au quotidien restent les choix les plus sûrs.",
          "b2": "Évite la course, le HIIT, les sauts, le yoga en torsion et le port de charges lourdes sauf avis contraire.",
          "b3": "Lève le pied si la pression pelvienne, les ballonnements ou une douleur d’un côté augmentent."
        },
        "medication": {
          "badge": "Médicaments",
          "title": "Horaire des médicaments",
          "body": "Pendant la stimulation, l’horaire et l’accord de la clinique comptent plus que d’ajuster seul·e.",
          "b1": "L’horaire du déclenchement est précis ; appelle tout de suite en cas de retard ou d’oubli.",
          "b2": "Vérifie avant toute nouvelle ordonnance, AINS, aspirine, antihistaminique ou anticoagulant.",
          "b3": "Le paracétamol est généralement autorisé, mais suis le plan antidouleur de ta clinique."
        },
        "supplements": {
          "badge": "Compléments",
          "title": "Règles pour les compléments",
          "body": "Les compléments ne sont pas inoffensifs juste parce qu’ils sont en vente libre, surtout près de la ponction.",
          "b1": "La vitamine prénatale ou le folate est souvent recommandé ; confirme la dose avec ta clinique.",
          "b2": "Ne commence pas la DHEA, des plantes, des antioxydants à forte dose ou des compléments hormono-actifs en cours de cycle sans accord.",
          "b3": "Préviens la clinique pour CoQ10, oméga-3, vitamine D, biotine et tout ce qui peut affecter la coagulation ou les analyses."
        }
      },
      "today_rows": {
        "collection": {
          "appt_title": "Rendez-vous de prélèvement",
          "appt_detail": "Labo principal, apporte une pièce d’identité. Fenêtre d’abstinence : jour 3 sur 2-5.",
          "proc_title": "Traitement de l’échantillon",
          "proc_detail": "Le labo vérifie la concentration, la mobilité, la morphologie et estime les paillettes.",
          "storage_title": "Confirmation de conservation",
          "storage_detail": "Attendue le jour même si l’échantillon est mis en banque."
        },
        "wait": {
          "prog_title": "Progestérone",
          "prog_detail": "Continue sauf si la clinique change le plan.",
          "any_time": "À tout moment",
          "symptom_title": "Point sur les symptômes",
          "symptom_detail": "Appelle en cas de douleur sévère, saignements abondants, fièvre ou essoufflement.",
          "beta_title": "Prise de sang beta",
          "beta_detail": "La clinique t’appellera après relecture du résultat."
        },
        "donor": {
          "screening_title": "Analyses de dépistage",
          "screening_detail": "Prise de sang pour maladies infectieuses et dépistage génétique de porteur.",
          "coord_title": "Appel coordinatrice",
          "coord_detail": "Point sur le statut de matching, les prochains documents et le calendrier de l’indemnisation."
        },
        "stim": {
          "gonal_detail": "Stimule la croissance des follicules par la FSH.",
          "subc_pen": "Stylo sous-cutané",
          "monitoring_title": "Visite de monitoring",
          "monitoring_detail": "Échographie + estradiol. L’estimation de ponction est mise à jour ensuite.",
          "cetrotide_detail": "Bloque l’ovulation prématurée pendant la maturation folliculaire.",
          "subc_vial": "Flacon sous-cutané"
        }
      },
      "section": {
        "today_title": "Aujourd’hui",
        "today_subtitle": "Actions concrètes pour ce jour du cycle.",
        "calendar_action": "Calendrier",
        "testing_title": "Analyses",
        "testing_subtitle": "Résultats récents et contexte de monitoring pour ce jour du cycle.",
        "all_tests_action": "Toutes les analyses",
        "good_to_know_title": "Bon à savoir",
        "good_to_know_subtitle": "Repères et estimations utiles pour la suite.",
        "cycle_logistics_title": "Logistique du cycle",
        "cycle_logistics_subtitle": "Médicaments, préparation à la ponction, contacts clinique et calendrier des mises à jour du labo.",
        "ivf_specifics_title": "Spécificités FIV",
        "ivf_specifics_subtitle": "Le sperme, la fécondation, les tests embryonnaires et les choix de transfert changent ce qui se passe après la ponction."
      },
      "widget": {
        "timeline_title": "Calendrier",
        "test_results_title": "Résultats d’analyses",
        "test_results_subtitle": "Les résultats nouveaux et en attente apparaissent ici.",
        "monitoring_progress_title": "Progression du monitoring",
        "monitoring_progress_subtitle": "Enregistre chaque visite pour suivre la croissance folliculaire, l’estradiol et la progression vers le déclenchement.",
        "what_to_know_title": "Ce qu’il faut savoir",
        "what_to_know_subtitle": "Utilise-le comme rappel rapide entre deux monitorings. Les consignes de ta clinique restent prioritaires.",
        "cycle_may_freeze_title": "Ce que ce cycle peut congeler",
        "cycle_may_freeze_subtitle": "Estimation à partir du nombre de follicules du jour. Les chiffres réels se mettent à jour après ponction, contrôle de maturité et congélation.",
        "cycle_may_become_title": "Ce que ce cycle peut devenir",
        "cycle_may_become_subtitle": "Estimation à partir du nombre de follicules du jour. Après la ponction, elle se met à jour avec les ovocytes ponctionnés, matures, fécondés, les blastocystes et les résultats PGT-A éventuels.",
        "logistics_checklist_title": "Checklist logistique du cycle",
        "after_retrieval_title": "Après la ponction",
        "after_retrieval_egg_subtitle": "Fais défiler : jour de la ponction, contrôle de maturité, confirmation de congélation et conservation.",
        "after_retrieval_embryo_subtitle": "Fais défiler : jour de la ponction, fécondation, clivage, blastocyste, congélation et PGT-A.",
        "ivf_plan_title": "Plan FIV",
        "retrieval_decisions_title": "Décisions du jour de la ponction"
      },
      "test_results_preview": {
        "purpose_amh": "Reflète la taille de ta réserve ovarienne",
        "purpose_fsh": "Indique l’effort de ton corps pour faire mûrir un ovocyte",
        "purpose_vitamin_d": "Soutient la qualité ovocytaire et l’implantation",
        "purpose_tsh": "Indique si la thyroïde suit le rythme des hormones de la fertilité",
        "tomorrow": "demain",
        "friday": "vendredi",
        "prep_baseline": "Jour 2-3 du cycle s’il s’agit d’un bilan de base",
        "prep_thyroid": "Demande pour le jeûne et la biotine avant un bilan thyroïdien"
      },
      "monitoring_action": {
        "log_monitoring": "Ajouter les résultats du monitoring",
        "log_symptoms": "Ajouter les symptômes"
      },
      "ivf_plan": {
        "endometrium_label": "Endomètre",
        "endometrium_note": "trilamellaire",
        "sperm_label": "Stratégie sperme",
        "sperm_value": "Frais avec secours",
        "sperm_note": "prélèvement le matin de la ponction",
        "fertilization_label": "Fécondation",
        "fertilization_note": "plan de la clinique",
        "pgta_value": "Prévu",
        "pgta_note": "tout congeler d’abord",
        "task1_title": "Échantillon du partenaire",
        "task1_detail": "Un échantillon frais est prévu ; une paillette de secours est disponible si besoin.",
        "task2_title": "Consentement ICSI",
        "task2_detail": "Signé et rattaché au cycle.",
        "task3_title": "Plan PGT-A",
        "task3_detail": "Le plan biopsie et freeze-all est prêt pour le labo."
      },
      "owner": {
        "you": "Toi",
        "partner": "Partenaire",
        "clinic": "Clinique",
        "lab": "Labo",
        "legal": "Juridique",
        "agency": "Agence",
        "louise": "Louise"
      },
      "due": {
        "now": "Maintenant",
        "optional": "Optionnel",
        "done": "Terminé",
        "today": "Aujourd’hui",
        "tomorrow": "Demain",
        "this_week": "Cette semaine",
        "retrieval_morning": "Matin de la ponction"
      },
      "status": {
        "available": "Disponible",
        "learn": "À découvrir"
      },
      "setup": {
        "eyebrow": "Configuration",
        "title": "Configure ton parcours",
        "summary": "Réponds à quelques éléments essentiels pour que Louise t’affiche le bon parcours dès le départ.",
        "hm1_label": "Prochaine étape",
        "hm1_value": "Choisir un parcours",
        "hm1_note": "2 minutes",
        "hm2_label": "Connu",
        "hm2_value": "Âge + localisation",
        "hm2_note": "depuis le profil",
        "hm3_label": "Manquant",
        "hm3_value": "Objectif + délai",
        "hm3_note": "nécessaire pour t’orienter",
        "primary_action": "Commencer la configuration",
        "section_title": "Ta configuration",
        "section_subtitle": "Commence par les essentiels qui changent ce qui apparaît ensuite.",
        "tasks_title": "Réponds d’abord à ça",
        "t1_title": "Choisis ton objectif",
        "t1_detail": "Préserver, tomber enceinte, donner, recourir à un·e donneur·euse/gestation pour autrui, adopter ou s’informer.",
        "t2_title": "Précise qui est impliqué·e",
        "t2_detail": "Partenaire, donneur·euse, gestatrice, parent d’intention ou seul·e.",
        "t3_title": "Note un délai urgent",
        "t3_detail": "Soins oncologiques, hormones, âge, calendrier du cycle ou échéance clinique.",
        "routes_title": "Parcours probables",
        "r1_title": "Préserver la fertilité",
        "r1_detail": "Planification de la congélation d’ovocytes, de sperme ou d’embryons.",
        "r2_title": "Tomber enceinte",
        "r2_detail": "IIU, FIV, don, gestation pour autrui ou parcours informatif en premier.",
        "r3_title": "Donner ou porter",
        "r3_detail": "Parcours de don ou de gestation avec tâches d’agence et de dépistage."
      },
      "learn": {
        "eyebrow": "Découvrir",
        "title": "Explore sans être poussé·e vers un traitement",
        "summary": "Explore en clarté avant de choisir une clinique, un test ou un parcours de traitement.",
        "hm1_label": "Mode",
        "hm1_value": "Apprentissage",
        "hm1_note": "aucun traitement supposé",
        "hm2_label": "Sauvegardé",
        "hm2_value": "4 questions",
        "hm2_note": "pour les consultations",
        "hm3_label": "Prochaine étape",
        "hm3_value": "Comparer les options",
        "hm3_note": "10 minutes",
        "section_title": "Commence ici",
        "section_subtitle": "Compare les options et choisis des actions facultatives sans entamer de plan de traitement.",
        "paths_title": "Comparer les parcours",
        "p1_title": "Congeler des ovocytes",
        "p1_detail": "Adapté pour préserver des ovocytes non fécondés.",
        "p2_title": "Congeler du sperme",
        "p2_detail": "Mise en banque rapide et moins complexe avec spermogramme.",
        "p3_title": "Congeler des embryons",
        "p3_detail": "Nécessite une source d’ovocytes, de sperme et des décisions de labo.",
        "p4_title": "IIU vs FIV",
        "p4_detail": "Calendrier, coût, taux de succès et implication du labo différents.",
        "actions_title": "Prochaines actions facultatives",
        "a1_title": "Sauvegarde des questions pour la clinique",
        "a1_detail": "Construis une checklist de consultation à partir des sujets que tu lis.",
        "a2_title": "Vérifier les analyses de base",
        "a2_detail": "AMH/AFC ou spermogramme si tu veux des données avant de décider.",
        "a3_title": "Trouver des soins près de toi",
        "a3_detail": "Parcours cliniques, labos et programmes sans t’engager."
      },
      "post_procedure_outcome": {
        "early_pregnancy": {
          "whats_next": "Et maintenant",
          "what_usually_comes_next": "Ce qui vient ensuite",
          "weeks_and_days_along": "Vous en êtes à ${weeks} semaines et ${days} jours.",
          "about_weeks_along": "Vous en êtes à environ ${weeks} semaines.",
          "usually_between_dates": "Estimé entre le ${start} et le ${end}",
          "your_clinic_plan_comes_first": "Ce sont des repères habituels, pas des rendez-vous fixés. Vérifiez toujours le calendrier avec votre clinique : c'est le sien qui compte.",
          "milestone_repeat_beta": "Une nouvelle prise de sang",
          "milestone_first_scan": "La première échographie",
          "milestone_care_handover": "Le passage au suivi de grossesse",
          "milestone_first_trimester_screening": "Le dépistage du premier trimestre",
          "first_weeks_confirm_the_result_ivf": "Après un transfert en FIV, ces premières semaines servent surtout à confirmer le résultat et à voir où vous en êtes.",
          "first_weeks_confirm_the_result_fet": "Après un transfert d'embryon congelé, ces premières semaines servent surtout à confirmer le résultat et à voir où vous en êtes.",
          "first_weeks_confirm_the_result_iui": "Après une insémination, ces premières semaines servent surtout à confirmer le résultat et à voir où vous en êtes.",
          "first_weeks_confirm_the_result_oi": "Après un cycle d'induction de l'ovulation, ces premières semaines servent surtout à confirmer le résultat et à voir où vous en êtes.",
          "next_weeks_repeat_beta": "Une nouvelle prise de sang, souvent deux jours plus tard.",
          "next_weeks_first_scan": "Une première échographie, généralement quelques semaines après le résultat.",
          "clinic_says_what_to_keep_taking": "Votre clinique vous dira quels traitements continuer, et si quelque chose change.",
          "next_weeks_care_handover": "Le moment venu, votre clinique passera le relais au suivi de grossesse. Elle vous dira quand.",
          "next_weeks_first_trimester_screening": "Un dépistage du premier trimestre est généralement proposé ; votre clinique vous dira quand.",
          "about_the_numbers": "Ces chiffres",
          "one_number_says_little": "Un seul chiffre ne dit pas grand-chose",
          "a_beta_is_read_with_its_timing": "Un taux de bêta se lit toujours avec la date du prélèvement et ce qui l'a précédé. Louise ne cherche pas à interpréter le vôtre.",
          "numbers_timing_matters": "Le même taux peut vouloir dire autre chose selon le moment où il a été mesuré.",
          "numbers_clinic_reads_trend": "Votre clinique regarde l'ensemble : le moment, et l'évolution d'un résultat à l'autre.",
          "numbers_louise_keeps_record": "Louise garde chaque résultat que vous notez, pour que vous puissiez tout montrer à votre équipe.",
          "if_something_worries_you": "Si quelque chose vous inquiète",
          "do_not_wait_to_call": "Rien ne vous oblige à attendre votre prochain rendez-vous",
          "some_things_are_worth_a_call_today": "Certaines choses valent un appel le jour même, même si un rendez-vous est déjà prévu. Cette liste n'est pas complète, et le doute suffit pour appeler.",
          "bleeding_pain_fever_or_anything_else": "Des saignements, des douleurs ou de la fièvre sont de bonnes raisons d'appeler votre clinique, comme tout autre signe qui vous inquiète.",
          "most_clinics_answer_without_an_appointment": "La plupart des cliniques répondent à une question sans rendez-vous.",
          "reach_out_local_emergency": "Si vous ne vous sentez pas bien ou en sécurité, appelez le numéro d'urgence local.",
          "update_this_pregnancy": "Mettre à jour cette grossesse",
          "record_a_result_or_say_what_changed": "Ouvrez votre cycle pour ajouter ou modifier ce qui est enregistré."
        },
        "shared": {
          "hero_positive_action": "Regardons la suite",
          "hero_negative_action": "Regardons la suite",
          "hero_uncertain_action": "Revoir les détails du résultat",
          "take_a_breath_after_this_cycle": "Prenez un instant apr\u00e8s ce cycle",
          "hero_adverse_action": "Revoir ce qui a été enregistré",
          "hero_unavailable_action": "Ajouter ou revoir le résultat",
          "handoff_title": "Choisir la suite",
          "handoff_body": "Quand vous serez prête, Louise peut vous aider à transformer le résultat que vous avez enregistré en questions et en prochaine étape concrète avec votre clinique.",
          "handoff_cta": "Explorer la suite",
          "handoff_check_1": "Garder le résultat avec vos dossiers",
          "handoff_check_2": "Revoir le calendrier du suivi",
          "handoff_chat_prompt": "Aidez-moi à comprendre les prochaines étapes après mon résultat confirmé de traitement de fertilité. Tenez compte de la source du résultat et du contexte de la procédure, aidez-moi à préparer mes questions pour la clinique et terminez par une étape concrète. Ne posez pas de diagnostic et ne modifiez pas mon traitement.",
          "handoff_positive_title": "La suite, à votre rythme",
          "handoff_positive_body": "Quand vous serez prête, Louise peut vous aider à garder ensemble le résultat et vos questions pour votre clinique.",
          "handoff_positive_cta": "En parler",
          "handoff_positive_check_1": "Garder le résultat avec vos dossiers",
          "handoff_positive_check_2": "Préparer vos questions pour la clinique",
          "handoff_positive_chat_prompt": "Aidez-moi à préparer mon suivi après mon résultat positif de traitement de fertilité. Tenez compte du contexte de la procédure, aidez-moi à préparer mes questions pour la clinique et terminez par une étape concrète. Ne posez pas de diagnostic et ne modifiez pas mon traitement.",
          "handoff_negative_title": "La suite, quand vous le déciderez",
          "handoff_negative_body": "Quand vous serez prête, Louise peut vous aider à transformer ce résultat en questions claires pour votre clinique, sans présumer de la suite que vous souhaitez donner.",
          "handoff_negative_cta": "En parler",
          "specify_this_cycles_outcome": "Préciser l'issue de ce cycle",
          "handoff_negative_secondary_cta": "Planifier un autre cycle",
          "handoff_negative_check_1": "Garder le résultat avec vos dossiers",
          "handoff_negative_check_2": "Préparer vos questions pour la clinique",
          "handoff_negative_chat_prompt": "Aidez-moi à préparer mes questions pour la clinique après mon résultat négatif de traitement de fertilité. Tenez compte du contexte de la procédure, ne présumez pas de la suite que je souhaite donner et terminez par une étape concrète. Ne posez pas de diagnostic et ne modifiez pas mon traitement.",
          "handoff_unavailable_title": "Être accompagnée pendant l’attente",
          "handoff_unavailable_body": "Votre résultat n’est pas encore disponible dans Louise. Quand vous serez prête, nous pouvons vous aider à préparer une question ou à garder une étape de suivi confirmée, sans deviner le résultat.",
          "handoff_unavailable_cta": "En parler pendant l’attente",
          "handoff_unavailable_check_1": "Garder le résultat non qualifié jusqu’à confirmation",
          "handoff_unavailable_check_2": "Préparer une question pour la clinique",
          "handoff_unavailable_chat_prompt": "Mon résultat de traitement de fertilité n’est pas encore disponible dans Louise. Aidez-moi à préparer une question pour ma clinique ou à identifier la prochaine étape confirmée, sans deviner si le résultat est positif ou négatif. Ne posez pas de diagnostic et ne modifiez pas mon traitement.",
          "pause_eyebrow": "Après ce cycle",
          "pause_title": "Avançons une étape à la fois",
          "pause_summary": "Vous pouvez laisser ce cycle ici pour le moment. Si vous le souhaitez, nous pouvons revoir ce qui s’est passé, préparer vos questions, ou vous laisser de l’espace jusqu’à ce que vous ayez envie d’y revenir.",
          "pause_summary_supporting": "Vous pouvez laisser ce cycle ici pour le moment. Si vous le souhaitez, nous pouvons le revoir ensemble, ou vous aider à préparer des questions. Il n’y a rien à réparer — être là suffit.",
          "pause_primary_action": "Revoir ensemble",
          "setup_eyebrow": "Quand vous serez prête",
          "setup_title": "Avançons une étape à la fois",
          "setup_summary": "Vous n’avez pas besoin de tout organiser aujourd’hui. Commencez par un rendez-vous, une note sur un traitement ou une question, puis revenez au reste quand vous serez prête.",
          "setup_primary_action": "Commencer par une chose",
          "next_clinic_title": "Prochaine étape avec la clinique",
          "next_clinic_subtitle": "Seuls les rendez-vous, analyses et consignes enregistrés pour vous apparaissent ici.",
          "setup_next_clinic_subtitle": "Commencez par le prochain rendez-vous, la prochaine analyse ou la prochaine consigne confirmée.",
          "next_clinic_today_title": "Rendez-vous ou consigne à venir",
          "known_title": "Ce qui est connu",
          "known_subtitle": "Gardez la procédure et le résultat disponibles sans en faire le titre de la page.",
          "good_to_know": "Bon à savoir",
          "the_first_few_weeks": "Les premières semaines",
          "what_happens_next_and_who_to_ask": "Ce qui vient ensuite, et à qui en parler.",
          "known_result_title": "Enregistrement du résultat",
          "known_result_value_pregnancy": "Résultat positif enregistré.",
          "known_result_value_no_pregnancy": "Résultat négatif enregistré.",
          "known_result_value_not_confirmed": "Le statut du résultat n’est pas confirmé.",
          "known_result_source_provider": "Ajouté par votre clinique ou votre équipe de soins.",
          "known_result_source_patient": "Vous avez enregistré ce résultat.",
          "known_result_source_partner": "Ajouté par un partenaire partagé.",
          "known_result_source_system": "Ajouté par un système connecté.",
          "known_result_source_unknown": "La source n’est pas encore enregistrée.",
          "known_result_verification_verified": "Cet enregistrement est marqué comme vérifié.",
          "known_result_verification_unverified": "Cet enregistrement n’est pas marqué comme vérifié.",
          "known_result_verification_refuted": "Cet enregistrement est marqué comme réfuté ; vérifiez la correction avant de vous y fier.",
          "known_timeline_title": "Votre calendrier de soins",
          "known_procedure_detail": "Les détails de la procédure restent reliés à ce cycle.",
          "known_result_detail": "Le résultat reste disponible dans l’historique du cycle et les dossiers.",
          "known_next_label": "Prochaine étape",
          "known_next_detail": "Ajoutez ou consultez un vrai suivi quand vous en aurez un.",
          "setup_next_label": "Préparer le suivi",
          "setup_next_detail": "Ajoutez le prochain rendez-vous, la prochaine analyse ou la consigne de la clinique.",
          "when_ready_title": "Quand vous serez prête",
          "when_ready_subtitle": "Choisissez une action utile. Rien ne démarre automatiquement.",
          "setup_ready_title": "Préparer ce qui vous aide",
          "setup_ready_subtitle": "Gardez les étapes de soins confirmées ensemble avant de choisir un suivi facultatif.",
          "stage_action_add_follow_up": "Ajouter un rendez-vous de suivi",
          "stage_action_add_follow_up_detail": "Enregistrez la date, l’heure et les notes communiquées par la clinique.",
          "stage_action_schedule_appointment": "Planifier un rendez-vous",
          "stage_action_schedule_appointment_detail": "Ajoutez la date, l’heure et les notes de votre prochaine visite.",
          "stage_action_add_medication": "Ajouter un traitement",
          "stage_action_add_medication_detail": "Enregistrez le traitement, la dose ou la consigne de votre équipe de soins.",
          "stage_action_review_records": "Revoir ce cycle",
          "could_not_save_that_try_again": "Nous n'avons pas pu enregistrer. Réessayez.",
          "stage_action_review_records_detail": "Ouvrez l’historique de votre procédure et de votre résultat.",
          "stage_action_review_records_detail_ivf": "Ouvrez l’historique de votre procédure FIV et de votre résultat.",
          "stage_action_review_records_detail_fet": "Ouvrez l’historique de votre transfert FET et de votre résultat.",
          "stage_action_review_records_detail_iui": "Ouvrez l’historique de votre insémination IIU et de votre résultat.",
          "stage_action_review_records_detail_oi": "Ouvrez l’historique de votre cycle d’induction de l’ovulation et de votre résultat.",
          "stage_action_save_question": "Poser une question sur ce résultat",
          "stage_action_save_question_detail": "Ouvrez l’assistant avec le contexte de ce cycle pour préparer le suivi.",
          "stage_action_save_question_prompt": "Je veux préparer une question sur mon résultat de traitement de fertilité et mon prochain rendez-vous. Aidez-moi à la rendre précise et concise, sans poser de diagnostic ni modifier mon traitement.",
          "stage_action_explore_next": "Explorer une autre étape",
          "stage_action_explore_next_detail": "Ouvrez la planification quand vous serez prête ; aucun traitement ne démarre.",
          "stage_action_tracking": "Parler du suivi de grossesse",
          "stage_action_tracking_detail": "Choisissez si vous voulez l’activer — rien ne démarre sans votre accord.",
          "stage_action_tracking_prompt": "J’ai un résultat positif après un traitement de fertilité et je veux comprendre le suivi de grossesse. Expliquez quelles informations sont utiles à noter maintenant, quelles méthodes de datation ma clinique peut utiliser et quelles questions poser lors du suivi. Ne posez pas de diagnostic et ne modifiez pas mon traitement."
        },
        "pregnancy_tracking": {
          "title": "Configurer le suivi de grossesse",
          "summary": "C’est facultatif. Louise peut garder ensemble votre suivi, vos questions et votre résultat sans deviner une semaine ou une date prévue d’accouchement.",
          "opted_in_title": "Le suivi de grossesse est prêt",
          "opted_in_summary": "Vous gardez le contrôle de ce que vous ajoutez. Aucune semaine ni date prévue ne s’affichera avant l’enregistrement d’une méthode de datation.",
          "action_appointment": "Ajouter un rendez-vous de suivi",
          "action_appointment_detail": "Enregistrez la prochaine échographie, le prochain beta ou rendez-vous quand vous aurez les détails.",
          "action_question": "Préparer une question",
          "action_question_detail": "Demandez à Louise de vous aider à formuler une question précise pour votre équipe de soins.",
          "action_question_prompt": "J’ai un résultat positif après un traitement de fertilité et je veux préparer une question pour mon prochain suivi. Aidez-moi à la rendre précise sans poser de diagnostic ni modifier mon traitement.",
          "action_records": "Revoir l’enregistrement du résultat",
          "action_records_detail": "Gardez la procédure, la source du résultat et l’historique du cycle reliés.",
          "action_open": "Configurer le suivi de grossesse",
          "action_review": "Revoir le suivi de grossesse",
          "the_weeks_ahead": "Les premières semaines",
          "what_usually_comes_next_and_who_to_ask": "Ce qui arrive généralement ensuite, et à qui s'adresser. Rien à faire aujourd'hui.",
          "you_will_find_this_on_your_home_page": "Vous retrouverez tout ça sur votre page d’accueil, à votre rythme."
        },
        "ivf": {
          "positive": {
            "eyebrow": "Résultat FIV",
            "title": "Un résultat FIV positif est enregistré — prenez un instant",
            "summary": "Quels que soient vos sentiments, rien n’a besoin d’être décidé aujourd’hui. Quand vous serez prête, nous garderons ici ce résultat, les détails du transfert et vos questions pour votre prochain échange avec la clinique.",
            "section_title": "La suite",
            "section_subtitle": "Gardez le résultat relié aux dossiers du transfert, de l’embryon et de la clinique.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Transfert frais FIV/ICSI",
            "result_label": "Résultat FIV"
          },
          "negative": {
            "eyebrow": "Résultat FIV",
            "summary": "Quels que soient vos sentiments, vous n’avez pas besoin de décider de la suite aujourd’hui. Quand vous serez prête, nous vous aiderons à comprendre ce cycle et à préparer vos questions pour votre prochaine conversation avec votre clinique.",
            "section_title": "La suite",
            "section_subtitle": "Gardez le résultat relié aux dossiers du transfert, de l’embryon et de la clinique.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Transfert frais FIV/ICSI",
            "result_label": "Résultat FIV"
          },
          "unavailable": {
            "eyebrow": "Résultat FIV",
            "title": "Votre résultat FIV n’est pas encore disponible",
            "summary": "Quand votre résultat de clinique ou d’analyse sera disponible, vous pourrez l’ajouter ici. D’ici là, nous ne qualifierons pas ce cycle de positif ou de négatif.",
            "section_title": "Garder ce cycle en vue",
            "section_subtitle": "Enregistrez la prochaine étape réelle en attendant un résultat officiel.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Transfert frais FIV/ICSI",
            "result_label": "Résultat FIV"
          },
          "uncertain": {
            "eyebrow": "Résultat FIV",
            "title": "Reprenons un instant votre résultat FIV",
            "summary": "Ce résultat n’est pas assez clair pour qualifier le cycle de positif ou de négatif. Consultez l’enregistrement ou vérifiez la prochaine étape avec votre équipe de soins.",
            "section_title": "Clarifier ce qui a été enregistré",
            "section_subtitle": "Gardez le contexte du transfert ensemble pendant la vérification du résultat.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Transfert frais FIV/ICSI",
            "result_label": "Résultat FIV"
          },
          "adverse": {
            "eyebrow": "Après votre résultat FIV",
            "title": "Avançons une étape à la fois",
            "summary": "Vous n’avez pas à prendre aujourd’hui une décision sur la suite du traitement. Quand vous serez prête, nous pouvons vous aider à garder les informations réunies et à préparer un échange avec votre équipe de soins.",
            "section_title": "Ce qui peut vous aider maintenant",
            "section_subtitle": "Gardez le contexte du transfert et votre prochaine conversation ensemble. En cas de symptômes urgents, contactez votre équipe de soins ou les services d’urgence locaux.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Transfert frais FIV/ICSI",
            "result_label": "Résultat FIV"
          }
        },
        "fet": {
          "positive": {
            "eyebrow": "Résultat FET",
            "title": "Un résultat FET positif est enregistré — prenez un instant",
            "summary": "Quels que soient vos sentiments, rien n’a besoin d’être décidé aujourd’hui. Quand vous serez prête, nous garderons ici ce résultat, les détails du transfert et vos questions pour votre prochain échange avec la clinique.",
            "section_title": "La suite",
            "section_subtitle": "Gardez le résultat confirmé relié à votre plan de clinique et à l’historique du transfert.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Transfert FET",
            "result_label": "Résultat FET"
          },
          "negative": {
            "eyebrow": "Résultat FET",
            "summary": "Quels que soient vos sentiments, vous n’avez pas besoin de décider de la suite aujourd’hui. Quand vous serez prête, nous vous aiderons à comprendre ce cycle et à préparer vos questions pour votre prochaine conversation avec votre clinique.",
            "section_title": "La suite",
            "section_subtitle": "Avancez avec votre clinique sans transformer un résultat en prescription.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Transfert FET",
            "result_label": "Résultat FET"
          },
          "unavailable": {
            "eyebrow": "Résultat FET",
            "title": "Votre résultat FET n’est pas encore disponible",
            "summary": "Quand votre résultat de clinique ou d’analyse sera disponible, vous pourrez l’ajouter ici. D’ici là, nous ne qualifierons pas ce cycle de positif ou de négatif.",
            "section_title": "Garder ce cycle en vue",
            "section_subtitle": "Enregistrez la prochaine étape réelle en attendant un résultat officiel.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Transfert FET",
            "result_label": "Résultat FET"
          },
          "uncertain": {
            "eyebrow": "Résultat FET",
            "title": "Reprenons un instant votre résultat FET",
            "summary": "Ce résultat n’est pas assez clair pour qualifier le cycle de positif ou de négatif. Consultez l’enregistrement ou vérifiez la prochaine étape avec votre équipe de soins.",
            "section_title": "Clarifier ce qui a été enregistré",
            "section_subtitle": "Gardez le contexte du transfert FET ensemble pendant la vérification du résultat.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Transfert FET",
            "result_label": "Résultat FET"
          },
          "adverse": {
            "eyebrow": "Après votre résultat FET",
            "title": "Avançons une étape à la fois",
            "summary": "Vous n’avez pas à prendre aujourd’hui une décision sur la suite du traitement. Quand vous serez prête, nous pouvons vous aider à garder les informations réunies et à préparer un échange avec votre équipe de soins.",
            "section_title": "Ce qui peut vous aider maintenant",
            "section_subtitle": "Gardez le contexte du transfert et votre prochaine conversation ensemble. En cas de symptômes urgents, contactez votre équipe de soins ou les services d’urgence locaux.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Transfert FET",
            "result_label": "Résultat FET"
          }
        },
        "iui": {
          "positive": {
            "eyebrow": "Résultat de l’insémination",
            "title": "Un résultat IUI positif est enregistré — prenez un instant",
            "summary": "Quels que soient vos sentiments, rien n’a besoin d’être décidé aujourd’hui. Quand vous serez prête, nous garderons ici ce résultat, les détails de l’insémination et vos questions pour votre prochain échange avec la clinique.",
            "section_title": "La suite",
            "section_subtitle": "Gardez le résultat relié à la date d’insémination et à votre plan de soins.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Procédure d’IUI",
            "result_label": "Résultat IUI"
          },
          "negative": {
            "eyebrow": "Résultat de l’insémination",
            "summary": "Quels que soient vos sentiments, vous n’avez pas besoin de décider de la suite aujourd’hui. Quand vous serez prête, nous vous aiderons à comprendre ce cycle et à préparer vos questions pour votre prochaine conversation avec votre clinique.",
            "section_title": "La suite",
            "section_subtitle": "Avancez avec votre clinique sans présumer de ce que vous souhaitez faire ensuite.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Procédure d’IUI",
            "result_label": "Résultat IUI"
          },
          "unavailable": {
            "eyebrow": "Résultat de l’insémination",
            "title": "Votre résultat IUI n’est pas encore disponible",
            "summary": "Quand votre résultat de clinique ou d’analyse sera disponible, vous pourrez l’ajouter ici. D’ici là, nous ne qualifierons pas ce cycle de positif ou de négatif.",
            "section_title": "Garder ce cycle en vue",
            "section_subtitle": "Enregistrez la prochaine étape réelle en attendant un résultat officiel.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Procédure d’IUI",
            "result_label": "Résultat IUI"
          },
          "uncertain": {
            "eyebrow": "Résultat de l’insémination",
            "title": "Reprenons un instant votre résultat IUI",
            "summary": "Ce résultat n’est pas assez clair pour qualifier le cycle de positif ou de négatif. Consultez l’enregistrement ou vérifiez la prochaine étape avec votre équipe de soins.",
            "section_title": "Clarifier ce qui a été enregistré",
            "section_subtitle": "Gardez le contexte de l’insémination ensemble pendant la vérification du résultat.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Procédure d’IUI",
            "result_label": "Résultat IUI"
          },
          "adverse": {
            "eyebrow": "Après votre résultat IUI",
            "title": "Avançons une étape à la fois",
            "summary": "Vous n’avez pas à prendre aujourd’hui une décision sur la suite du traitement. Quand vous serez prête, nous pouvons vous aider à garder les informations réunies et à préparer un échange avec votre équipe de soins.",
            "section_title": "Ce qui peut vous aider maintenant",
            "section_subtitle": "Gardez le contexte de l’insémination et votre prochaine conversation ensemble. En cas de symptômes urgents, contactez votre équipe de soins ou les services d’urgence locaux.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Procédure d’IUI",
            "result_label": "Résultat IUI"
          }
        },
        "oi": {
          "positive": {
            "eyebrow": "Résultat d’induction de l’ovulation",
            "title": "Un résultat positif est enregistré — prenez un instant",
            "summary": "Quels que soient vos sentiments, rien n’a besoin d’être décidé aujourd’hui. Quand vous serez prête, nous garderons ici ce résultat, les détails du traitement et vos questions pour votre prochain échange avec la clinique.",
            "section_title": "La suite",
            "section_subtitle": "Gardez le résultat relié au moment de l’ovulation et au plan de votre clinique.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Cycle d’induction de l’ovulation",
            "result_label": "Résultat OI"
          },
          "negative": {
            "eyebrow": "Résultat d’induction de l’ovulation",
            "summary": "Quels que soient vos sentiments, vous n’avez pas besoin de décider de la suite aujourd’hui. Quand vous serez prête, nous vous aiderons à comprendre ce cycle et à préparer vos questions pour votre prochaine conversation avec votre clinique.",
            "section_title": "La suite",
            "section_subtitle": "Avancez avec votre clinique sans présumer de ce que vous souhaitez faire ensuite.",
            "today_section_title": "Aujourd’hui",
            "procedure_label": "Cycle d’induction de l’ovulation",
            "result_label": "Résultat OI"
          },
          "unavailable": {
            "eyebrow": "Résultat d’induction de l’ovulation",
            "title": "Votre résultat d’induction de l’ovulation n’est pas encore disponible",
            "summary": "Quand votre résultat de clinique ou d’analyse sera disponible, vous pourrez l’ajouter ici. D’ici là, nous ne qualifierons pas ce cycle de positif ou de négatif.",
            "section_title": "Garder ce cycle en vue",
            "section_subtitle": "Enregistrez la prochaine étape réelle en attendant un résultat officiel.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Cycle d’induction de l’ovulation",
            "result_label": "Résultat OI"
          },
          "uncertain": {
            "eyebrow": "Résultat d’induction de l’ovulation",
            "title": "Reprenons un instant votre résultat d’induction de l’ovulation",
            "summary": "Ce résultat n’est pas assez clair pour qualifier le cycle de positif ou de négatif. Consultez l’enregistrement ou vérifiez la prochaine étape avec votre équipe de soins.",
            "section_title": "Clarifier ce qui a été enregistré",
            "section_subtitle": "Gardez le contexte de l’induction de l’ovulation ensemble pendant la vérification du résultat.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Cycle d’induction de l’ovulation",
            "result_label": "Résultat OI"
          },
          "adverse": {
            "eyebrow": "Après votre résultat d’induction de l’ovulation",
            "title": "Avançons une étape à la fois",
            "summary": "Vous n’avez pas à prendre aujourd’hui une décision sur la suite du traitement. Quand vous serez prête, nous pouvons vous aider à garder les informations réunies et à préparer un échange avec votre équipe de soins.",
            "section_title": "Ce qui peut vous aider maintenant",
            "section_subtitle": "Gardez le contexte de l’induction de l’ovulation et votre prochaine conversation ensemble. En cas de symptômes urgents, contactez votre équipe de soins ou les services d’urgence locaux.",
            "today_section_title": "Ce que vous pouvez faire maintenant",
            "procedure_label": "Cycle d’induction de l’ovulation",
            "result_label": "Résultat OI"
          }
        }
      },
      "concepts": {
        "egg_freezing_active": {
          "eyebrow": "Congélation d’ovocytes",
          "title": "Stimulation jour 7",
          "summary": "Les follicules grossissent et la sensation de pression ou de ballonnement peut augmenter aujourd’hui. Le monito de demain décidera si la ponction est avancée.",
          "hm1_label": "Progression",
          "hm1_value": "Jour 7",
          "hm1_note": "ponction estimée 24 mai",
          "hm2_label": "Follicules",
          "hm2_value": "12",
          "hm2_note": "lead 18 mm",
          "hm3_label": "Prochain",
          "hm3_value": "Monito",
          "hm3_note": "demain 8 h 20"
        },
        "embryo_freezing_active": {
          "eyebrow": "Congélation d’embryons",
          "title": "Stimulation jour 7",
          "summary": "12 follicules grossissent, le lead est à 18 mm et la ponction est actuellement estimée au 24 mai.",
          "hm1_label": "Progression",
          "hm1_value": "Jour 7",
          "hm1_note": "ponction estimée 24 mai",
          "hm2_label": "Follicules",
          "hm2_value": "12",
          "hm2_note": "lead 18 mm",
          "hm3_label": "Prochain",
          "hm3_value": "Monito",
          "hm3_note": "demain 8 h 20"
        },
        "ivf_active": {
          "eyebrow": "FIV",
          "title": "Stimulation avec plan embryonnaire prêt",
          "summary": "Suis les médicaments et rendez-vous d’aujourd’hui, la réponse ovarienne actuelle, l’état du sperme et la chronologie du labo qui démarre à la ponction.",
          "hm1_label": "Phase",
          "hm1_value": "Stim jour 7",
          "hm1_note": "ponction estimée 24 mai",
          "hm2_label": "Follicules",
          "hm2_value": "12",
          "hm2_note": "lead 18 mm",
          "hm3_label": "Labo",
          "hm3_value": "ICSI",
          "hm3_note": "PGT-A prévu"
        },
        "egg_freezing_postcycle": {
          "eyebrow": "Congélation d’ovocytes",
          "title": "11 ovocytes matures congelés",
          "summary": "Ton rapport de labo est arrivé. Vois ce qui a été congelé, où c’est stocké et si un autre cycle vaut la peine d’être envisagé.",
          "hm1_label": "Ponctionnés",
          "hm1_value": "14",
          "hm1_note": "depuis le liquide folliculaire",
          "hm2_label": "Matures",
          "hm2_value": "11",
          "hm2_note": "ovocytes MII",
          "hm3_label": "Congelés",
          "hm3_value": "11",
          "hm3_note": "stockés chez NY Cryo",
          "section_title": "Résultats",
          "section_subtitle": "L’entonnoir suit les étapes labo de la ponction au stockage.",
          "funnel_title": "Résultat de congélation d’ovocytes",
          "f1_label": "Ponctionnés",
          "f1_detail": "Ovocytes trouvés par l’embryologie.",
          "f2_label": "Matures",
          "f2_detail": "Ovocytes MII éligibles à la congélation.",
          "f3_label": "Congelés",
          "f3_detail": "Vitrifiés et stockés.",
          "inv_title": "Inventaire cryo",
          "inv_m1_label": "Installation de stockage",
          "inv_m1_value": "NY Cryo",
          "inv_m1_note": "actif",
          "inv_m2_label": "Renouvellement",
          "inv_m2_value": "18 mai 2027",
          "inv_m2_note": "650 $/an",
          "inv_m3_label": "Échantillons",
          "inv_m3_value": "3 paillettes",
          "inv_m3_note": "11 ovocytes au total",
          "dec_title": "Prochaine décision",
          "d1_title": "S’arrêter pour le moment",
          "d1_detail": "11 ovocytes matures sont stockés et le renouvellement annuel est actif.",
          "d1_status": "Raisonnable",
          "d2_title": "Envisager un autre cycle",
          "d2_detail": "Pour 2 enfants ou plus à venir, un autre cycle peut augmenter les chances.",
          "d2_status": "À discuter",
          "d3_title": "Téléverser le rapport de labo",
          "d3_detail": "Garde les documents d’embryologie et de stockage dans le coffre.",
          "d3_status": "Suivant"
        },
        "embryo_freezing_postcycle": {
          "eyebrow": "Congélation d’embryons",
          "title": "4 blastocystes congelés, PGT en attente",
          "summary": "Ta vue des résultats se concentre sur l’attrition, le statut des embryons, le PGT, le stockage et la prochaine décision.",
          "hm1_label": "Fécondés",
          "hm1_value": "8",
          "hm1_note": "2PN normaux",
          "hm2_label": "Blastos",
          "hm2_value": "4",
          "hm2_note": "congelés",
          "hm3_label": "PGT-A",
          "hm3_value": "En attente",
          "hm3_note": "estimé 7-10 jours",
          "section_title": "Résultats labo",
          "section_subtitle": "Chaque chiffre de l’entonnoir embryonnaire a un sens différent.",
          "funnel_title": "Entonnoir embryonnaire",
          "inv_title": "Inventaire embryons",
          "inv_m1_label": "Embryons congelés",
          "inv_m1_value": "4",
          "inv_m1_note": "2 jour 5, 2 jour 6",
          "inv_m2_label": "Biopsiés",
          "inv_m2_value": "4",
          "inv_m2_note": "PGT-A envoyé",
          "inv_m3_label": "Stockage",
          "inv_m3_value": "Actif",
          "inv_m3_note": "renouvellement mai 2027",
          "dec_title": "Ce qui se passe ensuite",
          "d1_title": "Attendre le PGT-A",
          "d1_detail": "Les résultats euploïdes mettent à jour la planification du transfert et les estimations familiales.",
          "d1_status": "En cours",
          "d2_title": "Planifier le transfert plus tard",
          "d2_detail": "Nécessite préparation utérine, protocole médicamenteux et timing du transfert.",
          "d2_status": "Suivant",
          "d3_title": "Envisager un autre cycle",
          "d3_detail": "Dépend du nombre d’euploïdes et de la taille familiale visée.",
          "d3_status": "À discuter"
        },
        "sperm_freezing_active": {
          "eyebrow": "Congélation de sperme",
          "title": "Recueil demain",
          "summary": "Ton rendez-vous, la fenêtre d’abstinence, les consignes de prélèvement, l’analyse attendue et l’objectif de stockage — tout est au même endroit.",
          "hm1_label": "Recueil",
          "hm1_value": "Demain",
          "hm1_note": "8 h 30",
          "hm2_label": "Abstinence",
          "hm2_value": "Jour 3",
          "hm2_note": "cible 2-5 jours",
          "hm3_label": "Objectif",
          "hm3_value": "6 paillettes",
          "hm3_note": "2 visites prévues",
          "section_title": "Jour du recueil",
          "section_subtitle": "Tout ce qu’il faut pour éviter un mauvais échantillon ou un rendez-vous manqué.",
          "today_title": "Programme",
          "tasks_title": "Avant d’y aller",
          "t1_title": "Apporter une pièce d’identité",
          "t1_detail": "Requis pour la vérification d’identité de l’échantillon.",
          "t1_due": "Demain",
          "t2_title": "Éviter la chaleur aujourd’hui",
          "t2_detail": "Pas de sauna, jacuzzi, fièvre ou maladie si possible.",
          "t2_due": "Aujourd’hui",
          "t3_title": "Signer le consentement de stockage",
          "t3_detail": "Le consentement et les choix de disposition doivent être complets avant le stockage longue durée.",
          "t3_due": "Avant la mise en banque",
          "metrics_title": "Aperçu du spermogramme de base",
          "metrics_subtitle": "Ces valeurs apparaissent une fois que le labo publie les résultats."
        },
        "sperm_freezing_wait": {
          "eyebrow": "Congélation de sperme",
          "title": "Échantillon en traitement",
          "summary": "L’échantillon a été prélevé aujourd’hui. Les résultats et la confirmation de stockage sont attendus dans les prochains jours.",
          "hm1_label": "Prélevé",
          "hm1_value": "Aujourd’hui",
          "hm1_note": "8 h 42",
          "hm2_label": "Résultats",
          "hm2_value": "2-5 jours",
          "hm2_note": "traitement labo",
          "hm3_label": "Stockage",
          "hm3_value": "En attente",
          "hm3_note": "même semaine",
          "section_title": "En attente des résultats",
          "section_subtitle": "Vois ce qui est en attente et ce que chaque résultat change.",
          "timeline_title": "Statut labo",
          "tl1_label": "Échantillon reçu",
          "tl1_detail": "Vérification d’identité et heure de prélèvement consignées.",
          "tl2_label": "Spermogramme",
          "tl2_detail": "Volume, concentration, mobilité, morphologie.",
          "tl3_label": "Estimation congélation/décongélation",
          "tl3_detail": "Sperme mobile utilisable attendu après décongélation.",
          "tl4_label": "Confirmation de stockage",
          "tl4_detail": "Paillettes, installation et date de renouvellement annuel publiées.",
          "funnel_title": "Entonnoir de stockage attendu",
          "dec_title": "Prochaine étape probable",
          "d1_title": "Refaire un recueil",
          "d1_detail": "Recommandé si le premier échantillon donne moins de 3 paillettes utilisables.",
          "d1_status": "Possible",
          "d2_title": "Démarrer un reset de 90 jours",
          "d2_detail": "Utile si le nombre, la mobilité ou la fragmentation de l’ADN est anormal.",
          "d2_status": "Dépend du résultat",
          "d3_title": "Stocker et arrêter",
          "d3_detail": "Raisonnable si l’objectif de paillettes est atteint et l’usage futur est FIV/ICSI.",
          "d3_status": "Possible"
        },
        "sperm_freezing_postcycle": {
          "eyebrow": "Congélation de sperme",
          "title": "6 paillettes stockées",
          "summary": "L’inventaire est en banque. Vois ce qui est stocké, ce que ça peut soutenir, et si un nouveau test ou un prélèvement supplémentaire aide.",
          "hm1_label": "Échantillons",
          "hm1_value": "2",
          "hm1_note": "en banque",
          "hm2_label": "Paillettes",
          "hm2_value": "6",
          "hm2_note": "stockées",
          "hm3_label": "Renouvellement",
          "hm3_value": "Mai 2027",
          "hm3_note": "420 $/an",
          "section_title": "Inventaire",
          "section_subtitle": "Vois quels parcours futurs les paillettes congelées pourront soutenir.",
          "funnel_title": "Entonnoir d’échantillons en banque",
          "metrics_title": "Estimation post-décongélation",
          "m1_label": "Mobiles totaux",
          "m1_value": "24 M",
          "m1_note": "sur l’ensemble des paillettes",
          "m2_label": "Adéquation IIU",
          "m2_value": "Limité",
          "m2_note": "peut nécessiter plus de paillettes",
          "m3_label": "Adéquation FIV/ICSI",
          "m3_value": "Solide",
          "m3_note": "moins de sperme nécessaire",
          "dec_title": "Re-tester ou vitrifier plus",
          "d1_title": "Pas de re-test urgent",
          "d1_detail": "L’inventaire convient à un usage FIV/ICSI de secours.",
          "d1_status": "OK",
          "d2_title": "Faire un recueil supplémentaire",
          "d2_detail": "Améliore la flexibilité IIU et la redondance.",
          "d2_status": "À envisager",
          "d3_title": "Reset de 90 jours",
          "d3_detail": "Utile si tu cherches à améliorer un futur échantillon frais.",
          "d3_status": "Optionnel"
        },
        "ivf_precycle": {
          "eyebrow": "Planification FIV",
          "title": "Prêt·e pour la FIV",
          "summary": "Coordonne ovocytes, sperme, utérus, plan labo, fit clinique et coûts avant le démarrage du protocole.",
          "hm1_label": "Prochain",
          "hm1_value": "Tests de base",
          "hm1_note": "AMH + AFC",
          "hm2_label": "Sperme",
          "hm2_value": "Nécessaire",
          "hm2_note": "spermogramme",
          "hm3_label": "Clinique",
          "hm3_value": "2 matchs",
          "hm3_note": "couverture en attente",
          "section_title": "État de préparation",
          "section_subtitle": "Vois ce qui est prêt avant qu’un démarrage de cycle puisse être confirmé.",
          "tasks_title": "Éléments ouverts",
          "t1_title": "Compléter l’historique médical",
          "t1_detail": "Le plan de cycle a besoin des médicaments, diagnostics, chirurgies et historique de grossesse.",
          "t1_owner": "Toi",
          "t1_due": "Aujourd’hui",
          "t2_title": "Ajouter le spermogramme",
          "t2_detail": "Requis pour choisir entre FIV classique, ICSI, sperme de donneur ou congélation de secours.",
          "t2_owner": "Partenaire/labo",
          "t2_due": "Cette semaine",
          "t3_title": "Vérifier la couverture",
          "t3_detail": "Sépare diagnostics, médicaments, labo FIV, ponction, transfert et stockage.",
          "t3_owner": "Toi",
          "t3_due": "Cette semaine",
          "metrics_title": "Aperçu de base",
          "m1_label": "AMH",
          "m1_value": "Manquant",
          "m1_note": "à commander ou téléverser",
          "m2_label": "AFC",
          "m2_value": "Manquant",
          "m2_note": "échographie",
          "m3_label": "Éval utérine",
          "m3_value": "Pas faite",
          "m3_note": "SIS/HSG si la clinique le requiert",
          "dec_title": "Parcours de soins",
          "d1_title": "2 cliniques correspondent à la localisation",
          "d1_detail": "Les deux proposent FIV + ICSI + PGT-A.",
          "d1_status": "Débloqué après couverture",
          "d2_title": "Qualité du labo d’embryologie",
          "d2_detail": "Vérifie les taux de blasto, le workflow PGT, le stockage et la coordination du transfert.",
          "d2_status": "Comparer",
          "d3_title": "Démarrer le cycle",
          "d3_detail": "Disponible une fois la clinique, le protocole et le démarrage du cycle confirmés.",
          "d3_status": "Verrouillé"
        },
        "ivf_positive": {
          "eyebrow": "Résultat",
          "title": "Beta positive",
          "summary": "Garde clair·e le prochain beta, les médicaments, les symptômes d’alerte et le timing de l’échographie.",
          "hm1_label": "Beta",
          "hm1_value": "186",
          "hm1_note": "Résultat positif",
          "hm2_label": "Répétition",
          "hm2_value": "48 heures",
          "hm2_note": "20 mai",
          "hm3_label": "Médicaments",
          "hm3_value": "Continuer",
          "hm3_note": "pas de changement",
          "section_title": "Prochaines étapes médicales",
          "section_subtitle": "Le suivi de grossesse précoce nécessite des tâches précises.",
          "trend_title": "Évolution beta",
          "tr1_label": "Beta 1",
          "tr1_value": "186",
          "tr1_note": "aujourd’hui",
          "tr2_label": "Beta 2",
          "tr2_value": "Programmé",
          "tr2_note": "48 heures",
          "tr3_label": "Échographie",
          "tr3_value": "Estimé 6-7 sem.",
          "tr3_note": "après évolution beta",
          "today_title": "Continuer aujourd’hui",
          "tasks_title": "Avant l’échographie",
          "t1_title": "Répéter le beta",
          "t1_detail": "Une seconde prise de sang confirme l’évolution.",
          "t1_owner": "Clinique",
          "t1_due": "20 mai",
          "t2_title": "Continuer la progestérone",
          "t2_detail": "N’arrête pas sauf si la clinique change le plan.",
          "t2_owner": "Toi",
          "t2_due": "Quotidien",
          "t3_title": "Dossier de transmission OB",
          "t3_detail": "Le résumé de grossesse et les dossiers FIV sont préparés après l’échographie.",
          "t3_owner": "Louise",
          "t3_due": "Plus tard"
        },
        "ivf_negative": {
          "eyebrow": "Résultat",
          "title": "Beta négative",
          "summary": "Prochaines étapes claires — consignes médicamenteuses, soutien, récap du cycle et options suivantes.",
          "hm1_label": "Beta",
          "hm1_value": "Négative",
          "hm1_note": "revu",
          "hm2_label": "Prochain",
          "hm2_value": "Consult.",
          "hm2_note": "23 mai",
          "hm3_label": "Embryons",
          "hm3_value": "2 stockés",
          "hm3_note": "disponibles",
          "section_title": "Ce qui se passe maintenant",
          "section_subtitle": "Soutien et consignes concrètes pour les jours à venir.",
          "tasks_title": "Aujourd’hui",
          "t1_title": "Plan médicamenteux",
          "t1_detail": "La clinique demande d’arrêter la progestérone ce soir.",
          "t1_owner": "Clinique",
          "t1_due": "Aujourd’hui",
          "t2_title": "À quoi s’attendre côté saignements",
          "t2_detail": "Les règles peuvent démarrer dans quelques jours ; appelle en cas de saignement abondant ou de douleur sévère.",
          "t2_owner": "Toi",
          "t2_due": "Cette semaine",
          "t3_title": "Consultation de suivi",
          "t3_detail": "Reviens sur la qualité des embryons, le protocole de transfert et les options de prochaine tentative.",
          "t3_owner": "Toi + clinique",
          "t3_due": "23 mai",
          "funnel_title": "Récap du cycle",
          "f1_label": "Ponctionnés",
          "f1_detail": "Ovocytes collectés.",
          "f2_label": "Matures",
          "f2_detail": "Ovocytes MII.",
          "f3_label": "Fécondés",
          "f3_detail": "Fécondation normale.",
          "f4_label": "Blastos",
          "f4_detail": "Blastocystes.",
          "f5_label": "Transféré",
          "f5_detail": "Cette tentative.",
          "dec_title": "Options pour la prochaine tentative",
          "d1_title": "Utiliser un embryon stocké",
          "d1_detail": "2 embryons restent congelés.",
          "d1_status": "Disponible",
          "d2_title": "Changer de protocole",
          "d2_detail": "Discute du timing de la progestérone, de la préparation de l’endomètre ou de la sélection d’embryon.",
          "d2_status": "Consult.",
          "d3_title": "Pause",
          "d3_detail": "Garde le stockage actif et décide plus tard.",
          "d3_status": "Disponible"
        },
        "iui_precycle": {
          "eyebrow": "Planification IIU",
          "title": "Préparer le timing de l’IIU",
          "summary": "Centre le timing de l’ovulation, l’état du sperme/des paillettes, le monitoring, le trigger, l’insémination et l’attente du beta.",
          "hm1_label": "Cycle",
          "hm1_value": "Pas démarré",
          "hm1_note": "appeler au jour 1",
          "hm2_label": "Source sperme",
          "hm2_value": "Partenaire",
          "hm2_note": "SA téléversé",
          "hm3_label": "Plan",
          "hm3_value": "IIU médicamenteuse",
          "hm3_note": "létrozole + déclencheur",
          "section_title": "État de préparation",
          "section_subtitle": "Tout ce qu’il faut avant le jour 1 du cycle.",
          "tasks_title": "Éléments ouverts",
          "t1_title": "Confirmer l’appel jour 1",
          "t1_detail": "La clinique ouvre le planning de monito quand les règles commencent.",
          "t1_owner": "Toi",
          "t1_due": "Jour 1 du cycle",
          "t2_title": "Plan d’échantillon partenaire",
          "t2_detail": "Abstinence de 2 à 5 jours avant le recueil.",
          "t2_owner": "Partenaire",
          "t2_due": "Jour de l’IIU",
          "t3_title": "Couverture du trigger",
          "t3_detail": "Ordonnance Ovidrel et vérification du bénéfice pharmacie.",
          "t3_owner": "Toi",
          "t3_due": "Cette semaine",
          "metrics_title": "Bases",
          "m1_label": "Spermogramme",
          "m1_value": "Normal",
          "m1_note": "téléversé",
          "m2_label": "Trompes",
          "m2_value": "HSG claire",
          "m2_note": "perméables des deux côtés",
          "m3_label": "Protocole",
          "m3_value": "Letrozole",
          "m3_note": "CD 3-7",
          "timeline_title": "Forme du cycle IIU",
          "tl1_label": "Jour 1 du cycle",
          "tl1_detail": "Appeler la clinique et programmer le baseline.",
          "tl2_label": "CD 3-7",
          "tl2_detail": "Letrozole.",
          "tl3_label": "CD 10-12",
          "tl3_detail": "Monito et trigger possible.",
          "tl4_label": "IIU",
          "tl4_detail": "Insémination 24 à 36 heures après le trigger.",
          "tl5_label": "Attente du beta",
          "tl5_detail": "Prise de sang environ 14 jours plus tard."
        },
        "iui_active": {
          "eyebrow": "IIU",
          "title": "Trigger ce soir",
          "summary": "Un tableau de bord du timing pour le follicule, l’endomètre, le trigger, l’échantillon de sperme, l’insémination et le début de l’attente.",
          "hm1_label": "Jour du cycle",
          "hm1_value": "CD 11",
          "hm1_note": "monito terminé",
          "hm2_label": "Lead follicule",
          "hm2_value": "20 mm",
          "hm2_note": "ovaire droit",
          "hm3_label": "IIU",
          "hm3_value": "36 heures",
          "hm3_note": "20 mai 9 h 30",
          "section_title": "Timing",
          "section_subtitle": "Les 36 prochaines heures sont mappées sur des actions précises.",
          "today_title": "Aujourd’hui et demain",
          "r1_title": "Trigger Ovidrel",
          "r1_detail": "Injection ce soir. L’IIU est programmée 36 heures plus tard.",
          "r2_title": "Échantillon partenaire",
          "r2_detail": "Recueil avant le lavage labo. Fenêtre d’abstinence — jour 3.",
          "r2_procedure": "Recueil de sperme",
          "r3_title": "Rendez-vous IIU",
          "r3_detail": "Arrive 15 minutes en avance.",
          "metrics_title": "Résultat du monito",
          "m1_label": "Lead follicule",
          "m1_value": "20 mm",
          "m1_note": "prêt",
          "m2_label": "Endomètre",
          "m2_value": "8,6 mm",
          "m2_note": "trilaminaire",
          "m3_label": "LH",
          "m3_value": "Bas",
          "m3_note": "trigger prévu",
          "tasks_title": "À ne pas manquer",
          "t1_title": "Trigger à 21 h",
          "t1_detail": "Le timing contrôle la fenêtre d’insémination.",
          "t1_owner": "Toi",
          "t1_due": "Ce soir",
          "t2_title": "Recueil partenaire",
          "t2_detail": "L’échantillon doit arriver avant la limite de lavage labo.",
          "t2_owner": "Partenaire",
          "t2_due": "20 mai",
          "t3_title": "Démarrer le plan d’attente",
          "t3_detail": "La date du beta et les médicaments apparaissent après que l’IIU est consignée.",
          "t3_owner": "Louise",
          "t3_due": "Après l’IIU"
        },
        "iui_wait": {
          "eyebrow": "Attente IIU",
          "title": "5 jours après l’IIU",
          "summary": "Les nuances du trigger, l’incertitude des symptômes, les médicaments et ce qui se passe le jour du test.",
          "hm1_label": "IIU",
          "hm1_value": "Il y a 5 jours",
          "hm1_note": "20 mai",
          "hm2_label": "Test",
          "hm2_value": "31 mai",
          "hm2_note": "beta clinique",
          "hm3_label": "Déclencheur",
          "hm3_value": "Peut persister",
          "hm3_note": "éviter les tests précoces",
          "section_title": "Pendant l’attente",
          "section_subtitle": "Soutien pendant l’attente, avec un timing spécifique à l’IIU.",
          "today_title": "Aujourd’hui",
          "dec_title": "Timing du test maison",
          "d1_title": "Trop tôt",
          "d1_detail": "L’hCG du trigger peut créer de faux positifs peu après l’injection.",
          "d1_status": "Ne pas s’y fier",
          "d2_title": "Beta clinique",
          "d2_detail": "La prise de sang est programmée le 31 mai.",
          "d2_status": "Utilise ça",
          "d3_title": "Début des règles",
          "d3_detail": "Préviens la clinique ; ils peuvent vouloir consigner des instructions.",
          "d3_status": "Planifier"
        },
        "amab_family_building_precycle": {
          "eyebrow": "Construction familiale",
          "title": "Comparer sperme, donneur·euse, gestatrice et parcours embryon",
          "summary": "Coordonne les options de sperme des deux partenaires plus le don d’ovocytes, la gestatrice, la création d’embryons, le juridique et les coûts.",
          "hm1_label": "Partenaire A",
          "hm1_value": "SA prêt",
          "hm1_note": "46 M/mL",
          "hm2_label": "Partenaire B",
          "hm2_value": "Test à faire",
          "hm2_note": "cette semaine",
          "hm3_label": "Donneur/gestatrice",
          "hm3_value": "Non sélectionné·e",
          "hm3_note": "matching ouvert",
          "section_title": "Construire le parcours",
          "section_subtitle": "Garde les tests de sperme, le don d’ovocytes, la gestatrice, le juridique et les coûts au même endroit.",
          "metrics_title": "Comparer les entrées sperme",
          "m1_label": "Mobilité Partenaire A",
          "m1_value": "52 %",
          "m1_note": "banque de secours",
          "m2_label": "Test Partenaire B",
          "m2_value": "Manquant",
          "m2_note": "commander un spermogramme",
          "m3_label": "Plan séparé",
          "m3_value": "Non décidé",
          "m3_note": "embryons A/B possibles",
          "tasks_title": "Tâches source et juridiques",
          "t1_title": "Présélectionner des donneuses d’ovocytes",
          "t1_detail": "3 donneuses correspondent à l’âge, au statut de porteuse et à la compatibilité agence.",
          "t1_owner": "Toi",
          "t1_due": "Cette semaine",
          "t2_title": "Choisir la voie gestatrice",
          "t2_detail": "Matching par agence vs gestatrice connue.",
          "t2_owner": "Toi",
          "t2_due": "Suivant",
          "t3_title": "Intake juridique",
          "t3_detail": "Checklist parentalité et accord donneuse/gestatrice.",
          "t3_owner": "Juridique",
          "t3_due": "Après présélection",
          "timeline_title": "Séquence de construction familiale",
          "tl1_label": "Maintenant",
          "tl1_detail": "Tester et éventuellement congeler le sperme des deux partenaires.",
          "tl2_label": "Suivant",
          "tl2_detail": "Choisir la source d’ovocytes donneuse et la voie gestatrice.",
          "tl3_label": "Ensuite",
          "tl3_detail": "Créer des embryons avec un plan de sperme séparé si souhaité.",
          "tl4_label": "Après PGT/stockage",
          "tl4_detail": "Préparer le transfert chez la gestatrice."
        },
        "partner_precycle": {
          "eyebrow": "Vue partenaire",
          "title": "Tes tâches avant le démarrage du traitement",
          "summary": "Vois ce qui t’appartient et ce qui est partagé du plan de traitement.",
          "hm1_label": "Tes tâches",
          "hm1_value": "2 ouvertes",
          "hm1_note": "spermogramme + couverture",
          "hm2_label": "Plan partagé",
          "hm2_value": "Pré-cycle",
          "hm2_note": "présélection clinique",
          "hm3_label": "Prochain",
          "hm3_value": "Spermogramme",
          "hm3_note": "cette semaine",
          "section_title": "À ta charge",
          "section_subtitle": "Concentre-toi sur tes tâches tout en gardant le plan partagé visible.",
          "tasks_title": "Tes tâches",
          "t1_title": "Réserver le spermogramme",
          "t1_detail": "Nécessaire avant que le plan sperme FIV/IIU soit final.",
          "t1_owner": "Toi",
          "t1_due": "Cette semaine",
          "t2_title": "Ajouter les détails de couverture",
          "t2_detail": "Les avantages employeur ou l’assurance peuvent affecter l’estimation partagée.",
          "t2_owner": "Toi",
          "t2_due": "Cette semaine",
          "t3_title": "Lire le soutien jour de ponction",
          "t3_detail": "Trajet, repas, médicaments et symptômes à surveiller.",
          "t3_owner": "Toi",
          "t3_due": "Plus tard",
          "timeline_title": "Progression partagée",
          "tl1_label": "Historique médical",
          "tl1_detail": "Le·la patient·e principal·e a complété l’historique de base.",
          "tl2_label": "Présélection clinique",
          "tl2_detail": "2 cliniques débloquées après le statut de couverture.",
          "tl3_label": "Démarrage du cycle",
          "tl3_detail": "Pas encore programmé."
        },
        "partner_active": {
          "eyebrow": "Vue partenaire",
          "title": "Ce que tu peux faire aujourd’hui",
          "summary": "Actions à la charge du partenaire, rendez-vous partagés et soutien pratique pour aujourd’hui.",
          "hm1_label": "Aujourd’hui",
          "hm1_value": "Échantillon de secours",
          "hm1_note": "confirmer avant 17 h",
          "hm2_label": "Partagé",
          "hm2_value": "Monito demain",
          "hm2_note": "8 h 20",
          "hm3_label": "Soutien",
          "hm3_value": "Ballonnement probable",
          "hm3_note": "stimulation jour 7",
          "section_title": "Aujourd’hui",
          "section_subtitle": "Le·la partenaire peut agir sans lire tout le dossier du·de la patient·e principal·e.",
          "tasks_title": "Tes actions",
          "t1_title": "Confirmer le plan d’échantillon de secours",
          "t1_detail": "Dis à la clinique si l’échantillon frais ou la paillette congelée est prioritaire.",
          "t1_owner": "Toi",
          "t1_due": "Aujourd’hui",
          "t2_title": "Préparer le plan de récupération",
          "t2_detail": "La ponction peut nécessiter un trajet retour avec sédation.",
          "t2_owner": "Toi",
          "t2_due": "Avant la ponction",
          "t3_title": "Soutenir la routine de médicaments",
          "t3_detail": "Aide à dégager du temps pour les injections du soir.",
          "t3_owner": "Toi",
          "t3_due": "Ce soir",
          "today_title": "Planning partagé",
          "dec_title": "Comment soutenir aujourd’hui",
          "d1_title": "Pratique",
          "d1_detail": "Hydratation, repas légers, planification du trajet et rappels de médicaments.",
          "d1_status": "Utile",
          "d2_title": "Émotionnel",
          "d2_detail": "Demande avant de chercher à résoudre ; l’inconfort de stimulation peut varier.",
          "d2_status": "Utile"
        },
        "egg_donor": {
          "eyebrow": "Donneuse d’ovocytes",
          "title": "Dépistage en cours",
          "summary": "Opérations agence et clinique — candidature, dépistage, juridique, match, prêt·e pour le cycle, compensation et documents.",
          "hm1_label": "Statut",
          "hm1_value": "Dépistage",
          "hm1_note": "2 tâches aujourd’hui",
          "hm2_label": "Match",
          "hm2_value": "Profil en ligne",
          "hm2_note": "revue agence",
          "hm3_label": "Compensation",
          "hm3_value": "8 000 $",
          "hm3_note": "en attente de match",
          "section_title": "Dépistage",
          "section_subtitle": "Suis les tâches de dépistage du jour, les rendez-vous et les prochains documents.",
          "today_title": "Aujourd’hui",
          "tasks_title": "Exigences ouvertes",
          "t1_title": "Téléverser les labos précédents",
          "t1_detail": "L’agence a besoin des dossiers avant la clairance médicale.",
          "t1_owner": "Toi",
          "t1_due": "Aujourd’hui",
          "t2_title": "Consultation psy",
          "t2_detail": "Rendez-vous de dépistage virtuel.",
          "t2_owner": "Agence",
          "t2_due": "22 mai",
          "t3_title": "Dossier juridique",
          "t3_detail": "Se débloque après le match avec parent·e d’intention.",
          "t3_owner": "Juridique",
          "t3_due": "Après le match",
          "timeline_title": "Parcours donneuse",
          "tl1_label": "Candidature",
          "tl1_detail": "Profil accepté par l’agence.",
          "tl2_label": "Dépistage",
          "tl2_detail": "Labos, psy, dépistage génétique de porteuse.",
          "tl3_label": "Match",
          "tl3_detail": "Les parent·e·s d’intention sélectionnent le profil.",
          "tl4_label": "Cycle",
          "tl4_detail": "Médicaments, monito, trigger, ponction.",
          "tl5_label": "Paiement",
          "tl5_detail": "Étapes de compensation après la ponction."
        },
        "sperm_donor": {
          "eyebrow": "Donneur de sperme",
          "title": "Visite de don cette semaine",
          "summary": "Suis l’éligibilité, le planning de recueil, les fenêtres d’abstinence, le statut des échantillons, la quarantaine/re-test et la compensation.",
          "hm1_label": "Statut",
          "hm1_value": "Approuvé",
          "hm1_note": "donneur actif",
          "hm2_label": "Échantillons",
          "hm2_value": "3 acceptés",
          "hm2_note": "1 en attente",
          "hm3_label": "Prochaine visite",
          "hm3_value": "Vendredi",
          "hm3_note": "9 h 00",
          "section_title": "Opérations de don",
          "section_subtitle": "Vois la visite de don, le statut des échantillons et les exigences du programme.",
          "today_title": "Planning de don",
          "metrics_title": "Statut des échantillons",
          "m1_label": "Acceptés",
          "m1_value": "3",
          "m1_note": "éligibles à la quarantaine",
          "m2_label": "En attente",
          "m2_value": "1",
          "m2_note": "revue labo",
          "m3_label": "Refusés",
          "m3_value": "0",
          "m3_note": "ce mois-ci",
          "m4_label": "Compensation",
          "m4_value": "350 $",
          "m4_note": "prochain versement",
          "tasks_title": "Exigences du programme",
          "t1_title": "Re-tester les labos infectieux",
          "t1_detail": "Requis avant que les échantillons soient libérés de quarantaine.",
          "t1_owner": "Toi",
          "t1_due": "Dans 6 mois",
          "t2_title": "Maintenir la fenêtre d’abstinence",
          "t2_detail": "Cible 2 à 5 jours avant la visite de vendredi.",
          "t2_owner": "Toi",
          "t2_due": "Vendredi"
        },
        "carrier": {
          "eyebrow": "Gestatrice",
          "title": "Candidature et dépistage",
          "summary": "Coordonne l’intake agence, les dossiers médicaux, le dépistage, le juridique, la préparation au transfert et la compensation.",
          "hm1_label": "Statut",
          "hm1_value": "Candidature",
          "hm1_note": "dossiers à fournir",
          "hm2_label": "Agence",
          "hm2_value": "2 matchs",
          "hm2_note": "en revue",
          "hm3_label": "Prochain",
          "hm3_value": "Dossiers OB",
          "hm3_note": "à téléverser",
          "section_title": "Préparation gestatrice",
          "section_subtitle": "Les responsabilités agence, juridique et médicales sont séparées.",
          "tasks_title": "Exigences ouvertes",
          "t1_title": "Téléverser les dossiers OB",
          "t1_detail": "Historique de grossesse et d’accouchement nécessaire pour la revue médicale.",
          "t1_owner": "Toi",
          "t1_due": "Aujourd’hui",
          "t2_title": "Revue de la police d’assurance",
          "t2_detail": "Revue de couverture grossesse de gestatrice en cours.",
          "t2_owner": "Agence",
          "t2_due": "Cette semaine",
          "t3_title": "Consultation psy",
          "t3_detail": "Programmée après pré-clairance médicale.",
          "t3_owner": "Agence",
          "t3_due": "Suivant",
          "timeline_title": "Parcours gestatrice",
          "tl1_label": "Candidature",
          "tl1_detail": "Profil et éligibilité initiale.",
          "tl2_label": "Dépistage",
          "tl2_detail": "Médical, psy, assurance et contexte du foyer.",
          "tl3_label": "Match et juridique",
          "tl3_detail": "Match parent·e d’intention et contrat.",
          "tl4_label": "Préparation transfert",
          "tl4_detail": "Embryon, médicaments, vérifications endomètre, transfert."
        },
        "intended_parent": {
          "eyebrow": "Parent·e d’intention",
          "title": "Donneur·euse, gestatrice, embryons, juridique et coûts",
          "summary": "Coordonne le travail agence, le matching des sources, la prêt embryonnaire, les étapes juridiques et l’argent.",
          "hm1_label": "Donneuse d’ovocytes",
          "hm1_value": "3 présélectionnées",
          "hm1_note": "statut de porteuse vérifié",
          "hm2_label": "Gestatrice",
          "hm2_value": "Recherche ouverte",
          "hm2_note": "2 appels agence",
          "hm3_label": "Séquestre",
          "hm3_value": "Pas démarré",
          "hm3_note": "juridique d’abord",
          "section_title": "Plan opérationnel",
          "section_subtitle": "Garde le travail agence, clinique, labo et juridique en une seule vue.",
          "tasks_title": "Tâches ouvertes",
          "t1_title": "Choisir la présélection de donneuse",
          "t1_detail": "3 candidates correspondent au profil, à la disponibilité et au dépistage de porteuse.",
          "t1_owner": "Toi",
          "t1_due": "Cette semaine",
          "t2_title": "Intake agence gestatrice",
          "t2_detail": "Deux appels programmés ; un requiert d’abord un plan embryon.",
          "t2_owner": "Toi",
          "t2_due": "Cette semaine",
          "t3_title": "Intake juridique",
          "t3_detail": "Parentalité, donneuse et contrats gestatrice.",
          "t3_owner": "Juridique",
          "t3_due": "Après choix donneuse/gestatrice",
          "metrics_title": "Aperçu des coûts",
          "m1_label": "Acomptes agence",
          "m1_value": "18-25 k$",
          "m1_note": "fourchette",
          "m2_label": "Cycle donneuse",
          "m2_value": "35-55 k$",
          "m2_note": "estimé",
          "m3_label": "Séquestre gestatrice",
          "m3_value": "Pas ouvert",
          "m3_note": "juridique d’abord",
          "timeline_title": "Parcours vers le transfert",
          "tl1_label": "Maintenant",
          "tl1_detail": "Sélectionner la voie donneuse et gestatrice.",
          "tl2_label": "Suivant",
          "tl2_detail": "Créer des embryons ou confirmer l’inventaire d’embryons.",
          "tl3_label": "Juridique",
          "tl3_detail": "Contrats et séquestre.",
          "tl4_label": "Transfert",
          "tl4_detail": "Clairance médicale gestatrice et cycle de transfert."
        }
      },
      "detailed": {
        "egg_freezing_postcycle": {
          "s1_title": "Ce que le résultat veut dire",
          "s1_subtitle": "Traduis le rapport de labo en contexte de stockage et de planification familiale.",
          "quality_title": "Qualité du résultat",
          "q1_label": "Taux de maturité",
          "q1_value": "79 %",
          "q1_note": "11 sur 14 ponctionnés",
          "q2_label": "Méthode de congélation",
          "q2_value": "Vitrifié",
          "q2_note": "refroidissement rapide",
          "q3_label": "Survie à la décongélation",
          "q3_value": "Non connu",
          "q3_note": "estimé plus tard par la clinique/labo",
          "funnel_title": "Estimation d’usage futur",
          "f1_label": "Ovocytes congelés",
          "f1_detail": "Stockés maintenant.",
          "f2_label": "Survivent à la décongélation",
          "f2_detail": "Beaucoup, mais pas tous, sont attendus à survivre à la décongélation.",
          "f3_label": "Fécondent",
          "f3_detail": "Si utilisés avec du sperme plus tard, tous les ovocytes ne fécondent pas.",
          "f4_label": "Blastocystes",
          "f4_detail": "Les embryons doivent continuer à se développer avant transfert/test.",
          "f5_label": "Estimation de naissance vivante",
          "f5_detail": "L’âge à la congélation et les facteurs sperme/embryon changent ça.",
          "s2_title": "Opérations de stockage",
          "s2_subtitle": "Garde l’inventaire cryo visible et utilisable.",
          "tasks_title": "Maintenir le stockage à jour",
          "t1_title": "Confirmer le contact de l’installation",
          "t1_detail": "NY Cryo est listé comme installation de stockage active.",
          "t1_owner": "Toi",
          "t1_due": "Cette semaine",
          "t2_title": "Mettre un rappel de renouvellement",
          "t2_detail": "Renouvellement annuel à faire avant le 18 mai 2027.",
          "t2_owner": "Louise",
          "t2_due": "Terminé",
          "t3_title": "Téléverser le rapport final",
          "t3_detail": "Le rapport d’embryologie et le certificat de stockage doivent être dans les documents.",
          "t3_owner": "Toi",
          "t3_due": "Optionnel"
        },
        "embryo_freezing_postcycle": {
          "section_title": "PGT et stockage",
          "section_subtitle": "Revois l’inventaire d’embryons, le timing PGT, le stockage et les prochaines décisions.",
          "metrics_title": "Statut PGT-A",
          "m1_label": "Biopsiés",
          "m1_value": "4",
          "m1_note": "tous les blastos congelés",
          "m2_label": "ETA résultat",
          "m2_value": "27 mai",
          "m2_note": "estimation labo",
          "m3_label": "Transférables",
          "m3_value": "En attente",
          "m3_note": "nécessite PGT-A ou revue clinique",
          "tasks_title": "Tâches d’inventaire",
          "t1_title": "Téléverser le rapport PGT",
          "t1_detail": "Le rapport attache les résultats euploïde/aneuploïde/mosaïque à chaque embryon.",
          "t1_owner": "Toi",
          "t1_due": "Quand prêt",
          "t2_title": "Confirmer les étiquettes d’embryons",
          "t2_detail": "Faire correspondre les identifiants labo à l’inventaire de stockage.",
          "t2_owner": "Labo",
          "t2_due": "Cette semaine",
          "t3_title": "Consultation planification de transfert",
          "t3_detail": "Réserver après les résultats PGT-A si tu utilises les embryons bientôt.",
          "t3_owner": "Toi",
          "t3_due": "Après les résultats"
        },
        "sperm_freezing_active": {
          "s1_title": "Qualité du recueil",
          "s1_subtitle": "Concentre-toi sur les facteurs de recueil que tu peux contrôler.",
          "checks_title": "Vérifications pré-recueil",
          "c1_label": "Abstinence",
          "c1_value": "3 jours",
          "c1_note": "dans la cible 2-5 jours",
          "c2_label": "Fièvre/chaleur",
          "c2_value": "Aucune",
          "c2_note": "10 derniers jours",
          "c3_label": "Hydratation",
          "c3_value": "Consignée",
          "c3_note": "aujourd’hui",
          "c4_label": "Pièce d’identité + consentement",
          "c4_value": "Prêt",
          "c4_note": "requis",
          "tasks_title": "Consignes de recueil",
          "t1_title": "Arriver avec une pièce d’identité",
          "t1_detail": "La vérification d’identité est requise avant que l’échantillon soit accepté.",
          "t1_owner": "Toi",
          "t1_due": "8 h 30",
          "t2_title": "Demander l’estimation post-décongélation",
          "t2_detail": "Ça détermine si l’inventaire convient mieux à l’IIU ou à la FIV/ICSI.",
          "t2_owner": "Toi",
          "t2_due": "À la visite",
          "t3_title": "Choisir les paramètres de disposition",
          "t3_detail": "Stockage, usage futur, destruction et choix en cas de décès/incapacité doivent être documentés.",
          "t3_owner": "Toi",
          "t3_due": "Avant le stockage",
          "s2_title": "Objectif de stockage",
          "s2_subtitle": "Vois si cette visite suffit ou si un autre recueil est utile.",
          "funnel_title": "Paillettes cibles",
          "funnel_subtitle": "Un second recueil est déjà programmé si le premier échantillon produit moins de paillettes utilisables que prévu."
        },
        "sperm_freezing_wait": {
          "section_title": "Ce que le labo vérifie",
          "section_subtitle": "Vois pourquoi les résultats prennent du temps et ce que chaque métrique change.",
          "metrics_title": "Métriques spermogramme en attente",
          "m1_label": "Volume",
          "m1_value": "En attente",
          "m1_note": "quantité de l’échantillon",
          "m2_label": "Concentration",
          "m2_value": "En attente",
          "m2_note": "sperme par mL",
          "m3_label": "Mobilité",
          "m3_value": "En attente",
          "m3_note": "sperme mobile",
          "m4_label": "Morphologie",
          "m4_value": "En attente",
          "m4_note": "formes strictes",
          "dec_title": "Branches de résultats",
          "d1_title": "Objectif atteint",
          "d1_detail": "La confirmation de stockage devient la tâche principale.",
          "d1_status": "Stocker",
          "d2_title": "Nombre de paillettes limite",
          "d2_detail": "Un autre recueil améliore la redondance.",
          "d2_status": "Recueillir à nouveau",
          "d3_title": "Analyse anormale",
          "d3_detail": "Un reset de 72 à 90 jours, un spermogramme répété et une revue urologie deviennent utiles.",
          "d3_status": "Optimiser"
        },
        "sperm_freezing_postcycle": {
          "section_title": "Utiliser l’inventaire plus tard",
          "section_subtitle": "Vois ce que les paillettes congelées pourront soutenir.",
          "metrics_title": "Adéquation par usage",
          "m1_label": "IIU",
          "m1_value": "Peut-être",
          "m1_note": "dépend du nombre de mobiles post-décongélation par paillette",
          "m2_label": "FIV",
          "m2_value": "Solide",
          "m2_note": "moins de sperme nécessaire",
          "m3_label": "ICSI",
          "m3_value": "Optimal",
          "m3_note": "un seul sperme par ovocyte",
          "m4_label": "Secours",
          "m4_value": "Prêt",
          "m4_note": "pour le jour de ponction FIV",
          "tasks_title": "Maintenance du stockage",
          "t1_title": "Sauvegarder le certificat de stockage",
          "t1_detail": "Installation, nombre de paillettes et date de renouvellement sont stockés dans les documents.",
          "t1_owner": "Louise",
          "t1_due": "Terminé",
          "t2_title": "Paiement de renouvellement",
          "t2_detail": "Frais de stockage annuels dus en mai 2027.",
          "t2_owner": "Toi",
          "t2_due": "Mai 2027",
          "t3_title": "Re-tester si tu essaies bientôt",
          "t3_detail": "Refaire un spermogramme si tu prévois un usage de sperme frais.",
          "t3_owner": "Toi",
          "t3_due": "Optionnel"
        },
        "ivf_precycle": {
          "s1_title": "Préparation requise",
          "s1_subtitle": "Sépare les données de base, la source sperme, la préparation utérine et le fit clinique.",
          "tasks_title": "Avant protocole",
          "t1_title": "Historique médical",
          "t1_detail": "Médicaments, grossesses antérieures, chirurgies, diagnostics, allergies et pertes.",
          "t1_owner": "Toi",
          "t1_due": "Aujourd’hui",
          "t2_title": "Réserve ovarienne",
          "t2_detail": "AMH plus AFC donnent à la clinique un point de départ pour le dosage de stimulation.",
          "t2_owner": "Toi/clinique",
          "t2_due": "Cette semaine",
          "t3_title": "Plan sperme",
          "t3_detail": "Spermogramme, sperme de donneur ou secours congelé décide des détails FIV vs ICSI.",
          "t3_owner": "Partenaire/labo",
          "t3_due": "Cette semaine",
          "t4_title": "Évaluation utérine",
          "t4_detail": "HSG, SIS ou hystéroscopie si la clinique a besoin d’une vérification cavité/trompes.",
          "t4_owner": "Clinique",
          "t4_due": "Avant le transfert",
          "dec_title": "Présélection clinique",
          "d1_title": "RMA Brooklyn",
          "d1_detail": "Labo FIV solide, workflow PGT-A, estimation in-network en attente.",
          "d1_status": "91 % fit",
          "d2_title": "NYU Langone Fertility",
          "d2_detail": "Soins hospitaliers, reconnu pour les historiques complexes, consultation dans 12 jours.",
          "d2_status": "88 % fit",
          "d3_title": "Spring Tribeca",
          "d3_detail": "Consultation rapide, forfait self-pay transparent, stockage sur place.",
          "d3_status": "84 % fit",
          "s2_title": "Coût et couverture",
          "s2_subtitle": "Vois ce qui change l’estimation reste à charge.",
          "estimate_title": "Entrées d’estimation",
          "e1_label": "Diagnostics",
          "e1_value": "0-850 $",
          "e1_note": "dépend de la couverture",
          "e2_label": "Médicaments",
          "e2_value": "3-7 k$",
          "e2_note": "dépend de la dose",
          "e3_label": "FIV + labo",
          "e3_value": "12-22 k$",
          "e3_note": "ICSI/PGT/stockage séparés",
          "e4_label": "Couverture",
          "e4_value": "Inconnue",
          "e4_note": "vérifier les avantages"
        },
        "ivf_positive": {
          "section_title": "Suivi précoce",
          "section_subtitle": "Reste médicalement précis·e jusqu’à ce que la grossesse soit confirmée par l’évolution et l’échographie.",
          "timeline_title": "Prochains jalons",
          "tl1_label": "Aujourd’hui",
          "tl1_detail": "Beta positive revue ; continuer les médicaments.",
          "tl2_label": "48 heures",
          "tl2_detail": "Beta répété pour vérifier l’évolution.",
          "tl3_label": "5-6 semaines",
          "tl3_detail": "Échographie précoce confirme la localisation et le sac gestationnel.",
          "tl4_label": "6-7 semaines",
          "tl4_detail": "Échographie de battements de cœur si l’évolution et le premier scan sont rassurants.",
          "tl5_label": "Transmission OB",
          "tl5_detail": "Le résumé de transfert et les dates FIV vont à l’OB après libération de la clinique fertilité.",
          "tasks_title": "Appelle maintenant si",
          "t1_title": "Douleur sévère d’un côté",
          "t1_detail": "Surtout avec vertiges ou douleur d’épaule.",
          "t1_owner": "Toi",
          "t1_due": "À tout moment",
          "t2_title": "Saignements abondants",
          "t2_detail": "Si tu remplis une serviette ou si tu passes de gros caillots.",
          "t2_owner": "Toi",
          "t2_due": "À tout moment",
          "t3_title": "Problème de médicament",
          "t3_detail": "Progestérone manquée ou problème de renouvellement.",
          "t3_owner": "Toi",
          "t3_due": "Aujourd’hui"
        },
        "ivf_negative": {
          "section_title": "Après un résultat négatif",
          "section_subtitle": "Garde les consignes de soins et les données du cycle prêtes pour la consultation.",
          "metrics_title": "Options restantes",
          "m1_label": "Embryons stockés",
          "m1_value": "2",
          "m1_note": "les deux congelés",
          "m2_label": "PGT-A",
          "m2_value": "1 euploïde",
          "m2_note": "1 non testé",
          "m3_label": "Suivi",
          "m3_value": "23 mai",
          "m3_note": "virtuel",
          "m4_label": "Médicaments",
          "m4_value": "Arrêter ce soir",
          "m4_note": "selon la clinique",
          "tasks_title": "Préparer la consultation",
          "t1_title": "Sauvegarder les questions",
          "t1_detail": "Qualité d’embryon, timing de la progestérone, préparation de l’endomètre et changements de protocole.",
          "t1_owner": "Toi",
          "t1_due": "Avant la consultation",
          "t2_title": "Téléverser la note de résultat",
          "t2_detail": "Le résultat beta et les consignes d’arrêt s’attachent à ce cycle.",
          "t2_owner": "Louise",
          "t2_due": "Terminé",
          "t3_title": "Choisir le rythme",
          "t3_detail": "Utiliser un embryon stocké, refaire une ponction ou faire une pause.",
          "t3_owner": "Toi",
          "t3_due": "Après la consultation"
        },
        "iui_precycle": {
          "section_title": "Préparation IIU",
          "section_subtitle": "Concentre-toi sur le timing, les trompes, le sperme/les paillettes, le plan d’ovulation, le trigger et la couverture.",
          "metrics_title": "Entrées",
          "m1_label": "Vérification trompes",
          "m1_value": "Claire",
          "m1_note": "HSG téléversée",
          "m2_label": "Sperme",
          "m2_value": "Normal",
          "m2_note": "SA partenaire",
          "m3_label": "Protocole",
          "m3_value": "Letrozole",
          "m3_note": "CD 3-7",
          "m4_label": "Déclencheur",
          "m4_value": "Ovidrel",
          "m4_note": "couverture en attente",
          "dec_title": "Présélection de soins",
          "d1_title": "Clinique avec IIU le week-end",
          "d1_detail": "Utile parce que le timing de l’ovulation peut tomber un week-end.",
          "d1_status": "Meilleur fit",
          "d2_title": "Cabinet OB connu",
          "d2_detail": "Coût plus bas mais moins de flexibilité de monito.",
          "d2_status": "Comparer",
          "d3_title": "Monito à la maison + IIU clinique",
          "d3_detail": "Marche si le trigger et le timing labo sont fiables.",
          "d3_status": "Optionnel"
        },
        "iui_active": {
          "section_title": "Trigger et insémination",
          "section_subtitle": "Transforme une fenêtre de timing étroite en rendez-vous précis et responsabilités claires.",
          "metrics_title": "Plan sperme",
          "m1_label": "Source",
          "m1_value": "Partenaire",
          "m1_note": "recueil frais",
          "m2_label": "Abstinence",
          "m2_value": "3 jours",
          "m2_note": "dans la cible",
          "m3_label": "Lavage",
          "m3_value": "8 h 15",
          "m3_note": "rendez-vous labo",
          "m4_label": "IIU",
          "m4_value": "9 h 30",
          "m4_note": "même clinique",
          "timeline_title": "Prochaines 48 heures",
          "tl1_label": "Ce soir 21 h",
          "tl1_detail": "Injection trigger.",
          "tl2_label": "Demain",
          "tl2_detail": "Pas de tests d’ovulation supplémentaires sauf si la clinique demande.",
          "tl3_label": "20 mai 8 h",
          "tl3_detail": "Échantillon partenaire et lavage labo.",
          "tl4_label": "20 mai 9 h 30",
          "tl4_detail": "Procédure IIU.",
          "tl5_label": "Après l’IIU",
          "tl5_detail": "Consignes des deux semaines d’attente et date du beta."
        },
        "iui_wait": {
          "section_title": "Plan de résultat IIU",
          "section_subtitle": "Gère la confusion liée au trigger et garde le timing de test clair.",
          "metrics_title": "Fenêtre de test",
          "m1_label": "Injection trigger",
          "m1_value": "18 mai",
          "m1_note": "peut affecter les tests maison",
          "m2_label": "Beta fiable",
          "m2_value": "31 mai",
          "m2_note": "prise de sang",
          "m3_label": "Plan règles",
          "m3_value": "Prévenir la clinique",
          "m3_note": "si saignements démarrent",
          "tasks_title": "Pendant l’attente",
          "t1_title": "Continuer les médicaments",
          "t1_detail": "Progestérone ou soutien lutéal si prescrit.",
          "t1_owner": "Toi",
          "t1_due": "Quotidien",
          "t2_title": "Éviter les conclusions précoces",
          "t2_detail": "L’hCG du trigger peut causer des faux positifs avant de se dissiper.",
          "t2_owner": "Toi",
          "t2_due": "Cette semaine",
          "t3_title": "Planifier la prochaine branche de cycle",
          "t3_detail": "Si négatif, la clinique peut redémarrer le baseline avec les prochaines règles.",
          "t3_owner": "Clinique",
          "t3_due": "Après le beta"
        },
        "amab_family_building_precycle": {
          "s1_title": "Deux entrées sperme",
          "s1_subtitle": "Pour la construction familiale AMAB + AMAB, l’optimisation du sperme et la stratégie embryon séparé sont au premier plan.",
          "compare_title": "Comparaison partenaires",
          "c1_label": "Partenaire A",
          "c1_value": "SA normal",
          "c1_note": "congélation de secours recommandée",
          "c2_label": "Partenaire B",
          "c2_value": "SA manquant",
          "c2_note": "commander le test",
          "c3_label": "Frag. ADN",
          "c3_value": "Optionnel",
          "c3_note": "si SA/historique anormal",
          "c4_label": "Optimisation",
          "c4_value": "72-90 jours",
          "c4_note": "cycle sperme",
          "tasks_title": "Programme de reset sperme",
          "t1_title": "Spermogramme de base",
          "t1_detail": "Nombre, mobilité, morphologie ; fragmentation ADN optionnelle.",
          "t1_owner": "Partenaire B",
          "t1_due": "Cette semaine",
          "t2_title": "Congeler des échantillons de secours",
          "t2_detail": "Protège contre les problèmes du jour de recueil pendant la création d’embryons.",
          "t2_owner": "Les deux partenaires",
          "t2_due": "Avant le cycle donneuse",
          "t3_title": "Répéter le test",
          "t3_detail": "Après la fenêtre de reset, compare nombre/mobilité/fragmentation ADN.",
          "t3_owner": "Les deux partenaires",
          "t3_due": "90 jours",
          "s2_title": "Donneuse, gestatrice, juridique, argent",
          "s2_subtitle": "Garde chaque dépendance externe visible.",
          "program_title": "Aperçu du programme",
          "p1_label": "Donneuse d’ovocytes",
          "p1_value": "3 présélectionnées",
          "p1_note": "statut de porteuse compatible",
          "p2_label": "Gestatrice",
          "p2_value": "2 appels agence",
          "p2_note": "cette semaine",
          "p3_label": "Juridique",
          "p3_value": "Pas démarré",
          "p3_note": "après présélection",
          "p4_label": "Budget",
          "p4_value": "145-210 k$",
          "p4_note": "large fourchette initiale"
        },
        "partner_precycle": {
          "section_title": "Contexte partagé",
          "section_subtitle": "Vois la progression du traitement et ton propre travail en un seul endroit.",
          "metrics_title": "Plan principal",
          "m1_label": "Traitement",
          "m1_value": "Planification FIV",
          "m1_note": "pré-cycle",
          "m2_label": "Clinique",
          "m2_value": "Présélection ouverte",
          "m2_note": "couverture en attente",
          "m3_label": "Démarrage cycle",
          "m3_value": "Pas fixé",
          "m3_note": "après consultation",
          "dec_title": "Contribution partenaire",
          "d1_title": "Spermogramme",
          "d1_detail": "Nécessaire pour le plan sperme FIV/IIU et les décisions ICSI.",
          "d1_status": "À réserver",
          "d2_title": "Détails de couverture",
          "d2_detail": "Les avantages employeur peuvent changer matériellement l’estimation partagée.",
          "d2_status": "À ajouter",
          "d3_title": "Plan de soutien",
          "d3_detail": "Trajet, timing des médicaments et logistique du jour de ponction apparaissent au démarrage du cycle.",
          "d3_status": "Plus tard"
        },
        "partner_active": {
          "section_title": "Tableau de bord adapté aux permissions",
          "section_subtitle": "Soutiens le cycle avec tes propres tâches et le contexte partagé.",
          "metrics_title": "Cycle partagé",
          "m1_label": "Phase",
          "m1_value": "Stim jour 7",
          "m1_note": "ponction estimée 24 mai",
          "m2_label": "Aide du jour",
          "m2_value": "2 éléments",
          "m2_note": "échantillon + trajet",
          "m3_label": "Prochain rendez-vous",
          "m3_value": "Demain",
          "m3_note": "8 h 20",
          "tasks_title": "À la charge du·de la partenaire",
          "t1_title": "Confirmer le plan d’échantillon",
          "t1_detail": "La décision d’échantillon frais ou de paillette de secours est due avant la ponction.",
          "t1_owner": "Toi",
          "t1_due": "Aujourd’hui",
          "t2_title": "Bloquer la fenêtre de ponction",
          "t2_detail": "La sédation requiert généralement un accompagnement et un horaire de récupération flexible.",
          "t2_owner": "Toi",
          "t2_due": "24 mai",
          "t3_title": "Soutien médicaments",
          "t3_detail": "Les injections du soir sont plus simples avec un horaire stable et le matériel prêt.",
          "t3_owner": "Toi",
          "t3_due": "Ce soir"
        },
        "egg_donor": {
          "section_title": "Opérations d’agence",
          "section_subtitle": "Suis les tâches de clairance et le bilan médical.",
          "comp_title": "Chronologie de compensation",
          "c1_label": "Compensation de base",
          "c1_value": "8 000 $",
          "c1_note": "après ponction",
          "c2_label": "Dépistage",
          "c2_value": "Couvert",
          "c2_note": "agence/clinique paie",
          "c3_label": "Déplacements",
          "c3_value": "Remboursés",
          "c3_note": "reçus nécessaires",
          "tasks_title": "Checklist de clairance",
          "t1_title": "Labos infectieux",
          "t1_detail": "Prise de sang programmée aujourd’hui.",
          "t1_owner": "Clinique",
          "t1_due": "Aujourd’hui",
          "t2_title": "Dépistage génétique de porteuse",
          "t2_detail": "Échantillon collecté avec la prise de sang.",
          "t2_owner": "Clinique",
          "t2_due": "Aujourd’hui",
          "t3_title": "Clairance psy",
          "t3_detail": "Rendez-vous virtuel ; résultat envoyé à l’agence.",
          "t3_owner": "Agence",
          "t3_due": "22 mai",
          "t4_title": "Revue juridique",
          "t4_detail": "Se débloque après le match avec les parent·e·s d’intention.",
          "t4_owner": "Juridique",
          "t4_due": "Après le match"
        },
        "sperm_donor": {
          "section_title": "Programme de don",
          "section_subtitle": "Suis chaque échantillon et le parcours quarantaine/re-test.",
          "timeline_title": "Parcours de libération d’échantillon",
          "tl1_label": "Visite",
          "tl1_detail": "Échantillon collecté et dépisté.",
          "tl2_label": "Acceptation labo",
          "tl2_detail": "Nombre, mobilité, dépistage infectieux et entrée en quarantaine.",
          "tl3_label": "Quarantaine",
          "tl3_detail": "Les échantillons restent retenus jusqu’à la fenêtre de re-test requise.",
          "tl4_label": "Re-test",
          "tl4_detail": "Les labos infectieux sont répétés avant libération.",
          "tl5_label": "Versement",
          "tl5_detail": "La compensation suit les règles du programme et les échantillons acceptés.",
          "metrics_title": "Mois en cours",
          "m1_label": "Échantillons acceptés",
          "m1_value": "3",
          "m1_note": "éligibles",
          "m2_label": "Échantillons en attente",
          "m2_value": "1",
          "m2_note": "revue labo",
          "m3_label": "Versement",
          "m3_value": "350 $",
          "m3_note": "prochain cycle"
        },
        "carrier": {
          "section_title": "Préparation au match",
          "section_subtitle": "Garde les exigences médicales, assurance, juridique et dépistage en une seule vue.",
          "metrics_title": "Aperçu de la candidature",
          "m1_label": "Historique de grossesse",
          "m1_value": "2 naissances précédentes",
          "m1_note": "dossiers en attente",
          "m2_label": "Assurance",
          "m2_value": "En revue",
          "m2_note": "exclusions GPA",
          "m3_label": "Match agence",
          "m3_value": "2 agences",
          "m3_note": "intake ouvert",
          "tasks_title": "Avant le match",
          "t1_title": "Téléverser les dossiers OB",
          "t1_detail": "Notes d’accouchement, complications et historique post-partum.",
          "t1_owner": "Toi",
          "t1_due": "Aujourd’hui",
          "t2_title": "Revue de la police d’assurance",
          "t2_detail": "Vérifie les exclusions et la couverture grossesse.",
          "t2_owner": "Agence",
          "t2_due": "Cette semaine",
          "t3_title": "Vérifications foyer/antécédents",
          "t3_detail": "Exigences spécifiques au programme avant le match.",
          "t3_owner": "Agence",
          "t3_due": "Suivant",
          "t4_title": "Consultation juridique",
          "t4_detail": "Compensation, droits, prise de décision et clauses de résiliation.",
          "t4_owner": "Juridique",
          "t4_due": "Après le match"
        },
        "intended_parent": {
          "section_title": "Espace de matching",
          "section_subtitle": "Rends concret le travail donneuse, gestatrice, embryon et juridique.",
          "dec_title": "Présélections",
          "d1_title": "Donneuse d’ovocytes A",
          "d1_detail": "27 ans, compatible avec porteuse, disponible en juillet, frais agence 18 k$.",
          "d1_status": "Favori",
          "d2_title": "Donneuse d’ovocytes B",
          "d2_detail": "31 ans, cycle précédent solide, un chevauchement de porteuse à revoir.",
          "d2_status": "À revoir",
          "d3_title": "Agence gestatrice",
          "d3_detail": "Deux agences acceptent tes critères d’état/juridique.",
          "d3_status": "Appels",
          "tasks_title": "Avant la création d’embryons",
          "t1_title": "Choisir la source sperme",
          "t1_detail": "Sperme partenaire, sperme de donneur ou fécondation séparée.",
          "t1_owner": "Toi",
          "t1_due": "Cette semaine",
          "t2_title": "Intake juridique",
          "t2_detail": "Accords donneuse et gestatrice plus structure de séquestre.",
          "t2_owner": "Juridique",
          "t2_due": "Après présélection",
          "t3_title": "Plan de création d’embryons",
          "t3_detail": "La clinique et le labo créent les embryons avant le transfert chez la gestatrice.",
          "t3_owner": "Clinique",
          "t3_due": "Après donneuse sélectionnée",
          "metrics_title": "Aperçu argent",
          "m1_label": "Acomptes agence",
          "m1_value": "18-25 k$",
          "m1_note": "début",
          "m2_label": "Cycle donneuse",
          "m2_value": "35-55 k$",
          "m2_note": "sans variabilité médicaments FIV",
          "m3_label": "Compensation/séquestre gestatrice",
          "m3_value": "65-95 k$",
          "m3_note": "selon juridique + état"
        }
      },
      "inline": {
        "today_timeline_title": "Programme",
        "today_schedule_title": "Programme",
        "test_results_title": "Résultats d’analyses",
        "test_results_subtitle": "Les résultats nouveaux et en attente apparaissent ici.",
        "test_results_not_recorded_detail": "Seuls les résultats enregistrés pour toi apparaîtront ici.",
        "monitoring_data_not_recorded_detail": "Seules les valeurs de monitoring enregistrées par ton équipe soignante apparaîtront ici.",
        "active_logistics_not_recorded_detail": "Les informations de la clinique apparaîtront ici quand le rendez-vous, le médicament ou le document correspondant sera enregistré.",
        "ivf_plan_not_recorded_detail": "Les détails sur la fécondation, le sperme, les embryons et les tests apparaîtront quand ta clinique les enregistrera.",
        "post_retrieval_eyebrow": "Après la ponction",
        "post_retrieval_title": "Ponction terminée",
        "post_retrieval_summary": "Garde ton programme réel du jour à portée de main pendant que ta clinique enregistre la prochaine mise à jour du laboratoire ou de la conservation.",
        "post_retrieval_today_section_title": "Aujourd’hui",
        "post_retrieval_today_section_subtitle": "Garde les médicaments et rendez-vous visibles sans prolonger les indicateurs de stimulation.",
        "post_retrieval_guidance_section_title": "Après la ponction",
        "post_retrieval_guidance_section_subtitle": "Repères de récupération et relais vers les résultats enregistrés par la clinique.",
        "post_retrieval_guidance_title": "À savoir maintenant",
        "post_retrieval_guidance_subtitle": "Les consignes de ta clinique restent prioritaires pendant que le laboratoire termine son travail.",
        "post_retrieval": {
          "lab_section_title": "Mises à jour du laboratoire",
          "retrieved_eggs_label": "Ovocytes ponctionnés",
          "retrieved_eggs_waiting": "Comptage au laboratoire en cours.",
          "mature_eggs_label": "Ovocytes matures",
          "mature_eggs_waiting": "Évaluation de la maturité en cours.",
          "fertilized_eggs_label": "Ovocytes fécondés",
          "fertilized_eggs_waiting": "Contrôle de fécondation en cours.",
          "day_three_embryos_label": "Embryons à J3",
          "day_three_embryos_waiting": "Vérification du développement précoce en cours.",
          "day_five_embryos_label": "Embryons à J5",
          "day_five_embryos_waiting": "Vérification du développement à J5 en cours.",
          "frozen_eggs_label": "Ovocytes vitrifiés",
          "frozen_eggs_waiting": "Confirmation de la congélation en attente.",
          "frozen_embryos_label": "Embryons vitrifiés",
          "frozen_embryos_waiting": "Confirmation de la congélation en attente.",
          "awaiting_update": "En attente",
          "unit_eggs": "ovocytes",
          "unit_embryos": "embryons",
          "from_clinic": "De ta clinique",
          "added_by_you": "Ajouté par toi",
          "added_by_partner": "Ajouté par ton/ta partenaire",
          "recorded": "Enregistré",
          "add_or_edit_results": "Ajouter ou modifier les résultats",
          "recovery_badge": "RÉCUPÉRATION",
          "recovery_title": "Récupère à ton rythme",
          "recovery_body": "Suis les consignes d’activité, de médicaments et d’hydratation données par ta clinique.",
          "recovery_b1": "Garde les consignes de la clinique faciles à retrouver.",
          "recovery_b2": "Utilise Aujourd’hui pour les rappels réels de médicaments ou de rendez-vous.",
          "recovery_b3": "Contacte ta clinique si les symptômes sont intenses ou différents de ce qui t’avait été expliqué.",
          "lab_badge": "LABORATOIRE",
          "lab_title": "Les mises à jour doivent venir de la clinique",
          "lab_body": "L’accueil doit afficher les étapes enregistrées du laboratoire et de la conservation, pas des nombres ou résultats estimés.",
          "lab_b1": "Les mises à jour de fécondation et de développement embryonnaire apparaissent lorsqu’elles sont enregistrées.",
          "lab_b2": "Les mises à jour de conservation des ovocytes apparaissent pour les cycles de vitrification d’ovocytes.",
          "lab_b3": "Une donnée manquante reste inconnue jusqu’à son enregistrement par la clinique.",
          "safety_badge": "QUAND APPELER",
          "safety_title": "Gardons le signal de sécurité clair",
          "safety_body": "Les consignes post-ponction de la clinique doivent rester faciles à trouver sans suggérer de diagnostic.",
          "safety_b1": "Suis les signes d’alerte et les consignes de contact fournies par ta clinique.",
          "safety_b2": "Ne modifie pas ton traitement à partir d’un résultat non enregistré.",
          "safety_b3": "Demande à ton équipe soignante quand la prochaine mise à jour ou le suivi n’est pas clair."
        },
        "sperm_active_data_not_recorded_detail": "Les consignes de recueil et les mises à jour du laboratoire apparaîtront quand ta clinique les enregistrera.",
        "sperm_wait_data_not_recorded_detail": "Seuls les résultats de laboratoire et les prochaines étapes enregistrés apparaîtront ici.",
        "sperm_postcycle_data_not_recorded_detail": "Seuls l'inventaire de sperme et les valeurs du laboratoire enregistrés apparaîtront ici.",
        "cycle_status_review_eyebrow": "Statut du cycle",
        "cycle_status_review_title": "Gardons les faits de ce cycle",
        "cycle_status_review_summary": "Un parcours de traitement annulé ou modifié n’est pas la même chose qu’un résultat négatif. Vérifiez ce qui a été enregistré et confirmez la prochaine étape avec votre équipe soignante.",
        "cycle_status_review_section_title": "Ce que vous pouvez faire maintenant",
        "cycle_status_review_section_subtitle": "Rien ne démarre automatiquement. Garde le contexte du cycle à portée de main en attendant un plan confirmé.",
        "cycle_status_review_today_title": "Aujourd'hui",
        "cycle_status_review_records_title": "Revoir ce cycle",
        "cycle_status_review_records_detail": "Ouvre l'historique de la procédure et les notes d'annulation ou de changement enregistrées.",
        "cycle_status_review_records_action": "Revoir les détails du cycle",
        "cycle_status_review_clinic_title": "Ajouter la prochaine étape de la clinique",
        "cycle_status_review_clinic_detail": "Enregistrez une visite reprogrammée, un suivi ou une consigne quand votre équipe soignante les confirme.",
        "cycle_status_review_clinic_action": "Ouvrir les rendez-vous",
        "cycle_status_review_question_title": "Préparer une question",
        "cycle_status_review_question_detail": "Demandez à Louise de vous aider à préparer la prochaine conversation avec votre équipe soignante.",
        "cycle_status_review_question_action": "Préparer une question",
        "cycle_status_review_question_prompt": "Mon cycle de traitement de fertilité a été annulé ou modifié au lieu de se dérouler comme prévu. Aidez-moi à préparer une question concise pour mon équipe soignante sur ce qui a été enregistré et la suite. Ne qualifiez pas le cycle de positif ou négatif, ne posez pas de diagnostic et ne modifiez pas mon traitement.",
        "cycle_status_review_cancelled_title": "Ce cycle a été annulé",
        "cycle_status_review_cancelled_summary": "Vérifiez ce qui a été enregistré et confirmez le suivi avec votre équipe soignante. Une annulation n’est pas un résultat négatif.",
        "cycle_status_review_cancelled_question_prompt": "Mon cycle de traitement de fertilité a été annulé. Aidez-moi à préparer une question concise pour mon équipe soignante sur ce qui a été enregistré et la suite. Ne qualifiez pas le cycle de positif ou négatif, ne posez pas de diagnostic et ne modifiez pas mon traitement.",
        "cycle_status_review_converted_title": "Ce parcours de traitement a changé",
        "cycle_status_review_converted_summary": "Vérifiez ce qui a été enregistré et confirmez le nouveau plan avec votre équipe soignante. Un parcours modifié n’est pas un résultat négatif.",
        "cycle_status_review_converted_question_prompt": "Mon parcours de traitement de fertilité a changé. Aidez-moi à préparer une question concise pour mon équipe soignante sur ce qui a été enregistré et la suite. Ne qualifiez pas le cycle de positif ou négatif, ne posez pas de diagnostic et ne modifiez pas mon traitement.",
        "cycle_status_review_handoff_title": "Préparer la prochaine conversation avec la clinique",
        "cycle_status_review_handoff_body": "Quand vous le voudrez, Louise peut vous aider à transformer ce qui a été enregistré en une question claire ou une prochaine étape, sans deviner ce que signifie l’annulation ou le changement.",
        "cycle_status_review_handoff_cta": "Parler de la prochaine étape",
        "cycle_status_review_handoff_check_1": "Revoir ce qui a été enregistré",
        "cycle_status_review_handoff_check_2": "Préparer une question pour votre équipe soignante",
        "cycle_status_review_cancelled_handoff_title": "Faciliter le suivi de l’annulation",
        "cycle_status_review_cancelled_handoff_body": "Quand vous le voudrez, Louise peut vous aider à transformer les détails enregistrés de l’annulation en une question claire ou une prochaine étape, sans deviner la suite.",
        "cycle_status_review_cancelled_handoff_cta": "Parler de l’annulation",
        "cycle_status_review_cancelled_handoff_check_1": "Revoir ce qui a été enregistré",
        "cycle_status_review_cancelled_handoff_check_2": "Préparer une question pour votre équipe soignante",
        "cycle_status_review_converted_handoff_title": "Faciliter la navigation du changement de traitement",
        "cycle_status_review_converted_handoff_body": "Quand vous le voudrez, Louise peut vous aider à transformer le changement de traitement enregistré en une question claire ou une prochaine étape, sans supposer pourquoi le plan a changé.",
        "cycle_status_review_converted_handoff_cta": "Parler du changement de traitement",
        "cycle_status_review_converted_handoff_check_1": "Revoir ce qui a été enregistré",
        "cycle_status_review_converted_handoff_check_2": "Préparer une question pour votre équipe soignante",
        "test_results_iui_subtitle": "Les résultats de timing nouveaux et en attente apparaissent ici.",
        "monitoring_progress_title": "Progression du monitoring",
        "monitoring_progress_subtitle": "Enregistre chaque visite pour suivre la croissance folliculaire, l’estradiol, les symptômes et le timing de la ponction.",
        "monitoring_progress_iui_subtitle": "Utilise-le pour garder croissance folliculaire, timing du déclenchement, préparation du sperme et timing de l’insémination connectés.",
        "what_to_know_title": "Bon à savoir",
        "what_to_know_subtitle": "Utilise-le comme rappel rapide entre deux monitorings. Les consignes de ta clinique restent prioritaires.",
        "what_to_know_iui_subtitle": "Les consignes de ta clinique sur le déclenchement et l’insémination restent prioritaires.",
        "cycle_may_freeze_title": "Ce que ce cycle peut vitrifier",
        "cycle_may_freeze_subtitle": "Estimation à partir du nombre de follicules du jour. Les chiffres réels se mettent à jour après ponction, contrôle de maturité et vitrification.",
        "cycle_may_become_title": "Ce que ce cycle peut devenir",
        "cycle_may_become_subtitle": "Estimation à partir du nombre de follicules du jour. Après la ponction, elle se met à jour avec les ovocytes ponctionnés, matures, fécondés, les blastocystes et les résultats DPI éventuels.",
        "logistics_checklist_title": "Checklist logistique du cycle",
        "iui_logistics_checklist_title": "Checklist logistique IIU",
        "after_retrieval_title": "Après la ponction",
        "after_retrieval_egg_subtitle": "Fais défiler : jour de la ponction, contrôle de maturité, confirmation de vitrification et conservation.",
        "after_retrieval_embryo_subtitle": "Fais défiler : jour de la ponction, fécondation, clivage, blastocyste, vitrification et DPI.",
        "section_today_title": "Aujourd’hui",
        "section_today_subtitle": "Actions concrètes pour ce jour du cycle.",
        "section_today_iui_subtitle": "Actions concrètes pour cette fenêtre de timing IIU.",
        "section_testing_title": "Analyses",
        "section_testing_subtitle": "Résultats récents et contexte de monitoring pour ce jour du cycle.",
        "section_testing_iui_subtitle": "Contexte monitoring et source du sperme récent pour ce jour du cycle IIU.",
        "section_good_to_know_title": "Bon à savoir",
        "section_good_to_know_subtitle": "Repères et estimations utiles pour la suite.",
        "section_good_to_know_iui_subtitle": "Repères utiles pour le déclenchement, le timing du sperme et la transition vers l’attente.",
        "section_cycle_logistics_title": "Logistique du cycle",
        "section_cycle_logistics_subtitle": "Médicaments, préparation à la ponction, contacts clinique et calendrier des mises à jour du labo.",
        "section_iui_logistics_subtitle": "Timing du déclenchement, gestion de l’échantillon, préparation à la procédure et transition vers l’attente.",
        "fet_active_plan_section_heading": "Suivre le plan enregistré",
        "fet_active_plan_section_supporting": "Seules les ordonnances, les rendez-vous et les résultats enregistrés pour vous apparaissent ici.",
        "fet_active_records_heading": "Plan et préparation de la clinique",
        "fet_active_records_detail": "Les décisions de la clinique concernant les médicaments, le suivi et la préparation apparaîtront ici une fois enregistrées.",
        "fet_active_transfer_heading": "Dossiers du transfert et des résultats",
        "fet_active_transfer_detail": "Un transfert, une décongélation ou un résultat de bêta n’apparaît ici qu’après son enregistrement par la clinique.",
        "section_ivf_specifics_title": "Spécificités FIV",
        "section_ivf_specifics_subtitle": "Le sperme, la fécondation, les tests embryonnaires et les choix de transfert changent ce qui se passe après la ponction.",
        "ivf_plan_title": "Plan FIV",
        "ivf_plan_endometrium_label": "Endomètre",
        "ivf_plan_endometrium_value": "8,2 mm",
        "ivf_plan_endometrium_note": "trilamellaire",
        "ivf_plan_sperm_label": "Stratégie sperme",
        "ivf_plan_sperm_value": "Frais + secours",
        "ivf_plan_sperm_note": "prélèvement le matin de la ponction",
        "ivf_plan_fertilization_label": "Fécondation",
        "ivf_plan_fertilization_value": "ICSI",
        "ivf_plan_fertilization_note": "plan de la clinique",
        "ivf_plan_pgta_label": "DPI",
        "ivf_plan_pgta_value": "Prévu",
        "ivf_plan_pgta_note": "tout vitrifier d’abord",
        "retrieval_decisions_title": "Décisions du jour de la ponction",
        "retrieval_decisions_partner_sample_title": "Échantillon du partenaire",
        "retrieval_decisions_partner_sample_detail": "Un échantillon frais est prévu ; une paillette de secours est disponible si besoin.",
        "retrieval_decisions_icsi_title": "Consentement ICSI",
        "retrieval_decisions_icsi_detail": "Signé et joint au cycle.",
        "retrieval_decisions_pgta_title": "Plan DPI",
        "retrieval_decisions_pgta_detail": "Le plan de biopsie et vitrification totale est prêt pour le labo.",
        "calendar_action": "Calendrier",
        "all_tests_action": "Toutes les analyses",
        "egg_postcycle_section_title": "Résultats de vitrification d’ovocytes",
        "egg_postcycle_section_subtitle": "Étapes labo de la ponction au stockage.",
        "egg_postcycle_funnel_retrieved_label": "Ponctionnés",
        "egg_postcycle_funnel_retrieved_detail": "Ovocytes trouvés par l’embryologie.",
        "egg_postcycle_funnel_mature_label": "Matures",
        "egg_postcycle_funnel_mature_detail": "Ovocytes MII éligibles à la vitrification.",
        "egg_postcycle_funnel_frozen_label": "Vitrifiés",
        "egg_postcycle_funnel_frozen_detail": "Vitrifiés et stockés.",
        "embryo_postcycle_section_title": "Résultats de vitrification d’embryons",
        "embryo_postcycle_section_subtitle": "Étapes labo de la fécondation au stockage.",
        "embryo_funnel_retrieved_label": "Ovocytes ponctionnés",
        "embryo_funnel_retrieved_detail": "Ovocytes trouvés par le labo.",
        "embryo_funnel_mature_label": "Matures",
        "embryo_funnel_mature_detail": "Ovocytes MII prêts pour ICSI.",
        "embryo_funnel_fertilized_label": "Fécondés",
        "embryo_funnel_fertilized_detail": "Contrôle de fécondation 2PN normale.",
        "embryo_funnel_blastocysts_label": "Blastocystes",
        "embryo_funnel_blastocysts_detail": "Embryons jour 5-7 à vitrifier/tester.",
        "embryo_funnel_euploid_label": "Euploïdes",
        "embryo_funnel_euploid_detail": "Estimés après DPI ; le rapport du labo confirmera.",
        "sperm_active_eyebrow": "Vitrification de sperme",
        "sperm_active_title": "Recueil demain",
        "sperm_active_summary": "Ton rendez-vous, la fenêtre d’abstinence, les consignes de prélèvement, l’analyse attendue et l’objectif de stockage — tout est au même endroit.",
        "sperm_active_hm1_label": "Recueil",
        "sperm_active_hm1_value": "Demain",
        "sperm_active_hm1_note": "8 h 30",
        "sperm_active_hm2_label": "Abstinence",
        "sperm_active_hm2_value": "Jour 3",
        "sperm_active_hm2_note": "cible 2-5 jours",
        "sperm_active_hm3_label": "Objectif",
        "sperm_active_hm3_value": "6 paillettes",
        "sperm_active_hm3_note": "2 visites prévues",
        "sperm_active_section_title": "Jour du recueil",
        "sperm_active_section_subtitle": "Tout ce qu’il faut pour éviter un mauvais échantillon ou un rendez-vous manqué.",
        "sperm_active_tasks_title": "Avant d’y aller",
        "sperm_active_t1_title": "Apporter une pièce d’identité",
        "sperm_active_t1_detail": "Requis pour la vérification d’identité de l’échantillon.",
        "sperm_active_t2_title": "Éviter la chaleur aujourd’hui",
        "sperm_active_t2_detail": "Pas de sauna, jacuzzi, fièvre ou maladie si possible.",
        "sperm_active_t3_title": "Signer le consentement de stockage",
        "sperm_active_t3_detail": "Le consentement et les choix de disposition doivent être complets avant le stockage longue durée.",
        "sperm_active_semen_title": "Résultats de spermogramme",
        "sperm_wait_section_title": "En attente des résultats",
        "sperm_wait_section_subtitle": "Vois ce qui est en attente et ce que chaque résultat change.",
        "sperm_wait_lab_status_title": "Statut labo",
        "sperm_wait_tl1_label": "Échantillon reçu",
        "sperm_wait_tl1_detail": "Vérification d’identité et heure de prélèvement consignées.",
        "sperm_wait_tl2_label": "Spermogramme",
        "sperm_wait_tl2_detail": "Volume, concentration, mobilité, morphologie.",
        "sperm_wait_tl3_label": "Estimation vitrification/décongélation",
        "sperm_wait_tl3_detail": "Sperme mobile utilisable attendu après décongélation.",
        "sperm_wait_tl4_label": "Confirmation de stockage",
        "sperm_wait_tl4_detail": "Paillettes, installation et date de renouvellement annuel publiées.",
        "sperm_wait_dec_title": "Prochaine étape probable",
        "sperm_wait_d1_title": "Refaire un recueil",
        "sperm_wait_d1_detail": "Recommandé si le premier échantillon donne moins de 3 paillettes utilisables.",
        "sperm_wait_d1_status": "Possible",
        "sperm_wait_d2_title": "Démarrer un reset de 90 jours",
        "sperm_wait_d2_detail": "Utile si le nombre, la mobilité ou la fragmentation de l’ADN est anormal.",
        "sperm_wait_d2_status": "Dépend du résultat",
        "sperm_wait_d3_title": "Stocker et arrêter",
        "sperm_wait_d3_detail": "Raisonnable si l’objectif de paillettes est atteint et l’usage futur est FIV/ICSI.",
        "sperm_wait_d3_status": "Possible",
        "sperm_postcycle_section_title": "Résultats de vitrification de sperme",
        "sperm_postcycle_section_subtitle": "Ce qui a été mis en banque et où c’est stocké.",
        "sperm_postcycle_semen_title": "Résultats de spermogramme",
        "beta_wait_eyebrow": "Attente",
        "beta_wait_title": "6 jours après le transfert",
        "beta_wait_summary": "Rends l’attente concrète : timing de la bêta, médicaments, symptômes et quand appeler.",
        "beta_wait_section_today_title": "Aujourd’hui",
        "beta_wait_section_today_subtitle": "Réduire l’incertitude sans prédire l’issue.",
        "beta_wait_today_title": "Aujourd’hui",
        "beta_wait_section_testing_title": "Analyses",
        "beta_wait_section_testing_subtitle": "Garde le timing de la bêta et les branches de résultat clairs.",
        "beta_wait_result_plan_title": "Plan résultat bêta",
        "beta_wait_result_plan_subtitle": "Fais défiler la prise de sang bêta, la branche positive et la branche négative.",
        "beta_wait_section_more_title": "Bon à savoir",
        "beta_wait_section_more_subtitle": "Contexte utile pour les symptômes, les tests maison et quand appeler.",
        "beta_wait_what_to_know_title": "Bon à savoir",
        "beta_wait_what_to_know_subtitle": "Les symptômes peuvent être réels sans être prédictifs.",
        "ivf_positive_eyebrow": "Résultat",
        "ivf_positive_title": "Bêta positif",
        "ivf_positive_summary": "Garde la prochaine bêta, les médicaments, les symptômes d’alerte et le timing de l’échographie clairs.",
        "ivf_positive_section_title": "Prochaines étapes médicales",
        "ivf_positive_section_subtitle": "Le suivi de début de grossesse demande des tâches précises.",
        "ivf_positive_today_title": "Continuer aujourd’hui",
        "ivf_positive_tasks_title": "Avant l’échographie",
        "ivf_positive_t1_title": "Bêta de contrôle",
        "ivf_positive_t1_detail": "La deuxième prise de sang confirme la progression.",
        "ivf_positive_t3_title": "Dossier de transmission obstétrique",
        "ivf_positive_t3_detail": "Le résumé de grossesse et le dossier FIV sont préparés après l’échographie.",
        "ivf_negative_eyebrow": "Résultat",
        "ivf_negative_title": "Bêta négatif",
        "ivf_negative_summary": "Prochaines étapes claires : instructions médicamenteuses, soutien, récap du cycle et options suivantes.",
        "ivf_negative_section_title": "Ce qui se passe maintenant",
        "ivf_negative_section_subtitle": "Soutien et instructions concrètes pour les prochains jours.",
        "ivf_negative_tasks_title": "Aujourd’hui",
        "ivf_negative_t1_title": "Plan médicaments",
        "ivf_negative_t1_detail": "La clinique demande d’arrêter la progestérone ce soir.",
        "ivf_negative_t2_title": "Saignements à venir",
        "ivf_negative_t2_detail": "Les règles peuvent arriver dans quelques jours ; appelle en cas de saignements abondants ou de douleur sévère.",
        "ivf_negative_t3_title": "Consultation de suivi",
        "ivf_negative_t3_detail": "Revoir la qualité embryonnaire, le protocole de transfert et les options de prochaine tentative.",
        "ivf_negative_funnel_title": "Récap du cycle",
        "ivf_negative_funnel_retrieved_label": "Ponctionnés",
        "ivf_negative_funnel_retrieved_detail": "Ovocytes recueillis.",
        "ivf_negative_funnel_mature_label": "Matures",
        "ivf_negative_funnel_mature_detail": "Ovocytes MII.",
        "ivf_negative_funnel_fertilized_label": "Fécondés",
        "ivf_negative_funnel_fertilized_detail": "Fécondation normale.",
        "ivf_negative_funnel_blasts_label": "Blastos",
        "ivf_negative_funnel_blasts_detail": "Blastocystes.",
        "ivf_negative_funnel_transferred_label": "Transférés",
        "ivf_negative_funnel_transferred_detail": "Cette tentative.",
        "ivf_negative_dec_title": "Options pour la prochaine tentative",
        "ivf_negative_d1_title": "Utiliser un embryon stocké",
        "ivf_negative_d1_detail": "2 embryons restent vitrifiés.",
        "ivf_negative_d1_status": "Disponible",
        "ivf_negative_d2_title": "Changer de protocole",
        "ivf_negative_d2_detail": "Discuter du timing de la progestérone, de la préparation de l’endomètre ou de la sélection embryonnaire.",
        "ivf_negative_d2_status": "Consultation",
        "ivf_negative_d3_title": "Pause",
        "ivf_negative_d3_detail": "Garder le stockage actif et décider plus tard.",
        "ivf_negative_d3_status": "Disponible",
        "iui_wait_section_today_title": "Aujourd’hui",
        "iui_wait_section_today_subtitle": "Soutien pendant l’attente, avec un timing spécifique à l’IIU.",
        "iui_wait_today_title": "Aujourd’hui",
        "iui_wait_section_testing_title": "Analyses",
        "iui_wait_section_testing_subtitle": "Gère la confusion du déclenchement et garde le timing de la bêta clair.",
        "iui_wait_result_plan_title": "Plan résultat IIU",
        "iui_wait_result_plan_subtitle": "Fais défiler la fenêtre de test fiable et ce qu’il faut faire si des saignements commencent.",
        "iui_wait_section_more_title": "Bon à savoir",
        "iui_wait_section_more_subtitle": "Contexte utile pour l’hCG du déclenchement, les symptômes et la prochaine branche.",
        "iui_wait_what_to_know_title": "Bon à savoir",
        "iui_wait_what_to_know_subtitle": "Le déclenchement peut rendre les tests précoces peu fiables.",
        "oi_wait_section_today_title": "Aujourd’hui",
        "oi_wait_section_today_subtitle": "Gardez les jours après l’ovulation reliés au plan de votre clinique.",
        "oi_wait_today_title": "Aujourd’hui",
        "oi_wait_section_testing_title": "Tests",
        "oi_wait_section_testing_subtitle": "Gardez la date prévue du test et la suite bien visibles.",
        "oi_wait_result_plan_title": "Plan de résultat OI",
        "oi_wait_result_plan_subtitle": "Gardez ensemble le moment de l’ovulation, le test prévu et le suivi.",
        "oi_wait_section_more_title": "Bon à savoir",
        "oi_wait_section_more_subtitle": "Contexte utile sur le moment de l’ovulation, les médicaments et la suite.",
        "oi_wait_what_to_know_title": "Bon à savoir",
        "oi_wait_what_to_know_subtitle": "L’ovulation donne un timing, pas le résultat.",
        "intended_parent_hm1_label": "Donneuse d’ovocytes",
        "intended_parent_hm1_value": "3 présélectionnées",
        "intended_parent_hm1_note": "statut gestatrice vérifié",
        "intended_parent_hm2_label": "Gestatrice",
        "intended_parent_hm2_value": "Recherche en cours",
        "intended_parent_hm2_note": "2 appels d’agence",
        "intended_parent_hm3_label": "Séquestre",
        "intended_parent_hm3_value": "Pas commencé",
        "intended_parent_hm3_note": "juridique d’abord",
        "intended_parent_section_title": "Plan opérationnel",
        "intended_parent_section_subtitle": "Garde agence, clinique, labo et juridique dans une seule vue.",
        "intended_parent_tasks_title": "Tâches ouvertes",
        "intended_parent_t1_title": "Choisir la présélection de donneuses",
        "intended_parent_t1_detail": "3 candidates correspondent au profil, à la disponibilité et au dépistage gestatrice.",
        "intended_parent_t1_due": "Cette semaine",
        "intended_parent_t2_title": "Entretien agence gestatrice",
        "intended_parent_t2_detail": "Deux appels prévus ; l’un nécessite un plan embryon d’abord.",
        "intended_parent_t2_due": "Cette semaine",
        "intended_parent_t3_title": "Entretien juridique",
        "intended_parent_t3_detail": "Filiation, donneuse et contrats gestatrice.",
        "intended_parent_t3_due": "Après le choix donneuse/gestatrice",
        "intended_parent_timeline_title": "Chemin vers le transfert",
        "intended_parent_tl1_label": "Maintenant",
        "intended_parent_tl1_detail": "Sélectionner la voie donneuse et gestatrice.",
        "intended_parent_tl2_label": "Ensuite",
        "intended_parent_tl2_detail": "Créer des embryons ou confirmer l’inventaire embryonnaire.",
        "intended_parent_tl3_label": "Juridique",
        "intended_parent_tl3_detail": "Contrats et séquestre.",
        "intended_parent_tl4_label": "Transfert",
        "intended_parent_tl4_detail": "Validation médicale de la gestatrice et cycle de transfert.",
        "owner_you": "Toi",
        "owner_partner": "Partenaire",
        "owner_clinic": "Clinique",
        "owner_lab": "Labo",
        "owner_legal": "Juridique",
        "owner_louise": "Louise",
        "owner_you_clinic": "Toi + clinique",
        "due_now": "Maintenant",
        "due_today": "Aujourd’hui",
        "due_tomorrow": "Demain",
        "due_done": "Terminé",
        "due_daily": "Quotidien",
        "due_clinic_scheduled": "La clinique planifiera",
        "due_later": "Plus tard",
        "due_this_week": "Cette semaine",
        "due_any_time": "À tout moment",
        "due_retrieval_morning": "Matin de la ponction",
        "due_before_banking": "Avant la mise en banque",
        "due_may_23": "23 mai",
        "egg_postcycle_eyebrow": "Vitrification d’ovocytes",
        "egg_postcycle_title": "Cycle de vitrification d’ovocytes terminé",
        "egg_postcycle_summary": "Consulte tes résultats enregistrés, les détails de conservation et les prochaines options.",
        "egg_freezing_active_eyebrow": "Vitrification d’ovocytes",
        "egg_freezing_active_title": "Stimulation jour 7",
        "egg_freezing_active_summary": "Les follicules grossissent et la sensation de pression ou de ballonnement peut augmenter aujourd’hui. Le monitoring de demain décide si la ponction est avancée.",
        "embryo_freezing_active_eyebrow": "Vitrification d’embryons",
        "embryo_freezing_active_title": "Stimulation jour 7",
        "embryo_freezing_active_summary": "12 follicules grossissent, le lead est à 18 mm et la ponction est actuellement estimée au 24 mai.",
        "embryo_postcycle_eyebrow": "Vitrification d’embryons",
        "embryo_postcycle_title": "Cycle de vitrification d’embryons terminé",
        "embryo_postcycle_summary": "Consulte les résultats enregistrés, les tests en attente, la conservation et les prochaines options.",
        "embryo_postcycle_testing_title": "Tests des embryons",
        "embryo_postcycle_testing_subtitle": "Téléverse ton rapport de DPI dès que la clinique te l’envoie. Seuls les résultats enregistrés apparaîtront ici.",
        "sperm_freezing_wait_eyebrow": "Vitrification de sperme",
        "sperm_freezing_wait_title": "Échantillon en traitement",
        "sperm_freezing_wait_summary": "L’échantillon a été prélevé aujourd’hui. Les résultats et la confirmation de stockage sont attendus dans les prochains jours.",
        "sperm_freezing_postcycle_eyebrow": "Vitrification de sperme",
        "sperm_freezing_postcycle_title": "Cycle de vitrification de sperme terminé",
        "sperm_freezing_postcycle_summary": "Consulte ton analyse enregistrée, les détails de conservation et les prochaines options.",
        "ivf_active_eyebrow": "FIV",
        "oi_active_eyebrow": "Induction d’ovulation",
        "oi_active_title": "Stimulation en cours",
        "oi_active_summary": "Suis les médicaments et rendez-vous du jour, et ta réponse ovarienne au fil des échographies.",
        "follow_growth_and_trigger_timing": "Enregistre chaque visite pour suivre la croissance folliculaire, l’estradiol, les symptômes et le moment du déclenchement.",
        "ivf_active_title": "Stimulation avec plan embryon prêt",
        "ivf_active_summary": "Suis les médicaments et rendez-vous d’aujourd’hui, la réponse ovarienne actuelle, l’état du sperme et la chronologie du labo qui démarre à la ponction.",
        "iui_active_eyebrow": "IIU",
        "iui_active_title": "Déclenchement ce soir",
        "iui_active_summary": "Un tableau de bord de timing pour follicule, endomètre, déclenchement, échantillon de sperme, insémination et le début de l’attente.",
        "iui_wait_eyebrow": "Attente IIU",
        "iui_wait_title": "5 jours après IIU",
        "iui_wait_summary": "Nuances du déclenchement, incertitude des symptômes, médicaments et ce qui se passe le jour du test.",
        "intended_parent_eyebrow": "Parent d’intention",
        "intended_parent_title": "Donneuse, GPA, embryons, juridique et coûts",
        "intended_parent_summary": "Coordonner le travail des agences, l’appariement des sources, la disponibilité des embryons, les jalons juridiques et l’argent.",
        "iui_monitoring_baseline": "État de base",
        "iui_monitoring_cd9": "J9",
        "iui_monitoring_today": "Aujourd’hui",
        "iui_monitoring_trigger": "Déclenchement",
        "iui_monitoring_iui": "IIU",
        "iui_what_to_know_timing_badge": "Timing",
        "iui_what_to_know_timing_title": "Le timing du déclenchement guide la fenêtre IIU",
        "iui_what_to_know_timing_body": "Une fois que la clinique te donne l’heure du déclenchement, ce qui compte ensuite c’est la précision, pas plus de prédictions.",
        "iui_what_to_know_timing_b1": "Utilise l’heure de déclenchement donnée par ta clinique ; ne l’avance ni ne la retarde sans appeler.",
        "iui_what_to_know_timing_b2": "Le rendez-vous IIU est généralement planifié autour de la fenêtre d’ovulation attendue.",
        "iui_what_to_know_timing_b3": "Les tests d’ovulation supplémentaires sont rarement utiles, sauf demande de la clinique.",
        "iui_what_to_know_sperm_badge": "Sperme",
        "iui_what_to_know_sperm_title": "Le timing de l’échantillon fait partie du plan",
        "iui_what_to_know_sperm_body": "L’échantillon et le lavage au labo ont besoin d’un délai suffisant avant l’insémination, surtout en prélèvement frais.",
        "iui_what_to_know_sperm_b1": "Respecte la fenêtre d’abstinence donnée par ta clinique.",
        "iui_what_to_know_sperm_b2": "Apporte une pièce d’identité et les documents donneur ou partenaire demandés par le labo.",
        "iui_what_to_know_sperm_b3": "Appelle la clinique si le prélèvement risque d’être retardé ou difficile.",
        "iui_what_to_know_after_badge": "Après",
        "iui_what_to_know_after_title": "L’attente commence après l’insémination",
        "iui_what_to_know_after_body": "Après l’IIU, l’accueil passe du timing aux rappels de médicaments, au contexte des symptômes et au planning du bêta.",
        "iui_what_to_know_after_b1": "Continue le soutien lutéal exactement comme prescrit si ta clinique en utilise.",
        "iui_what_to_know_after_b2": "Le déclenchement peut fausser les tests urinaires précoces.",
        "iui_what_to_know_after_b3": "Utilise la date de bêta de ta clinique plutôt que de tester plus tôt pour décider.",
        "iui_logistics_trigger_title": "Plan de déclenchement",
        "iui_logistics_trigger_timeframe": "Ce soir",
        "iui_logistics_trigger_body": "L’heure du déclenchement cadre le rendez-vous d’insémination. Garde le médicament, la dose et les consignes d’injection accessibles.",
        "iui_logistics_trigger_i1_label": "Ovitrelle prête",
        "iui_logistics_trigger_i1_detail": "Prête pour 21 h",
        "iui_logistics_trigger_i2_label": "Consignes d’injection",
        "iui_logistics_trigger_i2_detail": "Dose et voie confirmées par la clinique",
        "iui_logistics_trigger_i3_label": "En cas de retard ou d’oubli",
        "iui_logistics_trigger_i3_detail": "Appelle la clinique avant de changer le timing",
        "iui_logistics_sperm_title": "Logistique du sperme",
        "iui_logistics_sperm_timeframe": "Matin de l’IIU",
        "iui_logistics_sperm_body": "Prélèvement frais, décongélation d’un don ou paillette du partenaire : tous nécessitent un délai labo avant le rendez-vous d’IIU.",
        "iui_logistics_sperm_i1_label": "Heure de prélèvement",
        "iui_logistics_sperm_i1_detail": "20 mai à 8 h",
        "iui_logistics_sperm_i2_label": "Lavage au labo",
        "iui_logistics_sperm_i2_detail": "Traitement avant l’IIU à 9 h 30",
        "iui_logistics_sperm_i3_label": "Plan de secours",
        "iui_logistics_sperm_i3_detail": "Appelle si l’heure de prélèvement change",
        "iui_logistics_after_title": "Après l’IIU",
        "iui_logistics_after_timeframe": "Le jour même",
        "iui_logistics_after_body": "L’étape suivante glisse vers l’attente du bêta, avec rappels de médicaments et contexte des symptômes.",
        "iui_logistics_after_i1_label": "Compte rendu",
        "iui_logistics_after_i1_detail": "Les détails de l’IIU sont rattachés au cycle",
        "iui_logistics_after_i2_label": "Consignes médicaments",
        "iui_logistics_after_i2_detail": "Progestérone ou autre soutien si prescrit",
        "iui_logistics_after_i3_label": "Date du bêta",
        "iui_logistics_after_i3_detail": "Timing de la prise de sang après l’IIU",
        "beta_wait_result_clinic_title": "Bêta clinique",
        "beta_wait_result_clinic_timeframe": "24 mai",
        "beta_wait_result_clinic_timeframe_pending": "Date non confirmée",
        "beta_wait_result_clinic_body": "Le bêta sanguin est le test qui guide la décision. Les tests à la maison et les symptômes peuvent prêter à confusion dans cette fenêtre.",
        "beta_wait_result_clinic_i1_label": "Prise de sang",
        "beta_wait_result_clinic_i1_detail": "Rendez-vous au labo de la clinique",
        "beta_wait_result_clinic_i2_label": "Appel résultat",
        "beta_wait_result_clinic_i2_detail": "Le jour même après relecture clinique",
        "beta_wait_result_clinic_i3_label": "Plan médicaments",
        "beta_wait_result_clinic_i3_detail": "À poursuivre tant que la clinique ne change pas les consignes",
        "beta_wait_result_positive_title": "Si positif",
        "beta_wait_result_positive_timeframe": "Environ 48 h plus tard",
        "beta_wait_result_positive_body": "L’information utile ensuite, c’est de voir si le bêta augmente correctement, puis le timing de l’échographie.",
        "beta_wait_result_positive_i1_label": "Bêta de contrôle",
        "beta_wait_result_positive_i1_detail": "Généralement vers 48 h",
        "beta_wait_result_positive_i2_label": "Poursuivre les médicaments",
        "beta_wait_result_positive_i2_detail": "Progestérone et soutien restent visibles",
        "beta_wait_result_positive_i3_label": "Timing échographie",
        "beta_wait_result_positive_i3_detail": "Planifiée après l’analyse de la tendance du bêta",
        "beta_wait_result_negative_title": "Si négatif",
        "beta_wait_result_negative_timeframe": "Après relecture",
        "beta_wait_result_negative_body": "L’accueil bascule vers les consignes d’arrêt, le soutien émotionnel et un récap de cycle prêt pour la consultation.",
        "beta_wait_result_negative_i1_label": "Plan d’arrêt",
        "beta_wait_result_negative_i1_detail": "Uniquement après les consignes de la clinique",
        "beta_wait_result_negative_i2_label": "Consultation de suivi",
        "beta_wait_result_negative_i2_detail": "Revue protocole, embryon et transfert",
        "beta_wait_result_negative_i3_label": "Étape suivante",
        "beta_wait_result_negative_i3_detail": "Embryon en réserve, nouveau cycle ou pause",
        "iui_wait_result_window_title": "Fenêtre de test fiable",
        "iui_wait_result_window_timeframe": "31 mai",
        "iui_wait_result_window_body": "Après un déclenchement à l’hCG, les tests urinaires précoces peuvent être trompeurs. Le bêta clinique est le résultat qui doit guider la décision.",
        "iui_wait_result_window_i1_label": "Injection déclenchement",
        "iui_wait_result_window_i1_detail": "18 mai ; peut fausser les tests à la maison",
        "iui_wait_result_window_i2_label": "Bêta clinique",
        "iui_wait_result_window_i2_detail": "Prise de sang le 31 mai",
        "iui_wait_result_window_i3_label": "Appel résultat",
        "iui_wait_result_window_i3_detail": "La clinique relit avant la suite",
        "iui_wait_result_bleeding_title": "Si des saignements commencent",
        "iui_wait_result_bleeding_timeframe": "À tout moment",
        "iui_wait_result_bleeding_body": "Les saignements n’ont pas à être interprétés seul. La clinique peut quand même vouloir le bêta ou donner des consignes de reprise.",
        "iui_wait_result_bleeding_i1_label": "Message à la clinique",
        "iui_wait_result_bleeding_i1_detail": "Note l’heure, le flux et les symptômes",
        "iui_wait_result_bleeding_i2_label": "Question médicaments",
        "iui_wait_result_bleeding_i2_detail": "Demande avant d’arrêter le soutien lutéal",
        "iui_wait_result_bleeding_i3_label": "Prochain état de base",
        "iui_wait_result_bleeding_i3_detail": "La clinique peut planifier autour des prochaines règles",
        "oi_wait_result_window_title": "La fenêtre du test prévu",
        "oi_wait_result_window_timeframe": "31 mai",
        "oi_wait_result_window_body": "Après l’ovulation, la date du test de la clinique est le signal le plus clair. Les symptômes ne peuvent pas confirmer le résultat.",
        "oi_wait_result_window_i1_label": "Moment de l’ovulation",
        "oi_wait_result_window_i1_detail": "Enregistré dans votre cycle",
        "oi_wait_result_window_i2_label": "Test de la clinique",
        "oi_wait_result_window_i2_detail": "Utilisez la date donnée par votre clinique",
        "oi_wait_result_window_i3_label": "Prochaine conversation",
        "oi_wait_result_window_i3_detail": "Revoir le résultat avant de modifier votre plan",
        "oi_wait_result_bleeding_title": "Si des saignements commencent",
        "oi_wait_result_bleeding_timeframe": "À tout moment",
        "oi_wait_result_bleeding_body": "Écrivez à la clinique si des saignements commencent avant le test prévu ou si vous ne savez pas quoi faire avec vos médicaments.",
        "oi_wait_result_bleeding_i1_label": "Message à la clinique",
        "oi_wait_result_bleeding_i1_detail": "Notez l’heure, le flux et les symptômes",
        "oi_wait_result_bleeding_i2_label": "Question médicaments",
        "oi_wait_result_bleeding_i2_detail": "Demandez avant d’arrêter un soutien prescrit",
        "oi_wait_result_bleeding_i3_label": "Cycle suivant",
        "oi_wait_result_bleeding_i3_detail": "Planifiez seulement après confirmation de la clinique",
        "beta_wait_wtk_symptoms_badge": "Symptômes",
        "beta_wait_wtk_symptoms_title": "Les symptômes ne sont pas un résultat",
        "beta_wait_wtk_symptoms_body": "Crampes, sensibilité des seins, légers saignements ou aucun symptôme : tout peut arriver après un transfert et avec la progestérone.",
        "beta_wait_wtk_symptoms_b1": "Note les symptômes s’ils t’aident à communiquer avec la clinique.",
        "beta_wait_wtk_symptoms_b2": "N’utilise pas l’intensité des symptômes pour prédire le bêta.",
        "beta_wait_wtk_symptoms_b3": "Le repos, l’hydratation et une activité normale et douce sont tout à fait bien.",
        "beta_wait_wtk_testing_badge": "Tests",
        "beta_wait_wtk_testing_title": "Le bêta guide la décision",
        "beta_wait_wtk_testing_body": "La prise de sang bêta est le signal le plus clair pour la suite. Tester plus tôt ajoute du bruit sans changer le plan.",
        "beta_wait_wtk_testing_b1": "Garde le rendez-vous bêta bien visible.",
        "beta_wait_wtk_testing_b2": "Continue les médicaments jusqu’à ce que la clinique les change.",
        "beta_wait_wtk_testing_b3": "Attends-toi à un second bêta si le premier est positif.",
        "beta_wait_wtk_hometest_badge": "Tests maison",
        "beta_wait_wtk_hometest_title": "Tu as fait un test maison ?",
        "beta_wait_wtk_hometest_body": "Beaucoup de personnes font un test maison pendant l'attente. En ce moment le résultat peut t'induire en erreur dans un sens comme dans l'autre, alors prends-le avec du recul et laisse le bêta trancher.",
        "beta_wait_wtk_hometest_b1": "Ton injection de déclenchement contient de l'hCG, donc un positif précoce peut n'être que le reste du déclenchement.",
        "beta_wait_wtk_hometest_b2": "Il peut être trop tôt pour un vrai positif, donc un négatif maintenant n'est pas fiable.",
        "beta_wait_wtk_hometest_b3": "Quoi que dise le test, c'est le bêta en clinique qui décide de la suite.",
        "beta_wait_wtk_support_badge": "Quand appeler",
        "beta_wait_wtk_support_title": "Quand appeler ta clinique",
        "beta_wait_wtk_support_body": "La plupart de ce que tu ressens pendant l’attente est normal. Voici les signes qui méritent un appel tout de suite.",
        "beta_wait_wtk_support_b1": "Douleur pelvienne sévère ou d’un seul côté.",
        "beta_wait_wtk_support_b2": "Saignements abondants, fièvre ou sensation d’évanouissement.",
        "beta_wait_wtk_support_b3": "Essoufflement ou ballonnement rapide et sévère.",
        "iui_wait_wtk_trigger_badge": "Déclenchement",
        "iui_wait_wtk_trigger_title": "Le déclenchement peut fausser les tests précoces",
        "iui_wait_wtk_trigger_body": "L’Ovitrelle et les autres déclencheurs à l’hCG peuvent persister, donc les tests urinaires précoces peuvent sembler positifs avant qu’une grossesse soit confirmée.",
        "iui_wait_wtk_trigger_b1": "Utilise la date du bêta clinique pour décider.",
        "iui_wait_wtk_trigger_b2": "Évite de changer les médicaments d’après les tests à la maison.",
        "iui_wait_wtk_trigger_b3": "Note les symptômes pour le contexte, pas pour prédire.",
        "iui_wait_wtk_meds_badge": "Médicaments",
        "iui_wait_wtk_meds_title": "Garde le soutien lutéal simple",
        "iui_wait_wtk_meds_body": "Si de la progestérone ou un autre soutien a été prescrit, l’accueil doit le présenter comme une ligne du Aujourd’hui ordinaire.",
        "iui_wait_wtk_meds_b1": "Continue sauf si la clinique change le plan.",
        "iui_wait_wtk_meds_b2": "Demande avant d’arrêter en cas de saignements.",
        "iui_wait_wtk_meds_b3": "Garde les renouvellements ou les doses manquées visibles comme tâches.",
        "iui_wait_wtk_next_badge": "Suite",
        "iui_wait_wtk_next_title": "L’étape suivante dépend du bêta",
        "iui_wait_wtk_next_body": "Après le résultat, la page bascule vers le soutien positif, les consignes en cas de négatif ou la préparation du cycle suivant.",
        "iui_wait_wtk_next_b1": "Si positif, le timing du bêta de contrôle devient le centre.",
        "iui_wait_wtk_next_b2": "Si négatif, les consignes d’arrêt et la prépa consultation deviennent le centre.",
        "iui_wait_wtk_next_b3": "En cas de doute, les tests cliniques de contrôle restent dans Tests.",
        "oi_wait_wtk_ovulation_badge": "Timing",
        "oi_wait_wtk_ovulation_title": "L’ovulation n’est pas le résultat",
        "oi_wait_wtk_ovulation_body": "L’ovulation donne un moment de référence, mais seul le test prévu peut répondre à la question d’une grossesse.",
        "oi_wait_wtk_ovulation_b1": "Utilisez la date du test de la clinique pour décider.",
        "oi_wait_wtk_ovulation_b2": "Les symptômes ne peuvent pas confirmer le résultat.",
        "oi_wait_wtk_ovulation_b3": "Notez le timing ou les symptômes s’ils vous aident à parler à la clinique.",
        "oi_wait_wtk_meds_badge": "Médicaments",
        "oi_wait_wtk_meds_title": "Gardez le plan de la clinique",
        "oi_wait_wtk_meds_body": "Si de la progestérone ou un autre soutien a été prescrit, gardez-le visible comme une ligne normale d’Aujourd’hui.",
        "oi_wait_wtk_meds_b1": "Continuez sauf si la clinique change le plan.",
        "oi_wait_wtk_meds_b2": "Demandez avant d’arrêter en cas de saignements.",
        "oi_wait_wtk_meds_b3": "Gardez visibles les doses manquées ou les questions de renouvellement.",
        "oi_wait_wtk_next_badge": "Suite",
        "oi_wait_wtk_next_title": "La suite dépend du test",
        "oi_wait_wtk_next_body": "Après le résultat, l’accueil doit passer au soutien positif, à une pause entre les cycles ou à une clarification sans supposer ce que vous souhaitez.",
        "oi_wait_wtk_next_b1": "Si positif, le timing du suivi devient le centre.",
        "oi_wait_wtk_next_b2": "Si négatif, la revue du cycle et les options de pause deviennent le centre.",
        "oi_wait_wtk_next_b3": "En cas de doute, les tests répétés restent avec la clinique.",
        "today_rows_iui_wait_luteal_title": "Soutien lutéal",
        "today_rows_iui_wait_luteal_detail": "Continue la progestérone ou un autre soutien si prescrit.",
        "today_rows_iui_wait_avoid_title": "Évite les conclusions hâtives",
        "today_rows_iui_wait_avoid_detail": "L’hCG du déclenchement peut fausser les tests à la maison avant le bêta clinique.",
        "today_rows_iui_wait_this_week": "Cette semaine",
        "today_rows_iui_wait_beta_title": "Bêta clinique",
        "today_rows_iui_wait_beta_detail": "Prise de sang pour le résultat de l’IIU.",
        "today_rows_oi_wait_luteal_title": "Soutien prescrit",
        "today_rows_oi_wait_luteal_detail": "Continuez la progestérone ou un autre soutien si prescrit.",
        "today_rows_oi_wait_avoid_title": "Attendre le test prévu",
        "today_rows_oi_wait_avoid_detail": "Les tests à la maison et les symptômes ne peuvent pas confirmer le résultat si tôt.",
        "today_rows_oi_wait_this_week": "Cette semaine",
        "today_rows_oi_wait_beta_title": "Test de grossesse",
        "today_rows_oi_wait_beta_detail": "Utilisez la date donnée par votre clinique après l’ovulation.",
        "today_rows_iui_active_trigger_title": "Déclenchement Ovitrelle",
        "today_rows_iui_active_trigger_detail": "Injection ce soir. IIU prévue 36 heures plus tard.",
        "today_rows_iui_active_partner_title": "Échantillon du partenaire",
        "today_rows_iui_active_partner_detail": "Prélèvement avant le lavage au labo. Fenêtre d’abstinence : jour 3.",
        "today_rows_iui_active_iui_title": "Rendez-vous IIU",
        "today_rows_iui_active_iui_detail": "Arrive 15 minutes en avance.",
        "today_rows_stim_gonal_title": "Gonal-F 225 UI",
        "peek_day_tomorrow": "Demain",
        "peek_day_may_21": "21 mai",
        "peek_day_may_22": "22 mai",
        "peek_monitoring_title": "Visite de monitoring",
        "peek_monitoring_detail": "Échographie + prise de sang. Les doses peuvent être ajustées ensuite.",
        "peek_gonal_title": "Gonal-F 225 UI",
        "peek_gonal_detail": "Garde la dose dans le calendrier sauf changement de la clinique.",
        "peek_cetrotide_title": "Cetrotide",
        "peek_cetrotide_detail": "Bloque l’ovulation précoce pendant que les follicules continuent de grandir.",
        "peek_supply_title": "Vérification du stock",
        "peek_supply_detail": "Assure-toi d’avoir l’antagoniste et les médicaments de déclenchement sous la main.",
        "peek_dose_title": "Ajustement de dose possible",
        "peek_dose_detail": "La clinique peut ajuster le plan après relecture des résultats.",
        "peek_dose_afternoon": "Après-midi",
        "peek_empty_title": "Rien de prévu pour l’instant.",
        "peek_empty_detail": "Cette journée pourra se remplir après le monitoring de demain et les consignes de la clinique.",
        "due_at_visit": "Au rendez-vous",
        "due_before_consult": "Avant la consultation",
        "due_after_consult": "Après la consultation",
        "due_after_shortlist": "Après présélection",
        "due_after_donor_selected": "Après choix de la donneuse",
        "sperm_active_collection_quality_section_title": "Qualité du prélèvement",
        "sperm_active_collection_quality_section_subtitle": "Concentre-toi sur les facteurs de prélèvement que tu peux contrôler.",
        "sperm_active_metrics_title": "Vérifications avant prélèvement",
        "sperm_active_metric_abstinence_label": "Abstinence",
        "sperm_active_metric_abstinence_value": "3 jours",
        "sperm_active_metric_abstinence_note": "dans la cible 2-5 jours",
        "sperm_active_metric_fever_label": "Fièvre/chaleur",
        "sperm_active_metric_fever_value": "Aucune",
        "sperm_active_metric_fever_note": "ces 10 derniers jours",
        "sperm_active_metric_hydration_label": "Hydratation",
        "sperm_active_metric_hydration_value": "Notée",
        "sperm_active_metric_hydration_note": "aujourd’hui",
        "sperm_active_metric_id_label": "Pièce d’identité + consentement",
        "sperm_active_metric_id_value": "Prêts",
        "sperm_active_metric_id_note": "obligatoires",
        "sperm_active_tasks_collection_title": "Consignes de prélèvement",
        "sperm_active_task_arrive_title": "Apporte une pièce d’identité",
        "sperm_active_task_arrive_detail": "Le contrôle d’identité est nécessaire avant que l’échantillon soit accepté.",
        "sperm_active_task_arrive_time": "8 h 30",
        "sperm_active_task_estimate_title": "Demande l’estimation après décongélation",
        "sperm_active_task_estimate_detail": "Cela aide à savoir si l’inventaire convient mieux à l’IIU ou à la FIV/ICSI.",
        "sperm_active_task_disposition_title": "Choisis les paramètres de devenir",
        "sperm_active_task_disposition_detail": "Conservation, usage futur, destruction et choix en cas de décès ou d’incapacité doivent être documentés.",
        "sperm_active_task_disposition_due": "Avant la conservation",
        "sperm_wait_section_lab_check_title": "Ce que le labo vérifie",
        "sperm_wait_section_lab_check_subtitle": "Comprends pourquoi les résultats prennent du temps et ce que chaque indicateur change.",
        "sperm_wait_semen_title": "Résultats de l’analyse de sperme",
        "sperm_wait_decision_title": "Suite selon les résultats",
        "sperm_wait_decision_d1_title": "Objectif atteint",
        "sperm_wait_decision_d1_detail": "La confirmation de stockage devient la tâche principale.",
        "sperm_wait_decision_d1_status": "Stocker",
        "sperm_wait_decision_d2_title": "Nombre de paillettes limite",
        "sperm_wait_decision_d2_detail": "Un nouveau prélèvement améliore la redondance.",
        "sperm_wait_decision_d2_status": "Reprélever",
        "sperm_wait_decision_d3_title": "Analyse anormale",
        "sperm_wait_decision_d3_detail": "Une remise à zéro de 72-90 jours, une nouvelle analyse et un avis d’urologie deviennent utiles.",
        "sperm_wait_decision_d3_status": "Optimiser",
        "sperm_postcycle_future_use_title": "Estimation d’utilisation future",
        "sperm_postcycle_future_use_subtitle": "Si tu les utilises plus tard, voici une projection approximative.",
        "sperm_postcycle_projection_unavailable_title": "Estimation d’utilisation future indisponible",
        "sperm_postcycle_projection_unavailable_detail": "Une estimation évaluée sur le plan clinique sera affichée lorsque les échantillons et les rapports enregistrés le permettront.",
        "sperm_postcycle_funnel_s1_label": "Échantillon",
        "sperm_postcycle_funnel_s1_detail": "Estimation des spermatozoïdes utilisables avant congélation.",
        "sperm_postcycle_funnel_s2_label": "Traités",
        "sperm_postcycle_funnel_s2_detail": "Après lavage et préparation au labo.",
        "sperm_postcycle_funnel_s3_label": "Paillettes congelées",
        "sperm_postcycle_funnel_s3_detail": "Conservées sur l’ensemble des prélèvements.",
        "sperm_postcycle_funnel_s4_label": "Utilisables après décongélation",
        "sperm_postcycle_funnel_s4_detail": "Estimation des paillettes mobiles après décongélation.",
        "egg_postcycle_future_use_title": "Estimation d’utilisation future",
        "egg_postcycle_future_use_subtitle": "Si tu les utilises plus tard, voici une projection approximative.",
        "embryo_postcycle_future_use_title": "Estimation d’utilisation future",
        "embryo_postcycle_future_use_subtitle": "Si tu les utilises plus tard, voici une projection approximative.",
        "handoff_decide_title": "Choisis ta prochaine étape",
        "handoff_egg_body": "Quand tu es prête, tu peux refaire un cycle pour mettre plus d’ovocytes en banque, ou les décongeler pour une FIV.",
        "handoff_egg_cta": "Explore tes options",
        "handoff_egg_chat_prompt": "Examine l’ensemble de mon profil actuel, mon parcours de fertilité, mes traitements, les résultats de mes cycles et mes objectifs. Aide-moi à comparer mes options après la congélation d’ovocytes, notamment refaire un cycle de ponction, utiliser mes ovocytes congelés pour une FIV ou les garder en conservation. Explique les avantages et les inconvénients, les informations qui pourraient manquer et les questions utiles à poser à mon équipe soignante. Je souhaite pouvoir poser des questions de suivi. Quand je choisis une voie, termine par une prochaine étape concrète et demande mon accord avant d’ouvrir une configuration de traitement.",
        "handoff_egg_check_1": "Démarrer un nouveau cycle pour en banque plus",
        "handoff_egg_check_2": "Utiliser tes ovocytes pour une FIV",
        "handoff_egg_check_3": "Les garder en conservation",
        "handoff_embryo_body": "Quand tu es prête, tu peux planifier un transfert d’embryon congelé, créer plus d’embryons ou les garder en conservation.",
        "handoff_embryo_cta": "Explore tes options",
        "handoff_embryo_chat_prompt": "Examine l’ensemble de mon profil actuel, mon parcours de fertilité, mes traitements, les résultats de mes cycles et mes objectifs. Aide-moi à comparer mes options après la congélation d’embryons, notamment planifier un transfert d’embryon congelé, créer plus d’embryons ou les garder en conservation. Explique les avantages et les inconvénients, les informations qui pourraient manquer et les questions utiles à poser à mon équipe soignante. Je souhaite pouvoir poser des questions de suivi. Quand je choisis une voie, termine par une prochaine étape concrète et demande mon accord avant d’ouvrir une configuration de traitement.",
        "handoff_embryo_check_1": "Planifier un transfert d’embryon congelé",
        "handoff_embryo_check_2": "Créer plus d’embryons",
        "handoff_embryo_check_3": "Les garder en conservation",
        "handoff_sperm_body": "Quand tu es prêt, tu peux utiliser tes échantillons stockés pour un traitement, en prélever d’autres ou les garder en conservation.",
        "handoff_sperm_cta": "Explore tes options",
        "handoff_sperm_chat_prompt": "Examine l’ensemble de mon profil actuel, mon parcours de fertilité, mes traitements, les résultats de mes cycles et mes objectifs. Aide-moi à comparer mes options après la congélation de sperme, notamment utiliser mes échantillons stockés pour un traitement, en prélever d’autres ou les garder en conservation. Explique les avantages et les inconvénients, les informations qui pourraient manquer et les questions utiles à poser à mon équipe soignante. Je souhaite pouvoir poser des questions de suivi. Quand je choisis une voie, termine par une prochaine étape concrète et demande mon accord avant d’ouvrir une configuration de traitement.",
        "handoff_sperm_check_1": "Utiliser tes échantillons pour un traitement",
        "handoff_sperm_check_2": "Mettre un autre échantillon en banque",
        "handoff_sperm_check_3": "Les garder en conservation",
        "ivf_negative_after_section_title": "Après un résultat négatif",
        "ivf_negative_after_section_subtitle": "Garde les consignes de soin et les données du cycle prêtes pour la consultation.",
        "ivf_negative_after_tasks_title": "Préparer la consultation",
        "ivf_negative_after_t1_title": "Note tes questions",
        "ivf_negative_after_t1_detail": "Qualité embryonnaire, timing de la progestérone, préparation de l’endomètre et ajustements de protocole.",
        "ivf_negative_after_t2_title": "Téléverse le compte rendu",
        "ivf_negative_after_t2_detail": "Le résultat du bêta et les consignes d’arrêt sont rattachés à ce cycle.",
        "ivf_negative_after_t3_title": "Choisis ton rythme",
        "ivf_negative_after_t3_detail": "Utiliser un embryon en réserve, refaire une ponction ou faire une pause.",
        "intended_parent_match_section_title": "Espace de matching",
        "intended_parent_match_section_subtitle": "Rends concrets les volets donneuse, GPA, embryon et juridique.",
        "intended_parent_match_decision_title": "Présélections",
        "intended_parent_match_d1_title": "Donneuse d’ovocytes A",
        "intended_parent_match_d1_detail": "27 ans, compatible porteuse, disponible en juillet, frais agence 18 k$.",
        "intended_parent_match_d1_status": "Préférée",
        "intended_parent_match_d2_title": "Donneuse d’ovocytes B",
        "intended_parent_match_d2_detail": "31 ans, cycle précédent solide, un croisement porteuse à revoir.",
        "intended_parent_match_d2_status": "À revoir",
        "intended_parent_match_d3_title": "Agence de GPA",
        "intended_parent_match_d3_detail": "Deux agences acceptent tes critères d’État/juridiques.",
        "intended_parent_match_d3_status": "Appels",
        "intended_parent_match_tasks_title": "Avant la création d’embryons",
        "intended_parent_match_t1_title": "Choisir la source de sperme",
        "intended_parent_match_t1_detail": "Sperme du partenaire, don ou fécondation partagée.",
        "intended_parent_match_t2_title": "Démarche juridique",
        "intended_parent_match_t2_detail": "Accords donneuse et GPA plus structure du séquestre.",
        "intended_parent_match_t3_title": "Plan de création d’embryons",
        "intended_parent_match_t3_detail": "Clinique et labo créent les embryons avant le transfert à la porteuse.",
        "log_date_today": "Aujourd’hui",
        "log_date_yesterday": "Hier",
        "log_date_may_15": "15 mai",
        "log_cycle_day_4": "Jour 4",
        "log_cycle_day_6": "Jour 6",
        "log_cycle_day_7": "Jour 7",
        "today_label_today": "Aujourd’hui",
        "today_label_any_time": "À tout moment",
        "action_calendar": "Calendrier",
        "action_complete_history": "Compléter mon historique",
        "action_check_tests": "Voir mes analyses",
        "action_find_care": "Trouver un centre",
        "action_check_coverage": "Vérifier ma couverture",
        "action_open_program": "Ouvrir le programme",
        "action_open_documents": "Ouvrir les documents",
        "action_review_meds": "Voir mes médicaments",
        "action_open_care_team": "Voir mon équipe soignante",
        "action_log_monitoring": "Noter les résultats du monitoring",
        "action_log_symptoms": "Noter mes symptômes",
        "action_open_care": "Ouvrir mes soins",
        "action_view_cryo_vault": "Voir mon coffre cryogénique",
        "test_preview_new_result": "Nouveau résultat",
        "test_preview_waiting": "En attente des résultats",
        "iui_insight_lh_test_name": "LH",
        "iui_insight_lh_purpose": "Indique si ton corps est déjà en train de déclencher l’ovulation avant l’injection",
        "iui_insight_lh_value": "Bas",
        "iui_insight_lh_headline": "LH bas avant le déclenchement",
        "iui_insight_lh_interpretation": "Un LH bas veut dire que la clinique ne voit pas encore de pic spontané.",
        "iui_insight_lh_meaning": "C’est cohérent avec l’utilisation du déclenchement prévu pour contrôler le timing de l’IIU.",
        "iui_insight_lh_next": "Respecte l’heure du déclenchement donnée par ta clinique.",
        "iui_insight_progesterone_test_name": "Progestérone",
        "iui_insight_progesterone_purpose": "Vérifie si l’ovulation a déjà commencé",
        "iui_insight_progesterone_headline": "La progestérone est encore en phase pré-ovulatoire",
        "iui_insight_progesterone_interpretation": "La progestérone est assez basse pour que l’ovulation n’ait probablement pas encore eu lieu.",
        "iui_insight_progesterone_meaning": "La fenêtre de timing actuelle reste cohérente avec le plan de déclenchement et d’IIU.",
        "iui_insight_progesterone_next": "Poursuis le déclenchement prévu sauf consigne contraire de la clinique.",
        "iui_insight_semen_test_name": "Spermogramme",
        "iui_insight_semen_purpose": "Aide à estimer si l’échantillon convient pour une IIU",
        "iui_insight_semen_value": "En attente",
        "iui_insight_semen_headline": "Le nombre post-lavage sera mis à jour le jour de l’IIU",
        "iui_insight_semen_interpretation": "Pour l’IIU, le nombre de spermatozoïdes mobiles après lavage est souvent le chiffre le plus utile.",
        "iui_insight_semen_meaning": "Le labo traite l’échantillon avant l’insémination et note le nombre final.",
        "iui_insight_semen_next": "Garde bien en vue le rendez-vous de prélèvement et l’horaire du lavage.",
        "iui_insight_beta_test_name": "Bêta hCG",
        "iui_insight_beta_purpose": "Confirme la grossesse après l’attente post-IIU",
        "iui_insight_beta_value": "Programmé",
        "iui_insight_beta_headline": "Le bêta est prévu après l’attente",
        "iui_insight_beta_interpretation": "Le bêta sanguin est le résultat clinique utilisé pour décider après une IIU.",
        "iui_insight_beta_meaning": "Tester trop tôt peut prêter à confusion, surtout après un déclenchement à l’hCG.",
        "iui_insight_beta_next": "Utilise la date du bêta clinique pour les décisions de la suite."
      }
    },
    "schedule": {
      "tomorrow": "Demain",
      "nothing_scheduled": "Rien de prévu",
      "nothing_scheduled_detail": "Aucun médicament ni rendez-vous ce jour-là pour l’instant."
    },
    "pending_semen_analysis": {
      "test_name": "Spermogramme",
      "test_purpose": "Numération, mobilité et morphologie des spermatozoïdes regroupées",
      "value": "Voir les détails",
      "headline": "Spermogramme en attente",
      "interpretation": "Le laboratoire analyse l’échantillon et publiera les résultats du spermogramme dès qu’ils seront prêts.",
      "what_this_means": "Ce résultat aide à savoir si l’échantillon actuel suffit, si un nouveau prélèvement est utile, et comment l’échantillon pourra être utilisé par la suite.",
      "next_step": "Attends le résultat du laboratoire avant d’adapter le plan."
    },
    "guided_precycle": {
      "actions": {
        "plan_builder": "Choisis ton parcours",
        "learn": "Découvrir les options",
        "testing": "Voir les examens",
        "medical_history": "Compléter les antécédents",
        "care": "Ouvrir les soins",
        "find_care": "Trouver un centre",
        "coverage": "Vérifier la prise en charge"
      },
      "setup": {
        "eyebrow": "Mise en place",
        "title": "Mets en place ton espace fertilité",
        "phase_description": "Commence par les quelques infos qui rendent chaque plan pré-cycle plus utile : ton objectif, où tu en es dans le parcours et les données que tu as déjà.",
        "intro": "En quelques minutes, on transforme un profil vide en plan pré-cycle guidé.",
        "snapshot_next_label": "À suivre",
        "snapshot_next_value": "Choisis ton parcours",
        "snapshot_cycle_label": "Cycle de traitement",
        "snapshot_cycle_value": "Pas encore choisi",
        "section_path_step_label": "Étape 1 : choisis ton parcours",
        "section_path_title": "Dis-nous ce que tu explores",
        "section_path_body": "Choisis l’objectif qui te correspond aujourd’hui. L’espace s’adapte ensuite à l’autoconservation d’ovocytes, à la congélation d’embryons, à l’autoconservation du sperme, à la FIV, à l’IIU, au don, à la GPA ou au parcours de parent d’intention.",
        "section_path_bullet_preserve": "Préserver sa fertilité pour plus tard",
        "section_path_bullet_pregnant": "Essayer de tomber enceinte",
        "section_path_bullet_donate": "Faire un don d’ovocytes, de sperme ou porter pour quelqu’un",
        "section_baseline_step_label": "Étape 2 : ajoute tes données de départ",
        "section_baseline_title": "Ajoute les premières infos qui changent les recommandations",
        "section_baseline_body": "L’âge, l’historique des cycles, les projets avec un partenaire ou un don, les examens déjà faits et les antécédents médicaux déterminent les sections pré-cycle à traiter en priorité.",
        "section_baseline_bullet_history": "Antécédents médicaux",
        "section_baseline_bullet_labs": "Examens déjà réalisés",
        "section_baseline_bullet_coverage": "Prise en charge et localisation",
        "section_care_step_label": "Étape 3 : trouve un centre",
        "section_care_title": "Commence à comparer le bon parcours de soins",
        "section_care_body": "Une fois l’objectif clair, les démarches autour du centre, du laboratoire, du don, de la GPA et de la prise en charge rejoignent le même plan guidé.",
        "section_care_bullet_clinics": "Centres",
        "section_care_bullet_programs": "Programmes",
        "section_care_bullet_coverage_fit": "Compatibilité prise en charge"
      },
      "learn_explorer": {
        "eyebrow": "Découvrir",
        "title": "Explore les options sans choisir trop vite",
        "phase_description": "Utilise la même structure guidée pour comparer les parcours, avant même de savoir si la prochaine étape est un examen, le choix d’un centre, un don ou un traitement.",
        "intro": "Commence large, puis affine vers le plan pré-cycle qui correspond à ton objectif.",
        "snapshot_next_label": "À suivre",
        "snapshot_next_value": "Comparer les parcours",
        "snapshot_cycle_label": "Cycle de traitement",
        "snapshot_cycle_value": "Pas encore choisi",
        "section_options_step_label": "Étape 1 : compare les options",
        "section_options_title": "Compare les options",
        "section_options_body": "Passe d’un parcours biologique à l’autre au fil de ta réflexion.",
        "section_options_bullet_preservation": "Préservation",
        "section_options_bullet_pregnancy": "Traitement de fertilité",
        "section_options_bullet_donor_or_carrier": "Don ou GPA",
        "section_numbers_step_label": "Étape 2 : connais tes chiffres clés",
        "section_numbers_title": "Connais tes chiffres clés",
        "section_numbers_body": "Ajoute seulement les chiffres qui t’aident à comparer les parcours que tu envisages.",
        "section_numbers_bullet_ovarian": "Réserve ovarienne",
        "section_numbers_bullet_semen": "Spermogramme",
        "section_numbers_bullet_carrier": "Dépistage des porteurs sains",
        "section_care_step_label": "Étape 3 : trouve des soins",
        "section_care_title": "Trouve des soins",
        "section_care_body": "Quand tu es prêt·e, compare les soins qui correspondent au parcours que tu veux suivre.",
        "section_care_bullet_clinics": "Centres",
        "section_care_bullet_labs": "Laboratoires",
        "section_care_bullet_programs": "Programmes",
        "biology_options_title": "Regarde les différentes options",
        "biology_options_subtitle": "Choisis un parcours pour voir sa biologie, son calendrier et les décisions qui le structurent. Tu peux changer quand tu veux.",
        "biology_option_egg_freezing": "Congélation d’ovocytes",
        "biology_option_embryo_freezing": "Congélation d’embryons",
        "biology_option_iui": "IIU",
        "biology_option_ivf": "FIV",
        "biology_option_sperm_freezing": "Congélation de sperme",
        "handoff_title": "Prêt·e à choisir un parcours ?",
        "handoff_body": "Quand une direction te semble juste, transforme ce que tu as appris en plan avec les prochaines étapes, les bonnes personnes et les soins adaptés.",
        "handoff_cta": "Choisir ton parcours",
        "handoff_chat": "En parler",
        "handoff_chat_prompt": "J’explore les options de fertilité et de projet parental et j’aimerais comparer ce que j’ai appris. Pose-moi des questions sur ce qui compte pour moi, indique-moi les informations qui peuvent encore manquer et aide-moi à choisir une prochaine étape utile sans supposer que j’ai déjà choisi un traitement.",
        "handoff_check_options": "Options comparées",
        "handoff_check_numbers": "Chiffres réunis",
        "handoff_check_care": "Soins prêts à comparer"
      },
      "trying_naturally": {
        "eyebrow": "Essais naturels",
        "title": "Un plan pour essayer naturellement",
        "phase_description": "Utilise les soins déjà disponibles sans être orienté·e vers un traitement.",
        "intro": "Commence par l’essentiel, suis uniquement ce qui t’est utile et garde un accès clair aux soins si tes besoins évoluent.",
        "snapshot_next_label": "À suivre",
        "snapshot_next_value": "Revoir tes antécédents",
        "snapshot_cycle_label": "Cycle de traitement",
        "snapshot_cycle_value": "Pas nécessaire pour commencer",
        "section_preparation_step_label": "Étape 1 : prépare-toi",
        "section_preparation_title": "Rassemble ton contexte de départ",
        "section_preparation_body": "Revois tes antécédents et les bases de la préparation à la grossesse avant de décider si des examens ou une consultation sont utiles.",
        "section_preparation_bullet_history": "Antécédents médicaux",
        "section_preparation_bullet_health": "Préparation à la grossesse",
        "section_preparation_bullet_partner": "Contexte partenaire ou don",
        "section_tracking_step_label": "Étape 2 : suis ce qui t’aide",
        "section_tracking_title": "Utilise les soins sans démarrer de traitement",
        "section_tracking_body": "Tu peux utiliser le calendrier et les suivis disponibles sans créer de cycle de traitement. Les prédictions restent des estimations et ne prouvent ni l’ovulation ni la fertilité.",
        "section_tracking_bullet_cycle": "Historique des cycles",
        "section_tracking_bullet_optional": "Signaux facultatifs",
        "section_tracking_bullet_estimates": "Estimations transparentes",
        "section_care_step_label": "Étape 3 : sache quand consulter",
        "section_care_title": "Garde l’évaluation et les soins à portée de main",
        "section_care_body": "Quand ton calendrier, tes symptômes, tes facteurs de risque ou tes questions nécessitent un soutien, utilise Trouver un centre pour préparer la prochaine conversation.",
        "section_care_bullet_timing": "Durée des essais",
        "section_care_bullet_risk": "Questions liées aux risques",
        "section_care_bullet_provider": "Choix de professionnels"
      },
      "ivf_precycle": {
        "eyebrow": "Préparation FIV",
        "title": "Prépare la FIV avant le démarrage du cycle",
        "phase_description": "Préparer une FIV demande de regrouper au même endroit la réserve ovarienne, l’évaluation utérine, l’origine du sperme ou du don, la méthode de fécondation, le choix du centre, les médicaments, les décisions du laboratoire et le plan de transfert.",
        "intro": "Utilise ce plan guidé pour comprendre la FIV, faire les examens de départ, comparer les centres et te préparer au début du cycle.",
        "snapshot_next_label": "À suivre",
        "snapshot_next_value": "Examens de départ",
        "snapshot_cycle_label": "Cycle de traitement",
        "snapshot_cycle_value": "Pas encore programmé"
      },
      "iui_precycle": {
        "eyebrow": "Préparation IIU",
        "title": "Prépare l’IIU avant le jour 1 du cycle",
        "phase_description": "Préparer une IIU demande de caler le timing de l’ovulation, l’état des trompes, l’origine du sperme, le choix des médicaments, le calendrier de suivi, le déclenchement et le plan pour la bêta-hCG.",
        "intro": "Utilise ce plan guidé pour confirmer que l’IIU est adaptée, faire les examens de départ et comprendre le calendrier avant le début du traitement.",
        "snapshot_next_label": "À suivre",
        "snapshot_next_value": "Confirmer que l’IIU convient",
        "snapshot_cycle_label": "Cycle de traitement",
        "snapshot_cycle_value": "Pas encore programmé"
      },
      "amab_family_building_precycle": {
        "eyebrow": "Projet parental",
        "title": "Construis le parcours autour du sperme, du don, de la GPA et des embryons",
        "phase_description": "Pour un projet parental côté AMAB, on garde la même structure guidée, mais on met d’abord en avant l’analyse du sperme, le don d’ovocytes, le parcours GPA, le volet juridique, le coût et la création des embryons.",
        "intro": "Utilise ce plan guidé pour comparer les apports en sperme, les voies don et GPA, les équipes médicales et la séquence avant la création d’embryons.",
        "snapshot_next_label": "À suivre",
        "snapshot_next_value": "Sperme et plan d’apport",
        "snapshot_cycle_label": "Cycle de traitement",
        "snapshot_cycle_value": "Pas encore programmé"
      }
    }
  },
  "you": {
    "panel_titles": {
      "personal_info": "Informations personnelles",
      "medical_fertility": "Médical et fertilité",
      "coverage_benefits": "Couverture santé",
      "connections": "Connexions et partage",
      "research_studies": "Études de recherche",
      "notifications": "Notifications",
      "integrations": "Intégrations",
      "preferences": "Préférences",
      "account": "Compte"
    },
    "overview": {
      "your_info_header": "Vos informations",
      "settings_header": "Paramètres",
      "personal_info_value": "${filled} sur ${total}",
      "medical_fertility_progress": "${completed} sur ${total} terminées",
      "medical_fertility_not_set": "Non renseigné",
      "coverage_on_file": "Couverture enregistrée",
      "coverage_add": "Ajouter une couverture",
      "connections_count": "${count} connecté·e·s",
      "connections_recorded_count": "${count} enregistrements de l’équipe",
      "connections_none": "Aucune",
      "research_matched": "${count} correspondant·e·s",
      "research_none": "Aucune étude admissible",
      "notifications_active": "${count} actives",
      "notifications_loading": "Chargement…",
      "notifications_unavailable": "Indisponible",
      "integrations_apple_health_data": "Données Apple Health",
      "integrations_none": "Aucune"
    },
    "profile_header": {
      "add_your_name": "Ajoutez votre prénom",
      "name_save_failed": "Nous n’avons pas pu enregistrer votre prénom. Le prénom saisi est toujours là.",
      "avatar_upload_failed": "Nous n’avons pas pu modifier votre photo. La photo précédente est toujours utilisée."
    },
    "email_badge": {
      "verify": "Vérifier",
      "resend": "Renvoyer",
      "check_your_email": "Consultez votre e-mail",
      "sent": "Envoyé !",
      "failed_to_send": "Nous n’avons pas pu envoyer le lien de vérification. Réessayez."
    },
    "phone_badge": {
      "verify": "Vérifier",
      "submit": "Valider",
      "code_placeholder": "000000",
      "failed_to_send": "Échec de l'envoi du code",
      "invalid_code": "Code invalide"
    },
    "personal_info": {
      "section_title": "Informations personnelles",
      "name_label": "Prénom",
      "name_placeholder": "Votre prénom",
      "first_name_label": "Prénom",
      "first_name_placeholder": "Prénom",
      "last_name_label": "Nom de famille",
      "last_name_placeholder": "Nom de famille",
      "email_label": "Adresse e-mail",
      "email_placeholder": "nom@exemple.com",
      "phone_label": "Téléphone",
      "sex_at_birth_label": "Sexe à la naissance",
      "sex_at_birth_placeholder": "Sélectionnez le sexe à la naissance",
      "sex_female": "Femme (AFAB)",
      "sex_male": "Homme (AMAB)",
      "sex_at_birth_change_hint": "La modification de ce choix nécessite une confirmation.",
      "sex_at_birth_change_title": "Modifier le sexe à la naissance ?",
      "sex_at_birth_change_personalization_description": "Nous mettrons à jour les questions, recommandations et tests qui vous sont présentés. Vos objectifs, votre historique, vos conversations, vos cycles et vos documents resteront inchangés.",
      "sex_at_birth_change_goal_update_description": "Votre objectif actuel est ${goal}. Nous le conserverons, mais les questions, recommandations, tests et tâches de soins affichés pourront être mis à jour. Votre historique restera inchangé.",
      "sex_at_birth_change_goal_conflict_description": "Votre objectif actuel est ${goal}. Cette modification le rend incompatible avec le contexte de soins que nous utilisons. Votre historique restera inchangé, mais vous devrez revoir votre objectif avant d’enregistrer cette modification.",
      "sex_at_birth_goal_conflict_save_message": "Revoyez votre objectif ${goal} avant d’enregistrer cette modification du sexe à la naissance. Vos données enregistrées n’ont pas été modifiées.",
      "sex_at_birth_goal_review_action": "Revoir l’objectif",
      "sex_at_birth_change_cancel": "Conserver le choix",
      "sex_at_birth_change_confirm": "Modifier",
      "birth_date_label": "Date de naissance",
      "address_label": "Adresse",
      "address_hint": "Utilisée pour les livraisons et les courriers liés à vos soins.",
      "emergency_contact_label": "Contact d'urgence",
      "emergency_contact_placeholder": "Ajouter un contact d'urgence",
      "emergency_name_label": "Nom",
      "emergency_name_placeholder": "Nom du contact",
      "emergency_phone_label": "Téléphone",
      "emergency_relationship_label": "Lien",
      "emergency_relationship_placeholder": "Choisir un lien",
      "save_changes": "Enregistrer",
      "cancel": "Annuler",
      "relationship_partner": "Partenaire",
      "relationship_spouse": "Conjoint·e",
      "relationship_parent": "Parent",
      "relationship_child": "Enfant",
      "relationship_sibling": "Frère/Sœur",
      "relationship_friend": "Ami·e",
      "relationship_colleague": "Collègue",
      "relationship_other": "Autre",
      "save_failed_message": "Nous n’avons pas pu enregistrer vos modifications. Réessayez.",
      "save_partial_message": "Certaines modifications ont été enregistrées, mais pas ${fields}. Réessayez.",
      "profile_not_ready_message": "Votre profil est encore en cours de chargement. Réessayez dans un instant.",
      "email_verification_send_failed": "Votre adresse e-mail a été enregistrée, mais nous n’avons pas pu envoyer le lien de vérification. Utilisez Vérifier pour réessayer.",
      "invite_sent": "Invitation envoyée !",
      "invite_failed": "Échec — touchez pour réessayer",
      "invite_send_sms": "Envoyer l'invitation SMS"
    },
    "my_journey": {
      "menu_start_cycle": "Démarrer un cycle de traitement",
      "menu_end_cycle": "Arrêter le cycle",
      "menu_journey_map": "Carte du parcours",
      "menu_change_goal": "Changer d'objectif",
      "menu_a11y": "Actions du cycle",
      "set_your_path": "Définir votre parcours",
      "past_cycles_one": "${count} cycle passé",
      "past_cycles_other": "${count} cycles passés",
      "add_history": "Ajouter un historique",
      "clinic_linked": "Clinique liée",
      "map": "Carte",
      "phase_deciding_label": "Décider",
      "phase_preparing_label": "Préparer",
      "phase_in_treatment_label": "Traiter",
      "phase_storing_label": "Conserver",
      "phase_deciding_heading": "En réflexion",
      "phase_deciding_message": "Prenez le temps de la réflexion — chaque question explorée vous rapproche de votre décision.",
      "phase_preparing_heading": "En préparation",
      "phase_preparing_message": "Tout se met en place pour la suite.",
      "phase_in_treatment_heading": "En traitement",
      "phase_in_treatment_message": "Vous y êtes. Une étape à la fois.",
      "phase_storing_heading": "En conservation",
      "phase_storing_message": "Conservés en sécurité jusqu'à votre prochain pas.",
      "phase_result_label": "Résultat",
      "phase_result_heading": "Votre résultat",
      "phase_result_message": "Le cycle est derrière vous — c'est ici que sa réponse arrive.",
      "intent_exploring": "Exploration",
      "intent_preservation": "Préservation",
      "intent_egg_freezing": "Congélation d'ovocytes",
      "intent_sperm_freezing": "Congélation de sperme",
      "intent_embryo_freezing": "Congélation d'embryons",
      "intent_pregnancy": "Essai de conception",
      "intent_egg_donation": "Don d'ovocytes",
      "intent_sperm_donation": "Don de sperme",
      "intent_adoption": "Adoption",
      "intent_surrogacy": "GPA (gestation pour autrui)",
      "intent_donation": "Don d'ovocytes",
      "intent_conception": "Essai de conception",
      "intent_starting_treatment": "En préparation",
      "intent_in_treatment": "Cycle en cours"
    },
    "my_passport": {
      "header": "Mon passeport",
      "done": "Terminé",
      "badges_collected": "${unlocked} badges sur ${total} obtenus",
      "earned_on": "Obtenu le ${date}",
      "badges_unlocked_together": "${count} badges débloqués",
      "badge_position": "Badge ${position} sur ${count}",
      "newly_unlocked": "Étape franchie — vous avez obtenu un nouveau badge !",
      "new_in_passport": "Cette étape figure maintenant dans votre passeport.",
      "view_in_passport": "Voir dans le passeport",
      "complete_to_unlock": "Réalisez l'action ci-dessus pour le débloquer",
      "loading": "Chargement de votre passeport…",
      "unavailable": "Votre passeport est temporairement indisponible. Réessayez dans un instant."
    },
    "partner_card": {
      "waiting_for": "En attente de ${name}…",
      "waiting_for_partner": "En attente de ton/ta partenaire…",
      "we_sent_invite": "Nous avons envoyé une invitation à ${name}. Nous vous préviendrons dès qu'il rejoint.",
      "we_sent_invite_generic": "Nous avons envoyé une invitation. Nous vous préviendrons dès qu’iel rejoint.",
      "pending": "En attente",
      "resend": "Renvoyer",
      "manage_invitation": "Gérer l’invitation",
      "doing_this_with_someone": "Vous traversez cette étape à deux ?",
      "invite_blurb": "Invitez un·e partenaire pour coordonner vos soins et partager le parcours. Vous décidez de ce qu'il·elle peut voir.",
      "compact_blurb": "Invitez un·e partenaire pour coordonner vos soins.",
      "invite_partner": "Inviter un·e partenaire",
      "dismiss": "Masquer cette invitation",
      "linked_with_name": "En lien avec ${name}",
      "linked_with_partner": "En lien avec votre partenaire",
      "linked_blurb": "Ses soins apparaissent dans votre agenda. Touchez pour gérer ce qu'il·elle peut voir des vôtres.",
      "connected": "Lié·e"
    },
    "connections_sharing": {
      "section_title": "Connexions et partage",
      "partner_label": "Partenaire",
      "partner_add": "Inviter mon·ma partenaire",
      "clinic_label": "Clinique",
      "clinic_add": "Ajouter une clinique à l’équipe",
      "clinic_detail": "Gardez les informations de votre clinique au même endroit",
      "pharmacy_label": "Pharmacie",
      "pharmacy_add": "Ajouter une pharmacie",
      "pharmacy_detail": "Gardez les informations de votre pharmacie au même endroit",
      "provider_label": "Autre soignant·e",
      "provider_add": "Ajouter un·e soignant·e",
      "provider_detail": "Gardez votre équipe soignante élargie au même endroit",
      "recorded": "Enregistré",
      "care_team_member": "Membre de l’équipe soignante",
      "load_failed": "Impossible de charger ton équipe soignante.",
      "retry": "Réessayer",
      "loading": "Chargement de ton équipe soignante…",
      "connected": "Connecté·e",
      "pending": "En attente",
      "failed": "Échec",
      "sharing": "Partage",
      "add_provider_or_connection": "Ajouter un·e soignant·e ou une connexion",
      "connection_status": {
        "not_requested_label": "Pas encore demandé",
        "not_requested_subtitle": "Enregistré — aucune demande de connexion n’a commencé.",
        "requested_label": "Demandé",
        "requested_subtitle": "Nous vérifierons s’il est possible de les connecter.",
        "contacted_label": "Contacté",
        "contacted_subtitle": "Nous vérifions si une connexion sécurisée est possible.",
        "available_label": "Prêt à connecter",
        "available_subtitle": "La synchronisation sécurisée est disponible.",
        "not_available_label": "Pas encore disponible",
        "not_available_subtitle": "La synchronisation sécurisée n’est pas encore proposée. Nous conserverons votre demande.",
        "connected_label": "Connecté·e",
        "connected_subtitle": "La synchronisation sécurisée est active."
      },
      "integration_status": {
        "unknown_label": "Pas encore connecté·e",
        "unknown_subtitle": "Les informations de votre équipe sont conservées ici pendant que vous décidez de la suite.",
        "not_available_label": "Pas encore disponible",
        "not_available_subtitle": "Nous ne pouvons pas encore nous connecter avec elle, mais ses informations restent dans votre équipe.",
        "discovered_label": "Connexion en cours d’étude",
        "discovered_subtitle": "Nous vérifions comment nous connecter avec elle en toute sécurité.",
        "ready_label": "Prêt·e à connecter",
        "ready_subtitle": "Vous pouvez commencer à partager en toute sécurité.",
        "connected_label": "Connecté·e",
        "connected_subtitle": "La synchronisation sécurisée est active."
      },
      "identity_status": {
        "unmatched": "Non associé",
        "candidate": "Correspondance à vérifier",
        "matched": "Associé",
        "verified": "Vérifié",
        "rejected": "Non associé"
      },
      "sharing_status": {
        "not_shared": "Non partagé",
        "ready": "Prêt à partager",
        "active": "Partagé",
        "expired": "Partage expiré",
        "revoked": "Partage révoqué"
      },
      "official_identity": "Nous avons trouvé une correspondance pour ce membre de votre équipe.",
      "connection_summary": {
        "clinic_multiple": "${count} cliniques",
        "pharmacy_multiple": "${count} pharmacies",
        "provider_multiple": "${count} soignant·e·s",
        "multiple_subtitle": "Consultez et gérez votre équipe soignante"
      },
      "connection_management": {
        "description": "Consultez les personnes et organisations enregistrées dans votre équipe soignante.",
        "remove_title": "Supprimer ${name} ?",
        "remove_description": "Cet enregistrement sera supprimé de Louise. Nous ne les contacterons pas et cela n’affectera pas leurs dossiers.",
        "remove_confirm": "Supprimer",
        "clinic": {
          "title": "Vos cliniques",
          "empty": "Aucune clinique ajoutée.",
          "add": "Ajouter une autre clinique",
          "remove": "Supprimer la clinique"
        },
        "pharmacy": {
          "title": "Vos pharmacies",
          "empty": "Aucune pharmacie ajoutée.",
          "add": "Ajouter une autre pharmacie",
          "remove": "Supprimer la pharmacie"
        },
        "provider": {
          "title": "Vos soignant·e·s",
          "empty": "Aucun·e soignant·e ajouté·e.",
          "add": "Ajouter un·e autre soignant·e",
          "remove": "Supprimer le·la soignant·e"
        }
      },
      "connection_modal": {
        "clinic": {
          "title": "Ajouter votre clinique",
          "edit_title": "Modifier la clinique",
          "description": "Enregistrez les informations de votre clinique dans votre équipe soignante.",
          "name_label": "Nom de la clinique",
          "name_placeholder": "p. ex. Clinique de fertilité"
        },
        "pharmacy": {
          "title": "Ajouter votre pharmacie",
          "edit_title": "Modifier la pharmacie",
          "description": "Enregistrez les informations de votre pharmacie dans votre équipe soignante.",
          "name_label": "Nom de la pharmacie",
          "name_placeholder": "p. ex. Pharmacie du centre-ville"
        },
        "provider": {
          "title": "Ajouter un·e soignant·e",
          "edit_title": "Modifier le·la soignant·e",
          "description": "Enregistrez un membre de votre équipe soignante et gardez ses informations au même endroit.",
          "name_label": "Nom du·de la soignant·e",
          "name_placeholder": "p. ex. Dr Maya Chen"
        },
        "name_required": "Veuillez saisir un nom.",
        "contact_email": "E-mail de contact",
        "contact_email_hint": "Facultatif. Si vous avez l’e-mail de l’équipe, il nous aide à trouver le bon contact.",
        "contact_email_placeholder": "soins@exemple.com",
        "email_invalid": "Saisissez une adresse e-mail valide.",
        "specialty": "Spécialité",
        "specialty_placeholder": "p. ex. gynécologue, thérapeute, acupuncteur·rice",
        "relationship": "Rôle dans votre équipe soignante",
        "relationship_placeholder": "p. ex. médecin de la reproduction, infirmier·ère, thérapeute",
        "practice_name": "Cabinet ou organisation",
        "practice_name_placeholder": "p. ex. Santé des femmes Harbor",
        "location": "Lieu",
        "location_placeholder": "p. ex. Boston ou 123 rue Principale",
        "contact_phone": "Téléphone de contact",
        "contact_phone_placeholder": "Numéro de téléphone facultatif",
        "notes": "Notes personnelles",
        "notes_placeholder": "Ce que vous souhaitez retenir de ce membre de votre équipe",
        "privacy_note": "Nous ne partagerons pas vos informations de santé avec eux sans votre autorisation.",
        "save_failed": "Nous n’avons pas pu enregistrer cette connexion. Réessayez.",
        "delete_failed": "Nous n’avons pas pu supprimer cette connexion. Réessayez.",
        "saved_title": "${name} a été ajouté·e à votre équipe soignante",
        "saved_description": "Vous pouvez le modifier ou le supprimer à tout moment.",
        "done": "Terminer",
        "cancel": "Annuler",
        "back": "Retour",
        "save": "Enregistrer"
      }
    },
    "reminders_notifications": {
      "section_title": "Notifications",
      "appointments_label": "Rappels de rendez-vous",
      "appointments_description": "Recevez une alerte avant vos prochains rendez-vous",
      "medications_label": "Rappels de traitement",
      "medications_description": "Rappels quotidiens pour vos traitements",
      "cycle_updates_label": "Mises à jour du cycle",
      "cycle_updates_description": "Phase du cycle et prédictions quotidiennes",
      "test_results_label": "Résultats disponibles",
      "test_results_description": "Soyez informée dès qu'un nouveau résultat arrive",
      "coverage_status_label": "Mises à jour de couverture",
      "coverage_status_description": "Vérification de l'assurance et changements de prestations",
      "documents_label": "Mises à jour des documents",
      "documents_description": "Soyez informée lorsqu'un document de votre dossier de soins change",
      "payments_label": "Paiements",
      "payments_description": "Confirmations et rappels de paiement",
      "period_predictions_label": "Prédictions de règles",
      "period_predictions_description": "Alertes anticipées sur votre cycle",
      "chat_messages_label": "Messages",
      "chat_messages_description": "Nouveaux messages de votre équipe soignante",
      "timing_label": "Me le rappeler",
      "device_ready": "Cet appareil est prêt pour les catégories de rappels que vous activez ci-dessous.",
      "device_access_limited": "Les notifications sont limitées sur cet appareil. Les rappels peuvent arriver discrètement.",
      "device_access_temporary": "L’accès aux notifications est temporaire sur cet appareil. Consultez ses réglages pour continuer à recevoir les rappels.",
      "device_access_not_requested": "Cet appareil n’a pas encore été connecté aux rappels push. Vos préférences restent enregistrées séparément.",
      "device_connecting": "Connexion de cet appareil pour recevoir les rappels activés.",
      "device_access_denied": "Les notifications sont désactivées sur cet appareil. Vos préférences restent enregistrées, mais les rappels push ne peuvent pas y arriver.",
      "device_access_restricted": "L’accès aux notifications est limité sur cet appareil. Vos préférences restent enregistrées, mais les rappels push ne peuvent pas y arriver.",
      "device_unsupported": "Les rappels push ne sont pas disponibles sur le web ou un simulateur. Les notifications intégrées et vos préférences restent disponibles.",
      "device_token_rejected": "Vos préférences restent enregistrées, mais cet appareil n’a pas pu créer une adresse de notification. Réessayez ou vérifiez ses réglages.",
      "device_registration_failed": "Vos préférences de rappel restent activées, mais la connexion de cet appareil a échoué. Réessayez.",
      "device_status_updating": "Vérification de l’accès aux notifications de cet appareil…",
      "learn_about_device_notifications": "En savoir plus sur la réception des rappels",
      "open_device_settings": "Ouvrir les réglages de l’appareil",
      "retry_device_registration": "Réessayer",
      "permission_education_title": "Choisissez comment recevoir vos rappels",
      "permission_education_body": "Louise peut envoyer des rappels de traitement et de rendez-vous au bon moment, ainsi que des mises à jour lorsque certains résultats ou documents de soins sont disponibles. Vous choisissez les catégories et le moment des rappels ci-dessous, puis pourrez modifier ce choix ici ou dans les réglages de l’appareil.",
      "permission_education_categories": "Vos préférences de rappel restent séparées de l’autorisation de l’appareil. Activer une catégorie enregistre votre choix même si cet appareil ne peut pas recevoir de notifications push.",
      "permission_education_privacy": "Votre appareil contrôle l’affichage sur l’écran verrouillé et les aperçus. Louise n’affiche ni les jetons bruts ni le contenu clinique des rappels dans ses diagnostics.",
      "permission_education_not_now": "Pas maintenant",
      "permission_education_continue": "Continuer",
      "load_failed": "Impossible de charger vos réglages de notifications.",
      "save_failed": "Impossible d’enregistrer cette modification. Votre réglage précédent est toujours actif.",
      "try_again": "Réessayer"
    },
    "insurance_card": {
      "your_coverage": "Votre couverture",
      "insurance": "Assurance",
      "coverage_and_costs": "Couverture et estimation des coûts",
      "add_title": "Ajoutez les détails de votre assurance",
      "add_description": "Ajoutez votre formule et votre numéro d’adhérent·e pour que nous puissions vérifier votre couverture et estimer vos coûts.",
      "add_action": "Ajouter les détails de l’assurance",
      "empty_title": "Aucune formule dans votre dossier",
      "empty_subtitle": "Ajoutez vos informations pour estimer vos coûts",
      "loading": "Chargement",
      "loading_title": "Vérification de votre couverture",
      "loading_subtitle": "Recherche d’une assurance déjà enregistrée",
      "not_on_file": "Non renseigné",
      "not_added": "Non ajouté",
      "plan_not_added": "Formule non ajoutée",
      "member_id": "Numéro d'adhérent·e",
      "plan": "Formule",
      "ivf_coverage": "Couverture FIV",
      "ivf_coverage_value": "Jusqu'à 3 cycles",
      "lifetime_max": "Plafond à vie",
      "lifetime_max_value": "15 000 $",
      "egg_freezing": "Congélation d'ovocytes",
      "egg_freezing_value": "Couvert",
      "medications": "Traitements",
      "medications_value": "Couverts à 80 %",
      "add_insurance_to_unlock": "Ajouter une assurance pour débloquer",
      "active": "Active",
      "expired": "Expirée",
      "verification": "Vérification",
      "verification_verified": "Vérifiée",
      "verification_pending": "Vérification en cours",
      "verification_unverified": "À vérifier",
      "edit": "Modifier l’assurance"
    },
    "preferences": {
      "section_title": "Préférences",
      "language_label": "Langue",
      "language_english": "English",
      "language_french": "Français",
      "date_format_label": "Format de date",
      "timezone_label": "Lieu",
      "timezone_description": "Calendrier de soins à l’heure locale",
      "location_picker_title": "Où êtes-vous ?",
      "location_picker_description": "Recherchez votre ville et votre pays. Nous définirons votre fuseau horaire.",
      "location_search_placeholder": "Rechercher une ville ou un pays",
      "location_suggested": "Lieux fréquents",
      "location_no_matches": "Aucun lieu trouvé. Essayez une ville et un pays.",
      "location_lookup_failed": "Nous n’avons pas pu déterminer le fuseau horaire de ce lieu. Choisissez-en un manuellement.",
      "manual_timezone_title": "Choisir un fuseau horaire manuellement",
      "manual_timezone_description": "Utilisez cette option si votre ville n’est pas disponible.",
      "manual_timezone_picker_title": "Fuseau horaire",
      "tz_eastern": "Est (ET)",
      "tz_central": "Centre (CT)",
      "tz_mountain": "Montagnes (MT)",
      "tz_pacific": "Pacifique (PT)",
      "tz_alaska": "Alaska (AKT)",
      "tz_hawaii": "Hawaï (HT)",
      "tz_london": "Londres (GMT)",
      "tz_paris": "Paris (CET)",
      "tz_berlin": "Berlin (CET)",
      "tz_tokyo": "Tokyo (JST)",
      "tz_sydney": "Sydney (AEST)",
      "tz_utc": "UTC",
      "haptics_label": "Retours haptiques",
      "haptics_description": "Vibration lors des interactions",
      "sound_label": "Sons de l’interface",
      "sound_description": "Sons discrets lors des interactions",
      "picker_choose": "Choisir ${setting}",
      "preferences_load_failed": "Impossible de charger vos préférences.",
      "preferences_save_failed": "Impossible d’enregistrer cette modification. Votre réglage précédent est toujours actif.",
      "try_again": "Réessayer"
    },
    "integrations": {
      "apple_health_description": "Importez l’historique de cycle, les symptômes et les données de fertilité",
      "apple_health_data_on_file": "Des données Apple Health sont enregistrées",
      "apple_health_no_compatible_data": "Aucune donnée Apple Health compatible n’a encore été trouvée",
      "import_data": "Importer les données",
      "refresh_data": "Actualiser les données",
      "iphone_only": "iPhone uniquement",
      "oura_description": "Sommeil, VFC, état de préparation et tendances de température",
      "tempdrop_description": "Suivi de la température basale",
      "natural_cycles_description": "Données de cycle lorsqu’une connexion sécurisée sera disponible",
      "apple_health_status_load_failed": "Impossible de vérifier si des données Apple Health sont enregistrées.",
      "apple_health_import_failed": "Impossible d’importer les données Apple Health. Réessayez.",
      "try_again": "Réessayer"
    },
    "calendar_sync": {
      "add_care_events_to_device_calendar": "Ajoutez vos rendez-vous et rappels de médicaments au calendrier de votre appareil",
      "available_in_mobile_app": "App mobile uniquement",
      "set_up_sync": "Configurer",
      "sync_now": "Synchroniser",
      "sync_in_progress": "Synchronisation…",
      "not_synced_yet": "Connecté — pas encore synchronisé",
      "last_synced_at": "Dernière synchronisation ${when}",
      "sync_failed_try_again": "Nous n'avons pas pu mettre à jour votre calendrier. Veuillez réessayer.",
      "partial_sync_failure_retry": "Certains événements n'ont pas pu être ajoutés la dernière fois. Synchronisez à nouveau pour réessayer.",
      "before_you_connect": "Avant de connecter",
      "events_visible_to_calendar_viewers": "My Louise ajoutera vos rendez-vous et rappels de médicaments à venir pour les 90 prochains jours au calendrier de votre choix. Toute personne pouvant voir ce calendrier — y compris les comptes partagés ou professionnels — verra ces événements. Vos rappels Louise continuent de fonctionner dans tous les cas.",
      "continue_and_allow_access": "Continuer",
      "not_now": "Pas maintenant",
      "choose_a_calendar": "Choisir un calendrier",
      "only_writable_calendars_listed": "My Louise ne peut ajouter des événements qu'aux calendriers modifiables.",
      "add_events_to_this_calendar": "Ajouter les événements",
      "no_writable_calendars_found": "Aucun calendrier modifiable n'a été trouvé sur cet appareil. Ajoutez d'abord un calendrier dans l'app calendrier de votre appareil.",
      "calendar_access_needed": "Accès au calendrier requis",
      "calendar_access_denied_open_settings": "L'accès au calendrier est désactivé pour My Louise. Autorisez-le dans les réglages de votre appareil pour continuer.",
      "open_device_settings": "Ouvrir les réglages",
      "connected_calendar": "Calendrier connecté",
      "upcoming_events_in_calendar": "${count} événements à venir dans votre calendrier",
      "disconnect_and_remove_events": "Déconnecter et supprimer les événements",
      "untitled_appointment": "Rendez-vous",
      "unnamed_medication": "Médicament",
      "online_appointment_location": "En ligne"
    },
    "fertility_profile": {
      "section_title": "Profil de fertilité",
      "conditions_label": "Diagnostics",
      "partner_label": "Partenaire",
      "timeline_label": "Échéance",
      "ethnicity_label": "Origine",
      "location_label": "Lieu",
      "not_set": "Non renseigné",
      "connected": "Connecté·e",
      "conditions": {
        "none_selected": "Aucun sélectionné",
        "pcos": "PMOS (ex SOPK)",
        "endo": "Endométriose",
        "thyroid": "Thyroïde",
        "irregular": "Règles irrégulières",
        "loss": "Fausse couche",
        "cancer": "Cancer",
        "none": "Aucun",
        "unsure": "Je ne sais pas"
      },
      "timeline_value": {
        "asap": "Dès que possible",
        "three_months": "D'ici 3 mois",
        "six_months": "D'ici 6 mois",
        "exploring": "Je me renseigne",
        "not_set": "Non renseigné"
      },
      "language_labels": {
        "en": "English",
        "es": "Español",
        "fr": "Français"
      }
    },
    "care_context": {
      "section_title": "Contexte de soins",
      "loading": "Chargement…",
      "medical_history_label": "Antécédents médicaux",
      "medical_history_continue": "Continuez vos antécédents médicaux",
      "past_treatment_label": "Traitements passés",
      "past_treatment_reported": "Traitement antérieur déclaré",
      "past_treatment_none": "Aucun traitement antérieur dans votre dossier",
      "past_treatment_one": "1 cycle antérieur dans votre dossier",
      "past_treatment_other": "${count} cycles antérieurs dans votre dossier",
      "cryo_inventory_label": "Inventaire cryo",
      "cryo_inventory_empty": "Aucun inventaire cryo dans votre dossier",
      "cryo_inventory_one": "1 spécimen conservé",
      "cryo_inventory_other": "${count} spécimens conservés",
      "records_label": "Dossiers de soins",
      "records_empty": "Aucun dossier de soins",
      "records_one": "1 dossier de soins",
      "records_other": "${count} dossiers de soins",
      "records_filter_label": "Antécédents médicaux"
    },
    "account_footer": {
      "two_factor_label": "Authentification à deux facteurs",
      "enabled": "Activée",
      "disabled": "Désactivée",
      "two_factor_disabled_description": "Protégez votre compte avec une application d’authentification ou une clé d’accès.",
      "two_factor_enabled_description": "L’authentification à deux facteurs protège votre compte.",
      "two_factor_totp_enabled_description": "Votre application d’authentification protège votre compte.",
      "two_factor_passkey_enabled_description": "Votre clé d’accès protège votre compte.",
      "two_factor_both_enabled_description": "Votre application d’authentification et votre clé d’accès protègent votre compte.",
      "logout_label": "Se déconnecter",
      "logout_description": "Déconnectez-vous sur cet appareil. Vous pourrez vous reconnecter à tout moment.",
      "deactivate_label": "Désactiver le compte",
      "deactivate_description": "Désactivez l’accès et déconnectez-vous."
    },
    "research_studies": {
      "anonymous_label": "Contribution de données anonymisées",
      "anonymous_description": "Aidez à améliorer la prise en charge grâce à des données anonymisées",
      "empty_title": "Aucune étude admissible pour le moment",
      "empty_description": "Lorsqu’une étude pourra vous correspondre, nous afficherons ici les détails.",
      "contribution_load_failed": "Nous n’avons pas pu charger votre choix de contribution. Réessayez.",
      "contribution_save_failed": "Nous n’avons pas pu enregistrer votre choix. Réessayez."
    },
    "coverage_benefits": {
      "insurance_label": "Assurance",
      "insurance_add": "Ajouter une assurance",
      "insurance_on_file": "Assurance enregistrée",
      "plan_label": "Formule",
      "plan_not_specified": "Non renseignée",
      "member_id_label": "Numéro d'adhérent·e",
      "fertility_coverage_label": "Couverture fertilité",
      "treatments_count": "${count} traitements",
      "fertility_coverage_pending": "Nous vérifions votre couverture",
      "fertility_coverage_unverified": "Votre assurance n’a pas encore été vérifiée",
      "fertility_coverage_not_found": "Aucun détail sur les prestations de fertilité dans votre dossier",
      "coverage_load_failed": "Nous n’avons pas pu charger les détails de votre couverture.",
      "try_again": "Réessayer",
      "verified": "Vérifié",
      "pending": "En attente",
      "unverified": "Non vérifié",
      "employer_benefits_label": "Avantages fertilité employeur",
      "employer_benefits_add": "Ajouter des avantages employeur",
      "employer_benefits_on_file": "Avantages enregistrés",
      "employer_benefits_not_listed": "Aucun avantage employeur renseigné",
      "employer_benefits_modal_title": "Ajouter des avantages employeur",
      "employer_benefits_modal_description": "Ajoutez le programme professionnel que vous utilisez pour vos soins de fertilité. Il peut être distinct de votre assurance santé.",
      "employer_benefits_question": "Avez-vous des avantages fertilité via votre travail ?",
      "employer_benefits_yes": "Oui",
      "employer_benefits_no": "Non",
      "employer_benefits_provider_label": "Organisme du programme",
      "employer_benefits_provider_hint": "Ajoutez un organisme comme Progyny, Carrot, Maven ou Kindbody si vous le connaissez.",
      "employer_benefits_provider_placeholder": "p. ex. Progyny",
      "employer_benefits_question_hint": "Vous ne savez pas ? Consultez votre portail d’avantages ou votre équipe RH. Les avantages fertilité de l’employeur peuvent être distincts de l’assurance santé.",
      "employer_benefits_none_action": "Je n’ai pas d’avantages employeur",
      "employer_benefits_card_title": "Avantages fertilité employeur",
      "employer_benefits_card_subtitle": "Soutien professionnel facultatif",
      "employer_benefits_card_empty_title": "Voyez si votre travail peut aider",
      "employer_benefits_card_empty_description": "Votre employeur peut proposer des avantages fertilité distincts de votre assurance santé.",
      "employer_benefits_card_empty_card_title": "Aucun programme professionnel renseigné",
      "employer_benefits_card_empty_card_subtitle": "Ajoutez le programme fertilité proposé par votre travail, si vous en avez un.",
      "employer_benefits_card_action": "Ajouter des avantages employeur",
      "employer_benefits_card_program": "Programme d’avantages",
      "employer_benefits_card_status": "Statut",
      "employer_benefits_card_not_on_file": "Non renseigné",
      "employer_benefits_card_not_added": "Non ajouté",
      "employer_benefits_card_optional": "Facultatif",
      "employer_benefits_card_check_work": "À vérifier au travail",
      "employer_benefits_card_on_file": "Enregistrés",
      "employer_benefits_card_saved_title": "Détails des avantages ajoutés",
      "employer_benefits_card_saved_description": "Ces avantages peuvent être distincts de votre assurance santé.",
      "employer_benefits_card_none_subtitle": "Réponse enregistrée",
      "employer_benefits_card_none_title": "Aucun avantage employeur renseigné",
      "employer_benefits_card_none_description": "Vous pourrez mettre cette réponse à jour si vos avantages changent.",
      "employer_benefits_card_update": "Mettre à jour",
      "employer_benefits_cancel": "Annuler",
      "employer_benefits_save": "Enregistrer",
      "employer_benefits_save_failed": "Nous n’avons pas pu enregistrer vos avantages employeur. Réessayez."
    },
    "support": {
      "section_title": "Aide",
      "chat_label": "Discuter avec l’assistance",
      "chat_value": "Obtenir de l'aide",
      "chat_title": "Discuter avec l’assistance",
      "chat_subtitle": "Vos messages restent ici. Nous répondons généralement sous 24 heures.",
      "chat_history_label": "Conversation avec l’assistance",
      "chat_empty_title": "Commencer une conversation",
      "chat_empty_subtitle": "Posez-nous vos questions sur Louise, vos soins ou votre compte.",
      "chat_load_error": "Nous ne pouvons pas charger vos messages pour le moment.",
      "chat_retry": "Réessayer",
      "feedback_label": "Demander une fonctionnalité ou donner votre avis",
      "message_title": "Écrire à Louise",
      "message_feedback_title": "Partager votre avis",
      "message_subtitle": "Posez-nous vos questions. Nous répondons généralement sous 24 heures.",
      "message_feedback_subtitle": "Dites-nous comment améliorer Louise. Nous répondons généralement sous 24 heures.",
      "message_feedback_sent": "Envoyé. Vous pourrez le retrouver à tout moment dans votre conversation avec l’assistance.",
      "message_input_label": "Votre message",
      "message_placeholder": "Écrivez votre message",
      "message_attach": "Joindre un fichier",
      "message_attachment_too_large": "Chaque pièce jointe doit faire 10 Mo ou moins.",
      "message_too_many_attachments": "Vous pouvez ajouter jusqu’à 5 pièces jointes par message.",
      "message_send": "Envoyer",
      "message_from_support": "Assistance Louise",
      "message_from_you": "Vous",
      "privacy_label": "Politique de confidentialité",
      "terms_label": "Conditions d'utilisation"
    },
    "medical_details": {
      "section_title": "Détails médicaux",
      "blood_type_label": "Groupe sanguin",
      "blood_type_placeholder": "Non renseigné",
      "blood_type_picker_title": "Sélectionner le groupe sanguin",
      "blood_type_save_failed": "Nous n’avons pas pu enregistrer votre groupe sanguin. Réessayez.",
      "allergies_label": "Allergies",
      "allergies_none": "Aucune",
      "allergies_add": "Ajouter les informations sur les allergies",
      "emergency_contact_section_title": "Contact d'urgence",
      "emergency_contact_label": "Contact d'urgence",
      "emergency_contact_placeholder": "Ajouter un contact d'urgence",
      "emergency_name_label": "Nom",
      "emergency_name_placeholder": "Nom du contact",
      "emergency_phone_label": "Téléphone",
      "emergency_relationship_label": "Lien",
      "emergency_relationship_placeholder": "Choisir un lien",
      "save_changes": "Enregistrer les modifications",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "emergency_name_required": "Ajoutez son nom",
      "emergency_phone_required": "Ajoutez son numéro de téléphone",
      "emergency_contact_save_failed": "Nous n’avons pas pu enregistrer votre contact d’urgence. Réessayez.",
      "remove_emergency_contact": "Supprimer le contact d’urgence",
      "relationship_partner": "Partenaire",
      "relationship_spouse": "Conjoint·e",
      "relationship_parent": "Parent",
      "relationship_child": "Enfant",
      "relationship_sibling": "Frère/Sœur",
      "relationship_friend": "Ami·e",
      "relationship_colleague": "Collègue",
      "relationship_other": "Autre"
    },
    "invite_friend": {
      "section_title": "Aider un·e ami·e",
      "blurb": "Vous connaissez quelqu'un·e dans une situation similaire ?\nPartagez Louise pour tenter de gagner un cycle de soins de fertilité gratuit.",
      "compact_blurb": "Partagez Louise pour tenter de gagner un cycle gratuit.",
      "share_button": "Partager Louise",
      "dismiss": "Masquer la carte Aider un·e ami·e",
      "share_title": "Louise : Votre accompagnement fertilité",
      "share_message": "J'utilise Louise pour m'accompagner dans mon parcours fertilité : suivi du traitement, recherche de clinique, gestion des coûts. Je pense que ça pourrait t'être utile aussi : ${url}",
      "share_sheet_title": "Partager Louise",
      "share_sheet_subtitle": "Envoyez ce lien à quelqu'un qui pourrait bénéficier de Louise.",
      "share_sheet_copy": "Copier le lien",
      "share_sheet_copied": "Lien copié",
      "landing_title": "Un·e ami·e vous a invité·e",
      "landing_subtitle": "Louise, c'est votre accompagnement fertilité. Suivez votre traitement, trouvez une clinique et gérez vos coûts. Commencez par quelques questions.",
      "landing_cta": "Commencer"
    },
    "shared": {
      "select": "Sélectionner",
      "back": "Retour"
    },
    "insurance_modal": {
      "title": "Détails de l'assurance",
      "edit": "Modifier",
      "add_blurb": "Enregistrez les informations dont vous disposez et ajoutez le reste plus tard.",
      "edit_blurb": "Mettez à jour les informations d'assurance dont vous disposez.",
      "insurance_card_label": "Carte d'assurance",
      "front_card_label": "Recto",
      "back_card_label": "Verso",
      "add_card_action": "Ajouter le ${side} de la carte d'assurance",
      "retry_card_action": "Réessayer l'envoi du ${side} de la carte d'assurance",
      "add_card_button": "Ajouter",
      "retry_card_button": "Réessayer",
      "card_add_hint": "Ajouter une photo ou un PDF",
      "card_uploading": "Envoi en cours…",
      "card_reading": "Lecture de la carte…",
      "card_upload_error": "Échec de l'envoi. Appuyez pour réessayer.",
      "card_ocr_error": "Les détails de la carte n'ont pas pu être lus. Vous pouvez les saisir manuellement.",
      "open_card_action": "Ouvrir le ${side} de la carte d'assurance",
      "view_card_action": "Voir le ${side} de la carte d'assurance",
      "replace_card_action": "Remplacer le ${side} de la carte d'assurance",
      "remove_card_action": "Supprimer le ${side} de la carte d'assurance",
      "carrier_label": "Organisme d'assurance",
      "carrier_placeholder": "p. ex. Mutuelle Générale",
      "carrier_search_unavailable": "La recherche d'organisme est indisponible. Vous pouvez saisir le nom manuellement et enregistrer.",
      "carrier_searching": "Recherche en cours…",
      "member_id_label": "Numéro d'adhérent·e",
      "member_id_placeholder": "p. ex. ABC123456789",
      "group_number_label": "Numéro de groupe",
      "group_number_placeholder": "p. ex. 12345",
      "no_details_error": "Ajoutez au moins une information d'assurance avant d'enregistrer.",
      "error_generic": "Vos informations d'assurance n'ont pas pu être enregistrées. Veuillez réessayer.",
      "cancel_button": "Annuler",
      "save_button": "Enregistrer",
      "delete_card_title": "Supprimer l'image de la carte ?",
      "delete_card_message": "Cela supprime cette image de carte d'assurance. Vous pourrez la téléverser à nouveau à tout moment.",
      "delete_card_cancel": "Annuler",
      "delete_card_confirm": "Supprimer",
      "provider_label": "Organisme d'assurance",
      "plan_name_label": "Nom de la formule",
      "group_number_summary_label": "Numéro de groupe",
      "plan_type_label": "Type de formule",
      "not_provided": "Non renseigné",
      "status_verified": "Vérifiée",
      "status_verified_description": "Votre assurance a été vérifiée auprès de votre organisme.",
      "status_pending": "Vérification en cours",
      "status_pending_description": "Nous vérifions votre couverture. Cela prend en général 1 à 2 jours ouvrés.",
      "status_unverified": "Non vérifiée",
      "status_unverified_description": "Vos informations d'assurance n'ont pas encore été vérifiées.",
      "fertility_coverage_header": "Couverture fertilité",
      "deductible_label": "Franchise",
      "oop_max_label": "Reste à charge maximum",
      "coinsurance_label": "Coassurance",
      "treatments_covered_label": "Traitements couverts"
    },
    "modals": {
      "logout": {
        "title": "Se déconnecter",
        "message": "Vous serez déconnecté·e de votre compte sur cet appareil. Vous pouvez vous reconnecter à tout moment.",
        "cancel": "Annuler",
        "confirm": "Se déconnecter"
      },
      "delete_account": {
        "title": "Désactiver le compte",
        "message": "Nous désactiverons votre accès et vous déconnecterons. Les dossiers de soins requis restent liés à vos cliniques et relations de soins.",
        "deactivation_title": "L’accès sera désactivé",
        "deactivation_description": "Les dossiers de soins requis restent liés aux cliniques et aux relations de soins.",
        "reactivation_title": "Besoin de revenir ?",
        "reactivation_description": "Contactez le support pour restaurer votre accès.",
        "confirmation_token": "DÉSACTIVER",
        "type_prefix": "Tapez",
        "type_suffix": "pour confirmer",
        "type_placeholder": "Tapez DÉSACTIVER",
        "cancel": "Annuler",
        "confirm": "Désactiver",
        "error": "Une erreur s'est produite. Réessayez ou contactez le support."
      },
      "roadmap": {
        "title": "Votre feuille de route",
        "current_badge": "En cours",
        "deciding_label": "Phase de réflexion",
        "deciding_description": "Découvrez vos options de fertilité et identifiez la voie qui vous convient.",
        "deciding_milestone_1": "Définir votre objectif de parcours",
        "deciding_milestone_2": "Déposer un premier document ou résultat",
        "deciding_milestone_3": "Prendre une première consultation",
        "deciding_milestone_4": "Ajouter votre clinique à votre équipe de soins",
        "preparing_label": "Phase de préparation",
        "preparing_description": "Préparez votre corps et votre logistique pour le traitement à venir.",
        "preparing_milestone_1": "Réaliser le bilan sanguin et les examens de base",
        "preparing_milestone_2": "Commencer les traitements prescrits si besoin",
        "preparing_milestone_3": "Constituer votre équipe soignante et votre planning",
        "preparing_milestone_4": "Connecter votre partenaire",
        "in_treatment_label": "Phase de traitement",
        "in_treatment_description": "Traitement de fertilité actif, avec monitorage, interventions et suivi quotidien.",
        "in_treatment_milestone_1": "Se rendre aux rendez-vous de monitorage",
        "in_treatment_milestone_2": "Respecter le protocole de traitement",
        "in_treatment_milestone_3": "Ponction ovocytaire ou transfert d'embryon",
        "in_treatment_milestone_4": "Récupération après l'intervention",
        "storing_label": "Phase de conservation",
        "storing_description": "Vos ovocytes, embryons ou échantillons sont conservés en sécurité pour l'avenir.",
        "storing_milestone_1": "Confirmer le centre de conservation et la formule",
        "storing_milestone_2": "Ajouter vos specimens à votre coffre",
        "storing_milestone_3": "Déposer le compte rendu du laboratoire",
        "storing_milestone_4": "Ouvrir un nouveau cycle quand vous serez prête",
        "result_label": "Résultat",
        "result_description": "Votre cycle est terminé. C'est l'attente du résultat, et ce qu'il vous apprend.",
        "result_milestone_1": "Poursuivre votre traitement de soutien",
        "result_milestone_2": "Enregistrer votre résultat de bêta-hCG",
        "result_milestone_3": "Déposer le compte rendu de votre bêta",
        "result_milestone_4": "Ouvrir votre cycle suivant"
      },
      "partner_manage": {
        "pending_invite_to": "Invitation en attente pour ${name}",
        "pending_invitation": "Invitation en attente",
        "manage_named": "Gérer ${name}",
        "manage_partner": "Gérer mon·ma partenaire",
        "pending_message_named": "${name} n'a pas encore accepté l'invitation. Vous pouvez l'annuler et en envoyer une nouvelle à tout moment.",
        "pending_message_generic": "L'invitation n'a pas encore été acceptée. Vous pouvez l'annuler et en envoyer une nouvelle à tout moment.",
        "done": "Terminé",
        "cancel_invitation": "Annuler l'invitation",
        "remove_partner": "Retirer mon·ma partenaire",
        "cancel_invitation_title": "Annuler cette invitation ?",
        "cancel_invitation_message": "Le lien d’invitation cessera de fonctionner. Tu pourras envoyer une nouvelle invitation plus tard.",
        "remove_partner_connection_title": "Supprimer cette connexion partenaire",
        "remove_partner_connection_message": "Le nouvel accès et le partage avec ton/ta partenaire s’arrêteront après confirmation par le serveur. Les dossiers qui t’appartiennent restent les tiens ; les copies déjà téléchargées ne pourront peut-être pas être récupérées.",
        "cancel": "Annuler",
        "confirm_invitation_cancellation": "Annuler l’invitation",
        "remove_connection": "Supprimer",
        "remove_failed": "Échec du retrait du partenaire"
      },
      "data_sharing": {
        "connect_partner": "Connecter un·e partenaire",
        "connect_clinic": "Connecter une clinique",
        "connect_pharmacy": "Connecter une pharmacie",
        "connect_provider": "Connecter un·e soignant·e",
        "sharing_with": "Partage avec ${name}",
        "generic_partner": "Partage de données — partenaire",
        "generic_clinic": "Partage de données — clinique",
        "generic_pharmacy": "Partage de données — pharmacie",
        "generic_provider": "Partage de données — soignant·e",
        "pending_intro": "Les contrôles de partage pour cette connexion seront disponibles dès qu'elle sera active. Rien n'est enregistré pour l'instant — tu définiras tes préférences quand la connexion existera.",
        "pending_invitation_for": "Invitation en attente pour ${name}",
        "pending_invite_status_value": "En attente",
        "pending_invite_status_with_expiry": "En attente · Expire le ${date}",
        "pending_invite_sent_to": "Envoyée à ${phone}",
        "save_invitation": "Enregistrer",
        "pending_sharing_updated": "Préférences de partage enregistrées.",
        "pending_sharing_update_failed": "Impossible d'enregistrer les préférences de partage. Réessaie.",
        "local_history_notice": "Tes derniers changements d'historique médical restent uniquement sur cet appareil. Tu peux désactiver un accès existant maintenant, mais aucun nouvel accès ne peut être activé tant que ces changements ne sont pas synchronisés ou vérifiés.",
        "medical_history_label": "Antécédents médicaux",
        "medical_history_description": "Pathologies, diagnostics et historique de traitement",
        "test_results_label": "Résultats d'examens",
        "test_results_description": "Bilans, taux hormonaux et imagerie",
        "medications_label": "Traitements",
        "medications_description": "Ordonnances actuelles et passées",
        "cycle_data_label": "Données du cycle",
        "cycle_data_description": "Suivi des règles, prédictions et symptômes",
        "appointments_label": "Rendez-vous",
        "appointments_description": "Rendez-vous du parcours partagé",
        "documents_label": "Documents",
        "documents_description": "Fichiers téléchargés, formulaires de consentement et comptes rendus",
        "remove_partner": "Retirer mon·ma partenaire",
        "cancel_invitation": "Annuler l’invitation",
        "partner_phone_unavailable": "Numéro de téléphone indisponible",
        "remove_failed": "Échec du retrait du partenaire",
        "done": "Terminé"
      },
      "disable_2fa": {
        "title": "Désactiver la double authentification",
        "message": "Saisis un code actuel depuis ton application d’authentification pour confirmer. Ton compte sera moins sécurisé sans 2FA.",
        "passkey_message": "Confirme avec ta clé d’accès pour désactiver la double authentification. Ton compte sera moins sécurisé sans elle.",
        "code_placeholder": "000000",
        "error_invalid": "Code invalide. Réessaie.",
        "error_generic": "Un problème est survenu. Réessaie.",
        "cancel": "Annuler",
        "confirm": "Désactiver"
      },
      "setup_2fa": {
        "intro_title": "Double authentification",
        "intro_message": "Ajoute une couche de sécurité supplémentaire à ton compte. Tu auras besoin d’une application d’authentification comme Google Authenticator ou Authy.",
        "intro_error_default": "Échec de la configuration",
        "intro_cancel": "Annuler",
        "intro_setup": "Configurer",
        "scan_title": "Scanne le QR code",
        "scan_message_web": "Ouvre ton application d’authentification et scanne ce code.",
        "scan_message_mobile": "Appuie pour ouvrir ton application d’authentification, ou scanne depuis un autre appareil.",
        "scan_open_in_app": "Ouvrir dans l’application d’authentification",
        "scan_secret_copied": "Aucune application d’authentification trouvée — clé copiée dans le presse-papier.",
        "scan_qr_a11y": "QR code 2FA",
        "scan_manual_intro": "Ou saisis ce code manuellement :",
        "scan_next": "Suivant",
        "verify_title": "Saisis le code de vérification",
        "verify_message": "Saisis le code à 6 chiffres de ton application d’authentification.",
        "verify_code_placeholder": "000000",
        "verify_error_invalid": "Code invalide. Réessaie.",
        "verify_confirm": "Vérifier",
        "recovery_title": "Sauvegarde tes codes de récupération",
        "recovery_message": "Conserve-les en lieu sûr. Chaque code ne peut être utilisé qu’une seule fois si tu perds l’accès à ton application d’authentification.",
        "recovery_copy_all": "Tout copier",
        "recovery_acknowledge": "J’ai sauvegardé ces codes. Je comprends qu’ils ne seront plus affichés.",
        "recovery_done": "Terminé",
        "passkey_or": "ou",
        "passkey_button": "Configurer une clé d'accès",
        "passkey_error_default": "Impossible de configurer ta clé d'accès. Réessaie.",
        "passkey_success": "Clé d'accès ajoutée"
      },
      "end_cycle": {
        "title": "Terminer le cycle de traitement",
        "subtitle": "Comment ce cycle s’est-il terminé ? On va le clôturer et le garder dans ton historique.",
        "past_outcome_prompt": "Quel a été le résultat de ce cycle passé ? Ajoute-le à ton historique de traitement.",
        "past_preservation_outcome_prompt": "Que s’est-il passé pendant ce cycle passé de préservation ? Ajoute le résultat à ton historique de traitement.",
        "past_donation_outcome_prompt": "Que s’est-il passé pendant ce cycle passé de don ? Ajoute le résultat à ton historique de traitement.",
        "current_close_after_procedure_prompt": "Ton transfert ou ton insémination est terminé. Quel a été le résultat de ce cycle de traitement ?",
        "current_close_before_outcome_prompt": "Ce cycle n’a pas encore abouti à un résultat de grossesse. Indique-nous comment tu souhaites le clôturer.",
        "current_close_recorded_result_prompt": "Un résultat est déjà enregistré pour ce cycle. Confirme-le ci-dessous pour clôturer le cycle de traitement.",
        "recorded_result_recap_title": "Vérifie ton résultat enregistré",
        "recorded_result_recap_prompt": "Ce résultat est déjà enregistré. Vérifie les détails ci-dessous avant de clôturer le cycle.",
        "recorded_result_label": "Résultat enregistré",
        "recorded_result_date_label": "Enregistré le",
        "recorded_result_status_label": "Statut du résultat",
        "recorded_result_notes_label": "Notes",
        "recorded_result_positive_status": "Positif",
        "recorded_result_negative_status": "Négatif",
        "recorded_result_uncertain_status": "Incertain",
        "close_with_recorded_result": "Clôturer avec ce résultat",
        "choose_different_outcome": "Choisir un autre résultat",
        "history_note": "Tes infos de traitement, ton suivi et tes documents resteront accessibles depuis ton historique.",
        "outcome_completed_preservation": "Cycle terminé",
        "completed_preservation_description": "Les étapes prévues de préservation sont terminées.",
        "outcome_completed_donation": "Don terminé",
        "completed_donation_description": "Les étapes prévues du don sont terminées.",
        "prompt_preservation": "Comment ce cycle s'est-il terminé ? Le clôturer le déplace dans votre historique — ce que vous avez conservé reste dans votre coffre cryo.",
        "prompt_donation": "Comment ce cycle s'est-il terminé ? Le clôturer le déplace dans votre historique.",
        "confirm_completed_title": "Ce cycle est terminé",
        "confirm_completed_body": "Il est enregistré dans votre historique. Rien n'est à décider aujourd'hui.",
        "outcome_pregnancy": "Grossesse",
        "pregnancy_outcome_description": "Le cycle s'est terminé par un résultat de grossesse positif.",
        "outcome_no_pregnancy": "Pas de grossesse",
        "no_pregnancy_outcome_description": "Le cycle s'est terminé sans grossesse.",
        "outcome_miscarriage": "Perte de grossesse",
        "pregnancy_loss_outcome_description": "Le cycle s'est terminé après une perte de grossesse.",
        "outcome_cancelled": "Cycle annulé",
        "cycle_cancelled_outcome_description": "Le cycle s'est arrêté avant la fin du traitement.",
        "outcome_other": "Autre",
        "other_outcome_description": "Choisis cette option si une autre issue correspond mieux.",
        "outcome_details_title": "Ajouter une note sur ce cycle",
        "outcome_details_prompt": "Ajoute ce que tu souhaites garder en mémoire sur sa fin.",
        "cancelled_details_title": "Pourquoi le cycle a-t-il été annulé ?",
        "cancelled_details_prompt": "Choisis la raison qui correspond le mieux à ce qui s’est passé.",
        "other_details_title": "Déclarer un changement",
        "other_details_prompt": "Ajoute une note pour que ton historique reflète ce qui s’est passé.",
        "reason_label": "Raison (facultatif)",
        "reason_doctor": "Recommandation du médecin",
        "reason_side_effects": "Effets secondaires trop importants",
        "reason_schedule": "Conflit d’emploi du temps",
        "reason_personal": "Raisons personnelles",
        "reason_other": "Autre",
        "notes_placeholder": "Ajouter une note (facultatif)",
        "cancel": "Annuler",
        "confirm": "Terminer le cycle"
      },
      "partner_invite": {
        "visual_you": "Toi",
        "visual_together": "Ensemble",
        "step_who_title": "Qui est ton partenaire ?",
        "step_who_subtitle": "Celle ou celui qui partage ce parcours avec toi.",
        "step_who_name_label": "Son prénom",
        "step_who_name_hint": "Saisis un prénom pour continuer.",
        "step_who_name_placeholder": "Son prénom",
        "step_share_title": "Que souhaites-tu partager avec ${name} pour ce parcours ?",
        "step_share_subtitle": "Choisis ce que tu veux partager au fil de ce parcours de fertilité. Tes antécédents médicaux privés restent à toi.",
        "step_share_note": "Iel peut créer son propre compte Louise et gérer séparément ses propres informations de santé.",
        "sharing_scope_required": "Un parcours partagé en cours est nécessaire avant d’envoyer cette invitation.",
        "shared_cycle_data_label": "Données du cycle et des règles",
        "shared_cycle_data_description": "Suivi des règles, symptômes et évolution du cycle",
        "shared_appointments_label": "Rendez-vous",
        "shared_appointments_description": "Rendez-vous du parcours partagé",
        "shared_medications_label": "Médicaments",
        "shared_medications_description": "Détails des médicaments partagés avec ce partenaire",
        "shared_test_results_label": "Résultats d’analyses",
        "shared_test_results_description": "Accès à tes résultats d’analyses ; active ce choix seulement si tu veux les partager.",
        "step_phone_title": "Contacter ${name}",
        "step_phone_subtitle": "Saisis son numéro de téléphone pour lui envoyer une invitation.",
        "step_phone_number_label": "Son numéro de téléphone",
        "step_phone_number_placeholder": "Numéro de téléphone",
        "step_progress": "Étape ${current} sur ${total}",
        "send_invite": "Envoyer l’invitation",
        "update_invite": "Modifier l’invitation",
        "step_sent_title": "L’invitation est envoyée",
        "step_sent_message": "${name} recevra un lien pour te rejoindre. Tu retrouveras l’invitation en attente dans Connexions partenaires, dans les réglages, où tu peux l’annuler à tout moment.",
        "step_updated_title": "L’invitation est mise à jour",
        "step_updated_message": "${name} recevra l’invitation mise à jour. Tu la retrouveras dans les Connexions partenaires, dans les réglages, où tu peux l’annuler à tout moment.",
        "sending": "Envoi…",
        "done": "Terminé",
        "close": "Fermer",
        "back": "Retour",
        "continue": "Continuer",
        "dismiss_error": "Fermer l’erreur",
        "unlink_pending": "Dissociation…",
        "unlink_action": "Dissocier le partenaire actuel et réessayer"
      }
    },
    "intent_picker": {
      "title_goal": "Ton parcours",
      "title_stage": "Où en es-tu dans ton parcours ?",
      "subtitle": "Pour qu'on puisse personnaliser chaque partie de ton expérience.",
      "journey_save_in_progress": "Enregistrement de ton parcours…",
      "journey_save_failed": "Nous n'avons pas pu enregistrer ton parcours. Ta sélection actuelle n'a pas changé. Réessaie.",
      "goal": {
        "preserve_label": "Préserver ma fertilité",
        "preserve_sublabel": "Congeler des ovocytes ou des embryons",
        "grow_label": "Fonder ma famille",
        "grow_sublabel": "Naturellement ou avec un traitement",
        "donate_label": "Aider quelqu'un d'autre",
        "donate_sublabel": "Don",
        "explore_label": "Juste me renseigner",
        "explore_sublabel": "Voir ce qui existe"
      },
      "preserve": {
        "exploring_label": "Juste explorer mes options",
        "exploring_sublabel": "Me renseigner sur ce qui existe",
        "egg_freezing_label": "Congélation d'ovocytes",
        "sperm_freezing_label": "Congélation de sperme",
        "freezing_sublabel": "J'y réfléchis ou j'ai déjà commencé",
        "embryo_label": "Congélation d'embryons",
        "embryo_sublabel": "J'y réfléchis ou j'ai déjà commencé"
      },
      "grow": {
        "trying_label": "J'essaie naturellement",
        "trying_sublabel": "Concevoir sans traitement",
        "researching_label": "Je me renseigne sur mes options",
        "researching_sublabel": "Comparer les chemins vers la parentalité",
        "adoption_label": "Adoption",
        "adoption_sublabel": "Explorer l'adoption et d'autres chemins vers la parentalité",
        "ready_label": "Je me prépare à un traitement",
        "ready_sublabel": "J'envisage IIU, FIV ou un autre acte",
        "in_treatment_label": "Déjà en traitement",
        "in_treatment_sublabel": "En cours d'IIU, FIV ou équivalent"
      },
      "help": {
        "sperm_donation_label": "Donner mon sperme",
        "sperm_donation_sublabel": "Aider d'autres personnes à fonder une famille",
        "egg_donation_label": "Donner mes ovocytes",
        "egg_donation_sublabel": "Aider d'autres personnes à fonder une famille",
        "surrogacy_label": "Être gestatrice pour autrui",
        "surrogacy_sublabel": "Porter une grossesse pour quelqu'un d'autre"
      }
    }
  },
  "med_history": {
    "save_failed_title": "Échec de l'enregistrement",
    "save_failed_message": "Nous n'avons pas pu enregistrer vos informations. Veuillez réessayer.",
    "save_failed_ok": "OK",
    "overview": {
      "insight_start_basics": "Commence par les bases — les cliniques s'en servent pour personnaliser tes soins",
      "insight_great_start": "Bon début — plus tu partages, meilleur sera ton plan de soins",
      "insight_drug_interactions": "Les interactions médicamenteuses peuvent désormais être vérifiées avec ton profil",
      "insight_test_results": "Tes résultats d'analyses aident à te proposer les bons protocoles",
      "insight_profile_powerful": "${completed} sections sur ${total} complétées — ton profil devient puissant",
      "recap_age": "Âge ${age}",
      "recap_no_diagnosis": "Aucun diagnostic signalé",
      "recap_test_results_one": "${count} résultat d'analyse enregistré",
      "recap_test_results_other": "${count} résultats d'analyses enregistrés",
      "recap_no_test_results": "Pas encore de résultats d'analyses",
      "recap_cycles_one": "${count} cycle : ${types}",
      "recap_cycles_other": "${count} cycles : ${types}",
      "recap_no_treatments": "Aucun traitement enregistré",
      "recap_pain_scale": "douleur ${value}/10",
      "recap_pap_done": "Frottis réalisé",
      "recap_std_history": "Antécédents d'IST",
      "recap_no_std": "Aucun antécédent d'IST",
      "recap_no_contraception": "Aucun historique de contraception",
      "recap_pregnancies_one": "${count} grossesse enregistrée",
      "recap_pregnancies_other": "${count} grossesses enregistrées",
      "recap_no_pregnancies": "Aucune grossesse",
      "recap_medications_one": "${count} médicament",
      "recap_medications_other": "${count} médicaments",
      "recap_no_medications": "Aucun médicament",
      "recap_vaccines_one": "${count} vaccin",
      "recap_vaccines_other": "${count} vaccins",
      "recap_no_allergies": "Aucune allergie connue",
      "recap_conditions_one": "${count} affection signalée",
      "recap_conditions_other": "${count} affections signalées",
      "recap_no_conditions": "Aucune affection signalée",
      "recap_no_surgeries": "Aucune intervention chirurgicale",
      "recap_no_exposures": "Aucune exposition",
      "recap_no_substances": "Aucune substance",
      "recap_sleep_hours": "${min}–${max} h de sommeil",
      "recap_exercises_regularly": "Fait de l'exercice régulièrement",
      "recap_not_exercising": "Pas d'activité physique",
      "recap_supplements_one": "${count} complément",
      "recap_supplements_other": "${count} compléments",
      "recap_adopted": "Adopté·e",
      "recap_gamete_donation": "Don de gamètes",
      "back": "Retour",
      "header_title": "Historique médical",
      "header_blurb": "Réponds à ton historique et ajoute tes dossiers pour mieux guider tes soins.",
      "complete_badge": "Terminé",
      "xp_badge": "${xp} XP",
      "level_badge": "Niv.${level} — ${title}",
      "level": {
        "newcomer": "Débutant·e",
        "getting_started": "En route",
        "health_explorer": "Explorateur·rice santé",
        "wellness_pro": "Pro du bien-être",
        "health_champion": "Champion·ne santé"
      },
      "group": {
        "basic": "Informations de base",
        "fertility": "Fertilité & tests",
        "gynae": "Gynécologie & obstétrique",
        "gynae_male": "Santé sexuelle & reproductive",
        "medical": "Historique médical",
        "lifestyle": "Mode de vie",
        "family_history": "Historique familial"
      },
      "row": {
        "basic_info": "À propos de toi",
        "infertility": "Diagnostic d'infertilité",
        "fertility_testing": "Tests de fertilité",
        "fertility_treatments": "Traitements de fertilité",
        "menstrual_health": "Santé menstruelle",
        "sexual_health": "Santé sexuelle",
        "contraception": "Contraception",
        "pregnancies": "Grossesses",
        "medications_vaccines": "Médicaments & vaccins",
        "allergies": "Allergies",
        "diseases": "Maladies & bilans",
        "surgeries": "Chirurgies",
        "exposure": "Expositions",
        "substances": "Substances",
        "sleep_activity": "Sommeil & activité",
        "diet_supplements": "Alimentation & compléments",
        "family_history": "Ascendance & famille"
      },
      "hero_complete_local_title": "Ton historique médical est complet sur cet appareil",
      "hero_complete_local_summary": "Louise enregistre encore des changements locaux avant que cet historique soit prêt à être utilisé ou partagé avec tes soignant·es.",
      "sync_status": {
        "title_checking": "Vérification des changements enregistrés…",
        "title_saving": "Enregistrement des changements…",
        "title_session_changed": "Ta session patient a changé",
        "title_needs_attention": "Des changements nécessitent ton attention",
        "title_retained": "Une réponse reste sur cet appareil",
        "title_not_synced": "Pas encore synchronisé",
        "title_saved": "Tous les changements sont enregistrés",
        "detail_undurable_one": "${count} changement reste ouvert ici pendant que Louise réessaie le stockage sécurisé. Garde cet écran ouvert.",
        "detail_undurable_other": "${count} changements restent ouverts ici pendant que Louise réessaie le stockage sécurisé. Garde cet écran ouvert.",
        "detail_storage_error": "Louise n'a pas encore pu vérifier les changements enregistrés sur cet appareil. Elle réessaiera automatiquement.",
        "detail_checking": "Louise restaure les changements conservés en sécurité sur cet appareil.",
        "detail_saving": "Tu peux continuer pendant que Louise synchronise en arrière-plan.",
        "detail_failed_identity": "La réponse reste en sécurité sur cet appareil, mais elle appartient à une session patient qui n'est plus disponible. Reconnecte-toi avant de la renvoyer. Ignorer cet avertissement ne supprimera pas la réponse.",
        "detail_failed_visible": "La réponse reste visible. Renvoie-la ou ouvre sa section pour la modifier. Ignorer cet avertissement ne supprimera pas la réponse.",
        "detail_failed_retained": "La réponse est toujours conservée ici. Ouvre sa section pour la modifier ou renvoie-la quand tu es prêt·e.",
        "detail_pending_one": "${count} changement est en sécurité sur cet appareil. Louise réessaiera automatiquement.",
        "detail_pending_other": "${count} changements sont en sécurité sur cet appareil. Louise réessaiera automatiquement.",
        "detail_saved": "Ton historique médical est à jour.",
        "acceptance_failed": "Ce changement n'a pas pu être conservé sur cet appareil. Réessaie.",
        "accessibility_status": "Statut de synchronisation de l'historique médical : ${title}",
        "accessibility_saving": "Enregistrement des changements de l'historique médical",
        "retry": "Réessayer",
        "accessibility_retry": "Réessayer ce changement de l'historique médical",
        "action_failed": "Ça n'a pas fonctionné cette fois. La réponse est toujours en sécurité sur cet appareil — réessaie.",
        "edit_section": "Modifier ${section}",
        "dismiss": "Ignorer l'avertissement",
        "accessibility_dismiss": "Ignorer cet avertissement de synchronisation de l'historique médical"
      },
      "progress_card": {
        "title": "Historique médical",
        "blurb": "Un historique complet débloque la personnalisation des traitements, les contrôles de sécurité des médicaments, le dépistage des facteurs de risque et des résumés prêts pour la clinique.",
        "level_xp": "${level} · ${xp} XP",
        "start": "Commencer",
        "accessibility_start": "Commencer l'historique médical",
        "continue": "Continuer",
        "accessibility_continue": "Continuer l'historique médical",
        "accessibility_open_category": "Ouvrir ${title}"
      }
    },
    "shared": {
      "next": "Suivant",
      "continue": "Continuer",
      "yes": "Oui",
      "no": "Non",
      "unknown": "Je ne sais pas",
      "yes_diagnosed": "Oui, diagnostiqué",
      "maybe_undiagnosed": "Je pense en avoir, mais ce n'a pas été diagnostiqué",
      "remind_me_later": "Me le rappeler plus tard",
      "not_provided": "Non renseigné",
      "tap_to_update": "Touchez une réponse pour la modifier",
      "edit_all": "Revoir toutes les questions",
      "recorded": "Enregistré",
      "none_recorded": "Aucun enregistrement"
    },
    "family_history": {
      "ancestry_title": "Quelle est votre ascendance ?",
      "ancestry_subtitle": "Votre origine ethnique peut apporter des informations importantes sur les risques génétiques. Vous pouvez sélectionner plusieurs options.",
      "ancestry": {
        "african": "Africaine",
        "african_or_african_american": "Afro-américaine/\nCaribéenne",
        "middle_eastern_north_african": "Moyen-orientale/\nAfrique du Nord",
        "american_indian_native_american": "Autochtone/\nPeuples indigènes",
        "caucasian": "Européenne/Blanche",
        "asian": "Asiatique",
        "hispanic_caribbean": "Hispanique/latino",
        "multi_racial": "Multiraciale",
        "other": "Autre",
        "i_dont_know": "Préfère ne pas répondre"
      },
      "adopted_title": "Êtes-vous adopté·e ou sans information sur l'histoire médicale de votre famille ?",
      "adopted_subtitle": "Connaître votre situation nous permet de tenir compte de risques génétiques inconnus, et de mieux comprendre votre historique médical complet.",
      "adoption": {
        "adopted_or_dont_know_biological_parents": "Je suis adopté·e / je ne connais pas mes parents biologiques",
        "from_gamete_donation": "Je suis né·e d'un don de gamètes",
        "not_adopted": "Aucune de ces réponses, continuer avec mon historique médical familial"
      },
      "family_member_title": "Quel·le membre de la famille ?",
      "family_member_subtitle": "Précisez le ou la proche qui a rencontré des difficultés de fertilité",
      "family_member": {
        "mother": "Mère",
        "father": "Père",
        "brother": "Frère",
        "sister": "Sœur",
        "grandmother_mother_side": "Grand-mère\nmaternelle",
        "grandfather_mother_side": "Grand-père\nmaternel",
        "grandmother_father_side": "Grand-mère\npaternelle",
        "grandfather_father_side": "Grand-père\npaternel",
        "other": "Autre"
      },
      "des_title": "Votre mère a-t-elle pris du DES ou un autre médicament pendant sa grossesse avec vous ?",
      "des_subtitle": "Nous demandons car le DES peut provoquer des troubles de la reproduction chez les personnes exposées in utero",
      "dna_test_title": "Avez-vous déjà fait un test ADN pour confirmer votre ascendance ?",
      "dna_test_subtitle": "Un test ADN analyse votre matériel génétique pour confirmer votre ascendance",
      "dna_report_title": "Avez-vous un rapport d'ascendance ADN ?",
      "dna_report_section_label": "Mon rapport",
      "dna_report_info": "Ce document sera également disponible dans la section Documents.",
      "dna_report_test_date_label": "Date du test",
      "dna_report_test_date_placeholder": "À quelle date ce test a-t-il été effectué ?",
      "dna_report_dont_have": "Je n'ai pas le rapport",
      "dna_report_add_another": "Ajouter un autre rapport ADN",
      "dna_report_default_name": "Rapport ADN",
      "family_infertility_title": "Un membre de votre famille proche a-t-il eu des difficultés à concevoir ?",
      "family_infertility_subtitle": "Cette question aide à identifier d'éventuels schémas de troubles de la fertilité dans votre famille",
      "maternal_diseases_title": "Connaissez-vous des maladies du côté maternel de votre famille ?",
      "maternal_diseases_description": "Cela peut inclure votre mère.",
      "maternal_diseases_example": "Cela peut être général, « j'ai entendu que l'oncle de ma mère avait du diabète », ou précis, « ma grand-mère a eu un AVC à 67 ans ».",
      "paternal_diseases_title": "Connaissez-vous des maladies du côté paternel de votre famille ?",
      "paternal_diseases_description": "Cela peut inclure votre père.",
      "paternal_diseases_example": "Cela peut être général, « j'ai entendu que le cousin de mon père avait du diabète », ou précis, « ma grand-mère a eu un AVC à 67 ans ».",
      "diseases_label": "Maladies ou problèmes de santé connus",
      "diseases_placeholder": "N'hésitez pas à écrire ce que vous voulez",
      "complete_subtitle": "Vous avez terminé les questions sur l'historique familial"
    },
    "basic_info": {
      "flow": {
        "section_label": "À propos de vous",
        "help_accessibility_label": "Pourquoi nous posons cette question",
        "chips": {
          "about_you": "À propos de vous",
          "pregnancy": "Antécédents de grossesse",
          "medical_history": "Historique médical",
          "allergies": "Allergies",
          "medications": "Médicaments"
        }
      },
      "help": {
        "sex_at_birth": "Le sexe qui vous a été assigné à la naissance nous aide à afficher les questions de santé reproductive qui vous concernent.",
        "basics": "Votre date de naissance, votre taille et votre poids permettent de contextualiser les informations de santé. Vous pourrez les modifier plus tard.",
        "pregnancy": "Comptez toutes les grossesses, y compris celles qui se sont terminées par une fausse couche, une mortinaissance ou une IVG.",
        "endometriosis": "Choisissez diagnostiquée si un professionnel de santé a confirmé l'endométriose. Choisissez l'option suspectée si elle a été évoquée sans être confirmée.",
        "pcos": "Choisissez diagnostiqué si un professionnel de santé a confirmé le SOPK. Choisissez l'option suspectée s'il a été évoqué sans être confirmé.",
        "varicocele": "Choisissez diagnostiquée si un professionnel de santé a confirmé une varicocèle. Choisissez l'option suspectée si elle a été évoquée sans être confirmée.",
        "cancer": "Incluez tout diagnostic de cancer passé ou actuel. Vous pourrez ajouter le type, les dates et les traitements dans les antécédents médicaux.",
        "allergies": "Cette question concerne uniquement les réactions aux médicaments. Les autres allergies peuvent être ajoutées dans la section Allergies.",
        "allergy_details": "Ajoutez un médicament ou une substance par entrée. Utilisez le champ de notes pour décrire la réaction et sa date.",
        "medications": "Incluez les médicaments sur ordonnance, en vente libre, hormonaux et de fertilité que vous prenez régulièrement ou si nécessaire.",
        "medication_details": "Ajoutez un médicament par entrée. Indiquez la fréquence et tout contexte utile dans les notes.",
        "quick_exposure": "Ce bref aperçu nous aide à repérer les éléments utiles pour vos soins. Vous pourrez ajouter la fréquence et les détails plus tard dans Substances."
      },
      "sex_at_birth": {
        "title": "Quel sexe vous a été assigné à la naissance ?",
        "subtitle": "Cela nous aide à comprendre vos besoins et à vous proposer des conseils pertinents pour la suite",
        "female": "Femme",
        "male": "Homme"
      },
      "basics": {
        "title": "Quelques informations de base sur vous",
        "subtitle": "Ces éléments peuvent être pertinents pour adapter les soins et les conseils à vos besoins.",
        "date_of_birth": "Date de naissance",
        "weight": "Poids",
        "height": "Taille",
        "date_placeholder": "JJ/MM/AAAA",
        "weight_placeholder": "Votre poids",
        "height_placeholder_cm": "Votre taille",
        "height_placeholder_ft": "p. ex. 5'10"
      },
      "quick_exposure": {
        "title": "Utilisez-vous actuellement l'une de ces substances ?",
        "subtitle": "Sélectionnez tout ce qui s'applique. Vous pourrez ajouter des détails plus tard.",
        "alcohol": "Alcool",
        "cannabis": "Cannabis / weed",
        "cigarettes": "Tabac / cigarettes",
        "vape": "Nicotine / vapotage",
        "other": "Autres substances",
        "none": "Aucune de ces réponses"
      },
      "pregnancy": {
        "title_afab": "Avez-vous déjà été enceinte ?",
        "title_amab": "Avez-vous déjà eu un enfant ?",
        "subtitle": "Y compris les fausses couches et les IVG",
        "counter_label": "Combien ?",
        "counter_description": "Y compris les fausses couches et les IVG"
      },
      "pregnancy_count": {
        "title": "Vos grossesses",
        "subtitle": "Y compris les fausses couches et les IVG",
        "counter_label": "Vos grossesses",
        "counter_description": "Combien de grossesses avez-vous eues ?"
      },
      "endometriosis": {
        "title": "Avez-vous de l'endométriose ?"
      },
      "pcos": {
        "title": "Avez-vous un PMOS (ex SOPK) ?"
      },
      "varicocele": {
        "title": "Avez-vous une varicocèle ?"
      },
      "cancer": {
        "title": "Avez-vous déjà eu un cancer ?",
        "subtitle": "Vous pourrez ajouter plus de détails plus tard"
      },
      "allergies": {
        "title": "Êtes-vous allergique à des médicaments ?"
      },
      "allergies_details": {
        "title": "À quels médicaments êtes-vous allergique ?",
        "subtitle": "Vous pouvez indiquer un nom de marque ou une substance spécifique",
        "field_label": "Allergie médicamenteuse ${n}",
        "name_placeholder": "Nom du médicament ou substance",
        "comments_placeholder": "Ajouter des commentaires ou détails",
        "add_another": "Ajouter une autre allergie médicamenteuse",
        "remove": "Supprimer l'allergie médicamenteuse ${n}"
      },
      "medications": {
        "current_medications": "Vos médicaments actuels",
        "edit_medications_in_medications_and_vaccines": "Consultez ici les informations partagées. Ajoutez ou modifiez vos médicaments dans la section Médicaments et vaccins.",
        "no_current_medications_recorded": "Vous n'avez pas encore ajouté de médicament actuel.",
        "manage_medications_and_vaccines": "Gérer les médicaments et vaccins",
        "open_categorized_medical_history_editor": "Ouvrir l'éditeur catégorisé des antécédents médicaux."
      },
      "complete": {
        "title": "Sur mesure pour vous",
        "subtitle": "Merci d'avoir répondu à ces questions, nous pourrons adapter votre expérience !",
        "saving": "Enregistrement…",
        "save_failed_title": "Échec de l'enregistrement",
        "save_failed_message": "Nous n'avons pas pu enregistrer vos informations. Veuillez réessayer.",
        "save_failed_ok": "OK"
      }
    },
    "fertility": {
      "continue": "Continuer",
      "save_info": "Enregistrer",
      "testing": {
        "types_title": "Avez-vous fait un ou plusieurs examens de fertilité ?",
        "types_subtitle": "Sélectionnez toutes les options qui s'appliquent, ou choisissez « Aucun » si vous n'en avez pas fait.",
        "upload_label": "Importer des images ou des fichiers",
        "none": "Aucun de ces examens",
        "other_details_label": "Parlez-nous d'un autre examen",
        "other_details_placeholder": "Ajoutez tout autre examen ou détail utile",
        "type": {
          "urine": "Analyses\nd'urine",
          "imaging": "Examens\nd'imagerie",
          "sampling": "Prélèvements",
          "genetic": "Tests\ngénétiques",
          "blood": "Analyses\nde sang",
          "semen": "Spermogramme",
          "other": "Autre"
        },
        "blood_title": "Avez-vous fait l'un de ces examens sanguins ?",
        "blood_subtitle": "Sélectionnez toutes les options qui s'appliquent.",
        "blood_type": {
          "hormonal": "Bilan\nhormonal",
          "std": "Dépistage IST",
          "thyroid": "Bilan\nthyroïdien",
          "other": "Autre analyse\nde sang"
        },
        "urine_title": "Quel type d'analyse d'urine avez-vous fait ?",
        "urine_subtitle": "Sélectionnez une option",
        "urine_type": {
          "ovulation": "Test\nd'ovulation",
          "pregnancy": "Test\nde grossesse",
          "other": "Autre analyse\nd'urine"
        },
        "imaging_title": "Avez-vous fait l'un de ces examens d'imagerie ?",
        "imaging_subtitle": "Sélectionnez toutes les options qui s'appliquent.",
        "imaging_type": {
          "transabdominal": "Échographie\nsus-pubienne",
          "transvaginal": "Échographie\nendovaginale",
          "hysterosonography": "Hystérosonographie (SIS)",
          "hysterosalpingography": "Hystérosalpingographie (HSG)",
          "antral_follicle": "Compte des\nfollicules antraux",
          "laparoscopy": "Cœlioscopie",
          "hysteroscopy": "Hystéroscopie",
          "pelvic_mri": "IRM pelvienne",
          "other": "Autre examen\nd'imagerie"
        },
        "genetic_title": "Quels tests génétiques avez-vous faits ?",
        "genetic_subtitle": "Vous pouvez sélectionner plusieurs réponses",
        "genetic_type": {
          "karyotyping": "Caryotype",
          "carrier_testing": "Test de portage",
          "exome_genome": "Séquençage de\nl'exome ou du génome",
          "other": "Autre test\ngénétique"
        },
        "sampling_title": "Avez-vous fait l'un de ces prélèvements ?",
        "sampling_subtitle": "Sélectionnez toutes les options qui s'appliquent.",
        "sampling_type": {
          "swab_test": "Prélèvement\nvaginal",
          "pap_smear": "Frottis",
          "endometrial_biopsy": "Biopsie de\nl'endomètre",
          "other": "Autre\nprélèvement"
        },
        "complete_section_label": "Bilan de fertilité",
        "complete_title": "Votre historique d'analyses prend forme",
        "complete_subtitle": "Vous avez indiqué les examens qui font déjà partie de votre parcours.",
        "complete_return_hint": "Vous pourrez ajouter ou modifier des résultats quand vous le souhaitez.",
        "complete_recap": "Vous nous avez parlé de ${types}.",
        "complete_recap_empty": "Vous n'avez pas ajouté de type d'examen cette fois-ci.",
        "complete_insight_default": "Tout garder au même endroit évite de vous reposer les mêmes questions et rend les prochains échanges avec votre équipe plus précis.",
        "complete_insight_blood": "Comme vous avez indiqué des analyses de sang, nous pourrons les relier au reste de votre parcours de fertilité lors des prochaines étapes.",
        "complete_insight_semen": "Comme vous avez indiqué un spermogramme, nous pourrons garder ce contexte visible lors des prochaines étapes.",
        "complete_insight_file": "Vous avez ajouté ${count} fichier à votre historique. Nous pourrons utiliser ce document pour compléter les détails plus tard.",
        "complete_insight_files": "Vous avez ajouté ${count} fichiers à votre historique. Nous pourrons utiliser ces documents pour compléter les détails plus tard."
      },
      "treatments": {
        "done_title": "Avez-vous déjà eu recours à des traitements d'AMP ?",
        "done_subtitle": "L'AMP comprend la congélation d'ovocytes, l'IIU, l'ICSI, la stimulation ovarienne, la FIV, etc.",
        "types_title": "Avez-vous suivi l'un de ces traitements d'AMP ?",
        "types_subtitle": "Sélectionnez toutes les options qui s'appliquent, ou choisissez « Aucun de ces traitements ».",
        "none": "Aucun de ces traitements",
        "type": {
          "ivf_icsi": "FIV/ICSI",
          "iui": "IIU",
          "medicated_cycle": "Stimulation\novarienne",
          "ovulation_induction": "Stimulation\novulatoire",
          "medications_only": "Médicaments\nseulement",
          "timed_intercourse": "Rapports\nprogrammés",
          "other_treatment": "Autre\ntraitement",
          "unknown_treatment": "Traitement\ninconnu",
          "fet": "Transfert\nd'embryon congelé",
          "egg_freezing": "Congélation d'ovocytes",
          "embryo_freezing": "Congélation d'embryons"
        },
        "common": {
          "details_subtitle": "Vous pourrez ajouter plus de détails plus tard",
          "name_label": "Nom ou protocole du traitement",
          "name_placeholder": "Nom (facultatif)",
          "date_label": "Date de début du traitement",
          "date_placeholder": "Quand ce traitement a-t-il commencé ?",
          "clinic_label": "Clinique",
          "clinic_placeholder": "Dans quelle clinique a-t-il été réalisé ?",
          "outcome_label": "Résultat",
          "outcome_placeholder": "Quel a été le résultat ?",
          "notes_label": "Notes",
          "notes_placeholder": "Notes (facultatif)",
          "remove_cycle_title": "Supprimer ce traitement ?",
          "remove_cycle_message": "Les détails du dernier traitement seront supprimés de cette réponse.",
          "remove_cycle_cancel": "Conserver",
          "remove_cycle_confirm": "Supprimer",
          "cycle": "Cycle ${n}"
        },
        "outcome": {
          "miscarriage": "Fausse couche",
          "chemical_pregnancy": "Grossesse biochimique",
          "ectopic_pregnancy": "Grossesse extra-utérine",
          "still_birth": "Mort-né·e",
          "other": "Autre",
          "live_birth": "Naissance vivante",
          "multiple_live_births": "Naissances multiples vivantes"
        },
        "ivf": {
          "title": "Détails du cycle de FIV/ICSI",
          "counter_label": "Vos cycles de FIV/ICSI",
          "counter_description": "Combien de cycles de FIV/ICSI avez-vous commencés ? Cela inclut les cycles annulés."
        },
        "iui": {
          "title": "Détails du cycle d'IIU",
          "counter_label": "Vos cycles d'IIU",
          "counter_description": "Combien de cycles d'IIU avez-vous commencés ? Cela inclut les cycles annulés."
        },
        "fet": {
          "title": "Détails du transfert d'embryon congelé",
          "counter_label": "Vos cycles de TEC",
          "counter_description": "Combien de cycles de TEC avez-vous commencés ? Cela inclut les cycles annulés.",
          "patient_report_notice": "Voici les informations que vous avez saisies. Louise les conserve comme un historique déclaré par vous, et vous pouvez les modifier à tout moment.",
          "unknown_placeholder": "Inconnu / non indiqué",
          "protocol_label": "Protocole, si vous le connaissez",
          "protocol_unknown": "Inconnu / non indiqué",
          "protocol_true_natural": "Naturel",
          "protocol_modified_natural": "Naturel modifié",
          "protocol_programmed": "Programmé / THS",
          "protocol_stimulated": "Stimulé",
          "protocol_down_regulated": "Avec suppression",
          "protocol_other": "Autre",
          "transfer_state_label": "Que s'est-il passé pour le transfert ?",
          "transfer_unknown": "Inconnu / non indiqué",
          "transfer_planned": "Prévu",
          "transfer_scheduled": "Programmé",
          "transfer_performed": "Transfert effectué",
          "transfer_cancelled": "Annulé",
          "transfer_no_transfer": "Tenté / aucun transfert",
          "transfer_thaw_failure": "Aucun transfert après échec de décongélation",
          "transfer_paused": "En pause",
          "thaw_state_label": "Que savez-vous de la décongélation ?",
          "thaw_unknown": "Inconnu / non indiqué",
          "thaw_not_applicable": "Non applicable",
          "thaw_ordered": "Demandée",
          "thaw_survived": "A survécu",
          "thaw_failed": "N'a pas survécu",
          "thaw_partial": "Résultat partiel / mixte",
          "thaw_not_reported": "Non indiqué",
          "embryo_count_label": "Nombre d'embryons, si vous le connaissez",
          "embryo_count_placeholder": "Laissez vide si vous ne savez pas",
          "result_state_label": "Résultat ou état de grossesse, si connu",
          "result_unknown": "Inconnu / non indiqué",
          "result_not_yet_known": "Résultat encore inconnu",
          "result_negative": "Négatif / pas de grossesse",
          "result_indeterminate_repeat": "Indéterminé / nouveau test nécessaire",
          "result_pregnancy_detected": "Grossesse détectée",
          "result_pregnancy_unknown_location": "Grossesse de localisation inconnue",
          "result_ongoing": "Grossesse en cours",
          "result_biochemical_pregnancy": "Grossesse biochimique",
          "result_ectopic_pregnancy": "Grossesse extra-utérine",
          "result_early_pregnancy_loss": "Perte précoce de grossesse / fausse couche",
          "result_stillbirth": "Mortinaissance",
          "result_live_birth": "Naissance vivante",
          "result_no_transfer": "Aucun transfert",
          "result_cancelled": "Annulé",
          "result_paused": "En pause"
        },
        "egg_freezing": {
          "title": "Détails de la congélation d'ovocytes",
          "counter_label": "Vos cycles de congélation d'ovocytes",
          "counter_description": "Combien de cycles de congélation d'ovocytes avez-vous commencés ? Cela inclut les cycles annulés.",
          "date_label": "Date du traitement",
          "clinic_label": "Clinique",
          "eggs_frozen_label": "Ovocytes congelés",
          "eggs_frozen_placeholder": "Combien d'ovocytes ont été congelés ?"
        },
        "embryo_freezing": {
          "title": "Détails de la congélation d'embryons",
          "counter_label": "Vos cycles de congélation d'embryons",
          "counter_description": "Combien de cycles de congélation d'embryons avez-vous faits ? Cela inclut les cycles annulés.",
          "date_label": "Date du traitement",
          "clinic_label": "Clinique",
          "embryos_frozen_label": "Embryons congelés",
          "embryos_frozen_placeholder": "Combien d'embryons ont été congelés ?"
        },
        "meds_only": {
          "title": "Détails du cycle médicamenté",
          "counter_label": "Vos cycles médicamentés",
          "counter_description": "Combien de cycles médicamentés avez-vous commencés ? Cela inclut les cycles annulés."
        },
        "oi": {
          "cycle_details": "Détails de la stimulation ovulatoire",
          "reported_cycles": "Vos cycles de stimulation ovulatoire",
          "reported_cycles_description": "Combien de cycles de stimulation ovulatoire avez-vous indiqués ? Cela inclut les cycles annulés."
        },
        "other": {
          "title": "Autre traitement",
          "timed_intercourse_details": "Détails des rapports programmés",
          "unknown_treatment_details": "Détails du traitement inconnu",
          "subtitle": "Ajoutez des détails",
          "name_label": "Nom du traitement",
          "name_placeholder": "Nom (facultatif)",
          "date_label": "Date du traitement",
          "date_placeholder": "Date (facultatif)",
          "notes_label": "Notes",
          "notes_placeholder": "Notes (facultatif)"
        },
        "complete_subtitle": "Vous avez terminé les questions sur vos traitements de fertilité",
        "save_error": "Nous n'avons pas pu enregistrer ces traitements. Tes réponses sont toujours là — réessaie."
      },
      "infertility": {
        "diagnosis_title": "Avez-vous reçu un diagnostic d'infertilité ?",
        "diagnosis_subtitle": "À la suite d'examens réalisés par un·e professionnel·le.",
        "diagnosis_art_needed": "Non, mais j'ai besoin d'AMP pour dépister les embryons",
        "cause_title": "Quelle était la cause de l'infertilité ?",
        "cause_subtitle": "Vous pouvez sélectionner plusieurs réponses.",
        "cause": {
          "tubal_causes": "Pathologie\ntubaire",
          "ovulation_disorders": "Trouble de\nl'ovulation",
          "uterus_anomalies": "Anomalies\nutérines",
          "endometriosis": "Endométriose",
          "premature_ovarian_insufficiency": "Insuffisance ovarienne\nprématurée",
          "production": "Faible production\nde spermatozoïdes",
          "anatomical": "Varicocèle /\nanatomique",
          "functional": "Mobilité /\nfonctionnel",
          "endocrine": "Endocrinien\n(thyroïde, hormonal…)",
          "genetics": "Génétique",
          "psychosexual": "Psychosexuel",
          "unexplained_infertility": "Inexpliquée\n(idiopathique)",
          "other": "Autre"
        },
        "cause_other_title": "Vous avez sélectionné « Autre », merci de nous donner plus d'informations",
        "cause_other_label": "Détails de l'autre cause",
        "cause_other_placeholder": "N'hésitez pas à écrire ce que vous voulez",
        "partner_diagnosis_title": "Votre partenaire a-t-il·elle reçu un diagnostic d'infertilité ?",
        "partner_diagnosis_subtitle": "Si oui, partagez ci-dessous ce que vous savez de son diagnostic.",
        "partner_details_label": "Pouvez-vous nous en dire plus sur l'infertilité de votre partenaire ?",
        "partner_details_placeholder": "Partagez ce que vous savez de son diagnostic, de ses examens ou de ses traitements.",
        "complete_subtitle": "Vous avez terminé les questions sur le diagnostic d'infertilité"
      },
      "past_cycles": {
        "back": "Retour à l'historique médical",
        "title": "Cycles passés",
        "add_cycle": "ajouter un cycle",
        "empty": "Aucun cycle ajouté pour l'instant",
        "treatment": {
          "ivf": "FIV/ICSI",
          "iui": "IIU",
          "fet": "TEC",
          "meds_only": "SO",
          "egg_freezing": "Congélation d'ovocytes",
          "embryo_freezing": "Congélation d'embryons",
          "sperm_freezing": "Congélation de sperme",
          "other": "Autre",
          "default": "Traitement"
        },
        "action": {
          "embryo_details": "détails embryon",
          "exam": "examen",
          "medications": "médicaments",
          "exams": "examens",
          "transfer": "transfert",
          "document": "document",
          "sperm_source": "source du sperme",
          "egg_details": "détails ovocytes",
          "details": "détails"
        }
      }
    },
    "gynae": {
      "menstrual_health": {
        "cycle_status_title": "Est-ce que l'une de ces situations te concerne ?",
        "cycle_status_subtitle": "Sélectionne l'option qui décrit le mieux ton cycle.",
        "continue": "Continuer",
        "cycle_status": {
          "regular_cycle": "J'ai un cycle régulier",
          "irregular_cycle": "J'ai un cycle irrégulier",
          "no_longer_have_period": "Je n'ai plus mes règles",
          "never_had_period": "Je n'ai jamais eu mes règles",
          "no_period_due_to_contraception": "Pas de règles à cause d'une contraception"
        },
        "cycle_details_title": "Détails de ton cycle",
        "cycle_details_subtitle": "Parle-nous de la durée moyenne de ton cycle et de ton flux.",
        "min_cycle_length_label": "Durée minimale du cycle (jours)",
        "max_cycle_length_label": "Durée maximale du cycle (jours)",
        "flow_intensity_label": "Intensité habituelle des règles",
        "flow_intensity": {
          "light": "Léger",
          "medium": "Moyen",
          "heavy": "Abondant"
        },
        "last_3_periods_title": "Tes 3 dernières règles",
        "last_3_periods_subtitle": "Indique les dates que tu connais. Nous estimerons la durée de ton cycle.",
        "period_label": "RÈGLES ${number}",
        "start_date_placeholder": "Date de début",
        "end_date_placeholder": "Date de fin",
        "age_first_period_title": "À quel âge as-tu eu tes premières règles ?",
        "age_label": "Âge",
        "fertile_window_title": "Connais-tu ta fenêtre de fertilité ?",
        "fertile_window_subtitle": "Ta fenêtre de fertilité correspond aux jours du cycle où une grossesse est la plus probable.",
        "bleed_outside_period_title": "As-tu des saignements en dehors de tes règles ?",
        "symptoms_title": "Dis-nous tout ce que tu veux sur tes règles",
        "symptoms_subtitle": "Ces détails peuvent nous aider à identifier certaines conditions et à adapter tes soins.",
        "symptoms_details_label": "Que souhaites-tu nous dire sur tes règles ?",
        "symptoms_details_placeholder": "Partage les symptômes, habitudes ou changements que tu as remarqués.",
        "pain_scale_title": "Échelle de douleur",
        "pain_scale_subtitle": "Sur une échelle de 1 à 10, à quel point as-tu mal pendant tes règles ?",
        "pain_no_pain": "Aucune douleur",
        "pain_worst_pain": "Douleur maximale",
        "pain_medication_title": "Prends-tu des antidouleurs pendant tes règles ?",
        "complete_subtitle": "Tu as terminé les questions sur ta santé menstruelle"
      },
      "sexual_health": {
        "continue": "Continuer",
        "pap_smear_title": "As-tu déjà fait un frottis cervical ?",
        "pap_smear_subtitle": "Le frottis cervical recherche des cellules anormales au niveau du col de l'utérus, y compris des signes d'infection ou de cancer.",
        "pap_smear_result_title": "Le résultat était-il anormal ?",
        "pap_smear_result_subtitle": "Cela nous aide à déterminer si des examens de suivi peuvent être pertinents.",
        "pap_smear_procedures_title": "As-tu subi l'une des procédures suivantes à la suite d'un frottis anormal ?",
        "pap_smear_procedures_subtitle": "Sélectionne toutes les options qui s'appliquent.",
        "select_procedures_label": "SÉLECTIONNE LES PROCÉDURES",
        "pap_smear_procedure": {
          "colposcopy": "Colposcopie",
          "laser_treatment": "Traitement au laser",
          "cryotherapy": "Cryothérapie (congélation)",
          "other": "Autre"
        },
        "none": "Aucune",
        "pap_smear_procedure_details_title": "Parle-nous de tes procédures après un frottis anormal",
        "pap_smear_procedure_details_subtitle": "Des informations détaillées nous aident à diagnostiquer et à prendre en charge ta condition efficacement.",
        "procedure_date_label": "Date de l'intervention",
        "procedure_date_placeholder": "Quand cela s'est-il passé ?",
        "notes_label": "Commentaires ou notes",
        "notes_placeholder": "Ajoute des commentaires ou des notes",
        "add_another": "Ajouter une autre ${name}",
        "stds_title": "As-tu déjà eu ou été traité·e pour l'une des infections suivantes ?",
        "stds_subtitle": "Sélectionne toutes les options qui s'appliquent.",
        "select_conditions_label": "SÉLECTIONNE LES INFECTIONS",
        "std": {
          "syphilis": "Syphilis",
          "gonorrhea": "Gonorrhée",
          "chlamydia": "Chlamydia",
          "hpv": "Verrues génitales (VPH)",
          "hepatitis": "Hépatite",
          "hiv": "VIH",
          "genital_herpes": "Herpès génital",
          "trichomonas_vaginalis": "Trichomonas vaginalis",
          "other": "Autre"
        },
        "std_details_title": "Parle-nous de ton IST",
        "std_details_subtitle": "Des informations détaillées nous aident à diagnostiquer et à prendre en charge ta condition efficacement.",
        "std_other_card_title": "Tu as sélectionné « Autre » — partage davantage de détails pour qu'on puisse te conseiller.",
        "other_label": "Autre infection",
        "std_other_placeholder": "Comment cela s'appelait-il ?",
        "std_diagnosed_label": "Date du diagnostic",
        "std_diagnosed_placeholder": "Quand a-t-elle été diagnostiquée ?",
        "treatment_label": "Traitement",
        "std_treatment_placeholder": "Si tu as suivi un traitement, lequel ?",
        "std_notes_placeholder": "Commentaires ou notes",
        "vaginal_infections_title": "Souffres-tu d'infections vaginales ?",
        "vaginal_infections_subtitle": "Cela inclut les mycoses, la vaginose bactérienne ou d'autres infections.",
        "vaginal_infection": {
          "often": "Oui, souvent",
          "past": "J'en ai eu par le passé mais pas récemment",
          "none": "Non"
        },
        "vaginal_infection_details_title": "Parle-nous de ton infection vaginale",
        "vaginal_infection_details_subtitle": "Des informations détaillées nous aident à diagnostiquer et à prendre en charge ta condition efficacement.",
        "vaginal_infection_card_title": "Détails de l'infection vaginale",
        "vaginal_infection_description_label": "Détails de l'infection",
        "vaginal_infection_description_placeholder": "Décris ton infection",
        "vaginal_infection_start_label": "Date de début",
        "vaginal_infection_start_placeholder": "Quand l'infection a-t-elle commencé ?",
        "vaginal_infection_notes_label": "Commentaires ou notes",
        "lubricants_title": "Utilises-tu des lubrifiants ?",
        "lubricants_subtitle": "Certains lubrifiants peuvent affecter la mobilité des spermatozoïdes et la fertilité.",
        "lubricants_frequency_label": "À quelle fréquence utilises-tu des lubrifiants ?",
        "lubricants_name_label": "Quel lubrifiant utilises-tu ?",
        "lubricants_name_placeholder": "Nom du lubrifiant",
        "frequency": {
          "rarely": "Rarement",
          "sometimes": "Parfois",
          "often": "Souvent"
        },
        "painful_intercourse_title": "Les rapports sexuels sont-ils douloureux ?",
        "painful_intercourse_subtitle": "La douleur pendant les rapports peut indiquer des problèmes de santé que nous devons prendre en compte.",
        "painful_intercourse_rate_label": "ÉVALUE TA DOULEUR DE 1 À 10",
        "no_pain": "Aucune douleur",
        "worst_pain": "Douleur maximale",
        "erectile_difficulties_title": "As-tu des difficultés d'érection ?",
        "erectile_difficulties_subtitle": "Les difficultés d'érection peuvent être liées à des problèmes de santé sous-jacents susceptibles d'affecter la fertilité.",
        "partner_ejaculate_title_afab": "Ton/ta partenaire éjacule-t-il·elle dans ton vagin pendant les rapports ?",
        "partner_ejaculate_title_amab": "Éjacules-tu dans le vagin de ton/ta partenaire pendant les rapports ?",
        "partner_ejaculate_subtitle": "Cela nous aide à comprendre les facteurs qui pourraient influencer tes chances de conception.",
        "partner_ejaculate_frequency_label": "À quelle fréquence ?",
        "complete_subtitle": "Tu as terminé les questions sur ta santé sexuelle"
      },
      "contraception": {
        "continue": "Continuer",
        "usage_title": "Utilises-tu ou as-tu utilisé une contraception ?",
        "usage_subtitle": "Cela nous aide à comprendre ton parcours de fertilité et à te proposer des conseils personnalisés.",
        "methods_title": "As-tu utilisé l'une de ces méthodes de contraception ?",
        "methods_subtitle": "Sélectionne toutes les options qui s'appliquent, ou choisis « Aucune de ces méthodes ».",
        "select_methods_label": "SÉLECTIONNE LES MÉTHODES",
        "none": "Aucune de ces méthodes",
        "method": {
          "birth_control_pill": "Pilule contraceptive",
          "female_condom": "Préservatif féminin",
          "male_condom": "Préservatif masculin",
          "hormonal_iud": "DIU hormonal",
          "copper_iud": "DIU au cuivre",
          "contraceptive_implant": "Implant",
          "contraceptive_ring": "Anneau vaginal",
          "contraceptive_injection": "Injection",
          "contraceptive_patch": "Patch",
          "spermicide": "Spermicide",
          "female_sterilization": "Ligature des trompes",
          "vasectomy": "Vasectomie",
          "withdrawal": "Retrait",
          "andro_switch": "Andro-switch",
          "thermal_underwear": "Sous-vêtement thermique",
          "contraceptive_slip": "Slip contraceptif",
          "fertility_awareness": "Méthodes d'observation du cycle",
          "abstinence": "Abstinence",
          "foam": "Mousse",
          "calendar_method": "Méthodes d'observation du cycle",
          "other": "Autre"
        },
        "details_title": "Parle-nous de ta contraception",
        "details_subtitle": "Des précisions sur ta contraception nous aident à mieux te conseiller.",
        "other_card_title": "Tu as sélectionné « Autre » — merci de préciser",
        "other_label": "Autre méthode",
        "other_placeholder": "Comment cela s'appelait-il ?",
        "name_label": "Marque ou nom de la méthode",
        "name_placeholder": "Marque ou nom de la méthode (ex. « Yasmin »)",
        "start_date_label": "Date de début",
        "start_date_placeholder": "Quand as-tu commencé ?",
        "end_date_label": "Date de fin",
        "end_date_placeholder": "Quand as-tu arrêté ? (le cas échéant)",
        "days_till_period_label": "Nombre de jours avant le retour des règles après l'arrêt",
        "days_till_period_placeholder": "Nombre de jours avant le retour des règles",
        "notes_label": "Commentaires ou notes",
        "notes_placeholder": "Commentaires ou notes",
        "complete_subtitle": "Tu as terminé les questions sur ta contraception"
      },
      "pregnancies": {
        "next": "Suivant",
        "usage_title": "As-tu déjà été enceinte ?",
        "usage_subtitle": "Y compris fausses couches et IVG.",
        "details_title": "Tes grossesses",
        "details_subtitle": "Combien de fois as-tu été enceinte ? Cela inclut les fausses couches et les IVG.",
        "pregnancy_counter_label": "Tes grossesses",
        "pregnancy_counter_description": "Combien de fois as-tu été enceinte ?",
        "pregnancy_card_title": "Grossesse ${number}",
        "more_details_later": "Tu pourras ajouter plus de détails plus tard.",
        "start_date_label": "Date de début",
        "start_date_placeholder": "Quand cette grossesse a-t-elle commencé ?",
        "outcome_label": "Issue",
        "outcome_placeholder": "Quelle a été l'issue ?",
        "delivery_type_label": "Type d'accouchement",
        "delivery_type_placeholder": "Quel type d'accouchement ?",
        "delivery_date_label": "Date d'accouchement",
        "delivery_date_placeholder": "Quand a eu lieu l'accouchement ?",
        "with_current_partner_label": "Partenaire actuel·le",
        "with_current_partner_placeholder": "Était-ce avec ton/ta partenaire actuel·le ?",
        "notes_label": "Notes",
        "notes_placeholder": "Ajoute des commentaires ou des notes",
        "outcome": {
          "live_birth": "Naissance vivante",
          "miscarriage": "Fausse couche",
          "still_birth": "Mort-né·e",
          "abortion": "IVG"
        },
        "delivery_type": {
          "natural": "Naturel",
          "c_section": "Césarienne"
        },
        "complete_subtitle": "Tu as terminé les questions sur tes grossesses"
      }
    },
    "lifestyle": {
      "continue": "Continuer",
      "next": "Suivant",
      "none": "Aucun",
      "diet_supplements": {
        "diet_title": "Comment décrirais-tu ton alimentation actuelle ?",
        "diet_subtitle": "Sélectionne tout ce qui s'applique. Ton alimentation actuelle apporte des indices clés sur la façon dont elle peut influencer ta fertilité.",
        "diet_type": {
          "all_round": "Alimentation équilibrée",
          "vegetarian": "Végétarien·ne",
          "vegan": "Végan·e",
          "food_hypersensitivity": "Hypersensibilité à certains aliments",
          "religious_restriction": "Restriction religieuse alimentaire",
          "lchf_diet": "Régime LCHF",
          "low_gi_food": "Aliments à faible IG",
          "other": "Autre régime"
        },
        "supplements_title": "Prends-tu actuellement des compléments ?",
        "supplements_subtitle": "Indique tous les compléments en vente libre que tu prends actuellement",
        "supplement_type": {
          "folic_acid": "Acide folique",
          "coenzyme_q10": "Coenzyme Q10",
          "minerals": "Minéraux",
          "herbal": "Plantes",
          "other": "Autre"
        },
        "details_title": "Quelques détails sur les compléments",
        "details_subtitle": "Tu peux ajouter tous les détails que tu veux sur ce que tu as sélectionné — rien n'est obligatoire bien sûr, cela aidera simplement ton·ta médecin",
        "details_card_subtitle": "Tu pourras ajouter plus de détails plus tard",
        "start_date_label": "Date de début",
        "start_date_placeholder": "Quand as-tu commencé à en prendre ?",
        "frequency_placeholder": "Décris la fréquence",
        "frequency_modal_title": "À quelle fréquence en prends-tu ?",
        "frequency": {
          "1_6_times_year": "1 à 6 fois/an",
          "1_time_month": "1 fois/mois",
          "2_3_times_month": "2 à 3 fois par mois",
          "1_2_times_week": "1 à 2 fois/semaine",
          "3_4_times_week": "3 à 4 fois/semaine",
          "at_least_5_times_week": "Au moins 5 fois/semaine"
        },
        "herbal_placeholder": "Quel type de complément à base de plantes ?",
        "herbal_label": "Complément à base de plantes",
        "other_supplement_placeholder": "De quel complément s'agit-il ?",
        "other_supplement_label": "Autre complément",
        "notes_placeholder": "Quelque chose à ajouter ? Marque, commentaires, etc.",
        "notes_label": "Notes sur le complément",
        "add_another": "Ajouter un autre complément",
        "complete_subtitle": "Tu as terminé les questions sur l'alimentation et les compléments"
      },
      "exposure": {
        "types_title": "À quels types d'expositions as-tu été confronté·e ?",
        "types_subtitle": "Sélectionne tout ce qui s'applique.",
        "details_subtitle": "Dis-nous en plus sur cette exposition.",
        "details_default_title": "Exposition",
        "exposure_type": {
          "chemicals": "Produits chimiques",
          "x_rays": "Rayons X",
          "agricultural_area": "Zones agricoles",
          "nuclear": "Sources nucléaires",
          "toxins": "Toxines",
          "prolonged_heat": "Chaleur prolongée",
          "other_exposure": "Autre"
        },
        "exposure_frequency": {
          "less_1_a_year": "Moins d'une fois par an",
          "less_1_a_month": "Moins d'une fois par mois",
          "1_a_month": "Une fois par mois",
          "2-3_a_month": "2 à 3 fois par mois",
          "1_a_week": "Une fois par semaine",
          "2-3_a_week": "2 à 3 fois par semaine",
          "4-6_a_week": "4 à 6 fois par semaine",
          "everyday": "Tous les jours"
        },
        "frequency_label": "FRÉQUENCE",
        "frequency_placeholder": "Sélectionne une fréquence",
        "context_label": "CONTEXTE",
        "context_placeholder": "Où ou dans quel contexte cela se produit-il ?",
        "other_label": "TYPE D'EXPOSITION",
        "other_placeholder": "Quel type d'exposition ?",
        "complete_subtitle": "Tu as terminé les questions sur les expositions"
      },
      "sleep_activity": {
        "sleep_title": "Combien d'heures dors-tu en général par nuit ?",
        "sleep_subtitle": "Moyenne du mois dernier",
        "activity_title": "Fais-tu du sport ?",
        "activity_subtitle": "Cela inclut tout sport, séance de gym ou activité physique régulière à laquelle tu participes",
        "activity_slider_label": "Combien d'heures par semaine fais-tu généralement du sport ?",
        "complete_title": "Super !",
        "complete_subtitle": "Tu as terminé les questions sur le sommeil et l'activité"
      },
      "substances": {
        "intro_title": "Consommes-tu actuellement des stimulants ou des substances ?",
        "intro_subtitle": "Cela inclut l'alcool, la nicotine, le cannabis et plus encore.",
        "select_title": "Quelles substances consommes-tu ?",
        "select_subtitle": "Sélectionne tout ce qui s'applique.",
        "substance_type": {
          "alcohol": "Alcool",
          "coffee": "Café",
          "cigarettes": "Cigarettes",
          "vape": "Vapoteuses",
          "snus": "Snus",
          "cannabis": "Cannabis",
          "cbd": "CBD",
          "cocaine": "Cocaïne",
          "hookah": "Chicha",
          "other": "Autre"
        },
        "substance_frequency": {
          "yearly_or_less": "Une fois par an ou moins",
          "monthly_or_less": "Une fois par mois ou moins",
          "weekly_or_less": "Une fois par semaine ou moins",
          "daily": "Tous les jours",
          "stopped": "J'ai arrêté"
        },
        "details_subtitle": "Donne-nous un peu plus de détails pour qu'on puisse adapter nos recommandations.",
        "frequency_label": "FRÉQUENCE",
        "frequency_placeholder": "Sélectionne une fréquence",
        "quantity_placeholder": "Saisis un nombre",
        "notes_placeholder": "Ajoute quelques détails",
        "start_date_label": "DATE DE DÉBUT",
        "start_date_placeholder": "Quand as-tu commencé ?",
        "stop_date_label": "DATE D'ARRÊT",
        "stop_date_placeholder": "Si tu as arrêté, c'était quand ?",
        "other_label": "TYPE DE SUBSTANCE",
        "other_placeholder": "De quelle substance s'agit-il ?",
        "substance_title": {
          "alcohol": "Alcool",
          "coffee": "Café",
          "cigarettes": "Cigarettes",
          "vape": "Vapoteuses",
          "snus": "Snus",
          "cannabis": "Cannabis",
          "cbd": "CBD",
          "cocaine": "Cocaïne",
          "hookah": "Chicha",
          "other": "Autres substances"
        },
        "substance_context_label": {
          "alcohol": "Quel type de boissons ou d'occasions ?",
          "coffee": "Quel type de café ou de boissons énergisantes ?",
          "cigarettes": "Une marque ou une intensité particulière ?",
          "vape": "Quels appareils ou liquides utilises-tu ?",
          "snus": "Marque ou format ?",
          "cannabis": "Sous quelle forme en consommes-tu (fleur, comestibles, etc.) ?",
          "cbd": "Quel type de produits CBD ?",
          "cocaine": "Quel est le contexte habituel ?",
          "hookah": "Où fumes-tu généralement ?",
          "other": "De quelle substance s'agit-il ?"
        },
        "substance_quantity_label": {
          "alcohol": "Combien de verres par jour en moyenne ?",
          "coffee": "Combien de tasses par jour ?",
          "cigarettes": "Combien par jour ?",
          "vape": "Combien de bouffées ou cartouches par jour ?",
          "snus": "Combien de portions par jour ?",
          "cannabis": "À quelle fréquence par session ?",
          "cbd": "Quelle dose par jour ?",
          "cocaine": "Quelle quantité par session ?",
          "hookah": "Combien de sessions par semaine ?",
          "other": "À quelle fréquence et en quelle quantité ?"
        },
        "complete_title": "Super !",
        "complete_subtitle": "Tes détails sur la consommation de substances sont enregistrés."
      }
    },
    "medical": {
      "shared": {
        "next": "Suivant",
        "continue": "Continuer",
        "none": "Aucun",
        "other": "Autre",
        "remove": "Retirer",
        "delete": "Supprimer"
      },
      "allergies": {
        "intro_title": "Es-tu allergique à des médicaments ?",
        "intro_subtitle": "Cela nous aide à comprendre tes antécédents médicaux et à éviter d'éventuelles réactions",
        "details_title": "À quels médicaments es-tu allergique ?",
        "details_subtitle": "Tu peux indiquer le nom d'une marque ou d'une substance précise",
        "medication_allergy_label": "Allergie médicamenteuse ${index}",
        "name_placeholder": "Nom du médicament ou de la substance",
        "comments_placeholder": "Ajoute des commentaires ou des précisions",
        "add_another": "Ajouter une autre allergie médicamenteuse",
        "complete_subtitle": "Tu as terminé les questions sur les allergies"
      },
      "disease_history": {
        "breast_testing": {
          "title": "As-tu passé l'un des examens suivants ?",
          "subtitle": "Tu peux sélectionner plusieurs réponses",
          "section_label": "HISTORIQUE DES EXAMENS",
          "test_types": {
            "mammogram": "Mammographie",
            "breast_ultrasound": "Échographie mammaire",
            "breast_tomosynthesis": "Tomosynthèse mammaire",
            "breast_mri": "IRM mammaire",
            "clinical_breast_exam": "Examen clinique des seins",
            "other": "Autres"
          },
          "details_title": "Détails de l'examen",
          "details_subtitle": "Tu peux téléverser une copie de tes résultats si tu en as.",
          "result_label": "RÉSULTAT ${index}",
          "other_section_label": "AUTRE",
          "other_name_label": "Nom de l'examen",
          "other_name_placeholder": "Quel est le nom de cet examen ?",
          "exam_date_label": "Date de l'examen",
          "exam_date_placeholder": "Quand cet examen a-t-il été réalisé ?",
          "outcome_label": "Résultat de l'examen",
          "outcome_placeholder": "Quel a été le résultat de l'examen ?",
          "notes_label": "Notes sur l'examen",
          "notes_placeholder": "Ajoute des notes sur cet examen",
          "add_another_result": "Ajouter un autre résultat de ${label}"
        },
        "breast_conditions": {
          "title": "Ressens-tu l'un des symptômes mammaires suivants",
          "subtitle": "Tu peux sélectionner plusieurs réponses",
          "section_label": "SÉLECTIONNE LES SYMPTÔMES",
          "condition_types": {
            "discharge": "Écoulement",
            "pain": "Douleur",
            "other": "Autres"
          }
        },
        "breast_symptom_other": {
          "title": "Autre",
          "subtitle": "Tu as sélectionné « autre », merci de nous donner plus de détails",
          "label": "Autre symptôme mammaire",
          "placeholder": "Écris ce que tu souhaites"
        },
        "cancer_history": {
          "title": "As-tu déjà reçu un diagnostic de cancer ?",
          "subtitle": "Tu pourras ajouter des détails sur ton diagnostic"
        },
        "cancer_details": {
          "title": "Parle-nous de ton diagnostic de cancer",
          "subtitle": "Ajoute des détails pour chaque diagnostic",
          "card_label": "CANCER",
          "card_label_indexed": "CANCER ${index}",
          "type_label": "Type de cancer",
          "type_placeholder": "Type de cancer",
          "diagnosis_date_label": "Date du diagnostic",
          "diagnosis_date_placeholder": "Quand as-tu été diagnostiqué·e ?",
          "remission_label": "Statut de rémission",
          "remission_placeholder": "Es-tu en rémission ?",
          "add_another": "Ajouter un autre diagnostic de cancer",
          "cancer_fallback": "Cancer ${index}"
        },
        "cancer_treatments": {
          "title": "Quels traitements as-tu reçus ?",
          "subtitle": "Tu peux sélectionner plusieurs réponses",
          "cancer_label": "CANCER ${index}",
          "treatment_types": {
            "surgery": "Chirurgie",
            "chemotherapy": "Chimiothérapie",
            "radiation_therapy": "Radiothérapie",
            "bone_marrow_transplant": "Greffe de moelle osseuse",
            "immunotherapy": "Immunothérapie",
            "hormone_therapy": "Hormonothérapie",
            "targeted_drug_therapy": "Thérapie ciblée",
            "radiofrequency_therapy": "Radiofréquence",
            "other": "Autre"
          }
        },
        "cancer_treatment_details": {
          "title": "Parle-nous davantage de tes traitements",
          "subtitle": "Ajoute des détails pour chaque traitement reçu",
          "other_section_label": "AUTRE",
          "other_name_label": "Nom du traitement",
          "other_name_placeholder": "Quel est le nom de ce traitement ?",
          "start_label": "Début du traitement",
          "start_placeholder": "Quand le traitement a-t-il commencé ?",
          "end_label": "Fin du traitement",
          "end_placeholder": "Quand le traitement s'est-il terminé ?",
          "notes_label": "Notes sur le traitement",
          "notes_placeholder": "Ajoute des notes sur ce traitement",
          "add_another": "Ajouter un autre traitement"
        },
        "disease_categories": {
          "title": "As-tu des antécédents parmi les pathologies suivantes ?",
          "subtitle": "Tu peux sélectionner plusieurs réponses",
          "section_label": "CATÉGORIES DE MALADIES",
          "categories": {
            "endocrine": "Endocrinien",
            "infectious": "Infectieux",
            "cardiovascular": "Cardiovasculaire",
            "respiratory": "Respiratoire",
            "gastrointestinal": "Gastro-intestinal",
            "hepatic_biliary": "Hépatique et biliaire",
            "renal_urinary": "Rénal et urinaire",
            "musculoskeletal": "Musculo-squelettique",
            "hematological": "Hématologique",
            "autoimmune": "Auto-immun",
            "genetic": "Génétique",
            "eating_disorders": "Troubles alimentaires",
            "neurological_mental_health": "Neurologique et santé mentale"
          },
          "category_questions": {
            "endocrine": "L'un des troubles ou symptômes endocriniens suivants te concerne-t-il ?",
            "infectious": "L'une des maladies infectieuses suivantes te concerne-t-elle ?",
            "cardiovascular": "L'une des maladies cardiovasculaires suivantes te concerne-t-elle ?",
            "respiratory": "L'une des maladies respiratoires suivantes te concerne-t-elle ?",
            "gastrointestinal": "L'un des troubles gastro-intestinaux suivants te concerne-t-il ?",
            "hepatic_biliary": "L'un des troubles hépatiques ou biliaires suivants te concerne-t-il ?",
            "renal_urinary": "L'un des troubles rénaux ou urinaires suivants te concerne-t-il ?",
            "musculoskeletal": "L'un des troubles musculo-squelettiques suivants te concerne-t-il ?",
            "hematological": "L'un des troubles hématologiques suivants te concerne-t-il ?",
            "autoimmune": "L'une des maladies auto-immunes suivantes te concerne-t-elle ?",
            "genetic": "L'une des maladies génétiques suivantes te concerne-t-elle ?",
            "eating_disorders": "L'un des troubles alimentaires suivants te concerne-t-il ?",
            "neurological_mental_health": "L'un des troubles neurologiques ou de santé mentale suivants te concerne-t-il ?"
          }
        },
        "diseases": {
          "endocrine": {
            "diabetes": "Diabète",
            "pcos": "PMOS (ex SOPK)",
            "thyroid_disease": "Maladie thyroïdienne",
            "excessive_body_or_facial_hair": "Pilosité excessive (corps/visage)",
            "hair_loss": "Perte de cheveux",
            "rapid_weight_gain_or_loss": "Variation rapide de poids",
            "temperature_intolerance": "Intolérance à la température",
            "excessive_hunger_or_thirst": "Faim ou soif excessive",
            "hypothalamic_pituitary": "Hypothalamo-hypophysaire",
            "hyperthyroidism_failure": "Hyperthyroïdie",
            "primary_ovarian_insufficiency": "Insuffisance ovarienne primaire",
            "diminished_ovarian_reserve": "Réserve ovarienne diminuée",
            "other": "Autre"
          },
          "infectious": {
            "rubella": "Rubéole",
            "chicken_pox": "Varicelle",
            "measles": "Rougeole",
            "mumps": "Oreillons",
            "rheumatic_fever": "Rhumatisme articulaire aigu",
            "covid_19": "COVID-19",
            "other": "Autre"
          },
          "cardiovascular": {
            "elevated_blood_pressure": "Hypertension artérielle",
            "blood_clots": "Caillots sanguins",
            "heart_murmur": "Souffle au cœur",
            "mitral_valve_prolapse": "Prolapsus de la valve mitrale",
            "stroke": "AVC",
            "other": "Autre"
          },
          "respiratory": {
            "lung_disease": "Maladie pulmonaire",
            "asthma": "Asthme",
            "seizures": "Convulsions",
            "other": "Autre"
          },
          "gastrointestinal": {
            "irritable_bowel_syndrome": "SII (côlon irritable)",
            "frequent_nausea_vomiting": "Nausées/vomissements fréquents",
            "blood_in_stool": "Sang dans les selles",
            "frequent_diarrhea": "Diarrhées fréquentes",
            "other": "Autre"
          },
          "hepatic_biliary": {
            "liver_disease": "Maladie du foie",
            "gallbladder_disease": "Maladie de la vésicule biliaire",
            "other": "Autre"
          },
          "renal_urinary": {
            "kidney_issues": "Problèmes rénaux",
            "frequent_urination": "Mictions fréquentes",
            "bladder_infection": "Infection de la vessie",
            "blood_in_urine": "Sang dans les urines",
            "frequent_urinary_tract_infections": "Infections urinaires fréquentes",
            "other": "Autre"
          },
          "musculoskeletal": {
            "arthritis": "Arthrite",
            "gout": "Goutte",
            "fibrodysplasia_ossificans_progressiva": "Fibrodysplasie ossifiante",
            "malignant_hyperthermia": "Hyperthermie maligne",
            "other": "Autre"
          },
          "hematological": {
            "easy_bruising": "Tendance aux ecchymoses",
            "sickle_cell_anemia": "Drépanocytose",
            "other": "Autre"
          },
          "autoimmune": {
            "lupus": "Lupus",
            "rheumatoid_arthritis": "Polyarthrite rhumatoïde",
            "multiple_sclerosis": "Sclérose en plaques",
            "vitiligo": "Vitiligo",
            "crohns_disease": "Maladie de Crohn",
            "other": "Autre"
          },
          "genetic": {
            "klinefelter_syndrome": "Syndrome de Klinefelter",
            "noonan_syndrome": "Syndrome de Noonan",
            "cftr": "CFTR",
            "y_chromosome_microdeletions": "Microdélétions du chromosome Y",
            "other": "Autre"
          },
          "eating_disorders": {
            "bulimia": "Boulimie",
            "anorexia": "Anorexie",
            "orthorexia": "Orthorexie",
            "binge_eating_disorder": "Hyperphagie",
            "rumination_disorder": "Mérycisme",
            "other": "Autre"
          },
          "neurological_mental_health": {
            "anxiety": "Anxiété",
            "depression": "Dépression",
            "bipolar_disorder": "Trouble bipolaire",
            "schizophrenia": "Schizophrénie",
            "endometriosis": "Endométriose",
            "other": "Autre"
          }
        },
        "disease_details": {
          "title": "Parle-nous davantage de tes pathologies",
          "subtitle": "Ajoute des détails pour chaque pathologie sélectionnée",
          "other_section_label": "AUTRE",
          "other_name_label": "Nom de la pathologie",
          "other_name_placeholder": "Quel est le nom de cette pathologie ?",
          "diagnosis_date_label": "Date du diagnostic",
          "diagnosis_date_placeholder": "Quand as-tu été diagnostiqué·e ?",
          "treatment_label": "Traitement reçu",
          "treatment_placeholder": "Quel traitement as-tu reçu ?"
        },
        "disease_other": {
          "title": "Autres pathologies",
          "subtitle": "Merci de préciser tes autres pathologies",
          "label": "Détails de l'autre pathologie",
          "placeholder": "Décris ton autre pathologie ${category}"
        },
        "select_conditions_fallback": "Sélectionne des pathologies",
        "complete_subtitle": "Tu as terminé les questions sur les maladies et examens"
      },
      "medications_vaccines": {
        "intro_title": "Prends-tu actuellement des médicaments ?",
        "products_title": "Utilises-tu l'un des produits ci-dessous ?",
        "products_subtitle": "Tu peux sélectionner plusieurs réponses",
        "medication_products": {
          "nose_drops": "Gouttes nasales",
          "cold_medicine": "Médicament contre le rhume",
          "diuretics": "Diurétiques",
          "pain_relief": "Antidouleur ou anti-inflammatoire",
          "relaxants": "Relaxants",
          "sleeping_pills": "Somnifères",
          "allergy_medication": "Médicament contre les allergies",
          "nicotine_subs": "Substituts nicotiniques & produits anti-tabac",
          "other": "Autre",
          "none": "Aucun"
        },
        "other_medication_placeholder": "Précise ou ajoute plus de détails",
        "other_medication_label": "Autre médicament ou détails",
        "medication_details_title": "Parle-nous davantage des médicaments que tu prends",
        "medication_name_required_other_details_optional": "Ajoutez le nom du médicament ; les autres détails sont facultatifs.",
        "medication_card_fallback": "Médicament",
        "medication_name_label": "Nom du médicament ou de la marque",
        "medication_name_placeholder": "Nom du médicament ou marque",
        "frequency_label": "Fréquence",
        "frequency_placeholder": "Décris la fréquence",
        "comments_label": "Commentaires ou détails",
        "comments_placeholder": "Ajoute des commentaires ou des précisions",
        "add_another_medication": "Ajouter un autre médicament",
        "vaccines_title": "Sélectionne les vaccins que tu as reçus",
        "vaccines_subtitle": "Tu peux sélectionner plusieurs réponses",
        "vaccine_options": {
          "hpv": "HPV",
          "covid19": "Covid 19",
          "chicken_pox": "Varicelle",
          "tetanus": "Tétanos",
          "polio": "Poliomyélite",
          "influenza": "Grippe",
          "mmr": "Rougeole, oreillons & rubéole",
          "hepatitis_a": "Hépatite A",
          "hepatitis_b": "Hépatite B",
          "other": "Autre",
          "none": "Aucun"
        },
        "other_vaccine_placeholder": "Précise ou ajoute plus de détails",
        "other_vaccine_label": "Autre vaccin ou détails",
        "vaccine_details_title": "Parle-nous davantage de ton vaccin",
        "vaccine_details_subtitle": "Aucune information n'est obligatoire",
        "vaccine_card_fallback": "Vaccin",
        "vaccine_card_title": "Détails — ${label}",
        "date_received_label": "Date de réception",
        "date_label": "Date",
        "date_placeholder": "Tu te souviens quand ?",
        "brand_label": "Marque du vaccin",
        "brand_placeholder": "Quelle était la marque du vaccin ?",
        "notes_label": "Commentaires ou notes",
        "notes_placeholder": "Ajoute des commentaires et des notes",
        "add_another_vaccine": "Ajouter un autre vaccin",
        "complete_subtitle": "Tu as terminé les questions sur les médicaments et vaccins"
      },
      "surgeries": {
        "title": "As-tu déjà eu des interventions chirurgicales ?",
        "subtitle": "Tu peux sélectionner plusieurs réponses",
        "section_label": "HISTORIQUE CHIRURGICAL",
        "never_had_surgery": "Je n'ai jamais eu de chirurgie",
        "surgery_types": {
          "tubal_ligation": "Ligature des trompes",
          "salpingectomy": "Salpingectomie",
          "operative_laparoscopy": "Laparoscopie opératoire",
          "myomectomy": "Myomectomie",
          "operative_hysteroscopy": "Hystéroscopie opératoire",
          "varicocelectomy": "Varicocélectomie",
          "orchiopexy": "Orchidopexie",
          "vasectomy": "Vasectomie",
          "other": "Autre"
        },
        "details_title": "Parle-nous davantage de tes interventions",
        "details_subtitle": "Ces détails nous aident à évaluer leur impact sur ta fertilité",
        "other_card_label": "TU AS SÉLECTIONNÉ « AUTRE » POUR LES CHIRURGIES",
        "card_label": "DÉTAILS — ${label}",
        "other_name_placeholder": "Quel était le nom de l'intervention ?",
        "other_name_label": "Nom de l'intervention",
        "procedure_date_label": "Date de l'intervention",
        "procedure_date_placeholder": "Quand cette intervention a-t-elle eu lieu ?",
        "comments_placeholder": "Ajoute des commentaires et des notes",
        "comments_label": "Commentaires ou notes",
        "complete_subtitle": "Tu as terminé les questions sur l'historique chirurgical"
      }
    },
    "complete": {
      "title_default": "Vos réponses sont enregistrées",
      "secondary_subtitle_default": "Vous pourrez ajouter ou modifier des détails quand vous le souhaitez.",
      "recap_label": "Ce que nous avons compris",
      "insight_label": "Pourquoi c'est utile",
      "button_label_default": "Terminer",
      "submitting_label_default": "Enregistrement…",
      "back_to_medical_history": "Retour à l'historique médical",
      "local_answers_notice": "Cette section est complète ici, mais les changements de l'historique médical ne pourront être partagés qu'une fois la synchronisation terminée.",
      "next_section_prefix": "Passons ${section}",
      "next_section": {
        "basicInfo": "à propos de toi",
        "infertility": "au diagnostic d'infertilité",
        "fertilityTesting": "aux tests de fertilité",
        "fertilityTreatments": "aux traitements de fertilité",
        "menstrualHealth": "à ta santé menstruelle",
        "sexualHealth": "à ta santé sexuelle",
        "contraception": "à ta contraception",
        "pregnancy": "à tes grossesses",
        "medicationsVaccines": "à tes médicaments & vaccins",
        "allergies": "aux allergies",
        "diseaseHistory": "aux maladies & bilans de santé",
        "surgeries": "à tes chirurgies",
        "exposure": "à tes expositions",
        "substances": "aux substances",
        "sleepActivity": "au sommeil & à l'activité",
        "dietSupplements": "à l'alimentation & aux compléments",
        "familyHistory": "à ton historique familial"
      }
    },
    "medical_history_card": {
      "tagline": "Commencez à répondre",
      "title": "Historique médical",
      "subtitle": "Complétez les sections et aidez votre médecin à optimiser votre parcours de fertilité !"
    },
    "question_screen": {
      "default_caption": "À propos de vous",
      "help_accessibility_label": "Pourquoi cette question ?",
      "files_added": "Fichiers ajoutés",
      "file_ready": "Ajouté à ton historique médical",
      "flow_help": {
        "basic-info": "Ces questions nous aident à comprendre ta santé de base et à afficher les éléments de ton historique qui te concernent.",
        "infertility": "Ces questions nous aident à comprendre les diagnostics et les causes possibles d'infertilité pour préparer les prochaines étapes.",
        "fertility-testing": "Ces questions nous aident à organiser tes tests de fertilité et à relier les résultats à tes soins.",
        "fertility-treatments": "Ces questions nous aident à comprendre les traitements essayés et leur place dans ton parcours de fertilité.",
        "menstrual-health": "Ces questions nous aident à comprendre tes cycles, tes symptômes et leur rythme.",
        "sexual-health": "Ces questions nous aident à comprendre les facteurs sexuels et reproductifs qui peuvent influencer tes soins.",
        "contraception": "Ces questions nous aident à comprendre ta contraception actuelle ou passée et son contexte.",
        "pregnancies": "Ces questions nous aident à comprendre tes grossesses, leurs issues et les détails utiles à tes soins.",
        "medications-vaccines": "Ces questions nous aident à garder tes médicaments et tes vaccins visibles pour des soins plus sûrs.",
        "allergies": "Ces questions nous aident à noter tes allergies afin que ton équipe évite les réactions connues.",
        "diseases": "Ces questions nous aident à noter les pathologies et examens qui peuvent influencer ta fertilité et tes soins.",
        "surgeries": "Ces questions nous aident à noter les interventions et les détails qui peuvent influencer ta santé reproductive.",
        "exposure": "Ces questions nous aident à comprendre les expositions environnementales qui peuvent concerner ta fertilité et ta santé.",
        "substances": "Ces questions nous aident à comprendre ta consommation afin d'adapter les conseils à ton contexte.",
        "sleep-activity": "Ces questions nous aident à comprendre ton sommeil et ton activité, qui peuvent influencer ton bien-être.",
        "diet-supplements": "Ces questions nous aident à comprendre ton alimentation et tes compléments, qui peuvent interagir avec tes soins.",
        "family-history": "Ces questions nous aident à comprendre les risques héréditaires et les antécédents de ta famille."
      }
    },
    "review": {
      "section_title": {
        "basic-info": "À propos de vous",
        "infertility": "Diagnostic d'infertilité",
        "fertility-testing": "Tests de fertilité",
        "fertility-treatments": "Traitements de fertilité",
        "menstrual-health": "Santé menstruelle",
        "sexual-health": "Santé sexuelle",
        "contraception": "Contraception",
        "pregnancies": "Grossesses",
        "medications-vaccines": "Médicaments et vaccins",
        "allergies": "Allergies",
        "diseases": "Maladies et bilans",
        "surgeries": "Chirurgies",
        "exposure": "Expositions",
        "substances": "Substances",
        "sleep-activity": "Sommeil et activité",
        "diet-supplements": "Alimentation et compléments",
        "family-history": "Historique familial"
      },
      "item": {
        "sex_at_birth": "Sexe à la naissance",
        "female": "Féminin",
        "male": "Masculin",
        "date_of_birth": "Date de naissance",
        "height": "Taille",
        "weight": "Poids",
        "been_pregnant_before": "Déjà été enceinte",
        "endometriosis": "Endométriose",
        "pcos": "PMOS (ex SOPK)",
        "pcos_diagnosed": "Diagnostiqué",
        "pcos_suspected": "Suspecté",
        "varicocele": "Varicocèle",
        "cancer_history": "Antécédents de cancer",
        "allergies": "Allergies",
        "no_known_allergies": "Aucune allergie connue",
        "unknown_allergy_name": "Inconnue",
        "currently_taking_medications": "Prend actuellement des médicaments",
        "infertility_diagnosis": "Diagnostic d'infertilité",
        "infertility_yes_diagnosed": "Oui, diagnostiqué",
        "infertility_art_carrier": "AMP nécessaire pour dépister les embryons",
        "causes": "Causes",
        "partner_infertility": "Infertilité du·de la partenaire",
        "partner_details": "Détails sur l'infertilité du·de la partenaire",
        "test_results": "Résultats des tests",
        "no_test_results": "Aucun résultat de test enregistré",
        "test_n": "Test ${n}",
        "treatments": "Traitements",
        "no_treatments": "Aucun traitement enregistré",
        "treatment": "Traitement",
        "treatment_n": "${name} n°${n}",
        "cycle_status": "État du cycle",
        "cycle_length": "Durée du cycle",
        "cycle_length_days": "${count} jours",
        "flow_intensity": "Intensité habituelle des règles",
        "period_length": "Durée des règles",
        "period_length_days": "${count} jours",
        "pain_scale": "Échelle de douleur",
        "pain_scale_value": "${value}/10",
        "period_details": "Détails sur les règles",
        "last_periods_tracked": "Dernières règles suivies",
        "periods_recorded_one": "${count} cycle enregistré",
        "periods_recorded_other": "${count} cycles enregistrés",
        "had_pap_smear": "A fait un frottis",
        "pap_smear_result_abnormal": "Résultat du frottis anormal",
        "abnormal_pap_smear_procedures": "Examens de suivi du frottis",
        "std_history": "Antécédents d'IST",
        "vaginal_infections": "Infections vaginales",
        "painful_intercourse": "Rapports douloureux",
        "uses_lubricant": "Utilise du lubrifiant",
        "partner_ejaculates_in_vagina": "Le·la partenaire éjacule dans le vagin",
        "self_ejaculates_in_partner_vagina": "Tu éjacules dans le vagin de ton/ta partenaire",
        "erectile_difficulties": "Difficultés d'érection",
        "contraception_history": "Antécédents de contraception",
        "no_contraception_history": "Aucun antécédent de contraception",
        "contraception_methods": "Méthodes de contraception",
        "method_n": "Méthode ${n}",
        "pregnancy_history": "Antécédents de grossesse",
        "no_pregnancies": "Aucune grossesse",
        "pregnancies": "Grossesses",
        "pregnancy_n": "Grossesse ${n}",
        "medication": "Médicament",
        "vaccine": "Vaccin",
        "vaccinations": "Vaccinations",
        "disease_history": "Antécédents médicaux",
        "no_conditions_reported": "Aucune affection rapportée",
        "condition": "Affection",
        "surgical_history": "Antécédents chirurgicaux",
        "no_surgeries": "Aucune chirurgie",
        "has_surgeries": "A eu des chirurgies",
        "surgery": "Chirurgie",
        "environmental_exposures": "Expositions environnementales",
        "no_exposures_reported": "Aucune exposition rapportée",
        "has_exposures": "A été exposé·e",
        "exposure": "Exposition",
        "substance_use": "Consommation de substances",
        "no_substances_reported": "Aucune substance rapportée",
        "uses_substances": "Consomme des substances",
        "substance": "Substance",
        "hours_of_sleep": "Heures de sommeil",
        "hours_of_sleep_range": "${min}–${max} heures",
        "exercises_regularly": "Fait du sport régulièrement",
        "exercise_type": "Type d'activité",
        "exercise_frequency": "Fréquence d'activité",
        "diet": "Alimentation",
        "supplement": "Complément",
        "diet_and_supplements": "Alimentation et compléments",
        "no_diet_supplements_recorded": "Aucune alimentation ou complément enregistré",
        "taking": "En cours",
        "has_allergies": "A des allergies",
        "ancestry": "Ascendance",
        "dna_test": "Test ADN",
        "adoption_status": "Adoption",
        "family_infertility": "Infertilité familiale",
        "des_exposure": "Exposition au DES",
        "no_family_history_recorded": "Aucun historique familial enregistré"
      }
    },
    "components": {
      "form_fields": {
        "result_n": "Résultat ${n}",
        "test_name_placeholder": "Qu'est-ce qui a été testé ?",
        "value_placeholder": "Résultat de laboratoire",
        "add_another": "Ajouter un autre résultat"
      },
      "file_upload": {
        "uploaded": "TÉLÉVERSÉ",
        "upload_cta": "Téléverser une copie du document",
        "file_types": "PDF, JPEG ou PNG"
      }
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread_badge": "${count} nouvelle·s",
    "mark_all_read": "Tout marquer comme lu",
    "try_again": "Réessayer",
    "load_error": "Impossible de charger les notifications",
    "empty_title": "Aucune notification pour le moment",
    "empty_subtitle": "Quand il y aura quelque chose à consulter, ce sera affiché ici.",
    "all_caught_up": "Tu es à jour",
    "badge_ready_title": "Une étape du passeport est prête",
    "badge_ready_body": "Ouvrez le passeport pour consulter cette mise à jour.",
    "time_upcoming": "À venir",
    "time_just_now": "À l'instant",
    "time_minutes": "il y a ${minutes} min",
    "time_hours": "il y a ${hours} h",
    "time_yesterday": "Hier",
    "time_days": "il y a ${days} j"
  },
  "learn": {
    "title": "Explorer",
    "subtitle": "Découvrir, comprendre, décider",
    "recommended_for_you": "Recommandé pour toi",
    "encyclopedia": "Encyclopédie",
    "todays_spotlight": "À la une aujourd'hui",
    "back_to_learn": "Explorer",
    "section_progress": "${read}/${total} lus",
    "article_tags": {
      "guides": "Guides",
      "travel": "Voyage",
      "decisions": "Décisions",
      "science": "Science",
      "costs": "Coûts",
      "endometriosis": "Endométriose",
      "pcos": "PMOS (ex SOPK)",
      "thyroid": "Thyroïde",
      "clinic": "Clinique",
      "treatment": "Traitement",
      "preparation": "Préparation",
      "egg_freezing": "Congélation d'ovocytes",
      "lifestyle": "Hygiène de vie",
      "optimization": "Optimisation",
      "emotional_support": "Soutien émotionnel",
      "testing": "Examens",
      "practical": "Pratique",
      "partners": "Partenaires",
      "male_fertility": "Fertilité masculine",
      "female_fertility": "Fertilité féminine"
    },
    "filter_chips": {
      "all": "Tout",
      "guides": "Guides",
      "travel": "Voyage",
      "decisions": "Décisions",
      "science": "Science",
      "costs": "Coûts",
      "conditions": "Pathologies",
      "treatments": "Traitements",
      "lifestyle": "Hygiène de vie",
      "support": "Soutien",
      "encyclopedia": "Encyclopédie",
      "saved": "Enregistrés"
    },
    "section_labels": {
      "guides": "Guides",
      "travel": "Voyage",
      "decisions": "Décisions",
      "science": "Science et chiffres",
      "costs": "Coûts et remboursement",
      "conditions": "Pathologies",
      "treatments": "Traitements",
      "lifestyle": "Hygiène de vie",
      "support": "Soutien",
      "saved": "Enregistrés"
    },
    "empty_saved_title": "Aucun article enregistré pour l'instant",
    "empty_saved_subtitle": "Touche l'icône de marque-page en lisant un article",
    "empty_articles_title": "Pas encore d'articles",
    "empty_articles_subtitle": "On ajoute bientôt plus de contenu sur ce sujet",
    "encyclopedia_cards": {
      "medications_title": "Médicaments",
      "medications_subtitle": "Ce qu'ils font, comment les prendre",
      "medications_detail": "Gonadotrophines · Déclencheurs · Progestérone · plus",
      "procedures_title": "Procédures",
      "procedures_subtitle": "Étapes et processus du traitement",
      "procedures_detail": "Stimulation · Ponction · Transfert · plus",
      "tests_title": "Tests et marqueurs",
      "tests_subtitle": "Ce qu'on mesure et ce que ça veut dire",
      "tests_detail": "AMH · Échographie · Analyses · plus",
      "conditions_title": "Pathologies",
      "conditions_subtitle": "Comprendre ce qui affecte la fertilité",
      "conditions_detail": "DOR · PMOS (ex SOPK) · Endométriose · plus"
    },
    "ai_assistant": {
      "default_title": "Pose ta question",
      "default_subtitle": "Personnalisé pour ton parcours",
      "default_empty_prompt": "Pose-moi des questions sur les traitements de fertilité, les délais, les coûts, ou ce qui te préoccupe.",
      "default_input_placeholder": "Qu'est-ce qui te trotte dans la tête ?",
      "analysing": "Analyse…",
      "progress": {
        "checking_context": "Vérification du contexte partagé",
        "reviewing_guidance": "Examen des conseils de fertilité pertinents",
        "preparing_reply": "Préparation d'une réponse claire"
      },
      "info_sheet_title": "À propos de ton assistant",
      "info_what_title": "Qu'est-ce que je peux demander ?",
      "info_what_body": "Tout ce qui concerne ton parcours de fertilité — options de traitement, à quoi t'attendre, comment te préparer, coûts, délais, compléments, et plus encore.",
      "info_personalized_title": "Personnalisé pour toi",
      "info_personalized_body": "Ton assistant connaît le contexte de ton profil, tes préférences et où tu en es dans ton parcours, pour des réponses adaptées à ta situation.",
      "info_not_advice_title": "Pas un avis médical",
      "info_not_advice_body": "C'est un outil éducatif, pas un substitut à un avis médical professionnel. Consulte toujours ton médecin avant toute décision de traitement.",
      "connection_error_title": "Chat indisponible",
      "connection_error_message": "Je n’arrive pas à joindre le chat pour le moment. Essaie d’envoyer à nouveau ta question.",
      "error_title": "Erreur",
      "error_message": "Une erreur est survenue : ${message}",
      "error_generic": "Une erreur est survenue"
    },
    "article_reader": {
      "related_articles": "Articles liés",
      "continue_reading": "Continuer la lecture"
    },
    "read_time_minutes": "${minutes} min",
    "article_chat_prompt": {
      "just_read_article": "Je viens de lire un article de Louise Learn et j'aimerais en discuter.",
      "article_line": "Article : ${title}",
      "summary_line": "Résumé de l'article : ${teaser}",
      "no_summary": "non fourni",
      "key_takeaways_heading": "Points clés :",
      "help_me_understand": "Aide-moi à comprendre les idées principales en langage simple, puis demande-moi ce que j'aimerais explorer ou appliquer à ma situation."
    },
    "article_actions": {
      "chat_about_this": "En parler",
      "chat_about_this_accessibility": "Parler de cet article",
      "saved": "Enregistré",
      "save_accessibility": "Enregistrer l'article",
      "remove_saved_accessibility": "Retirer l'article des favoris",
      "close_accessibility": "Fermer"
    },
    "disclaimer_medical_info": "Ces informations sont à but éducatif uniquement et ne remplacent pas un avis médical. Consulte toujours ton équipe soignante au sujet de ta situation spécifique.",
    "condition_detail": {
      "section_what_is_it": "Qu'est-ce que c'est",
      "section_symptoms": "Symptômes",
      "section_how_diagnosed": "Comment c'est diagnostiqué",
      "section_impact_on_fertility": "Impact sur la fertilité",
      "section_prevalence": "Prévalence",
      "section_treatment_options": "Options de traitement",
      "section_prognosis": "Pronostic",
      "section_evidence": "Sources scientifiques",
      "symptoms_log_hint": "Touchez un symptôme pour voir les détails. Utilisez + pour l'enregistrer aujourd'hui.",
      "for_whom_her": "Elle",
      "for_whom_him": "Lui",
      "for_whom_both": "Les deux partenaires"
    },
    "ai_message_blocks": {
      "thinking": "Réflexion…",
      "analyzing": "Analyse…",
      "reasoning": "Raisonnement",
      "what_i_checked": "Ce que j’ai vérifié",
      "updating": "Mise à jour",
      "sources": "Sources",
      "ask_about_this": "Poser une question",
      "suggested_for_question": "Suggestions pour cette question",
      "buy_now": "Acheter",
      "view_details": "Voir les détails",
      "sdk_reasoning_default": "Raisonnement SDK",
      "lead_narration": "Je vais examiner les dossiers et les antécédents pertinents, puis les relier à vos objectifs pour expliquer ce résultat dans son contexte.",
      "sources_narration": "Ensuite, je vais chercher dans la littérature médicale des données qui correspondent à votre profil.",
      "steps": {
        "profile": "Examen de vos objectifs et de vos antécédents de santé",
        "test_results": "Recherche de résultats pertinents dans votre dossier",
        "records": "Recherche de vos dossiers pertinents et de vos antécédents de santé",
        "goals": "Examen de vos objectifs",
        "biomarkers": "Vérification de vos biomarqueurs pertinents",
        "treatment_context": "Examen de votre contexte de traitement",
        "medical_history": "Examen de vos antécédents médicaux",
        "fertility_history": "Examen de vos antécédents de fertilité",
        "medications": "Examen de vos médicaments actuels",
        "lifestyle": "Examen de votre mode de vie",
        "family_history": "Examen de vos antécédents familiaux",
        "cycle_timing": "Vérification du calendrier de votre cycle",
        "other": "Examen du contexte supplémentaire",
        "research": "Recherche médicale"
      }
    },
    "evidence_levels": {
      "expert_opinion": {
        "label": "Avis d'expert",
        "description": "Un avis d'expert ou un raisonnement basé sur le mécanisme peut expliquer la plausibilité biologique, mais ne teste pas directement si une intervention améliore les résultats."
      },
      "observational": {
        "label": "Observationnelle",
        "description": "Une étude observationnelle cherche des tendances dans des données du monde réel sans assigner les personnes à un groupe traitement ou témoin. Elle peut montrer des associations, mais ne peut pas prouver de lien de cause à effet."
      },
      "cohort": {
        "label": "Cohorte",
        "description": "Une étude de cohorte suit un groupe de personnes dans le temps pour observer les résultats. Moins solide qu'un essai randomisé, elle apporte des données précieuses sur les associations et tendances en conditions réelles."
      },
      "review": {
        "label": "Revue",
        "description": "Une revue systématique ou narrative résume les recherches existantes sur un sujet. Les revues sont utiles pour le contexte, mais leur force dépend des études incluses et de la rigueur de la méthode."
      },
      "rct": {
        "label": "Essai contrôlé randomisé",
        "description": "Un essai contrôlé randomisé (ECR) est considéré comme l'étalon-or de la recherche clinique. Les participants sont assignés au hasard à un groupe traitement ou témoin, ce qui réduit les biais et fournit de solides preuves causales."
      },
      "meta_analysis": {
        "label": "Méta-analyse",
        "description": "Une méta-analyse combine les résultats de plusieurs études indépendantes pour tirer des conclusions plus solides. C'est l'un des plus hauts niveaux de preuve quand les études incluses sont pertinentes et de qualité."
      },
      "guideline": {
        "label": "Recommandation",
        "description": "Recommandations cliniques émises par une grande société savante (ESHRE, ASRM, ACOG, ACMG, ATA, Endocrine Society, NICE, HAS, CNGOF, etc.). Les recommandations synthétisent les méta-analyses, les essais cliniques et le consensus d'experts — elles représentent le plus haut niveau de consensus sur la manière d'appliquer les preuves en pratique clinique."
      },
      "official": {
        "label": "Source officielle",
        "description": "Source institutionnelle ou gouvernementale (ameli.fr, service-public.fr, Agence de la biomédecine, ANSM, OMS). Elle fait autorité pour les aspects légaux, administratifs et de remboursement."
      },
      "reference": {
        "label": "Référence médicale",
        "description": "Référence d'information médicale grand public (Mayo Clinic, NHS, Cleveland Clinic, Orphanet). Utile pour la vulgarisation, mais à compléter par les sources primaires pour les décisions cliniques."
      }
    },
    "supplement_detail": {
      "badge_supplement": "Complément",
      "evidence_strength": {
        "strong": "Solides",
        "moderate": "Modérées",
        "emerging": "Émergentes",
        "mixed": "Mitigées",
        "debunked": "Réfutées"
      },
      "evidence_badge": "Preuves ${strength}",
      "you_are_taking": "Vous prenez ce complément",
      "you_have_taken": "Vous avez déjà pris ce complément",
      "you_stopped_taking": "Vous avez arrêté ce complément",
      "row_your_supplement": "Complément",
      "section_how_to_take": "Comment le prendre",
      "row_dosage": "Dose : ${value}",
      "row_timing": "Moment : ${value}",
      "how_to_take_label_dosage": "Dose",
      "how_to_take_label_timing": "Moment",
      "how_to_take_label_best_time": "Meilleur moment",
      "how_to_take_label_start_timing": "Quand commencer",
      "how_to_take_label_cycle_note": "Note de cycle",
      "section_bioavailability": "Biodisponibilité",
      "row_form": "Forme : ${value}",
      "row_absorption": "Absorption : ${value}",
      "row_metabolism": "Métabolisme : ${value}",
      "row_bioavailability_timing": "Note de prise : ${value}",
      "row_caution": "À surveiller : ${value}",
      "bioavailability_label_form": "Forme",
      "bioavailability_label_absorption": "Absorption",
      "bioavailability_label_metabolism": "Métabolisme",
      "bioavailability_label_timing": "Moment",
      "bioavailability_label_caution": "À surveiller",
      "section_what_to_expect": "À quoi s'attendre",
      "section_keep_in_mind": "À garder en tête",
      "section_interacts_with": "Interactions avec",
      "interaction_taking": "En cours",
      "interaction_severity_note": "Note",
      "interaction_severity_caution": "Attention",
      "interaction_severity_critical": "Critique",
      "section_food_sources": "Sources alimentaires",
      "section_evidence": "Preuves",
      "interest_button_label": "L'obtenir",
      "interest_button_captured": "On te tient au courant !",
      "food_modal_serving": "Portion",
      "food_modal_per_serving": "Par portion"
    },
    "program_detail": {
      "badge_coming_soon": "Bientôt disponible",
      "for_whom_her": "Elle",
      "for_whom_him": "Lui",
      "for_whom_both": "Elle et lui",
      "modules_count_one": "${count} module",
      "modules_count_other": "${count} modules",
      "section_whats_included": "Ce qui est inclus",
      "section_how_it_works": "Comment ça fonctionne",
      "phase_parallel_suffix": " (en parallèle)",
      "section_what_youll_track": "Ce que tu vas suivre",
      "marker_retest": "Retest : ${value}",
      "section_evidence": "Preuves",
      "row_evidence_level": "Preuves : ${level}",
      "notify_when_launches": "On te préviendra au lancement de ce programme"
    },
    "test_detail": {
      "section_what_it_measures": "Ce que ça mesure",
      "section_marker_timing": "Moment par marqueur",
      "section_at_a_glance": "En bref",
      "section_sold_as": "Vendu sous les noms",
      "section_result_types": "Ce à quoi s'attendre pour chaque type de résultat",
      "section_best_for": "Adapté pour",
      "section_research": "Ce que dit la recherche",
      "section_what_to_expect": "À quoi s'attendre",
      "section_biomarkers_tracked": "Marqueurs suivis",
      "section_available_as": "Disponible sous",
      "marketed_as": "Commercialisé sous",
      "what_it_is": "Ce que c'est",
      "evidence_note": "Note sur les preuves",
      "view_all_related": "Voir tous les tests liés",
      "view_all_prefix": "Voir tous les ${category}",
      "female_test_a11y": "Test féminin",
      "male_test_a11y": "Test masculin",
      "evidence_strength_strong": "Preuves solides",
      "evidence_strength_moderate": "Preuves modérées",
      "evidence_strength_emerging": "Émergentes",
      "evidence_strength_mixed": "Preuves mitigées",
      "evidence_strength_debunked": "Non soutenu par les preuves",
      "sold_by": "Vendu par ${company}",
      "section_how_it_works": "Comment ça fonctionne",
      "section_why_it_matters": "Pourquoi c'est important",
      "section_turnaround_time": "Délai de résultat",
      "section_cost": "Coût",
      "cost_fr_covered": "Pris en charge à 100 % par la Sécurité sociale dans le cadre d'un parcours d'AMP conventionné.",
      "cost_fr_limited": "Pris en charge par la Sécurité sociale uniquement dans des indications cliniques précises. Hors indication, à payer (compter quelques centaines d'euros).",
      "cost_fr_out_of_pocket": "Examen complémentaire généralement non remboursé par la Sécurité sociale en France. Coût à payer, variable selon le laboratoire.",
      "section_when_to_take": "Quand le faire",
      "section_about_product": "À propos de ce produit",
      "section_panel_parameters": "Ce que ce panel examine",
      "section_evidence": "Sources scientifiques",
      "section_considerations": "Points de vigilance",
      "section_possible_results": "Types de résultats possibles",
      "related_commercial_tests_description": "Voici les analyses commerciales liées à cette catégorie de test canonique.",
      "no_result_types_available": "Ce test ne propose pas encore de catégories de compte rendu fixes.",
      "section_price": "Prix",
      "order_from_provider": "Commander chez le fournisseur",
      "order_now": "Commander le kit",
      "order_success": "Commande passée",
      "order_error": "Le paiement n'a pas pu démarrer. Réessayez.",
      "order_in_app": "À commander dans l'application Louise",
      "badge_at_home": "À domicile",
      "badge_clinic_visit": "Visite en clinique",
      "category_blood_marker": "Marqueur sanguin",
      "category_imaging": "Imagerie",
      "category_genetic": "Génétique",
      "category_semen": "Analyse de sperme",
      "category_monitoring": "Suivi",
      "category_biopsy": "Biopsie",
      "quick_fact_sample": "Échantillon",
      "quick_fact_time": "Durée",
      "quick_fact_pain": "Douleur",
      "quick_fact_anesthesia": "Anesthésie",
      "quick_fact_prep": "Préparation",
      "quick_fact_results": "Résultats"
    },
    "encyclopedia_screens": {
      "all": "Tout",
      "medications": {
        "title": "Médicaments",
        "subtitle": "Les médicaments de fertilité et comment ils agissent",
        "search_placeholder": "Rechercher médicaments, marques…",
        "count_one": "${count} médicament",
        "count_other": "${count} médicaments",
        "empty": "Aucun médicament ne correspond à ta recherche",
        "drug_classes": {
          "gonadotropin": "Gonadotrophines",
          "gnrh_antagonist": "Antagonistes GnRH",
          "gnrh_agonist": "Agonistes GnRH",
          "trigger_shot": "Déclencheurs",
          "progesterone": "Progestérone",
          "estrogen": "Œstrogène",
          "oral_ovulation_induction": "Ovulation orale",
          "anticoagulant": "Anticoagulants",
          "supplement": "Compléments"
        },
        "routes": {
          "subcutaneous": "Sous-cutanée",
          "intramuscular": "Intramusculaire",
          "oral": "Orale",
          "topical": "Cutanée",
          "vaginal": "Vaginale"
        }
      },
      "conditions": {
        "title": "Pathologies",
        "subtitle": "Comprendre ce qui affecte ta fertilité",
        "search_placeholder": "Rechercher pathologies…",
        "count_one": "${count} pathologie",
        "count_other": "${count} pathologies",
        "empty": "Aucune pathologie ne correspond à ta recherche",
        "categories": {
          "reproductive": "Reproducteur",
          "endocrine": "Endocrinien",
          "autoimmune": "Auto-immune",
          "structural": "Structurel",
          "genetic": "Génétique",
          "male_factor": "Facteur masculin"
        }
      },
      "tests": {
        "title": "Tests et marqueurs",
        "subtitle": "Ce qu'on mesure et ce que ça veut dire",
        "search_placeholder": "Rechercher tests…",
        "count_one": "${count} élément",
        "count_other": "${count} éléments",
        "empty": "Aucun test ne correspond à ta recherche",
        "categories": {
          "blood_marker": "Marqueurs sanguins",
          "imaging": "Imagerie",
          "genetic": "Génétique",
          "semen": "Sperme",
          "monitoring": "Suivi"
        }
      },
      "procedures": {
        "title": "Procédures",
        "subtitle": "Étapes et processus de ton traitement",
        "search_placeholder": "Rechercher procédures…",
        "count_one": "${count} procédure",
        "count_other": "${count} procédures",
        "empty": "Aucune procédure ne correspond à ta recherche",
        "categories": {
          "consultation": "Consultations",
          "stimulation": "Stimulation",
          "retrieval": "Ponction",
          "lab": "Laboratoire",
          "transfer": "Transfert",
          "diagnostic": "Diagnostic",
          "recovery": "Récupération"
        }
      }
    }
  }
}
